const countries = [
  {
    code: "AL",
    name: "Albania",
    coordinates: [
      [
        { lat: 42.54726562499999, lng: 20.063964843749996 },
        { lat: 42.524658203125, lng: 20.103515625 },
        { lat: 42.42587890624999, lng: 20.18574218750001 },
        { lat: 42.33896484375, lng: 20.240527343750017 },
        { lat: 42.3087890625, lng: 20.348242187500006 },
        { lat: 42.274951171874996, lng: 20.408300781250006 },
        { lat: 42.223388671875, lng: 20.485449218750006 },
        { lat: 42.17148437499999, lng: 20.522851562500023 },
        { lat: 42.013085937499994, lng: 20.57539062500001 },
        { lat: 41.91743164062499, lng: 20.581445312500023 },
        { lat: 41.873681640624994, lng: 20.566210937500017 },
        { lat: 41.862353515624996, lng: 20.553125 },
        { lat: 41.706494140625, lng: 20.505175781250014 },
        { lat: 41.62705078125, lng: 20.5166015625 },
        { lat: 41.574755859374996, lng: 20.516210937500002 },
        { lat: 41.554101562499994, lng: 20.4755859375 },
        { lat: 41.521289062499996, lng: 20.448632812500023 },
        { lat: 41.39140624999999, lng: 20.49238281250001 },
        { lat: 41.336083984374994, lng: 20.487011718750008 },
        { lat: 41.272607421874994, lng: 20.48896484375001 },
        { lat: 41.12783203124999, lng: 20.56787109375 },
        { lat: 41.083056640624996, lng: 20.61445312500001 },
        { lat: 41.061669921874994, lng: 20.656054687500017 },
        { lat: 40.928369140624994, lng: 20.709277343750017 },
        { lat: 40.9052734375, lng: 20.740820312500006 },
        { lat: 40.917919921875, lng: 20.870214843750006 },
        { lat: 40.903125, lng: 20.93349609375002 },
        { lat: 40.871533203125, lng: 20.95859375 },
        { lat: 40.849902343749996, lng: 20.964257812500023 },
        { lat: 40.775292968749994, lng: 20.95576171875001 },
        { lat: 40.7177734375, lng: 20.987890625 },
        { lat: 40.658642578125, lng: 21.031054687500014 },
        { lat: 40.622460937499994, lng: 21.030859375 },
        { lat: 40.56337890624999, lng: 21.001953125 },
        { lat: 40.494384765625, lng: 20.9501953125 },
        { lat: 40.46791992187499, lng: 20.881640625000017 },
        { lat: 40.445458984374994, lng: 20.806054687500023 },
        { lat: 40.391894531249996, lng: 20.77001953125 },
        { lat: 40.334912109375, lng: 20.75166015625001 },
        { lat: 40.29267578125, lng: 20.717871093750006 },
        { lat: 40.246386718749996, lng: 20.69697265625001 },
        { lat: 40.151757812499994, lng: 20.664941406250023 },
        { lat: 40.1173828125, lng: 20.65742187500001 },
        { lat: 40.082666015624994, lng: 20.60625 },
        { lat: 40.068505859374994, lng: 20.52705078125001 },
        { lat: 40.065576171874994, lng: 20.4560546875 },
        { lat: 40.049462890624994, lng: 20.408007812500017 },
        { lat: 40.0171875, lng: 20.383691406250023 },
        { lat: 39.991064453125, lng: 20.338476562500002 },
        { lat: 39.979443359375, lng: 20.311132812500006 },
        { lat: 39.95078125, lng: 20.311328125000017 },
        { lat: 39.890625, lng: 20.344238281249996 },
        { lat: 39.841796875, lng: 20.381640625000017 },
        { lat: 39.802636718749994, lng: 20.382421875 },
        { lat: 39.791748046875, lng: 20.364062500000017 },
        { lat: 39.79667968749999, lng: 20.30615234375 },
        { lat: 39.7822265625, lng: 20.293847656250023 },
        { lat: 39.73857421874999, lng: 20.28759765625 },
        { lat: 39.701171875, lng: 20.272070312500006 },
        { lat: 39.678369140624994, lng: 20.24824218750001 },
        { lat: 39.653515625, lng: 20.206835937500017 },
        { lat: 39.66162109375, lng: 20.13105468750001 },
        { lat: 39.699121093749994, lng: 20.05976562500001 },
        { lat: 39.710693359375, lng: 20.022558593750006 },
        { lat: 39.709423828125, lng: 20.001269531250017 },
        { lat: 39.801025390625, lng: 19.995605468749996 },
        { lat: 39.872265625, lng: 19.96484375 },
        { lat: 40.0435546875, lng: 19.851855468750017 },
        { lat: 40.2099609375, lng: 19.48457031250001 },
        { lat: 40.28486328125, lng: 19.39814453125001 },
        { lat: 40.347705078124996, lng: 19.360156250000017 },
        { lat: 40.407080078125, lng: 19.322265625 },
        { lat: 40.408740234374996, lng: 19.35859375000001 },
        { lat: 40.393701171874994, lng: 19.39453125 },
        { lat: 40.37568359375, lng: 19.440527343750002 },
        { lat: 40.40537109375, lng: 19.45917968750001 },
        { lat: 40.470263671874996, lng: 19.439257812500017 },
        { lat: 40.6220703125, lng: 19.34462890625002 },
        { lat: 40.66381835937499, lng: 19.3375 },
        { lat: 40.79072265625, lng: 19.383886718750006 },
        { lat: 40.93330078125, lng: 19.461230468750017 },
        { lat: 41.1060546875, lng: 19.4560546875 },
        { lat: 41.23637695312499, lng: 19.480078125 },
        { lat: 41.32099609375, lng: 19.453417968750017 },
        { lat: 41.424755859375, lng: 19.440625 },
        { lat: 41.5626953125, lng: 19.497363281250017 },
        { lat: 41.596826171874994, lng: 19.54580078125002 },
        { lat: 41.640429687499996, lng: 19.57568359375 },
        { lat: 41.7875, lng: 19.577539062500023 },
        { lat: 41.85615234375, lng: 19.46826171875 },
        { lat: 41.869091796875, lng: 19.342382812500006 },
        { lat: 41.91884765624999, lng: 19.345507812500017 },
        { lat: 41.99775390624999, lng: 19.361132812500017 },
        { lat: 42.0240234375, lng: 19.352148437500006 },
        { lat: 42.069091796875, lng: 19.361425781250002 },
        { lat: 42.12929687499999, lng: 19.330859375000017 },
        { lat: 42.17255859375, lng: 19.28066406250002 },
        { lat: 42.249267578125, lng: 19.329003906250023 },
        { lat: 42.34189453125, lng: 19.39960937500001 },
        { lat: 42.415380859375, lng: 19.465136718750017 },
        { lat: 42.491943359375, lng: 19.54453125 },
        { lat: 42.5654296875, lng: 19.597460937500017 },
        { lat: 42.628564453124994, lng: 19.65449218750001 },
        { lat: 42.64794921875, lng: 19.703417968750017 },
        { lat: 42.634521484375, lng: 19.727832031250017 },
        { lat: 42.60693359375, lng: 19.74072265625 },
        { lat: 42.525146484375, lng: 19.73779296875 },
        { lat: 42.496923828125, lng: 19.754492187500006 },
        { lat: 42.476171875, lng: 19.78828125000001 },
        { lat: 42.486328125, lng: 19.859765625000023 },
        { lat: 42.506689453125, lng: 19.9390625 },
        { lat: 42.54990234374999, lng: 20.045703125000017 },
        { lat: 42.54726562499999, lng: 20.063964843749996 },
      ],
    ],
  },
  {
    code: "CH",
    name: "Switzerland",
    coordinates: [
      [
        { lat: 47.52421875, lng: 9.524023437500006 },
        { lat: 47.51113281249999, lng: 9.554394531250011 },
        { lat: 47.467041015625, lng: 9.625878906250023 },
        { lat: 47.391796875, lng: 9.609082031250011 },
        { lat: 47.270751953125, lng: 9.527539062500011 },
        { lat: 47.17265625, lng: 9.484277343750023 },
        { lat: 47.09750976562499, lng: 9.4794921875 },
        { lat: 47.06225585937499, lng: 9.487695312500023 },
        { lat: 47.062744140625, lng: 9.502343750000023 },
        { lat: 47.05737304687499, lng: 9.580273437500011 },
        { lat: 47.057470703125, lng: 9.619921875000017 },
        { lat: 47.037109375, lng: 9.745019531250023 },
        { lat: 47.007373046874996, lng: 9.8453125 },
        { lat: 46.975976562499994, lng: 9.864648437500023 },
        { lat: 46.9376953125, lng: 9.877734375000017 },
        { lat: 46.8853515625, lng: 9.996875 },
        { lat: 46.851513671875, lng: 10.133496093750011 },
        { lat: 46.862353515624996, lng: 10.179785156250006 },
        { lat: 46.98476562499999, lng: 10.349414062500017 },
        { lat: 46.964404296874996, lng: 10.414941406250023 },
        { lat: 46.8994140625, lng: 10.45458984375 },
        { lat: 46.86494140624999, lng: 10.45283203125001 },
        { lat: 46.73486328125, lng: 10.406054687500017 },
        { lat: 46.6650390625, lng: 10.39794921875 },
        { lat: 46.61884765625, lng: 10.438281250000017 },
        { lat: 46.582861328125, lng: 10.442480468750006 },
        { lat: 46.550048828125, lng: 10.4306640625 },
        { lat: 46.5470703125, lng: 10.363085937500017 },
        { lat: 46.56484375, lng: 10.272265625000017 },
        { lat: 46.62109375, lng: 10.195507812500011 },
        { lat: 46.61435546875, lng: 10.1375 },
        { lat: 46.599902343749996, lng: 10.087011718750006 },
        { lat: 46.54677734374999, lng: 10.061230468750011 },
        { lat: 46.483203125, lng: 10.038281250000011 },
        { lat: 46.447900390624994, lng: 10.045605468750011 },
        { lat: 46.420751953125, lng: 10.081933593750023 },
        { lat: 46.36284179687499, lng: 10.109667968750017 },
        { lat: 46.287988281249994, lng: 10.1298828125 },
        { lat: 46.253515625, lng: 10.145214843750011 },
        { lat: 46.238232421875, lng: 10.128320312500023 },
        { lat: 46.227978515625, lng: 10.08056640625 },
        { lat: 46.238085937499996, lng: 10.041015625 },
        { lat: 46.327685546874996, lng: 9.9716796875 },
        { lat: 46.36181640624999, lng: 9.939257812500017 },
        { lat: 46.3677734375, lng: 9.884472656250011 },
        { lat: 46.346044921875, lng: 9.78779296875001 },
        { lat: 46.2958984375, lng: 9.639453125000017 },
        { lat: 46.29609375, lng: 9.57958984375 },
        { lat: 46.306201171874996, lng: 9.528710937500021 },
        { lat: 46.34877929687499, lng: 9.481054687500006 },
        { lat: 46.430810546874994, lng: 9.440625 },
        { lat: 46.48232421874999, lng: 9.427636718750023 },
        { lat: 46.4806640625, lng: 9.399316406250021 },
        { lat: 46.495556640625, lng: 9.304394531250011 },
        { lat: 46.4751953125, lng: 9.260156250000023 },
        { lat: 46.391259765624994, lng: 9.259765625 },
        { lat: 46.28676757812499, lng: 9.251074218750006 },
        { lat: 46.21923828125, lng: 9.203417968750017 },
        { lat: 46.102441406249994, lng: 9.070996093750011 },
        { lat: 46.05146484375, lng: 9.022363281250023 },
        { lat: 46.014892578125, lng: 9.003027343750006 },
        { lat: 45.98310546875, lng: 8.998925781250023 },
        { lat: 45.928125, lng: 9.019140625 },
        { lat: 45.87558593749999, lng: 9.046679687500015 },
        { lat: 45.845703125, lng: 9.023730468750017 },
        { lat: 45.830029296875, lng: 8.953710937500006 },
        { lat: 45.861962890624994, lng: 8.904296875 },
        { lat: 45.918701171875, lng: 8.885156250000023 },
        { lat: 45.99619140625, lng: 8.778027343750011 },
        { lat: 46.06103515625, lng: 8.826757812500004 },
        { lat: 46.07714843749999, lng: 8.818554687500011 },
        { lat: 46.110791015625, lng: 8.641699218750006 },
        { lat: 46.159814453124994, lng: 8.5654296875 },
        { lat: 46.24589843749999, lng: 8.458398437500021 },
        { lat: 46.28286132812499, lng: 8.4384765625 },
        { lat: 46.402783203125, lng: 8.44296875 },
        { lat: 46.431884765625, lng: 8.436816406250017 },
        { lat: 46.44604492187499, lng: 8.422558593750011 },
        { lat: 46.445117187499996, lng: 8.370703125 },
        { lat: 46.40341796874999, lng: 8.298535156250011 },
        { lat: 46.341210937499994, lng: 8.23193359375 },
        { lat: 46.271044921874996, lng: 8.095703125 },
        { lat: 46.256005859374994, lng: 8.08154296875 },
        { lat: 46.18759765625, lng: 8.127246093750017 },
        { lat: 46.1609375, lng: 8.12519531250001 },
        { lat: 46.051904296874994, lng: 8.014257812500006 },
        { lat: 46.015917968749996, lng: 7.9931640625 },
        { lat: 45.94746093749999, lng: 7.852343750000016 },
        { lat: 45.921826171875, lng: 7.787890625000016 },
        { lat: 45.972216796874996, lng: 7.592578125000016 },
        { lat: 45.978173828124994, lng: 7.538574218749999 },
        { lat: 45.94443359375, lng: 7.451562500000023 },
        { lat: 45.912353515625, lng: 7.327929687500017 },
        { lat: 45.880419921874996, lng: 7.129003906250006 },
        { lat: 45.90380859374999, lng: 7.055761718750006 },
        { lat: 45.92578125, lng: 7.02109375 },
        { lat: 45.958837890625, lng: 7.00390625 },
        { lat: 46.017138671874996, lng: 6.953710937500006 },
        { lat: 46.05175781249999, lng: 6.897265625000016 },
        { lat: 46.089404296874996, lng: 6.858007812500006 },
        { lat: 46.13066406249999, lng: 6.8056640625 },
        { lat: 46.16513671875, lng: 6.772070312500006 },
        { lat: 46.275195312499996, lng: 6.816796875000023 },
        { lat: 46.31396484375, lng: 6.7841796875 },
        { lat: 46.36918945312499, lng: 6.767382812500016 },
        { lat: 46.40664062499999, lng: 6.77607421875001 },
        { lat: 46.41577148437499, lng: 6.758105468750017 },
        { lat: 46.437353515625, lng: 6.578222656250006 },
        { lat: 46.43051757812499, lng: 6.428906250000011 },
        { lat: 46.393701171874994, lng: 6.321875 },
        { lat: 46.3326171875, lng: 6.234667968750017 },
        { lat: 46.31943359375, lng: 6.22421875 },
        { lat: 46.308447265625, lng: 6.229589843750006 },
        { lat: 46.25224609374999, lng: 6.27294921875 },
        { lat: 46.19306640624999, lng: 6.199414062500011 },
        { lat: 46.147021484374996, lng: 6.086621093750011 },
        { lat: 46.14233398437499, lng: 6.006640625000016 },
        { lat: 46.151220703125, lng: 5.971484375000017 },
        { lat: 46.214697265625, lng: 5.970019531250017 },
        { lat: 46.238085937499996, lng: 6.0361328125 },
        { lat: 46.27939453124999, lng: 6.095898437500011 },
        { lat: 46.337646484375, lng: 6.115917968750011 },
        { lat: 46.37861328125, lng: 6.123242187500011 },
        { lat: 46.428173828125, lng: 6.06025390625001 },
        { lat: 46.458544921874996, lng: 6.06796875 },
        { lat: 46.516064453125, lng: 6.10703125 },
        { lat: 46.5669921875, lng: 6.129687500000017 },
        { lat: 46.61103515625, lng: 6.160742187500006 },
        { lat: 46.683056640625, lng: 6.28515625 },
        { lat: 46.755419921874996, lng: 6.41015625 },
        { lat: 46.832275390625, lng: 6.429003906250016 },
        { lat: 46.92587890625, lng: 6.438574218750006 },
        { lat: 46.94833984375, lng: 6.45625 },
        { lat: 47.004345703125, lng: 6.624804687500017 },
        { lat: 47.026513671874994, lng: 6.666894531250023 },
        { lat: 47.058251953124994, lng: 6.688085937500005 },
        { lat: 47.16318359375, lng: 6.820703125000023 },
        { lat: 47.2671875, lng: 6.952050781250023 },
        { lat: 47.302050781249996, lng: 6.978515625 },
        { lat: 47.322509765625, lng: 7.000585937500006 },
        { lat: 47.339453125, lng: 7.000585937500006 },
        { lat: 47.3525390625, lng: 6.98408203125001 },
        { lat: 47.361230468749994, lng: 6.921484375 },
        { lat: 47.39423828125, lng: 6.900390625 },
        { lat: 47.45322265625, lng: 6.968359375 },
        { lat: 47.48935546875, lng: 7.053417968750011 },
        { lat: 47.48984375, lng: 7.136035156250017 },
        { lat: 47.4732421875, lng: 7.169238281250018 },
        { lat: 47.45371093749999, lng: 7.167480468749999 },
        { lat: 47.43271484375, lng: 7.203125 },
        { lat: 47.42578125, lng: 7.265722656250005 },
        { lat: 47.43310546875, lng: 7.343164062500022 },
        { lat: 47.45517578125, lng: 7.420019531250006 },
        { lat: 47.507666015625, lng: 7.467382812500006 },
        { lat: 47.54736328125, lng: 7.494921875000016 },
        { lat: 47.592724609375, lng: 7.615625 },
        { lat: 47.569873046874996, lng: 7.698046875000017 },
        { lat: 47.563867187499994, lng: 7.927050781250016 },
        { lat: 47.576171875, lng: 8.09375 },
        { lat: 47.60693359375, lng: 8.198242187499998 },
        { lat: 47.60693359375, lng: 8.327832031250011 },
        { lat: 47.589599609375, lng: 8.414746093750011 },
        { lat: 47.592138671875, lng: 8.430078125000023 },
        { lat: 47.59619140625, lng: 8.454003906250023 },
        { lat: 47.612695312499994, lng: 8.477636718750006 },
        { lat: 47.6240234375, lng: 8.559472656250023 },
        { lat: 47.63779296875, lng: 8.570507812500011 },
        { lat: 47.651904296874996, lng: 8.567089843750011 },
        { lat: 47.65913085937499, lng: 8.55234375 },
        { lat: 47.651806640625, lng: 8.451757812500006 },
        { lat: 47.6626953125, lng: 8.413281250000011 },
        { lat: 47.687792968749996, lng: 8.403417968750004 },
        { lat: 47.73134765624999, lng: 8.435742187500011 },
        { lat: 47.766894531249996, lng: 8.509863281250006 },
        { lat: 47.775634765625, lng: 8.572656250000023 },
        { lat: 47.76611328125, lng: 8.617871093750011 },
        { lat: 47.700048828125, lng: 8.728320312500017 },
        { lat: 47.698046875, lng: 8.754785156250023 },
        { lat: 47.709912109375, lng: 8.770117187500004 },
        { lat: 47.71655273437499, lng: 8.793066406250006 },
        { lat: 47.70361328125, lng: 8.831152343750006 },
        { lat: 47.6626953125, lng: 8.874023437499998 },
        { lat: 47.656396484374994, lng: 8.881152343750017 },
        { lat: 47.670703125, lng: 9.127539062500006 },
        { lat: 47.670703125, lng: 9.182812500000011 },
        { lat: 47.598925781249996, lng: 9.35 },
        { lat: 47.52421875, lng: 9.524023437500006 },
      ],
    ],
  },
  {
    code: "AD",
    name: "Andorra",
    coordinates: [
      [
        { lat: 42.503320312499994, lng: 1.7060546875 },
        { lat: 42.49667968749999, lng: 1.678515625000017 },
        { lat: 42.455957031249994, lng: 1.58642578125 },
        { lat: 42.44169921874999, lng: 1.534082031250023 },
        { lat: 42.434472656249994, lng: 1.486230468750023 },
        { lat: 42.437451171875, lng: 1.448828125 },
        { lat: 42.46132812499999, lng: 1.428125 },
        { lat: 42.497851562499996, lng: 1.430273437500006 },
        { lat: 42.530810546874996, lng: 1.421972656250006 },
        { lat: 42.548388671874996, lng: 1.414843750000017 },
        { lat: 42.5958984375, lng: 1.428320312500006 },
        { lat: 42.6216796875, lng: 1.458886718750023 },
        { lat: 42.642724609374994, lng: 1.501367187500023 },
        { lat: 42.635009765625, lng: 1.568164062500017 },
        { lat: 42.604443359375, lng: 1.709863281250023 },
        { lat: 42.575927734375, lng: 1.739453125000011 },
        { lat: 42.55673828125, lng: 1.740234375 },
        { lat: 42.525634765625, lng: 1.713964843750006 },
        { lat: 42.503320312499994, lng: 1.7060546875 },
      ],
    ],
  },
  {
    code: "BE",
    name: "Belgium",
    coordinates: [
      [
        { lat: 51.432812499999955, lng: 4.816015625000033 },
        { lat: 51.41206054687501, lng: 4.820703125000023 },
        { lat: 51.40327148437498, lng: 4.84804687500008 },
        { lat: 51.40776367187501, lng: 4.943945312499977 },
        { lat: 51.445361328125045, lng: 4.992578125000023 },
        { lat: 51.46909179687498, lng: 5.03095703125004 },
        { lat: 51.453125, lng: 5.05947265625008 },
        { lat: 51.406835937500006, lng: 5.073437500000068 },
        { lat: 51.34648437499995, lng: 5.099902343750045 },
        { lat: 51.278955078124966, lng: 5.214160156250045 },
        { lat: 51.259716796874955, lng: 5.310839843750045 },
        { lat: 51.27299804687502, lng: 5.429785156250034 },
        { lat: 51.285058593749966, lng: 5.476855468750017 },
        { lat: 51.275, lng: 5.508789062500028 },
        { lat: 51.23930664062499, lng: 5.540429687499994 },
        { lat: 51.1984375, lng: 5.60878906250008 },
        { lat: 51.16948242187496, lng: 5.752343750000023 },
        { lat: 51.153076171875, lng: 5.796484375000033 },
        { lat: 51.125634765624994, lng: 5.827148437500057 },
        { lat: 51.08642578125, lng: 5.818261718750022 },
        { lat: 50.98876953124999, lng: 5.749804687500017 },
        { lat: 50.95991210937498, lng: 5.740820312500063 },
        { lat: 50.95024414062498, lng: 5.75 },
        { lat: 50.93212890625003, lng: 5.736621093750016 },
        { lat: 50.86665039062501, lng: 5.647558593750063 },
        { lat: 50.843603515625, lng: 5.639453125000017 },
        { lat: 50.80595703124999, lng: 5.669140625000011 },
        { lat: 50.774755859375006, lng: 5.69355468750001 },
        { lat: 50.78105468749996, lng: 5.69453125000004 },
        { lat: 50.80913085937501, lng: 5.830957031250051 },
        { lat: 50.75255685798351, lng: 5.89246112249532 },
        { lat: 50.75043945312503, lng: 5.993945312500017 },
        { lat: 50.73222656249996, lng: 6.005957031249977 },
        { lat: 50.67924804687502, lng: 6.119433593750016 },
        { lat: 50.63725585937499, lng: 6.154492187500039 },
        { lat: 50.59667968749997, lng: 6.235937500000033 },
        { lat: 50.54536132812501, lng: 6.168457031250057 },
        { lat: 50.52250976562496, lng: 6.1787109375 },
        { lat: 50.499121093750006, lng: 6.20302734375008 },
        { lat: 50.485498046874966, lng: 6.294921875000057 },
        { lat: 50.451757812500034, lng: 6.340917968750006 },
        { lat: 50.400244140625006, lng: 6.343652343750051 },
        { lat: 50.31616210937503, lng: 6.36445312500001 },
        { lat: 50.23266601562497, lng: 6.175097656250074 },
        { lat: 50.13935546874998, lng: 6.12128906250004 },
        { lat: 50.120996093749966, lng: 6.116503906250045 },
        { lat: 50.12377929687499, lng: 6.110058593750068 },
        { lat: 50.15458984374996, lng: 6.08906250000004 },
        { lat: 50.154296875, lng: 6.054785156249977 },
        { lat: 50.16718749999995, lng: 5.976269531250068 },
        { lat: 50.08281250000002, lng: 5.866894531250068 },
        { lat: 50.01269531250003, lng: 5.817382812500028 },
        { lat: 49.96123046875002, lng: 5.7880859375 },
        { lat: 49.919628906249976, lng: 5.744042968749994 },
        { lat: 49.875634765624994, lng: 5.73525390625008 },
        { lat: 49.85717773437506, lng: 5.740820312500063 },
        { lat: 49.83334960937498, lng: 5.725781250000011 },
        { lat: 49.80830078125003, lng: 5.725 },
        { lat: 49.758886718750006, lng: 5.78798828125008 },
        { lat: 49.73217773437497, lng: 5.8037109375 },
        { lat: 49.64477539062503, lng: 5.880371093749971 },
        { lat: 49.61284179687502, lng: 5.856542968750006 },
        { lat: 49.57832031249998, lng: 5.837597656250067 },
        { lat: 49.55380859375006, lng: 5.815429687499972 },
        { lat: 49.53828125000001, lng: 5.789746093749983 },
        { lat: 49.53920898437502, lng: 5.710449218749999 },
        { lat: 49.528222656249994, lng: 5.610058593750068 },
        { lat: 49.51103515624996, lng: 5.542382812500051 },
        { lat: 49.51088867187502, lng: 5.507324218749999 },
        { lat: 49.55449218750001, lng: 5.434667968750034 },
        { lat: 49.61982421875001, lng: 5.353515625000028 },
        { lat: 49.650976562500034, lng: 5.301953125000011 },
        { lat: 49.67792968750003, lng: 5.27880859375 },
        { lat: 49.68925781250002, lng: 5.215039062500068 },
        { lat: 49.72148437500001, lng: 5.124121093750006 },
        { lat: 49.756542968749976, lng: 5.061035156250028 },
        { lat: 49.77836914062498, lng: 5.006933593750034 },
        { lat: 49.789257812499976, lng: 4.930566406250023 },
        { lat: 49.78813476562502, lng: 4.867578125000051 },
        { lat: 49.84711914062504, lng: 4.849121093750028 },
        { lat: 49.914501953125004, lng: 4.841503906250068 },
        { lat: 49.959570312500034, lng: 4.790039062499972 },
        { lat: 50.135888671874994, lng: 4.86054687500004 },
        { lat: 50.15317382812503, lng: 4.818652343750045 },
        { lat: 50.1390625, lng: 4.772851562500023 },
        { lat: 50.097070312499966, lng: 4.706640625000034 },
        { lat: 50.046875, lng: 4.675097656250017 },
        { lat: 50.00244140624997, lng: 4.65615234375005 },
        { lat: 49.96025390624999, lng: 4.545019531250063 },
        { lat: 49.944970703124994, lng: 4.36875 },
        { lat: 49.96025390624999, lng: 4.176074218750045 },
        { lat: 49.971582031249994, lng: 4.149316406250023 },
        { lat: 49.984472656250034, lng: 4.137011718750074 },
        { lat: 50, lng: 4.136816406250034 },
        { lat: 50.02387695312498, lng: 4.150292968750023 },
        { lat: 50.052832031250034, lng: 4.183886718750045 },
        { lat: 50.09414062499999, lng: 4.192187500000045 },
        { lat: 50.1298828125, lng: 4.157714843750028 },
        { lat: 50.14379882812499, lng: 4.13525390625 },
        { lat: 50.17841796875004, lng: 4.144140625000034 },
        { lat: 50.22177734374998, lng: 4.169628906250067 },
        { lat: 50.24648437500005, lng: 4.174609375000017 },
        { lat: 50.32133789062502, lng: 4.044140624999983 },
        { lat: 50.33593749999997, lng: 3.949707031250028 },
        { lat: 50.338574218749976, lng: 3.858105468750011 },
        { lat: 50.34697265624999, lng: 3.788574218750057 },
        { lat: 50.343505859375, lng: 3.748046875000056 },
        { lat: 50.321679687499994, lng: 3.718847656250063 },
        { lat: 50.306054687500016, lng: 3.689355468750022 },
        { lat: 50.324804687500006, lng: 3.667285156250045 },
        { lat: 50.45732421875002, lng: 3.626757812500045 },
        { lat: 50.47734374999999, lng: 3.595410156250068 },
        { lat: 50.49946289062498, lng: 3.47695312500008 },
        { lat: 50.50737304687498, lng: 3.316210937500017 },
        { lat: 50.53154296875002, lng: 3.273339843750079 },
        { lat: 50.591162109375006, lng: 3.249804687500074 },
        { lat: 50.66293945312498, lng: 3.234960937499977 },
        { lat: 50.73168945312502, lng: 3.182031250000051 },
        { lat: 50.748925781249994, lng: 3.154882812500006 },
        { lat: 50.77944335937499, lng: 3.106835937500079 },
        { lat: 50.76689453125001, lng: 3.022851562500023 },
        { lat: 50.72705078124997, lng: 2.921972656250006 },
        { lat: 50.716015624999955, lng: 2.862402343750034 },
        { lat: 50.71176757812498, lng: 2.839746093750023 },
        { lat: 50.750634765624994, lng: 2.759375 },
        { lat: 50.81142578125002, lng: 2.669140625000011 },
        { lat: 50.87592773437501, lng: 2.596777343750006 },
        { lat: 50.91176757812505, lng: 2.579296874999983 },
        { lat: 50.95527343750001, lng: 2.60146484375008 },
        { lat: 50.98857421874996, lng: 2.574804687500063 },
        { lat: 51.04951171875004, lng: 2.536035156250051 },
        { lat: 51.097119140624955, lng: 2.52490234375 },
        { lat: 51.26542968749995, lng: 2.96015625000004 },
        { lat: 51.351611328125045, lng: 3.225195312500034 },
        { lat: 51.37768554687503, lng: 3.35009765625 },
        { lat: 51.29111328125006, lng: 3.380078125000068 },
        { lat: 51.26362304687495, lng: 3.40283203125 },
        { lat: 51.24575195312505, lng: 3.43251953125008 },
        { lat: 51.242236328125045, lng: 3.471972656250045 },
        { lat: 51.26362304687495, lng: 3.51708984375 },
        { lat: 51.28618164062501, lng: 3.580273437499983 },
        { lat: 51.27568359375002, lng: 3.681835937500068 },
        { lat: 51.25483398437504, lng: 3.755664062500017 },
        { lat: 51.23320312499998, lng: 3.78193359375004 },
        { lat: 51.212597656249955, lng: 3.83076171875004 },
        { lat: 51.207666015625016, lng: 3.902050781250011 },
        { lat: 51.24707031250006, lng: 4.040039062500057 },
        { lat: 51.30708007812501, lng: 4.17255859375004 },
        { lat: 51.34873046874998, lng: 4.211425781250057 },
        { lat: 51.38647460937503, lng: 4.226171875000034 },
        { lat: 51.36152343750001, lng: 4.304492187500017 },
        { lat: 51.356005859375045, lng: 4.373730468749983 },
        { lat: 51.36708984374999, lng: 4.40400390625004 },
        { lat: 51.42758789062506, lng: 4.384765625000028 },
        { lat: 51.459814453125055, lng: 4.44091796875 },
        { lat: 51.47470703124998, lng: 4.503417968750028 },
        { lat: 51.44858398437498, lng: 4.531640625000023 },
        { lat: 51.42192382812496, lng: 4.588769531250023 },
        { lat: 51.421728515625006, lng: 4.633984375000068 },
        { lat: 51.49111328125002, lng: 4.755664062499989 },
        { lat: 51.47739257812498, lng: 4.784179687500028 },
        { lat: 51.452734375000034, lng: 4.810546875 },
        { lat: 51.432812499999955, lng: 4.816015625000033 },
      ],
    ],
  },
  {
    name: "Belarus",
    code: "BY",
    coordinates: [
      [
        { lat: 56.142919921875, lng: 28.14794921875 },
        { lat: 56.055908203125, lng: 28.284277343750006 },
        { lat: 56.05253906249999, lng: 28.316308593750023 },
        { lat: 56.08671874999999, lng: 28.39208984375 },
        { lat: 56.089013671875, lng: 28.407031250000017 },
        { lat: 56.09199218749999, lng: 28.56396484375 },
        { lat: 56.061767578125, lng: 28.63691406250001 },
        { lat: 56.00263671875, lng: 28.69082031250002 },
        { lat: 55.955371093749996, lng: 28.740820312500002 },
        { lat: 55.94257812499999, lng: 28.794726562500014 },
        { lat: 56.002099609375, lng: 28.94746093750001 },
        { lat: 56.021777343749996, lng: 29.031738281249996 },
        { lat: 56.021142578125, lng: 29.087402343749996 },
        { lat: 55.96787109375, lng: 29.283007812500017 },
        { lat: 55.93872070312499, lng: 29.375 },
        { lat: 55.91220703125, lng: 29.39609375 },
        { lat: 55.8810546875, lng: 29.39794921875 },
        { lat: 55.834716796875, lng: 29.373144531250006 },
        { lat: 55.784375, lng: 29.353417968750023 },
        { lat: 55.72485351562499, lng: 29.412988281250023 },
        { lat: 55.6845703125, lng: 29.482226562500014 },
        { lat: 55.751171875, lng: 29.630078125 },
        { lat: 55.7697265625, lng: 29.6845703125 },
        { lat: 55.77041015625, lng: 29.744140625 },
        { lat: 55.7951171875, lng: 29.823925781250008 },
        { lat: 55.83232421874999, lng: 29.881640625000017 },
        { lat: 55.845263671874996, lng: 29.937011718749996 },
        { lat: 55.83642578125, lng: 30.042675781250008 },
        { lat: 55.84521484375, lng: 30.23359375000001 },
        { lat: 55.78681640625, lng: 30.45625 },
        { lat: 55.768798828125, lng: 30.475390625000014 },
        { lat: 55.70029296875, lng: 30.586718750000014 },
        { lat: 55.666259765625, lng: 30.625585937500006 },
        { lat: 55.65546875, lng: 30.66230468750001 },
        { lat: 55.622119140624996, lng: 30.7216796875 },
        { lat: 55.601123046874996, lng: 30.80078125 },
        { lat: 55.60751953124999, lng: 30.85595703125 },
        { lat: 55.59638671875, lng: 30.882226562500023 },
        { lat: 55.57001953125, lng: 30.906835937500006 },
        { lat: 55.525341796875, lng: 30.908789062500002 },
        { lat: 55.397412109375, lng: 30.900585937500015 },
        { lat: 55.360400390624996, lng: 30.861816406249996 },
        { lat: 55.3302734375, lng: 30.820996093750008 },
        { lat: 55.30698242187499, lng: 30.810546875 },
        { lat: 55.2787109375, lng: 30.814453125 },
        { lat: 55.22343749999999, lng: 30.87744140625 },
        { lat: 55.13759765625, lng: 30.95888671875002 },
        { lat: 55.08779296875, lng: 30.97773437500001 },
        { lat: 55.05048828124999, lng: 30.97773437500001 },
        { lat: 54.940722656249996, lng: 30.866796875 },
        { lat: 54.914990234375, lng: 30.829882812500014 },
        { lat: 54.8609375, lng: 30.804492187500014 },
        { lat: 54.806005859375, lng: 30.791015625 },
        { lat: 54.783251953124996, lng: 30.798828125 },
        { lat: 54.6958984375, lng: 30.984179687500014 },
        { lat: 54.648486328124996, lng: 31.121289062500008 },
        { lat: 54.625341796875, lng: 31.152148437500017 },
        { lat: 54.6109375, lng: 31.154882812500006 },
        { lat: 54.51708984375, lng: 31.081933593750023 },
        { lat: 54.491796875, lng: 31.074804687500006 },
        { lat: 54.452978515625, lng: 31.18476562500001 },
        { lat: 54.391650390624996, lng: 31.245507812500023 },
        { lat: 54.29169921875, lng: 31.29912109375002 },
        { lat: 54.195947265625, lng: 31.403613281250017 },
        { lat: 54.11118164062499, lng: 31.62841796875 },
        { lat: 54.055908203125, lng: 31.791992187499996 },
        { lat: 54.030712890625, lng: 31.825976562500014 },
        { lat: 54.00078125, lng: 31.837792968750023 },
        { lat: 53.935009765625, lng: 31.825292968750006 },
        { lat: 53.85498046874999, lng: 31.783007812500014 },
        { lat: 53.81044921875, lng: 31.754199218750017 },
        { lat: 53.79194335937499, lng: 31.82080078125 },
        { lat: 53.796875, lng: 31.9921875 },
        { lat: 53.78125, lng: 32.200390625 },
        { lat: 53.69291992187499, lng: 32.4501953125 },
        { lat: 53.6533203125, lng: 32.45097656250002 },
        { lat: 53.61728515625, lng: 32.42519531250002 },
        { lat: 53.579248046875, lng: 32.44238281249999 },
        { lat: 53.54697265625, lng: 32.469628906250016 },
        { lat: 53.44814453125, lng: 32.68574218750001 },
        { lat: 53.41943359375, lng: 32.70644531250002 },
        { lat: 53.371435546875, lng: 32.71025390625001 },
        { lat: 53.336328125, lng: 32.70429687500001 },
        { lat: 53.32890624999999, lng: 32.64443359375002 },
        { lat: 53.312402343749994, lng: 32.57802734375002 },
        { lat: 53.2703125, lng: 32.469335937500006 },
        { lat: 53.210595703124994, lng: 32.42626953125 },
        { lat: 53.128369140625, lng: 32.25068359375001 },
        { lat: 53.09116210937499, lng: 32.14199218750002 },
        { lat: 53.089453125, lng: 32.05546875000002 },
        { lat: 53.106201171875, lng: 31.849707031250006 },
        { lat: 53.146875, lng: 31.777441406250006 },
        { lat: 53.18417968749999, lng: 31.74746093750002 },
        { lat: 53.200927734375, lng: 31.668261718750017 },
        { lat: 53.20249023437499, lng: 31.562988281249996 },
        { lat: 53.196044921875, lng: 31.417871093750026 },
        { lat: 53.184814453125, lng: 31.38837890625001 },
        { lat: 53.138964843749996, lng: 31.364550781250017 },
        { lat: 53.060888671875, lng: 31.30292968750001 },
        { lat: 53.01669921875, lng: 31.2587890625 },
        { lat: 52.989794921874996, lng: 31.29511718750001 },
        { lat: 52.933447265625, lng: 31.353027343749996 },
        { lat: 52.86181640625, lng: 31.442773437500023 },
        { lat: 52.7982421875, lng: 31.53515625 },
        { lat: 52.75922851562499, lng: 31.56484375000002 },
        { lat: 52.7314453125, lng: 31.5634765625 },
        { lat: 52.69873046875, lng: 31.51943359375002 },
        { lat: 52.6330078125, lng: 31.526171875000017 },
        { lat: 52.546191406249996, lng: 31.615917968750008 },
        { lat: 52.532470703125, lng: 31.585546875 },
        { lat: 52.426025390625, lng: 31.57656250000002 },
        { lat: 52.312304687499996, lng: 31.57734375000001 },
        { lat: 52.284814453125, lng: 31.6015625 },
        { lat: 52.26220703125, lng: 31.64990234375 },
        { lat: 52.220654296875, lng: 31.690625 },
        { lat: 52.125830078125, lng: 31.758593750000014 },
        { lat: 52.10107421874999, lng: 31.76337890625001 },
        { lat: 52.10810546874999, lng: 31.57373046875 },
        { lat: 52.10537109375, lng: 31.345996093750014 },
        { lat: 52.050244140625, lng: 31.21796875000001 },
        { lat: 52.062939453125, lng: 31.16845703125 },
        { lat: 52.076953125, lng: 31.079296875 },
        { lat: 52.046191406249996, lng: 30.980664062500008 },
        { lat: 51.95307617187499, lng: 30.845703125 },
        { lat: 51.895166015625, lng: 30.75527343750002 },
        { lat: 51.814111328125, lng: 30.667285156250017 },
        { lat: 51.770068359374996, lng: 30.639453125000017 },
        { lat: 51.68896484375, lng: 30.583886718750026 },
        { lat: 51.596337890624994, lng: 30.533007812500017 },
        { lat: 51.531494140625, lng: 30.56074218750001 },
        { lat: 51.471240234374996, lng: 30.602343750000017 },
        { lat: 51.40634765625, lng: 30.611718750000023 },
        { lat: 51.355419921875, lng: 30.632519531250008 },
        { lat: 51.318359375, lng: 30.576953125000014 },
        { lat: 51.265039062499994, lng: 30.54453125 },
        { lat: 51.274316406249994, lng: 30.449511718750017 },
        { lat: 51.32553710937499, lng: 30.333398437500026 },
        { lat: 51.399609375, lng: 30.308984375000023 },
        { lat: 51.451220703124996, lng: 30.219531250000017 },
        { lat: 51.477880859375, lng: 30.160742187500002 },
        { lat: 51.48203125, lng: 30.063769531250017 },
        { lat: 51.4580078125, lng: 29.908789062500002 },
        { lat: 51.43955078125, lng: 29.7060546875 },
        { lat: 51.4345703125, lng: 29.553125 },
        { lat: 51.40834960937499, lng: 29.469628906250023 },
        { lat: 51.382568359375, lng: 29.346484375000014 },
        { lat: 51.413037109375, lng: 29.298828125 },
        { lat: 51.497021484375, lng: 29.23046875 },
        { lat: 51.58061523437499, lng: 29.17421875000002 },
        { lat: 51.61728515624999, lng: 29.135644531250023 },
        { lat: 51.62753906249999, lng: 29.10205078125 },
        { lat: 51.625439453125, lng: 29.060742187500008 },
        { lat: 51.598925781249996, lng: 29.013085937500023 },
        { lat: 51.57177734375, lng: 28.97773437500001 },
        { lat: 51.562158203124994, lng: 28.92753906250002 },
        { lat: 51.540185546874994, lng: 28.849511718750023 },
        { lat: 51.5103515625, lng: 28.793261718750017 },
        { lat: 51.433398437499996, lng: 28.73125 },
        { lat: 51.438867187499994, lng: 28.690234375000017 },
        { lat: 51.45654296875, lng: 28.647753906250017 },
        { lat: 51.542626953124994, lng: 28.599023437500023 },
        { lat: 51.562451171875, lng: 28.532031250000017 },
        { lat: 51.563623046874994, lng: 28.424609375000017 },
        { lat: 51.581835937499996, lng: 28.291601562500002 },
        { lat: 51.607861328125, lng: 28.18378906250001 },
        { lat: 51.60166015625, lng: 28.14443359375002 },
        { lat: 51.5650390625, lng: 28.08027343750001 },
        { lat: 51.559765625, lng: 28.0107421875 },
        { lat: 51.5923828125, lng: 27.85859375000001 },
        { lat: 51.57744140624999, lng: 27.82880859375001 },
        { lat: 51.529150390625, lng: 27.788867187500017 },
        { lat: 51.482568359374994, lng: 27.741308593750006 },
        { lat: 51.477978515625, lng: 27.7 },
        { lat: 51.48994140625, lng: 27.676757812499996 },
        { lat: 51.572412109374994, lng: 27.689746093750017 },
        { lat: 51.601611328124996, lng: 27.601367187500017 },
        { lat: 51.606103515625, lng: 27.45234375000001 },
        { lat: 51.59414062499999, lng: 27.34765625 },
        { lat: 51.597412109375, lng: 27.296289062500023 },
        { lat: 51.613574218749996, lng: 27.270117187500006 },
        { lat: 51.75205078125, lng: 27.141992187500023 },
        { lat: 51.76083984375, lng: 27.074121093750023 },
        { lat: 51.75400390624999, lng: 26.95283203125001 },
        { lat: 51.770703125, lng: 26.7734375 },
        { lat: 51.801904296875, lng: 26.566894531249996 },
        { lat: 51.813427734375, lng: 26.453417968750017 },
        { lat: 51.84443359375, lng: 26.394335937500014 },
        { lat: 51.855029296874996, lng: 26.26708984375 },
        { lat: 51.913525390625, lng: 25.925292968749996 },
        { lat: 51.92382812499999, lng: 25.785742187500006 },
        { lat: 51.924755859375, lng: 25.58027343750001 },
        { lat: 51.937744140625, lng: 25.2671875 },
        { lat: 51.93051757812499, lng: 25.066699218750017 },
        { lat: 51.91113281249999, lng: 24.97382812500001 },
        { lat: 51.89912109375, lng: 24.86640625 },
        { lat: 51.88828125, lng: 24.68515625 },
        { lat: 51.889501953125, lng: 24.611328125 },
        { lat: 51.883056640625, lng: 24.495214843750006 },
        { lat: 51.867529296875, lng: 24.361914062500006 },
        { lat: 51.838427734374996, lng: 24.323730468749996 },
        { lat: 51.774707031249996, lng: 24.280078125000017 },
        { lat: 51.6646484375, lng: 24.126855468750023 },
        { lat: 51.59130859375, lng: 23.978320312500017 },
        { lat: 51.58505859375, lng: 23.951171875 },
        { lat: 51.62397460937499, lng: 23.8642578125 },
        { lat: 51.637109375, lng: 23.79169921875001 },
        { lat: 51.64130859375, lng: 23.706835937500017 },
        { lat: 51.628857421875, lng: 23.64667968750001 },
        { lat: 51.610498046875, lng: 23.60859375000001 },
        { lat: 51.525390625, lng: 23.613769531249996 },
        { lat: 51.51791992187499, lng: 23.605273437500017 },
        { lat: 51.618896484375, lng: 23.539648437500006 },
        { lat: 51.710253906249996, lng: 23.54482421875002 },
        { lat: 51.76240234375, lng: 23.581347656250017 },
        { lat: 51.80932617187499, lng: 23.62568359375001 },
        { lat: 51.879785156249994, lng: 23.607421875 },
        { lat: 51.972998046875, lng: 23.65107421875001 },
        { lat: 52.040380859375, lng: 23.652441406250006 },
        { lat: 52.069580078125, lng: 23.63330078125 },
        { lat: 52.103076171874996, lng: 23.597949218750017 },
        { lat: 52.140380859375, lng: 23.50117187500001 },
        { lat: 52.16953125, lng: 23.458398437500023 },
        { lat: 52.208447265625, lng: 23.327148437499996 },
        { lat: 52.25693359375, lng: 23.19697265625001 },
        { lat: 52.28662109375, lng: 23.175097656250017 },
        { lat: 52.306982421875, lng: 23.18125 },
        { lat: 52.337890625, lng: 23.2041015625 },
        { lat: 52.428369140624994, lng: 23.303320312500006 },
        { lat: 52.5162109375, lng: 23.410937500000017 },
        { lat: 52.5515625, lng: 23.479589843750006 },
        { lat: 52.664208984375, lng: 23.844726562499996 },
        { lat: 52.70361328125, lng: 23.901269531250023 },
        { lat: 52.770263671875, lng: 23.915429687500023 },
        { lat: 52.81875, lng: 23.916308593750017 },
        { lat: 52.9048828125, lng: 23.909375 },
        { lat: 53.0275390625, lng: 23.887109375000023 },
        { lat: 53.112109375, lng: 23.859179687500017 },
        { lat: 53.270947265625, lng: 23.78925781250001 },
        { lat: 53.59921875, lng: 23.598925781250017 },
        { lat: 53.939794921875, lng: 23.484667968750017 },
        { lat: 53.919824218749994, lng: 23.55908203125 },
        { lat: 53.912255859375, lng: 23.733691406250017 },
        { lat: 53.935693359374994, lng: 23.872558593749996 },
        { lat: 53.93896484375, lng: 23.944433593750006 },
        { lat: 53.931640625, lng: 24.00849609375001 },
        { lat: 53.94501953125, lng: 24.103906250000023 },
        { lat: 53.950439453125, lng: 24.191308593750023 },
        { lat: 53.919970703124996, lng: 24.236621093750014 },
        { lat: 53.89296875, lng: 24.31796875 },
        { lat: 53.9318359375, lng: 24.478515625 },
        { lat: 53.979833984375, lng: 24.620703125 },
        { lat: 53.974658203124996, lng: 24.768164062500006 },
        { lat: 53.9982421875, lng: 24.78925781250001 },
        { lat: 54.118994140625, lng: 24.82568359375 },
        { lat: 54.145166015625, lng: 24.869531250000023 },
        { lat: 54.133056640625, lng: 25.04609375 },
        { lat: 54.154931640625, lng: 25.111425781250002 },
        { lat: 54.2142578125, lng: 25.179492187500014 },
        { lat: 54.251269531249996, lng: 25.28369140625 },
        { lat: 54.251220703125, lng: 25.37060546875 },
        { lat: 54.292773437499996, lng: 25.461132812500008 },
        { lat: 54.264941406249996, lng: 25.505664062500017 },
        { lat: 54.215136718749996, lng: 25.52734375 },
        { lat: 54.17524414062499, lng: 25.497363281250017 },
        { lat: 54.159619140625, lng: 25.510351562500006 },
        { lat: 54.139892578125, lng: 25.573046875000014 },
        { lat: 54.140478515625, lng: 25.680566406250023 },
        { lat: 54.15698242187499, lng: 25.74921875000001 },
        { lat: 54.17978515625, lng: 25.765234375 },
        { lat: 54.22119140625, lng: 25.765039062500023 },
        { lat: 54.25966796875, lng: 25.748144531250006 },
        { lat: 54.29296875, lng: 25.70253906250002 },
        { lat: 54.310107421874996, lng: 25.61689453125001 },
        { lat: 54.310693359375, lng: 25.557519531250023 },
        { lat: 54.331835937499996, lng: 25.54736328125 },
        { lat: 54.37705078125, lng: 25.56757812500001 },
        { lat: 54.460400390625, lng: 25.62031250000001 },
        { lat: 54.535791015625, lng: 25.68515625 },
        { lat: 54.56425781249999, lng: 25.72480468750001 },
        { lat: 54.590380859374996, lng: 25.73164062500001 },
        { lat: 54.636035156249996, lng: 25.723925781250017 },
        { lat: 54.71787109374999, lng: 25.722460937500017 },
        { lat: 54.833251953125, lng: 25.780859375 },
        { lat: 54.919287109375, lng: 25.859277343750023 },
        { lat: 54.94716796875, lng: 25.964453125 },
        { lat: 54.9623046875, lng: 26.09296875000001 },
        { lat: 55.00327148437499, lng: 26.175195312500023 },
        { lat: 55.050390625, lng: 26.2158203125 },
        { lat: 55.090136718749996, lng: 26.23125 },
        { lat: 55.12451171874999, lng: 26.250781250000017 },
        { lat: 55.13959960937499, lng: 26.291796875000014 },
        { lat: 55.130175781249996, lng: 26.601171875 },
        { lat: 55.20419921875, lng: 26.6484375 },
        { lat: 55.22490234374999, lng: 26.675 },
        { lat: 55.24677734375, lng: 26.734375 },
        { lat: 55.273095703125, lng: 26.775683593750017 },
        { lat: 55.293359375, lng: 26.760156250000023 },
        { lat: 55.306445312499996, lng: 26.68125 },
        { lat: 55.318017578125, lng: 26.49531250000001 },
        { lat: 55.34248046875, lng: 26.457617187500006 },
        { lat: 55.371923828125, lng: 26.469531250000017 },
        { lat: 55.44814453125, lng: 26.51923828125001 },
        { lat: 55.546484375, lng: 26.566601562500008 },
        { lat: 55.62265625, lng: 26.5908203125 },
        { lat: 55.667529296874996, lng: 26.593554687500017 },
        { lat: 55.679638671875, lng: 26.620214843750006 },
        { lat: 55.693994140625, lng: 26.771875 },
        { lat: 55.709228515625, lng: 26.82246093750001 },
        { lat: 55.81293945312499, lng: 26.953027343750023 },
        { lat: 55.83056640624999, lng: 27.052539062500017 },
        { lat: 55.80390625, lng: 27.309179687500006 },
        { lat: 55.805957031249996, lng: 27.427148437500023 },
        { lat: 55.803515625, lng: 27.45917968750001 },
        { lat: 55.798779296875, lng: 27.576757812500006 },
        { lat: 55.8091796875, lng: 27.589453125 },
        { lat: 55.91171875, lng: 27.642285156250008 },
        { lat: 55.941552734374994, lng: 27.694238281250023 },
        { lat: 56.07617187499999, lng: 27.896289062500017 },
        { lat: 56.13330078125, lng: 28.032031250000017 },
        { lat: 56.145800781249996, lng: 28.11787109375001 },
        { lat: 56.142919921875, lng: 28.14794921875 },
      ],
    ],
  },
  {
    code: "CZ",
    name: "Czech Republic",
    coordinates: [
      [
        { lat: 50.858984375, lng: 14.809375 },
        { lat: 50.861376953124996, lng: 14.895800781250015 },
        { lat: 50.88657226562499, lng: 14.982910156249998 },
        { lat: 50.92724609375, lng: 14.989941406250011 },
        { lat: 51.00341796875, lng: 14.984472656250006 },
        { lat: 51.01435546875, lng: 14.99375 },
        { lat: 50.99287109375, lng: 15.125976562499998 },
        { lat: 50.958544921874996, lng: 15.258593750000017 },
        { lat: 50.88300781249999, lng: 15.277050781250011 },
        { lat: 50.845751953124996, lng: 15.312597656250004 },
        { lat: 50.811767578125, lng: 15.354394531250021 },
        { lat: 50.796289062499994, lng: 15.394628906250007 },
        { lat: 50.79384765624999, lng: 15.463964843750006 },
        { lat: 50.748876953125, lng: 15.643945312500023 },
        { lat: 50.739697265625, lng: 15.730566406250006 },
        { lat: 50.70869140625, lng: 15.819238281250023 },
        { lat: 50.67690429687499, lng: 15.893945312500023 },
        { lat: 50.670263671875, lng: 15.948535156250017 },
        { lat: 50.63544921875, lng: 15.973828125000011 },
        { lat: 50.611621093749996, lng: 16.007226562500023 },
        { lat: 50.629931640624996, lng: 16.06640625 },
        { lat: 50.655615234375, lng: 16.2822265625 },
        { lat: 50.621386718749996, lng: 16.359960937500006 },
        { lat: 50.58515625, lng: 16.4125 },
        { lat: 50.57363281249999, lng: 16.419726562500017 },
        { lat: 50.541650390624994, lng: 16.39228515625001 },
        { lat: 50.516894531249996, lng: 16.379101562500008 },
        { lat: 50.50048828125, lng: 16.35664062500001 },
        { lat: 50.4830078125, lng: 16.282519531250017 },
        { lat: 50.4546875, lng: 16.24072265625 },
        { lat: 50.423730468749994, lng: 16.210351562500023 },
        { lat: 50.394091796874996, lng: 16.230761718750017 },
        { lat: 50.371875, lng: 16.291308593750017 },
        { lat: 50.36689453125, lng: 16.334179687500008 },
        { lat: 50.34521484375, lng: 16.350488281250023 },
        { lat: 50.248388671875, lng: 16.487597656250017 },
        { lat: 50.121923828125, lng: 16.5966796875 },
        { lat: 50.1021484375, lng: 16.63916015625 },
        { lat: 50.097460937499996, lng: 16.679101562500023 },
        { lat: 50.116064453125, lng: 16.72529296875001 },
        { lat: 50.15703125, lng: 16.778613281250017 },
        { lat: 50.18671875, lng: 16.841796875 },
        { lat: 50.20195312499999, lng: 16.895312500000014 },
        { lat: 50.2369140625, lng: 16.989648437500023 },
        { lat: 50.25971679687499, lng: 16.99335937500001 },
        { lat: 50.34521484375, lng: 16.91474609375001 },
        { lat: 50.414501953125, lng: 16.869140625 },
        { lat: 50.427050781249996, lng: 16.88007812500001 },
        { lat: 50.41611328125, lng: 16.980761718750017 },
        { lat: 50.378320312499994, lng: 17.151953125 },
        { lat: 50.25478515624999, lng: 17.41523437500001 },
        { lat: 50.25478515624999, lng: 17.462304687500023 },
        { lat: 50.2640625, lng: 17.554589843750023 },
        { lat: 50.284228515624996, lng: 17.654687500000023 },
        { lat: 50.307177734374996, lng: 17.702246093750006 },
        { lat: 50.298632812499996, lng: 17.720117187500023 },
        { lat: 50.230761718749996, lng: 17.735449218750006 },
        { lat: 50.1935546875, lng: 17.709277343750017 },
        { lat: 50.157470703125, lng: 17.58935546875 },
        { lat: 50.139501953125, lng: 17.596289062500006 },
        { lat: 50.11640625, lng: 17.627050781250002 },
        { lat: 50.10078125, lng: 17.68105468750002 },
        { lat: 50.05678710937499, lng: 17.74658203125 },
        { lat: 50.006591796875, lng: 17.79169921875001 },
        { lat: 49.983300781249994, lng: 17.83125 },
        { lat: 49.97226562499999, lng: 17.874804687500014 },
        { lat: 49.999072265624996, lng: 17.983789062500023 },
        { lat: 50.020263671875, lng: 18.0146484375 },
        { lat: 50.03525390625, lng: 18.028320312499996 },
        { lat: 50.03193359375, lng: 18.04951171875001 },
        { lat: 50.007275390625, lng: 18.087695312500017 },
        { lat: 49.9927734375, lng: 18.09921875 },
        { lat: 49.964746093749994, lng: 18.205273437500008 },
        { lat: 49.93027343749999, lng: 18.26630859375001 },
        { lat: 49.9140625, lng: 18.305273437500006 },
        { lat: 49.929833984374994, lng: 18.348437500000017 },
        { lat: 49.902392578124996, lng: 18.516210937500006 },
        { lat: 49.879345703125, lng: 18.562402343750023 },
        { lat: 49.841113281249996, lng: 18.5771484375 },
        { lat: 49.81791992187499, lng: 18.56884765625 },
        { lat: 49.7578125, lng: 18.594628906250023 },
        { lat: 49.613720703125, lng: 18.806933593750017 },
        { lat: 49.54013671875, lng: 18.82929687500001 },
        { lat: 49.510791015624996, lng: 18.83222656250001 },
        { lat: 49.50922851562499, lng: 18.807031250000023 },
        { lat: 49.493994140625, lng: 18.74970703125001 },
        { lat: 49.48847656249999, lng: 18.676171875000023 },
        { lat: 49.491455078125, lng: 18.596484375000017 },
        { lat: 49.464697265625, lng: 18.534570312500023 },
        { lat: 49.42109375, lng: 18.47607421875 },
        { lat: 49.390917968749996, lng: 18.415820312500014 },
        { lat: 49.363916015624994, lng: 18.383105468750017 },
        { lat: 49.33623046874999, lng: 18.36484375 },
        { lat: 49.257373046874996, lng: 18.160937500000017 },
        { lat: 49.22456054687499, lng: 18.132617187500017 },
        { lat: 49.17978515625, lng: 18.109960937500006 },
        { lat: 49.1193359375, lng: 18.100390625000017 },
        { lat: 49.06513671875, lng: 18.0859375 },
        { lat: 49.036523437499994, lng: 18.050878906250006 },
        { lat: 49.011962890625, lng: 17.940722656250017 },
        { lat: 48.99873046874999, lng: 17.91328125000001 },
        { lat: 48.971142578125, lng: 17.892675781250006 },
        { lat: 48.92861328124999, lng: 17.830859375000017 },
        { lat: 48.888134765625, lng: 17.758496093750008 },
        { lat: 48.841845703124996, lng: 17.62539062500002 },
        { lat: 48.827783203124994, lng: 17.482617187500008 },
        { lat: 48.842822265624996, lng: 17.296875 },
        { lat: 48.8609375, lng: 17.1884765625 },
        { lat: 48.841064453125, lng: 17.13564453125002 },
        { lat: 48.78076171875, lng: 17.063281250000017 },
        { lat: 48.676904296874994, lng: 16.985253906250023 },
        { lat: 48.59882812499999, lng: 16.953125 },
        { lat: 48.620898437499996, lng: 16.928320312500006 },
        { lat: 48.7037109375, lng: 16.883691406250023 },
        { lat: 48.714306640625, lng: 16.83320312500001 },
        { lat: 48.722021484375, lng: 16.764453125000017 },
        { lat: 48.734228515625, lng: 16.712695312500017 },
        { lat: 48.781884765624994, lng: 16.600976562500023 },
        { lat: 48.796240234375, lng: 16.543554687500006 },
        { lat: 48.800097656249996, lng: 16.477929687500023 },
        { lat: 48.7720703125, lng: 16.414843750000017 },
        { lat: 48.73896484375, lng: 16.367285156250006 },
        { lat: 48.73940429687499, lng: 16.219335937500006 },
        { lat: 48.754785156249994, lng: 16.057226562500006 },
        { lat: 48.86445312499999, lng: 15.825195312499998 },
        { lat: 48.8654296875, lng: 15.765039062500021 },
        { lat: 48.86044921875, lng: 15.70078125 },
        { lat: 48.886376953124994, lng: 15.599414062500015 },
        { lat: 48.957373046875, lng: 15.402929687500004 },
        { lat: 48.97402343749999, lng: 15.310937500000023 },
        { lat: 48.96386718749999, lng: 15.252734375000015 },
        { lat: 48.948144531249994, lng: 15.199609375000023 },
        { lat: 48.9462890625, lng: 15.16171875 },
        { lat: 48.9693359375, lng: 15.139746093750004 },
        { lat: 48.997851562499996, lng: 15.066796875000023 },
        { lat: 49.001123046874994, lng: 14.993457031250017 },
        { lat: 48.98393554687499, lng: 14.972167968749998 },
        { lat: 48.827734375, lng: 14.947363281250004 },
        { lat: 48.771386718749994, lng: 14.92255859375001 },
        { lat: 48.7740234375, lng: 14.821875 },
        { lat: 48.747363281249996, lng: 14.785937500000017 },
        { lat: 48.671923828124996, lng: 14.706640625 },
        { lat: 48.59921875, lng: 14.691308593750021 },
        { lat: 48.613330078124996, lng: 14.553906250000011 },
        { lat: 48.625537109374996, lng: 14.488671875000023 },
        { lat: 48.616259765624996, lng: 14.431054687500023 },
        { lat: 48.576220703124996, lng: 14.367578125000023 },
        { lat: 48.578564453125, lng: 14.189843750000023 },
        { lat: 48.602490234375, lng: 14.049121093750017 },
        { lat: 48.692431640624996, lng: 13.98876953125 },
        { lat: 48.72802734375, lng: 13.92431640625 },
        { lat: 48.75986328124999, lng: 13.843164062500023 },
        { lat: 48.766943359375, lng: 13.814746093750017 },
        { lat: 48.815966796874996, lng: 13.769921875000023 },
        { lat: 48.876708984375, lng: 13.684960937500023 },
        { lat: 48.95966796875, lng: 13.547656250000017 },
        { lat: 48.95556640625, lng: 13.440722656250017 },
        { lat: 48.97758789062499, lng: 13.401171875000017 },
        { lat: 49.008105468749996, lng: 13.383691406250023 },
        { lat: 49.060791015625, lng: 13.339062500000011 },
        { lat: 49.097460937499996, lng: 13.288769531250011 },
        { lat: 49.111669921875, lng: 13.227832031250017 },
        { lat: 49.158349609374994, lng: 13.140527343750021 },
        { lat: 49.260107421875, lng: 13.023730468750017 },
        { lat: 49.33046875, lng: 12.916699218750011 },
        { lat: 49.329345703125, lng: 12.813378906250021 },
        { lat: 49.36621093749999, lng: 12.747851562500017 },
        { lat: 49.41450195312499, lng: 12.68115234375 },
        { lat: 49.461230468749996, lng: 12.63203125000001 },
        { lat: 49.574853515624994, lng: 12.555761718750006 },
        { lat: 49.639697265624996, lng: 12.500292968750015 },
        { lat: 49.67978515624999, lng: 12.45703125 },
        { lat: 49.713183593749996, lng: 12.408203125 },
        { lat: 49.73964843749999, lng: 12.390527343750023 },
        { lat: 49.800146484375, lng: 12.4501953125 },
        { lat: 49.830078125, lng: 12.471875 },
        { lat: 49.853076171874996, lng: 12.497558593749998 },
        { lat: 49.87744140624999, lng: 12.5125 },
        { lat: 49.895800781249996, lng: 12.512011718750015 },
        { lat: 49.955517578125, lng: 12.457617187500006 },
        { lat: 49.998583984374996, lng: 12.384179687500023 },
        { lat: 50.04233398437499, lng: 12.276464843750006 },
        { lat: 50.097509765625, lng: 12.207812500000017 },
        { lat: 50.14804687499999, lng: 12.182519531250021 },
        { lat: 50.175830078124996, lng: 12.175 },
        { lat: 50.213427734374996, lng: 12.127832031250023 },
        { lat: 50.26855468749999, lng: 12.089746093750023 },
        { lat: 50.3017578125, lng: 12.08984375 },
        { lat: 50.310986328125, lng: 12.09921875 },
        { lat: 50.3109375, lng: 12.134863281250006 },
        { lat: 50.288378906249996, lng: 12.174804687499998 },
        { lat: 50.244873046875, lng: 12.231152343750011 },
        { lat: 50.181445312499996, lng: 12.27734375 },
        { lat: 50.205712890624994, lng: 12.3056640625 },
        { lat: 50.273242187499996, lng: 12.358593750000011 },
        { lat: 50.3498046875, lng: 12.452636718749998 },
        { lat: 50.393408203125, lng: 12.549023437500011 },
        { lat: 50.3970703125, lng: 12.635546875000017 },
        { lat: 50.40913085937499, lng: 12.706445312500021 },
        { lat: 50.43095703124999, lng: 12.765429687500015 },
        { lat: 50.422216796875, lng: 12.868261718750006 },
        { lat: 50.4064453125, lng: 12.942675781250017 },
        { lat: 50.4162109375, lng: 12.966796875 },
        { lat: 50.4560546875, lng: 12.9970703125 },
        { lat: 50.490380859374994, lng: 13.016406250000017 },
        { lat: 50.510498046875, lng: 13.18115234375 },
        { lat: 50.5767578125, lng: 13.237695312500023 },
        { lat: 50.576416015625, lng: 13.26953125 },
        { lat: 50.58632812499999, lng: 13.306054687500023 },
        { lat: 50.61142578125, lng: 13.341015625000011 },
        { lat: 50.621728515624994, lng: 13.374609375 },
        { lat: 50.609326171875, lng: 13.401171875000017 },
        { lat: 50.60107421875, lng: 13.436132812500004 },
        { lat: 50.616943359375, lng: 13.472558593750023 },
        { lat: 50.692822265625, lng: 13.526562500000011 },
        { lat: 50.704638671874996, lng: 13.556738281250006 },
        { lat: 50.71650390625, lng: 13.701367187500011 },
        { lat: 50.761279296874996, lng: 13.898535156250006 },
        { lat: 50.801123046875, lng: 13.998437500000023 },
        { lat: 50.82275390624999, lng: 14.096484375000017 },
        { lat: 50.861230468749994, lng: 14.201757812500004 },
        { lat: 50.898730468749996, lng: 14.369042968750023 },
        { lat: 50.9140625, lng: 14.377050781250006 },
        { lat: 50.952587890625, lng: 14.299414062500006 },
        { lat: 50.976904296875, lng: 14.273339843750023 },
        { lat: 51.001855468749994, lng: 14.255859375 },
        { lat: 51.0294921875, lng: 14.283203125 },
        { lat: 51.03779296875, lng: 14.319726562500023 },
        { lat: 51.026269531249994, lng: 14.367285156250006 },
        { lat: 51.00986328124999, lng: 14.50732421875 },
        { lat: 50.993945312499996, lng: 14.545703125000017 },
        { lat: 50.95493164062499, lng: 14.559667968750006 },
        { lat: 50.91860351562499, lng: 14.59521484375 },
        { lat: 50.91474609374999, lng: 14.623828125000015 },
        { lat: 50.85556640624999, lng: 14.613574218750015 },
        { lat: 50.83261718749999, lng: 14.658203125 },
        { lat: 50.81469726562499, lng: 14.72333984375001 },
        { lat: 50.818310546875, lng: 14.766503906250025 },
        { lat: 50.842333984374996, lng: 14.797460937500004 },
        { lat: 50.858984375, lng: 14.809375 },
      ],
    ],
  },
  {
    name: "Bulgaria",
    code: "BG",
    coordinates: [
      [
        { lat: 43.742236328124996, lng: 28.585351562500023 },
        { lat: 43.501318359375, lng: 28.561816406250017 },
        { lat: 43.389306640624994, lng: 28.465429687500006 },
        { lat: 43.42685546874999, lng: 28.319628906250017 },
        { lat: 43.39560546875, lng: 28.13369140625002 },
        { lat: 43.26826171875, lng: 28.03515625 },
        { lat: 43.230517578124996, lng: 27.979296875000017 },
        { lat: 43.1861328125, lng: 27.92890625 },
        { lat: 43.020703125, lng: 27.896484375 },
        { lat: 42.74970703125, lng: 27.88886718750001 },
        { lat: 42.716650390625, lng: 27.818359375 },
        { lat: 42.70654296875, lng: 27.753710937500017 },
        { lat: 42.468066406249996, lng: 27.484765625000023 },
        { lat: 42.4009765625, lng: 27.63955078125002 },
        { lat: 42.349951171875, lng: 27.70820312500001 },
        { lat: 42.2080078125, lng: 27.821386718750006 },
        { lat: 42.04741210937499, lng: 27.982714843750017 },
        { lat: 41.969042968749996, lng: 28.014453125000017 },
        { lat: 41.986621093749996, lng: 27.879199218750017 },
        { lat: 41.981298828125, lng: 27.831933593750023 },
        { lat: 41.95654296874999, lng: 27.801660156250023 },
        { lat: 41.9615234375, lng: 27.738867187500006 },
        { lat: 41.96132812499999, lng: 27.6611328125 },
        { lat: 41.93291015624999, lng: 27.579882812500017 },
        { lat: 41.920800781249994, lng: 27.53486328125001 },
        { lat: 41.946875, lng: 27.47480468750001 },
        { lat: 42.025048828124994, lng: 27.362890625 },
        { lat: 42.079541015625, lng: 27.294921875 },
        { lat: 42.09326171874999, lng: 27.244335937500008 },
        { lat: 42.077099609375, lng: 27.193359375 },
        { lat: 42.058642578124996, lng: 27.01171875 },
        { lat: 42.02685546875, lng: 26.96875 },
        { lat: 41.991845703124994, lng: 26.884863281250006 },
        { lat: 41.975146484374996, lng: 26.800390625 },
        { lat: 41.963330078125, lng: 26.67919921875 },
        { lat: 41.964892578124996, lng: 26.615332031250006 },
        { lat: 41.94794921875, lng: 26.5796875 },
        { lat: 41.896728515625, lng: 26.549707031250023 },
        { lat: 41.8466796875, lng: 26.529296875 },
        { lat: 41.8263671875, lng: 26.51142578125001 },
        { lat: 41.8015625, lng: 26.3603515625 },
        { lat: 41.772802734375, lng: 26.327246093750006 },
        { lat: 41.744677734374996, lng: 26.31796875 },
        { lat: 41.716552734375, lng: 26.320898437500006 },
        { lat: 41.743798828124994, lng: 26.20058593750002 },
        { lat: 41.72568359375, lng: 26.107421875 },
        { lat: 41.704150390624996, lng: 26.085546875 },
        { lat: 41.67324218749999, lng: 26.066015625 },
        { lat: 41.640185546874996, lng: 26.076953125000017 },
        { lat: 41.608203125, lng: 26.111230468750023 },
        { lat: 41.521533203124996, lng: 26.143554687499996 },
        { lat: 41.434863281249996, lng: 26.155175781250023 },
        { lat: 41.3857421875, lng: 26.135351562500006 },
        { lat: 41.35068359375, lng: 26.06640625 },
        { lat: 41.311914062499994, lng: 25.923339843749996 },
        { lat: 41.33041992187499, lng: 25.784960937500014 },
        { lat: 41.3150390625, lng: 25.723925781250017 },
        { lat: 41.310107421874996, lng: 25.621484375000023 },
        { lat: 41.29980468749999, lng: 25.52705078125001 },
        { lat: 41.26435546875, lng: 25.381933593750006 },
        { lat: 41.243554687499994, lng: 25.25117187500001 },
        { lat: 41.315771484375, lng: 25.133398437500006 },
        { lat: 41.36499023437499, lng: 24.993554687500023 },
        { lat: 41.39423828125, lng: 24.846875 },
        { lat: 41.372900390625, lng: 24.79580078125002 },
        { lat: 41.356103515624994, lng: 24.773730468750017 },
        { lat: 41.419970703124996, lng: 24.65107421875001 },
        { lat: 41.442724609375, lng: 24.595996093750014 },
        { lat: 41.4673828125, lng: 24.5693359375 },
        { lat: 41.552539062499996, lng: 24.51826171875001 },
        { lat: 41.55522460937499, lng: 24.487890625 },
        { lat: 41.52353515624999, lng: 24.38671875 },
        { lat: 41.525048828124994, lng: 24.289453125000023 },
        { lat: 41.530810546874996, lng: 24.230371093750023 },
        { lat: 41.527246093749994, lng: 24.056054687500023 },
        { lat: 41.469091796875, lng: 24.03291015625001 },
        { lat: 41.46005859375, lng: 24.011328125 },
        { lat: 41.452294921874994, lng: 23.973535156250023 },
        { lat: 41.455957031249994, lng: 23.880859375 },
        { lat: 41.412988281249994, lng: 23.762304687500002 },
        { lat: 41.386767578124996, lng: 23.635156250000023 },
        { lat: 41.386035156249996, lng: 23.53583984375001 },
        { lat: 41.398730468749996, lng: 23.433398437500017 },
        { lat: 41.38964843749999, lng: 23.372070312499996 },
        { lat: 41.3849609375, lng: 23.23984375 },
        { lat: 41.322070312499996, lng: 23.155957031250008 },
        { lat: 41.325634765625, lng: 23.02558593750001 },
        { lat: 41.336279296875, lng: 22.916015625 },
        { lat: 41.356103515624994, lng: 22.9296875 },
        { lat: 41.60561523437499, lng: 22.951464843750014 },
        { lat: 41.71694335937499, lng: 23.005664062500017 },
        { lat: 41.73984375, lng: 23.00361328125001 },
        { lat: 41.757177734375, lng: 22.991992187500014 },
        { lat: 41.77509765624999, lng: 22.943945312500006 },
        { lat: 41.835205078125, lng: 22.9091796875 },
        { lat: 41.993603515625, lng: 22.83681640625002 },
        { lat: 42.025683593749996, lng: 22.79609375000001 },
        { lat: 42.059130859374996, lng: 22.68232421875001 },
        { lat: 42.104833984375, lng: 22.582714843750008 },
        { lat: 42.165087890624996, lng: 22.49824218750001 },
        { lat: 42.31396484375, lng: 22.344042968750014 },
        { lat: 42.328857421875, lng: 22.42207031250001 },
        { lat: 42.359130859375, lng: 22.445703125000023 },
        { lat: 42.440966796874996, lng: 22.523535156250006 },
        { lat: 42.48120117187499, lng: 22.53242187500001 },
        { lat: 42.50390625, lng: 22.524218750000017 },
        { lat: 42.543310546875, lng: 22.472070312500023 },
        { lat: 42.6291015625, lng: 22.43623046875001 },
        { lat: 42.70947265625, lng: 22.463281250000023 },
        { lat: 42.75078125, lng: 22.465625 },
        { lat: 42.791650390624994, lng: 22.439257812500017 },
        { lat: 42.84248046875, lng: 22.466796875 },
        { lat: 42.8703125, lng: 22.522753906250017 },
        { lat: 42.878466796874996, lng: 22.55810546875 },
        { lat: 42.883935546874994, lng: 22.706152343750006 },
        { lat: 42.985742187499994, lng: 22.799902343750002 },
        { lat: 43.01826171875, lng: 22.856835937500023 },
        { lat: 43.075976562499996, lng: 22.91523437500001 },
        { lat: 43.097070312499994, lng: 22.942285156250023 },
        { lat: 43.142041015625, lng: 22.96796875000001 },
        { lat: 43.18798828124999, lng: 22.976855468750017 },
        { lat: 43.25234375, lng: 22.85957031250001 },
        { lat: 43.30073242187499, lng: 22.81972656250002 },
        { lat: 43.354150390624994, lng: 22.767578125 },
        { lat: 43.391064453125, lng: 22.69697265625001 },
        { lat: 43.454492187499994, lng: 22.55458984375002 },
        { lat: 43.518847656249996, lng: 22.499121093750006 },
        { lat: 43.60224609375, lng: 22.474121093749996 },
        { lat: 43.665478515625, lng: 22.436328125000017 },
        { lat: 43.706640625, lng: 22.394824218750017 },
        { lat: 43.740136718749994, lng: 22.38691406250001 },
        { lat: 43.78129882812499, lng: 22.36962890625 },
        { lat: 43.862109375, lng: 22.36542968750001 },
        { lat: 43.96953125, lng: 22.399023437500006 },
        { lat: 44.007421875, lng: 22.420800781250023 },
        { lat: 44.018017578125, lng: 22.469042968750017 },
        { lat: 44.07529296875, lng: 22.597460937500017 },
        { lat: 44.148583984374994, lng: 22.603417968750023 },
        { lat: 44.194091796875, lng: 22.6265625 },
        { lat: 44.22021484375, lng: 22.66748046875 },
        { lat: 44.23779296875, lng: 22.705078125 },
        { lat: 44.195214843749994, lng: 22.775195312500017 },
        { lat: 44.12729492187499, lng: 22.945410156250002 },
        { lat: 44.07797851562499, lng: 23.02851562500001 },
        { lat: 44.047216796875, lng: 23.0244140625 },
        { lat: 44.01699218749999, lng: 22.9853515625 },
        { lat: 43.987207031249994, lng: 22.91132812500001 },
        { lat: 43.947900390624994, lng: 22.868261718750002 },
        { lat: 43.8990234375, lng: 22.8564453125 },
        { lat: 43.864550781249996, lng: 22.867675781249996 },
        { lat: 43.83447265625, lng: 22.919042968750006 },
        { lat: 43.873876953125, lng: 23.224609375 },
        { lat: 43.853564453124996, lng: 23.534570312500023 },
        { lat: 43.786669921874996, lng: 23.95078125 },
        { lat: 43.763476562499996, lng: 24.22675781250001 },
        { lat: 43.794384765625, lng: 24.430566406250023 },
        { lat: 43.738427734374994, lng: 24.808203125 },
        { lat: 43.686328125, lng: 25.15966796875 },
        { lat: 43.670800781249994, lng: 25.4970703125 },
        { lat: 43.711767578125, lng: 25.686132812500006 },
        { lat: 43.76684570312499, lng: 25.81884765625 },
        { lat: 43.870556640625, lng: 25.933398437500017 },
        { lat: 44.007275390625, lng: 26.2158203125 },
        { lat: 44.08398437499999, lng: 26.4892578125 },
        { lat: 44.14619140625, lng: 26.847753906250006 },
        { lat: 44.167382812499994, lng: 27.0869140625 },
        { lat: 44.146142578124994, lng: 27.120703125 },
        { lat: 44.0205078125, lng: 27.425390625 },
        { lat: 44.020068359374996, lng: 27.56103515625 },
        { lat: 43.997802734375, lng: 27.6708984375 },
        { lat: 43.964599609375, lng: 27.710742187500017 },
        { lat: 43.956298828125, lng: 27.738574218750017 },
        { lat: 43.987353515624996, lng: 27.884277343749996 },
        { lat: 43.918603515624994, lng: 27.94892578125001 },
        { lat: 43.822412109374994, lng: 28.05 },
        { lat: 43.77285156249999, lng: 28.221972656250017 },
        { lat: 43.744775390624994, lng: 28.37519531250001 },
        { lat: 43.740478515625, lng: 28.4234375 },
        { lat: 43.742236328124996, lng: 28.585351562500023 },
      ],
    ],
  },
  {
    code: "BA",
    name: "Bosnia and Herzegovina",
    coordinates: [
      [
        { lat: 45.276562499999976, lng: 16.918652343749983 },
        { lat: 45.171777343750016, lng: 17.125390625000023 },
        { lat: 45.15605468750002, lng: 17.210644531250068 },
        { lat: 45.17055664062505, lng: 17.25869140625008 },
        { lat: 45.16396484375002, lng: 17.324121093750076 },
        { lat: 45.13330078125, lng: 17.46914062500005 },
        { lat: 45.12036132812502, lng: 17.50263671875004 },
        { lat: 45.12255859375003, lng: 17.54628906250005 },
        { lat: 45.16347656250002, lng: 17.65351562500004 },
        { lat: 45.158398437499955, lng: 17.690136718750036 },
        { lat: 45.078125, lng: 17.812792968750074 },
        { lat: 45.077246093750034, lng: 17.874414062500023 },
        { lat: 45.11186523437499, lng: 17.94863281250005 },
        { lat: 45.14179687499995, lng: 17.996289062500068 },
        { lat: 45.119384765625, lng: 18.137207031249996 },
        { lat: 45.13291015625, lng: 18.21796875000001 },
        { lat: 45.13427734375003, lng: 18.284960937500074 },
        { lat: 45.12055664062498, lng: 18.35761718750004 },
        { lat: 45.10200195312501, lng: 18.423925781250063 },
        { lat: 45.08583984375002, lng: 18.48828125000003 },
        { lat: 45.07744140624999, lng: 18.66259765625 },
        { lat: 45.02651367187502, lng: 18.746093750000057 },
        { lat: 44.97724609375001, lng: 18.779394531250006 },
        { lat: 44.94721679687501, lng: 18.78017578125008 },
        { lat: 44.914892578125006, lng: 18.788378906250045 },
        { lat: 44.883251953124955, lng: 18.836425781249996 },
        { lat: 44.865185546875004, lng: 18.94130859375005 },
        { lat: 44.86918945312502, lng: 19.007128906250045 },
        { lat: 44.87133789062503, lng: 19.042089843750063 },
        { lat: 44.89960937500001, lng: 19.131542968750065 },
        { lat: 44.914257812499955, lng: 19.23681640625003 },
        { lat: 44.8974609375, lng: 19.31269531250004 },
        { lat: 44.88090820312502, lng: 19.348632812500057 },
        { lat: 44.858544921874994, lng: 19.35683593750005 },
        { lat: 44.780664062500016, lng: 19.33447265625003 },
        { lat: 44.69677734374997, lng: 19.29189453125005 },
        { lat: 44.609570312499976, lng: 19.22314453125 },
        { lat: 44.52734375, lng: 19.15136718750003 },
        { lat: 44.48378906250002, lng: 19.132421875000063 },
        { lat: 44.41455078125003, lng: 19.127343750000023 },
        { lat: 44.359960937500006, lng: 19.118457031250074 },
        { lat: 44.33027343750001, lng: 19.128320312500023 },
        { lat: 44.302539062500045, lng: 19.15185546875003 },
        { lat: 44.28056640625002, lng: 19.231542968750006 },
        { lat: 44.22583007812506, lng: 19.33886718750003 },
        { lat: 44.15449218749998, lng: 19.43017578124997 },
        { lat: 44.073486328125, lng: 19.547167968750017 },
        { lat: 44.04345703125003, lng: 19.583789062500017 },
        { lat: 44.011083984375, lng: 19.583691406249983 },
        { lat: 43.98710937499999, lng: 19.54951171875004 },
        { lat: 43.97802734375, lng: 19.449414062499983 },
        { lat: 43.98510742187502, lng: 19.34521484375 },
        { lat: 43.99335937500004, lng: 19.305273437500034 },
        { lat: 43.98344726562496, lng: 19.26806640625 },
        { lat: 43.96503906250004, lng: 19.245019531249994 },
        { lat: 43.943310546874955, lng: 19.257226562499994 },
        { lat: 43.844775390625045, lng: 19.364062500000017 },
        { lat: 43.703564453124955, lng: 19.488183593750076 },
        { lat: 43.642871093750045, lng: 19.495117187500057 },
        { lat: 43.595166015624976, lng: 19.47998046875 },
        { lat: 43.56206054687499, lng: 19.451269531250002 },
        { lat: 43.56757812499998, lng: 19.399609375000068 },
        { lat: 43.59345703125001, lng: 19.360351562500057 },
        { lat: 43.59179687500003, lng: 19.30078125 },
        { lat: 43.584375, lng: 19.254492187500063 },
        { lat: 43.53330078125, lng: 19.19433593749997 },
        { lat: 43.53544921874999, lng: 19.164355468750014 },
        { lat: 43.52773437500002, lng: 19.11279296874997 },
        { lat: 43.51772460937502, lng: 19.080078125000057 },
        { lat: 43.53251953125002, lng: 19.0283203125 },
        { lat: 43.54233398437498, lng: 18.97421875 },
        { lat: 43.52666015624999, lng: 18.95068359375 },
        { lat: 43.49672851562502, lng: 18.94023437499999 },
        { lat: 43.44238281250006, lng: 18.97382812500001 },
        { lat: 43.35732421875002, lng: 19.036718750000034 },
        { lat: 43.292431640624955, lng: 19.026660156250017 },
        { lat: 43.28540039062502, lng: 18.97871093750001 },
        { lat: 43.339453125000034, lng: 18.934667968750006 },
        { lat: 43.34819335937504, lng: 18.895605468750063 },
        { lat: 43.34633789062502, lng: 18.85107421875003 },
        { lat: 43.283544921875006, lng: 18.749218750000068 },
        { lat: 43.230810546875006, lng: 18.67421875000008 },
        { lat: 43.19394531250006, lng: 18.656835937500006 },
        { lat: 43.15366210937503, lng: 18.629980468750034 },
        { lat: 43.12460937500006, lng: 18.621875 },
        { lat: 43.027685546875034, lng: 18.623632812500063 },
        { lat: 43.01215820312498, lng: 18.488476562500068 },
        { lat: 42.997900390625006, lng: 18.460156250000065 },
        { lat: 42.96845703125004, lng: 18.44384765625003 },
        { lat: 42.844091796875006, lng: 18.455078125 },
        { lat: 42.777246093749994, lng: 18.46601562500001 },
        { lat: 42.674169921875034, lng: 18.543261718750045 },
        { lat: 42.64160156249997, lng: 18.545898437500025 },
        { lat: 42.62011718750003, lng: 18.534960937500045 },
        { lat: 42.57919921875006, lng: 18.480078125000034 },
        { lat: 42.56450195312499, lng: 18.453906250000045 },
        { lat: 42.55971679687499, lng: 18.436328125000017 },
        { lat: 42.58666992187497, lng: 18.346582031250023 },
        { lat: 42.59941406249999, lng: 18.304003906250045 },
        { lat: 42.690576171874994, lng: 18.123925781250048 },
        { lat: 42.74125976562502, lng: 18.044531250000034 },
        { lat: 42.80742187500002, lng: 17.918847656250023 },
        { lat: 42.845068359375034, lng: 17.84130859375003 },
        { lat: 42.90224609375005, lng: 17.80195312500001 },
        { lat: 42.91547851562498, lng: 17.74023437500003 },
        { lat: 42.897119140624994, lng: 17.667578125000063 },
        { lat: 42.93837890625005, lng: 17.585156250000068 },
        { lat: 42.959765625000045, lng: 17.64345703125005 },
        { lat: 42.980078125, lng: 17.657812500000034 },
        { lat: 43.006591796875, lng: 17.650488281250063 },
        { lat: 43.04277343749998, lng: 17.62480468750007 },
        { lat: 43.19892578125001, lng: 17.402246093750023 },
        { lat: 43.30561523437498, lng: 17.293066406250063 },
        { lat: 43.343847656250034, lng: 17.27529296875008 },
        { lat: 43.44575195312501, lng: 17.27382812500005 },
        { lat: 43.47021484375003, lng: 17.248046875000053 },
        { lat: 43.516552734374955, lng: 17.084570312500034 },
        { lat: 43.64902343750003, lng: 16.90185546875003 },
        { lat: 43.77880859375003, lng: 16.713476562500034 },
        { lat: 43.815039062500034, lng: 16.68769531250001 },
        { lat: 43.913183593750034, lng: 16.59052734375004 },
        { lat: 44.00258789062505, lng: 16.47207031250005 },
        { lat: 44.05961914062502, lng: 16.377539062500063 },
        { lat: 44.12451171874999, lng: 16.300097656250017 },
        { lat: 44.21513671874999, lng: 16.214257812500023 },
        { lat: 44.352001953124976, lng: 16.169824218750023 },
        { lat: 44.473730468750006, lng: 16.13027343750005 },
        { lat: 44.52099609375006, lng: 16.10341796875008 },
        { lat: 44.537597656249964, lng: 16.04902343750001 },
        { lat: 44.68193359374999, lng: 15.880078125000068 },
        { lat: 44.765820312500004, lng: 15.736621093750047 },
        { lat: 44.85639648437498, lng: 15.73798828125007 },
        { lat: 45.00751953124995, lng: 15.761523437500074 },
        { lat: 45.17895507812497, lng: 15.788085937500057 },
        { lat: 45.20278320312505, lng: 15.822851562500034 },
        { lat: 45.21572265625002, lng: 15.888281250000032 },
        { lat: 45.21079101562498, lng: 15.963183593750019 },
        { lat: 45.18959960937502, lng: 16.028320312500057 },
        { lat: 45.07221679687498, lng: 16.157324218750063 },
        { lat: 45.02661132812503, lng: 16.231054687500063 },
        { lat: 45.00883789062496, lng: 16.293359375000048 },
        { lat: 45.058349609375, lng: 16.365039062500014 },
        { lat: 45.162011718749994, lng: 16.45351562499999 },
        { lat: 45.21669921875002, lng: 16.53066406250008 },
        { lat: 45.196875, lng: 16.79082031250007 },
        { lat: 45.276562499999976, lng: 16.918652343749983 },
      ],
    ],
  },
  {
    code: "AT",
    name: "Austria",
    coordinates: [
      [
        { lat: 48.59882812499999, lng: 16.953125 },
        { lat: 48.58857421874999, lng: 16.948828125 },
        { lat: 48.550927734374994, lng: 16.943359375 },
        { lat: 48.503515625, lng: 16.90449218750001 },
        { lat: 48.44140625, lng: 16.862695312500023 },
        { lat: 48.3869140625, lng: 16.86542968750001 },
        { lat: 48.198095703125, lng: 16.97265625 },
        { lat: 48.083251953125, lng: 17.06787109375 },
        { lat: 48.03955078125, lng: 17.0859375 },
        { lat: 48.00595703125, lng: 17.147363281250023 },
        { lat: 47.963623046875, lng: 17.0890625 },
        { lat: 47.90087890624999, lng: 17.077734375 },
        { lat: 47.872949218749994, lng: 17.039941406250023 },
        { lat: 47.837109375, lng: 17.030078125000014 },
        { lat: 47.804541015625, lng: 17.0458984375 },
        { lat: 47.76376953124999, lng: 17.04560546875001 },
        { lat: 47.707568359374996, lng: 17.06660156250001 },
        { lat: 47.6953125, lng: 16.973437500000017 },
        { lat: 47.697265625, lng: 16.862695312500023 },
        { lat: 47.69399414062499, lng: 16.823046875000017 },
        { lat: 47.678662109375, lng: 16.785937500000017 },
        { lat: 47.68627929687499, lng: 16.74755859375 },
        { lat: 47.739013671875, lng: 16.6474609375 },
        { lat: 47.750537109374996, lng: 16.590917968750006 },
        { lat: 47.747363281249996, lng: 16.55097656250001 },
        { lat: 47.724462890625, lng: 16.52109375 },
        { lat: 47.69506835937499, lng: 16.469628906250023 },
        { lat: 47.674462890624994, lng: 16.421289062500023 },
        { lat: 47.65629882812499, lng: 16.43212890625 },
        { lat: 47.60888671875, lng: 16.639746093750006 },
        { lat: 47.536035156249994, lng: 16.676562500000017 },
        { lat: 47.47661132812499, lng: 16.636621093750023 },
        { lat: 47.447558593749996, lng: 16.623046875 },
        { lat: 47.424658203125, lng: 16.57441406250001 },
        { lat: 47.404541015625, lng: 16.514746093750006 },
        { lat: 47.39951171875, lng: 16.44287109375 },
        { lat: 47.36743164062499, lng: 16.434375 },
        { lat: 47.27314453125, lng: 16.462597656250008 },
        { lat: 47.252734375, lng: 16.439746093750014 },
        { lat: 47.2234375, lng: 16.416894531250023 },
        { lat: 47.145898437499994, lng: 16.438378906250023 },
        { lat: 47.140380859375, lng: 16.482812500000023 },
        { lat: 47.12265625, lng: 16.49267578125 },
        { lat: 47.091259765625, lng: 16.484765625000023 },
        { lat: 47.057861328125, lng: 16.476953125000023 },
        { lat: 47.02246093749999, lng: 16.461230468750014 },
        { lat: 47.006787109375, lng: 16.453417968750017 },
        { lat: 46.996972656249994, lng: 16.423925781250006 },
        { lat: 47.002197265625, lng: 16.331835937500017 },
        { lat: 46.971923828125, lng: 16.252539062500006 },
        { lat: 46.86328125, lng: 16.093066406250017 },
        { lat: 46.84482421875, lng: 16.037207031250006 },
        { lat: 46.8013671875, lng: 15.976855468750017 },
        { lat: 46.705859375, lng: 15.98046875 },
        { lat: 46.69721679687499, lng: 15.972265625 },
        { lat: 46.677636718749994, lng: 15.957617187500006 },
        { lat: 46.711279296875, lng: 15.766894531250017 },
        { lat: 46.710742187499996, lng: 15.76025390625 },
        { lat: 46.6984375, lng: 15.632617187500017 },
        { lat: 46.65463867187499, lng: 15.545312500000023 },
        { lat: 46.62963867187499, lng: 15.439257812500019 },
        { lat: 46.64296874999999, lng: 15.216992187500011 },
        { lat: 46.6259765625, lng: 15.000683593750011 },
        { lat: 46.613232421875, lng: 14.949414062500011 },
        { lat: 46.605908203125, lng: 14.893261718750011 },
        { lat: 46.58046875, lng: 14.840625 },
        { lat: 46.544580078124994, lng: 14.810546875 },
        { lat: 46.49912109375, lng: 14.756738281250023 },
        { lat: 46.463427734374996, lng: 14.68017578125 },
        { lat: 46.436083984374996, lng: 14.596972656250017 },
        { lat: 46.41293945312499, lng: 14.5771484375 },
        { lat: 46.399707031249996, lng: 14.5498046875 },
        { lat: 46.417041015624996, lng: 14.503515625 },
        { lat: 46.41611328124999, lng: 14.465917968750004 },
        { lat: 46.4279296875, lng: 14.419921875 },
        { lat: 46.44072265624999, lng: 14.267285156250011 },
        { lat: 46.46191406249999, lng: 14.099511718750023 },
        { lat: 46.482177734375, lng: 14.019628906250006 },
        { lat: 46.498193359374994, lng: 13.928808593750006 },
        { lat: 46.51123046874999, lng: 13.831347656250015 },
        { lat: 46.514306640624994, lng: 13.743945312500017 },
        { lat: 46.520263671875, lng: 13.7 },
        { lat: 46.55556640624999, lng: 13.490039062500017 },
        { lat: 46.557910156249996, lng: 13.3515625 },
        { lat: 46.57265625, lng: 13.16875 },
        { lat: 46.625878906249994, lng: 12.805566406250023 },
        { lat: 46.6474609375, lng: 12.699804687500006 },
        { lat: 46.654101562499996, lng: 12.5986328125 },
        { lat: 46.672509765624994, lng: 12.479199218750011 },
        { lat: 46.70263671875, lng: 12.38828125 },
        { lat: 46.759814453124996, lng: 12.330078125 },
        { lat: 46.835888671875, lng: 12.267968750000023 },
        { lat: 46.93525390625, lng: 12.154101562500017 },
        { lat: 46.98476562499999, lng: 12.130761718750023 },
        { lat: 47.028173828125, lng: 12.16552734375 },
        { lat: 47.06088867187499, lng: 12.201269531250004 },
        { lat: 47.075, lng: 12.197167968750023 },
        { lat: 47.08212890625, lng: 12.169433593749998 },
        { lat: 47.03969726562499, lng: 11.969531250000017 },
        { lat: 46.986083984375, lng: 11.775683593750017 },
        { lat: 46.984667968749996, lng: 11.699414062500011 },
        { lat: 46.99658203125, lng: 11.62548828125 },
        { lat: 46.997412109375, lng: 11.52753906250001 },
        { lat: 46.983056640624994, lng: 11.433203125 },
        { lat: 46.97568359375, lng: 11.244433593750017 },
        { lat: 46.936181640624994, lng: 11.133886718750006 },
        { lat: 46.859130859375, lng: 11.0634765625 },
        { lat: 46.79697265624999, lng: 11.025097656250011 },
        { lat: 46.777001953124994, lng: 10.993261718750006 },
        { lat: 46.76948242187499, lng: 10.92734375 },
        { lat: 46.775244140625, lng: 10.828906250000017 },
        { lat: 46.793310546875, lng: 10.759765625 },
        { lat: 46.84638671875, lng: 10.689257812500017 },
        { lat: 46.85371093749999, lng: 10.579785156250011 },
        { lat: 46.855126953124994, lng: 10.479394531250023 },
        { lat: 46.86494140624999, lng: 10.45283203125001 },
        { lat: 46.8994140625, lng: 10.45458984375 },
        { lat: 46.964404296874996, lng: 10.414941406250023 },
        { lat: 46.98476562499999, lng: 10.349414062500017 },
        { lat: 46.862353515624996, lng: 10.179785156250006 },
        { lat: 46.851513671875, lng: 10.133496093750011 },
        { lat: 46.8853515625, lng: 9.996875 },
        { lat: 46.9376953125, lng: 9.877734375000017 },
        { lat: 46.975976562499994, lng: 9.864648437500023 },
        { lat: 47.007373046874996, lng: 9.8453125 },
        { lat: 47.037109375, lng: 9.745019531250023 },
        { lat: 47.057470703125, lng: 9.619921875000017 },
        { lat: 47.05737304687499, lng: 9.580273437500011 },
        { lat: 47.075830078124994, lng: 9.595703125 },
        { lat: 47.10712890625, lng: 9.610546875000011 },
        { lat: 47.132080078125, lng: 9.601171875 },
        { lat: 47.15791015625, lng: 9.571875 },
        { lat: 47.185498046875, lng: 9.555761718750006 },
        { lat: 47.212255859375, lng: 9.551074218750017 },
        { lat: 47.234130859375, lng: 9.542187500000011 },
        { lat: 47.25463867187499, lng: 9.536816406250011 },
        { lat: 47.270751953125, lng: 9.527539062500011 },
        { lat: 47.391796875, lng: 9.609082031250011 },
        { lat: 47.467041015625, lng: 9.625878906250023 },
        { lat: 47.51113281249999, lng: 9.554394531250011 },
        { lat: 47.52421875, lng: 9.524023437500006 },
        { lat: 47.53403320312499, lng: 9.548925781250006 },
        { lat: 47.52587890625, lng: 9.650585937500011 },
        { lat: 47.55078125, lng: 9.715136718750017 },
        { lat: 47.575537109375, lng: 9.748925781250021 },
        { lat: 47.552294921874996, lng: 9.839160156250017 },
        { lat: 47.505322265625, lng: 9.971582031250023 },
        { lat: 47.473583984375, lng: 10.034082031250023 },
        { lat: 47.449072265625, lng: 10.059863281250017 },
        { lat: 47.428515625, lng: 10.07421875 },
        { lat: 47.393359375, lng: 10.066308593750023 },
        { lat: 47.37958984375, lng: 10.096484375000017 },
        { lat: 47.374267578125, lng: 10.158789062500006 },
        { lat: 47.363427734374994, lng: 10.200292968750006 },
        { lat: 47.3171875, lng: 10.185742187500011 },
        { lat: 47.27880859375, lng: 10.183007812500023 },
        { lat: 47.284130859375, lng: 10.240625 },
        { lat: 47.313427734375, lng: 10.312792968750017 },
        { lat: 47.366064453125, lng: 10.369140625 },
        { lat: 47.4169921875, lng: 10.40390625 },
        { lat: 47.54106445312499, lng: 10.43037109375001 },
        { lat: 47.5515625, lng: 10.439453125 },
        { lat: 47.54179687499999, lng: 10.482812500000023 },
        { lat: 47.547216796875, lng: 10.65869140625 },
        { lat: 47.52412109375, lng: 10.741601562500023 },
        { lat: 47.52021484375, lng: 10.873046875 },
        { lat: 47.50078125, lng: 10.87060546875 },
        { lat: 47.470458984375, lng: 10.893945312500023 },
        { lat: 47.426708984375, lng: 10.9521484375 },
        { lat: 47.39814453125, lng: 10.980859375000023 },
        { lat: 47.39311523437499, lng: 11.0419921875 },
        { lat: 47.40888671875, lng: 11.136035156250017 },
        { lat: 47.425195312499994, lng: 11.191210937500017 },
        { lat: 47.413623046874996, lng: 11.2119140625 },
        { lat: 47.42490234375, lng: 11.297949218750006 },
        { lat: 47.460253906249996, lng: 11.374121093750006 },
        { lat: 47.487158203125, lng: 11.392968750000023 },
        { lat: 47.506103515625, lng: 11.469921875000011 },
        { lat: 47.549755859375, lng: 11.573925781250011 },
        { lat: 47.58349609375, lng: 11.716796875 },
        { lat: 47.61953125, lng: 12.185644531250006 },
        { lat: 47.646728515625, lng: 12.203808593750011 },
        { lat: 47.70908203125, lng: 12.196875 },
        { lat: 47.71826171875, lng: 12.209277343750017 },
        { lat: 47.702734375, lng: 12.268359375000017 },
        { lat: 47.68818359375, lng: 12.363183593750021 },
        { lat: 47.66611328125, lng: 12.435742187500011 },
        { lat: 47.63730468749999, lng: 12.48291015625 },
        { lat: 47.636132812499994, lng: 12.526562500000011 },
        { lat: 47.65629882812499, lng: 12.59423828125 },
        { lat: 47.66933593749999, lng: 12.685839843750017 },
        { lat: 47.63940429687499, lng: 12.771386718750023 },
        { lat: 47.60703125, lng: 12.796191406250017 },
        { lat: 47.59042968749999, lng: 12.781152343750023 },
        { lat: 47.56416015625, lng: 12.7828125 },
        { lat: 47.5421875, lng: 12.809375 },
        { lat: 47.5064453125, lng: 12.87890625 },
        { lat: 47.47568359375, lng: 12.968066406250017 },
        { lat: 47.478076171874996, lng: 13.014355468750011 },
        { lat: 47.5080078125, lng: 13.031542968750017 },
        { lat: 47.57915039062499, lng: 13.047949218750006 },
        { lat: 47.655126953125, lng: 13.054101562500023 },
        { lat: 47.69873046875, lng: 13.033593750000021 },
        { lat: 47.709423828125, lng: 12.985546875000011 },
        { lat: 47.712841796875, lng: 12.928125 },
        { lat: 47.721875, lng: 12.897656250000011 },
        { lat: 47.74580078124999, lng: 12.908300781250006 },
        { lat: 47.807763671874994, lng: 12.954199218750006 },
        { lat: 47.890625, lng: 12.953515625000021 },
        { lat: 47.984814453125, lng: 12.849902343750015 },
        { lat: 48.075976562499996, lng: 12.760058593750015 },
        { lat: 48.106982421874996, lng: 12.760351562500006 },
        { lat: 48.16083984374999, lng: 12.814257812500017 },
        { lat: 48.2037109375, lng: 12.897460937499998 },
        { lat: 48.27509765625, lng: 13.082128906250006 },
        { lat: 48.289941406249994, lng: 13.140429687500017 },
        { lat: 48.301904296874994, lng: 13.215234375000023 },
        { lat: 48.33125, lng: 13.322851562500004 },
        { lat: 48.361376953124996, lng: 13.374609375 },
        { lat: 48.39414062499999, lng: 13.409375 },
        { lat: 48.56455078125, lng: 13.459863281250023 },
        { lat: 48.571826171874996, lng: 13.471679687499998 },
        { lat: 48.581835937499996, lng: 13.486621093750017 },
        { lat: 48.52304687499999, lng: 13.675195312500021 },
        { lat: 48.532763671874996, lng: 13.692187500000017 },
        { lat: 48.542382812499994, lng: 13.723925781250017 },
        { lat: 48.587451171874996, lng: 13.785351562500011 },
        { lat: 48.6216796875, lng: 13.798828125 },
        { lat: 48.686425781249994, lng: 13.797460937500006 },
        { lat: 48.74750976562499, lng: 13.802929687500011 },
        { lat: 48.766943359375, lng: 13.814746093750017 },
        { lat: 48.75986328124999, lng: 13.843164062500023 },
        { lat: 48.72802734375, lng: 13.92431640625 },
        { lat: 48.692431640624996, lng: 13.98876953125 },
        { lat: 48.602490234375, lng: 14.049121093750017 },
        { lat: 48.578564453125, lng: 14.189843750000023 },
        { lat: 48.576220703124996, lng: 14.367578125000023 },
        { lat: 48.616259765624996, lng: 14.431054687500023 },
        { lat: 48.625537109374996, lng: 14.488671875000023 },
        { lat: 48.613330078124996, lng: 14.553906250000011 },
        { lat: 48.59921875, lng: 14.691308593750021 },
        { lat: 48.671923828124996, lng: 14.706640625 },
        { lat: 48.747363281249996, lng: 14.785937500000017 },
        { lat: 48.7740234375, lng: 14.821875 },
        { lat: 48.771386718749994, lng: 14.92255859375001 },
        { lat: 48.827734375, lng: 14.947363281250004 },
        { lat: 48.98393554687499, lng: 14.972167968749998 },
        { lat: 49.001123046874994, lng: 14.993457031250017 },
        { lat: 48.997851562499996, lng: 15.066796875000023 },
        { lat: 48.9693359375, lng: 15.139746093750004 },
        { lat: 48.9462890625, lng: 15.16171875 },
        { lat: 48.948144531249994, lng: 15.199609375000023 },
        { lat: 48.96386718749999, lng: 15.252734375000015 },
        { lat: 48.97402343749999, lng: 15.310937500000023 },
        { lat: 48.957373046875, lng: 15.402929687500004 },
        { lat: 48.886376953124994, lng: 15.599414062500015 },
        { lat: 48.86044921875, lng: 15.70078125 },
        { lat: 48.8654296875, lng: 15.765039062500021 },
        { lat: 48.86445312499999, lng: 15.825195312499998 },
        { lat: 48.754785156249994, lng: 16.057226562500006 },
        { lat: 48.73940429687499, lng: 16.219335937500006 },
        { lat: 48.73896484375, lng: 16.367285156250006 },
        { lat: 48.7720703125, lng: 16.414843750000017 },
        { lat: 48.800097656249996, lng: 16.477929687500023 },
        { lat: 48.796240234375, lng: 16.543554687500006 },
        { lat: 48.781884765624994, lng: 16.600976562500023 },
        { lat: 48.734228515625, lng: 16.712695312500017 },
        { lat: 48.722021484375, lng: 16.764453125000017 },
        { lat: 48.714306640625, lng: 16.83320312500001 },
        { lat: 48.7037109375, lng: 16.883691406250023 },
        { lat: 48.620898437499996, lng: 16.928320312500006 },
        { lat: 48.59882812499999, lng: 16.953125 },
      ],
    ],
  },
  {
    code: "DE",
    coordinates: [
      [
        { lat: 53.919042968750034, lng: 14.1982421875 },
        { lat: 53.870751953124966, lng: 14.213671875000045 },
        { lat: 53.874365234375006, lng: 14.172167968750017 },
        { lat: 53.86308593750002, lng: 14.04833984375 },
        { lat: 53.879052734374966, lng: 13.92578125 },
        { lat: 53.93896484375, lng: 13.902148437500074 },
        { lat: 53.996630859375045, lng: 13.921679687500045 },
        { lat: 54.03627929687502, lng: 13.872460937500051 },
        { lat: 54.059570312499964, lng: 13.827148437499972 },
        { lat: 54.09282226562502, lng: 13.820410156250034 },
        { lat: 54.12724609374999, lng: 13.827734375 },
        { lat: 54.03457031250005, lng: 14.038867187500045 },
        { lat: 53.95034179687502, lng: 14.211425781250028 },
        { lat: 53.919042968750034, lng: 14.1982421875 },
      ],
      [
        { lat: 54.41796875, lng: 11.282812500000063 },
        { lat: 54.41601562500003, lng: 11.129296875000051 },
        { lat: 54.45600585937501, lng: 11.070703125000023 },
        { lat: 54.46616210937503, lng: 11.01171875 },
        { lat: 54.51547851562503, lng: 11.043457031250057 },
        { lat: 54.533398437499955, lng: 11.0849609375 },
        { lat: 54.50126953124999, lng: 11.233593750000068 },
        { lat: 54.438378906249966, lng: 11.2802734375 },
        { lat: 54.41796875, lng: 11.282812500000063 },
      ],
      [
        { lat: 54.382714843749994, lng: 13.709179687500011 },
        { lat: 54.31542968749997, lng: 13.734179687500044 },
        { lat: 54.281152343749994, lng: 13.707324218750074 },
        { lat: 54.33818359374999, lng: 13.594921875000011 },
        { lat: 54.33740234375, lng: 13.48203125 },
        { lat: 54.24956054687496, lng: 13.414550781250028 },
        { lat: 54.245849609375, lng: 13.364355468750034 },
        { lat: 54.32563476562501, lng: 13.190039062500034 },
        { lat: 54.36455078125001, lng: 13.162109375000028 },
        { lat: 54.396923828124955, lng: 13.156347656250006 },
        { lat: 54.508984374999955, lng: 13.18125 },
        { lat: 54.544238281250045, lng: 13.176660156250051 },
        { lat: 54.582763671875, lng: 13.231445312500028 },
        { lat: 54.63842773437506, lng: 13.239941406250068 },
        { lat: 54.697119140625, lng: 13.336816406249994 },
        { lat: 54.699316406250006, lng: 13.422753906250021 },
        { lat: 54.649609375, lng: 13.45009765625008 },
        { lat: 54.615380859374966, lng: 13.491210937500028 },
        { lat: 54.57700195312506, lng: 13.636035156250044 },
        { lat: 54.55957031249997, lng: 13.65761718750008 },
        { lat: 54.53544921875001, lng: 13.670703125000074 },
        { lat: 54.488183593749994, lng: 13.603320312500045 },
        { lat: 54.463964843750034, lng: 13.58046875000008 },
        { lat: 54.425146484375034, lng: 13.601855468749989 },
        { lat: 54.382714843749994, lng: 13.709179687500011 },
      ],
      [
        { lat: 54.71269531249999, lng: 8.587890625000028 },
        { lat: 54.688183593749976, lng: 8.548925781250063 },
        { lat: 54.69106445312502, lng: 8.453808593750068 },
        { lat: 54.714111328125, lng: 8.400390625 },
        { lat: 54.73867187500005, lng: 8.417675781250068 },
        { lat: 54.757421875000034, lng: 8.46816406250005 },
        { lat: 54.76030273437502, lng: 8.50996093750004 },
        { lat: 54.748730468749955, lng: 8.573437500000011 },
        { lat: 54.71269531249999, lng: 8.587890625000028 },
      ],
      [
        { lat: 54.808007812500044, lng: 9.254980468750034 },
        { lat: 54.806298828124966, lng: 9.341992187499983 },
        { lat: 54.84042968749998, lng: 9.49873046875004 },
        { lat: 54.85541992187501, lng: 9.615820312500004 },
        { lat: 54.834375, lng: 9.661230468750006 },
        { lat: 54.82553710937497, lng: 9.725 },
        { lat: 54.82553710937497, lng: 9.739746093750028 },
        { lat: 54.80717773437495, lng: 9.745898437500045 },
        { lat: 54.780615234375055, lng: 9.892285156250011 },
        { lat: 54.73828125000005, lng: 9.953808593750011 },
        { lat: 54.673925781250006, lng: 10.022167968750011 },
        { lat: 54.58129882812506, lng: 10.028808593750028 },
        { lat: 54.51464843750006, lng: 9.941308593750051 },
        { lat: 54.47246093749999, lng: 9.86865234375 },
        { lat: 54.488427734375044, lng: 10.143457031250021 },
        { lat: 54.45019531249997, lng: 10.17080078125008 },
        { lat: 54.408935546875, lng: 10.212402343750028 },
        { lat: 54.43833007812506, lng: 10.360449218750006 },
        { lat: 54.316259765625055, lng: 10.731542968750006 },
        { lat: 54.375683593749976, lng: 10.95595703125008 },
        { lat: 54.379150390624964, lng: 11.013378906250066 },
        { lat: 54.28051757812506, lng: 11.064355468750051 },
        { lat: 54.18115234374997, lng: 11.008593750000074 },
        { lat: 54.075146484374955, lng: 10.810742187500068 },
        { lat: 54.00981445312495, lng: 10.854589843750034 },
        { lat: 53.99531250000004, lng: 10.917773437500045 },
        { lat: 54.00917968750002, lng: 11.104296875000017 },
        { lat: 53.94462890625001, lng: 11.39960937500004 },
        { lat: 53.964746093750016, lng: 11.461132812500068 },
        { lat: 54.11352539062506, lng: 11.700585937500078 },
        { lat: 54.14545898437498, lng: 11.796289062500051 },
        { lat: 54.168310546875006, lng: 12.111328125 },
        { lat: 54.22587890625002, lng: 12.16865234375004 },
        { lat: 54.283789062500006, lng: 12.296289062500023 },
        { lat: 54.347021484375006, lng: 12.378515625 },
        { lat: 54.4673828125, lng: 12.575390625000038 },
        { lat: 54.44570312500005, lng: 12.779101562500074 },
        { lat: 54.42265625, lng: 12.898046875000063 },
        { lat: 54.411035156249994, lng: 13.028613281250017 },
        { lat: 54.28271484375005, lng: 13.147460937500057 },
        { lat: 54.14086914062503, lng: 13.448046875000017 },
        { lat: 54.15322265624996, lng: 13.72421875000006 },
        { lat: 54.019042968749964, lng: 13.822265625000057 },
        { lat: 53.85336914062498, lng: 13.865527343750074 },
        { lat: 53.801367187500034, lng: 13.950390625000038 },
        { lat: 53.76743164062506, lng: 14.025 },
        { lat: 53.73188476562501, lng: 14.25 },
        { lat: 53.729638671874994, lng: 14.258886718750006 },
        { lat: 53.707128906250034, lng: 14.266113281250057 },
        { lat: 53.62475585937502, lng: 14.279882812500032 },
        { lat: 53.55644531249999, lng: 14.29873046875005 },
        { lat: 53.28349609374996, lng: 14.41455078125 },
        { lat: 53.216748046874955, lng: 14.412304687500011 },
        { lat: 53.19902343749999, lng: 14.410937500000076 },
        { lat: 53.105566406250034, lng: 14.36855468750005 },
        { lat: 53.026757812499966, lng: 14.293164062500068 },
        { lat: 52.982324218749994, lng: 14.193652343750045 },
        { lat: 52.93286132812503, lng: 14.138867187500066 },
        { lat: 52.87822265625002, lng: 14.128613281250011 },
        { lat: 52.78251953124996, lng: 14.253710937500015 },
        { lat: 52.64560546875003, lng: 14.514062500000021 },
        { lat: 52.52851562499998, lng: 14.619433593750015 },
        { lat: 52.431103515624955, lng: 14.569726562499994 },
        { lat: 52.35966796874996, lng: 14.554589843750021 },
        { lat: 52.31416015625001, lng: 14.573925781250066 },
        { lat: 52.277636718750045, lng: 14.615625 },
        { lat: 52.25, lng: 14.679882812500068 },
        { lat: 52.207470703124955, lng: 14.705371093750015 },
        { lat: 52.150048828124994, lng: 14.692382812500027 },
        { lat: 52.110205078125034, lng: 14.704589843750027 },
        { lat: 52.08183593750002, lng: 14.752539062500032 },
        { lat: 52.07080078124999, lng: 14.748144531250034 },
        { lat: 52.030859375000034, lng: 14.724804687500068 },
        { lat: 51.95800781250003, lng: 14.69296875000006 },
        { lat: 51.90483398437502, lng: 14.674902343750034 },
        { lat: 51.832373046875006, lng: 14.601660156250034 },
        { lat: 51.77080078124999, lng: 14.623925781250023 },
        { lat: 51.69819335937503, lng: 14.681347656250013 },
        { lat: 51.661718750000055, lng: 14.72490234374999 },
        { lat: 51.62714843750004, lng: 14.73867187500005 },
        { lat: 51.544921874999964, lng: 14.7109375 },
        { lat: 51.523876953124955, lng: 14.724707031250063 },
        { lat: 51.463330078124955, lng: 14.905957031250042 },
        { lat: 51.435351562500045, lng: 14.935546875000027 },
        { lat: 51.37714843749998, lng: 14.953125 },
        { lat: 51.25273437499995, lng: 15.016601562499998 },
        { lat: 51.09511718749999, lng: 14.963867187499998 },
        { lat: 51.008740234374976, lng: 14.917480468750057 },
        { lat: 50.871630859375045, lng: 14.814257812499987 },
        { lat: 50.858984375000034, lng: 14.809375 },
        { lat: 50.84233398437502, lng: 14.797460937500032 },
        { lat: 50.81831054687501, lng: 14.76650390625005 },
        { lat: 50.81469726562497, lng: 14.72333984375004 },
        { lat: 50.832617187500006, lng: 14.658203125 },
        { lat: 50.855566406250055, lng: 14.613574218750044 },
        { lat: 50.91474609375004, lng: 14.623828125000015 },
        { lat: 50.91860351562502, lng: 14.595214843750057 },
        { lat: 50.954931640625034, lng: 14.559667968750006 },
        { lat: 50.99394531249998, lng: 14.545703124999989 },
        { lat: 51.009863281250034, lng: 14.50732421875 },
        { lat: 51.02626953125002, lng: 14.367285156250063 },
        { lat: 51.03779296874995, lng: 14.319726562500051 },
        { lat: 51.029492187499955, lng: 14.283203125 },
        { lat: 51.00185546875002, lng: 14.255859375 },
        { lat: 50.97690429687498, lng: 14.273339843750023 },
        { lat: 50.95258789062501, lng: 14.299414062500006 },
        { lat: 50.91406249999997, lng: 14.377050781250006 },
        { lat: 50.89873046874996, lng: 14.369042968750081 },
        { lat: 50.86123046875005, lng: 14.201757812500004 },
        { lat: 50.82275390625003, lng: 14.096484375000045 },
        { lat: 50.80112304687506, lng: 13.998437500000051 },
        { lat: 50.76127929687502, lng: 13.898535156250034 },
        { lat: 50.716503906249955, lng: 13.701367187500011 },
        { lat: 50.70463867187504, lng: 13.556738281250034 },
        { lat: 50.692822265625004, lng: 13.52656250000004 },
        { lat: 50.61694335937503, lng: 13.472558593750051 },
        { lat: 50.60107421874997, lng: 13.436132812499975 },
        { lat: 50.60932617187498, lng: 13.401171875000074 },
        { lat: 50.621728515625016, lng: 13.374609375000063 },
        { lat: 50.611425781250055, lng: 13.341015625000068 },
        { lat: 50.58632812499999, lng: 13.306054687500051 },
        { lat: 50.57641601562503, lng: 13.269531250000057 },
        { lat: 50.576757812500006, lng: 13.237695312500051 },
        { lat: 50.510498046875, lng: 13.18115234375 },
        { lat: 50.490380859374994, lng: 13.016406250000017 },
        { lat: 50.45605468750003, lng: 12.997070312499972 },
        { lat: 50.41621093749998, lng: 12.966796875000028 },
        { lat: 50.40644531250004, lng: 12.942675781249989 },
        { lat: 50.422216796875055, lng: 12.868261718750034 },
        { lat: 50.43095703124996, lng: 12.765429687500045 },
        { lat: 50.409130859374955, lng: 12.706445312500021 },
        { lat: 50.39707031249998, lng: 12.635546875000045 },
        { lat: 50.393408203125034, lng: 12.549023437500011 },
        { lat: 50.349804687499955, lng: 12.452636718749998 },
        { lat: 50.27324218749999, lng: 12.358593750000011 },
        { lat: 50.205712890624994, lng: 12.3056640625 },
        { lat: 50.18144531250002, lng: 12.27734375 },
        { lat: 50.24487304687497, lng: 12.231152343749983 },
        { lat: 50.28837890624995, lng: 12.174804687500057 },
        { lat: 50.31093750000002, lng: 12.134863281250006 },
        { lat: 50.31098632812504, lng: 12.099218750000034 },
        { lat: 50.30175781250003, lng: 12.089843749999972 },
        { lat: 50.26855468749999, lng: 12.089746093750051 },
        { lat: 50.21342773437496, lng: 12.12783203125008 },
        { lat: 50.17583007812504, lng: 12.175 },
        { lat: 50.148046875000055, lng: 12.182519531250021 },
        { lat: 50.09750976562497, lng: 12.207812500000045 },
        { lat: 50.042333984375006, lng: 12.276464843749977 },
        { lat: 49.99858398437498, lng: 12.38417968750008 },
        { lat: 49.95551757812501, lng: 12.457617187500034 },
        { lat: 49.89580078125002, lng: 12.512011718750015 },
        { lat: 49.87744140624999, lng: 12.5125 },
        { lat: 49.85307617187502, lng: 12.497558593749998 },
        { lat: 49.83007812500002, lng: 12.471875 },
        { lat: 49.80014648437506, lng: 12.450195312500028 },
        { lat: 49.73964843749999, lng: 12.390527343750051 },
        { lat: 49.71318359375002, lng: 12.408203125 },
        { lat: 49.679785156250055, lng: 12.45703125 },
        { lat: 49.63969726562496, lng: 12.500292968750015 },
        { lat: 49.574853515624994, lng: 12.555761718750034 },
        { lat: 49.46123046875002, lng: 12.632031250000038 },
        { lat: 49.41450195312501, lng: 12.68115234375 },
        { lat: 49.36621093750003, lng: 12.747851562500017 },
        { lat: 49.32934570312497, lng: 12.813378906250051 },
        { lat: 49.33046875000002, lng: 12.91669921875004 },
        { lat: 49.260107421875006, lng: 13.023730468750074 },
        { lat: 49.15834960937505, lng: 13.14052734375008 },
        { lat: 49.11166992187503, lng: 13.227832031250017 },
        { lat: 49.09746093749999, lng: 13.288769531250066 },
        { lat: 49.06079101562497, lng: 13.339062500000011 },
        { lat: 49.00810546874999, lng: 13.383691406250051 },
        { lat: 48.97758789062499, lng: 13.401171875000074 },
        { lat: 48.95556640625002, lng: 13.440722656250045 },
        { lat: 48.95966796874998, lng: 13.547656250000074 },
        { lat: 48.87670898437506, lng: 13.68496093750005 },
        { lat: 48.81596679687501, lng: 13.769921875000051 },
        { lat: 48.76694335937498, lng: 13.814746093750017 },
        { lat: 48.74750976562501, lng: 13.802929687500011 },
        { lat: 48.686425781249994, lng: 13.797460937500063 },
        { lat: 48.62167968750006, lng: 13.79882812499997 },
        { lat: 48.58745117187502, lng: 13.785351562499983 },
        { lat: 48.542382812499966, lng: 13.723925781249989 },
        { lat: 48.53276367187496, lng: 13.692187500000017 },
        { lat: 48.523046875000034, lng: 13.675195312500021 },
        { lat: 48.58183593750002, lng: 13.486621093750074 },
        { lat: 48.57182617187501, lng: 13.471679687500028 },
        { lat: 48.564550781250034, lng: 13.459863281250023 },
        { lat: 48.394140625000055, lng: 13.409375 },
        { lat: 48.361376953125045, lng: 13.374609375000063 },
        { lat: 48.33125, lng: 13.322851562500004 },
        { lat: 48.301904296874994, lng: 13.215234375000023 },
        { lat: 48.289941406249966, lng: 13.140429687500045 },
        { lat: 48.27509765624995, lng: 13.082128906249975 },
        { lat: 48.20371093749997, lng: 12.897460937500028 },
        { lat: 48.160839843749955, lng: 12.814257812500045 },
        { lat: 48.10698242187499, lng: 12.760351562500063 },
        { lat: 48.07597656249999, lng: 12.760058593750015 },
        { lat: 47.98481445312498, lng: 12.849902343750015 },
        { lat: 47.890625, lng: 12.95351562500008 },
        { lat: 47.807763671874966, lng: 12.954199218750032 },
        { lat: 47.745800781249955, lng: 12.908300781250006 },
        { lat: 47.721875, lng: 12.897656250000068 },
        { lat: 47.71284179687498, lng: 12.928125 },
        { lat: 47.70942382812501, lng: 12.98554687500004 },
        { lat: 47.69873046875006, lng: 13.033593750000051 },
        { lat: 47.65512695312503, lng: 13.05410156250005 },
        { lat: 47.57915039062502, lng: 13.047949218750034 },
        { lat: 47.50800781250001, lng: 13.031542968750074 },
        { lat: 47.478076171875045, lng: 13.01435546875004 },
        { lat: 47.475683593750006, lng: 12.968066406250017 },
        { lat: 47.50644531250003, lng: 12.878906250000057 },
        { lat: 47.542187499999955, lng: 12.809375 },
        { lat: 47.56416015624998, lng: 12.782812500000034 },
        { lat: 47.590429687500006, lng: 12.781152343750051 },
        { lat: 47.60703125, lng: 12.796191406249989 },
        { lat: 47.63940429687503, lng: 12.771386718750023 },
        { lat: 47.66933593750002, lng: 12.685839843750074 },
        { lat: 47.65629882812502, lng: 12.594238281249972 },
        { lat: 47.636132812499994, lng: 12.52656250000004 },
        { lat: 47.637304687500055, lng: 12.482910156250028 },
        { lat: 47.66611328124998, lng: 12.435742187500011 },
        { lat: 47.68818359375004, lng: 12.36318359375008 },
        { lat: 47.70273437499998, lng: 12.268359375000017 },
        { lat: 47.71826171875003, lng: 12.209277343750074 },
        { lat: 47.709082031250034, lng: 12.196875 },
        { lat: 47.64672851562503, lng: 12.203808593750011 },
        { lat: 47.61953125, lng: 12.185644531250063 },
        { lat: 47.58349609375003, lng: 11.716796875 },
        { lat: 47.54975585937498, lng: 11.57392578125004 },
        { lat: 47.50610351562497, lng: 11.469921875000066 },
        { lat: 47.487158203125034, lng: 11.392968750000023 },
        { lat: 47.46025390624996, lng: 11.374121093750006 },
        { lat: 47.424902343750034, lng: 11.297949218750032 },
        { lat: 47.41362304687496, lng: 11.2119140625 },
        { lat: 47.42519531250002, lng: 11.191210937500045 },
        { lat: 47.408886718749976, lng: 11.136035156249989 },
        { lat: 47.39311523437496, lng: 11.041992187500028 },
        { lat: 47.398144531250004, lng: 10.98085937499999 },
        { lat: 47.42670898437495, lng: 10.952148437500028 },
        { lat: 47.470458984375, lng: 10.893945312500051 },
        { lat: 47.500781250000045, lng: 10.870605468750028 },
        { lat: 47.52021484375001, lng: 10.873046874999972 },
        { lat: 47.52412109375001, lng: 10.741601562500023 },
        { lat: 47.547216796875006, lng: 10.65869140625 },
        { lat: 47.54179687499996, lng: 10.482812500000051 },
        { lat: 47.55156249999999, lng: 10.439453125000027 },
        { lat: 47.54106445312498, lng: 10.43037109375004 },
        { lat: 47.41699218750003, lng: 10.403906250000063 },
        { lat: 47.366064453125034, lng: 10.369140625 },
        { lat: 47.313427734374976, lng: 10.312792968750074 },
        { lat: 47.284130859374955, lng: 10.240625 },
        { lat: 47.27880859375002, lng: 10.18300781250008 },
        { lat: 47.317187500000045, lng: 10.185742187500011 },
        { lat: 47.36342773437505, lng: 10.200292968750063 },
        { lat: 47.37426757812502, lng: 10.158789062500034 },
        { lat: 47.379589843749955, lng: 10.096484375000045 },
        { lat: 47.39335937500002, lng: 10.066308593750023 },
        { lat: 47.42851562499999, lng: 10.074218750000028 },
        { lat: 47.44907226562498, lng: 10.059863281250045 },
        { lat: 47.47358398437501, lng: 10.034082031250023 },
        { lat: 47.50532226562498, lng: 9.971582031249994 },
        { lat: 47.55229492187496, lng: 9.839160156250017 },
        { lat: 47.575537109375006, lng: 9.748925781250021 },
        { lat: 47.55078125000002, lng: 9.715136718750074 },
        { lat: 47.52587890625, lng: 9.650585937500068 },
        { lat: 47.53403320312498, lng: 9.548925781250063 },
        { lat: 47.52421875000002, lng: 9.524023437500032 },
        { lat: 47.59892578124996, lng: 9.35 },
        { lat: 47.67070312500002, lng: 9.182812500000068 },
        { lat: 47.67070312500002, lng: 9.127539062500006 },
        { lat: 47.65639648437505, lng: 8.881152343750074 },
        { lat: 47.66269531249998, lng: 8.874023437500057 },
        { lat: 47.70361328124997, lng: 8.831152343750006 },
        { lat: 47.71655273437503, lng: 8.793066406250063 },
        { lat: 47.70991210937501, lng: 8.770117187500004 },
        { lat: 47.69804687499999, lng: 8.75478515625008 },
        { lat: 47.700048828125055, lng: 8.728320312500017 },
        { lat: 47.76611328125, lng: 8.617871093749983 },
        { lat: 47.775634765625, lng: 8.572656250000023 },
        { lat: 47.76689453124998, lng: 8.509863281250006 },
        { lat: 47.73134765625002, lng: 8.435742187500011 },
        { lat: 47.687792968750045, lng: 8.403417968750004 },
        { lat: 47.66269531249998, lng: 8.413281250000068 },
        { lat: 47.65180664062498, lng: 8.451757812500006 },
        { lat: 47.65913085937498, lng: 8.55234375000006 },
        { lat: 47.65190429687502, lng: 8.56708984375004 },
        { lat: 47.63779296874998, lng: 8.57050781250004 },
        { lat: 47.62402343750003, lng: 8.55947265625008 },
        { lat: 47.61269531250002, lng: 8.477636718750034 },
        { lat: 47.59619140625003, lng: 8.454003906249993 },
        { lat: 47.592138671875006, lng: 8.430078125000023 },
        { lat: 47.58959960937503, lng: 8.414746093750011 },
        { lat: 47.60693359375, lng: 8.327832031250068 },
        { lat: 47.60693359375, lng: 8.198242187500028 },
        { lat: 47.57617187500002, lng: 8.09375 },
        { lat: 47.56386718750002, lng: 7.927050781250045 },
        { lat: 47.56987304687499, lng: 7.698046875000017 },
        { lat: 47.59272460937504, lng: 7.615625 },
        { lat: 47.606542968750006, lng: 7.565429687500001 },
        { lat: 47.67387695312496, lng: 7.529394531250034 },
        { lat: 47.77363281250004, lng: 7.538574218750028 },
        { lat: 47.90566406250002, lng: 7.593261718750056 },
        { lat: 48.002587890625044, lng: 7.608496093750063 },
        { lat: 48.064306640625006, lng: 7.584179687499983 },
        { lat: 48.15678710937502, lng: 7.616601562500023 },
        { lat: 48.280029296875, lng: 7.705664062500063 },
        { lat: 48.410009765625, lng: 7.765136718749999 },
        { lat: 48.54682617187498, lng: 7.794824218749994 },
        { lat: 48.636035156250045, lng: 7.837988281250006 },
        { lat: 48.69853515624999, lng: 7.92275390625005 },
        { lat: 48.87329101562497, lng: 8.124023437500028 },
        { lat: 48.88642578124998, lng: 8.140332031250038 },
        { lat: 48.97358398437498, lng: 8.134863281250006 },
        { lat: 48.98588867187499, lng: 8.080664062500063 },
        { lat: 49.01093750000003, lng: 8.001269531250045 },
        { lat: 49.04189453125005, lng: 7.799218750000023 },
        { lat: 49.061767578125, lng: 7.610937500000033 },
        { lat: 49.086376953124955, lng: 7.525488281250033 },
        { lat: 49.15219726562503, lng: 7.450585937500051 },
        { lat: 49.15307617187503, lng: 7.404199218749994 },
        { lat: 49.12954101562505, lng: 7.313378906250079 },
        { lat: 49.113623046875, lng: 7.19990234375004 },
        { lat: 49.12753906249997, lng: 7.117382812500011 },
        { lat: 49.12485351562498, lng: 7.065722656250074 },
        { lat: 49.112695312499994, lng: 7.03671875 },
        { lat: 49.123437500000044, lng: 7.022167968750068 },
        { lat: 49.17988281249998, lng: 7.001464843750028 },
        { lat: 49.19462890624999, lng: 6.958300781250017 },
        { lat: 49.20751953125003, lng: 6.891210937500034 },
        { lat: 49.20195312499996, lng: 6.84951171875008 },
        { lat: 49.173925781250034, lng: 6.820703125000051 },
        { lat: 49.154150390625, lng: 6.77626953125008 },
        { lat: 49.16059570312498, lng: 6.735449218750006 },
        { lat: 49.290869140625034, lng: 6.607617187499983 },
        { lat: 49.31967773437506, lng: 6.574707031250028 },
        { lat: 49.34619140625003, lng: 6.566308593750023 },
        { lat: 49.394677734374966, lng: 6.534277343750063 },
        { lat: 49.44287109375002, lng: 6.458105468750006 },
        { lat: 49.45815429687502, lng: 6.38222656250008 },
        { lat: 49.45273437499997, lng: 6.344335937500005 },
        { lat: 49.51269531250003, lng: 6.348437500000045 },
        { lat: 49.59960937499997, lng: 6.37832031250008 },
        { lat: 49.64497070312498, lng: 6.40673828125 },
        { lat: 49.682031249999966, lng: 6.444628906250017 },
        { lat: 49.70781249999999, lng: 6.484765625000023 },
        { lat: 49.75439453124997, lng: 6.49375 },
        { lat: 49.79848632812499, lng: 6.4873046875 },
        { lat: 49.80532226562505, lng: 6.440917968750057 },
        { lat: 49.83789062500003, lng: 6.32460937500008 },
        { lat: 49.87216796874998, lng: 6.256054687500039 },
        { lat: 49.915136718750034, lng: 6.204882812500017 },
        { lat: 49.97431640625001, lng: 6.138183593749999 },
        { lat: 50.034375, lng: 6.10976562500008 },
        { lat: 50.09423828125003, lng: 6.108300781250051 },
        { lat: 50.120996093749966, lng: 6.116503906250045 },
        { lat: 50.13935546874998, lng: 6.12128906250004 },
        { lat: 50.23266601562497, lng: 6.175097656250074 },
        { lat: 50.31616210937503, lng: 6.36445312500001 },
        { lat: 50.400244140625006, lng: 6.343652343750051 },
        { lat: 50.451757812500034, lng: 6.340917968750006 },
        { lat: 50.485498046874966, lng: 6.294921875000057 },
        { lat: 50.499121093750006, lng: 6.20302734375008 },
        { lat: 50.52250976562496, lng: 6.1787109375 },
        { lat: 50.54536132812501, lng: 6.168457031250057 },
        { lat: 50.59667968749997, lng: 6.235937500000033 },
        { lat: 50.63725585937499, lng: 6.154492187500039 },
        { lat: 50.67924804687502, lng: 6.119433593750016 },
        { lat: 50.73222656249996, lng: 6.005957031249977 },
        { lat: 50.75043945312503, lng: 5.993945312500017 },
        { lat: 50.904882812500055, lng: 6.048437500000034 },
        { lat: 50.94995117187499, lng: 6.0068359375 },
        { lat: 50.97294921874999, lng: 5.955078125 },
        { lat: 50.98422851562506, lng: 5.894726562500068 },
        { lat: 51.00566406249999, lng: 5.867187500000057 },
        { lat: 51.030126953125006, lng: 5.857519531250034 },
        { lat: 51.0453125, lng: 5.86835937500001 },
        { lat: 51.04082031250004, lng: 5.939257812500074 },
        { lat: 51.05668945312498, lng: 5.961035156250063 },
        { lat: 51.14741210937501, lng: 6.129980468750034 },
        { lat: 51.16484374999998, lng: 6.136914062500011 },
        { lat: 51.174707031249966, lng: 6.113378906250034 },
        { lat: 51.17998046874996, lng: 6.082421875000023 },
        { lat: 51.19902343750004, lng: 6.074804687500063 },
        { lat: 51.22412109374999, lng: 6.075878906250011 },
        { lat: 51.35483398437498, lng: 6.166210937500039 },
        { lat: 51.41059570312498, lng: 6.192871093750057 },
        { lat: 51.45, lng: 6.198828125000034 },
        { lat: 51.48891601562502, lng: 6.193261718750051 },
        { lat: 51.55009765624996, lng: 6.1416015625 },
        { lat: 51.59892578124996, lng: 6.091113281250016 },
        { lat: 51.63779296874998, lng: 6.08935546875 },
        { lat: 51.65825195312499, lng: 6.052734375 },
        { lat: 51.762402343749955, lng: 5.948535156250017 },
        { lat: 51.802685546875004, lng: 5.948730468750057 },
        { lat: 51.83398437499997, lng: 6.007617187500045 },
        { lat: 51.853955078124955, lng: 6.089843750000028 },
        { lat: 51.870410156250045, lng: 6.1171875 },
        { lat: 51.88076171875002, lng: 6.166503906249999 },
        { lat: 51.85073242187502, lng: 6.29707031250004 },
        { lat: 51.82465820312504, lng: 6.355664062500011 },
        { lat: 51.830029296874976, lng: 6.372167968749977 },
        { lat: 51.85839843749997, lng: 6.425 },
        { lat: 51.853955078124955, lng: 6.517578125000028 },
        { lat: 51.91088867187503, lng: 6.741796875000062 },
        { lat: 51.93828125000002, lng: 6.775195312500017 },
        { lat: 51.96738281249997, lng: 6.800390625 },
        { lat: 51.98017578125001, lng: 6.802441406250068 },
        { lat: 52.03618164062496, lng: 6.715625 },
        { lat: 52.056884765625, lng: 6.712988281250062 },
        { lat: 52.080224609374966, lng: 6.724511718749994 },
        { lat: 52.09868164062499, lng: 6.749023437500028 },
        { lat: 52.111230468749966, lng: 6.800390625 },
        { lat: 52.13579101562502, lng: 6.855078125000034 },
        { lat: 52.20551757812501, lng: 6.977246093750068 },
        { lat: 52.26601562499999, lng: 7.019628906250006 },
        { lat: 52.33149414062501, lng: 7.032617187500079 },
        { lat: 52.38022460937498, lng: 7.035156250000057 },
        { lat: 52.41899414062495, lng: 7.001855468750022 },
        { lat: 52.44409179687502, lng: 6.96816406250008 },
        { lat: 52.440283203125034, lng: 6.92207031250001 },
        { lat: 52.442285156250016, lng: 6.832519531249971 },
        { lat: 52.464013671874994, lng: 6.748828125000074 },
        { lat: 52.49921874999998, lng: 6.702929687500045 },
        { lat: 52.530175781249966, lng: 6.69160156250004 },
        { lat: 52.549658203125034, lng: 6.712402343750028 },
        { lat: 52.573583984375034, lng: 6.71875 },
        { lat: 52.59765625000006, lng: 6.705371093750016 },
        { lat: 52.617871093749976, lng: 6.710742187500045 },
        { lat: 52.63408203125002, lng: 6.74843750000008 },
        { lat: 52.63354492187497, lng: 7.013183593750028 },
        { lat: 52.65136718749997, lng: 7.033007812500045 },
        { lat: 52.74477539062499, lng: 7.050878906250063 },
        { lat: 52.88701171875002, lng: 7.117089843750051 },
        { lat: 52.966210937499994, lng: 7.179492187500045 },
        { lat: 52.99951171875003, lng: 7.189941406250057 },
        { lat: 53.187207031249976, lng: 7.188964843750028 },
        { lat: 53.28227539062499, lng: 7.197265625000028 },
        { lat: 53.32695312500001, lng: 7.152050781250068 },
        { lat: 53.375830078125034, lng: 7.053320312500033 },
        { lat: 53.477636718750006, lng: 7.074316406250034 },
        { lat: 53.556982421875, lng: 7.107128906250068 },
        { lat: 53.65454101562497, lng: 7.20644531250005 },
        { lat: 53.681347656250004, lng: 7.285253906250034 },
        { lat: 53.69726562499997, lng: 7.629199218750017 },
        { lat: 53.69072265624998, lng: 8.00927734375 },
        { lat: 53.543408203124976, lng: 8.167089843750004 },
        { lat: 53.46767578125002, lng: 8.108496093750063 },
        { lat: 53.43242187500002, lng: 8.200781250000034 },
        { lat: 53.44531249999997, lng: 8.245214843750006 },
        { lat: 53.51118164062498, lng: 8.279003906250068 },
        { lat: 53.58413085937502, lng: 8.301562500000044 },
        { lat: 53.606201171875, lng: 8.333886718750051 },
        { lat: 53.55170898437498, lng: 8.45136718750001 },
        { lat: 53.514355468750004, lng: 8.492675781249972 },
        { lat: 53.39423828124998, lng: 8.495214843750063 },
        { lat: 53.55688476562497, lng: 8.53847656250008 },
        { lat: 53.670751953125, lng: 8.50625 },
        { lat: 53.781103515625006, lng: 8.528417968750063 },
        { lat: 53.838476562500055, lng: 8.57558593750008 },
        { lat: 53.875, lng: 8.618945312500045 },
        { lat: 53.83569335937503, lng: 8.897753906250074 },
        { lat: 53.85595703124997, lng: 9.20556640625 },
        { lat: 53.81347656250003, lng: 9.321972656250011 },
        { lat: 53.600488281249966, lng: 9.585351562500021 },
        { lat: 53.565625, lng: 9.673144531250045 },
        { lat: 53.554638671874955, lng: 9.783984375000074 },
        { lat: 53.600195312500006, lng: 9.63125 },
        { lat: 53.859130859375, lng: 9.31201171875 },
        { lat: 53.89121093750006, lng: 9.216406249999977 },
        { lat: 53.90092773437499, lng: 9.069628906250017 },
        { lat: 53.92622070312498, lng: 8.978125 },
        { lat: 53.96533203125006, lng: 8.92041015625 },
        { lat: 54.00029296874999, lng: 8.903515625000011 },
        { lat: 54.26079101562502, lng: 8.906640625000023 },
        { lat: 54.29956054687503, lng: 8.8515625 },
        { lat: 54.31303710937502, lng: 8.780371093750063 },
        { lat: 54.29521484375002, lng: 8.736035156250011 },
        { lat: 54.29497070312499, lng: 8.64492187500008 },
        { lat: 54.353955078125004, lng: 8.625781250000017 },
        { lat: 54.39765625, lng: 8.648046875 },
        { lat: 54.42753906249999, lng: 8.831152343750006 },
        { lat: 54.46757812499996, lng: 8.951855468750011 },
        { lat: 54.538330078125, lng: 8.957226562500038 },
        { lat: 54.59394531249995, lng: 8.880957031250034 },
        { lat: 54.695947265625044, lng: 8.789648437500006 },
        { lat: 54.791845703125034, lng: 8.682324218750068 },
        { lat: 54.90341796875003, lng: 8.670312500000023 },
        { lat: 54.9033203125, lng: 8.670703125000017 },
        { lat: 54.90112304687499, lng: 8.857226562499989 },
        { lat: 54.89692382812495, lng: 8.90292968750006 },
        { lat: 54.844677734374955, lng: 9.185839843750074 },
        { lat: 54.808007812500044, lng: 9.254980468750034 },
      ],
      [
        { lat: 54.786962890625034, lng: 8.307714843750034 },
        { lat: 54.76708984374997, lng: 8.284667968750057 },
        { lat: 54.90830078125006, lng: 8.295703124999989 },
        { lat: 55.05874023437496, lng: 8.405175781249994 },
        { lat: 55.05537109374998, lng: 8.451464843750017 },
        { lat: 55.01474609374997, lng: 8.404101562500045 },
        { lat: 54.98627929687504, lng: 8.390429687500017 },
        { lat: 54.92939453124998, lng: 8.371191406250006 },
        { lat: 54.89985351562501, lng: 8.3798828125 },
        { lat: 54.89174804687496, lng: 8.629589843750068 },
        { lat: 54.86538085937502, lng: 8.600585937500028 },
        { lat: 54.84760742187504, lng: 8.34736328125004 },
        { lat: 54.786962890625034, lng: 8.307714843750034 },
      ],
    ],
  },
  {
    code: "DK",
    coordinates: [
      [
        { lat: 54.891650390625045, lng: 11.361425781250006 },
        { lat: 54.82958984374999, lng: 11.538378906250074 },
        { lat: 54.83315429687502, lng: 11.658105468750051 },
        { lat: 54.80742187500002, lng: 11.739550781250017 },
        { lat: 54.767675781250006, lng: 11.758984374999983 },
        { lat: 54.67944335937505, lng: 11.765917968750072 },
        { lat: 54.653710937499966, lng: 11.68037109375004 },
        { lat: 54.66245117187506, lng: 11.5859375 },
        { lat: 54.62885742187495, lng: 11.457421875000023 },
        { lat: 54.77309570312505, lng: 11.035546875000051 },
        { lat: 54.89335937500002, lng: 11.041699218750068 },
        { lat: 54.940576171874966, lng: 11.058593750000027 },
        { lat: 54.95180664062502, lng: 11.258496093749983 },
        { lat: 54.891650390625045, lng: 11.361425781250006 },
      ],
      [
        { lat: 54.84755859375002, lng: 10.484375 },
        { lat: 54.83715820312502, lng: 10.417285156250045 },
        { lat: 54.85893554687501, lng: 10.34052734375004 },
        { lat: 54.940966796875045, lng: 10.215625 },
        { lat: 54.962744140625034, lng: 10.199902343750068 },
        { lat: 54.94882812500003, lng: 10.265527343750023 },
        { lat: 54.90595703125001, lng: 10.346972656250017 },
        { lat: 54.896826171875034, lng: 10.413671875 },
        { lat: 54.86054687500001, lng: 10.504882812500028 },
        { lat: 54.84755859375002, lng: 10.484375 },
      ],
      [
        { lat: 54.96577148437503, lng: 12.549218750000051 },
        { lat: 54.950878906250004, lng: 12.511035156250074 },
        { lat: 54.961816406250016, lng: 12.357519531250063 },
        { lat: 54.89248046875002, lng: 12.18447265625008 },
        { lat: 54.91440429687506, lng: 12.118847656250038 },
        { lat: 54.95869140625001, lng: 12.143652343750032 },
        { lat: 54.974804687500004, lng: 12.161718750000063 },
        { lat: 54.99360351562501, lng: 12.219921875000011 },
        { lat: 55.02109375000003, lng: 12.258789062500028 },
        { lat: 55.064111328124994, lng: 12.274023437500032 },
        { lat: 55.040917968749966, lng: 12.31005859375 },
        { lat: 55.03120117187495, lng: 12.417187500000068 },
        { lat: 55.017480468749994, lng: 12.469531250000072 },
        { lat: 54.99731445312497, lng: 12.51328125 },
        { lat: 54.96577148437503, lng: 12.549218750000051 },
      ],
      [
        { lat: 54.88637695312502, lng: 10.061230468750068 },
        { lat: 54.87246093750002, lng: 9.957128906249977 },
        { lat: 54.896630859374994, lng: 9.903906250000063 },
        { lat: 54.90600585937503, lng: 9.80625 },
        { lat: 55.059912109375034, lng: 9.77119140625004 },
        { lat: 55.06904296875001, lng: 9.78125 },
        { lat: 55.05825195312505, lng: 9.830371093750015 },
        { lat: 54.986474609374994, lng: 9.998828125000045 },
        { lat: 54.90791015624998, lng: 10.05771484375006 },
        { lat: 54.88637695312502, lng: 10.061230468750068 },
      ],
      [
        { lat: 54.750732421875, lng: 10.73408203125001 },
        { lat: 54.745068359375004, lng: 10.689746093750017 },
        { lat: 54.826074218749994, lng: 10.629492187500004 },
        { lat: 54.851416015625, lng: 10.621679687500006 },
        { lat: 54.903271484375004, lng: 10.692480468750063 },
        { lat: 54.96201171874998, lng: 10.738281250000057 },
        { lat: 55.052197265624955, lng: 10.856738281250045 },
        { lat: 55.157861328124994, lng: 10.925 },
        { lat: 55.15620117187501, lng: 10.951074218750078 },
        { lat: 55.062109375000034, lng: 10.920800781250021 },
        { lat: 54.799658203125034, lng: 10.765234375000034 },
        { lat: 54.750732421875, lng: 10.73408203125001 },
      ],
      [
        { lat: 55.021875, lng: 15.087695312500015 },
        { lat: 55.00493164062502, lng: 15.050781250000057 },
        { lat: 55.03295898437506, lng: 14.885546875000047 },
        { lat: 55.10224609375004, lng: 14.68417968750006 },
        { lat: 55.238037109375, lng: 14.713671875000015 },
        { lat: 55.296728515625034, lng: 14.765332031250068 },
        { lat: 55.14453125000003, lng: 15.132617187500015 },
        { lat: 55.08715820312497, lng: 15.137109375000051 },
        { lat: 55.021875, lng: 15.087695312500015 },
      ],
      [
        { lat: 55.60981445312498, lng: 10.645117187500006 },
        { lat: 55.5576171875, lng: 10.686816406250045 },
        { lat: 55.44633789062496, lng: 10.738085937500017 },
        { lat: 55.321875, lng: 10.819238281250021 },
        { lat: 55.26977539062497, lng: 10.785351562500068 },
        { lat: 55.203027343749966, lng: 10.808398437500045 },
        { lat: 55.13339843749998, lng: 10.785253906250034 },
        { lat: 55.05244140625001, lng: 10.623828125000015 },
        { lat: 55.04877929687498, lng: 10.44277343750008 },
        { lat: 55.08789062500006, lng: 10.254589843750011 },
        { lat: 55.163183593750006, lng: 9.988769531250028 },
        { lat: 55.20546875000002, lng: 9.967382812500034 },
        { lat: 55.22890625, lng: 9.93007812500008 },
        { lat: 55.35722656250002, lng: 9.858984375000063 },
        { lat: 55.515478515625034, lng: 9.860644531250045 },
        { lat: 55.535302734374966, lng: 9.994238281250006 },
        { lat: 55.61083984375, lng: 10.286132812500057 },
        { lat: 55.59897460937497, lng: 10.353613281250034 },
        { lat: 55.56035156250002, lng: 10.424023437500068 },
        { lat: 55.55805664062498, lng: 10.505078125000068 },
        { lat: 55.61284179687496, lng: 10.622753906250068 },
        { lat: 55.60981445312498, lng: 10.645117187500006 },
      ],
      [
        { lat: 55.596533203125006, lng: 12.665722656250068 },
        { lat: 55.55400390624996, lng: 12.571582031250074 },
        { lat: 55.55625, lng: 12.550878906250034 },
        { lat: 55.614599609375055, lng: 12.520312500000017 },
        { lat: 55.65009765625001, lng: 12.569921875 },
        { lat: 55.68022460937501, lng: 12.59921875 },
        { lat: 55.67934570312502, lng: 12.620019531250078 },
        { lat: 55.646777343750045, lng: 12.6484375 },
        { lat: 55.596533203125006, lng: 12.665722656250068 },
      ],
      [
        { lat: 55.783056640625, lng: 10.607324218750023 },
        { lat: 55.76508789062498, lng: 10.590332031250027 },
        { lat: 55.78378906249998, lng: 10.526953125 },
        { lat: 55.848486328125006, lng: 10.520312500000072 },
        { lat: 55.906591796875034, lng: 10.54433593750008 },
        { lat: 55.95854492187496, lng: 10.51611328125 },
        { lat: 55.99194335937503, lng: 10.547167968750017 },
        { lat: 55.91416015624998, lng: 10.636328125000063 },
        { lat: 55.877587890624994, lng: 10.66171875 },
        { lat: 55.83388671874996, lng: 10.627343750000023 },
        { lat: 55.783056640625, lng: 10.607324218750023 },
      ],
      [
        { lat: 55.785058593749966, lng: 12.56875 },
        { lat: 55.684960937499994, lng: 12.57119140625008 },
        { lat: 55.65581054687502, lng: 12.545214843750015 },
        { lat: 55.63662109375002, lng: 12.507031250000068 },
        { lat: 55.61625976562504, lng: 12.40712890625005 },
        { lat: 55.587841796875004, lng: 12.320605468750015 },
        { lat: 55.53789062499995, lng: 12.243457031250017 },
        { lat: 55.466503906249976, lng: 12.21503906250001 },
        { lat: 55.41425781250001, lng: 12.275390625000027 },
        { lat: 55.38564453125005, lng: 12.385156250000023 },
        { lat: 55.28618164062502, lng: 12.413085937500028 },
        { lat: 55.23710937499999, lng: 12.32246093750004 },
        { lat: 55.18813476562505, lng: 12.089941406250006 },
        { lat: 55.069921875000034, lng: 12.065527343750004 },
        { lat: 54.976757812499955, lng: 12.073046875000017 },
        { lat: 54.90903320312503, lng: 12.068847656250057 },
        { lat: 54.81533203125002, lng: 12.050390625000034 },
        { lat: 54.772607421875016, lng: 11.8623046875 },
        { lat: 54.91533203124995, lng: 11.74091796875004 },
        { lat: 54.97246093749999, lng: 11.73984375 },
        { lat: 55.03916015624998, lng: 11.70361328125 },
        { lat: 55.09599609375002, lng: 11.696777343750028 },
        { lat: 55.186914062499966, lng: 11.653808593750057 },
        { lat: 55.2115234375, lng: 11.475878906250045 },
        { lat: 55.21474609375005, lng: 11.406835937500004 },
        { lat: 55.19785156249998, lng: 11.310253906250068 },
        { lat: 55.20444335937498, lng: 11.286328125000068 },
        { lat: 55.32861328124997, lng: 11.170703125000045 },
        { lat: 55.465625, lng: 11.189746093750017 },
        { lat: 55.53476562500003, lng: 11.12802734375006 },
        { lat: 55.566064453125016, lng: 11.119531250000023 },
        { lat: 55.600732421874994, lng: 11.12099609375005 },
        { lat: 55.62929687500002, lng: 11.070312500000027 },
        { lat: 55.644433593749994, lng: 11.0087890625 },
        { lat: 55.721533203125006, lng: 10.978906250000051 },
        { lat: 55.740234374999964, lng: 11.049609375000072 },
        { lat: 55.73120117187499, lng: 11.224414062500074 },
        { lat: 55.73647460937502, lng: 11.275488281249977 },
        { lat: 55.752539062500006, lng: 11.322265625000028 },
        { lat: 55.87929687499999, lng: 11.463671875000045 },
        { lat: 55.9072265625, lng: 11.459570312500006 },
        { lat: 55.943457031250006, lng: 11.474707031249977 },
        { lat: 55.95688476562497, lng: 11.627734375000074 },
        { lat: 55.90791015625004, lng: 11.695898437500006 },
        { lat: 55.82949218750005, lng: 11.682226562499977 },
        { lat: 55.72900390625, lng: 11.690917968749972 },
        { lat: 55.70166015625003, lng: 11.783593750000023 },
        { lat: 55.69765625000002, lng: 11.819726562500023 },
        { lat: 55.771875, lng: 11.858300781250051 },
        { lat: 55.807958984375006, lng: 11.885351562500063 },
        { lat: 55.82807617187504, lng: 11.92207031250001 },
        { lat: 55.895898437499994, lng: 11.934570312500057 },
        { lat: 55.93730468749999, lng: 11.912792968750068 },
        { lat: 55.96816406249996, lng: 11.86640625000004 },
        { lat: 56.05214843750002, lng: 12.039648437500063 },
        { lat: 56.11865234374997, lng: 12.218945312499983 },
        { lat: 56.12211914062499, lng: 12.323242187500028 },
        { lat: 56.10585937500005, lng: 12.428222656249998 },
        { lat: 56.083398437499994, lng: 12.52578125000008 },
        { lat: 56.06406250000006, lng: 12.578710937500004 },
        { lat: 56.033007812500045, lng: 12.608398437500028 },
        { lat: 55.95898437500006, lng: 12.542968750000028 },
        { lat: 55.91845703125006, lng: 12.52480468750005 },
        { lat: 55.785058593749966, lng: 12.56875 },
      ],
      [
        { lat: 57.25253906250006, lng: 11.052148437500051 },
        { lat: 57.229101562500006, lng: 11.011425781250011 },
        { lat: 57.26225585937499, lng: 10.873828125000045 },
        { lat: 57.30859375000003, lng: 10.9345703125 },
        { lat: 57.329931640625, lng: 11.085742187500045 },
        { lat: 57.32290039062499, lng: 11.174511718750011 },
        { lat: 57.27690429687496, lng: 11.076855468750011 },
        { lat: 57.25253906250006, lng: 11.052148437500051 },
      ],
      [
        { lat: 57.17226562500005, lng: 10.436914062500023 },
        { lat: 57.02133789062503, lng: 10.338476562500063 },
        { lat: 56.99912109375003, lng: 10.29609375000004 },
        { lat: 56.82294921875003, lng: 10.28701171875005 },
        { lat: 56.780908203124994, lng: 10.296679687500074 },
        { lat: 56.62050781249999, lng: 10.282714843750057 },
        { lat: 56.55483398437502, lng: 10.383593750000017 },
        { lat: 56.52050781250006, lng: 10.490234375000057 },
        { lat: 56.52172851562503, lng: 10.84589843750004 },
        { lat: 56.49287109375001, lng: 10.882812500000028 },
        { lat: 56.44326171875002, lng: 10.926171875000051 },
        { lat: 56.35903320312502, lng: 10.894433593750078 },
        { lat: 56.29550781250003, lng: 10.856445312500057 },
        { lat: 56.24199218749998, lng: 10.753417968750028 },
        { lat: 56.20209960937501, lng: 10.621191406250006 },
        { lat: 56.20034179687502, lng: 10.538964843750051 },
        { lat: 56.27617187500002, lng: 10.42695312500004 },
        { lat: 56.25156250000006, lng: 10.37373046875004 },
        { lat: 56.212890625, lng: 10.31875 },
        { lat: 56.00537109375, lng: 10.226660156250006 },
        { lat: 55.86518554687504, lng: 10.18300781250008 },
        { lat: 55.85380859375002, lng: 10.159375 },
        { lat: 55.87446289062498, lng: 10.107324218750023 },
        { lat: 55.876074218750034, lng: 10.017382812500017 },
        { lat: 55.84282226562502, lng: 9.903710937500023 },
        { lat: 55.813085937500006, lng: 9.962011718750006 },
        { lat: 55.76142578125004, lng: 10.02363281250004 },
        { lat: 55.73554687500001, lng: 9.9990234375 },
        { lat: 55.70756835937498, lng: 9.899023437500063 },
        { lat: 55.650976562500006, lng: 9.810351562500017 },
        { lat: 55.608154296875, lng: 9.773242187500017 },
        { lat: 55.55747070312506, lng: 9.661425781250045 },
        { lat: 55.49321289062502, lng: 9.591113281250017 },
        { lat: 55.41357421875006, lng: 9.625585937500032 },
        { lat: 55.34365234375002, lng: 9.640234375 },
        { lat: 55.26640624999998, lng: 9.670996093750063 },
        { lat: 55.204736328125044, lng: 9.643261718749983 },
        { lat: 55.11625976562496, lng: 9.504785156250023 },
        { lat: 55.03955078125005, lng: 9.453710937500006 },
        { lat: 55.04052734375, lng: 9.572363281250034 },
        { lat: 55.022802734375006, lng: 9.64541015625008 },
        { lat: 55.00014648437502, lng: 9.688183593750011 },
        { lat: 54.96801757812505, lng: 9.732324218750023 },
        { lat: 54.928320312500034, lng: 9.705273437500011 },
        { lat: 54.82553710937497, lng: 9.739746093750028 },
        { lat: 54.82553710937497, lng: 9.725 },
        { lat: 54.834375, lng: 9.661230468750006 },
        { lat: 54.85541992187501, lng: 9.615820312500004 },
        { lat: 54.84042968749998, lng: 9.49873046875004 },
        { lat: 54.806298828124966, lng: 9.341992187499983 },
        { lat: 54.808007812500044, lng: 9.254980468750034 },
        { lat: 54.844677734374955, lng: 9.185839843750074 },
        { lat: 54.89692382812495, lng: 8.90292968750006 },
        { lat: 54.90112304687499, lng: 8.857226562499989 },
        { lat: 54.9033203125, lng: 8.670703125000017 },
        { lat: 54.90341796875003, lng: 8.670312500000023 },
        { lat: 54.98593750000006, lng: 8.661425781250074 },
        { lat: 55.04555664062502, lng: 8.638281250000063 },
        { lat: 55.13427734375, lng: 8.572949218749983 },
        { lat: 55.155664062499994, lng: 8.669824218750023 },
        { lat: 55.32856445312495, lng: 8.651074218750011 },
        { lat: 55.41821289062503, lng: 8.61591796875004 },
        { lat: 55.510302734375045, lng: 8.345312500000063 },
        { lat: 55.59980468749998, lng: 8.132128906250074 },
        { lat: 55.90117187499999, lng: 8.181347656250068 },
        { lat: 55.98237304687501, lng: 8.202343750000068 },
        { lat: 56.13989257812505, lng: 8.121484375000023 },
        { lat: 56.32119140625002, lng: 8.129882812500057 },
        { lat: 56.60688476562498, lng: 8.16396484375008 },
        { lat: 56.61806640625002, lng: 8.231738281250017 },
        { lat: 56.61669921875003, lng: 8.281445312500011 },
        { lat: 56.56542968750006, lng: 8.47314453125 },
        { lat: 56.560302734375, lng: 8.55292968750001 },
        { lat: 56.51450195312498, lng: 8.607617187500038 },
        { lat: 56.49565429687496, lng: 8.671679687500045 },
        { lat: 56.544287109375006, lng: 8.718066406250074 },
        { lat: 56.62744140625, lng: 8.736132812500017 },
        { lat: 56.73505859374998, lng: 8.88808593750008 },
        { lat: 56.77480468749999, lng: 8.99453125000008 },
        { lat: 56.79384765625005, lng: 9.06708984375004 },
        { lat: 56.75043945312501, lng: 9.14033203125004 },
        { lat: 56.70166015625, lng: 9.196386718750006 },
        { lat: 56.80839843749999, lng: 9.20966796875004 },
        { lat: 57.01171875000003, lng: 9.2548828125 },
        { lat: 57.043652343749955, lng: 9.11044921875006 },
        { lat: 57.01611328125003, lng: 8.992773437499977 },
        { lat: 56.88725585937499, lng: 8.876074218750006 },
        { lat: 56.72529296875004, lng: 8.771972656250028 },
        { lat: 56.710400390625004, lng: 8.603125 },
        { lat: 56.66455078124999, lng: 8.468359375 },
        { lat: 56.71210937500001, lng: 8.3466796875 },
        { lat: 56.754003906250006, lng: 8.268261718750011 },
        { lat: 56.81533203124999, lng: 8.26630859375004 },
        { lat: 56.85234374999999, lng: 8.284082031250023 },
        { lat: 56.98442382812496, lng: 8.427050781250017 },
        { lat: 57.11127929687498, lng: 8.618554687500051 },
        { lat: 57.11005859374998, lng: 8.8115234375 },
        { lat: 57.15058593749998, lng: 8.952246093750006 },
        { lat: 57.155419921874994, lng: 9.036328125000068 },
        { lat: 57.14653320312496, lng: 9.298828125 },
        { lat: 57.17431640625003, lng: 9.43359375 },
        { lat: 57.23247070312496, lng: 9.554296874999977 },
        { lat: 57.478417968749994, lng: 9.815136718750011 },
        { lat: 57.58095703124999, lng: 9.96230468750008 },
        { lat: 57.61704101562498, lng: 10.259082031250045 },
        { lat: 57.73540039062501, lng: 10.533300781250034 },
        { lat: 57.73691406249998, lng: 10.609960937500034 },
        { lat: 57.64868164062502, lng: 10.480957031250028 },
        { lat: 57.61455078125002, lng: 10.460253906250074 },
        { lat: 57.56220703125001, lng: 10.444628906250017 },
        { lat: 57.44853515625001, lng: 10.537109375000028 },
        { lat: 57.379345703124955, lng: 10.517578125000027 },
        { lat: 57.24321289062501, lng: 10.52412109375004 },
        { lat: 57.17226562500005, lng: 10.436914062500023 },
      ],
    ],
  },
  {
    code: "EE",
    coordinates: [
      [
        { lat: 58.621240234375016, lng: 22.61738281250004 },
        { lat: 58.59702148437506, lng: 22.688378906250023 },
        { lat: 58.60468750000002, lng: 22.753808593750023 },
        { lat: 58.621533203124976, lng: 22.820117187500045 },
        { lat: 58.60571289062505, lng: 22.964257812500023 },
        { lat: 58.48349609375, lng: 23.29287109375008 },
        { lat: 58.45083007812502, lng: 23.323242187500053 },
        { lat: 58.43598632812501, lng: 23.127148437500068 },
        { lat: 58.39848632812501, lng: 23.08261718750006 },
        { lat: 58.37231445312499, lng: 23.035449218750045 },
        { lat: 58.36386718749998, lng: 22.97988281250008 },
        { lat: 58.311279296875, lng: 22.88515625000005 },
        { lat: 58.260888671874966, lng: 22.757031250000068 },
        { lat: 58.230664062500004, lng: 22.730273437500045 },
        { lat: 58.23623046874999, lng: 22.49843750000005 },
        { lat: 58.217138671875, lng: 22.371679687499977 },
        { lat: 58.16074218749997, lng: 22.269335937500014 },
        { lat: 58.05180664062499, lng: 22.227343750000074 },
        { lat: 57.966796875, lng: 22.152441406250006 },
        { lat: 57.936035156250036, lng: 22.076269531250034 },
        { lat: 57.93134765624998, lng: 21.996875 },
        { lat: 57.96328125, lng: 21.978027343749996 },
        { lat: 57.995166015625024, lng: 21.98554687500001 },
        { lat: 58.11533203124998, lng: 22.152929687500006 },
        { lat: 58.15434570312502, lng: 22.187695312500068 },
        { lat: 58.17167968749999, lng: 22.10439453125008 },
        { lat: 58.21337890625005, lng: 22.03457031250005 },
        { lat: 58.26235351562499, lng: 21.882128906249985 },
        { lat: 58.30166015624999, lng: 21.854492187500057 },
        { lat: 58.30458984374999, lng: 21.891015625000023 },
        { lat: 58.315869140624976, lng: 21.924414062500006 },
        { lat: 58.34882812500001, lng: 21.96503906250001 },
        { lat: 58.38666992187501, lng: 21.984082031250065 },
        { lat: 58.49716796875003, lng: 21.862304687500057 },
        { lat: 58.51425781249998, lng: 21.924414062500006 },
        { lat: 58.51025390625006, lng: 22.00185546875005 },
        { lat: 58.478125, lng: 22.08134765625007 },
        { lat: 58.51582031250004, lng: 22.168554687500006 },
        { lat: 58.521386718749994, lng: 22.20556640625 },
        { lat: 58.50795898437502, lng: 22.266601562499996 },
        { lat: 58.580859375000045, lng: 22.328125 },
        { lat: 58.604882812499966, lng: 22.474414062500045 },
        { lat: 58.627392578125004, lng: 22.546972656250006 },
        { lat: 58.621240234375016, lng: 22.61738281250004 },
      ],
      [
        { lat: 58.550341796875045, lng: 23.343554687500017 },
        { lat: 58.53999023437498, lng: 23.260351562500034 },
        { lat: 58.611083984374964, lng: 23.063476562500057 },
        { lat: 58.65922851562501, lng: 23.109082031250036 },
        { lat: 58.678125, lng: 23.16542968750005 },
        { lat: 58.648583984374994, lng: 23.332812500000045 },
        { lat: 58.575537109375034, lng: 23.356445312500057 },
        { lat: 58.550341796875045, lng: 23.343554687500017 },
      ],
      [
        { lat: 58.826904296875, lng: 22.923730468750023 },
        { lat: 58.777441406250034, lng: 22.84169921875008 },
        { lat: 58.79721679687498, lng: 22.79287109375008 },
        { lat: 58.820898437500006, lng: 22.76728515625004 },
        { lat: 58.70917968749998, lng: 22.661425781250045 },
        { lat: 58.68999023437498, lng: 22.5421875 },
        { lat: 58.71206054687506, lng: 22.472656250000057 },
        { lat: 58.75380859375002, lng: 22.47890625000008 },
        { lat: 58.863378906250034, lng: 22.411035156250023 },
        { lat: 58.89545898437501, lng: 22.307421875000045 },
        { lat: 58.89848632812502, lng: 22.161914062500074 },
        { lat: 58.94360351562506, lng: 22.05625 },
        { lat: 58.97431640625001, lng: 22.46259765625004 },
        { lat: 59.026464843750055, lng: 22.504589843750068 },
        { lat: 59.081201171875016, lng: 22.587207031250017 },
        { lat: 59.08710937499998, lng: 22.649414062499996 },
        { lat: 59.07441406249995, lng: 22.702246093750006 },
        { lat: 59.03198242187502, lng: 22.71220703124999 },
        { lat: 59.015087890624955, lng: 22.72548828125005 },
        { lat: 58.99121093749997, lng: 22.909863281250036 },
        { lat: 58.91982421874999, lng: 22.98164062500001 },
        { lat: 58.833935546875004, lng: 23.008691406249994 },
        { lat: 58.826904296875, lng: 22.923730468750023 },
      ],
      [
        { lat: 59.639013671875055, lng: 25.50927734374997 },
        { lat: 59.62753906250003, lng: 25.61572265625 },
        { lat: 59.63466796874997, lng: 25.79375 },
        { lat: 59.553906249999955, lng: 26.46083984375005 },
        { lat: 59.553906249999955, lng: 26.625 },
        { lat: 59.471777343750006, lng: 26.85205078124997 },
        { lat: 59.450634765624955, lng: 26.974707031250006 },
        { lat: 59.45048828125001, lng: 27.33583984375005 },
        { lat: 59.414208984374994, lng: 27.892578125000057 },
        { lat: 59.469824218750055, lng: 28.001855468750023 },
        { lat: 59.484277343749966, lng: 28.0125 },
        { lat: 59.453173828125045, lng: 28.06582031250008 },
        { lat: 59.40307617187503, lng: 28.13300781250001 },
        { lat: 59.374414062499966, lng: 28.15107421875004 },
        { lat: 59.357568359374994, lng: 28.128320312500023 },
        { lat: 59.34326171875003, lng: 28.061328125000045 },
        { lat: 59.32783203124998, lng: 28.046093750000068 },
        { lat: 59.301708984374976, lng: 28.016406250000045 },
        { lat: 59.297021484375016, lng: 27.93818359375001 },
        { lat: 59.277636718750074, lng: 27.89765625000001 },
        { lat: 59.19267578124999, lng: 27.849511718750048 },
        { lat: 59.05200195312503, lng: 27.757617187500074 },
        { lat: 58.94497070312496, lng: 27.62177734375004 },
        { lat: 58.88627929687502, lng: 27.513085937499994 },
        { lat: 58.84130859375, lng: 27.464453125000034 },
        { lat: 58.78725585937499, lng: 27.434179687500002 },
        { lat: 58.733056640624966, lng: 27.427050781250074 },
        { lat: 58.43525390624996, lng: 27.531347656250006 },
        { lat: 58.381494140625016, lng: 27.53007812499999 },
        { lat: 58.326269531250034, lng: 27.505566406250065 },
        { lat: 58.270068359375045, lng: 27.48779296875 },
        { lat: 58.22133789062499, lng: 27.502441406250057 },
        { lat: 58.1380859375, lng: 27.571093750000017 },
        { lat: 58.013916015625, lng: 27.644140625000063 },
        { lat: 57.93461914062501, lng: 27.673437499999974 },
        { lat: 57.90546875000004, lng: 27.721972656250017 },
        { lat: 57.88413085937503, lng: 27.76875 },
        { lat: 57.87070312500007, lng: 27.778515625000068 },
        { lat: 57.85673828124997, lng: 27.776953125000034 },
        { lat: 57.841015624999955, lng: 27.75283203125008 },
        { lat: 57.7994140625, lng: 27.542089843750063 },
        { lat: 57.76420898437501, lng: 27.514746093749977 },
        { lat: 57.72495117187503, lng: 27.491992187500045 },
        { lat: 57.66679687499998, lng: 27.4 },
        { lat: 57.61254882812503, lng: 27.371777343749983 },
        { lat: 57.55029296874998, lng: 27.354296875000074 },
        { lat: 57.528125, lng: 27.35195312500005 },
        { lat: 57.52548828124998, lng: 27.326562500000023 },
        { lat: 57.53833007812503, lng: 27.187109375000034 },
        { lat: 57.57875976562499, lng: 27.033398437500068 },
        { lat: 57.60913085937506, lng: 26.96601562500001 },
        { lat: 57.608789062499994, lng: 26.89980468750002 },
        { lat: 57.58872070312498, lng: 26.81972656250005 },
        { lat: 57.53100585937502, lng: 26.532617187499994 },
        { lat: 57.54448242187502, lng: 26.462109375000036 },
        { lat: 57.60107421875, lng: 26.29804687500001 },
        { lat: 57.662744140624966, lng: 26.215039062500068 },
        { lat: 57.78554687500002, lng: 26.030371093750006 },
        { lat: 57.81474609375002, lng: 26.015234375000034 },
        { lat: 57.83818359374999, lng: 25.991113281250076 },
        { lat: 57.868554687499966, lng: 25.79375 },
        { lat: 57.91381835937505, lng: 25.72089843750001 },
        { lat: 57.920166015625, lng: 25.66015625 },
        { lat: 57.942773437499994, lng: 25.5712890625 },
        { lat: 58.03945312499996, lng: 25.34003906250004 },
        { lat: 58.04848632812502, lng: 25.28261718750008 },
        { lat: 58.0322265625, lng: 25.268652343749977 },
        { lat: 58.009375, lng: 25.27265625000001 },
        { lat: 57.99614257812501, lng: 25.258300781249996 },
        { lat: 57.99658203125003, lng: 25.22871093750001 },
        { lat: 58.032128906249994, lng: 25.17519531250005 },
        { lat: 58.063427734374976, lng: 25.11103515625004 },
        { lat: 58.00458984374998, lng: 24.911328125 },
        { lat: 57.98872070312504, lng: 24.839062500000036 },
        { lat: 57.98525390625002, lng: 24.775781250000023 },
        { lat: 57.90786132812499, lng: 24.45888671875005 },
        { lat: 57.86616210937501, lng: 24.3625 },
        { lat: 57.87060546875002, lng: 24.32255859375007 },
        { lat: 57.909765625, lng: 24.33203125000003 },
        { lat: 58.10595703125002, lng: 24.4638671875 },
        { lat: 58.261621093750016, lng: 24.4875 },
        { lat: 58.28300781250002, lng: 24.535742187500063 },
        { lat: 58.30458984374999, lng: 24.54970703125008 },
        { lat: 58.35424804687497, lng: 24.529101562500045 },
        { lat: 58.38608398437497, lng: 24.392187500000034 },
        { lat: 58.38139648437498, lng: 24.336914062500053 },
        { lat: 58.328027343749966, lng: 24.287207031250063 },
        { lat: 58.28955078125003, lng: 24.235644531250045 },
        { lat: 58.26611328125005, lng: 24.114843750000034 },
        { lat: 58.30664062500006, lng: 24.01093749999998 },
        { lat: 58.360839843749964, lng: 23.767578125000057 },
        { lat: 58.433007812500016, lng: 23.706054687500053 },
        { lat: 58.505615234375, lng: 23.691503906250034 },
        { lat: 58.57583007812499, lng: 23.562792968749985 },
        { lat: 58.65854492187498, lng: 23.509277343750025 },
        { lat: 58.716259765625004, lng: 23.530664062500023 },
        { lat: 58.75415039062499, lng: 23.64746093750003 },
        { lat: 58.787158203125074, lng: 23.680761718750063 },
        { lat: 58.78193359374998, lng: 23.53359375 },
        { lat: 58.78984374999999, lng: 23.50361328125001 },
        { lat: 58.819531249999976, lng: 23.49716796875003 },
        { lat: 58.920654296875, lng: 23.43203125 },
        { lat: 58.96049804687502, lng: 23.489648437500023 },
        { lat: 58.99921875000001, lng: 23.51503906250005 },
        { lat: 59.03217773437498, lng: 23.4677734375 },
        { lat: 59.06967773437497, lng: 23.48017578125004 },
        { lat: 59.10756835937497, lng: 23.516992187500076 },
        { lat: 59.19565429687498, lng: 23.494433593750014 },
        { lat: 59.24233398437496, lng: 23.640527343750023 },
        { lat: 59.275146484375, lng: 23.78251953124999 },
        { lat: 59.29189453125005, lng: 24.08339843750002 },
        { lat: 59.372314453125, lng: 24.05361328125008 },
        { lat: 59.37592773437501, lng: 24.175390625 },
        { lat: 59.47265625, lng: 24.38037109375003 },
        { lat: 59.455664062500006, lng: 24.58359375000003 },
        { lat: 59.522070312500034, lng: 24.877539062500063 },
        { lat: 59.52114257812502, lng: 25.44375 },
        { lat: 59.55947265625002, lng: 25.520898437500048 },
        { lat: 59.597998046875055, lng: 25.50742187500003 },
        { lat: 59.639013671875055, lng: 25.50927734374997 },
      ],
    ],
  },
  {
    code: "ES",
    coordinates: [
      [
        { lat: 27.809570312500053, lng: -17.887939453125 },
        { lat: 27.64638671875002, lng: -17.98476562500002 },
        { lat: 27.707470703125036, lng: -18.106591796874966 },
        { lat: 27.727929687500023, lng: -18.135937499999983 },
        { lat: 27.761474609375025, lng: -18.160546874999937 },
        { lat: 27.768115234375045, lng: -18.043359374999966 },
        { lat: 27.85014648437496, lng: -17.924511718749983 },
        { lat: 27.809570312500053, lng: -17.887939453125 },
      ],
      [
        { lat: 28.147363281250023, lng: -15.400585937499955 },
        { lat: 28.07050781250001, lng: -15.406689453124953 },
        { lat: 27.992822265624994, lng: -15.383154296874977 },
        { lat: 27.87470703125001, lng: -15.389160156249941 },
        { lat: 27.810693359375023, lng: -15.43676757812497 },
        { lat: 27.746972656249994, lng: -15.559375 },
        { lat: 27.758398437500006, lng: -15.65576171875 },
        { lat: 27.784082031250023, lng: -15.71030273437492 },
        { lat: 27.887548828125034, lng: -15.807324218749953 },
        { lat: 27.994482421874977, lng: -15.809472656249964 },
        { lat: 28.064160156249955, lng: -15.720947265624941 },
        { lat: 28.15405273437497, lng: -15.682763671874996 },
        { lat: 28.13691406250004, lng: -15.452783203124936 },
        { lat: 28.154248046875008, lng: -15.432714843749947 },
        { lat: 28.159326171874994, lng: -15.415478515624981 },
        { lat: 28.147363281250023, lng: -15.400585937499955 },
      ],
      [
        { lat: 28.02197265624997, lng: -17.184667968749977 },
        { lat: 28.013525390625034, lng: -17.225390624999932 },
        { lat: 28.03828125000001, lng: -17.27392578124997 },
        { lat: 28.117675781250025, lng: -17.324902343749955 },
        { lat: 28.17631835937499, lng: -17.290332031249932 },
        { lat: 28.203173828125045, lng: -17.258593749999957 },
        { lat: 28.199267578125045, lng: -17.21435546875 },
        { lat: 28.15595703125001, lng: -17.12963867187497 },
        { lat: 28.111132812500017, lng: -17.103759765624943 },
        { lat: 28.083447265624983, lng: -17.10107421875 },
        { lat: 28.02197265624997, lng: -17.184667968749977 },
      ],
      [
        { lat: 28.379931640624985, lng: -16.334472656249968 },
        { lat: 28.15141601562496, lng: -16.41821289062497 },
        { lat: 28.061914062500023, lng: -16.496240234374994 },
        { lat: 28.032080078125006, lng: -16.54277343749996 },
        { lat: 28.007177734374977, lng: -16.65800781249999 },
        { lat: 28.149169921875057, lng: -16.79472656249996 },
        { lat: 28.293261718750014, lng: -16.86601562499999 },
        { lat: 28.33959960937503, lng: -16.905322265625017 },
        { lat: 28.376123046875023, lng: -16.843066406249932 },
        { lat: 28.369824218749983, lng: -16.75205078124995 },
        { lat: 28.400488281250002, lng: -16.556835937499983 },
        { lat: 28.412695312500006, lng: -16.51743164062495 },
        { lat: 28.558203124999977, lng: -16.318994140624937 },
        { lat: 28.57597656249996, lng: -16.12363281249992 },
        { lat: 28.52827148437501, lng: -16.11914062499997 },
        { lat: 28.379931640624985, lng: -16.334472656249968 },
      ],
      [
        { lat: 28.169287109375063, lng: -14.196777343749943 },
        { lat: 28.056005859374977, lng: -14.332617187500006 },
        { lat: 28.082373046875034, lng: -14.468603515624977 },
        { lat: 28.100927734374977, lng: -14.491796874999922 },
        { lat: 28.12968749999999, lng: -14.355566406249977 },
        { lat: 28.215820312500025, lng: -14.231982421875017 },
        { lat: 28.406640625000023, lng: -14.152587890625 },
        { lat: 28.617431640625057, lng: -14.028369140625017 },
        { lat: 28.70668945312502, lng: -14.003369140624983 },
        { lat: 28.741455078124996, lng: -13.954150390624989 },
        { lat: 28.744677734375045, lng: -13.886279296874932 },
        { lat: 28.738037109375032, lng: -13.85722656249996 },
        { lat: 28.69121093749999, lng: -13.827148437499972 },
        { lat: 28.58515624999995, lng: -13.827587890624955 },
        { lat: 28.409326171875023, lng: -13.862988281249983 },
        { lat: 28.253466796874985, lng: -13.928027343749989 },
        { lat: 28.169287109375063, lng: -14.196777343749943 },
      ],
      [
        { lat: 28.49321289062496, lng: -17.83427734374999 },
        { lat: 28.485693359375034, lng: -17.859375 },
        { lat: 28.564599609375048, lng: -17.88212890624996 },
        { lat: 28.758251953124955, lng: -18.000781249999985 },
        { lat: 28.844580078125063, lng: -17.928808593749977 },
        { lat: 28.84677734375006, lng: -17.797558593749983 },
        { lat: 28.786572265624958, lng: -17.74453125 },
        { lat: 28.724462890625006, lng: -17.7265625 },
        { lat: 28.688574218749977, lng: -17.751611328124937 },
        { lat: 28.616015625000045, lng: -17.74438476562497 },
        { lat: 28.56909179687497, lng: -17.75800781250001 },
        { lat: 28.49321289062496, lng: -17.83427734374999 },
      ],
      [
        { lat: 28.911230468750034, lng: -13.715966796874966 },
        { lat: 28.84545898437497, lng: -13.78398437499996 },
        { lat: 28.869091796874983, lng: -13.85991210937496 },
        { lat: 29.013330078124962, lng: -13.823632812499966 },
        { lat: 29.056103515624983, lng: -13.78818359374992 },
        { lat: 29.118994140625006, lng: -13.650097656249955 },
        { lat: 29.144287109375, lng: -13.535058593749966 },
        { lat: 29.211230468749957, lng: -13.501416015624955 },
        { lat: 29.237207031250023, lng: -13.463574218749953 },
        { lat: 29.197509765625025, lng: -13.422949218749949 },
        { lat: 29.151367187500025, lng: -13.453759765624993 },
        { lat: 29.006591796875025, lng: -13.477929687499966 },
        { lat: 28.960205078125004, lng: -13.554687499999972 },
        { lat: 28.911230468750034, lng: -13.715966796874966 },
      ],
      [
        { lat: 38.672070312499955, lng: 1.593945312500068 },
        { lat: 38.65883789062502, lng: 1.571191406250051 },
        { lat: 38.670996093750006, lng: 1.504980468750063 },
        { lat: 38.670996093750006, lng: 1.40576171875 },
        { lat: 38.71142578124997, lng: 1.401953125000034 },
        { lat: 38.739648437500044, lng: 1.41718750000004 },
        { lat: 38.76821289062499, lng: 1.436328125000017 },
        { lat: 38.7119140625, lng: 1.496875 },
        { lat: 38.70146484374999, lng: 1.59267578125008 },
        { lat: 38.672070312499955, lng: 1.593945312500068 },
      ],
      [
        { lat: 38.91870117187503, lng: 1.445214843750051 },
        { lat: 38.857275390625034, lng: 1.408984375000045 },
        { lat: 38.879003906250006, lng: 1.256933593750063 },
        { lat: 38.90385742187502, lng: 1.223339843750068 },
        { lat: 38.97338867187497, lng: 1.25625 },
        { lat: 38.98173828124999, lng: 1.2998046875 },
        { lat: 39.03115234375002, lng: 1.302539062500017 },
        { lat: 39.080810546875, lng: 1.3486328125 },
        { lat: 39.12104492187504, lng: 1.564453125 },
        { lat: 39.08740234375003, lng: 1.613183593750079 },
        { lat: 39.03881835937497, lng: 1.623632812499977 },
        { lat: 38.932519531249994, lng: 1.494531250000051 },
        { lat: 38.91870117187503, lng: 1.445214843750051 },
      ],
      [
        { lat: 39.79008789062499, lng: 3.145312500000017 },
        { lat: 39.756689453125034, lng: 3.24111328125008 },
        { lat: 39.78671875000003, lng: 3.34218750000008 },
        { lat: 39.77729492187498, lng: 3.39589843750008 },
        { lat: 39.76123046874997, lng: 3.448925781250068 },
        { lat: 39.69775390625003, lng: 3.461816406250022 },
        { lat: 39.62714843750001, lng: 3.414648437500006 },
        { lat: 39.55566406250003, lng: 3.348730468750063 },
        { lat: 39.47705078125, lng: 3.29296875 },
        { lat: 39.38662109375005, lng: 3.244726562500034 },
        { lat: 39.333251953125, lng: 3.154589843750045 },
        { lat: 39.30126953124997, lng: 3.072851562500006 },
        { lat: 39.36835937499998, lng: 2.900097656250068 },
        { lat: 39.38505859374999, lng: 2.799804687500057 },
        { lat: 39.41025390624998, lng: 2.769824218750074 },
        { lat: 39.51025390624999, lng: 2.745996093750023 },
        { lat: 39.542138671875016, lng: 2.700585937500023 },
        { lat: 39.55620117187495, lng: 2.634082031250045 },
        { lat: 39.53066406249999, lng: 2.575878906250011 },
        { lat: 39.47788085937498, lng: 2.49951171875 },
        { lat: 39.53046874999995, lng: 2.458789062500045 },
        { lat: 39.540380859375034, lng: 2.394335937500045 },
        { lat: 39.57207031249999, lng: 2.37001953125008 },
        { lat: 39.61308593749998, lng: 2.371289062500068 },
        { lat: 39.854833984375034, lng: 2.784960937500045 },
        { lat: 39.908300781250006, lng: 2.904785156250057 },
        { lat: 39.97050781249999, lng: 3.15869140625 },
        { lat: 39.96108398437502, lng: 3.197558593750017 },
        { lat: 39.924218749999966, lng: 3.164453125000023 },
        { lat: 39.90771484374997, lng: 3.1669921875 },
        { lat: 39.88984374999998, lng: 3.198632812500051 },
        { lat: 39.86137695312496, lng: 3.190917968749972 },
        { lat: 39.836572265624966, lng: 3.15869140625 },
        { lat: 39.79008789062499, lng: 3.145312500000017 },
      ],
      [
        { lat: 39.84184570312499, lng: 4.293652343750011 },
        { lat: 39.830273437500004, lng: 4.275292968750023 },
        { lat: 39.94584960937501, lng: 3.967675781250051 },
        { lat: 39.958740234375, lng: 3.8671875 },
        { lat: 39.97636718750002, lng: 3.84267578125008 },
        { lat: 40.036474609375006, lng: 3.845410156250012 },
        { lat: 40.06303710937502, lng: 3.853417968750051 },
        { lat: 40.075097656249966, lng: 4.059179687500034 },
        { lat: 40.032373046874966, lng: 4.22578125000004 },
        { lat: 39.91723632812497, lng: 4.31513671875004 },
        { lat: 39.897509765625045, lng: 4.322070312500045 },
        { lat: 39.84184570312499, lng: 4.293652343750011 },
      ],
      [
        { lat: 43.76455078125005, lng: -7.698144531249995 },
        { lat: 43.72734375000002, lng: -7.594580078124948 },
        { lat: 43.73994140625001, lng: -7.503613281249982 },
        { lat: 43.69580078124997, lng: -7.399316406249965 },
        { lat: 43.594628906249966, lng: -7.261962890624972 },
        { lat: 43.55395507812503, lng: -7.060986328124955 },
        { lat: 43.58564453125001, lng: -6.900683593749989 },
        { lat: 43.59238281250006, lng: -6.617285156249977 },
        { lat: 43.57890625, lng: -6.47568359374992 },
        { lat: 43.60385742187498, lng: -6.22412109375 },
        { lat: 43.59492187500004, lng: -6.080126953124989 },
        { lat: 43.645068359375045, lng: -5.846679687499943 },
        { lat: 43.582470703124976, lng: -5.665820312499959 },
        { lat: 43.553173828124955, lng: -5.315722656249932 },
        { lat: 43.50185546874999, lng: -5.10527343749996 },
        { lat: 43.41572265625004, lng: -4.52304687499992 },
        { lat: 43.41474609375001, lng: -4.312792968749989 },
        { lat: 43.46308593750001, lng: -4.015332031249955 },
        { lat: 43.49941406250002, lng: -3.889355468749954 },
        { lat: 43.477880859375006, lng: -3.77402343749992 },
        { lat: 43.51948242187504, lng: -3.604638671874965 },
        { lat: 43.51103515624999, lng: -3.523632812499983 },
        { lat: 43.45170898437499, lng: -3.417871093750023 },
        { lat: 43.37158203125, lng: -3.045605468749926 },
        { lat: 43.43969726562502, lng: -2.947705078124983 },
        { lat: 43.454443359375006, lng: -2.875048828125017 },
        { lat: 43.41274414062505, lng: -2.607080078124937 },
        { lat: 43.32802734375002, lng: -2.337109374999926 },
        { lat: 43.32192382812502, lng: -2.196679687499994 },
        { lat: 43.345068359375034, lng: -1.991308593750005 },
        { lat: 43.400830078125004, lng: -1.828515624999966 },
        { lat: 43.407324218750006, lng: -1.794042968749949 },
        { lat: 43.37255859375003, lng: -1.792724609374943 },
        { lat: 43.32470703125006, lng: -1.753271484375005 },
        { lat: 43.30703124999999, lng: -1.712841796874926 },
        { lat: 43.28247070312497, lng: -1.627148437499983 },
        { lat: 43.27919921875002, lng: -1.561474609375011 },
        { lat: 43.26767578124998, lng: -1.471728515624932 },
        { lat: 43.240087890625034, lng: -1.410693359374932 },
        { lat: 43.197119140625006, lng: -1.407324218749949 },
        { lat: 43.149121093749976, lng: -1.422607421874943 },
        { lat: 43.10498046875006, lng: -1.459423828124983 },
        { lat: 43.071142578125006, lng: -1.480468750000028 },
        { lat: 43.05175781250006, lng: -1.460839843749937 },
        { lat: 43.03676757812502, lng: -1.42875976562496 },
        { lat: 43.032617187499966, lng: -1.39404296875 },
        { lat: 43.03759765625, lng: -1.370507812499994 },
        { lat: 43.06425781250002, lng: -1.352734374999926 },
        { lat: 43.09697265625002, lng: -1.318847656249943 },
        { lat: 43.10097656250002, lng: -1.300048828124943 },
        { lat: 43.08247070312498, lng: -1.301562499999988 },
        { lat: 43.05961914062496, lng: -1.285449218749989 },
        { lat: 43.02114257812502, lng: -1.175439453124966 },
        { lat: 42.94951171874999, lng: -0.933837890624943 },
        { lat: 42.94819335937498, lng: -0.839208984374949 },
        { lat: 42.93979492187506, lng: -0.762646484374983 },
        { lat: 42.909521484375034, lng: -0.740185546874926 },
        { lat: 42.798974609374966, lng: -0.586425781249943 },
        { lat: 42.80200195312506, lng: -0.549804687499943 },
        { lat: 42.79931640625003, lng: -0.481152343750011 },
        { lat: 42.80810546875006, lng: -0.398437499999943 },
        { lat: 42.82880859375001, lng: -0.338574218750011 },
        { lat: 42.82534179687502, lng: -0.29931640625 },
        { lat: 42.80395507812499, lng: -0.256054687499983 },
        { lat: 42.78530273437502, lng: -0.205322265624943 },
        { lat: 42.74892578124999, lng: -0.140039062499966 },
        { lat: 42.70385742187505, lng: -0.081494140624926 },
        { lat: 42.689111328124966, lng: -0.041162109374994 },
        { lat: 42.719335937500006, lng: 0.20136718750004 },
        { lat: 42.692919921875045, lng: 0.255468750000063 },
        { lat: 42.69326171875002, lng: 0.312890625000023 },
        { lat: 42.70014648437501, lng: 0.377246093750074 },
        { lat: 42.68627929687503, lng: 0.517675781250006 },
        { lat: 42.689599609374994, lng: 0.631640625000045 },
        { lat: 42.70063476562501, lng: 0.641992187500023 },
        { lat: 42.800439453124994, lng: 0.651757812500051 },
        { lat: 42.83574218749999, lng: 0.669824218749994 },
        { lat: 42.845117187500044, lng: 0.696875 },
        { lat: 42.83803710937502, lng: 0.764453125000017 },
        { lat: 42.778955078124966, lng: 1.010058593750045 },
        { lat: 42.742041015625006, lng: 1.111132812500017 },
        { lat: 42.71313476562497, lng: 1.208300781250017 },
        { lat: 42.70996093750006, lng: 1.293261718750017 },
        { lat: 42.69067382812503, lng: 1.349414062500074 },
        { lat: 42.59589843749998, lng: 1.428320312499977 },
        { lat: 42.54838867187499, lng: 1.414843750000074 },
        { lat: 42.53081054687496, lng: 1.421972656250034 },
        { lat: 42.49785156249999, lng: 1.430273437500034 },
        { lat: 42.46132812500002, lng: 1.428125 },
        { lat: 42.43745117187504, lng: 1.448828124999977 },
        { lat: 42.43447265624996, lng: 1.486230468750051 },
        { lat: 42.44169921875002, lng: 1.534082031250051 },
        { lat: 42.455957031249994, lng: 1.586425781250057 },
        { lat: 42.496679687500034, lng: 1.678515625000074 },
        { lat: 42.503320312500044, lng: 1.7060546875 },
        { lat: 42.457080078125045, lng: 1.859765625000051 },
        { lat: 42.42631835937499, lng: 1.927929687500068 },
        { lat: 42.39277343749998, lng: 1.951464843750074 },
        { lat: 42.358496093750034, lng: 1.986523437500011 },
        { lat: 42.353515625, lng: 2.032714843750028 },
        { lat: 42.386083984375055, lng: 2.098339843750068 },
        { lat: 42.42094726562496, lng: 2.200390625000068 },
        { lat: 42.39028320312502, lng: 2.374414062500079 },
        { lat: 42.345800781250006, lng: 2.56796875 },
        { lat: 42.340478515624994, lng: 2.651660156250074 },
        { lat: 42.36210937499996, lng: 2.65478515625 },
        { lat: 42.393017578124955, lng: 2.670019531250006 },
        { lat: 42.40849609374999, lng: 2.701855468750011 },
        { lat: 42.41303710937504, lng: 2.749414062500022 },
        { lat: 42.42924804687496, lng: 2.815625 },
        { lat: 42.4560546875, lng: 2.891406250000074 },
        { lat: 42.46723632812498, lng: 2.970019531250017 },
        { lat: 42.44721679687498, lng: 3.052636718750051 },
        { lat: 42.43100585937506, lng: 3.152148437500074 },
        { lat: 42.43115234374999, lng: 3.21142578125 },
        { lat: 42.36787109374998, lng: 3.23984375 },
        { lat: 42.34370117187504, lng: 3.287890625000017 },
        { lat: 42.288964843749994, lng: 3.306738281250034 },
        { lat: 42.260351562500006, lng: 3.218652343750051 },
        { lat: 42.25649414062502, lng: 3.166406250000051 },
        { lat: 42.16245117187506, lng: 3.150390625 },
        { lat: 42.135986328125, lng: 3.17519531250008 },
        { lat: 42.11113281249999, lng: 3.224609375 },
        { lat: 42.082226562499955, lng: 3.238085937499989 },
        { lat: 41.94423828125002, lng: 3.248046875 },
        { lat: 41.86103515625001, lng: 3.146875 },
        { lat: 41.76743164062506, lng: 3.0048828125 },
        { lat: 41.46650390625004, lng: 2.310937500000023 },
        { lat: 41.32075195312501, lng: 2.145605468750005 },
        { lat: 41.28740234375004, lng: 2.082617187500063 },
        { lat: 41.19560546874999, lng: 1.566601562500011 },
        { lat: 41.097558593749994, lng: 1.205859375000045 },
        { lat: 41.06206054687496, lng: 1.032910156250068 },
        { lat: 40.89160156250006, lng: 0.816894531250028 },
        { lat: 40.822851562500006, lng: 0.714648437500074 },
        { lat: 40.803808593750034, lng: 0.796093750000068 },
        { lat: 40.72236328125004, lng: 0.891113281250057 },
        { lat: 40.686230468749955, lng: 0.859179687500045 },
        { lat: 40.63046875000006, lng: 0.720605468750051 },
        { lat: 40.61333007812502, lng: 0.660058593750051 },
        { lat: 40.622216796874966, lng: 0.627148437500011 },
        { lat: 40.61450195312499, lng: 0.59609375000008 },
        { lat: 40.31904296875004, lng: 0.36367187500008 },
        { lat: 40.106591796874994, lng: 0.158398437499983 },
        { lat: 40.01396484374996, lng: 0.043066406250034 },
        { lat: 39.87592773437498, lng: -0.075146484374983 },
        { lat: 39.519873046875006, lng: -0.327001953124949 },
        { lat: 39.41708984375003, lng: -0.328955078125006 },
        { lat: 39.062597656250034, lng: -0.204931640624949 },
        { lat: 38.96948242187497, lng: -0.133789062499943 },
        { lat: 38.891210937500006, lng: -0.034130859374983 },
        { lat: 38.824658203124955, lng: 0.154882812499977 },
        { lat: 38.75917968750002, lng: 0.20156250000008 },
        { lat: 38.69677734375003, lng: 0.136328125000034 },
        { lat: 38.58569335937503, lng: -0.052734374999943 },
        { lat: 38.435644531250034, lng: -0.38125 },
        { lat: 38.317285156249966, lng: -0.520800781249989 },
        { lat: 38.203125, lng: -0.550683593749966 },
        { lat: 38.15185546875003, lng: -0.646777343749989 },
        { lat: 37.99204101562498, lng: -0.683203124999949 },
        { lat: 37.886132812499994, lng: -0.741552734374949 },
        { lat: 37.85024414062505, lng: -0.752734374999989 },
        { lat: 37.76992187500002, lng: -0.814648437500011 },
        { lat: 37.711621093749955, lng: -0.823095703124949 },
        { lat: 37.63105468749998, lng: -0.721582031249966 },
        { lat: 37.59624023437499, lng: -0.771875 },
        { lat: 37.58076171875003, lng: -0.822167968749937 },
        { lat: 37.57133789062499, lng: -0.93808593749992 },
        { lat: 37.561132812500034, lng: -1.327539062499937 },
        { lat: 37.38696289062497, lng: -1.640966796874949 },
        { lat: 37.23286132812504, lng: -1.797607421874971 },
        { lat: 36.94584960937499, lng: -1.939306640624977 },
        { lat: 36.77666015624999, lng: -2.111523437499983 },
        { lat: 36.745458984375034, lng: -2.187695312499955 },
        { lat: 36.81982421874999, lng: -2.305566406249994 },
        { lat: 36.83115234375, lng: -2.452832031249954 },
        { lat: 36.806494140625034, lng: -2.595703124999943 },
        { lat: 36.74755859375003, lng: -2.670605468749926 },
        { lat: 36.714746093749994, lng: -2.787548828124955 },
        { lat: 36.7431640625, lng: -2.901855468749971 },
        { lat: 36.75849609375001, lng: -3.149169921874972 },
        { lat: 36.755761718749994, lng: -3.25913085937492 },
        { lat: 36.707910156250016, lng: -3.43125 },
        { lat: 36.739843750000034, lng: -3.578808593749926 },
        { lat: 36.75605468749998, lng: -3.827783203124937 },
        { lat: 36.71811523437506, lng: -4.366845703124994 },
        { lat: 36.70024414062496, lng: -4.434863281249989 },
        { lat: 36.62915039062506, lng: -4.50224609374996 },
        { lat: 36.506445312500006, lng: -4.67412109374996 },
        { lat: 36.50205078125, lng: -4.935302734374972 },
        { lat: 36.423779296874955, lng: -5.171484374999949 },
        { lat: 36.373632812500034, lng: -5.230517578124989 },
        { lat: 36.23574218750002, lng: -5.329687499999949 },
        { lat: 36.134912109374994, lng: -5.3609375 },
        { lat: 36.13408203124999, lng: -5.381591796874943 },
        { lat: 36.15888671874998, lng: -5.407226562499943 },
        { lat: 36.15058593749998, lng: -5.443603515624972 },
        { lat: 36.07377929687496, lng: -5.4625 },
        { lat: 36.03881835937506, lng: -5.551269531249972 },
        { lat: 36.02592773437498, lng: -5.625488281249999 },
        { lat: 36.08833007812501, lng: -5.80839843749996 },
        { lat: 36.181738281250034, lng: -5.960693359374972 },
        { lat: 36.18842773437498, lng: -6.040673828124937 },
        { lat: 36.33378906250002, lng: -6.170458984374989 },
        { lat: 36.42646484374998, lng: -6.226269531249983 },
        { lat: 36.52651367187502, lng: -6.265917968749989 },
        { lat: 36.56484375, lng: -6.257714843749994 },
        { lat: 36.59672851562502, lng: -6.268945312499994 },
        { lat: 36.63701171874996, lng: -6.38413085937492 },
        { lat: 36.728857421875034, lng: -6.412255859374966 },
        { lat: 36.84814453125, lng: -6.328320312500011 },
        { lat: 36.898974609375045, lng: -6.259423828124994 },
        { lat: 36.91357421875, lng: -6.216796875000028 },
        { lat: 36.90849609375002, lng: -6.320947265625023 },
        { lat: 36.831640625, lng: -6.396191406249983 },
        { lat: 36.95463867187502, lng: -6.492431640624943 },
        { lat: 37.194238281249966, lng: -6.88461914062492 },
        { lat: 37.249169921874966, lng: -6.859375 },
        { lat: 37.27890625, lng: -6.863769531250028 },
        { lat: 37.214941406250034, lng: -6.929492187499989 },
        { lat: 37.19843750000004, lng: -6.97465820312496 },
        { lat: 37.20878906250002, lng: -7.174951171874993 },
        { lat: 37.17944335937497, lng: -7.406152343749937 },
        { lat: 37.42802734374999, lng: -7.467187499999937 },
        { lat: 37.523583984375016, lng: -7.496044921874954 },
        { lat: 37.58549804687502, lng: -7.503515624999977 },
        { lat: 37.72827148437497, lng: -7.443945312499921 },
        { lat: 37.786376953125, lng: -7.378906249999971 },
        { lat: 37.90644531250004, lng: -7.292236328125 },
        { lat: 38.00634765625006, lng: -7.185449218749994 },
        { lat: 38.030029296875, lng: -7.072509765625 },
        { lat: 38.04472656249996, lng: -7.022851562500023 },
        { lat: 38.121972656249966, lng: -6.981103515624937 },
        { lat: 38.18789062499999, lng: -6.957568359374932 },
        { lat: 38.194433593750006, lng: -6.974804687499982 },
        { lat: 38.181005859375006, lng: -7.106396484374982 },
        { lat: 38.45742187500002, lng: -7.343017578124943 },
        { lat: 38.50146484375003, lng: -7.335791015625006 },
        { lat: 38.56684570312501, lng: -7.30595703124996 },
        { lat: 38.649365234374955, lng: -7.286376953124972 },
        { lat: 38.71455078125001, lng: -7.28154296874996 },
        { lat: 38.77050781250002, lng: -7.219921874999925 },
        { lat: 38.82695312499999, lng: -7.125488281249971 },
        { lat: 38.907031250000045, lng: -7.046044921874937 },
        { lat: 38.98525390624999, lng: -7.00625 },
        { lat: 39.05644531250002, lng: -6.997949218749993 },
        { lat: 39.10708007812502, lng: -7.042968749999942 },
        { lat: 39.13520507812498, lng: -7.172412109374932 },
        { lat: 39.33813476562502, lng: -7.30576171874992 },
        { lat: 39.46513671874996, lng: -7.335449218749999 },
        { lat: 39.47832031249999, lng: -7.362695312499966 },
        { lat: 39.53618164062496, lng: -7.44511718749996 },
        { lat: 39.644726562499955, lng: -7.524218749999932 },
        { lat: 39.66157226562501, lng: -7.535693359374961 },
        { lat: 39.6806640625, lng: -7.454101562499943 },
        { lat: 39.681689453125045, lng: -7.117675781249972 },
        { lat: 39.70556640625, lng: -7.04741210937496 },
        { lat: 39.713964843750034, lng: -7.03671875 },
        { lat: 39.79838867187502, lng: -6.975390624999932 },
        { lat: 39.937109375000034, lng: -6.911181640624989 },
        { lat: 40.02182617187506, lng: -6.896093749999949 },
        { lat: 40.05683593749998, lng: -6.91640625 },
        { lat: 40.14262695312496, lng: -7.027832031249972 },
        { lat: 40.16791992187498, lng: -7.032617187499965 },
        { lat: 40.208349609375034, lng: -7.01469726562496 },
        { lat: 40.251611328124966, lng: -6.948437499999955 },
        { lat: 40.30073242187504, lng: -6.85888671875 },
        { lat: 40.343115234375034, lng: -6.8101562499999 },
        { lat: 40.37626953124996, lng: -6.82177734375 },
        { lat: 40.410986328125006, lng: -6.847949218749988 },
        { lat: 40.44326171875002, lng: -6.852050781249943 },
        { lat: 40.48315429687497, lng: -6.835693359374971 },
        { lat: 40.619091796874955, lng: -6.829833984374943 },
        { lat: 40.65405273437497, lng: -6.818359375 },
        { lat: 40.777490234374994, lng: -6.835888671874926 },
        { lat: 40.87832031250002, lng: -6.857714843749932 },
        { lat: 41.009130859375, lng: -6.928466796874972 },
        { lat: 41.038037109374955, lng: -6.915527343749999 },
        { lat: 41.06240234375002, lng: -6.8828125 },
        { lat: 41.10771484375002, lng: -6.775781249999937 },
        { lat: 41.21450195312502, lng: -6.690136718749983 },
        { lat: 41.3037109375, lng: -6.56591796875 },
        { lat: 41.37539062500002, lng: -6.403125 },
        { lat: 41.45502929687501, lng: -6.28935546874996 },
        { lat: 41.51591796874995, lng: -6.244335937499955 },
        { lat: 41.53203125, lng: -6.2125 },
        { lat: 41.560449218749994, lng: -6.221679687499943 },
        { lat: 41.60180664062497, lng: -6.243115234374955 },
        { lat: 41.642187500000034, lng: -6.308056640624954 },
        { lat: 41.66538085937503, lng: -6.391699218749949 },
        { lat: 41.664404296875034, lng: -6.48466796874996 },
        { lat: 41.672509765624994, lng: -6.542187499999954 },
        { lat: 41.70405273437501, lng: -6.558984375000023 },
        { lat: 41.78955078125003, lng: -6.552587890624948 },
        { lat: 41.874121093750034, lng: -6.557519531249966 },
        { lat: 41.91308593749997, lng: -6.575341796874966 },
        { lat: 41.9423828125, lng: -6.61826171874992 },
        { lat: 41.9345703125, lng: -6.70361328125 },
        { lat: 41.958496093749964, lng: -6.777294921874983 },
        { lat: 41.96416015624999, lng: -6.833203124999926 },
        { lat: 41.945263671874955, lng: -6.865527343749932 },
        { lat: 41.95063476562498, lng: -7.030468749999955 },
        { lat: 41.964208984375006, lng: -7.09912109375 },
        { lat: 41.98115234374998, lng: -7.147119140625023 },
        { lat: 41.9716796875, lng: -7.177929687499983 },
        { lat: 41.95522460937502, lng: -7.195361328124989 },
        { lat: 41.92939453125001, lng: -7.198339843749978 },
        { lat: 41.89526367187497, lng: -7.209619140624966 },
        { lat: 41.864404296874994, lng: -7.268554687499972 },
        { lat: 41.83369140624995, lng: -7.40361328124996 },
        { lat: 41.83598632812498, lng: -7.512597656249966 },
        { lat: 41.85795898437502, lng: -7.612597656249988 },
        { lat: 41.87397460937498, lng: -7.644677734374937 },
        { lat: 41.88847656250002, lng: -7.693066406249955 },
        { lat: 41.87055664062501, lng: -7.896386718749994 },
        { lat: 41.883642578125, lng: -7.920849609374982 },
        { lat: 41.851904296875034, lng: -7.990966796874972 },
        { lat: 41.81420898437499, lng: -8.094433593749926 },
        { lat: 41.81196289062498, lng: -8.152490234374937 },
        { lat: 41.819970703124994, lng: -8.173535156249955 },
        { lat: 41.83696289062502, lng: -8.18125 },
        { lat: 41.895849609375006, lng: -8.224755859374994 },
        { lat: 41.92709960937498, lng: -8.213330078124983 },
        { lat: 42.01816406250006, lng: -8.129980468749977 },
        { lat: 42.039941406249966, lng: -8.139306640624994 },
        { lat: 42.06938476562501, lng: -8.17358398437497 },
        { lat: 42.11186523437496, lng: -8.204199218749977 },
        { lat: 42.133691406249966, lng: -8.213085937499926 },
        { lat: 42.13740234375001, lng: -8.266064453124983 },
        { lat: 42.115087890625006, lng: -8.322558593749932 },
        { lat: 42.0693359375, lng: -8.538085937499972 },
        { lat: 42.05273437499999, lng: -8.589648437499989 },
        { lat: 42.008496093749955, lng: -8.68295898437492 },
        { lat: 41.941064453124994, lng: -8.777148437500017 },
        { lat: 41.92690429687502, lng: -8.85234375 },
        { lat: 41.946875, lng: -8.878320312500023 },
        { lat: 42.105273437500045, lng: -8.887207031249943 },
        { lat: 42.210595703124994, lng: -8.772460937499943 },
        { lat: 42.274169921875, lng: -8.690917968749941 },
        { lat: 42.28701171875002, lng: -8.729199218749926 },
        { lat: 42.285253906250034, lng: -8.815820312499966 },
        { lat: 42.33447265625003, lng: -8.809960937499937 },
        { lat: 42.35815429687506, lng: -8.76938476562492 },
        { lat: 42.411718750000034, lng: -8.730029296874987 },
        { lat: 42.43481445312503, lng: -8.776171874999989 },
        { lat: 42.470068359375034, lng: -8.81210937499992 },
        { lat: 42.562353515625006, lng: -8.80991210937492 },
        { lat: 42.59990234375002, lng: -8.79990234374992 },
        { lat: 42.640332031249976, lng: -8.8115234375 },
        { lat: 42.58564453125004, lng: -8.987792968750028 },
        { lat: 42.593847656250006, lng: -9.033105468750023 },
        { lat: 42.66235351562503, lng: -9.035058593749966 },
        { lat: 42.76669921875006, lng: -8.937207031249926 },
        { lat: 42.79858398437497, lng: -8.927197265624926 },
        { lat: 42.81401367187502, lng: -9.041601562499975 },
        { lat: 42.86523437499997, lng: -9.127197265625 },
        { lat: 42.91098632812506, lng: -9.179443359374972 },
        { lat: 42.97690429687498, lng: -9.235205078124977 },
        { lat: 43.035791015624994, lng: -9.235644531249989 },
        { lat: 43.17402343749998, lng: -9.178076171874977 },
        { lat: 43.214208984375006, lng: -9.095556640624949 },
        { lat: 43.238964843749976, lng: -9.024511718749949 },
        { lat: 43.334423828124976, lng: -8.873681640624966 },
        { lat: 43.31660156250001, lng: -8.665625 },
        { lat: 43.337060546874994, lng: -8.537060546874955 },
        { lat: 43.38583984374997, lng: -8.421582031249955 },
        { lat: 43.396826171875006, lng: -8.355468749999972 },
        { lat: 43.43940429687498, lng: -8.248925781249937 },
        { lat: 43.49692382812506, lng: -8.25229492187492 },
        { lat: 43.539599609375045, lng: -8.288867187500017 },
        { lat: 43.57988281249999, lng: -8.256738281249937 },
        { lat: 43.629052734374966, lng: -8.137158203124926 },
        { lat: 43.69438476562495, lng: -8.004687499999932 },
        { lat: 43.70698242187504, lng: -7.852734374999983 },
        { lat: 43.76455078125005, lng: -7.698144531249995 },
      ],
    ],
  },
  {
    code: "FI",
    coordinates: [
      [
        { lat: 60.10781249999999, lng: 21.62832031250008 },
        { lat: 60.09790039062503, lng: 21.540625 },
        { lat: 60.126806640625034, lng: 21.48603515625004 },
        { lat: 60.148339843749994, lng: 21.50673828125008 },
        { lat: 60.17231445312498, lng: 21.567968750000034 },
        { lat: 60.16899414062502, lng: 21.634082031249985 },
        { lat: 60.140869140624964, lng: 21.648144531250008 },
        { lat: 60.10781249999999, lng: 21.62832031250008 },
      ],
      [
        { lat: 60.140527343749994, lng: 21.833203125000068 },
        { lat: 60.10615234375001, lng: 21.73310546875001 },
        { lat: 60.11435546875, lng: 21.695019531250068 },
        { lat: 60.17231445312498, lng: 21.70478515625001 },
        { lat: 60.19882812499998, lng: 21.764257812500063 },
        { lat: 60.201806640624966, lng: 21.864355468750006 },
        { lat: 60.140527343749994, lng: 21.833203125000068 },
      ],
      [
        { lat: 60.37075195312499, lng: 22.175097656249985 },
        { lat: 60.347558593749994, lng: 22.301757812500057 },
        { lat: 60.35585937499999, lng: 22.354980468750057 },
        { lat: 60.303369140625044, lng: 22.41552734375003 },
        { lat: 60.26997070312498, lng: 22.31289062499999 },
        { lat: 60.22856445312499, lng: 22.305761718750063 },
        { lat: 60.202832031249976, lng: 22.346289062500063 },
        { lat: 60.165576171875045, lng: 22.360546875000036 },
        { lat: 60.165625, lng: 22.25830078124997 },
        { lat: 60.19697265624995, lng: 22.209375 },
        { lat: 60.236767578124976, lng: 22.188085937500063 },
        { lat: 60.26489257812503, lng: 22.14052734375005 },
        { lat: 60.286328124999955, lng: 22.07714843750003 },
        { lat: 60.314892578124976, lng: 22.108203125000045 },
        { lat: 60.35585937499999, lng: 22.125878906249994 },
        { lat: 60.37075195312499, lng: 22.175097656249985 },
      ],
      [
        { lat: 60.336669921875, lng: 21.994238281250006 },
        { lat: 60.33227539062497, lng: 21.921484375000034 },
        { lat: 60.38183593750006, lng: 21.818652343750045 },
        { lat: 60.401220703125006, lng: 21.805664062500057 },
        { lat: 60.41245117187498, lng: 21.845996093750014 },
        { lat: 60.45229492187502, lng: 21.8193359375 },
        { lat: 60.46992187499995, lng: 21.827246093750006 },
        { lat: 60.43847656250002, lng: 21.906835937500063 },
        { lat: 60.401708984375, lng: 21.950292968750034 },
        { lat: 60.393164062500034, lng: 21.907812499999977 },
        { lat: 60.355224609375036, lng: 21.97978515624999 },
        { lat: 60.336669921875, lng: 21.994238281250006 },
      ],
      [
        { lat: 60.52958984375004, lng: 21.450878906250068 },
        { lat: 60.483056640624966, lng: 21.43691406250008 },
        { lat: 60.48823242187495, lng: 21.369042968749994 },
        { lat: 60.47978515625002, lng: 21.3 },
        { lat: 60.525976562500006, lng: 21.24433593750001 },
        { lat: 60.60385742187497, lng: 21.214550781250068 },
        { lat: 60.62060546875003, lng: 21.224707031250006 },
        { lat: 60.63828125, lng: 21.268066406250025 },
        { lat: 60.59555664062498, lng: 21.301269531250057 },
        { lat: 60.52958984375004, lng: 21.450878906250068 },
      ],
      [
        { lat: 63.241308593750034, lng: 21.2177734375 },
        { lat: 63.22265624999997, lng: 21.228515625000057 },
        { lat: 63.22778320312503, lng: 21.287109375 },
        { lat: 63.261767578125045, lng: 21.366015625000017 },
        { lat: 63.24589843749999, lng: 21.421972656250034 },
        { lat: 63.19736328125007, lng: 21.415625 },
        { lat: 63.19921875, lng: 21.377636718750068 },
        { lat: 63.20722656250001, lng: 21.36718749999997 },
        { lat: 63.179492187500045, lng: 21.318457031250006 },
        { lat: 63.1626953125, lng: 21.30976562500001 },
        { lat: 63.152001953124966, lng: 21.25341796875 },
        { lat: 63.19946289062502, lng: 21.14931640624999 },
        { lat: 63.277539062499955, lng: 21.08388671875008 },
        { lat: 63.27773437499999, lng: 21.236328125000057 },
        { lat: 63.259130859375034, lng: 21.22177734375003 },
        { lat: 63.241308593750034, lng: 21.2177734375 },
      ],
      [
        { lat: 64.99101562499999, lng: 24.848242187500034 },
        { lat: 64.95781250000007, lng: 24.69892578125001 },
        { lat: 64.978564453125, lng: 24.57861328125 },
        { lat: 65.04287109375, lng: 24.576562500000023 },
        { lat: 65.073974609375, lng: 24.651171875000045 },
        { lat: 65.08642578124997, lng: 24.78603515625008 },
        { lat: 65.05532226562502, lng: 24.970605468750023 },
        { lat: 65.03872070312502, lng: 24.997558593749996 },
        { lat: 65.02626953124997, lng: 24.89179687500004 },
        { lat: 64.99101562499999, lng: 24.848242187500034 },
      ],
      [
        { lat: 69.97167968750003, lng: 28.047265625000023 },
        { lat: 69.87143554687503, lng: 28.269140625000034 },
        { lat: 69.82275390624997, lng: 28.411718750000034 },
        { lat: 69.73149414062505, lng: 28.800390625000063 },
        { lat: 69.67143554687505, lng: 29.141601562500025 },
        { lat: 69.47299804687503, lng: 29.333398437500048 },
        { lat: 69.39394531250002, lng: 29.238867187500063 },
        { lat: 69.36669921874997, lng: 29.19179687500005 },
        { lat: 69.28798828125, lng: 29.024902343749968 },
        { lat: 69.17690429687502, lng: 28.846289062500006 },
        { lat: 69.11899414062503, lng: 28.832617187500063 },
        { lat: 69.06059570312505, lng: 28.891894531250074 },
        { lat: 69.02197265625, lng: 28.96582031250003 },
        { lat: 69.00966796874997, lng: 28.89892578124997 },
        { lat: 68.96103515625, lng: 28.692187500000045 },
        { lat: 68.92822265624999, lng: 28.566015625 },
        { lat: 68.90415039062506, lng: 28.414062500000057 },
        { lat: 68.87226562499994, lng: 28.453515625000023 },
        { lat: 68.86552734375002, lng: 28.70595703125002 },
        { lat: 68.85644531250001, lng: 28.744824218750036 },
        { lat: 68.84003906249995, lng: 28.77285156250005 },
        { lat: 68.81381835937503, lng: 28.777636718750042 },
        { lat: 68.77143554687501, lng: 28.752050781250002 },
        { lat: 68.53764648437499, lng: 28.479296875000014 },
        { lat: 68.48837890625, lng: 28.470703125000053 },
        { lat: 68.35136718750007, lng: 28.560156250000063 },
        { lat: 68.189794921875, lng: 28.685156250000034 },
        { lat: 68.11796875000002, lng: 29.06298828125 },
        { lat: 68.06186523437506, lng: 29.343847656250006 },
        { lat: 67.92910156250001, lng: 29.524218750000017 },
        { lat: 67.75400390625003, lng: 29.821582031250017 },
        { lat: 67.68857421875003, lng: 29.97919921875004 },
        { lat: 67.66826171874999, lng: 29.988085937500014 },
        { lat: 67.54746093749998, lng: 29.94121093750007 },
        { lat: 67.426416015625, lng: 29.750585937500002 },
        { lat: 67.324365234375, lng: 29.57226562500003 },
        { lat: 67.201416015625, lng: 29.38769531249997 },
        { lat: 67.09658203125005, lng: 29.243359375000093 },
        { lat: 66.97094726562503, lng: 29.08701171875003 },
        { lat: 66.93022460937499, lng: 29.06904296875001 },
        { lat: 66.89174804687497, lng: 29.066210937500042 },
        { lat: 66.84921875, lng: 29.093066406250017 },
        { lat: 66.69550781249994, lng: 29.29326171875002 },
        { lat: 66.61704101562506, lng: 29.371191406250002 },
        { lat: 66.53217773437497, lng: 29.464355468749968 },
        { lat: 66.43969726562497, lng: 29.544335937499998 },
        { lat: 66.35683593749997, lng: 29.59072265625005 },
        { lat: 66.27612304687504, lng: 29.67089843749997 },
        { lat: 66.23486328125, lng: 29.72070312499997 },
        { lat: 66.17705078125002, lng: 29.80351562500007 },
        { lat: 66.091064453125, lng: 29.903417968750006 },
        { lat: 66.02294921875, lng: 29.936621093750002 },
        { lat: 65.78652343749995, lng: 30.0875 },
        { lat: 65.72626953125004, lng: 30.102734375000093 },
        { lat: 65.68168945312502, lng: 30.0953125 },
        { lat: 65.67070312499999, lng: 30.029003906250097 },
        { lat: 65.66362304687505, lng: 29.882617187500017 },
        { lat: 65.634375, lng: 29.723925781250014 },
        { lat: 65.62456054687502, lng: 29.715917968750063 },
        { lat: 65.56875, lng: 29.819433593750006 },
        { lat: 65.47343750000003, lng: 29.72802734374997 },
        { lat: 65.33696289062505, lng: 29.714843750000025 },
        { lat: 65.26533203125, lng: 29.617187500000025 },
        { lat: 65.248681640625, lng: 29.608007812500006 },
        { lat: 65.234765625, lng: 29.61240234375001 },
        { lat: 65.223876953125, lng: 29.629687500000017 },
        { lat: 65.204736328125, lng: 29.81054687499997 },
        { lat: 65.18530273437504, lng: 29.826171874999968 },
        { lat: 65.14506835937502, lng: 29.826953125000017 },
        { lat: 65.10791015625, lng: 29.81083984375007 },
        { lat: 65.08032226562497, lng: 29.720019531250014 },
        { lat: 65.03950195312501, lng: 29.62246093750005 },
        { lat: 65.001953125, lng: 29.60087890625007 },
        { lat: 64.968408203125, lng: 29.604199218750036 },
        { lat: 64.911767578125, lng: 29.6375 },
        { lat: 64.84575195312505, lng: 29.70166015625003 },
        { lat: 64.80429687500006, lng: 29.783203125000025 },
        { lat: 64.76503906250005, lng: 30.072851562500063 },
        { lat: 64.732568359375, lng: 30.110253906250048 },
        { lat: 64.6880859375, lng: 30.126171875000097 },
        { lat: 64.64462890625002, lng: 30.12011718749997 },
        { lat: 64.55771484375, lng: 29.98554687500004 },
        { lat: 64.52426757812503, lng: 29.986621093750077 },
        { lat: 64.44335937499997, lng: 30.041894531250048 },
        { lat: 64.36611328125005, lng: 30.108105468750036 },
        { lat: 64.28242187499995, lng: 30.390625 },
        { lat: 64.2365234375, lng: 30.487890625000063 },
        { lat: 64.2, lng: 30.513769531250002 },
        { lat: 64.14111328125003, lng: 30.527929687500006 },
        { lat: 64.077294921875, lng: 30.526074218750097 },
        { lat: 64.02060546875, lng: 30.50390625000003 },
        { lat: 63.94750976562503, lng: 30.415332031250017 },
        { lat: 63.80332031250006, lng: 30.210253906250074 },
        { lat: 63.747314453125, lng: 30.004101562500093 },
        { lat: 63.73515625000002, lng: 29.991503906250074 },
        { lat: 63.689013671875045, lng: 30.05537109375004 },
        { lat: 63.50405273437502, lng: 30.41855468750006 },
        { lat: 63.41748046875006, lng: 30.65527343749997 },
        { lat: 63.300634765625034, lng: 30.974804687500036 },
        { lat: 63.208300781250074, lng: 31.180859375000093 },
        { lat: 63.141894531250045, lng: 31.247460937499994 },
        { lat: 63.06806640625001, lng: 31.336718750000074 },
        { lat: 63.007714843749966, lng: 31.437011718749968 },
        { lat: 62.95532226562503, lng: 31.509277343750025 },
        { lat: 62.921630859375036, lng: 31.53652343749999 },
        { lat: 62.885400390624994, lng: 31.533984375000017 },
        { lat: 62.77612304687503, lng: 31.437304687500014 },
        { lat: 62.691650390624964, lng: 31.382421875 },
        { lat: 62.567822265624955, lng: 31.28564453125003 },
        { lat: 62.48139648437503, lng: 31.18671875000004 },
        { lat: 62.32377929687499, lng: 30.935742187500093 },
        { lat: 62.127587890624994, lng: 30.565625 },
        { lat: 62.06821289062506, lng: 30.47968750000004 },
        { lat: 61.964843750000064, lng: 30.306445312500017 },
        { lat: 61.757373046875045, lng: 30.00996093750004 },
        { lat: 61.71157226562496, lng: 29.933203125 },
        { lat: 61.54609375, lng: 29.690136718750036 },
        { lat: 61.49345703125001, lng: 29.57939453125007 },
        { lat: 61.44423828125002, lng: 29.492382812500097 },
        { lat: 61.28779296874996, lng: 29.251660156250097 },
        { lat: 61.16904296875, lng: 28.992968750000042 },
        { lat: 61.05874023437502, lng: 28.739062500000014 },
        { lat: 61.00283203124999, lng: 28.662890625000045 },
        { lat: 60.960205078125, lng: 28.568164062500017 },
        { lat: 60.919628906250004, lng: 28.455078125000057 },
        { lat: 60.89692382812501, lng: 28.40742187500004 },
        { lat: 60.74584960937502, lng: 28.151953125000034 },
        { lat: 60.53613281250003, lng: 27.797656250000074 },
        { lat: 60.53286132812499, lng: 27.76162109375002 },
        { lat: 60.498974609375004, lng: 27.66933593750005 },
        { lat: 60.49077148437504, lng: 27.52509765625004 },
        { lat: 60.46484375, lng: 27.46240234374997 },
        { lat: 60.53867187500003, lng: 27.24189453125001 },
        { lat: 60.54345703125002, lng: 27.20527343750001 },
        { lat: 60.52514648437502, lng: 27.07558593750005 },
        { lat: 60.47148437500001, lng: 26.951171875 },
        { lat: 60.45507812500006, lng: 26.721484375000014 },
        { lat: 60.437695312499955, lng: 26.607421875000057 },
        { lat: 60.412890625000074, lng: 26.534667968749968 },
        { lat: 60.471582031250016, lng: 26.519726562500036 },
        { lat: 60.545996093750006, lng: 26.55117187500005 },
        { lat: 60.595605468749994, lng: 26.601757812500068 },
        { lat: 60.62792968749999, lng: 26.60644531250003 },
        { lat: 60.62456054687501, lng: 26.569335937500025 },
        { lat: 60.551806640625045, lng: 26.495800781250068 },
        { lat: 60.46679687500002, lng: 26.456445312500023 },
        { lat: 60.42407226562503, lng: 26.377734375000074 },
        { lat: 60.406591796875034, lng: 26.204687499999977 },
        { lat: 60.47490234374998, lng: 26.036035156249994 },
        { lat: 60.474218750000034, lng: 25.955957031250023 },
        { lat: 60.42529296875003, lng: 26.00625 },
        { lat: 60.37158203125, lng: 26.040234375000068 },
        { lat: 60.34150390625001, lng: 26.03583984375004 },
        { lat: 60.34677734375, lng: 25.94589843750003 },
        { lat: 60.31459960937502, lng: 25.845800781250063 },
        { lat: 60.26752929687504, lng: 25.75800781250004 },
        { lat: 60.267431640625006, lng: 25.715429687500063 },
        { lat: 60.333203124999976, lng: 25.65644531250004 },
        { lat: 60.30249023437506, lng: 25.54824218750002 },
        { lat: 60.26123046875, lng: 25.45576171875001 },
        { lat: 60.24833984375002, lng: 25.267871093750017 },
        { lat: 60.194091796875, lng: 25.155859375 },
        { lat: 60.157470703125, lng: 24.95761718750003 },
        { lat: 60.158349609374994, lng: 24.84873046875006 },
        { lat: 60.11425781249997, lng: 24.600488281250023 },
        { lat: 60.046289062499994, lng: 24.517968750000076 },
        { lat: 60.02128906250005, lng: 24.44560546874999 },
        { lat: 60.04233398437498, lng: 24.342578125000045 },
        { lat: 60.009179687499966, lng: 24.025195312500042 },
        { lat: 59.965673828125, lng: 23.72177734375006 },
        { lat: 59.96816406249996, lng: 23.59267578125005 },
        { lat: 59.986230468749994, lng: 23.46357421875004 },
        { lat: 59.92578125000003, lng: 23.326757812500063 },
        { lat: 59.844921874999976, lng: 23.181445312500017 },
        { lat: 59.81601562500006, lng: 23.021289062500074 },
        { lat: 59.82636718750004, lng: 22.963867187500025 },
        { lat: 59.86879882812496, lng: 23.009765625000057 },
        { lat: 59.91269531250004, lng: 23.115722656250053 },
        { lat: 59.97221679687499, lng: 23.188476562500025 },
        { lat: 60.02182617187497, lng: 23.1984375 },
        { lat: 60.041308593750045, lng: 23.148437500000057 },
        { lat: 60.04726562499999, lng: 23.080175781250002 },
        { lat: 60.09853515624996, lng: 22.994140625000057 },
        { lat: 60.20971679687498, lng: 22.911718750000063 },
        { lat: 60.21582031249997, lng: 22.867089843750023 },
        { lat: 60.18662109374997, lng: 22.84443359375001 },
        { lat: 60.10136718750002, lng: 22.819140625000017 },
        { lat: 60.07680664062499, lng: 22.79345703125003 },
        { lat: 60.057275390624994, lng: 22.749804687500017 },
        { lat: 60.03759765625, lng: 22.697363281250002 },
        { lat: 60.028027343749976, lng: 22.64619140625004 },
        { lat: 60.029199218749966, lng: 22.462695312500045 },
        { lat: 60.07226562500003, lng: 22.43857421875003 },
        { lat: 60.09028320312498, lng: 22.43857421875003 },
        { lat: 60.14697265624997, lng: 22.47109375000008 },
        { lat: 60.156884765625044, lng: 22.44267578125007 },
        { lat: 60.20131835937505, lng: 22.469726562499968 },
        { lat: 60.19892578124998, lng: 22.512988281249985 },
        { lat: 60.20551757812501, lng: 22.564257812500045 },
        { lat: 60.228369140625034, lng: 22.589941406250034 },
        { lat: 60.25566406250002, lng: 22.587988281250006 },
        { lat: 60.26274414062502, lng: 22.516699218750034 },
        { lat: 60.28134765625, lng: 22.512304687500034 },
        { lat: 60.35908203125003, lng: 22.57587890625001 },
        { lat: 60.380566406249955, lng: 22.5849609375 },
        { lat: 60.38500976562497, lng: 22.560351562500042 },
        { lat: 60.37656250000003, lng: 22.52050781250003 },
        { lat: 60.400927734375024, lng: 22.257910156250006 },
        { lat: 60.500292968750024, lng: 21.93398437500008 },
        { lat: 60.50541992187499, lng: 21.854296875000014 },
        { lat: 60.59414062500005, lng: 21.805273437500063 },
        { lat: 60.582910156249966, lng: 21.727148437500034 },
        { lat: 60.53095703124996, lng: 21.61328125000003 },
        { lat: 60.570410156250006, lng: 21.52783203125003 },
        { lat: 60.596386718749955, lng: 21.436035156250057 },
        { lat: 60.636962890624964, lng: 21.410644531250057 },
        { lat: 60.69682617187498, lng: 21.411914062500042 },
        { lat: 60.767431640625, lng: 21.40400390625001 },
        { lat: 60.850048828124955, lng: 21.378906250000057 },
        { lat: 60.967480468749976, lng: 21.36054687500004 },
        { lat: 61.059228515625016, lng: 21.37773437499999 },
        { lat: 61.12714843750001, lng: 21.45097656249999 },
        { lat: 61.170507812500034, lng: 21.479101562500034 },
        { lat: 61.281201171874955, lng: 21.513476562500045 },
        { lat: 61.41083984374998, lng: 21.52119140625001 },
        { lat: 61.454980468749994, lng: 21.501757812500042 },
        { lat: 61.48432617187503, lng: 21.506640625000074 },
        { lat: 61.48432617187503, lng: 21.565039062500063 },
        { lat: 61.50952148437499, lng: 21.552343750000034 },
        { lat: 61.52329101562497, lng: 21.526660156250045 },
        { lat: 61.551953124999955, lng: 21.49824218750004 },
        { lat: 61.56713867187503, lng: 21.522460937499996 },
        { lat: 61.56821289062498, lng: 21.592382812500034 },
        { lat: 61.57788085937499, lng: 21.598046875000023 },
        { lat: 61.59155273437503, lng: 21.605957031250053 },
        { lat: 61.666845703125006, lng: 21.551855468750034 },
        { lat: 61.70273437500003, lng: 21.545605468750008 },
        { lat: 61.81166992187502, lng: 21.470507812500074 },
        { lat: 61.914941406249994, lng: 21.384863281250034 },
        { lat: 61.989648437500044, lng: 21.255957031250063 },
        { lat: 62.11264648437506, lng: 21.301660156250048 },
        { lat: 62.22382812499995, lng: 21.353710937499983 },
        { lat: 62.277392578125045, lng: 21.343359375 },
        { lat: 62.34257812499999, lng: 21.323437500000036 },
        { lat: 62.4140625, lng: 21.165625 },
        { lat: 62.514794921874994, lng: 21.142187500000063 },
        { lat: 62.622949218749994, lng: 21.103613281250034 },
        { lat: 62.68925781250001, lng: 21.118164062500057 },
        { lat: 62.739990234375064, lng: 21.143847656250045 },
        { lat: 62.79052734375003, lng: 21.19570312500005 },
        { lat: 62.95, lng: 21.45751953125 },
        { lat: 63.03325195312502, lng: 21.47353515625008 },
        { lat: 63.03930664062499, lng: 21.650976562500063 },
        { lat: 63.11372070312498, lng: 21.568652343750074 },
        { lat: 63.155517578124964, lng: 21.549218750000023 },
        { lat: 63.204296874999955, lng: 21.545117187499983 },
        { lat: 63.23769531250002, lng: 21.800390625000034 },
        { lat: 63.21025390625002, lng: 21.89570312500001 },
        { lat: 63.244140625, lng: 22.12031250000004 },
        { lat: 63.31044921874999, lng: 22.31972656250005 },
        { lat: 63.345654296874976, lng: 22.316210937500045 },
        { lat: 63.377197265625, lng: 22.285546875000023 },
        { lat: 63.43793945312495, lng: 22.243261718750034 },
        { lat: 63.45478515625001, lng: 22.273242187500017 },
        { lat: 63.44238281249997, lng: 22.345996093749985 },
        { lat: 63.47255859374999, lng: 22.31259765625003 },
        { lat: 63.50439453124999, lng: 22.318652343750017 },
        { lat: 63.491162109374955, lng: 22.39804687500003 },
        { lat: 63.579980468750016, lng: 22.527636718750045 },
        { lat: 63.647851562499994, lng: 22.532324218750034 },
        { lat: 63.68334960937503, lng: 22.75625 },
        { lat: 63.82182617187499, lng: 23.014453125000017 },
        { lat: 63.86494140624999, lng: 23.133593750000045 },
        { lat: 63.89614257812505, lng: 23.248730468750068 },
        { lat: 64.03447265625007, lng: 23.493945312500017 },
        { lat: 64.04091796874997, lng: 23.598925781250074 },
        { lat: 64.13417968750005, lng: 23.652929687500063 },
        { lat: 64.25825195312501, lng: 23.861425781250006 },
        { lat: 64.27412109374995, lng: 23.92480468750003 },
        { lat: 64.385986328125, lng: 24.022265625000074 },
        { lat: 64.51528320312495, lng: 24.27832031250003 },
        { lat: 64.68012695312498, lng: 24.440625 },
        { lat: 64.738671875, lng: 24.53017578125008 },
        { lat: 64.801025390625, lng: 24.557910156250045 },
        { lat: 64.80629882812502, lng: 24.657617187500023 },
        { lat: 64.85209960937502, lng: 24.747558593750053 },
        { lat: 64.88403320312503, lng: 24.942187499999985 },
        { lat: 64.87519531250001, lng: 25.134277343750057 },
        { lat: 64.85346679687504, lng: 25.214257812499994 },
        { lat: 64.8603515625, lng: 25.288183593750063 },
        { lat: 64.91640624999997, lng: 25.280761718750057 },
        { lat: 64.95102539062499, lng: 25.228027343750057 },
        { lat: 64.98427734375001, lng: 25.271093750000034 },
        { lat: 65.00947265625001, lng: 25.37265625000003 },
        { lat: 65.06513671874998, lng: 25.362304687500057 },
        { lat: 65.09863281249997, lng: 25.34023437499999 },
        { lat: 65.14326171875001, lng: 25.255859375000057 },
        { lat: 65.24321289062502, lng: 25.29785156249997 },
        { lat: 65.35273437499995, lng: 25.307910156250074 },
        { lat: 65.47924804687497, lng: 25.347851562500036 },
        { lat: 65.54628906250005, lng: 25.241796875000034 },
        { lat: 65.66035156250001, lng: 24.83935546875 },
        { lat: 65.656396484375, lng: 24.764257812499977 },
        { lat: 65.67070312499999, lng: 24.674902343750006 },
        { lat: 65.75712890625002, lng: 24.58154296874997 },
        { lat: 65.83168945312502, lng: 24.62324218750004 },
        { lat: 65.85917968750002, lng: 24.628027343750034 },
        { lat: 65.85834960937504, lng: 24.591601562500074 },
        { lat: 65.822021484375, lng: 24.532617187500048 },
        { lat: 65.78046874999998, lng: 24.40429687500003 },
        { lat: 65.81235351562498, lng: 24.2375 },
        { lat: 65.80527343750006, lng: 24.15546875000004 },
        { lat: 65.98984375, lng: 24.04902343750004 },
        { lat: 66.06035156250005, lng: 23.994628906250053 },
        { lat: 66.14824218750002, lng: 23.907324218750034 },
        { lat: 66.19116210937497, lng: 23.75146484374997 },
        { lat: 66.21542968750003, lng: 23.720996093750074 },
        { lat: 66.25263671874998, lng: 23.70029296875003 },
        { lat: 66.304296875, lng: 23.693554687499983 },
        { lat: 66.38071289062503, lng: 23.673828125000053 },
        { lat: 66.44340820312502, lng: 23.68203125000005 },
        { lat: 66.48076171874997, lng: 23.70117187500003 },
        { lat: 66.50585937500004, lng: 23.768359375000042 },
        { lat: 66.57661132812497, lng: 23.865527343750045 },
        { lat: 66.62802734374996, lng: 23.885839843750006 },
        { lat: 66.70688476562506, lng: 23.894140625 },
        { lat: 66.77573242187505, lng: 23.93886718750005 },
        { lat: 66.81054687500003, lng: 23.988574218750042 },
        { lat: 66.838232421875, lng: 23.97607421875 },
        { lat: 66.87783203124997, lng: 23.941796875000023 },
        { lat: 66.93403320312498, lng: 23.86933593750001 },
        { lat: 67.002587890625, lng: 23.758984375 },
        { lat: 67.06811523437503, lng: 23.677343750000063 },
        { lat: 67.12939453124997, lng: 23.64150390625005 },
        { lat: 67.18413085937502, lng: 23.62304687500003 },
        { lat: 67.23393554687505, lng: 23.626074218750006 },
        { lat: 67.26782226562503, lng: 23.656640625000023 },
        { lat: 67.31049804687501, lng: 23.76093750000004 },
        { lat: 67.32861328124997, lng: 23.774902343750057 },
        { lat: 67.42290039062497, lng: 23.733593750000065 },
        { lat: 67.44003906250003, lng: 23.660839843749983 },
        { lat: 67.449169921875, lng: 23.537109375 },
        { lat: 67.449951171875, lng: 23.468066406250074 },
        { lat: 67.46025390625007, lng: 23.454882812500045 },
        { lat: 67.47919921875001, lng: 23.451464843750045 },
        { lat: 67.51787109374999, lng: 23.46542968750006 },
        { lat: 67.56215820312505, lng: 23.504492187500034 },
        { lat: 67.59038085937502, lng: 23.53701171875008 },
        { lat: 67.61430664062502, lng: 23.541308593750074 },
        { lat: 67.69619140625, lng: 23.500195312500036 },
        { lat: 67.79658203125001, lng: 23.487792968749996 },
        { lat: 67.87519531249995, lng: 23.50185546875002 },
        { lat: 67.93320312500003, lng: 23.632910156249977 },
        { lat: 67.95439453125, lng: 23.63886718750004 },
        { lat: 68.01733398437504, lng: 23.474218749999977 },
        { lat: 68.08867187500002, lng: 23.35546875000003 },
        { lat: 68.13032226562498, lng: 23.318554687500065 },
        { lat: 68.13662109375002, lng: 23.18251953125008 },
        { lat: 68.25756835937506, lng: 23.09785156250004 },
        { lat: 68.31645507812505, lng: 22.975390625000045 },
        { lat: 68.36733398437502, lng: 22.854101562500034 },
        { lat: 68.39101562499995, lng: 22.78242187500001 },
        { lat: 68.46406250000001, lng: 22.362109375000074 },
        { lat: 68.477978515625, lng: 22.195117187500074 },
        { lat: 68.52060546874998, lng: 21.99746093750005 },
        { lat: 68.57412109374997, lng: 21.850195312500063 },
        { lat: 68.60854492187497, lng: 21.724023437500023 },
        { lat: 68.6509765625, lng: 21.616015625000045 },
        { lat: 68.69067382812499, lng: 21.465429687500002 },
        { lat: 68.72460937499997, lng: 21.42236328125003 },
        { lat: 68.787451171875, lng: 21.25976562500003 },
        { lat: 68.82880859374998, lng: 21.183398437500017 },
        { lat: 68.90693359375001, lng: 20.91855468750006 },
        { lat: 68.93774414062497, lng: 20.908984375000074 },
        { lat: 68.96748046874998, lng: 20.907031250000014 },
        { lat: 68.97983398437502, lng: 20.895117187500006 },
        { lat: 69.036865234375, lng: 20.622167968750006 },
        { lat: 69.069482421875, lng: 20.675878906250006 },
        { lat: 69.07143554687502, lng: 20.889257812500063 },
        { lat: 69.04174804687503, lng: 21.065722656250017 },
        { lat: 69.05444335937503, lng: 21.10449218750003 },
        { lat: 69.080810546875, lng: 21.12783203125008 },
        { lat: 69.18657226562505, lng: 21.052636718750023 },
        { lat: 69.21411132812496, lng: 21.06611328125001 },
        { lat: 69.24726562499997, lng: 21.14375 },
        { lat: 69.27368164062503, lng: 21.26679687500004 },
        { lat: 69.277490234375, lng: 21.461230468750045 },
        { lat: 69.273583984375, lng: 21.59375 },
        { lat: 69.27070312499995, lng: 21.621777343750068 },
        { lat: 69.15449218749998, lng: 21.81972656250008 },
        { lat: 69.04111328124998, lng: 21.98945312500001 },
        { lat: 68.9927734375, lng: 22.0796875 },
        { lat: 68.855859375, lng: 22.300390625000034 },
        { lat: 68.776611328125, lng: 22.382910156250063 },
        { lat: 68.719873046875, lng: 22.410937500000074 },
        { lat: 68.72021484374997, lng: 22.500683593750068 },
        { lat: 68.69531249999997, lng: 22.811035156250057 },
        { lat: 68.67436523437505, lng: 23.07167968750005 },
        { lat: 68.64257812499997, lng: 23.144335937500017 },
        { lat: 68.64897460937502, lng: 23.324023437500017 },
        { lat: 68.67763671875, lng: 23.4625 },
        { lat: 68.71386718750003, lng: 23.70703125 },
        { lat: 68.75839843750003, lng: 23.772558593750006 },
        { lat: 68.80590820312503, lng: 23.85400390625 },
        { lat: 68.7984375, lng: 23.99736328125007 },
        { lat: 68.760888671875, lng: 24.154101562500017 },
        { lat: 68.71152343749998, lng: 24.33203125000003 },
        { lat: 68.68867187500004, lng: 24.49052734374999 },
        { lat: 68.65283203125001, lng: 24.703222656249974 },
        { lat: 68.60649414062499, lng: 24.802441406250036 },
        { lat: 68.59326171875006, lng: 24.94140625000003 },
        { lat: 68.63959960937498, lng: 25.0869140625 },
        { lat: 68.76528320312502, lng: 25.172851562499996 },
        { lat: 68.82133789062507, lng: 25.249121093750006 },
        { lat: 68.862451171875, lng: 25.357128906250068 },
        { lat: 68.88061523437497, lng: 25.48085937500005 },
        { lat: 68.88715820312498, lng: 25.575292968750006 },
        { lat: 68.91914062500001, lng: 25.646679687499983 },
        { lat: 68.99013671874998, lng: 25.748339843750014 },
        { lat: 69.07612304687501, lng: 25.768164062500063 },
        { lat: 69.23144531250003, lng: 25.748632812500063 },
        { lat: 69.28266601562498, lng: 25.767187500000034 },
        { lat: 69.36650390625002, lng: 25.850195312500063 },
        { lat: 69.58862304687497, lng: 25.961523437500006 },
        { lat: 69.65263671875005, lng: 26.011523437500074 },
        { lat: 69.69155273437497, lng: 26.07246093750004 },
        { lat: 69.71469726562498, lng: 26.15615234375005 },
        { lat: 69.78193359375001, lng: 26.308203125000034 },
        { lat: 69.91503906250003, lng: 26.525390625000057 },
        { lat: 69.92631835937502, lng: 26.584277343750045 },
        { lat: 69.93305664062498, lng: 26.740234375000025 },
        { lat: 69.928125, lng: 26.93427734375004 },
        { lat: 69.90468749999995, lng: 27.108691406250042 },
        { lat: 69.90649414062497, lng: 27.127539062500063 },
        { lat: 69.91870117187497, lng: 27.205664062499977 },
        { lat: 69.96005859375006, lng: 27.34804687500005 },
        { lat: 70.042236328125, lng: 27.591699218750023 },
        { lat: 70.06484375, lng: 27.747851562500042 },
        { lat: 70.06166992187497, lng: 27.889941406250045 },
        { lat: 69.97167968750003, lng: 28.047265625000023 },
      ],
    ],
  },
  {
    code: "FR",
    coordinates: [
      [
        { lat: -21.33935546875003, lng: 55.79736328125003 },
        { lat: -21.369042968750037, lng: 55.65615234375005 },
        { lat: -21.35830078124998, lng: 55.55761718749997 },
        { lat: -21.27363281250004, lng: 55.36269531250005 },
        { lat: -21.21738281250005, lng: 55.31035156250002 },
        { lat: -21.05839843749999, lng: 55.23281250000005 },
        { lat: -21.002441406249957, lng: 55.25 },
        { lat: -20.90410156249999, lng: 55.31132812500007 },
        { lat: -20.86513671875005, lng: 55.45048828125007 },
        { lat: -20.87958984374997, lng: 55.596484375000074 },
        { lat: -20.90625, lng: 55.661914062500074 },
        { lat: -21.021484375000014, lng: 55.739160156249994 },
        { lat: -21.13857421874998, lng: 55.8390625000001 },
        { lat: -21.277832031250014, lng: 55.8224609375001 },
        { lat: -21.33935546875003, lng: 55.79736328125003 },
      ],
      [
        { lat: -12.97675781250004, lng: 45.180273437500006 },
        { lat: -12.98496093750002, lng: 45.11757812500005 },
        { lat: -12.958496093749957, lng: 45.08769531250002 },
        { lat: -12.895605468750034, lng: 45.069433593750006 },
        { lat: -12.835058593750034, lng: 45.08828125000005 },
        { lat: -12.786132812500014, lng: 45.09355468750002 },
        { lat: -12.701269531249963, lng: 45.04257812500006 },
        { lat: -12.653027343749997, lng: 45.092382812500055 },
        { lat: -12.709179687499969, lng: 45.13476562499997 },
        { lat: -12.712988281250034, lng: 45.158789062500006 },
        { lat: -12.752148437500026, lng: 45.22314453124997 },
        { lat: -12.824316406249977, lng: 45.20429687500003 },
        { lat: -12.847949218750003, lng: 45.20859375 },
        { lat: -12.920214843749973, lng: 45.17939453125004 },
        { lat: -12.97675781250004, lng: 45.180273437500006 },
      ],
      [
        { lat: 4.87612304687498, lng: -52.28891601562498 },
        { lat: 4.770898437500037, lng: -52.32460937499996 },
        { lat: 4.862792968750014, lng: -52.21997070312494 },
        { lat: 4.717382812499963, lng: -52.05810546875003 },
        { lat: 4.645996093749985, lng: -52.0123046875 },
        { lat: 4.514404296875, lng: -51.96191406249997 },
        { lat: 4.429882812500011, lng: -51.97934570312495 },
        { lat: 4.386230468749999, lng: -52.00170898437497 },
        { lat: 4.352294921875014, lng: -52.002929687499964 },
        { lat: 4.399072265625051, lng: -51.95478515625001 },
        { lat: 4.436132812500048, lng: -51.92768554687501 },
        { lat: 4.52431640624998, lng: -51.91958007812493 },
        { lat: 4.633740234374983, lng: -51.880273437500016 },
        { lat: 4.635693359375026, lng: -51.82753906250002 },
        { lat: 4.570507812499983, lng: -51.78564453125003 },
        { lat: 4.286816406249997, lng: -51.698632812499966 },
        { lat: 4.228808593750003, lng: -51.66582031249993 },
        { lat: 4.138769531250034, lng: -51.653271484374955 },
        { lat: 4.098486328125006, lng: -51.658105468749966 },
        { lat: 4.061279296874972, lng: -51.65253906249998 },
        { lat: 4.039697265625023, lng: -51.68344726562497 },
        { lat: 3.992675781250028, lng: -51.76708984374997 },
        { lat: 3.929931640625043, lng: -51.80527343750003 },
        { lat: 3.869580078124997, lng: -51.827490234375006 },
        { lat: 3.828564453124997, lng: -51.87949218749994 },
        { lat: 3.776953125000048, lng: -51.92890624999998 },
        { lat: 3.735107421875042, lng: -51.94433593750003 },
        { lat: 3.702001953124963, lng: -51.990625 },
        { lat: 3.646875, lng: -51.99951171874997 },
        { lat: 3.45229492187498, lng: -52.11611328125002 },
        { lat: 3.364697265624997, lng: -52.16259765625 },
        { lat: 3.271679687500054, lng: -52.22944335937501 },
        { lat: 3.237109375000017, lng: -52.27124023437499 },
        { lat: 3.181738281250019, lng: -52.327880859375 },
        { lat: 3.117724609375031, lng: -52.35664062499998 },
        { lat: 3.051562499999974, lng: -52.35664062499998 },
        { lat: 2.972216796874974, lng: -52.39638671875002 },
        { lat: 2.903857421874989, lng: -52.418408203124955 },
        { lat: 2.86416015624998, lng: -52.45585937499996 },
        { lat: 2.647656250000011, lng: -52.55468750000002 },
        { lat: 2.573144531250023, lng: -52.55947265625002 },
        { lat: 2.528906249999977, lng: -52.58300781250003 },
        { lat: 2.425732421875011, lng: -52.653173828125006 },
        { lat: 2.36367187499998, lng: -52.70063476562501 },
        { lat: 2.317187500000017, lng: -52.78339843749998 },
        { lat: 2.266650390625017, lng: -52.87041015624996 },
        { lat: 2.211523437499977, lng: -52.903466796875016 },
        { lat: 2.183544921874969, lng: -52.96484375 },
        { lat: 2.181738281250048, lng: -53.00971679687498 },
        { lat: 2.201708984375031, lng: -53.08227539062503 },
        { lat: 2.211328125000037, lng: -53.18007812499996 },
        { lat: 2.20488281249996, lng: -53.22978515624999 },
        { lat: 2.232275390625034, lng: -53.252197265625 },
        { lat: 2.295214843749974, lng: -53.28549804687495 },
        { lat: 2.339746093749994, lng: -53.33442382812498 },
        { lat: 2.324218750000028, lng: -53.36601562500002 },
        { lat: 2.279443359374966, lng: -53.43183593750001 },
        { lat: 2.253125, lng: -53.50898437500001 },
        { lat: 2.26191406250004, lng: -53.56396484375003 },
        { lat: 2.29291992187504, lng: -53.68369140624998 },
        { lat: 2.308544921875025, lng: -53.734716796875006 },
        { lat: 2.335009765625003, lng: -53.750146484375016 },
        { lat: 2.354833984375048, lng: -53.76777343749998 },
        { lat: 2.345996093750017, lng: -53.79423828124996 },
        { lat: 2.31293945312504, lng: -53.829541015624955 },
        { lat: 2.278271484374997, lng: -53.87661132812494 },
        { lat: 2.232568359375009, lng: -53.94643554687496 },
        { lat: 2.150488281249977, lng: -54.08974609375002 },
        { lat: 2.121044921875026, lng: -54.130078124999976 },
        { lat: 2.137060546875005, lng: -54.16738281249994 },
        { lat: 2.153320312500028, lng: -54.227978515624955 },
        { lat: 2.15424804687504, lng: -54.29306640624998 },
        { lat: 2.207519531250057, lng: -54.43310546875 },
        { lat: 2.245458984374963, lng: -54.51508789062498 },
        { lat: 2.293066406249991, lng: -54.55048828125001 },
        { lat: 2.313769531250031, lng: -54.59194335937502 },
        { lat: 2.326757812500006, lng: -54.61625976562499 },
        { lat: 2.335791015624991, lng: -54.60473632812497 },
        { lat: 2.342578125000031, lng: -54.56840820312502 },
        { lat: 2.343310546875003, lng: -54.53593749999999 },
        { lat: 2.416113281250005, lng: -54.48554687500001 },
        { lat: 2.46152343750002, lng: -54.40200195312496 },
        { lat: 2.713720703124977, lng: -54.25673828125002 },
        { lat: 2.817871093750057, lng: -54.19550781249998 },
        { lat: 2.874853515625034, lng: -54.18808593749998 },
        { lat: 2.993603515624969, lng: -54.17070312499999 },
        { lat: 3.138183593750028, lng: -54.203125 },
        { lat: 3.178759765625031, lng: -54.18803710937499 },
        { lat: 3.353320312499988, lng: -54.063183593749955 },
        { lat: 3.448535156250017, lng: -54.00957031249993 },
        { lat: 3.530517578125028, lng: -54.005957031250006 },
        { lat: 3.589550781249968, lng: -53.990478515624964 },
        { lat: 3.620410156250045, lng: -54.00590820312499 },
        { lat: 3.62939453125, lng: -54.03422851562499 },
        { lat: 3.705957031249966, lng: -54.08198242187495 },
        { lat: 3.769433593750023, lng: -54.11279296875 },
        { lat: 3.834423828125026, lng: -54.197460937499955 },
        { lat: 3.901074218750026, lng: -54.255517578124966 },
        { lat: 4.054101562500023, lng: -54.35073242187499 },
        { lat: 4.140039062500037, lng: -54.342138671875006 },
        { lat: 4.170947265625017, lng: -54.369140625 },
        { lat: 4.202490234374962, lng: -54.398388671874926 },
        { lat: 4.241406249999983, lng: -54.39624023437503 },
        { lat: 4.337646484375057, lng: -54.41601562499997 },
        { lat: 4.428027343749989, lng: -54.44067382812503 },
        { lat: 4.485009765624966, lng: -54.449609374999966 },
        { lat: 4.583007812500043, lng: -54.42607421874998 },
        { lat: 4.691992187500033, lng: -54.44023437500002 },
        { lat: 4.749316406249989, lng: -54.47114257812501 },
        { lat: 4.836523437499991, lng: -54.47968749999998 },
        { lat: 4.914697265625023, lng: -54.47333984375001 },
        { lat: 4.958789062500031, lng: -54.446875 },
        { lat: 5.013476562499989, lng: -54.45219726562496 },
        { lat: 5.18740234374998, lng: -54.331640625 },
        { lat: 5.288232421875009, lng: -54.24018554687495 },
        { lat: 5.358984375000034, lng: -54.155957031250004 },
        { lat: 5.41181640625004, lng: -54.085302734375006 },
        { lat: 5.676025390625043, lng: -53.98959960937495 },
        { lat: 5.768994140624983, lng: -53.91992187499997 },
        { lat: 5.782226562500014, lng: -53.84716796875 },
        { lat: 5.563476562500028, lng: -53.454443359375 },
        { lat: 5.543261718750003, lng: -53.27036132812497 },
        { lat: 5.425048828124986, lng: -52.899316406249966 },
        { lat: 5.273486328125017, lng: -52.76499023437498 },
        { lat: 5.021337890624991, lng: -52.453955078125006 },
        { lat: 4.942187500000031, lng: -52.29052734375003 },
        { lat: 4.87612304687498, lng: -52.28891601562498 },
      ],
      [
        { lat: 14.494482421874991, lng: -60.826269531250006 },
        { lat: 14.437402343750007, lng: -60.83662109374998 },
        { lat: 14.42626953125004, lng: -60.86210937499996 },
        { lat: 14.473779296875037, lng: -60.8994140625 },
        { lat: 14.467089843750017, lng: -61.063720703125 },
        { lat: 14.509570312500045, lng: -61.08886718749997 },
        { lat: 14.529687499999978, lng: -61.09033203125 },
        { lat: 14.601904296875032, lng: -61.01132812499998 },
        { lat: 14.62124023437498, lng: -61.10429687499998 },
        { lat: 14.652392578125017, lng: -61.14111328124995 },
        { lat: 14.804394531249981, lng: -61.219726562499964 },
        { lat: 14.84858398437501, lng: -61.21333007812501 },
        { lat: 14.871923828124977, lng: -61.18081054687493 },
        { lat: 14.875292968750045, lng: -61.127392578124976 },
        { lat: 14.826171874999986, lng: -61.027099609375 },
        { lat: 14.75625, lng: -60.952539062499994 },
        { lat: 14.755175781249989, lng: -60.92714843749996 },
        { lat: 14.735351562500043, lng: -60.91865234375001 },
        { lat: 14.686181640624966, lng: -60.93369140624997 },
        { lat: 14.644531250000014, lng: -60.88916015624994 },
        { lat: 14.613720703125038, lng: -60.86997070312494 },
        { lat: 14.494482421874991, lng: -60.826269531250006 },
      ],
      [
        { lat: 15.889941406250072, lng: -61.23046875000002 },
        { lat: 15.88603515624999, lng: -61.28623046875003 },
        { lat: 15.894677734374966, lng: -61.310742187499955 },
        { lat: 15.954882812500076, lng: -61.31840820312502 },
        { lat: 15.996240234374964, lng: -61.27529296875002 },
        { lat: 16.006298828124983, lng: -61.25 },
        { lat: 15.95991210937504, lng: -61.21235351562498 },
        { lat: 15.92124023437506, lng: -61.20341796874993 },
        { lat: 15.889941406250072, lng: -61.23046875000002 },
      ],
      [
        { lat: 16.006933593750006, lng: -61.58955078125001 },
        { lat: 15.962060546875023, lng: -61.67045898437497 },
        { lat: 15.975927734375006, lng: -61.71025390624998 },
        { lat: 16.062060546875045, lng: -61.75942382812496 },
        { lat: 16.300976562499955, lng: -61.79409179687502 },
        { lat: 16.340478515625023, lng: -61.76713867187493 },
        { lat: 16.355273437500017, lng: -61.748046874999964 },
        { lat: 16.32597656249999, lng: -61.64150390625002 },
        { lat: 16.292187499999955, lng: -61.597021484375006 },
        { lat: 16.270898437499966, lng: -61.55234375 },
        { lat: 16.227148437500034, lng: -61.57504882812498 },
        { lat: 16.047753906249994, lng: -61.563867187499994 },
        { lat: 16.006933593750006, lng: -61.58955078125001 },
      ],
      [
        { lat: 16.23041992187498, lng: -61.3271484375 },
        { lat: 16.219287109375017, lng: -61.44482421875 },
        { lat: 16.22802734375003, lng: -61.522167968749955 },
        { lat: 16.299609375000045, lng: -61.53999023437492 },
        { lat: 16.36020507812503, lng: -61.500585937500006 },
        { lat: 16.43378906250001, lng: -61.528906249999984 },
        { lat: 16.477685546874994, lng: -61.510644531249994 },
        { lat: 16.506640625000045, lng: -61.471191406249936 },
        { lat: 16.468310546875045, lng: -61.40644531250001 },
        { lat: 16.413427734375063, lng: -61.39614257812494 },
        { lat: 16.363183593750023, lng: -61.35546875 },
        { lat: 16.25610351562497, lng: -61.17260742187497 },
        { lat: 16.23041992187498, lng: -61.3271484375 },
      ],
      [
        { lat: 42.80541992187503, lng: 9.480371093750023 },
        { lat: 42.65859374999996, lng: 9.454199218750034 },
        { lat: 42.615576171875006, lng: 9.473242187500006 },
        { lat: 42.585595703125016, lng: 9.509375 },
        { lat: 42.552636718749966, lng: 9.526171875000045 },
        { lat: 42.16093750000002, lng: 9.556445312500074 },
        { lat: 42.12973632812506, lng: 9.550683593750051 },
        { lat: 41.97241210937497, lng: 9.428417968750011 },
        { lat: 41.92622070312498, lng: 9.40087890625 },
        { lat: 41.73120117187502, lng: 9.394824218750017 },
        { lat: 41.678808593750034, lng: 9.374218750000068 },
        { lat: 41.62714843749998, lng: 9.330859375000045 },
        { lat: 41.460058593750034, lng: 9.253417968750057 },
        { lat: 41.38491210937502, lng: 9.186132812500032 },
        { lat: 41.47656250000003, lng: 9.003027343750034 },
        { lat: 41.51616210937502, lng: 8.895019531250057 },
        { lat: 41.55888671875001, lng: 8.842089843750017 },
        { lat: 41.58837890624999, lng: 8.80751953125008 },
        { lat: 41.627685546875, lng: 8.82978515625001 },
        { lat: 41.66855468749997, lng: 8.879003906250006 },
        { lat: 41.70068359375003, lng: 8.886816406249977 },
        { lat: 41.73710937499999, lng: 8.770996093750028 },
        { lat: 41.76142578124998, lng: 8.71796875000004 },
        { lat: 41.804003906250045, lng: 8.718652343750023 },
        { lat: 41.87041015624999, lng: 8.75869140625008 },
        { lat: 41.925146484375034, lng: 8.740429687500011 },
        { lat: 41.92236328124999, lng: 8.673632812500074 },
        { lat: 41.93071289062502, lng: 8.621875 },
        { lat: 41.959130859375016, lng: 8.615136718750051 },
        { lat: 41.995556640624976, lng: 8.653417968750034 },
        { lat: 42.043115234374994, lng: 8.702539062500023 },
        { lat: 42.09560546875002, lng: 8.700976562500045 },
        { lat: 42.11821289062502, lng: 8.641601562500028 },
        { lat: 42.160839843749976, lng: 8.58779296875008 },
        { lat: 42.21879882812499, lng: 8.566210937500045 },
        { lat: 42.258447265624994, lng: 8.60791015625 },
        { lat: 42.284033203125034, lng: 8.675488281250011 },
        { lat: 42.343408203124966, lng: 8.625878906250023 },
        { lat: 42.34472656249997, lng: 8.592382812500034 },
        { lat: 42.35771484374996, lng: 8.565625 },
        { lat: 42.38530273437498, lng: 8.5875 },
        { lat: 42.426562500000045, lng: 8.64003906250008 },
        { lat: 42.54975585937501, lng: 8.71308593750004 },
        { lat: 42.60791015625003, lng: 8.81484375000008 },
        { lat: 42.64531250000002, lng: 8.994921875000074 },
        { lat: 42.66166992187499, lng: 9.04365234375004 },
        { lat: 42.704980468749994, lng: 9.088378906250028 },
        { lat: 42.73291015625, lng: 9.137890625000068 },
        { lat: 42.729199218749955, lng: 9.198046875000074 },
        { lat: 42.71245117187502, lng: 9.253515625 },
        { lat: 42.69462890625002, lng: 9.287695312500034 },
        { lat: 42.71318359374999, lng: 9.313378906250023 },
        { lat: 42.76689453125002, lng: 9.338378906250055 },
        { lat: 42.814062500000034, lng: 9.323046875000045 },
        { lat: 42.94379882812498, lng: 9.330957031250051 },
        { lat: 43.01738281249996, lng: 9.36318359375005 },
        { lat: 43.021484375, lng: 9.415234374999983 },
        { lat: 42.98100585937502, lng: 9.463281250000023 },
        { lat: 42.94521484375002, lng: 9.460839843750051 },
        { lat: 42.860498046874994, lng: 9.478613281250034 },
        { lat: 42.80541992187503, lng: 9.480371093750023 },
      ],
      [
        { lat: 45.904052734375, lng: -1.17832031249992 },
        { lat: 45.81660156250004, lng: -1.213574218750011 },
        { lat: 45.897119140624994, lng: -1.2802734375 },
        { lat: 45.967675781249994, lng: -1.368701171874989 },
        { lat: 46.032958984374964, lng: -1.388867187499926 },
        { lat: 46.050390625000055, lng: -1.388671874999972 },
        { lat: 46.00268554687503, lng: -1.285058593749994 },
        { lat: 45.904052734375, lng: -1.17832031249992 },
      ],
      [
        { lat: 50.750634765624994, lng: 2.759375 },
        { lat: 50.71176757812498, lng: 2.839746093750023 },
        { lat: 50.716015624999955, lng: 2.862402343750034 },
        { lat: 50.72705078124997, lng: 2.921972656250006 },
        { lat: 50.76689453125001, lng: 3.022851562500023 },
        { lat: 50.77944335937499, lng: 3.106835937500079 },
        { lat: 50.748925781249994, lng: 3.154882812500006 },
        { lat: 50.73168945312502, lng: 3.182031250000051 },
        { lat: 50.66293945312498, lng: 3.234960937499977 },
        { lat: 50.591162109375006, lng: 3.249804687500074 },
        { lat: 50.53154296875002, lng: 3.273339843750079 },
        { lat: 50.50737304687498, lng: 3.316210937500017 },
        { lat: 50.49946289062498, lng: 3.47695312500008 },
        { lat: 50.47734374999999, lng: 3.595410156250068 },
        { lat: 50.45732421875002, lng: 3.626757812500045 },
        { lat: 50.324804687500006, lng: 3.667285156250045 },
        { lat: 50.306054687500016, lng: 3.689355468750022 },
        { lat: 50.321679687499994, lng: 3.718847656250063 },
        { lat: 50.343505859375, lng: 3.748046875000056 },
        { lat: 50.34697265624999, lng: 3.788574218750057 },
        { lat: 50.338574218749976, lng: 3.858105468750011 },
        { lat: 50.33593749999997, lng: 3.949707031250028 },
        { lat: 50.32133789062502, lng: 4.044140624999983 },
        { lat: 50.24648437500005, lng: 4.174609375000017 },
        { lat: 50.22177734374998, lng: 4.169628906250067 },
        { lat: 50.17841796875004, lng: 4.144140625000034 },
        { lat: 50.14379882812499, lng: 4.13525390625 },
        { lat: 50.1298828125, lng: 4.157714843750028 },
        { lat: 50.09414062499999, lng: 4.192187500000045 },
        { lat: 50.052832031250034, lng: 4.183886718750045 },
        { lat: 50.02387695312498, lng: 4.150292968750023 },
        { lat: 50, lng: 4.136816406250034 },
        { lat: 49.984472656250034, lng: 4.137011718750074 },
        { lat: 49.971582031249994, lng: 4.149316406250023 },
        { lat: 49.96025390624999, lng: 4.176074218750045 },
        { lat: 49.944970703124994, lng: 4.36875 },
        { lat: 49.96025390624999, lng: 4.545019531250063 },
        { lat: 50.00244140624997, lng: 4.65615234375005 },
        { lat: 50.046875, lng: 4.675097656250017 },
        { lat: 50.097070312499966, lng: 4.706640625000034 },
        { lat: 50.1390625, lng: 4.772851562500023 },
        { lat: 50.15317382812503, lng: 4.818652343750045 },
        { lat: 50.135888671874994, lng: 4.86054687500004 },
        { lat: 49.959570312500034, lng: 4.790039062499972 },
        { lat: 49.914501953125004, lng: 4.841503906250068 },
        { lat: 49.84711914062504, lng: 4.849121093750028 },
        { lat: 49.78813476562502, lng: 4.867578125000051 },
        { lat: 49.789257812499976, lng: 4.930566406250023 },
        { lat: 49.77836914062498, lng: 5.006933593750034 },
        { lat: 49.756542968749976, lng: 5.061035156250028 },
        { lat: 49.72148437500001, lng: 5.124121093750006 },
        { lat: 49.68925781250002, lng: 5.215039062500068 },
        { lat: 49.67792968750003, lng: 5.27880859375 },
        { lat: 49.650976562500034, lng: 5.301953125000011 },
        { lat: 49.61982421875001, lng: 5.353515625000028 },
        { lat: 49.55449218750001, lng: 5.434667968750034 },
        { lat: 49.51088867187502, lng: 5.507324218749999 },
        { lat: 49.51103515624996, lng: 5.542382812500051 },
        { lat: 49.528222656249994, lng: 5.610058593750068 },
        { lat: 49.53920898437502, lng: 5.710449218749999 },
        { lat: 49.53828125000001, lng: 5.789746093749983 },
        { lat: 49.50507812499998, lng: 5.82343750000001 },
        { lat: 49.489746093749964, lng: 5.9013671875 },
        { lat: 49.47753906249997, lng: 5.928906250000011 },
        { lat: 49.45463867187502, lng: 5.959472656250028 },
        { lat: 49.44545898437502, lng: 6.01142578125004 },
        { lat: 49.45463867187502, lng: 6.074121093750023 },
        { lat: 49.485205078125034, lng: 6.119921875000016 },
        { lat: 49.498925781249966, lng: 6.181054687500051 },
        { lat: 49.49433593750001, lng: 6.242187500000057 },
        { lat: 49.47753906249997, lng: 6.277343750000028 },
        { lat: 49.45273437499997, lng: 6.344335937500005 },
        { lat: 49.45815429687502, lng: 6.38222656250008 },
        { lat: 49.44287109375002, lng: 6.458105468750006 },
        { lat: 49.394677734374966, lng: 6.534277343750063 },
        { lat: 49.34619140625003, lng: 6.566308593750023 },
        { lat: 49.31967773437506, lng: 6.574707031250028 },
        { lat: 49.290869140625034, lng: 6.607617187499983 },
        { lat: 49.16059570312498, lng: 6.735449218750006 },
        { lat: 49.154150390625, lng: 6.77626953125008 },
        { lat: 49.173925781250034, lng: 6.820703125000051 },
        { lat: 49.20195312499996, lng: 6.84951171875008 },
        { lat: 49.20751953125003, lng: 6.891210937500034 },
        { lat: 49.19462890624999, lng: 6.958300781250017 },
        { lat: 49.17988281249998, lng: 7.001464843750028 },
        { lat: 49.123437500000044, lng: 7.022167968750068 },
        { lat: 49.112695312499994, lng: 7.03671875 },
        { lat: 49.12485351562498, lng: 7.065722656250074 },
        { lat: 49.12753906249997, lng: 7.117382812500011 },
        { lat: 49.113623046875, lng: 7.19990234375004 },
        { lat: 49.12954101562505, lng: 7.313378906250079 },
        { lat: 49.15307617187503, lng: 7.404199218749994 },
        { lat: 49.15219726562503, lng: 7.450585937500051 },
        { lat: 49.086376953124955, lng: 7.525488281250033 },
        { lat: 49.061767578125, lng: 7.610937500000033 },
        { lat: 49.04189453125005, lng: 7.799218750000023 },
        { lat: 49.01093750000003, lng: 8.001269531250045 },
        { lat: 48.98588867187499, lng: 8.080664062500063 },
        { lat: 48.97358398437498, lng: 8.134863281250006 },
        { lat: 48.88642578124998, lng: 8.140332031250038 },
        { lat: 48.87329101562497, lng: 8.124023437500028 },
        { lat: 48.69853515624999, lng: 7.92275390625005 },
        { lat: 48.636035156250045, lng: 7.837988281250006 },
        { lat: 48.54682617187498, lng: 7.794824218749994 },
        { lat: 48.410009765625, lng: 7.765136718749999 },
        { lat: 48.280029296875, lng: 7.705664062500063 },
        { lat: 48.15678710937502, lng: 7.616601562500023 },
        { lat: 48.064306640625006, lng: 7.584179687499983 },
        { lat: 48.002587890625044, lng: 7.608496093750063 },
        { lat: 47.90566406250002, lng: 7.593261718750056 },
        { lat: 47.77363281250004, lng: 7.538574218750028 },
        { lat: 47.67387695312496, lng: 7.529394531250034 },
        { lat: 47.606542968750006, lng: 7.565429687500001 },
        { lat: 47.59272460937504, lng: 7.615625 },
        { lat: 47.54736328125003, lng: 7.494921875000016 },
        { lat: 47.507666015625034, lng: 7.467382812500006 },
        { lat: 47.45517578124998, lng: 7.420019531250034 },
        { lat: 47.43310546875002, lng: 7.343164062499995 },
        { lat: 47.42578125000003, lng: 7.265722656250033 },
        { lat: 47.432714843750034, lng: 7.203125 },
        { lat: 47.453710937500034, lng: 7.167480468749999 },
        { lat: 47.473242187500034, lng: 7.169238281250018 },
        { lat: 47.48984375000003, lng: 7.136035156249989 },
        { lat: 47.489355468750034, lng: 7.05341796875004 },
        { lat: 47.45322265625003, lng: 6.968359375000033 },
        { lat: 47.394238281250004, lng: 6.900390625000028 },
        { lat: 47.36123046875002, lng: 6.921484374999977 },
        { lat: 47.35253906250003, lng: 6.98408203125004 },
        { lat: 47.339453125000034, lng: 7.000585937500034 },
        { lat: 47.32250976562506, lng: 7.000585937500034 },
        { lat: 47.30205078124996, lng: 6.978515625000057 },
        { lat: 47.26718750000006, lng: 6.95205078125008 },
        { lat: 47.163183593750006, lng: 6.820703125000051 },
        { lat: 47.05825195312505, lng: 6.688085937500034 },
        { lat: 47.02651367187496, lng: 6.666894531250079 },
        { lat: 47.00434570312498, lng: 6.624804687500017 },
        { lat: 46.94833984375003, lng: 6.45625 },
        { lat: 46.92587890624998, lng: 6.438574218750006 },
        { lat: 46.832275390625, lng: 6.429003906250016 },
        { lat: 46.75541992187499, lng: 6.41015625 },
        { lat: 46.683056640624976, lng: 6.285156250000028 },
        { lat: 46.61103515624995, lng: 6.160742187499977 },
        { lat: 46.56699218750006, lng: 6.129687500000045 },
        { lat: 46.516064453124976, lng: 6.107031250000063 },
        { lat: 46.45854492187499, lng: 6.06796875 },
        { lat: 46.42817382812501, lng: 6.06025390625004 },
        { lat: 46.378613281249955, lng: 6.123242187500068 },
        { lat: 46.33764648437506, lng: 6.115917968750011 },
        { lat: 46.27939453125, lng: 6.095898437500011 },
        { lat: 46.23808593750002, lng: 6.0361328125 },
        { lat: 46.214697265625034, lng: 5.970019531250045 },
        { lat: 46.151220703125006, lng: 5.971484375000074 },
        { lat: 46.14233398437505, lng: 6.006640625000045 },
        { lat: 46.14702148437501, lng: 6.086621093750068 },
        { lat: 46.19306640624998, lng: 6.199414062500039 },
        { lat: 46.25224609374996, lng: 6.272949218750028 },
        { lat: 46.30844726562506, lng: 6.229589843750063 },
        { lat: 46.31943359374997, lng: 6.224218750000033 },
        { lat: 46.3326171875, lng: 6.234667968750045 },
        { lat: 46.393701171875016, lng: 6.321875 },
        { lat: 46.43051757812506, lng: 6.428906250000011 },
        { lat: 46.437353515625034, lng: 6.578222656250034 },
        { lat: 46.41577148437497, lng: 6.758105468750017 },
        { lat: 46.40664062499999, lng: 6.77607421875004 },
        { lat: 46.36918945312498, lng: 6.767382812500045 },
        { lat: 46.31396484375003, lng: 6.7841796875 },
        { lat: 46.27519531250002, lng: 6.816796875000051 },
        { lat: 46.16513671874998, lng: 6.772070312500006 },
        { lat: 46.13066406249998, lng: 6.805664062500028 },
        { lat: 46.08940429687502, lng: 6.858007812500034 },
        { lat: 46.05175781249997, lng: 6.897265625000016 },
        { lat: 46.01713867187504, lng: 6.953710937500063 },
        { lat: 45.95883789062506, lng: 7.00390625 },
        { lat: 45.92578124999997, lng: 7.021093750000034 },
        { lat: 45.86835937500001, lng: 6.940820312500023 },
        { lat: 45.81455078125006, lng: 6.804492187500045 },
        { lat: 45.78007812499996, lng: 6.789160156250034 },
        { lat: 45.740869140624966, lng: 6.790917968750023 },
        { lat: 45.71000976562499, lng: 6.80625 },
        { lat: 45.67036132812498, lng: 6.881445312500006 },
        { lat: 45.58056640625, lng: 6.962402343750057 },
        { lat: 45.50048828125003, lng: 7.013671875000028 },
        { lat: 45.423681640625006, lng: 7.126074218750006 },
        { lat: 45.40092773437498, lng: 7.153417968749977 },
        { lat: 45.381738281249994, lng: 7.14638671875005 },
        { lat: 45.349023437499994, lng: 7.116796874999977 },
        { lat: 45.23994140624998, lng: 7.078320312500039 },
        { lat: 45.222607421874976, lng: 7.03242187500004 },
        { lat: 45.21557617187497, lng: 6.98125 },
        { lat: 45.135644531250044, lng: 6.842285156250028 },
        { lat: 45.14531249999995, lng: 6.780371093750006 },
        { lat: 45.14428710937503, lng: 6.692285156250022 },
        { lat: 45.11796874999999, lng: 6.627734375000017 },
        { lat: 45.06816406249995, lng: 6.634765625000028 },
        { lat: 45.02260742187502, lng: 6.69140625 },
        { lat: 44.972998046875034, lng: 6.724707031250034 },
        { lat: 44.92138671875, lng: 6.738183593750023 },
        { lat: 44.883154296875034, lng: 6.801074218750045 },
        { lat: 44.86030273437498, lng: 6.889355468750011 },
        { lat: 44.858740234375034, lng: 6.93984375000008 },
        { lat: 44.84501953124999, lng: 6.972851562500068 },
        { lat: 44.82729492187502, lng: 6.99267578125 },
        { lat: 44.716699218750044, lng: 7.030664062500023 },
        { lat: 44.68896484374999, lng: 7.007910156250006 },
        { lat: 44.677148437499966, lng: 6.96035156250008 },
        { lat: 44.631640625000045, lng: 6.931933593750074 },
        { lat: 44.564550781250034, lng: 6.875195312500068 },
        { lat: 44.51069335937498, lng: 6.842968750000068 },
        { lat: 44.46328125000002, lng: 6.87861328125004 },
        { lat: 44.42817382812498, lng: 6.893847656250045 },
        { lat: 44.39204101562498, lng: 6.874804687500074 },
        { lat: 44.33574218749996, lng: 6.900195312499989 },
        { lat: 44.280029296875, lng: 6.967285156249999 },
        { lat: 44.20170898437502, lng: 7.149414062500056 },
        { lat: 44.13798828125001, lng: 7.318554687500068 },
        { lat: 44.12739257812498, lng: 7.370898437500074 },
        { lat: 44.16835937499996, lng: 7.599414062500074 },
        { lat: 44.16484375, lng: 7.637207031250056 },
        { lat: 44.11601562499996, lng: 7.665039062500028 },
        { lat: 44.08315429687502, lng: 7.677148437500023 },
        { lat: 44.03364257812498, lng: 7.651464843750034 },
        { lat: 43.96542968750003, lng: 7.589648437500045 },
        { lat: 43.91108398437495, lng: 7.522656250000068 },
        { lat: 43.864892578124966, lng: 7.482031250000062 },
        { lat: 43.82294921875004, lng: 7.490527343750017 },
        { lat: 43.76713867187504, lng: 7.4931640625 },
        { lat: 43.75043945312501, lng: 7.43867187500001 },
        { lat: 43.76147460937503, lng: 7.436914062500023 },
        { lat: 43.770898437499994, lng: 7.414453125000051 },
        { lat: 43.76533203125001, lng: 7.395019531249999 },
        { lat: 43.753222656250045, lng: 7.380078125000067 },
        { lat: 43.73173828125001, lng: 7.377734375000045 },
        { lat: 43.696093750000045, lng: 7.261523437500074 },
        { lat: 43.65913085937498, lng: 7.181445312500017 },
        { lat: 43.438330078125006, lng: 6.864746093750057 },
        { lat: 43.37358398437496, lng: 6.716601562500074 },
        { lat: 43.3345703125, lng: 6.68740234375008 },
        { lat: 43.261669921875004, lng: 6.657226562500057 },
        { lat: 43.19907226562503, lng: 6.570214843750023 },
        { lat: 43.169287109375006, lng: 6.494042968750023 },
        { lat: 43.13872070312499, lng: 6.305371093750067 },
        { lat: 43.07236328124998, lng: 6.115917968750011 },
        { lat: 43.10097656250002, lng: 6.030566406250017 },
        { lat: 43.09790039062503, lng: 5.809472656250023 },
        { lat: 43.17783203125006, lng: 5.671582031250068 },
        { lat: 43.22851562499999, lng: 5.406542968750073 },
        { lat: 43.34492187499998, lng: 5.32021484375008 },
        { lat: 43.35249023437504, lng: 5.199511718750017 },
        { lat: 43.348974609375034, lng: 5.120410156250045 },
        { lat: 43.366601562499966, lng: 5.073144531250023 },
        { lat: 43.40629882812499, lng: 5.060839843749989 },
        { lat: 43.44453125000004, lng: 5.05976562500004 },
        { lat: 43.426953125, lng: 4.975976562500023 },
        { lat: 43.426953125, lng: 4.911914062500045 },
        { lat: 43.41162109375, lng: 4.873730468750067 },
        { lat: 43.39394531250002, lng: 4.843554687500045 },
        { lat: 43.40522460937501, lng: 4.807910156250074 },
        { lat: 43.40141601562496, lng: 4.787207031250034 },
        { lat: 43.37890625, lng: 4.789062500000056 },
        { lat: 43.37329101562499, lng: 4.712109375000011 },
        { lat: 43.387109374999966, lng: 4.628710937500074 },
        { lat: 43.447216796874955, lng: 4.409765625000063 },
        { lat: 43.45639648437506, lng: 4.37617187500004 },
        { lat: 43.479638671874994, lng: 4.22421875 },
        { lat: 43.50366210937499, lng: 4.162792968750011 },
        { lat: 43.56303710937502, lng: 4.113085937500017 },
        { lat: 43.581835937500045, lng: 4.07509765625008 },
        { lat: 43.59306640625002, lng: 4.052636718750023 },
        { lat: 43.56308593750003, lng: 3.910839843750011 },
        { lat: 43.51635742187503, lng: 3.861621093750017 },
        { lat: 43.461621093749955, lng: 3.784765625 },
        { lat: 43.193212890625006, lng: 3.258886718750063 },
        { lat: 43.08076171875001, lng: 3.162890625000045 },
        { lat: 42.915136718750006, lng: 3.051757812500057 },
        { lat: 42.837890625, lng: 3.043066406250063 },
        { lat: 42.59086914062501, lng: 3.090917968750034 },
        { lat: 42.461181640625, lng: 3.197851562500063 },
        { lat: 42.43115234374999, lng: 3.21142578125 },
        { lat: 42.43100585937506, lng: 3.152148437500074 },
        { lat: 42.44721679687498, lng: 3.052636718750051 },
        { lat: 42.46723632812498, lng: 2.970019531250017 },
        { lat: 42.4560546875, lng: 2.891406250000074 },
        { lat: 42.42924804687496, lng: 2.815625 },
        { lat: 42.41303710937504, lng: 2.749414062500022 },
        { lat: 42.40849609374999, lng: 2.701855468750011 },
        { lat: 42.393017578124955, lng: 2.670019531250006 },
        { lat: 42.36210937499996, lng: 2.65478515625 },
        { lat: 42.340478515624994, lng: 2.651660156250074 },
        { lat: 42.345800781250006, lng: 2.56796875 },
        { lat: 42.39028320312502, lng: 2.374414062500079 },
        { lat: 42.42094726562496, lng: 2.200390625000068 },
        { lat: 42.386083984375055, lng: 2.098339843750068 },
        { lat: 42.353515625, lng: 2.032714843750028 },
        { lat: 42.358496093750034, lng: 1.986523437500011 },
        { lat: 42.39277343749998, lng: 1.951464843750074 },
        { lat: 42.42631835937499, lng: 1.927929687500068 },
        { lat: 42.457080078125045, lng: 1.859765625000051 },
        { lat: 42.503320312500044, lng: 1.7060546875 },
        { lat: 42.52563476562497, lng: 1.713964843750006 },
        { lat: 42.556738281250006, lng: 1.740234375000028 },
        { lat: 42.575927734375, lng: 1.73945312500004 },
        { lat: 42.604443359374955, lng: 1.709863281250051 },
        { lat: 42.63500976562506, lng: 1.568164062500045 },
        { lat: 42.64272460937502, lng: 1.501367187500023 },
        { lat: 42.621679687500006, lng: 1.45888671875008 },
        { lat: 42.59589843749998, lng: 1.428320312499977 },
        { lat: 42.69067382812503, lng: 1.349414062500074 },
        { lat: 42.70996093750006, lng: 1.293261718750017 },
        { lat: 42.71313476562497, lng: 1.208300781250017 },
        { lat: 42.742041015625006, lng: 1.111132812500017 },
        { lat: 42.778955078124966, lng: 1.010058593750045 },
        { lat: 42.83803710937502, lng: 0.764453125000017 },
        { lat: 42.845117187500044, lng: 0.696875 },
        { lat: 42.83574218749999, lng: 0.669824218749994 },
        { lat: 42.800439453124994, lng: 0.651757812500051 },
        { lat: 42.70063476562501, lng: 0.641992187500023 },
        { lat: 42.689599609374994, lng: 0.631640625000045 },
        { lat: 42.68627929687503, lng: 0.517675781250006 },
        { lat: 42.70014648437501, lng: 0.377246093750074 },
        { lat: 42.69326171875002, lng: 0.312890625000023 },
        { lat: 42.692919921875045, lng: 0.255468750000063 },
        { lat: 42.719335937500006, lng: 0.20136718750004 },
        { lat: 42.689111328124966, lng: -0.041162109374994 },
        { lat: 42.70385742187505, lng: -0.081494140624926 },
        { lat: 42.74892578124999, lng: -0.140039062499966 },
        { lat: 42.78530273437502, lng: -0.205322265624943 },
        { lat: 42.80395507812499, lng: -0.256054687499983 },
        { lat: 42.82534179687502, lng: -0.29931640625 },
        { lat: 42.82880859375001, lng: -0.338574218750011 },
        { lat: 42.80810546875006, lng: -0.398437499999943 },
        { lat: 42.79931640625003, lng: -0.481152343750011 },
        { lat: 42.80200195312506, lng: -0.549804687499943 },
        { lat: 42.798974609374966, lng: -0.586425781249943 },
        { lat: 42.909521484375034, lng: -0.740185546874926 },
        { lat: 42.93979492187506, lng: -0.762646484374983 },
        { lat: 42.94819335937498, lng: -0.839208984374949 },
        { lat: 42.94951171874999, lng: -0.933837890624943 },
        { lat: 43.02114257812502, lng: -1.175439453124966 },
        { lat: 43.05961914062496, lng: -1.285449218749989 },
        { lat: 43.08247070312498, lng: -1.301562499999988 },
        { lat: 43.10097656250002, lng: -1.300048828124943 },
        { lat: 43.09697265625002, lng: -1.318847656249943 },
        { lat: 43.06425781250002, lng: -1.352734374999926 },
        { lat: 43.03759765625, lng: -1.370507812499994 },
        { lat: 43.032617187499966, lng: -1.39404296875 },
        { lat: 43.03676757812502, lng: -1.42875976562496 },
        { lat: 43.05175781250006, lng: -1.460839843749937 },
        { lat: 43.071142578125006, lng: -1.480468750000028 },
        { lat: 43.10498046875006, lng: -1.459423828124983 },
        { lat: 43.149121093749976, lng: -1.422607421874943 },
        { lat: 43.197119140625006, lng: -1.407324218749949 },
        { lat: 43.240087890625034, lng: -1.410693359374932 },
        { lat: 43.26767578124998, lng: -1.471728515624932 },
        { lat: 43.27919921875002, lng: -1.561474609375011 },
        { lat: 43.28247070312497, lng: -1.627148437499983 },
        { lat: 43.30703124999999, lng: -1.712841796874926 },
        { lat: 43.32470703125006, lng: -1.753271484375005 },
        { lat: 43.37255859375003, lng: -1.792724609374943 },
        { lat: 43.407324218750006, lng: -1.794042968749949 },
        { lat: 43.43803710937496, lng: -1.631445312499949 },
        { lat: 43.56376953124999, lng: -1.484863281249943 },
        { lat: 44.02021484374998, lng: -1.345996093749989 },
        { lat: 44.55986328124999, lng: -1.245507812499937 },
        { lat: 44.661816406249955, lng: -1.170800781249994 },
        { lat: 44.68984375, lng: -1.07695312499996 },
        { lat: 44.764013671875, lng: -1.152880859374989 },
        { lat: 44.726464843749994, lng: -1.200390624999983 },
        { lat: 44.686621093750034, lng: -1.220312499999949 },
        { lat: 44.66669921874998, lng: -1.245214843749977 },
        { lat: 45.16147460937506, lng: -1.189062499999977 },
        { lat: 45.342626953125006, lng: -1.149072265624994 },
        { lat: 45.532421874999955, lng: -1.081005859374983 },
        { lat: 45.45708007812499, lng: -0.941748046874949 },
        { lat: 45.380664062500045, lng: -0.826318359374966 },
        { lat: 45.31435546875002, lng: -0.766650390624989 },
        { lat: 45.09345703124998, lng: -0.691113281249954 },
        { lat: 45.04711914062503, lng: -0.633984374999955 },
        { lat: 45.00058593750006, lng: -0.548486328124966 },
        { lat: 45.051367187500006, lng: -0.582275390625 },
        { lat: 45.090185546875006, lng: -0.64111328125 },
        { lat: 45.384619140625034, lng: -0.733105468749983 },
        { lat: 45.46801757812497, lng: -0.790771484375028 },
        { lat: 45.53818359374998, lng: -0.88066406249996 },
        { lat: 45.685937499999966, lng: -1.169970703124989 },
        { lat: 45.714453125, lng: -1.195996093749983 },
        { lat: 45.770898437500044, lng: -1.209960937499972 },
        { lat: 45.76850585937501, lng: -1.114355468749949 },
        { lat: 45.741064453125, lng: -1.03173828125 },
        { lat: 45.772656249999955, lng: -1.041503906249943 },
        { lat: 45.80566406250002, lng: -1.066015624999949 },
        { lat: 45.92534179687499, lng: -1.104394531249966 },
        { lat: 46.204833984375, lng: -1.136376953124994 },
        { lat: 46.25268554687497, lng: -1.132031250000011 },
        { lat: 46.311376953125034, lng: -1.14628906249996 },
        { lat: 46.324511718750045, lng: -1.238818359374989 },
        { lat: 46.326904296875, lng: -1.31279296874996 },
        { lat: 46.35009765625, lng: -1.392480468749937 },
        { lat: 46.51484375, lng: -1.786523437499937 },
        { lat: 46.684814453125, lng: -1.92143554687496 },
        { lat: 46.81030273437497, lng: -2.059375 },
        { lat: 46.86503906250002, lng: -2.092480468750011 },
        { lat: 46.92050781250003, lng: -2.090283203125011 },
        { lat: 47.03764648437502, lng: -2.01889648437492 },
        { lat: 47.11162109374999, lng: -2.081933593749994 },
        { lat: 47.12631835937506, lng: -2.143554687500028 },
        { lat: 47.16293945312506, lng: -2.197070312499989 },
        { lat: 47.22392578125004, lng: -2.148583984374966 },
        { lat: 47.262939453125, lng: -2.108300781249937 },
        { lat: 47.27358398437502, lng: -2.027587890625028 },
        { lat: 47.260644531249966, lng: -1.921728515624949 },
        { lat: 47.22534179687497, lng: -1.8212890625 },
        { lat: 47.21596679687502, lng: -1.742529296874949 },
        { lat: 47.31069335937505, lng: -1.97539062499996 },
        { lat: 47.27875976562501, lng: -2.353027343749972 },
        { lat: 47.29096679687501, lng: -2.434423828124949 },
        { lat: 47.31206054687496, lng: -2.503125 },
        { lat: 47.381591796875, lng: -2.530029296874972 },
        { lat: 47.412939453125006, lng: -2.476318359374943 },
        { lat: 47.470898437499976, lng: -2.427685546874983 },
        { lat: 47.511621093750016, lng: -2.482714843749931 },
        { lat: 47.52705078124998, lng: -2.554052734374977 },
        { lat: 47.52617187499999, lng: -2.665917968749937 },
        { lat: 47.513867187499955, lng: -2.770312499999988 },
        { lat: 47.53725585937502, lng: -2.796777343749966 },
        { lat: 47.60180664062503, lng: -2.733105468749955 },
        { lat: 47.62553710937496, lng: -2.787207031249949 },
        { lat: 47.614453125, lng: -2.859375 },
        { lat: 47.60107421875006, lng: -2.964062499999926 },
        { lat: 47.621337890625, lng: -3.064208984375 },
        { lat: 47.694677734375034, lng: -3.158837890624994 },
        { lat: 47.69414062499999, lng: -3.221582031249994 },
        { lat: 47.68510742187502, lng: -3.264697265624989 },
        { lat: 47.71333007812501, lng: -3.328613281249943 },
        { lat: 47.72041015625001, lng: -3.395898437499966 },
        { lat: 47.71103515624998, lng: -3.443945312500005 },
        { lat: 47.753125, lng: -3.507812499999943 },
        { lat: 47.837548828124994, lng: -3.900927734374931 },
        { lat: 47.847851562499955, lng: -4.070703124999966 },
        { lat: 47.80961914062499, lng: -4.226416015624977 },
        { lat: 47.82290039062502, lng: -4.312109374999949 },
        { lat: 47.87744140625003, lng: -4.375097656249977 },
        { lat: 47.96894531250004, lng: -4.427978515625 },
        { lat: 48.03950195312501, lng: -4.678808593749949 },
        { lat: 48.085791015625034, lng: -4.629199218749959 },
        { lat: 48.096728515625045, lng: -4.512402343749982 },
        { lat: 48.12880859374999, lng: -4.377832031249993 },
        { lat: 48.16997070312504, lng: -4.32944335937492 },
        { lat: 48.217968749999955, lng: -4.434619140624932 },
        { lat: 48.22973632812506, lng: -4.512207031249943 },
        { lat: 48.246972656249994, lng: -4.544335937499994 },
        { lat: 48.2900390625, lng: -4.577148437499943 },
        { lat: 48.309716796874994, lng: -4.530664062499966 },
        { lat: 48.29926757812501, lng: -4.497900390624949 },
        { lat: 48.29306640624998, lng: -4.403320312499972 },
        { lat: 48.303662109375004, lng: -4.241406249999926 },
        { lat: 48.34707031249996, lng: -4.301757812499972 },
        { lat: 48.35673828124998, lng: -4.364404296874937 },
        { lat: 48.367626953124976, lng: -4.39316406249992 },
        { lat: 48.37231445312506, lng: -4.524804687499937 },
        { lat: 48.357519531250055, lng: -4.584716796874972 },
        { lat: 48.363134765625034, lng: -4.719384765624966 },
        { lat: 48.410009765625, lng: -4.748535156249943 },
        { lat: 48.45024414062501, lng: -4.7625 },
        { lat: 48.539892578125006, lng: -4.72075195312496 },
        { lat: 48.619970703125055, lng: -4.531201171874983 },
        { lat: 48.70751953125002, lng: -4.05888671874996 },
        { lat: 48.69472656250002, lng: -3.855664062499954 },
        { lat: 48.71049804687502, lng: -3.714794921874926 },
        { lat: 48.76567382812499, lng: -3.54599609374992 },
        { lat: 48.81293945312501, lng: -3.471484374999931 },
        { lat: 48.84082031250003, lng: -3.231445312499971 },
        { lat: 48.79067382812502, lng: -3.003222656250017 },
        { lat: 48.60107421875003, lng: -2.792871093749966 },
        { lat: 48.53681640624998, lng: -2.692333984374983 },
        { lat: 48.64829101562506, lng: -2.446191406249937 },
        { lat: 48.64501953125, lng: -2.07944335937492 },
        { lat: 48.58208007812499, lng: -2.00371093749996 },
        { lat: 48.635107421875034, lng: -1.973144531249943 },
        { lat: 48.697119140625055, lng: -1.905712890624955 },
        { lat: 48.668847656249966, lng: -1.851953124999937 },
        { lat: 48.63051757812499, lng: -1.824707031249972 },
        { lat: 48.64140624999998, lng: -1.437646484374994 },
        { lat: 48.65258789062503, lng: -1.376464843749972 },
        { lat: 48.69760742187498, lng: -1.480468750000028 },
        { lat: 48.80551757812503, lng: -1.565478515624932 },
        { lat: 49.20239257812505, lng: -1.583105468749977 },
        { lat: 49.31318359374998, lng: -1.690332031249966 },
        { lat: 49.490136718749966, lng: -1.813427734374983 },
        { lat: 49.59511718750002, lng: -1.870068359374983 },
        { lat: 49.63139648437496, lng: -1.87539062499999 },
        { lat: 49.68378906249998, lng: -1.856445312499971 },
        { lat: 49.68095703125001, lng: -1.70512695312496 },
        { lat: 49.66767578124998, lng: -1.588232421874949 },
        { lat: 49.70727539062497, lng: -1.36572265625 },
        { lat: 49.68017578125006, lng: -1.258642578124949 },
        { lat: 49.59824218750006, lng: -1.264941406249989 },
        { lat: 49.49487304687503, lng: -1.232275390625006 },
        { lat: 49.44482421874997, lng: -1.194970703124937 },
        { lat: 49.38789062500001, lng: -1.138525390624977 },
        { lat: 49.393164062500006, lng: -0.959130859374937 },
        { lat: 49.35971679687503, lng: -0.765527343749937 },
        { lat: 49.35454101562496, lng: -0.520898437499937 },
        { lat: 49.29677734374999, lng: -0.163476562499937 },
        { lat: 49.33022460937499, lng: -0.011181640625011 },
        { lat: 49.40151367187502, lng: 0.13613281250008 },
        { lat: 49.448388671874994, lng: 0.41689453125008 },
        { lat: 49.47319335937499, lng: 0.439257812500017 },
        { lat: 49.46328125, lng: 0.277636718750045 },
        { lat: 49.508447265624966, lng: 0.129394531250028 },
        { lat: 49.55751953125002, lng: 0.109375 },
        { lat: 49.60156250000003, lng: 0.1265625 },
        { lat: 49.70302734374999, lng: 0.186718749999983 },
        { lat: 49.862939453124966, lng: 0.6162109375 },
        { lat: 49.91020507812502, lng: 0.924121093750017 },
        { lat: 49.99824218750001, lng: 1.245507812500051 },
        { lat: 50.08852539062502, lng: 1.407226562500028 },
        { lat: 50.20507812500006, lng: 1.514062500000051 },
        { lat: 50.23071289062503, lng: 1.548437500000034 },
        { lat: 50.25219726562506, lng: 1.5927734375 },
        { lat: 50.29394531250003, lng: 1.551562500000045 },
        { lat: 50.73925781249997, lng: 1.579492187500051 },
        { lat: 50.819482421874994, lng: 1.60957031250004 },
        { lat: 50.885009765625, lng: 1.672265625000023 },
        { lat: 50.935693359375016, lng: 1.767675781250034 },
        { lat: 50.990625, lng: 1.9125 },
        { lat: 51.066503906250034, lng: 2.445703125000051 },
        { lat: 51.097119140624955, lng: 2.52490234375 },
        { lat: 51.04951171875004, lng: 2.536035156250051 },
        { lat: 50.98857421874996, lng: 2.574804687500063 },
        { lat: 50.95527343750001, lng: 2.60146484375008 },
        { lat: 50.91176757812505, lng: 2.579296874999983 },
        { lat: 50.87592773437501, lng: 2.596777343750006 },
        { lat: 50.81142578125002, lng: 2.669140625000011 },
        { lat: 50.750634765624994, lng: 2.759375 },
      ],
    ],
  },
  {
    code: "GB",
    coordinates: [
      [
        { lat: 50.69023437500002, lng: -1.065576171874966 },
        { lat: 50.65571289062501, lng: -1.149365234374983 },
        { lat: 50.61523437500003, lng: -1.17583007812496 },
        { lat: 50.59921875000006, lng: -1.196093749999988 },
        { lat: 50.58881835937498, lng: -1.25146484375 },
        { lat: 50.588525390624994, lng: -1.306298828124966 },
        { lat: 50.669775390625034, lng: -1.515332031249926 },
        { lat: 50.666113281250006, lng: -1.563427734374954 },
        { lat: 50.70332031250004, lng: -1.515673828124988 },
        { lat: 50.733544921874966, lng: -1.38583984374992 },
        { lat: 50.77348632812502, lng: -1.31279296874996 },
        { lat: 50.734716796875034, lng: -1.144238281250011 },
        { lat: 50.69023437500002, lng: -1.065576171874966 },
      ],
      [
        { lat: 53.321435546874966, lng: -4.196777343749972 },
        { lat: 53.302832031250006, lng: -4.154882812499977 },
        { lat: 53.30576171874998, lng: -4.04936523437496 },
        { lat: 53.26430664062496, lng: -4.084277343749989 },
        { lat: 53.21806640624995, lng: -4.200390624999926 },
        { lat: 53.17241210937499, lng: -4.27861328124996 },
        { lat: 53.13417968750002, lng: -4.373046875 },
        { lat: 53.17802734374999, lng: -4.418847656250023 },
        { lat: 53.176367187500006, lng: -4.471972656249989 },
        { lat: 53.26044921874998, lng: -4.553222656249943 },
        { lat: 53.386474609375, lng: -4.56787109375 },
        { lat: 53.419287109375006, lng: -4.46171875 },
        { lat: 53.41723632812502, lng: -4.315087890625023 },
        { lat: 53.321435546874966, lng: -4.196777343749972 },
      ],
      [
        { lat: 55.241796875000034, lng: -6.375292968749989 },
        { lat: 55.21684570312502, lng: -6.23422851562492 },
        { lat: 55.217382812500034, lng: -6.129150390625028 },
        { lat: 55.14453125000003, lng: -6.035791015624994 },
        { lat: 55.02968749999999, lng: -5.985742187499937 },
        { lat: 54.91621093749998, lng: -5.869189453124989 },
        { lat: 54.817480468750034, lng: -5.71684570312496 },
        { lat: 54.75708007812497, lng: -5.71074218749996 },
        { lat: 54.72465820312501, lng: -5.765185546874932 },
        { lat: 54.684375, lng: -5.879101562499955 },
        { lat: 54.64130859375001, lng: -5.878613281249955 },
        { lat: 54.66303710937501, lng: -5.803466796874999 },
        { lat: 54.673046874999976, lng: -5.738623046874949 },
        { lat: 54.66342773437498, lng: -5.582519531249943 },
        { lat: 54.61962890625003, lng: -5.52792968749992 },
        { lat: 54.554052734375, lng: -5.490185546874955 },
        { lat: 54.50019531249995, lng: -5.470410156249926 },
        { lat: 54.44165039062503, lng: -5.48388671875 },
        { lat: 54.46020507812497, lng: -5.525878906249943 },
        { lat: 54.512597656249994, lng: -5.568554687499925 },
        { lat: 54.536718750000034, lng: -5.615966796875 },
        { lat: 54.54975585937501, lng: -5.671093749999955 },
        { lat: 54.477880859375034, lng: -5.6460937499999 },
        { lat: 54.381738281249966, lng: -5.655957031249982 },
        { lat: 54.37265625, lng: -5.63188476562496 },
        { lat: 54.370996093750016, lng: -5.557812499999983 },
        { lat: 54.272558593750034, lng: -5.60678710937492 },
        { lat: 54.245849609375, lng: -5.708056640624932 },
        { lat: 54.23583984375, lng: -5.826171875000028 },
        { lat: 54.20097656250002, lng: -5.854638671874966 },
        { lat: 54.15605468750002, lng: -5.876074218749977 },
        { lat: 54.08906250000004, lng: -5.937744140625 },
        { lat: 54.05126953124997, lng: -6.019042968749972 },
        { lat: 54.05888671875002, lng: -6.119531250000023 },
        { lat: 54.08872070312506, lng: -6.218017578125 },
        { lat: 54.094873046874966, lng: -6.303662109374955 },
        { lat: 54.07709960937501, lng: -6.363671875000023 },
        { lat: 54.06064453125003, lng: -6.402587890624943 },
        { lat: 54.063623046874994, lng: -6.440283203124977 },
        { lat: 54.05727539062505, lng: -6.548144531249932 },
        { lat: 54.05864257812496, lng: -6.649804687499937 },
        { lat: 54.08476562499996, lng: -6.664208984374965 },
        { lat: 54.163427734375006, lng: -6.646875 },
        { lat: 54.184716796874994, lng: -6.669531249999977 },
        { lat: 54.19560546874999, lng: -6.766601562499942 },
        { lat: 54.21435546874997, lng: -6.802587890624977 },
        { lat: 54.268652343750034, lng: -6.858349609374982 },
        { lat: 54.294042968750055, lng: -6.869238281249977 },
        { lat: 54.3291015625, lng: -6.877246093749932 },
        { lat: 54.37431640624998, lng: -6.93613281249992 },
        { lat: 54.40668945312501, lng: -7.007714843749937 },
        { lat: 54.40825195312496, lng: -7.049707031249965 },
        { lat: 54.35537109375002, lng: -7.133496093749983 },
        { lat: 54.301806640625045, lng: -7.202587890624955 },
        { lat: 54.27490234374997, lng: -7.17807617187492 },
        { lat: 54.23950195312506, lng: -7.155468749999926 },
        { lat: 54.21411132812503, lng: -7.193066406249955 },
        { lat: 54.156005859375, lng: -7.306738281249949 },
        { lat: 54.13344726562502, lng: -7.324511718750017 },
        { lat: 54.12124023437502, lng: -7.355175781249955 },
        { lat: 54.137304687500006, lng: -7.409423828124972 },
        { lat: 54.13359375, lng: -7.544433593749942 },
        { lat: 54.14384765625002, lng: -7.606542968750005 },
        { lat: 54.186669921875016, lng: -7.678759765624959 },
        { lat: 54.21528320312498, lng: -7.854931640624983 },
        { lat: 54.283789062500006, lng: -7.884472656249955 },
        { lat: 54.29658203125004, lng: -7.918457031249943 },
        { lat: 54.41425781250004, lng: -8.118261718749977 },
        { lat: 54.45351562500002, lng: -8.14482421874996 },
        { lat: 54.47695312500002, lng: -8.118945312499932 },
        { lat: 54.51245117187505, lng: -8.044335937500023 },
        { lat: 54.57124023437504, lng: -7.793798828124949 },
        { lat: 54.59492187499998, lng: -7.754394531249999 },
        { lat: 54.61582031250006, lng: -7.746289062499954 },
        { lat: 54.639697265625045, lng: -7.819824218750028 },
        { lat: 54.66606445312499, lng: -7.886132812499937 },
        { lat: 54.68334960937505, lng: -7.908740234374933 },
        { lat: 54.698339843750006, lng: -7.910595703124955 },
        { lat: 54.71787109374998, lng: -7.872949218749994 },
        { lat: 54.71928710937499, lng: -7.797265624999937 },
        { lat: 54.71044921874997, lng: -7.7375 },
        { lat: 54.72802734375, lng: -7.689990234374932 },
        { lat: 54.745703125000055, lng: -7.606445312499972 },
        { lat: 54.767968749999966, lng: -7.55039062499992 },
        { lat: 54.82543945312506, lng: -7.502197265624972 },
        { lat: 54.87709960937499, lng: -7.451269531249977 },
        { lat: 54.905126953125034, lng: -7.445996093749982 },
        { lat: 55.00332031250005, lng: -7.40141601562496 },
        { lat: 55.027685546875034, lng: -7.376904296874926 },
        { lat: 55.091992187499976, lng: -7.218652343749937 },
        { lat: 55.05688476562503, lng: -7.178613281249937 },
        { lat: 55.048291015624976, lng: -7.100634765624959 },
        { lat: 55.08061523437499, lng: -7.030761718749943 },
        { lat: 55.18251953125005, lng: -6.947167968749966 },
        { lat: 55.18891601562501, lng: -6.888964843749989 },
        { lat: 55.18066406250002, lng: -6.824853515624994 },
        { lat: 55.19345703125006, lng: -6.698828124999977 },
        { lat: 55.24101562499998, lng: -6.475048828124955 },
        { lat: 55.241796875000034, lng: -6.375292968749989 },
      ],
      [
        { lat: 55.44882812500003, lng: -5.10541992187501 },
        { lat: 55.44809570312498, lng: -5.231494140624932 },
        { lat: 55.456738281249955, lng: -5.277050781249983 },
        { lat: 55.481054687500034, lng: -5.331494140624955 },
        { lat: 55.61835937500001, lng: -5.392675781249977 },
        { lat: 55.666943359374976, lng: -5.370800781249983 },
        { lat: 55.69072265625002, lng: -5.345703125 },
        { lat: 55.709179687499955, lng: -5.318115234375 },
        { lat: 55.71694335937502, lng: -5.251611328124937 },
        { lat: 55.69096679687498, lng: -5.185449218749966 },
        { lat: 55.666796875000045, lng: -5.160400390625 },
        { lat: 55.57397460937503, lng: -5.10498046875 },
        { lat: 55.494335937499976, lng: -5.094726562499943 },
        { lat: 55.44882812500003, lng: -5.10541992187501 },
      ],
      [
        { lat: 55.93056640625002, lng: -6.128906249999971 },
        { lat: 55.802148437499994, lng: -6.092822265624989 },
        { lat: 55.722509765625006, lng: -6.0576171875 },
        { lat: 55.69531249999997, lng: -6.055322265624994 },
        { lat: 55.65751953125002, lng: -6.088378906249972 },
        { lat: 55.60722656249999, lng: -6.253173828124972 },
        { lat: 55.60693359375, lng: -6.305078124999966 },
        { lat: 55.61914062499999, lng: -6.307226562499977 },
        { lat: 55.67031250000005, lng: -6.270019531249943 },
        { lat: 55.728369140625055, lng: -6.302050781249989 },
        { lat: 55.77250976562499, lng: -6.286425781249989 },
        { lat: 55.780615234375034, lng: -6.301757812499999 },
        { lat: 55.77436523437501, lng: -6.333886718749994 },
        { lat: 55.70424804687502, lng: -6.45195312499996 },
        { lat: 55.69731445312504, lng: -6.491357421874994 },
        { lat: 55.711572265624994, lng: -6.495654296874988 },
        { lat: 55.76899414062498, lng: -6.466455078124994 },
        { lat: 55.808251953124994, lng: -6.462841796874955 },
        { lat: 55.832373046875, lng: -6.445263671874925 },
        { lat: 55.854638671875016, lng: -6.413183593749976 },
        { lat: 55.87133789062506, lng: -6.374951171875011 },
        { lat: 55.87373046875001, lng: -6.344140624999937 },
        { lat: 55.856494140625045, lng: -6.311279296875 },
        { lat: 55.90458984374999, lng: -6.215673828124977 },
        { lat: 55.93056640625002, lng: -6.128906249999971 },
      ],
      [
        { lat: 55.81455078125003, lng: -5.970068359374949 },
        { lat: 55.803808593750055, lng: -5.990917968749925 },
        { lat: 55.80678710937505, lng: -6.041552734374932 },
        { lat: 55.82290039062505, lng: -6.060351562499932 },
        { lat: 55.84765625000002, lng: -6.070703125000023 },
        { lat: 55.893115234375045, lng: -6.07197265625001 },
        { lat: 55.925634765625006, lng: -6.04130859374996 },
        { lat: 55.974755859374966, lng: -5.911767578124966 },
        { lat: 55.99218749999997, lng: -5.970312499999977 },
        { lat: 56.00444335937499, lng: -5.972656250000028 },
        { lat: 56.045263671875034, lng: -5.9390625 },
        { lat: 56.10878906250002, lng: -5.799609374999932 },
        { lat: 56.12031249999995, lng: -5.76225585937496 },
        { lat: 56.11855468749996, lng: -5.725146484374959 },
        { lat: 56.00561523437505, lng: -5.797216796874977 },
        { lat: 55.81455078125003, lng: -5.970068359374949 },
      ],
      [
        { lat: 56.344335937500034, lng: -5.77788085937496 },
        { lat: 56.288720703124994, lng: -6.17617187499999 },
        { lat: 56.29365234375001, lng: -6.313427734374983 },
        { lat: 56.32094726562499, lng: -6.325830078124937 },
        { lat: 56.33916015624996, lng: -6.298486328124966 },
        { lat: 56.35688476562501, lng: -6.184863281249989 },
        { lat: 56.490625, lng: -6.138867187499955 },
        { lat: 56.55214843750002, lng: -6.310644531249949 },
        { lat: 56.56943359374998, lng: -6.31967773437492 },
        { lat: 56.598779296875016, lng: -6.30625 },
        { lat: 56.61186523437502, lng: -6.286328124999983 },
        { lat: 56.642968750000044, lng: -6.182080078124955 },
        { lat: 56.649853515625004, lng: -6.1382812499999 },
        { lat: 56.64565429687496, lng: -6.102734374999954 },
        { lat: 56.60981445312503, lng: -6.029589843749989 },
        { lat: 56.53452148437498, lng: -5.946679687499966 },
        { lat: 56.522558593750034, lng: -5.836035156249977 },
        { lat: 56.49067382812501, lng: -5.760839843749949 },
        { lat: 56.344335937500034, lng: -5.77788085937496 },
      ],
      [
        { lat: 56.58500976562495, lng: -6.607617187499983 },
        { lat: 56.57944335937498, lng: -6.66445312499999 },
        { lat: 56.59360351562503, lng: -6.668554687499948 },
        { lat: 56.66123046875003, lng: -6.56992187499992 },
        { lat: 56.67236328125, lng: -6.506054687499983 },
        { lat: 56.665771484374964, lng: -6.483691406249959 },
        { lat: 56.626611328124994, lng: -6.530078124999989 },
        { lat: 56.58500976562495, lng: -6.607617187499983 },
      ],
      [
        { lat: 56.965429687500006, lng: -7.416894531249993 },
        { lat: 56.95166015625005, lng: -7.504785156249966 },
        { lat: 56.959716796875, lng: -7.537402343749931 },
        { lat: 56.97236328125001, lng: -7.54296875 },
        { lat: 57.00678710937501, lng: -7.522949218750028 },
        { lat: 57.01894531249999, lng: -7.455468749999937 },
        { lat: 57.00029296875002, lng: -7.406689453124955 },
        { lat: 56.98334960937501, lng: -7.398925781249972 },
        { lat: 56.965429687500006, lng: -7.416894531249993 },
      ],
      [
        { lat: 56.964697265625034, lng: -6.279052734375 },
        { lat: 56.951806640624994, lng: -6.308740234375023 },
        { lat: 56.95429687499995, lng: -6.346240234374931 },
        { lat: 56.97089843749998, lng: -6.383398437499949 },
        { lat: 57.017919921875034, lng: -6.432617187499943 },
        { lat: 57.05053710937502, lng: -6.322363281249949 },
        { lat: 57.03139648437505, lng: -6.278222656250023 },
        { lat: 57.00952148437503, lng: -6.261279296874932 },
        { lat: 56.985253906249966, lng: -6.26054687499996 },
        { lat: 56.964697265625034, lng: -6.279052734375 },
      ],
      [
        { lat: 57.115332031250006, lng: -7.249853515624977 },
        { lat: 57.10976562500002, lng: -7.29204101562496 },
        { lat: 57.115136718750044, lng: -7.347412109374972 },
        { lat: 57.13066406250002, lng: -7.381494140624965 },
        { lat: 57.192138671875, lng: -7.415917968749966 },
        { lat: 57.229345703125034, lng: -7.422363281249943 },
        { lat: 57.298486328124994, lng: -7.407031249999931 },
        { lat: 57.38110351562505, lng: -7.410546874999937 },
        { lat: 57.38369140625005, lng: -7.296386718749972 },
        { lat: 57.371777343750004, lng: -7.267138671874959 },
        { lat: 57.12636718750002, lng: -7.247558593749971 },
        { lat: 57.115332031250006, lng: -7.249853515624977 },
      ],
      [
        { lat: 57.50498046874998, lng: -6.144726562499983 },
        { lat: 57.460791015625034, lng: -6.146142578125023 },
        { lat: 57.40883789062502, lng: -6.163769531249955 },
        { lat: 57.35366210937496, lng: -6.140820312499982 },
        { lat: 57.31425781250002, lng: -6.135546874999989 },
        { lat: 57.301708984374955, lng: -6.093408203124937 },
        { lat: 57.28354492187498, lng: -6.067626953124999 },
        { lat: 57.26323242187501, lng: -5.880273437499937 },
        { lat: 57.268945312500016, lng: -5.706005859374955 },
        { lat: 57.252685546875, lng: -5.672460937499977 },
        { lat: 57.22690429687498, lng: -5.668652343749983 },
        { lat: 57.19843749999995, lng: -5.696191406249993 },
        { lat: 57.14653320312496, lng: -5.795410156249972 },
        { lat: 57.06264648437502, lng: -5.913769531249926 },
        { lat: 57.045166015625, lng: -5.94907226562492 },
        { lat: 57.04443359375003, lng: -5.987304687499972 },
        { lat: 57.051953124999955, lng: -6.014746093749977 },
        { lat: 57.20122070312499, lng: -6.034375 },
        { lat: 57.18212890625003, lng: -6.162744140624937 },
        { lat: 57.18432617187503, lng: -6.266113281249943 },
        { lat: 57.20249023437498, lng: -6.322705078124926 },
        { lat: 57.2375, lng: -6.36240234374992 },
        { lat: 57.327490234375055, lng: -6.442431640624989 },
        { lat: 57.36289062499997, lng: -6.675439453124937 },
        { lat: 57.412451171875034, lng: -6.741308593749948 },
        { lat: 57.4423828125, lng: -6.761132812499993 },
        { lat: 57.458935546875004, lng: -6.75273437499996 },
        { lat: 57.49575195312506, lng: -6.70419921874992 },
        { lat: 57.48261718750004, lng: -6.643457031249994 },
        { lat: 57.490673828124976, lng: -6.605859374999966 },
        { lat: 57.50712890624996, lng: -6.583007812500028 },
        { lat: 57.52065429687497, lng: -6.583496093749943 },
        { lat: 57.552734375000036, lng: -6.615283203124932 },
        { lat: 57.562695312500004, lng: -6.616796874999976 },
        { lat: 57.60332031250002, lng: -6.37851562499992 },
        { lat: 57.66679687499998, lng: -6.357666015624943 },
        { lat: 57.67197265624998, lng: -6.305957031249989 },
        { lat: 57.65122070312501, lng: -6.246923828124949 },
        { lat: 57.585302734375006, lng: -6.166064453124989 },
        { lat: 57.50498046874998, lng: -6.144726562499983 },
      ],
      [
        { lat: 57.68295898437501, lng: -7.205566406250028 },
        { lat: 57.626660156249976, lng: -7.092773437499943 },
        { lat: 57.533300781250055, lng: -7.182617187499972 },
        { lat: 57.53374023437496, lng: -7.320556640625001 },
        { lat: 57.60195312500002, lng: -7.514746093749949 },
        { lat: 57.615869140624994, lng: -7.515625 },
        { lat: 57.636328125, lng: -7.499414062499937 },
        { lat: 57.65253906250001, lng: -7.470312499999949 },
        { lat: 57.656396484374994, lng: -7.44003906249992 },
        { lat: 57.64521484375003, lng: -7.39189453124996 },
        { lat: 57.663134765625045, lng: -7.324853515624993 },
        { lat: 57.65747070312506, lng: -7.271191406249983 },
        { lat: 57.68295898437501, lng: -7.205566406250028 },
      ],
      [
        { lat: 58.36328125000002, lng: -6.198681640624983 },
        { lat: 58.18886718750002, lng: -6.325830078124937 },
        { lat: 58.18457031250006, lng: -6.375585937499948 },
        { lat: 58.140966796875034, lng: -6.419287109374977 },
        { lat: 58.092871093750006, lng: -6.554589843749994 },
        { lat: 58.09189453125, lng: -6.436523437500028 },
        { lat: 58.07587890625001, lng: -6.403369140624931 },
        { lat: 58.041357421875006, lng: -6.40244140624992 },
        { lat: 58.02128906249998, lng: -6.425195312499937 },
        { lat: 57.94135742187498, lng: -6.578125 },
        { lat: 57.91103515625002, lng: -6.683300781249926 },
        { lat: 57.827539062499966, lng: -6.796582031249925 },
        { lat: 57.826513671875034, lng: -6.853759765624942 },
        { lat: 57.77338867187503, lng: -6.910351562499926 },
        { lat: 57.75004882812498, lng: -6.956933593749994 },
        { lat: 57.75, lng: -6.983105468749983 },
        { lat: 57.761767578124996, lng: -7.01318359375 },
        { lat: 57.81376953124999, lng: -7.083447265624926 },
        { lat: 57.864892578125016, lng: -6.955957031249966 },
        { lat: 57.893652343750034, lng: -6.94414062499996 },
        { lat: 57.92353515624998, lng: -6.856835937499937 },
        { lat: 57.93286132812503, lng: -6.864160156250023 },
        { lat: 57.97490234374996, lng: -7.002539062499949 },
        { lat: 58.00317382812502, lng: -7.057080078124954 },
        { lat: 58.017968750000016, lng: -7.051904296874965 },
        { lat: 58.05048828125001, lng: -6.985302734375011 },
        { lat: 58.05478515624998, lng: -7.01689453124996 },
        { lat: 58.07231445312502, lng: -7.038232421874937 },
        { lat: 58.07900390625002, lng: -7.076904296874999 },
        { lat: 58.09536132812499, lng: -7.088476562499977 },
        { lat: 58.138281250000034, lng: -7.095605468749994 },
        { lat: 58.18217773437499, lng: -7.085253906249932 },
        { lat: 58.20156250000005, lng: -7.044921874999972 },
        { lat: 58.222314453124994, lng: -7.028417968749977 },
        { lat: 58.22871093749998, lng: -7.012060546874949 },
        { lat: 58.21767578125005, lng: -6.94956054687492 },
        { lat: 58.182568359374976, lng: -6.886230468749972 },
        { lat: 58.19609374999998, lng: -6.812304687499932 },
        { lat: 58.18940429687495, lng: -6.726464843749937 },
        { lat: 58.19755859375001, lng: -6.72470703124992 },
        { lat: 58.28388671875004, lng: -6.787744140624994 },
        { lat: 58.301513671874964, lng: -6.776464843750006 },
        { lat: 58.32163085937498, lng: -6.742285156249948 },
        { lat: 58.383154296875006, lng: -6.544189453125028 },
        { lat: 58.48662109375001, lng: -6.297167968749959 },
        { lat: 58.502832031250044, lng: -6.237451171874966 },
        { lat: 58.48872070312501, lng: -6.219433593749926 },
        { lat: 58.43510742187501, lng: -6.194238281249966 },
        { lat: 58.36328125000002, lng: -6.198681640624983 },
      ],
      [
        { lat: 58.51547851562503, lng: -3.109667968749932 },
        { lat: 58.43369140625, lng: -3.10112304687496 },
        { lat: 58.408886718750004, lng: -3.112890624999977 },
        { lat: 58.378320312499994, lng: -3.136767578124932 },
        { lat: 58.32124023437501, lng: -3.212353515624983 },
        { lat: 58.23964843749999, lng: -3.410986328124949 },
        { lat: 58.052099609375055, lng: -3.775 },
        { lat: 57.95903320312502, lng: -3.99003906249996 },
        { lat: 57.914257812499955, lng: -4.019628906249949 },
        { lat: 57.852001953124976, lng: -4.035595703124926 },
        { lat: 57.83964843750004, lng: -3.906835937499977 },
        { lat: 57.818554687500004, lng: -3.857128906249983 },
        { lat: 57.78691406250004, lng: -3.887939453124943 },
        { lat: 57.67705078125004, lng: -4.078417968749931 },
        { lat: 57.577734375000055, lng: -4.134521484375 },
        { lat: 57.58125, lng: -3.988476562500011 },
        { lat: 57.60034179687503, lng: -3.8681640625 },
        { lat: 57.662255859375044, lng: -3.62822265624996 },
        { lat: 57.708251953125, lng: -3.402783203124955 },
        { lat: 57.71015625000003, lng: -3.2945312499999 },
        { lat: 57.67348632812502, lng: -3.083935546874926 },
        { lat: 57.67231445312495, lng: -3.036035156249937 },
        { lat: 57.689257812500045, lng: -2.946679687499937 },
        { lat: 57.692285156250016, lng: -2.85629882812492 },
        { lat: 57.68085937500002, lng: -2.244140625 },
        { lat: 57.70239257812505, lng: -2.074072265624977 },
        { lat: 57.67666015625005, lng: -1.961523437499977 },
        { lat: 57.612353515624996, lng: -1.867382812499983 },
        { lat: 57.49375, lng: -1.777929687499949 },
        { lat: 57.474023437499966, lng: -1.780664062499994 },
        { lat: 57.41997070312499, lng: -1.834716796874971 },
        { lat: 57.35219726562502, lng: -1.934472656249966 },
        { lat: 57.258886718750034, lng: -2.0203125 },
        { lat: 57.20854492187499, lng: -2.045507812499949 },
        { lat: 57.15346679687505, lng: -2.062353515625006 },
        { lat: 57.10253906250006, lng: -2.089550781249926 },
        { lat: 56.86333007812499, lng: -2.26025390625 },
        { lat: 56.73071289062497, lng: -2.426660156249966 },
        { lat: 56.63657226562497, lng: -2.5009765625 },
        { lat: 56.56157226562498, lng: -2.592675781249937 },
        { lat: 56.51440429687505, lng: -2.680957031249989 },
        { lat: 56.482958984375045, lng: -2.775195312499989 },
        { lat: 56.449365234375016, lng: -3.04741210937496 },
        { lat: 56.42529296875003, lng: -3.123583984374932 },
        { lat: 56.38393554687502, lng: -3.214453124999949 },
        { lat: 56.36347656250004, lng: -3.309960937499965 },
        { lat: 56.366064453125034, lng: -3.197998046874972 },
        { lat: 56.3890625, lng: -3.08701171874992 },
        { lat: 56.397509765625045, lng: -2.885156249999937 },
        { lat: 56.318261718749966, lng: -2.652734375000023 },
        { lat: 56.25341796875, lng: -2.674267578124955 },
        { lat: 56.20214843750003, lng: -2.767578124999972 },
        { lat: 56.194091796875, lng: -2.979785156249932 },
        { lat: 56.080126953125045, lng: -3.178222656249943 },
        { lat: 56.04506835937499, lng: -3.267773437499983 },
        { lat: 56.02763671875001, lng: -3.362255859374955 },
        { lat: 56.0328125, lng: -3.480419921874955 },
        { lat: 56.063330078125006, lng: -3.695117187500017 },
        { lat: 56.09521484375, lng: -3.789062499999972 },
        { lat: 56.04316406249998, lng: -3.704150390624989 },
        { lat: 56.016015625000016, lng: -3.6078125 },
        { lat: 55.951953125000045, lng: -3.048730468749937 },
        { lat: 55.95859375000006, lng: -3.015087890624926 },
        { lat: 56.026269531249994, lng: -2.836865234374955 },
        { lat: 56.02729492187501, lng: -2.599316406249954 },
        { lat: 55.90297851562502, lng: -2.14707031249992 },
        { lat: 55.807958984375006, lng: -2.016845703124972 },
        { lat: 55.67172851562506, lng: -1.830273437499954 },
        { lat: 55.618554687499966, lng: -1.728759765624972 },
        { lat: 55.57036132812502, lng: -1.655371093749949 },
        { lat: 55.498095703125045, lng: -1.61015625 },
        { lat: 55.25952148437503, lng: -1.522558593749977 },
        { lat: 55.02641601562504, lng: -1.42265625 },
        { lat: 54.77387695312501, lng: -1.291748046874943 },
        { lat: 54.703710937500034, lng: -1.232421874999943 },
        { lat: 54.65449218750004, lng: -1.154394531249949 },
        { lat: 54.54140625, lng: -0.759326171875017 },
        { lat: 54.50390625, lng: -0.671386718749943 },
        { lat: 54.395117187500034, lng: -0.518115234374989 },
        { lat: 54.279199218750044, lng: -0.370361328125 },
        { lat: 54.190136718750004, lng: -0.232861328124954 },
        { lat: 54.118066406249994, lng: -0.084375 },
        { lat: 54.08061523437501, lng: -0.156298828124989 },
        { lat: 54.021728515625, lng: -0.20556640625 },
        { lat: 53.94165039062503, lng: -0.16875 },
        { lat: 53.86518554687498, lng: -0.108251953124977 },
        { lat: 53.74282226562502, lng: 0.010546875000074 },
        { lat: 53.609277343749994, lng: 0.115332031250006 },
        { lat: 53.62944335937502, lng: 0.076708984375045 },
        { lat: 53.640527343749966, lng: 0.03608398437504 },
        { lat: 53.63720703125, lng: -0.019433593749994 },
        { lat: 53.64365234374998, lng: -0.073730468749943 },
        { lat: 53.685449218749966, lng: -0.173828125 },
        { lat: 53.73676757812504, lng: -0.270019531249972 },
        { lat: 53.716162109375006, lng: -0.461376953124983 },
        { lat: 53.72539062500002, lng: -0.56767578124996 },
        { lat: 53.72402343750002, lng: -0.659912109375 },
        { lat: 53.69438476562502, lng: -0.485058593750011 },
        { lat: 53.69233398437504, lng: -0.293701171875 },
        { lat: 53.46826171875003, lng: 0.12832031250008 },
        { lat: 53.33549804687499, lng: 0.270996093750028 },
        { lat: 53.15996093750001, lng: 0.355761718750045 },
        { lat: 53.081103515625045, lng: 0.298046875000011 },
        { lat: 53.03002929687502, lng: 0.208203125000011 },
        { lat: 52.97158203125002, lng: 0.12441406250008 },
        { lat: 52.90561523437498, lng: 0.0458984375 },
        { lat: 52.80869140625006, lng: 0.279785156250028 },
        { lat: 52.811621093750034, lng: 0.330175781250006 },
        { lat: 52.82519531250003, lng: 0.381933593750063 },
        { lat: 52.858154296875, lng: 0.431640625000057 },
        { lat: 52.938378906249994, lng: 0.515527343750023 },
        { lat: 52.96694335937505, lng: 0.55878906250004 },
        { lat: 52.97724609375001, lng: 0.704492187500051 },
        { lat: 52.97109375, lng: 0.826757812500006 },
        { lat: 52.95336914062503, lng: 0.948535156250017 },
        { lat: 52.95898437500003, lng: 1.05556640625008 },
        { lat: 52.92456054687503, lng: 1.271289062500045 },
        { lat: 52.89350585937501, lng: 1.382128906250074 },
        { lat: 52.753710937500045, lng: 1.656738281249972 },
        { lat: 52.67724609375, lng: 1.716113281249989 },
        { lat: 52.578515624999966, lng: 1.74335937500004 },
        { lat: 52.46899414062503, lng: 1.74658203125 },
        { lat: 52.36889648437497, lng: 1.700390624999983 },
        { lat: 52.278515624999955, lng: 1.647363281250023 },
        { lat: 52.16181640624998, lng: 1.614648437500023 },
        { lat: 52.11977539062502, lng: 1.59140625 },
        { lat: 52.086865234374976, lng: 1.558984375000051 },
        { lat: 51.994775390624966, lng: 1.41347656250008 },
        { lat: 51.95693359374999, lng: 1.31679687499999 },
        { lat: 51.973535156249994, lng: 1.275976562500034 },
        { lat: 51.97124023437496, lng: 1.232421875000057 },
        { lat: 51.949121093749994, lng: 1.227832031249989 },
        { lat: 51.902099609375, lng: 1.273828125000051 },
        { lat: 51.845361328124994, lng: 1.274414062499972 },
        { lat: 51.803369140624966, lng: 1.188476562500057 },
        { lat: 51.785449218750045, lng: 1.101171875000034 },
        { lat: 51.807812499999976, lng: 0.955078125000028 },
        { lat: 51.729589843750034, lng: 0.752246093750017 },
        { lat: 51.68940429687501, lng: 0.898046875000034 },
        { lat: 51.646630859374994, lng: 0.927441406249983 },
        { lat: 51.571435546874966, lng: 0.890917968750017 },
        { lat: 51.53789062499996, lng: 0.79921875000008 },
        { lat: 51.52304687500006, lng: 0.697558593750045 },
        { lat: 51.51948242187504, lng: 0.593457031250068 },
        { lat: 51.50107421875, lng: 0.507226562499994 },
        { lat: 51.465625, lng: 0.42451171875004 },
        { lat: 51.484472656250006, lng: 0.528320312500028 },
        { lat: 51.46796875, lng: 0.60029296875004 },
        { lat: 51.40468750000002, lng: 0.645507812500028 },
        { lat: 51.38657226562506, lng: 0.686523437500028 },
        { lat: 51.35952148437505, lng: 0.88935546875004 },
        { lat: 51.359716796875006, lng: 1.014941406250045 },
        { lat: 51.37509765625003, lng: 1.257128906250017 },
        { lat: 51.37470703125004, lng: 1.37343750000008 },
        { lat: 51.36328125, lng: 1.414941406250023 },
        { lat: 51.31083984374999, lng: 1.415625 },
        { lat: 51.18203125000002, lng: 1.397558593750034 },
        { lat: 51.15546874999995, lng: 1.365527343750074 },
        { lat: 51.04726562500002, lng: 1.044433593750028 },
        { lat: 50.9716796875, lng: 0.978613281250034 },
        { lat: 50.92587890624997, lng: 0.960156250000011 },
        { lat: 50.93398437500005, lng: 0.772363281250023 },
        { lat: 50.88554687500002, lng: 0.684375 },
        { lat: 50.853417968749966, lng: 0.532324218750062 },
        { lat: 50.819189453125006, lng: 0.414746093749983 },
        { lat: 50.7759765625, lng: 0.299707031249994 },
        { lat: 50.763037109375034, lng: 0.205078125 },
        { lat: 50.814355468749994, lng: -0.203906250000017 },
        { lat: 50.810156250000034, lng: -0.450781249999949 },
        { lat: 50.76542968749999, lng: -0.785253906249949 },
        { lat: 50.77280273437498, lng: -0.871386718749932 },
        { lat: 50.815625, lng: -1.000585937499949 },
        { lat: 50.844580078125034, lng: -1.132861328124989 },
        { lat: 50.857324218749966, lng: -1.285058593749994 },
        { lat: 50.896875, lng: -1.416455078124955 },
        { lat: 50.82080078124997, lng: -1.334472656249943 },
        { lat: 50.747460937499966, lng: -1.516748046874937 },
        { lat: 50.73286132812501, lng: -1.600830078124943 },
        { lat: 50.735156250000045, lng: -1.68789062499999 },
        { lat: 50.715234374999966, lng: -1.86601562499996 },
        { lat: 50.72539062499999, lng: -2.031054687499932 },
        { lat: 50.67324218750002, lng: -2.00625 },
        { lat: 50.627783203125006, lng: -1.962060546874994 },
        { lat: 50.60800781249998, lng: -1.99790039062492 },
        { lat: 50.603076171875045, lng: -2.035839843749926 },
        { lat: 50.63740234375001, lng: -2.350146484375017 },
        { lat: 50.63090820312502, lng: -2.394677734374937 },
        { lat: 50.59921875000006, lng: -2.43344726562492 },
        { lat: 50.61630859374998, lng: -2.547753906249937 },
        { lat: 50.66972656250002, lng: -2.658837890625023 },
        { lat: 50.70556640625006, lng: -2.77695312499992 },
        { lat: 50.722412109375, lng: -2.900878906249943 },
        { lat: 50.71660156249999, lng: -2.999414062499937 },
        { lat: 50.63242187499997, lng: -3.40458984374996 },
        { lat: 50.547949218750006, lng: -3.48544921874992 },
        { lat: 50.42817382812501, lng: -3.52587890625 },
        { lat: 50.32182617187502, lng: -3.584375 },
        { lat: 50.239941406249955, lng: -3.679785156250005 },
        { lat: 50.229248046875, lng: -3.793359374999937 },
        { lat: 50.28593749999999, lng: -3.90019531249996 },
        { lat: 50.34853515625005, lng: -4.103417968749966 },
        { lat: 50.390820312499955, lng: -4.172558593749926 },
        { lat: 50.39331054687503, lng: -4.194580078124972 },
        { lat: 50.37817382812506, lng: -4.217285156249972 },
        { lat: 50.35908203124998, lng: -4.296972656249977 },
        { lat: 50.35820312499999, lng: -4.379492187499976 },
        { lat: 50.34135742187502, lng: -4.506689453124977 },
        { lat: 50.29047851562504, lng: -4.727978515624926 },
        { lat: 50.255957031250006, lng: -4.817382812499942 },
        { lat: 50.16074218749998, lng: -5.009521484375 },
        { lat: 50.134375, lng: -5.048632812499989 },
        { lat: 50.038330078125, lng: -5.11850585937492 },
        { lat: 50.02138671875002, lng: -5.225244140624993 },
        { lat: 50.08295898437504, lng: -5.322851562499977 },
        { lat: 50.10444335937498, lng: -5.433984374999966 },
        { lat: 50.08339843750002, lng: -5.551220703124955 },
        { lat: 50.05068359375002, lng: -5.622119140624932 },
        { lat: 50.077246093750034, lng: -5.655175781249994 },
        { lat: 50.13188476562496, lng: -5.65625 },
        { lat: 50.19697265624998, lng: -5.57065429687492 },
        { lat: 50.24614257812495, lng: -5.342285156249943 },
        { lat: 50.37373046875004, lng: -5.141796874999955 },
        { lat: 50.45151367187498, lng: -5.04345703125 },
        { lat: 50.495263671875016, lng: -5.004443359374932 },
        { lat: 50.52314453125001, lng: -4.95639648437492 },
        { lat: 50.53369140625002, lng: -4.893554687499999 },
        { lat: 50.58203125, lng: -4.861279296875011 },
        { lat: 50.7763671875, lng: -4.582910156249966 },
        { lat: 50.82094726562502, lng: -4.559960937499994 },
        { lat: 50.90068359375002, lng: -4.546093750000011 },
        { lat: 50.97744140625002, lng: -4.523095703124937 },
        { lat: 51.02714843750002, lng: -4.296484374999948 },
        { lat: 51.18852539062502, lng: -4.188183593749925 },
        { lat: 51.20131835937496, lng: -4.158398437499983 },
        { lat: 51.23090820312495, lng: -3.842333984374988 },
        { lat: 51.22856445312502, lng: -3.60791015625 },
        { lat: 51.19697265624998, lng: -3.37509765624992 },
        { lat: 51.19414062500002, lng: -3.255761718749937 },
        { lat: 51.20502929687501, lng: -3.135986328124972 },
        { lat: 51.24858398437502, lng: -3.042041015625017 },
        { lat: 51.405664062500016, lng: -2.88125 },
        { lat: 51.47480468749998, lng: -2.790820312499989 },
        { lat: 51.53725585937502, lng: -2.687207031249926 },
        { lat: 51.60859374999998, lng: -2.590283203124983 },
        { lat: 51.74072265625, lng: -2.433056640624926 },
        { lat: 51.69521484375005, lng: -2.539355468750017 },
        { lat: 51.62299804687498, lng: -2.667675781249955 },
        { lat: 51.58110351562499, lng: -2.742138671874926 },
        { lat: 51.53886718749999, lng: -2.978515624999943 },
        { lat: 51.495800781250004, lng: -3.080371093749989 },
        { lat: 51.39848632812499, lng: -3.258789062499943 },
        { lat: 51.390429687500045, lng: -3.293115234374994 },
        { lat: 51.413818359375, lng: -3.562353515624948 },
        { lat: 51.539941406250016, lng: -3.7626953125 },
        { lat: 51.591650390625, lng: -3.890771484374994 },
        { lat: 51.597509765625034, lng: -3.943652343749931 },
        { lat: 51.58212890625, lng: -3.99833984374996 },
        { lat: 51.56640625, lng: -4.115283203124989 },
        { lat: 51.56909179687503, lng: -4.234570312499955 },
        { lat: 51.62734375, lng: -4.173681640624976 },
        { lat: 51.65991210937505, lng: -4.091015624999926 },
        { lat: 51.68251953125002, lng: -4.276171874999989 },
        { lat: 51.70024414062502, lng: -4.32763671875 },
        { lat: 51.74106445312506, lng: -4.38627929687496 },
        { lat: 51.74804687499997, lng: -4.531494140624971 },
        { lat: 51.73764648437497, lng: -4.600781249999955 },
        { lat: 51.683691406250006, lng: -4.717626953124949 },
        { lat: 51.626269531250045, lng: -4.902294921874926 },
        { lat: 51.70585937499999, lng: -5.124755859374942 },
        { lat: 51.74072265625, lng: -5.168359374999937 },
        { lat: 51.80805664062504, lng: -5.167236328124972 },
        { lat: 51.86137695312496, lng: -5.200585937499937 },
        { lat: 51.88017578124999, lng: -5.262304687499977 },
        { lat: 51.949658203125004, lng: -5.183349609374972 },
        { lat: 51.99589843750002, lng: -5.088085937499926 },
        { lat: 52.04184570312506, lng: -4.878515624999949 },
        { lat: 52.15087890624997, lng: -4.561132812499948 },
        { lat: 52.19731445312502, lng: -4.383154296874949 },
        { lat: 52.277441406250006, lng: -4.217724609374983 },
        { lat: 52.32626953125, lng: -4.149365234375011 },
        { lat: 52.39311523437502, lng: -4.099755859374937 },
        { lat: 52.47514648437504, lng: -4.050537109374943 },
        { lat: 52.54174804687503, lng: -3.980322265624949 },
        { lat: 52.55761718749997, lng: -4.048437499999948 },
        { lat: 52.60786132812498, lng: -4.07890625 },
        { lat: 52.658837890624994, lng: -4.070703124999966 },
        { lat: 52.704052734374955, lng: -4.039257812499955 },
        { lat: 52.76074218750006, lng: -4.067431640625017 },
        { lat: 52.820019531249955, lng: -4.11752929687492 },
        { lat: 52.86616210937504, lng: -4.114746093749972 },
        { lat: 52.915478515624955, lng: -4.101464843750023 },
        { lat: 52.91284179687503, lng: -4.229150390624994 },
        { lat: 52.897412109375004, lng: -4.3564453125 },
        { lat: 52.86245117187499, lng: -4.471826171874965 },
        { lat: 52.81494140625, lng: -4.583691406249926 },
        { lat: 52.80615234374997, lng: -4.683056640624926 },
        { lat: 52.84414062499999, lng: -4.68144531249996 },
        { lat: 52.89111328125006, lng: -4.638330078124966 },
        { lat: 52.958203124999955, lng: -4.525683593749932 },
        { lat: 53.013818359374994, lng: -4.40507812499996 },
        { lat: 53.056054687499994, lng: -4.362207031249937 },
        { lat: 53.10512695312505, lng: -4.328417968749989 },
        { lat: 53.14453125, lng: -4.268554687499943 },
        { lat: 53.218945312499955, lng: -4.111035156249926 },
        { lat: 53.30268554687498, lng: -3.809277343749983 },
        { lat: 53.3076171875, lng: -3.764208984374961 },
        { lat: 53.29790039062496, lng: -3.645898437499937 },
        { lat: 53.31054687499997, lng: -3.52958984374996 },
        { lat: 53.34067382812498, lng: -3.427734374999972 },
        { lat: 53.34716796874997, lng: -3.326171874999972 },
        { lat: 53.260302734375045, lng: -3.097558593749937 },
        { lat: 53.39467773437496, lng: -3.16557617187496 },
        { lat: 53.426855468750034, lng: -3.064746093749932 },
        { lat: 53.30537109374998, lng: -2.918554687499977 },
        { lat: 53.292578125000034, lng: -2.864160156249994 },
        { lat: 53.310205078124994, lng: -2.74951171875 },
        { lat: 53.33071289062499, lng: -2.79375 },
        { lat: 53.33193359374996, lng: -2.845410156249926 },
        { lat: 53.35024414062496, lng: -2.913085937499943 },
        { lat: 53.38920898437502, lng: -2.969970703124972 },
        { lat: 53.512841796874966, lng: -3.064599609374994 },
        { lat: 53.58623046875002, lng: -3.059472656249994 },
        { lat: 53.66254882812501, lng: -2.995703124999977 },
        { lat: 53.732763671875, lng: -2.925097656249988 },
        { lat: 53.74672851562502, lng: -2.984326171874983 },
        { lat: 53.77358398437499, lng: -3.03178710937496 },
        { lat: 53.843847656250006, lng: -3.045361328124983 },
        { lat: 53.905908203125016, lng: -3.026757812499994 },
        { lat: 53.96069335937499, lng: -2.899853515624983 },
        { lat: 54.043847656249966, lng: -2.86240234374992 },
        { lat: 54.135302734375045, lng: -2.84648437499996 },
        { lat: 54.177246093749964, lng: -2.86757812499999 },
        { lat: 54.170507812500034, lng: -2.993505859374977 },
        { lat: 54.153417968750006, lng: -3.054736328124931 },
        { lat: 54.12631835937498, lng: -3.109667968749932 },
        { lat: 54.12792968750006, lng: -3.165966796874955 },
        { lat: 54.22910156250006, lng: -3.321533203125028 },
        { lat: 54.30561523437501, lng: -3.410253906249977 },
        { lat: 54.46757812499996, lng: -3.56938476562496 },
        { lat: 54.564355468749966, lng: -3.592041015624971 },
        { lat: 54.77309570312505, lng: -3.464599609374943 },
        { lat: 54.90659179687506, lng: -3.26791992187492 },
        { lat: 54.95307617187501, lng: -3.036230468749977 },
        { lat: 54.96196289062496, lng: -3.081054687499972 },
        { lat: 54.96376953124999, lng: -3.434082031249943 },
        { lat: 54.947412109375016, lng: -3.550439453124937 },
        { lat: 54.89287109375002, lng: -3.658300781249977 },
        { lat: 54.876123046874966, lng: -3.719238281249943 },
        { lat: 54.86992187499996, lng: -3.783251953124931 },
        { lat: 54.84277343750002, lng: -3.841601562500017 },
        { lat: 54.80507812499999, lng: -3.898583984374994 },
        { lat: 54.780957031249955, lng: -3.957910156249994 },
        { lat: 54.78720703124998, lng: -4.0757812499999 },
        { lat: 54.77924804687495, lng: -4.132958984374937 },
        { lat: 54.80107421874996, lng: -4.174023437499955 },
        { lat: 54.83715820312502, lng: -4.208398437499937 },
        { lat: 54.846777343750034, lng: -4.253417968749972 },
        { lat: 54.835693359375, lng: -4.303662109374983 },
        { lat: 54.78706054687495, lng: -4.409912109374972 },
        { lat: 54.75834960937496, lng: -4.517480468749937 },
        { lat: 54.78901367187498, lng: -4.647558593749977 },
        { lat: 54.84614257812501, lng: -4.818066406249983 },
        { lat: 54.825292968750006, lng: -4.851708984374994 },
        { lat: 54.77226562499995, lng: -4.889501953124976 },
        { lat: 54.68945312500006, lng: -4.911230468749949 },
        { lat: 54.76137695312505, lng: -5.032324218749949 },
        { lat: 54.857519531250006, lng: -5.135498046875 },
        { lat: 54.917919921874955, lng: -5.170117187499955 },
        { lat: 54.98588867187496, lng: -5.172705078124948 },
        { lat: 55.01225585937499, lng: -5.11669921875 },
        { lat: 54.988134765625055, lng: -5.055859374999925 },
        { lat: 55.14946289062498, lng: -4.965185546874949 },
        { lat: 55.35942382812502, lng: -4.784814453124966 },
        { lat: 55.42099609375006, lng: -4.721142578124955 },
        { lat: 55.50131835937497, lng: -4.676757812499972 },
        { lat: 55.55390625000004, lng: -4.684375 },
        { lat: 55.59829101562502, lng: -4.72416992187496 },
        { lat: 55.699121093750044, lng: -4.891845703125 },
        { lat: 55.78120117187498, lng: -4.8896484375 },
        { lat: 55.87392578125005, lng: -4.871679687499977 },
        { lat: 55.929541015625006, lng: -4.826074218749937 },
        { lat: 55.94013671875004, lng: -4.806835937499926 },
        { lat: 55.93867187500001, lng: -4.58408203124992 },
        { lat: 55.96738281249998, lng: -4.67094726562496 },
        { lat: 56.05117187499999, lng: -4.844091796874949 },
        { lat: 56.08085937500001, lng: -4.841015624999955 },
        { lat: 56.158349609374994, lng: -4.80029296875 },
        { lat: 56.15048828124998, lng: -4.819140624999932 },
        { lat: 56.11469726562498, lng: -4.85625 },
        { lat: 56.028076171875, lng: -4.927099609375005 },
        { lat: 56.00786132812496, lng: -4.970361328124937 },
        { lat: 55.98730468750005, lng: -5.092822265625017 },
        { lat: 55.94462890624996, lng: -5.114990234375 },
        { lat: 55.93349609375002, lng: -5.134667968749994 },
        { lat: 55.92866210937501, lng: -5.195849609374959 },
        { lat: 55.88886718749998, lng: -5.214599609374942 },
        { lat: 55.886328125, lng: -5.228222656249983 },
        { lat: 55.929248046875045, lng: -5.245605468749972 },
        { lat: 56.00039062500005, lng: -5.247314453124943 },
        { lat: 56.065820312499966, lng: -5.22294921874996 },
        { lat: 56.11699218749999, lng: -5.176416015624994 },
        { lat: 56.23334960937498, lng: -4.996972656249937 },
        { lat: 56.19746093749995, lng: -5.084326171874977 },
        { lat: 56.08994140625, lng: -5.282324218749977 },
        { lat: 56.01923828124998, lng: -5.383447265624966 },
        { lat: 55.995361328125, lng: -5.41044921874996 },
        { lat: 55.975244140624994, lng: -5.418896484375011 },
        { lat: 55.952050781249966, lng: -5.418310546874977 },
        { lat: 55.82768554687504, lng: -5.372900390624949 },
        { lat: 55.770117187500034, lng: -5.38583984374992 },
        { lat: 55.389599609374955, lng: -5.55644531249996 },
        { lat: 55.351416015625, lng: -5.588769531249966 },
        { lat: 55.331445312500016, lng: -5.618457031249989 },
        { lat: 55.326855468749955, lng: -5.646533203124932 },
        { lat: 55.33413085937502, lng: -5.730664062499926 },
        { lat: 55.36264648437498, lng: -5.768212890624937 },
        { lat: 55.394970703124976, lng: -5.767871093749959 },
        { lat: 55.443457031250006, lng: -5.752099609374937 },
        { lat: 55.62397460937501, lng: -5.681347656250011 },
        { lat: 55.67412109375002, lng: -5.650634765624972 },
        { lat: 55.72075195312501, lng: -5.605029296874989 },
        { lat: 55.80239257812502, lng: -5.504492187499949 },
        { lat: 55.80771484375006, lng: -5.506933593750006 },
        { lat: 55.791699218749976, lng: -5.573876953124966 },
        { lat: 55.796972656250006, lng: -5.602392578125006 },
        { lat: 55.813134765624994, lng: -5.622851562499989 },
        { lat: 56.055273437500034, lng: -5.609570312499955 },
        { lat: 56.13496093750001, lng: -5.555273437499977 },
        { lat: 56.250830078125006, lng: -5.534960937499932 },
        { lat: 56.350048828124955, lng: -5.487890624999949 },
        { lat: 56.42231445312504, lng: -5.433398437499932 },
        { lat: 56.51479492187505, lng: -5.39194335937492 },
        { lat: 56.55590820312497, lng: -5.329443359374977 },
        { lat: 56.618798828124994, lng: -5.312695312499955 },
        { lat: 56.686865234375006, lng: -5.242578124999966 },
        { lat: 56.75805664062502, lng: -5.188378906249937 },
        { lat: 56.75102539062502, lng: -5.217578124999932 },
        { lat: 56.56572265625002, lng: -5.564208984374942 },
        { lat: 56.531982421875, lng: -5.652441406249976 },
        { lat: 56.54101562500006, lng: -5.772802734374977 },
        { lat: 56.56186523437503, lng: -5.86484375 },
        { lat: 56.60571289062499, lng: -5.936767578125 },
        { lat: 56.68989257812501, lng: -5.968896484374966 },
        { lat: 56.69213867187503, lng: -6.057714843749949 },
        { lat: 56.706689453124966, lng: -6.133691406249966 },
        { lat: 56.71801757812506, lng: -6.132763671874955 },
        { lat: 56.76391601562499, lng: -6.034716796874959 },
        { lat: 56.779638671875006, lng: -5.877636718749926 },
        { lat: 56.853076171875045, lng: -5.730615234374994 },
        { lat: 56.902685546875006, lng: -5.86142578124992 },
        { lat: 56.91840820312501, lng: -5.850390624999988 },
        { lat: 56.96064453125001, lng: -5.73627929687501 },
        { lat: 57.10234375000002, lng: -5.591308593749943 },
        { lat: 57.23271484375002, lng: -5.561914062499994 },
        { lat: 57.29394531249997, lng: -5.63125 },
        { lat: 57.33408203124997, lng: -5.656347656249977 },
        { lat: 57.378808593750016, lng: -5.794921874999972 },
        { lat: 57.43608398437495, lng: -5.818066406249955 },
        { lat: 57.46801757812499, lng: -5.801953124999983 },
        { lat: 57.499218749999955, lng: -5.756738281249994 },
        { lat: 57.523535156250034, lng: -5.688623046874965 },
        { lat: 57.54677734374996, lng: -5.581787109374972 },
        { lat: 57.571679687499966, lng: -5.678759765625017 },
        { lat: 57.60107421875, lng: -5.71494140624992 },
        { lat: 57.64365234374998, lng: -5.742382812500011 },
        { lat: 57.66831054687504, lng: -5.744921874999989 },
        { lat: 57.77822265625005, lng: -5.694726562499966 },
        { lat: 57.82353515625004, lng: -5.665478515624954 },
        { lat: 57.88134765625, lng: -5.608349609374955 },
        { lat: 57.87807617187505, lng: -5.349023437499966 },
        { lat: 57.90361328125001, lng: -5.319189453124948 },
        { lat: 57.90458984375002, lng: -5.289794921875 },
        { lat: 57.88134765625, lng: -5.157226562499972 },
        { lat: 57.90639648437505, lng: -5.176904296874994 },
        { lat: 58.04360351562502, lng: -5.39375 },
        { lat: 58.06972656250002, lng: -5.413183593750006 },
        { lat: 58.14370117187496, lng: -5.351367187499932 },
        { lat: 58.17666015625002, lng: -5.346875 },
        { lat: 58.21191406250003, lng: -5.355957031249972 },
        { lat: 58.23872070312498, lng: -5.338281250000023 },
        { lat: 58.25141601562498, lng: -5.269531249999943 },
        { lat: 58.250146484375, lng: -5.059960937499966 },
        { lat: 58.26264648437495, lng: -5.008300781250028 },
        { lat: 58.29829101562504, lng: -5.03183593749992 },
        { lat: 58.34516601562498, lng: -5.080615234375017 },
        { lat: 58.384521484375, lng: -5.090136718749988 },
        { lat: 58.41928710937497, lng: -5.078710937499977 },
        { lat: 58.48925781250002, lng: -5.076025390624949 },
        { lat: 58.52021484375004, lng: -5.066503906249977 },
        { lat: 58.56655273437496, lng: -5.016748046874966 },
        { lat: 58.58032226562502, lng: -4.975634765624932 },
        { lat: 58.588378906249964, lng: -4.924658203124948 },
        { lat: 58.57290039062502, lng: -4.80961914062496 },
        { lat: 58.55419921875002, lng: -4.765771484374994 },
        { lat: 58.510009765625, lng: -4.715429687499949 },
        { lat: 58.51357421875002, lng: -4.67822265625 },
        { lat: 58.56157226562502, lng: -4.53496093749996 },
        { lat: 58.568457031250006, lng: -4.491894531249983 },
        { lat: 58.512841796875044, lng: -4.433251953124937 },
        { lat: 58.557226562500034, lng: -4.188623046874993 },
        { lat: 58.577099609374976, lng: -3.859521484374937 },
        { lat: 58.60629882812498, lng: -3.661816406249983 },
        { lat: 58.616894531250004, lng: -3.453564453125011 },
        { lat: 58.65, lng: -3.25913085937492 },
        { lat: 58.63481445312502, lng: -3.053076171874949 },
        { lat: 58.61552734374999, lng: -3.04619140624996 },
        { lat: 58.588769531249966, lng: -3.056982421874949 },
        { lat: 58.51547851562503, lng: -3.109667968749932 },
      ],
      [
        { lat: 58.741601562500016, lng: -2.929394531249983 },
        { lat: 58.738623046875034, lng: -2.938964843749972 },
        { lat: 58.756933593750034, lng: -2.975390624999932 },
        { lat: 58.822656250000016, lng: -3.035449218749989 },
        { lat: 58.835693359375, lng: -2.941210937499989 },
        { lat: 58.827587890624955, lng: -2.896435546874926 },
        { lat: 58.79960937500002, lng: -2.913085937499943 },
        { lat: 58.741601562500016, lng: -2.929394531249983 },
      ],
      [
        { lat: 58.794189453124964, lng: -3.164941406249994 },
        { lat: 58.780957031249955, lng: -3.222119140624926 },
        { lat: 58.78193359374998, lng: -3.278808593750028 },
        { lat: 58.83974609375002, lng: -3.3671875 },
        { lat: 58.88178710937498, lng: -3.400830078124926 },
        { lat: 58.90961914062495, lng: -3.394726562499926 },
        { lat: 58.918994140625024, lng: -3.357421874999943 },
        { lat: 58.90527343749997, lng: -3.271923828124955 },
        { lat: 58.85717773437502, lng: -3.227636718749977 },
        { lat: 58.82587890624995, lng: -3.222119140624926 },
        { lat: 58.81357421875003, lng: -3.211621093749926 },
        { lat: 58.801220703124976, lng: -3.158544921874949 },
        { lat: 58.794189453124964, lng: -3.164941406249994 },
      ],
      [
        { lat: 59.02963867187497, lng: -3.057421874999931 },
        { lat: 59.004980468750034, lng: -3.07070312499999 },
        { lat: 59.005566406249976, lng: -2.99467773437496 },
        { lat: 58.98452148437502, lng: -2.884570312499989 },
        { lat: 58.98188476562505, lng: -2.817919921874988 },
        { lat: 58.95581054687506, lng: -2.762451171874972 },
        { lat: 58.90693359374995, lng: -2.793017578124989 },
        { lat: 58.89326171875001, lng: -2.826220703125017 },
        { lat: 58.890527343749994, lng: -2.863769531250028 },
        { lat: 58.93935546874999, lng: -2.994824218749983 },
        { lat: 58.919091796875016, lng: -3.166601562499977 },
        { lat: 58.92529296875006, lng: -3.2007812499999 },
        { lat: 58.938769531250045, lng: -3.223339843749983 },
        { lat: 58.955517578124976, lng: -3.232617187499926 },
        { lat: 58.989648437500016, lng: -3.232812499999966 },
        { lat: 58.99970703125001, lng: -3.242138671874926 },
        { lat: 58.96743164062502, lng: -3.304345703124965 },
        { lat: 58.97124023437498, lng: -3.331640624999948 },
        { lat: 58.98671875000005, lng: -3.347070312499966 },
        { lat: 59.01875, lng: -3.353710937500011 },
        { lat: 59.06499023437498, lng: -3.346826171874937 },
        { lat: 59.13081054687498, lng: -3.31035156249996 },
        { lat: 59.14394531249999, lng: -3.248583984374989 },
        { lat: 59.13632812500007, lng: -3.156494140624972 },
        { lat: 59.099023437499994, lng: -3.051123046875006 },
        { lat: 59.076025390625034, lng: -3.019238281249983 },
        { lat: 59.05766601562502, lng: -3.020019531249971 },
        { lat: 59.02963867187497, lng: -3.057421874999931 },
      ],
      [
        { lat: 59.231347656249966, lng: -2.548876953124989 },
        { lat: 59.23017578124998, lng: -2.662060546874955 },
        { lat: 59.28930664062505, lng: -2.603613281249949 },
        { lat: 59.30415039062495, lng: -2.535644531249972 },
        { lat: 59.297558593749955, lng: -2.406982421874943 },
        { lat: 59.27104492187504, lng: -2.429833984374994 },
        { lat: 59.231347656249966, lng: -2.548876953124989 },
      ],
      [
        { lat: 59.18676757812503, lng: -2.729394531249994 },
        { lat: 59.16191406250002, lng: -2.815234374999988 },
        { lat: 59.182470703125034, lng: -2.851855468749988 },
        { lat: 59.24682617187499, lng: -2.861425781249977 },
        { lat: 59.274365234375004, lng: -2.963769531249966 },
        { lat: 59.29145507812495, lng: -3.01347656249996 },
        { lat: 59.323876953124994, lng: -3.052050781250017 },
        { lat: 59.333837890625055, lng: -3.042236328124972 },
        { lat: 59.34711914062501, lng: -2.975537109374955 },
        { lat: 59.288330078125036, lng: -2.861621093749932 },
        { lat: 59.240820312500034, lng: -2.815039062499949 },
        { lat: 59.22675781250001, lng: -2.730664062499983 },
        { lat: 59.21948242187502, lng: -2.719921874999926 },
        { lat: 59.18676757812503, lng: -2.729394531249994 },
      ],
      [
        { lat: 60.5375, lng: -1.30810546875 },
        { lat: 60.467041015625, lng: -1.287402343749932 },
        { lat: 60.48530273437499, lng: -1.235742187499994 },
        { lat: 60.417724609374964, lng: -1.157763671874989 },
        { lat: 60.41762695312496, lng: -1.117968749999989 },
        { lat: 60.44448242187502, lng: -1.052441406249955 },
        { lat: 60.381591796875, lng: -1.065673828124971 },
        { lat: 60.20698242187495, lng: -1.133691406249994 },
        { lat: 60.177343750000034, lng: -1.152783203124955 },
        { lat: 60.12426757812497, lng: -1.165722656249926 },
        { lat: 60.113916015624994, lng: -1.179248046874932 },
        { lat: 60.00659179687497, lng: -1.199316406249949 },
        { lat: 59.971240234375074, lng: -1.245312499999983 },
        { lat: 59.88691406250001, lng: -1.28378906249992 },
        { lat: 59.87866210937503, lng: -1.299462890624994 },
        { lat: 59.911132812499964, lng: -1.355859374999937 },
        { lat: 60.03984375000002, lng: -1.299511718749926 },
        { lat: 60.11464843749996, lng: -1.27617187499996 },
        { lat: 60.15346679687496, lng: -1.290917968749937 },
        { lat: 60.188378906249966, lng: -1.32280273437496 },
        { lat: 60.18950195312502, lng: -1.409033203124949 },
        { lat: 60.173388671875045, lng: -1.48149414062496 },
        { lat: 60.193994140624966, lng: -1.496875 },
        { lat: 60.221777343750034, lng: -1.49912109374992 },
        { lat: 60.231005859375045, lng: -1.5166015625 },
        { lat: 60.2291015625, lng: -1.613037109374943 },
        { lat: 60.236767578124976, lng: -1.641357421874943 },
        { lat: 60.26225585937501, lng: -1.660058593750023 },
        { lat: 60.282519531250074, lng: -1.663769531249983 },
        { lat: 60.29838867187502, lng: -1.57666015625 },
        { lat: 60.29248046875006, lng: -1.494433593749932 },
        { lat: 60.332910156250016, lng: -1.374609374999949 },
        { lat: 60.468554687500045, lng: -1.449560546874949 },
        { lat: 60.48129882812506, lng: -1.548828125 },
        { lat: 60.49443359375007, lng: -1.571777343749972 },
        { lat: 60.51743164062503, lng: -1.552636718749966 },
        { lat: 60.52983398437498, lng: -1.498144531249977 },
        { lat: 60.598730468750006, lng: -1.414208984374937 },
        { lat: 60.609570312499976, lng: -1.363964843750011 },
        { lat: 60.607666015625064, lng: -1.301708984374926 },
        { lat: 60.5375, lng: -1.30810546875 },
      ],
      [
        { lat: 60.51386718750003, lng: -1.04252929687496 },
        { lat: 60.50229492187497, lng: -1.067871093749972 },
        { lat: 60.60390624999999, lng: -1.165527343749971 },
        { lat: 60.72021484374997, lng: -1.093310546874932 },
        { lat: 60.71650390625001, lng: -1.005615234375 },
        { lat: 60.68603515625003, lng: -0.991650390625011 },
        { lat: 60.658007812499996, lng: -1.000341796875006 },
        { lat: 60.65551757812502, lng: -1.045019531249949 },
        { lat: 60.646923828124955, lng: -1.049023437499955 },
        { lat: 60.592919921874966, lng: -1.035107421874983 },
        { lat: 60.530175781249966, lng: -1.03422851562496 },
        { lat: 60.51386718750003, lng: -1.04252929687496 },
      ],
      [
        { lat: 60.811962890625004, lng: -0.774267578124949 },
        { lat: 60.800488281249976, lng: -0.774316406249966 },
        { lat: 60.71616210937503, lng: -0.826171874999943 },
        { lat: 60.683935546875034, lng: -0.825488281249989 },
        { lat: 60.68701171875006, lng: -0.909130859374983 },
        { lat: 60.697265625, lng: -0.92226562499999 },
        { lat: 60.74565429687499, lng: -0.93808593749992 },
        { lat: 60.79716796875001, lng: -0.927539062499989 },
        { lat: 60.810449218749966, lng: -0.915820312500017 },
        { lat: 60.81591796875003, lng: -0.891406250000017 },
        { lat: 60.805810546874994, lng: -0.864941406249955 },
        { lat: 60.83188476562498, lng: -0.823437499999926 },
        { lat: 60.83125, lng: -0.80180664062496 },
        { lat: 60.811962890625004, lng: -0.774267578124949 },
      ],
    ],
  },
  {
    code: "HR",
    coordinates: [
      [
        { lat: 42.76904296874999, lng: 17.60781250000005 },
        { lat: 42.70034179687505, lng: 17.744238281250063 },
        { lat: 42.790380859375006, lng: 17.34414062500008 },
        { lat: 42.79863281249999, lng: 17.389550781249994 },
        { lat: 42.800390625, lng: 17.431933593750017 },
        { lat: 42.76904296874999, lng: 17.60781250000005 },
      ],
      [
        { lat: 42.99658203125, lng: 16.650683593750017 },
        { lat: 42.968652343749994, lng: 16.835546875000034 },
        { lat: 42.98149414062502, lng: 16.97109375000002 },
        { lat: 42.96435546875, lng: 17.093652343750023 },
        { lat: 42.93261718750003, lng: 17.16982421874999 },
        { lat: 42.917041015625045, lng: 17.188281250000045 },
        { lat: 42.91489257812506, lng: 17.089355468750057 },
        { lat: 42.92778320312502, lng: 16.9775390625 },
        { lat: 42.8955078125, lng: 16.850683593750006 },
        { lat: 42.912744140624966, lng: 16.738867187500063 },
        { lat: 42.93369140625006, lng: 16.696386718750006 },
        { lat: 42.959912109374976, lng: 16.666308593750017 },
        { lat: 42.99658203125, lng: 16.650683593750017 },
      ],
      [
        { lat: 43.02587890624999, lng: 17.219824218750063 },
        { lat: 42.850683593750034, lng: 17.72363281250003 },
        { lat: 42.897119140624994, lng: 17.667578125000063 },
        { lat: 42.91547851562498, lng: 17.74023437500003 },
        { lat: 42.90224609375005, lng: 17.80195312500001 },
        { lat: 42.845068359375034, lng: 17.84130859375003 },
        { lat: 42.80742187500002, lng: 17.918847656250023 },
        { lat: 42.74125976562502, lng: 18.044531250000034 },
        { lat: 42.690576171874994, lng: 18.123925781250048 },
        { lat: 42.59941406249999, lng: 18.304003906250045 },
        { lat: 42.58666992187497, lng: 18.346582031250023 },
        { lat: 42.55971679687499, lng: 18.436328125000017 },
        { lat: 42.52294921875006, lng: 18.438085937500006 },
        { lat: 42.48110351562505, lng: 18.476660156250063 },
        { lat: 42.43291015624999, lng: 18.517480468750023 },
        { lat: 42.52788085937499, lng: 18.3330078125 },
        { lat: 42.63403320312503, lng: 18.160644531249968 },
        { lat: 42.79741210937502, lng: 17.823828125 },
        { lat: 42.83715820312503, lng: 17.58496093750003 },
        { lat: 42.96845703125004, lng: 17.25820312500008 },
        { lat: 43.014892578125, lng: 17.045410156250057 },
        { lat: 43.025585937499955, lng: 17.126464843750057 },
        { lat: 43.02587890624999, lng: 17.219824218750063 },
      ],
      [
        { lat: 43.12578125000002, lng: 17.194042968750065 },
        { lat: 43.115429687499955, lng: 17.124121093750034 },
        { lat: 43.123144531250034, lng: 16.679199218750053 },
        { lat: 43.14389648437498, lng: 16.5498046875 },
        { lat: 43.19736328125003, lng: 16.405859375000063 },
        { lat: 43.21376953125002, lng: 16.37646484375003 },
        { lat: 43.22924804687506, lng: 16.52138671875005 },
        { lat: 43.21376953125002, lng: 16.65595703125004 },
        { lat: 43.174951171874994, lng: 16.697265625 },
        { lat: 43.14389648437498, lng: 17.061132812500063 },
        { lat: 43.12578125000002, lng: 17.194042968750065 },
      ],
      [
        { lat: 43.270654296874966, lng: 16.785253906250006 },
        { lat: 43.26806640624997, lng: 16.627441406249996 },
        { lat: 43.28618164062502, lng: 16.490332031250034 },
        { lat: 43.317236328125034, lng: 16.423144531250045 },
        { lat: 43.34340820312505, lng: 16.428125 },
        { lat: 43.387060546875055, lng: 16.44892578125004 },
        { lat: 43.38188476562499, lng: 16.601562500000057 },
        { lat: 43.35083007812506, lng: 16.834375 },
        { lat: 43.314648437499955, lng: 16.89130859375001 },
        { lat: 43.29794921875, lng: 16.873632812500063 },
        { lat: 43.270654296874966, lng: 16.785253906250006 },
      ],
      [
        { lat: 43.973828124999955, lng: 15.371386718750074 },
        { lat: 43.899511718750006, lng: 15.437207031250068 },
        { lat: 43.914794921875, lng: 15.374218750000038 },
        { lat: 43.96079101562506, lng: 15.30859375 },
        { lat: 44.01074218750003, lng: 15.270019531250028 },
        { lat: 43.973828124999955, lng: 15.371386718750074 },
      ],
      [
        { lat: 44.062304687500045, lng: 15.231054687500006 },
        { lat: 44.027050781249955, lng: 15.246679687499975 },
        { lat: 44.09331054687496, lng: 15.121875 },
        { lat: 44.137841796874966, lng: 15.074609375000023 },
        { lat: 44.157666015625004, lng: 15.065820312500078 },
        { lat: 44.062304687500045, lng: 15.231054687500006 },
      ],
      [
        { lat: 43.92236328125003, lng: 15.188769531249987 },
        { lat: 43.90771484375, lng: 15.203027343750051 },
        { lat: 43.89775390624999, lng: 15.201660156250059 },
        { lat: 43.91181640625001, lng: 15.149804687500051 },
        { lat: 43.90727539062499, lng: 15.13583984375006 },
        { lat: 44.125537109375045, lng: 14.891308593750068 },
        { lat: 44.16796874999997, lng: 14.865039062500045 },
        { lat: 44.11718750000003, lng: 14.952539062500025 },
        { lat: 43.92236328125003, lng: 15.188769531249987 },
      ],
      [
        { lat: 44.33574218749996, lng: 15.188476562500027 },
        { lat: 44.30917968749998, lng: 15.162597656249998 },
        { lat: 44.358154296875, lng: 15.097949218750074 },
        { lat: 44.393017578125004, lng: 15.038574218750055 },
        { lat: 44.43432617187497, lng: 14.99609375 },
        { lat: 44.48583984375, lng: 14.912792968750011 },
        { lat: 44.54472656249999, lng: 14.884667968750051 },
        { lat: 44.66474609375004, lng: 14.760449218750038 },
        { lat: 44.697363281250006, lng: 14.741894531250011 },
        { lat: 44.64868164062503, lng: 14.803808593750004 },
        { lat: 44.61826171875006, lng: 14.855371093750023 },
        { lat: 44.61083984374997, lng: 14.898046875 },
        { lat: 44.53422851562499, lng: 15.006445312500063 },
        { lat: 44.43574218750001, lng: 15.11298828125001 },
        { lat: 44.35019531249997, lng: 15.23994140625004 },
        { lat: 44.347558593749966, lng: 15.213574218749981 },
        { lat: 44.33574218749996, lng: 15.188476562500027 },
      ],
      [
        { lat: 44.75893554687502, lng: 14.831445312500023 },
        { lat: 44.71484375000002, lng: 14.856640625000013 },
        { lat: 44.75463867187506, lng: 14.7625 },
        { lat: 44.769873046875034, lng: 14.67822265625 },
        { lat: 44.7998046875, lng: 14.660351562499983 },
        { lat: 44.82436523437505, lng: 14.672460937500063 },
        { lat: 44.84814453125, lng: 14.690527343750004 },
        { lat: 44.844824218750034, lng: 14.754199218750015 },
        { lat: 44.82138671875006, lng: 14.763769531250004 },
        { lat: 44.75893554687502, lng: 14.831445312500023 },
      ],
      [
        { lat: 44.66005859375005, lng: 14.488085937500074 },
        { lat: 44.621240234375044, lng: 14.480371093750023 },
        { lat: 44.6703125, lng: 14.41953125000006 },
        { lat: 44.75830078125, lng: 14.388867187500011 },
        { lat: 44.90039062499997, lng: 14.31240234375008 },
        { lat: 44.94042968749997, lng: 14.302539062500017 },
        { lat: 44.97993164062501, lng: 14.342187500000023 },
        { lat: 45.01997070312501, lng: 14.340039062500011 },
        { lat: 45.144628906250006, lng: 14.285839843749981 },
        { lat: 45.16499023437498, lng: 14.33125 },
        { lat: 45.16743164062504, lng: 14.358203125000074 },
        { lat: 45.080957031249994, lng: 14.369140625 },
        { lat: 45.03125, lng: 14.39375 },
        { lat: 44.97021484375, lng: 14.467382812500034 },
        { lat: 44.86918945312502, lng: 14.452539062500023 },
        { lat: 44.72534179687503, lng: 14.467578125000074 },
        { lat: 44.693359375, lng: 14.482519531250006 },
        { lat: 44.66005859375005, lng: 14.488085937500074 },
      ],
      [
        { lat: 44.97705078124997, lng: 14.810253906250068 },
        { lat: 44.955615234375045, lng: 14.68701171875 },
        { lat: 44.99394531250004, lng: 14.628320312500051 },
        { lat: 45.02543945312496, lng: 14.612988281250042 },
        { lat: 45.03540039062506, lng: 14.51171875 },
        { lat: 45.079199218750006, lng: 14.450390625000038 },
        { lat: 45.09863281250006, lng: 14.437890625000051 },
        { lat: 45.146826171875006, lng: 14.524609375000038 },
        { lat: 45.224755859374994, lng: 14.571093750000019 },
        { lat: 45.17802734374996, lng: 14.629980468750034 },
        { lat: 45.09003906249998, lng: 14.701171875000059 },
        { lat: 45.06547851562504, lng: 14.739160156250051 },
        { lat: 44.97705078124997, lng: 14.810253906250068 },
      ],
      [
        { lat: 46.41640625000002, lng: 16.748046875000057 },
        { lat: 46.33930664062504, lng: 16.87148437500008 },
        { lat: 46.25366210937499, lng: 16.93994140624997 },
        { lat: 46.18730468749996, lng: 17.032714843750057 },
        { lat: 46.14033203124998, lng: 17.149609375000068 },
        { lat: 46.07661132812498, lng: 17.2421875 },
        { lat: 45.99614257812502, lng: 17.310644531250002 },
        { lat: 45.951074218749994, lng: 17.406347656250063 },
        { lat: 45.94130859375005, lng: 17.52919921875002 },
        { lat: 45.91376953125001, lng: 17.60703125 },
        { lat: 45.86835937500001, lng: 17.639648437500057 },
        { lat: 45.82724609374998, lng: 17.70644531250008 },
        { lat: 45.79042968750002, lng: 17.80712890625 },
        { lat: 45.77026367187499, lng: 17.96386718750003 },
        { lat: 45.765478515625006, lng: 18.263964843750074 },
        { lat: 45.76445312499999, lng: 18.290625 },
        { lat: 45.753027343750055, lng: 18.358300781250023 },
        { lat: 45.76733398437503, lng: 18.437304687500042 },
        { lat: 45.79614257812502, lng: 18.533593750000023 },
        { lat: 45.81328124999999, lng: 18.564648437500036 },
        { lat: 45.90747070312497, lng: 18.666015625 },
        { lat: 45.89936523437501, lng: 18.721777343749974 },
        { lat: 45.910839843749955, lng: 18.8330078125 },
        { lat: 45.931738281250034, lng: 18.900292968750023 },
        { lat: 45.931738281250034, lng: 18.905371093750006 },
        { lat: 45.90761718750002, lng: 18.90107421875001 },
        { lat: 45.86552734374995, lng: 18.8935546875 },
        { lat: 45.83574218750002, lng: 18.839062499999983 },
        { lat: 45.76708984374997, lng: 18.89453125 },
        { lat: 45.65581054687496, lng: 18.947265625 },
        { lat: 45.60083007812503, lng: 18.91787109375005 },
        { lat: 45.55800781250002, lng: 18.953710937499977 },
        { lat: 45.527246093749966, lng: 19.055078125000023 },
        { lat: 45.51499023437506, lng: 19.064257812500045 },
        { lat: 45.50219726562503, lng: 19.033300781250034 },
        { lat: 45.46582031249997, lng: 19.007617187500045 },
        { lat: 45.39951171875006, lng: 19.004687500000074 },
        { lat: 45.33691406249999, lng: 19.093066406250045 },
        { lat: 45.277978515624994, lng: 19.27285156250008 },
        { lat: 45.26806640625003, lng: 19.330273437500068 },
        { lat: 45.24541015625002, lng: 19.35224609375001 },
        { lat: 45.230615234375016, lng: 19.38232421875 },
        { lat: 45.2125, lng: 19.4 },
        { lat: 45.1890625, lng: 19.400976562500063 },
        { lat: 45.17299804687502, lng: 19.388085937500023 },
        { lat: 45.16728515624999, lng: 19.303027343750017 },
        { lat: 45.16777343750002, lng: 19.205957031250048 },
        { lat: 45.19624023437504, lng: 19.13691406250001 },
        { lat: 45.17548828124998, lng: 19.13076171875008 },
        { lat: 45.151708984375034, lng: 19.129687500000045 },
        { lat: 45.13720703125, lng: 19.062890625000023 },
        { lat: 44.973779296875016, lng: 19.1 },
        { lat: 44.92675781250003, lng: 19.085253906250042 },
        { lat: 44.910986328125006, lng: 19.060546875 },
        { lat: 44.91752929687502, lng: 19.037597656250025 },
        { lat: 44.91938476562504, lng: 19.00957031249999 },
        { lat: 44.90400390625001, lng: 18.99550781250008 },
        { lat: 44.86918945312502, lng: 19.007128906250045 },
        { lat: 44.865185546875004, lng: 18.94130859375005 },
        { lat: 44.883251953124955, lng: 18.836425781249996 },
        { lat: 44.914892578125006, lng: 18.788378906250045 },
        { lat: 44.94721679687501, lng: 18.78017578125008 },
        { lat: 44.97724609375001, lng: 18.779394531250006 },
        { lat: 45.02651367187502, lng: 18.746093750000057 },
        { lat: 45.07744140624999, lng: 18.66259765625 },
        { lat: 45.08583984375002, lng: 18.48828125000003 },
        { lat: 45.10200195312501, lng: 18.423925781250063 },
        { lat: 45.12055664062498, lng: 18.35761718750004 },
        { lat: 45.13427734375003, lng: 18.284960937500074 },
        { lat: 45.13291015625, lng: 18.21796875000001 },
        { lat: 45.119384765625, lng: 18.137207031249996 },
        { lat: 45.14179687499995, lng: 17.996289062500068 },
        { lat: 45.11186523437499, lng: 17.94863281250005 },
        { lat: 45.077246093750034, lng: 17.874414062500023 },
        { lat: 45.078125, lng: 17.812792968750074 },
        { lat: 45.158398437499955, lng: 17.690136718750036 },
        { lat: 45.16347656250002, lng: 17.65351562500004 },
        { lat: 45.12255859375003, lng: 17.54628906250005 },
        { lat: 45.12036132812502, lng: 17.50263671875004 },
        { lat: 45.13330078125, lng: 17.46914062500005 },
        { lat: 45.16396484375002, lng: 17.324121093750076 },
        { lat: 45.17055664062505, lng: 17.25869140625008 },
        { lat: 45.15605468750002, lng: 17.210644531250068 },
        { lat: 45.171777343750016, lng: 17.125390625000023 },
        { lat: 45.276562499999976, lng: 16.918652343749983 },
        { lat: 45.196875, lng: 16.79082031250007 },
        { lat: 45.21669921875002, lng: 16.53066406250008 },
        { lat: 45.162011718749994, lng: 16.45351562499999 },
        { lat: 45.058349609375, lng: 16.365039062500014 },
        { lat: 45.00883789062496, lng: 16.293359375000048 },
        { lat: 45.02661132812503, lng: 16.231054687500063 },
        { lat: 45.07221679687498, lng: 16.157324218750063 },
        { lat: 45.18959960937502, lng: 16.028320312500057 },
        { lat: 45.21079101562498, lng: 15.963183593750019 },
        { lat: 45.21572265625002, lng: 15.888281250000032 },
        { lat: 45.20278320312505, lng: 15.822851562500034 },
        { lat: 45.17895507812497, lng: 15.788085937500057 },
        { lat: 45.00751953124995, lng: 15.761523437500074 },
        { lat: 44.85639648437498, lng: 15.73798828125007 },
        { lat: 44.765820312500004, lng: 15.736621093750047 },
        { lat: 44.68193359374999, lng: 15.880078125000068 },
        { lat: 44.537597656249964, lng: 16.04902343750001 },
        { lat: 44.52099609375006, lng: 16.10341796875008 },
        { lat: 44.473730468750006, lng: 16.13027343750005 },
        { lat: 44.352001953124976, lng: 16.169824218750023 },
        { lat: 44.21513671874999, lng: 16.214257812500023 },
        { lat: 44.12451171874999, lng: 16.300097656250017 },
        { lat: 44.05961914062502, lng: 16.377539062500063 },
        { lat: 44.00258789062505, lng: 16.47207031250005 },
        { lat: 43.913183593750034, lng: 16.59052734375004 },
        { lat: 43.815039062500034, lng: 16.68769531250001 },
        { lat: 43.77880859375003, lng: 16.713476562500034 },
        { lat: 43.64902343750003, lng: 16.90185546875003 },
        { lat: 43.516552734374955, lng: 17.084570312500034 },
        { lat: 43.47021484375003, lng: 17.248046875000053 },
        { lat: 43.44575195312501, lng: 17.27382812500005 },
        { lat: 43.343847656250034, lng: 17.27529296875008 },
        { lat: 43.30561523437498, lng: 17.293066406250063 },
        { lat: 43.19892578125001, lng: 17.402246093750023 },
        { lat: 43.04277343749998, lng: 17.62480468750007 },
        { lat: 43.006591796875, lng: 17.650488281250063 },
        { lat: 42.980078125, lng: 17.657812500000034 },
        { lat: 42.959765625000045, lng: 17.64345703125005 },
        { lat: 42.93837890625005, lng: 17.585156250000068 },
        { lat: 42.962255859375006, lng: 17.53730468750001 },
        { lat: 43.11489257812502, lng: 17.329882812500017 },
        { lat: 43.21113281250001, lng: 17.12939453125003 },
        { lat: 43.392431640625006, lng: 16.903125 },
        { lat: 43.46406250000001, lng: 16.600292968750068 },
        { lat: 43.54335937500002, lng: 16.393945312500023 },
        { lat: 43.53125, lng: 16.26894531250005 },
        { lat: 43.50629882812501, lng: 16.13105468750004 },
        { lat: 43.50551757812502, lng: 16.045996093750034 },
        { lat: 43.519775390625, lng: 15.985546875000066 },
        { lat: 43.56894531249998, lng: 15.94257812500001 },
        { lat: 43.60698242187501, lng: 15.949121093749994 },
        { lat: 43.65664062499999, lng: 15.941503906250063 },
        { lat: 43.73593749999998, lng: 15.820605468750017 },
        { lat: 43.81127929687497, lng: 15.655664062500078 },
        { lat: 43.908789062500034, lng: 15.49941406250005 },
        { lat: 44.17211914062503, lng: 15.185839843750017 },
        { lat: 44.256787109374955, lng: 15.122949218749993 },
        { lat: 44.27290039062495, lng: 15.18466796875006 },
        { lat: 44.27143554687501, lng: 15.231347656250051 },
        { lat: 44.288818359375, lng: 15.284277343750006 },
        { lat: 44.28925781250001, lng: 15.369726562500006 },
        { lat: 44.27197265625003, lng: 15.470996093750044 },
        { lat: 44.32827148437505, lng: 15.381347656250057 },
        { lat: 44.38349609375001, lng: 15.269824218750072 },
        { lat: 44.602929687500044, lng: 14.981347656250023 },
        { lat: 44.70659179687502, lng: 14.895214843750066 },
        { lat: 44.81826171875005, lng: 14.885253906249972 },
        { lat: 44.971386718749976, lng: 14.906542968750044 },
        { lat: 45.08100585937501, lng: 14.854589843750034 },
        { lat: 45.22290039062506, lng: 14.63203125000001 },
        { lat: 45.297705078125006, lng: 14.550488281249981 },
        { lat: 45.342138671875006, lng: 14.386132812500081 },
        { lat: 45.33779296875002, lng: 14.31269531250004 },
        { lat: 45.28251953125002, lng: 14.268554687500028 },
        { lat: 45.15966796875006, lng: 14.236328125000027 },
        { lat: 44.99760742187499, lng: 14.090625 },
        { lat: 44.92719726562504, lng: 14.041992187500057 },
        { lat: 44.83564453125004, lng: 13.9658203125 },
        { lat: 44.829345703125, lng: 13.89980468750005 },
        { lat: 44.83740234375003, lng: 13.86074218750008 },
        { lat: 44.99150390624998, lng: 13.742480468750045 },
        { lat: 45.108203125000045, lng: 13.62929687500008 },
        { lat: 45.163427734375006, lng: 13.613476562500068 },
        { lat: 45.23139648437501, lng: 13.603320312500045 },
        { lat: 45.481787109375034, lng: 13.517187500000063 },
        { lat: 45.51689453124999, lng: 13.577929687500017 },
        { lat: 45.47675781249998, lng: 13.615234375000055 },
        { lat: 45.428369140624994, lng: 13.878710937500017 },
        { lat: 45.449804687500006, lng: 13.935644531250063 },
        { lat: 45.48261718750003, lng: 13.970117187500051 },
        { lat: 45.50336914062498, lng: 13.9703125 },
        { lat: 45.509423828124994, lng: 13.992773437500063 },
        { lat: 45.47783203125002, lng: 14.085546875000034 },
        { lat: 45.48515625000002, lng: 14.161230468750004 },
        { lat: 45.486621093750045, lng: 14.283007812500045 },
        { lat: 45.48144531250006, lng: 14.369921875000072 },
        { lat: 45.505761718750016, lng: 14.427343750000034 },
        { lat: 45.59521484375006, lng: 14.505175781249989 },
        { lat: 45.64526367187503, lng: 14.533984375000015 },
        { lat: 45.65722656249997, lng: 14.56884765625 },
        { lat: 45.65126953125002, lng: 14.591796875000055 },
        { lat: 45.610107421874964, lng: 14.608593750000013 },
        { lat: 45.57148437500001, lng: 14.649511718750006 },
        { lat: 45.50849609374998, lng: 14.733593749999983 },
        { lat: 45.478222656250004, lng: 14.793066406250034 },
        { lat: 45.46733398437501, lng: 14.847070312500021 },
        { lat: 45.49267578125003, lng: 14.9 },
        { lat: 45.499902343749994, lng: 14.954589843749998 },
        { lat: 45.450781250000034, lng: 15.110449218750036 },
        { lat: 45.44140624999997, lng: 15.242089843750023 },
        { lat: 45.46704101562506, lng: 15.339453125000063 },
        { lat: 45.502294921875034, lng: 15.326660156250028 },
        { lat: 45.541552734375045, lng: 15.291210937500011 },
        { lat: 45.5796875, lng: 15.28359375000005 },
        { lat: 45.61264648437506, lng: 15.290136718750034 },
        { lat: 45.64550781249999, lng: 15.356933593750055 },
        { lat: 45.659912109375, lng: 15.35371093750004 },
        { lat: 45.717724609374955, lng: 15.27294921875 },
        { lat: 45.73261718749998, lng: 15.27705078125004 },
        { lat: 45.797607421874964, lng: 15.454101562500057 },
        { lat: 45.834033203125045, lng: 15.624804687500015 },
        { lat: 45.86215820312498, lng: 15.652148437500074 },
        { lat: 45.90444335937499, lng: 15.668066406250032 },
        { lat: 45.98369140624996, lng: 15.675585937500045 },
        { lat: 46.04848632812502, lng: 15.666210937500011 },
        { lat: 46.109228515625055, lng: 15.596875 },
        { lat: 46.139990234375006, lng: 15.592578125000015 },
        { lat: 46.171923828125045, lng: 15.608984374999977 },
        { lat: 46.20073242187504, lng: 15.635937500000068 },
        { lat: 46.213232421875006, lng: 15.704199218750032 },
        { lat: 46.23398437499998, lng: 15.784277343750006 },
        { lat: 46.25786132812496, lng: 15.847558593750023 },
        { lat: 46.27763671874999, lng: 15.933300781250068 },
        { lat: 46.305371093749955, lng: 16.000683593750036 },
        { lat: 46.37133789062497, lng: 16.066503906250034 },
        { lat: 46.38222656249999, lng: 16.1064453125 },
        { lat: 46.37285156250001, lng: 16.22744140625005 },
        { lat: 46.389111328124955, lng: 16.25332031250008 },
        { lat: 46.48383789062498, lng: 16.23671875000008 },
        { lat: 46.507910156250006, lng: 16.258398437500034 },
        { lat: 46.52138671874999, lng: 16.30117187500005 },
        { lat: 46.53461914062504, lng: 16.321191406250048 },
        { lat: 46.5244140625, lng: 16.42763671875005 },
        { lat: 46.499902343749966, lng: 16.516210937499977 },
        { lat: 46.48500976562505, lng: 16.569921875 },
        { lat: 46.41640625000002, lng: 16.748046875000057 },
      ],
    ],
  },
  {
    code: "GR",
    coordinates: [
      [
        { lat: 35.53544921874999, lng: 23.852246093749983 },
        { lat: 35.528173828125, lng: 23.920605468750068 },
        { lat: 35.52944335937502, lng: 24.013281250000034 },
        { lat: 35.535400390624964, lng: 24.034375 },
        { lat: 35.59384765624998, lng: 24.093359375 },
        { lat: 35.59521484375, lng: 24.166015625000057 },
        { lat: 35.537451171875034, lng: 24.197753906250025 },
        { lat: 35.510839843750034, lng: 24.12402343750003 },
        { lat: 35.49580078124998, lng: 24.108984374999977 },
        { lat: 35.483642578125, lng: 24.123144531250034 },
        { lat: 35.45952148437499, lng: 24.178515625000017 },
        { lat: 35.468603515625055, lng: 24.255371093750057 },
        { lat: 35.42314453125002, lng: 24.25771484375008 },
        { lat: 35.385986328125, lng: 24.274902343750025 },
        { lat: 35.36381835937502, lng: 24.31289062500005 },
        { lat: 35.359472656250034, lng: 24.35400390625 },
        { lat: 35.36601562500002, lng: 24.444921875000034 },
        { lat: 35.380761718749994, lng: 24.53457031249999 },
        { lat: 35.409912109375, lng: 24.626953125 },
        { lat: 35.4248046875, lng: 24.721289062500034 },
        { lat: 35.40986328124998, lng: 25.003125 },
        { lat: 35.34692382812503, lng: 25.104296875000074 },
        { lat: 35.33935546875, lng: 25.296777343750023 },
        { lat: 35.30620117187502, lng: 25.475683593750063 },
        { lat: 35.328076171875004, lng: 25.569628906250017 },
        { lat: 35.34858398437501, lng: 25.73017578125004 },
        { lat: 35.32636718750004, lng: 25.75585937500003 },
        { lat: 35.18403320312498, lng: 25.735156250000074 },
        { lat: 35.142724609374994, lng: 25.74501953125005 },
        { lat: 35.122851562500045, lng: 25.791308593750074 },
        { lat: 35.13256835937497, lng: 25.837109375000068 },
        { lat: 35.17919921874997, lng: 25.893359375000074 },
        { lat: 35.215283203124955, lng: 26.028027343750065 },
        { lat: 35.215087890625, lng: 26.16787109375005 },
        { lat: 35.309765625, lng: 26.285546875000023 },
        { lat: 35.315136718749955, lng: 26.32021484375008 },
        { lat: 35.26860351562499, lng: 26.298632812500045 },
        { lat: 35.15922851562499, lng: 26.280859375000063 },
        { lat: 35.09516601562501, lng: 26.25556640625004 },
        { lat: 35.04467773437503, lng: 26.244335937500068 },
        { lat: 35.01860351562504, lng: 26.165625 },
        { lat: 35.01416015625003, lng: 26.046679687500045 },
        { lat: 35.025195312500045, lng: 25.829687500000063 },
        { lat: 35.00732421875006, lng: 25.6109375 },
        { lat: 34.95927734375002, lng: 25.20576171875004 },
        { lat: 34.93447265625002, lng: 24.79980468750003 },
        { lat: 34.950634765624955, lng: 24.745214843750006 },
        { lat: 35.014355468749955, lng: 24.743945312500017 },
        { lat: 35.05830078125004, lng: 24.735156250000017 },
        { lat: 35.08906250000001, lng: 24.70888671875008 },
        { lat: 35.115332031250034, lng: 24.583398437499994 },
        { lat: 35.160351562499955, lng: 24.463671875000045 },
        { lat: 35.22192382812497, lng: 23.994335937500065 },
        { lat: 35.24609375000002, lng: 23.883593750000074 },
        { lat: 35.233496093750034, lng: 23.703906250000074 },
        { lat: 35.23515625000002, lng: 23.63808593750005 },
        { lat: 35.257226562499966, lng: 23.59277343749997 },
        { lat: 35.29516601562497, lng: 23.561621093750034 },
        { lat: 35.41557617187499, lng: 23.54755859375001 },
        { lat: 35.534765625000034, lng: 23.56982421875 },
        { lat: 35.56625976562506, lng: 23.608691406250017 },
        { lat: 35.530371093750034, lng: 23.626562500000034 },
        { lat: 35.51391601562506, lng: 23.67265624999999 },
        { lat: 35.55014648437506, lng: 23.715429687500006 },
        { lat: 35.60473632812497, lng: 23.71503906250001 },
        { lat: 35.65551757812502, lng: 23.73691406250003 },
        { lat: 35.634228515624955, lng: 23.770800781250017 },
        { lat: 35.556201171875045, lng: 23.79335937500008 },
        { lat: 35.53544921874999, lng: 23.852246093749983 },
      ],
      [
        { lat: 35.46528320312498, lng: 27.17607421874999 },
        { lat: 35.409082031249994, lng: 27.137890625000036 },
        { lat: 35.45644531249996, lng: 27.099121093750057 },
        { lat: 35.51113281250002, lng: 27.11582031250006 },
        { lat: 35.59775390624998, lng: 27.070703125000023 },
        { lat: 35.72626953124995, lng: 27.156054687500017 },
        { lat: 35.78867187499998, lng: 27.158007812500042 },
        { lat: 35.820458984374966, lng: 27.22314453125 },
        { lat: 35.714453125000034, lng: 27.20703125 },
        { lat: 35.62949218750006, lng: 27.157226562499968 },
        { lat: 35.55893554687498, lng: 27.208886718750023 },
        { lat: 35.478564453125045, lng: 27.23359374999998 },
        { lat: 35.46528320312498, lng: 27.17607421874999 },
      ],
      [
        { lat: 36.18979492187498, lng: 23.053808593750034 },
        { lat: 36.14638671875002, lng: 23.042187500000068 },
        { lat: 36.17622070312498, lng: 22.93945312500003 },
        { lat: 36.220996093750045, lng: 22.91083984375004 },
        { lat: 36.32031250000003, lng: 22.90566406250005 },
        { lat: 36.36875, lng: 22.932617187500057 },
        { lat: 36.38393554687502, lng: 22.950488281250045 },
        { lat: 36.328125, lng: 22.997851562500017 },
        { lat: 36.24658203124999, lng: 23.09707031250008 },
        { lat: 36.18979492187498, lng: 23.053808593750034 },
      ],
      [
        { lat: 35.92929687500003, lng: 27.84277343750003 },
        { lat: 35.908300781250006, lng: 27.770605468750063 },
        { lat: 35.91103515625002, lng: 27.745703125000063 },
        { lat: 35.95732421874996, lng: 27.71552734375004 },
        { lat: 36.069189453125006, lng: 27.75732421875003 },
        { lat: 36.14111328125, lng: 27.71865234375005 },
        { lat: 36.171582031250004, lng: 27.71630859375003 },
        { lat: 36.21376953124999, lng: 27.77441406250003 },
        { lat: 36.27695312499998, lng: 27.815234375000017 },
        { lat: 36.345312500000034, lng: 27.91445312500005 },
        { lat: 36.42622070312501, lng: 28.171484375000034 },
        { lat: 36.43364257812502, lng: 28.23183593750005 },
        { lat: 36.370263671874966, lng: 28.230078125000063 },
        { lat: 36.209863281249994, lng: 28.14404296875003 },
        { lat: 36.12968749999999, lng: 28.067675781250017 },
        { lat: 36.06533203125002, lng: 28.087792968750023 },
        { lat: 36.04750976562505, lng: 27.965527343750065 },
        { lat: 35.92929687500003, lng: 27.84277343750003 },
      ],
      [
        { lat: 36.39262695312502, lng: 25.48242187500003 },
        { lat: 36.34008789062506, lng: 25.43593750000005 },
        { lat: 36.35893554687499, lng: 25.37050781250005 },
        { lat: 36.37895507812496, lng: 25.397167968750065 },
        { lat: 36.404882812500006, lng: 25.41289062500007 },
        { lat: 36.442285156249994, lng: 25.414648437500063 },
        { lat: 36.46533203124997, lng: 25.396875 },
        { lat: 36.473730468750006, lng: 25.408984375000074 },
        { lat: 36.43505859375003, lng: 25.467382812500063 },
        { lat: 36.39262695312502, lng: 25.48242187500003 },
      ],
      [
        { lat: 36.58540039062501, lng: 26.46064453125001 },
        { lat: 36.56152343750003, lng: 26.38164062500007 },
        { lat: 36.51137695312505, lng: 26.33144531250005 },
        { lat: 36.54692382812499, lng: 26.270019531250053 },
        { lat: 36.59541015625001, lng: 26.269824218750017 },
        { lat: 36.58056640624999, lng: 26.33701171875003 },
        { lat: 36.60786132812498, lng: 26.38417968750005 },
        { lat: 36.63857421875002, lng: 26.370019531250023 },
        { lat: 36.62421875000001, lng: 26.42128906250005 },
        { lat: 36.58540039062501, lng: 26.46064453125001 },
      ],
      [
        { lat: 36.55390625000001, lng: 27.860156250000017 },
        { lat: 36.53798828125005, lng: 27.83828125000008 },
        { lat: 36.58369140625004, lng: 27.788085937499968 },
        { lat: 36.607519531250006, lng: 27.785742187500034 },
        { lat: 36.634863281250055, lng: 27.836816406250048 },
        { lat: 36.64116210937502, lng: 27.8625 },
        { lat: 36.62250976562504, lng: 27.86982421875004 },
        { lat: 36.58266601562499, lng: 27.86904296875005 },
        { lat: 36.55390625000001, lng: 27.860156250000017 },
      ],
      [
        { lat: 36.763769531250034, lng: 24.535742187500063 },
        { lat: 36.70502929687495, lng: 24.5375 },
        { lat: 36.68398437500002, lng: 24.530664062499994 },
        { lat: 36.655615234375034, lng: 24.325976562500045 },
        { lat: 36.72299804687498, lng: 24.344921875 },
        { lat: 36.744287109374966, lng: 24.357421875000057 },
        { lat: 36.71293945312499, lng: 24.425195312500023 },
        { lat: 36.728955078124955, lng: 24.450195312500053 },
        { lat: 36.747460937499994, lng: 24.460351562500076 },
        { lat: 36.763769531250034, lng: 24.535742187500063 },
      ],
      [
        { lat: 36.67402343749995, lng: 25.38173828125002 },
        { lat: 36.65834960937505, lng: 25.364355468750034 },
        { lat: 36.721533203125034, lng: 25.288671875000063 },
        { lat: 36.75844726562502, lng: 25.25996093749998 },
        { lat: 36.789160156250055, lng: 25.29589843750003 },
        { lat: 36.71733398437499, lng: 25.40693359375001 },
        { lat: 36.67402343749995, lng: 25.38173828125002 },
      ],
      [
        { lat: 36.72709960937502, lng: 26.94960937500005 },
        { lat: 36.72592773437506, lng: 26.91835937500008 },
        { lat: 36.77421875000002, lng: 26.95556640625003 },
        { lat: 36.84038085937502, lng: 27.061132812500034 },
        { lat: 36.898632812499976, lng: 27.214941406250006 },
        { lat: 36.90512695312506, lng: 27.265625 },
        { lat: 36.86889648437506, lng: 27.352148437499977 },
        { lat: 36.809130859375045, lng: 27.193164062500017 },
        { lat: 36.777587890625, lng: 27.150976562500034 },
        { lat: 36.77075195312503, lng: 27.033593750000023 },
        { lat: 36.72709960937502, lng: 26.94960937500005 },
      ],
      [
        { lat: 36.79042968750005, lng: 25.859375 },
        { lat: 36.78222656249997, lng: 25.771093750000034 },
        { lat: 36.78974609374998, lng: 25.74316406250003 },
        { lat: 36.807031249999966, lng: 25.796777343750023 },
        { lat: 36.82539062499998, lng: 25.834375 },
        { lat: 36.84755859375005, lng: 25.852441406250076 },
        { lat: 36.886572265625006, lng: 25.941992187500034 },
        { lat: 36.937402343749966, lng: 26.000683593749983 },
        { lat: 36.902734375000016, lng: 26.064453125000025 },
        { lat: 36.87968750000002, lng: 25.984667968750017 },
        { lat: 36.79042968750005, lng: 25.859375 },
      ],
      [
        { lat: 36.92143554687499, lng: 24.72089843750004 },
        { lat: 36.91708984375, lng: 24.702636718750053 },
        { lat: 36.95927734374998, lng: 24.676464843750036 },
        { lat: 36.99858398437499, lng: 24.670996093750002 },
        { lat: 37.021630859374994, lng: 24.681445312500074 },
        { lat: 37.02382812499999, lng: 24.716113281250045 },
        { lat: 36.94921874999997, lng: 24.76318359375003 },
        { lat: 36.92143554687499, lng: 24.72089843750004 },
      ],
      [
        { lat: 36.95903320312502, lng: 27.01972656250004 },
        { lat: 36.945214843750044, lng: 26.919921875000025 },
        { lat: 37.02460937499998, lng: 26.93769531250001 },
        { lat: 37.087255859375034, lng: 26.88867187499997 },
        { lat: 37.05209960937498, lng: 26.966601562500045 },
        { lat: 37.00966796875002, lng: 27.01601562500008 },
        { lat: 37.00156249999998, lng: 27.040136718750006 },
        { lat: 36.97597656250002, lng: 27.034570312500048 },
        { lat: 36.95903320312502, lng: 27.01972656250004 },
      ],
      [
        { lat: 37.06840820312502, lng: 25.278906250000034 },
        { lat: 36.991308593750034, lng: 25.19941406250001 },
        { lat: 36.99965820312505, lng: 25.13330078125003 },
        { lat: 37.034960937500045, lng: 25.105468750000057 },
        { lat: 37.10742187500006, lng: 25.146484375000057 },
        { lat: 37.148535156250006, lng: 25.235058593750068 },
        { lat: 37.13784179687502, lng: 25.275292968749994 },
        { lat: 37.08417968750004, lng: 25.27148437500003 },
        { lat: 37.06840820312502, lng: 25.278906250000034 },
      ],
      [
        { lat: 36.96757812499999, lng: 25.54589843749997 },
        { lat: 36.9296875, lng: 25.456738281250008 },
        { lat: 36.984375, lng: 25.39589843750005 },
        { lat: 37.07041015624998, lng: 25.36191406250006 },
        { lat: 37.19638671875006, lng: 25.52529296875005 },
        { lat: 37.18510742187499, lng: 25.564355468750023 },
        { lat: 37.15253906250001, lng: 25.587890625 },
        { lat: 37.03930664062503, lng: 25.58427734375007 },
        { lat: 36.96757812499999, lng: 25.54589843749997 },
      ],
      [
        { lat: 37.125097656250006, lng: 24.523535156250063 },
        { lat: 37.110058593749976, lng: 24.486523437500068 },
        { lat: 37.13198242187499, lng: 24.42480468750003 },
        { lat: 37.18686523437498, lng: 24.441210937500074 },
        { lat: 37.21020507812503, lng: 24.48378906250005 },
        { lat: 37.19233398437504, lng: 24.529101562500045 },
        { lat: 37.16767578124998, lng: 24.535937500000014 },
        { lat: 37.125097656250006, lng: 24.523535156250063 },
      ],
      [
        { lat: 37.34443359375001, lng: 24.43574218750004 },
        { lat: 37.314111328124966, lng: 24.37890625 },
        { lat: 37.383447265624966, lng: 24.397753906250017 },
        { lat: 37.41962890624998, lng: 24.369726562500002 },
        { lat: 37.45039062500003, lng: 24.394824218750042 },
        { lat: 37.4751953125, lng: 24.43125 },
        { lat: 37.449560546875034, lng: 24.44853515625007 },
        { lat: 37.40800781250002, lng: 24.48144531250003 },
        { lat: 37.34443359375001, lng: 24.43574218750004 },
      ],
      [
        { lat: 37.493505859375, lng: 24.942871093750057 },
        { lat: 37.38969726562502, lng: 24.937890625000023 },
        { lat: 37.39057617187501, lng: 24.91152343750005 },
        { lat: 37.40659179687498, lng: 24.89619140625004 },
        { lat: 37.44633789062499, lng: 24.895312500000042 },
        { lat: 37.508886718750034, lng: 24.906542968750017 },
        { lat: 37.493505859375, lng: 24.942871093750057 },
      ],
      [
        { lat: 37.419140624999955, lng: 25.402734375000023 },
        { lat: 37.41298828125005, lng: 25.30712890625 },
        { lat: 37.48930664062496, lng: 25.312695312500068 },
        { lat: 37.50917968750002, lng: 25.348144531250025 },
        { lat: 37.47109375, lng: 25.462988281250063 },
        { lat: 37.44707031249996, lng: 25.45742187500008 },
        { lat: 37.419140624999955, lng: 25.402734375000023 },
      ],
      [
        { lat: 37.529394531250034, lng: 26.029296875000057 },
        { lat: 37.52558593749998, lng: 25.982421875 },
        { lat: 37.56557617187505, lng: 25.99677734375001 },
        { lat: 37.63491210937505, lng: 26.086328125000023 },
        { lat: 37.638281250000034, lng: 26.211523437500063 },
        { lat: 37.67304687500001, lng: 26.325585937500023 },
        { lat: 37.67431640625, lng: 26.351367187500014 },
        { lat: 37.61958007812504, lng: 26.296875 },
        { lat: 37.56850585937502, lng: 26.204882812500017 },
        { lat: 37.529394531250034, lng: 26.029296875000057 },
      ],
      [
        { lat: 37.59960937500006, lng: 25.255859375000057 },
        { lat: 37.535107421874955, lng: 25.21875 },
        { lat: 37.54506835937505, lng: 25.156347656250034 },
        { lat: 37.61445312499995, lng: 25.051953125000068 },
        { lat: 37.645947265624976, lng: 25.016308593750008 },
        { lat: 37.676904296874994, lng: 24.99648437500005 },
        { lat: 37.68066406250006, lng: 25.039355468750074 },
        { lat: 37.64799804687496, lng: 25.091796875000025 },
        { lat: 37.63066406249999, lng: 25.225390625000045 },
        { lat: 37.59960937500006, lng: 25.255859375000057 },
      ],
      [
        { lat: 37.57685546875003, lng: 24.355957031250025 },
        { lat: 37.528271484374976, lng: 24.288964843750048 },
        { lat: 37.60112304687502, lng: 24.277441406250034 },
        { lat: 37.67773437499997, lng: 24.320410156250063 },
        { lat: 37.68271484375, lng: 24.379101562500036 },
        { lat: 37.649023437500006, lng: 24.400781250000023 },
        { lat: 37.57685546875003, lng: 24.355957031250025 },
      ],
      [
        { lat: 37.81142578125005, lng: 26.82441406250004 },
        { lat: 37.778466796874994, lng: 26.947363281250034 },
        { lat: 37.781982421875, lng: 26.981542968750063 },
        { lat: 37.77001953125003, lng: 27.039648437500006 },
        { lat: 37.70927734375002, lng: 27.05507812500005 },
        { lat: 37.70048828124999, lng: 26.978125 },
        { lat: 37.644726562500004, lng: 26.844921875000036 },
        { lat: 37.65698242187503, lng: 26.78828125000004 },
        { lat: 37.70546875000002, lng: 26.720507812500017 },
        { lat: 37.71049804687499, lng: 26.612890625 },
        { lat: 37.723730468750034, lng: 26.58105468750003 },
        { lat: 37.78085937500003, lng: 26.63867187500003 },
        { lat: 37.809765624999955, lng: 26.74335937500004 },
        { lat: 37.81142578125005, lng: 26.82441406250004 },
      ],
      [
        { lat: 37.805371093749955, lng: 20.888476562500074 },
        { lat: 37.70800781250003, lng: 20.993945312500074 },
        { lat: 37.73212890624995, lng: 20.909082031249994 },
        { lat: 37.66474609375001, lng: 20.818554687500036 },
        { lat: 37.74345703124996, lng: 20.70380859375001 },
        { lat: 37.82314453125002, lng: 20.635058593750045 },
        { lat: 37.855029296875045, lng: 20.619531250000076 },
        { lat: 37.92954101562503, lng: 20.691503906250002 },
        { lat: 37.85297851562498, lng: 20.758691406249994 },
        { lat: 37.84072265624996, lng: 20.83984375000003 },
        { lat: 37.805371093749955, lng: 20.888476562500074 },
      ],
      [
        { lat: 37.75961914062506, lng: 24.991699218750057 },
        { lat: 37.69238281250002, lng: 24.962207031250074 },
        { lat: 37.77050781250006, lng: 24.884082031250074 },
        { lat: 37.82402343750002, lng: 24.79853515625004 },
        { lat: 37.87070312500003, lng: 24.766503906249994 },
        { lat: 37.89887695312501, lng: 24.71435546875003 },
        { lat: 37.961669921875, lng: 24.700195312499996 },
        { lat: 37.9875, lng: 24.763378906250068 },
        { lat: 37.99013671875002, lng: 24.79042968750008 },
        { lat: 37.913671875, lng: 24.855078125 },
        { lat: 37.90478515625006, lng: 24.956347656250045 },
        { lat: 37.85766601562506, lng: 24.94843750000004 },
        { lat: 37.79692382812502, lng: 24.98046874999997 },
        { lat: 37.75961914062506, lng: 24.991699218750057 },
      ],
      [
        { lat: 37.925878906250006, lng: 23.550976562499983 },
        { lat: 37.90117187500002, lng: 23.51142578125001 },
        { lat: 37.90239257812502, lng: 23.46679687499997 },
        { lat: 37.911474609375006, lng: 23.43525390625004 },
        { lat: 37.93125, lng: 23.41933593750008 },
        { lat: 37.940673828125, lng: 23.4390625 },
        { lat: 37.98037109374999, lng: 23.462207031250017 },
        { lat: 37.991113281249966, lng: 23.483691406250045 },
        { lat: 37.98603515624998, lng: 23.51552734375005 },
        { lat: 37.97021484374997, lng: 23.534863281249983 },
        { lat: 37.925878906250006, lng: 23.550976562499983 },
      ],
      [
        { lat: 38.38334960937502, lng: 20.61230468750003 },
        { lat: 38.267871093750045, lng: 20.624707031250068 },
        { lat: 38.24619140625006, lng: 20.69521484375005 },
        { lat: 38.14208984375, lng: 20.788867187500017 },
        { lat: 38.08881835937498, lng: 20.780761718750053 },
        { lat: 38.07055664062497, lng: 20.761328125 },
        { lat: 38.11972656250006, lng: 20.60615234375001 },
        { lat: 38.09765625, lng: 20.568945312499977 },
        { lat: 38.10664062499995, lng: 20.523535156250063 },
        { lat: 38.164160156250034, lng: 20.495507812500023 },
        { lat: 38.184375, lng: 20.498730468750068 },
        { lat: 38.21879882812499, lng: 20.47333984375004 },
        { lat: 38.23417968750002, lng: 20.4521484375 },
        { lat: 38.18842773437501, lng: 20.39101562500005 },
        { lat: 38.179882812499955, lng: 20.35253906250003 },
        { lat: 38.22172851562496, lng: 20.352246093750068 },
        { lat: 38.336767578125034, lng: 20.40869140625003 },
        { lat: 38.356201171875, lng: 20.435058593750057 },
        { lat: 38.31821289062498, lng: 20.4814453125 },
        { lat: 38.33232421875002, lng: 20.519628906250063 },
        { lat: 38.39453125, lng: 20.548339843750057 },
        { lat: 38.45654296875003, lng: 20.55029296875 },
        { lat: 38.47495117187503, lng: 20.563183593750068 },
        { lat: 38.38334960937502, lng: 20.61230468750003 },
      ],
      [
        { lat: 38.32944335937506, lng: 20.758691406249994 },
        { lat: 38.31860351562497, lng: 20.709277343750074 },
        { lat: 38.41430664062502, lng: 20.64638671875005 },
        { lat: 38.48032226562498, lng: 20.623632812500034 },
        { lat: 38.483984375, lng: 20.649707031250017 },
        { lat: 38.47631835937506, lng: 20.674804687500057 },
        { lat: 38.45141601562503, lng: 20.701269531250034 },
        { lat: 38.425927734374994, lng: 20.70107421875008 },
        { lat: 38.39863281250004, lng: 20.711621093750008 },
        { lat: 38.36577148437499, lng: 20.73916015625002 },
        { lat: 38.32944335937506, lng: 20.758691406249994 },
      ],
      [
        { lat: 38.21806640625002, lng: 26.094042968750017 },
        { lat: 38.16152343750005, lng: 25.99853515625 },
        { lat: 38.243310546874994, lng: 25.891894531250042 },
        { lat: 38.269628906250034, lng: 25.874316406250017 },
        { lat: 38.30263671875002, lng: 25.952636718750057 },
        { lat: 38.353515625, lng: 25.991406250000068 },
        { lat: 38.41601562500003, lng: 25.959960937500053 },
        { lat: 38.508398437500006, lng: 25.85126953125001 },
        { lat: 38.57402343749996, lng: 25.846093750000023 },
        { lat: 38.601708984375016, lng: 26.0125 },
        { lat: 38.54462890625001, lng: 26.11044921875006 },
        { lat: 38.540722656250004, lng: 26.160351562500008 },
        { lat: 38.486181640625006, lng: 26.141210937500034 },
        { lat: 38.468457031249955, lng: 26.149609375000036 },
        { lat: 38.30292968749998, lng: 26.157031250000042 },
        { lat: 38.279638671875034, lng: 26.11074218750002 },
        { lat: 38.23417968750002, lng: 26.103125 },
        { lat: 38.21806640625002, lng: 26.094042968750017 },
      ],
      [
        { lat: 38.60869140625002, lng: 20.68671875000001 },
        { lat: 38.60097656250005, lng: 20.64785156250008 },
        { lat: 38.60625, lng: 20.614355468750002 },
        { lat: 38.601708984375016, lng: 20.58398437500003 },
        { lat: 38.58256835937502, lng: 20.5546875 },
        { lat: 38.66186523437499, lng: 20.557910156250045 },
        { lat: 38.760156249999966, lng: 20.592480468750068 },
        { lat: 38.81757812500004, lng: 20.63466796875005 },
        { lat: 38.84423828125003, lng: 20.69414062499999 },
        { lat: 38.799169921875006, lng: 20.71962890625005 },
        { lat: 38.63833007812502, lng: 20.714843750000057 },
        { lat: 38.60869140625002, lng: 20.68671875000001 },
      ],
      [
        { lat: 38.80922851562502, lng: 24.67470703125005 },
        { lat: 38.78481445312502, lng: 24.56904296875001 },
        { lat: 38.788671875, lng: 24.54101562499997 },
        { lat: 38.81943359375006, lng: 24.56455078125006 },
        { lat: 38.832373046875034, lng: 24.56640625 },
        { lat: 38.88862304687501, lng: 24.461035156250034 },
        { lat: 38.96166992187497, lng: 24.473437500000074 },
        { lat: 38.98027343750004, lng: 24.485644531250074 },
        { lat: 38.942236328125034, lng: 24.564062500000063 },
        { lat: 38.87885742187498, lng: 24.58125 },
        { lat: 38.80922851562502, lng: 24.67470703125005 },
      ],
      [
        { lat: 38.958642578124994, lng: 23.41542968750008 },
        { lat: 38.85009765625, lng: 23.471972656250074 },
        { lat: 38.8134765625, lng: 23.525 },
        { lat: 38.77021484374998, lng: 23.63623046875003 },
        { lat: 38.76469726562499, lng: 23.68847656250003 },
        { lat: 38.68657226562499, lng: 23.878222656250045 },
        { lat: 38.670996093750006, lng: 24.09902343750008 },
        { lat: 38.648486328125045, lng: 24.127539062500034 },
        { lat: 38.58828125000002, lng: 24.15468750000005 },
        { lat: 38.54101562499999, lng: 24.199707031249996 },
        { lat: 38.50424804687506, lng: 24.211035156250006 },
        { lat: 38.46342773437498, lng: 24.1875 },
        { lat: 38.33862304687497, lng: 24.22011718750008 },
        { lat: 38.22001953124996, lng: 24.27578125000005 },
        { lat: 38.1625, lng: 24.359667968750074 },
        { lat: 38.14511718749998, lng: 24.463964843750006 },
        { lat: 38.14750976562501, lng: 24.563281250000074 },
        { lat: 38.12397460937504, lng: 24.58837890625003 },
        { lat: 38.02016601562502, lng: 24.57851562500008 },
        { lat: 37.97973632812506, lng: 24.53652343750005 },
        { lat: 37.969921875, lng: 24.502343750000023 },
        { lat: 37.98051757812501, lng: 24.47265625 },
        { lat: 38.004980468750034, lng: 24.445800781250025 },
        { lat: 38.01655273437498, lng: 24.41650390625003 },
        { lat: 38.01855468750006, lng: 24.359472656250034 },
        { lat: 38.060351562500045, lng: 24.31777343750008 },
        { lat: 38.11752929687506, lng: 24.212011718750006 },
        { lat: 38.15166015624999, lng: 24.19257812500004 },
        { lat: 38.204296874999955, lng: 24.189062500000034 },
        { lat: 38.24306640625005, lng: 24.144140625000034 },
        { lat: 38.31684570312498, lng: 24.102832031250074 },
        { lat: 38.337207031250045, lng: 24.063574218750063 },
        { lat: 38.374121093750006, lng: 24.04189453125008 },
        { lat: 38.389990234375034, lng: 24.040136718750002 },
        { lat: 38.400732421875006, lng: 23.88623046875 },
        { lat: 38.401220703125034, lng: 23.758789062500057 },
        { lat: 38.44306640625001, lng: 23.65078125000008 },
        { lat: 38.55253906250004, lng: 23.61738281250001 },
        { lat: 38.58198242187498, lng: 23.553320312500034 },
        { lat: 38.612939453124994, lng: 23.505273437499994 },
        { lat: 38.655859375000034, lng: 23.465234375000023 },
        { lat: 38.735009765624994, lng: 23.364062500000014 },
        { lat: 38.80122070312498, lng: 23.252148437500036 },
        { lat: 38.84482421874998, lng: 23.143945312500023 },
        { lat: 38.873388671875034, lng: 23.029101562500074 },
        { lat: 38.83964843749999, lng: 22.935742187500065 },
        { lat: 38.84765625000003, lng: 22.88134765625 },
        { lat: 38.870507812499966, lng: 22.870312500000068 },
        { lat: 38.915917968749994, lng: 22.986328125000057 },
        { lat: 39.002685546875, lng: 23.145800781250045 },
        { lat: 39.03134765625006, lng: 23.25820312500002 },
        { lat: 39.03491210937497, lng: 23.31269531250004 },
        { lat: 38.958642578124994, lng: 23.41542968750008 },
      ],
      [
        { lat: 39.11440429687502, lng: 23.779785156250057 },
        { lat: 39.08056640625006, lng: 23.735156250000045 },
        { lat: 39.09536132812505, lng: 23.666113281250002 },
        { lat: 39.20859375, lng: 23.59394531250004 },
        { lat: 39.11440429687502, lng: 23.779785156250057 },
      ],
      [
        { lat: 39.15830078124998, lng: 23.887988281250074 },
        { lat: 39.146582031250006, lng: 23.84121093750005 },
        { lat: 39.22636718749999, lng: 23.888085937500023 },
        { lat: 39.267724609374994, lng: 23.97089843750001 },
        { lat: 39.20053710937498, lng: 23.939746093750045 },
        { lat: 39.15830078124998, lng: 23.887988281250074 },
      ],
      [
        { lat: 39.329443359375034, lng: 26.41015625000003 },
        { lat: 39.270117187500034, lng: 26.39277343750004 },
        { lat: 39.171777343749966, lng: 26.531054687500045 },
        { lat: 39.109521484374994, lng: 26.578222656250063 },
        { lat: 39.04882812499997, lng: 26.59560546875005 },
        { lat: 39.03144531249998, lng: 26.583984375 },
        { lat: 39.064355468750016, lng: 26.531542968750045 },
        { lat: 39.074804687500034, lng: 26.488671875000023 },
        { lat: 39.03144531249998, lng: 26.503125 },
        { lat: 38.99414062500003, lng: 26.547167968750045 },
        { lat: 38.97280273437502, lng: 26.46875 },
        { lat: 38.97392578124999, lng: 26.39013671875003 },
        { lat: 39.02587890625, lng: 26.16083984375004 },
        { lat: 39.08105468749997, lng: 26.10791015625 },
        { lat: 39.16411132812502, lng: 26.245117187500057 },
        { lat: 39.19755859374999, lng: 26.273144531249983 },
        { lat: 39.19428710937504, lng: 26.17597656250001 },
        { lat: 39.095605468749994, lng: 26.072363281250034 },
        { lat: 39.138964843750045, lng: 25.90625 },
        { lat: 39.178662109374955, lng: 25.85546875 },
        { lat: 39.20004882812506, lng: 25.84414062500008 },
        { lat: 39.28754882812504, lng: 25.90957031250008 },
        { lat: 39.284619140624955, lng: 26.026464843750006 },
        { lat: 39.30429687499998, lng: 26.08837890625 },
        { lat: 39.33198242187501, lng: 26.164843750000045 },
        { lat: 39.37353515625005, lng: 26.16542968750008 },
        { lat: 39.38300781250001, lng: 26.347753906250002 },
        { lat: 39.329443359375034, lng: 26.41015625000003 },
      ],
      [
        { lat: 39.432714843750034, lng: 20.077929687500045 },
        { lat: 39.376611328124966, lng: 20.09960937500003 },
        { lat: 39.411425781250045, lng: 19.975 },
        { lat: 39.461523437500034, lng: 19.883984375000068 },
        { lat: 39.585302734375034, lng: 19.808886718750045 },
        { lat: 39.726171875000034, lng: 19.648925781250057 },
        { lat: 39.76708984375003, lng: 19.646484375 },
        { lat: 39.79809570312503, lng: 19.707324218750045 },
        { lat: 39.82011718749999, lng: 19.83857421875004 },
        { lat: 39.79726562500005, lng: 19.89169921875003 },
        { lat: 39.77373046875004, lng: 19.926074218750017 },
        { lat: 39.74672851562505, lng: 19.936816406250074 },
        { lat: 39.69262695312503, lng: 19.86220703125008 },
        { lat: 39.66811523437502, lng: 19.8466796875 },
        { lat: 39.61948242187506, lng: 19.904101562500074 },
        { lat: 39.6, lng: 19.903125 },
        { lat: 39.50590820312502, lng: 19.92734375 },
        { lat: 39.47041015624998, lng: 19.95527343750001 },
        { lat: 39.44208984374998, lng: 20.02773437500005 },
        { lat: 39.432714843750034, lng: 20.077929687500045 },
      ],
      [
        { lat: 39.98330078125002, lng: 25.437695312500036 },
        { lat: 39.94956054687498, lng: 25.39990234375 },
        { lat: 39.89130859375001, lng: 25.3720703125 },
        { lat: 39.80810546875003, lng: 25.357031250000063 },
        { lat: 39.80610351562498, lng: 25.29873046875008 },
        { lat: 39.82294921875004, lng: 25.263378906250068 },
        { lat: 39.85439453125005, lng: 25.251757812500017 },
        { lat: 39.89414062500006, lng: 25.24941406250005 },
        { lat: 39.89257812499999, lng: 25.223828125 },
        { lat: 39.84941406250002, lng: 25.203222656250063 },
        { lat: 39.829931640625034, lng: 25.185156250000034 },
        { lat: 39.825830078124994, lng: 25.126464843750057 },
        { lat: 39.852392578125006, lng: 25.06220703125004 },
        { lat: 39.90986328124998, lng: 25.065234375000017 },
        { lat: 39.97636718750002, lng: 25.052343750000063 },
        { lat: 39.999658203124966, lng: 25.05800781250005 },
        { lat: 40.00541992187499, lng: 25.234179687500074 },
        { lat: 39.95629882812503, lng: 25.285742187500006 },
        { lat: 39.98476562500005, lng: 25.34804687500008 },
        { lat: 40.01552734375002, lng: 25.373632812500063 },
        { lat: 40.03481445312502, lng: 25.44912109375008 },
        { lat: 39.98330078125002, lng: 25.437695312500036 },
      ],
      [
        { lat: 40.42656249999999, lng: 25.685742187500036 },
        { lat: 40.40043945312499, lng: 25.572656250000023 },
        { lat: 40.4828125, lng: 25.448046875000017 },
        { lat: 40.51586914062497, lng: 25.568554687500068 },
        { lat: 40.49199218749999, lng: 25.624316406250045 },
        { lat: 40.46386718750006, lng: 25.664257812500008 },
        { lat: 40.42656249999999, lng: 25.685742187500036 },
      ],
      [
        { lat: 40.615185546874955, lng: 24.774218750000074 },
        { lat: 40.57944335937506, lng: 24.64589843750002 },
        { lat: 40.64702148437495, lng: 24.51552734375002 },
        { lat: 40.68720703124998, lng: 24.516699218750006 },
        { lat: 40.76875, lng: 24.585546875 },
        { lat: 40.79291992187501, lng: 24.623339843750045 },
        { lat: 40.786279296874994, lng: 24.719140625000023 },
        { lat: 40.73027343749996, lng: 24.77363281250004 },
        { lat: 40.703857421875, lng: 24.78632812500004 },
        { lat: 40.65888671874998, lng: 24.768652343750006 },
        { lat: 40.615185546874955, lng: 24.774218750000074 },
      ],
      [
        { lat: 41.343115234375034, lng: 26.536425781250074 },
        { lat: 41.23876953125, lng: 26.330664062499977 },
        { lat: 41.143261718749976, lng: 26.325683593750025 },
        { lat: 41.09702148437498, lng: 26.32841796875007 },
        { lat: 41.06430664062497, lng: 26.33261718750003 },
        { lat: 41.03676757812496, lng: 26.354101562500063 },
        { lat: 40.99707031250006, lng: 26.354101562500063 },
        { lat: 40.95449218749999, lng: 26.331054687500057 },
        { lat: 40.88320312500002, lng: 26.241210937500057 },
        { lat: 40.826513671875034, lng: 26.178906250000068 },
        { lat: 40.749658203124994, lng: 26.109179687500074 },
        { lat: 40.74028320312496, lng: 26.069726562500023 },
        { lat: 40.726757812499955, lng: 26.03896484375008 },
        { lat: 40.76914062499998, lng: 26.0107421875 },
        { lat: 40.84409179687506, lng: 25.85566406250004 },
        { lat: 40.88779296874997, lng: 25.49677734375001 },
        { lat: 40.94311523437497, lng: 25.325292968750063 },
        { lat: 40.93281250000001, lng: 25.250097656250034 },
        { lat: 40.9947265625, lng: 25.104492187500025 },
        { lat: 40.96752929687497, lng: 25.004687500000045 },
        { lat: 40.857519531250034, lng: 24.792968750000057 },
        { lat: 40.86948242187497, lng: 24.678710937500057 },
        { lat: 40.93559570312495, lng: 24.55654296875005 },
        { lat: 40.94775390625003, lng: 24.47705078125 },
        { lat: 40.91274414062502, lng: 24.383789062500025 },
        { lat: 40.78613281249997, lng: 24.234375 },
        { lat: 40.72407226562504, lng: 24.082324218750074 },
        { lat: 40.74833984374998, lng: 23.946093750000017 },
        { lat: 40.74780273437497, lng: 23.762792968750063 },
        { lat: 40.67700195312503, lng: 23.743261718750006 },
        { lat: 40.62797851562499, lng: 23.778710937500023 },
        { lat: 40.54438476562501, lng: 23.87890625 },
        { lat: 40.481542968750006, lng: 23.831933593750023 },
        { lat: 40.41855468750006, lng: 23.866796875000034 },
        { lat: 40.40576171875003, lng: 23.932031250000076 },
        { lat: 40.40932617187502, lng: 24.03056640624999 },
        { lat: 40.32778320312502, lng: 24.21279296875008 },
        { lat: 40.241796875, lng: 24.292480468750057 },
        { lat: 40.14770507812503, lng: 24.343359375000034 },
        { lat: 40.215185546875006, lng: 24.232421875 },
        { lat: 40.28002929687497, lng: 24.158789062500006 },
        { lat: 40.30356445312498, lng: 24.056054687500048 },
        { lat: 40.35878906250005, lng: 23.913183593750063 },
        { lat: 40.36801757812506, lng: 23.823437500000065 },
        { lat: 40.329736328124994, lng: 23.72792968750008 },
        { lat: 40.286279296875016, lng: 23.720507812500074 },
        { lat: 40.20512695312499, lng: 23.823437500000065 },
        { lat: 40.155224609374955, lng: 23.917578125000063 },
        { lat: 40.11455078125002, lng: 23.96748046875001 },
        { lat: 40.024609374999976, lng: 24.000781250000045 },
        { lat: 39.994042968749994, lng: 23.981835937500023 },
        { lat: 39.96557617187506, lng: 23.947070312500045 },
        { lat: 40.02226562499996, lng: 23.83535156250002 },
        { lat: 40.22382812499998, lng: 23.66455078125003 },
        { lat: 40.26396484374999, lng: 23.42626953125 },
        { lat: 40.22197265624996, lng: 23.38642578125004 },
        { lat: 40.11542968750001, lng: 23.43320312500006 },
        { lat: 40.07392578125001, lng: 23.467089843750042 },
        { lat: 39.95888671875002, lng: 23.674121093750045 },
        { lat: 39.93447265625002, lng: 23.657519531250017 },
        { lat: 39.92407226562502, lng: 23.62734375 },
        { lat: 39.98984375, lng: 23.395605468750034 },
        { lat: 40.08994140624998, lng: 23.328222656250002 },
        { lat: 40.216455078124994, lng: 23.312011718749968 },
        { lat: 40.30429687500003, lng: 23.09814453125003 },
        { lat: 40.39990234374997, lng: 22.896484375000057 },
        { lat: 40.490625, lng: 22.851367187500017 },
        { lat: 40.524267578125006, lng: 22.892871093750045 },
        { lat: 40.59086914062499, lng: 22.92226562500008 },
        { lat: 40.57861328124997, lng: 22.811425781250048 },
        { lat: 40.536474609375006, lng: 22.74189453125001 },
        { lat: 40.49555664062501, lng: 22.629492187500034 },
        { lat: 40.42861328124996, lng: 22.62490234375005 },
        { lat: 40.366601562500016, lng: 22.642675781250034 },
        { lat: 40.27641601562496, lng: 22.60546875 },
        { lat: 40.11933593750001, lng: 22.56933593750003 },
        { lat: 40.03691406250002, lng: 22.59218750000005 },
        { lat: 39.80058593750002, lng: 22.835742187500017 },
        { lat: 39.62890625000003, lng: 22.919042968750034 },
        { lat: 39.563818359375006, lng: 22.978808593750045 },
        { lat: 39.492041015625034, lng: 23.103417968750023 },
        { lat: 39.35844726562499, lng: 23.233398437500025 },
        { lat: 39.28881835937502, lng: 23.288476562500076 },
        { lat: 39.17490234375, lng: 23.327734374999977 },
        { lat: 39.10439453125002, lng: 23.218359375 },
        { lat: 39.10146484375005, lng: 23.15468750000008 },
        { lat: 39.13276367187501, lng: 23.119433593750017 },
        { lat: 39.21044921875003, lng: 23.16875 },
        { lat: 39.25776367187501, lng: 23.16171875 },
        { lat: 39.3310546875, lng: 22.992871093750068 },
        { lat: 39.30634765625004, lng: 22.92138671874997 },
        { lat: 39.25859374999999, lng: 22.838964843750063 },
        { lat: 39.16997070312496, lng: 22.886035156250074 },
        { lat: 39.11152343749995, lng: 22.93896484375 },
        { lat: 39.03090820312496, lng: 22.965527343750008 },
        { lat: 39.03793945312498, lng: 23.066699218750017 },
        { lat: 38.94770507812498, lng: 22.930468750000045 },
        { lat: 38.901611328125, lng: 22.80263671875002 },
        { lat: 38.89892578125, lng: 22.676855468749977 },
        { lat: 38.89057617187498, lng: 22.596777343750002 },
        { lat: 38.86748046874999, lng: 22.569140625000074 },
        { lat: 38.850683593750034, lng: 22.63427734375003 },
        { lat: 38.84916992187499, lng: 22.6875 },
        { lat: 38.80039062499998, lng: 22.774023437500063 },
        { lat: 38.74189453124998, lng: 23.020312500000074 },
        { lat: 38.66796875, lng: 23.1376953125 },
        { lat: 38.66123046875006, lng: 23.25292968750003 },
        { lat: 38.52553710937505, lng: 23.368945312500045 },
        { lat: 38.48940429687505, lng: 23.56962890625007 },
        { lat: 38.35244140625002, lng: 23.683984375000076 },
        { lat: 38.32548828124995, lng: 23.836035156250063 },
        { lat: 38.275, lng: 23.96699218750001 },
        { lat: 38.22680664062503, lng: 24.005371093750025 },
        { lat: 38.139794921874966, lng: 24.024511718750006 },
        { lat: 37.95532226562506, lng: 24.033007812500045 },
        { lat: 37.81791992187502, lng: 24.061328125000042 },
        { lat: 37.77451171874997, lng: 24.062304687500074 },
        { lat: 37.709619140624994, lng: 24.055371093750068 },
        { lat: 37.67773437499997, lng: 24.019726562500008 },
        { lat: 37.67675781250006, lng: 23.97158203125005 },
        { lat: 37.77778320312501, lng: 23.87734375000005 },
        { lat: 37.88408203125002, lng: 23.73281250000008 },
        { lat: 38.01054687500002, lng: 23.58046875000005 },
        { lat: 38.03276367187502, lng: 23.537207031250034 },
        { lat: 38.03486328124998, lng: 23.50175781249999 },
        { lat: 37.992089843749994, lng: 23.42021484374999 },
        { lat: 37.95903320312499, lng: 23.193652343750017 },
        { lat: 37.912841796875, lng: 23.087402343750057 },
        { lat: 37.90263671874996, lng: 23.047460937500006 },
        { lat: 37.87836914062501, lng: 23.036328125000036 },
        { lat: 37.853125, lng: 23.086132812500068 },
        { lat: 37.79531250000005, lng: 23.147167968750068 },
        { lat: 37.71625976562501, lng: 23.147167968750068 },
        { lat: 37.62021484374997, lng: 23.197558593750017 },
        { lat: 37.59541015624998, lng: 23.262695312500057 },
        { lat: 37.597558593749994, lng: 23.347558593750023 },
        { lat: 37.57978515625001, lng: 23.396191406250068 },
        { lat: 37.541552734375045, lng: 23.408789062500063 },
        { lat: 37.496923828125006, lng: 23.458105468749977 },
        { lat: 37.46386718750003, lng: 23.490625 },
        { lat: 37.440185546875, lng: 23.48925781250003 },
        { lat: 37.37729492187506, lng: 23.252539062500034 },
        { lat: 37.348535156249966, lng: 23.20302734375008 },
        { lat: 37.333837890625006, lng: 23.16152343750005 },
        { lat: 37.36376953125006, lng: 23.1 },
        { lat: 37.440576171874994, lng: 23.096484375000045 },
        { lat: 37.481787109375034, lng: 23.01513671874997 },
        { lat: 37.51708984375003, lng: 22.940527343750063 },
        { lat: 37.5322265625, lng: 22.851074218750057 },
        { lat: 37.58510742187502, lng: 22.775 },
        { lat: 37.542138671874966, lng: 22.725390625000017 },
        { lat: 37.39331054687503, lng: 22.765039062500023 },
        { lat: 37.29082031250002, lng: 22.851074218750057 },
        { lat: 37.01586914062506, lng: 22.99501953125005 },
        { lat: 36.85351562500003, lng: 23.060351562500045 },
        { lat: 36.77495117187499, lng: 23.07353515625007 },
        { lat: 36.64453125, lng: 23.041015625000025 },
        { lat: 36.54760742187506, lng: 23.111718750000023 },
        { lat: 36.448095703125034, lng: 23.16015625000003 },
        { lat: 36.45185546874998, lng: 23.106835937500023 },
        { lat: 36.48696289062505, lng: 23.060546875 },
        { lat: 36.52836914062504, lng: 22.982910156249996 },
        { lat: 36.687109375000034, lng: 22.832324218750045 },
        { lat: 36.78618164062499, lng: 22.779882812500006 },
        { lat: 36.79394531250006, lng: 22.71718750000002 },
        { lat: 36.779736328125004, lng: 22.6083984375 },
        { lat: 36.56816406249996, lng: 22.489062500000017 },
        { lat: 36.446923828124966, lng: 22.48945312500001 },
        { lat: 36.47578124999998, lng: 22.42773437500003 },
        { lat: 36.513574218750044, lng: 22.374804687500017 },
        { lat: 36.64619140624998, lng: 22.38125 },
        { lat: 36.70190429687503, lng: 22.375976562500053 },
        { lat: 36.882568359375, lng: 22.23115234375004 },
        { lat: 36.90283203125003, lng: 22.16474609375001 },
        { lat: 36.963916015625045, lng: 22.13378906250003 },
        { lat: 37.028955078124966, lng: 22.08046875000008 },
        { lat: 37.016503906249994, lng: 22.01171875000003 },
        { lat: 36.990087890625034, lng: 21.95556640625003 },
        { lat: 36.89179687500001, lng: 21.940039062500063 },
        { lat: 36.80366210937498, lng: 21.93427734375004 },
        { lat: 36.73730468749997, lng: 21.892382812500045 },
        { lat: 36.86323242187495, lng: 21.738085937500045 },
        { lat: 37.080957031249994, lng: 21.58291015625005 },
        { lat: 37.20039062499998, lng: 21.57880859375001 },
        { lat: 37.309277343749955, lng: 21.692480468750006 },
        { lat: 37.38720703125003, lng: 21.678906250000068 },
        { lat: 37.54101562500003, lng: 21.5712890625 },
        { lat: 37.63994140625002, lng: 21.41621093750001 },
        { lat: 37.66933593750005, lng: 21.32929687499998 },
        { lat: 37.77451171874997, lng: 21.28847656250002 },
        { lat: 37.82885742187503, lng: 21.20527343750004 },
        { lat: 37.85415039062505, lng: 21.137988281250014 },
        { lat: 37.89160156250003, lng: 21.124707031250065 },
        { lat: 37.91928710937498, lng: 21.14501953125003 },
        { lat: 38.027441406250006, lng: 21.30810546875003 },
        { lat: 38.19667968750002, lng: 21.40371093750005 },
        { lat: 38.204736328124966, lng: 21.45117187500003 },
        { lat: 38.16459960937496, lng: 21.548730468750023 },
        { lat: 38.17509765624996, lng: 21.658398437500068 },
        { lat: 38.27421874999998, lng: 21.74843750000002 },
        { lat: 38.328125, lng: 21.82470703125003 },
        { lat: 38.321191406249966, lng: 21.95332031250001 },
        { lat: 38.188720703125, lng: 22.24375 },
        { lat: 38.11323242187498, lng: 22.55585937500004 },
        { lat: 38.04692382812496, lng: 22.711523437500034 },
        { lat: 37.981201171875, lng: 22.799609375000042 },
        { lat: 37.96757812499996, lng: 22.846386718750068 },
        { lat: 37.95830078125002, lng: 22.92031250000002 },
        { lat: 38.00747070312502, lng: 22.916992187500053 },
        { lat: 38.050927734374994, lng: 22.893164062500006 },
        { lat: 38.074609375000016, lng: 22.954785156250036 },
        { lat: 38.073339843750006, lng: 23.122070312499996 },
        { lat: 38.096386718750004, lng: 23.15253906250001 },
        { lat: 38.133691406249966, lng: 23.183496093750076 },
        { lat: 38.17607421874999, lng: 23.148925781250057 },
        { lat: 38.19643554687505, lng: 23.093554687500074 },
        { lat: 38.202099609374955, lng: 23.034375 },
        { lat: 38.21552734375004, lng: 22.995410156250045 },
        { lat: 38.20195312500002, lng: 22.932519531250023 },
        { lat: 38.234716796875034, lng: 22.834375 },
        { lat: 38.26171875000003, lng: 22.78369140625 },
        { lat: 38.289501953125004, lng: 22.753906250000057 },
        { lat: 38.34492187500001, lng: 22.58339843750005 },
        { lat: 38.43852539062499, lng: 22.421679687500045 },
        { lat: 38.38554687500002, lng: 22.38525390625 },
        { lat: 38.35683593750005, lng: 22.319921875 },
        { lat: 38.35283203125002, lng: 22.22685546875007 },
        { lat: 38.412451171875006, lng: 21.96533203124997 },
        { lat: 38.36694335937497, lng: 21.804687500000025 },
        { lat: 38.35502929687502, lng: 21.717089843750045 },
        { lat: 38.35400390625, lng: 21.650097656250068 },
        { lat: 38.33359375, lng: 21.567675781250074 },
        { lat: 38.321386718750006, lng: 21.472558593750048 },
        { lat: 38.407812500000034, lng: 21.390136718750025 },
        { lat: 38.474804687500004, lng: 21.35546875 },
        { lat: 38.48730468749997, lng: 21.3310546875 },
        { lat: 38.424365234375045, lng: 21.32978515625001 },
        { lat: 38.373925781249966, lng: 21.30332031250003 },
        { lat: 38.34555664062506, lng: 21.182617187500025 },
        { lat: 38.384667968750016, lng: 21.11318359375002 },
        { lat: 38.503271484375034, lng: 21.059765625000068 },
        { lat: 38.65400390625001, lng: 20.992187500000057 },
        { lat: 38.775732421875034, lng: 20.873242187500068 },
        { lat: 38.80751953125002, lng: 20.776855468750057 },
        { lat: 38.874414062499966, lng: 20.768554687500057 },
        { lat: 38.92788085937502, lng: 20.77734375 },
        { lat: 38.94111328124998, lng: 20.893164062500034 },
        { lat: 38.88515625000002, lng: 21.07421874999997 },
        { lat: 38.89628906249999, lng: 21.111621093750045 },
        { lat: 38.92207031250001, lng: 21.15234375 },
        { lat: 38.97919921875001, lng: 21.14453125 },
        { lat: 39.029980468749955, lng: 21.11835937500001 },
        { lat: 39.03227539062499, lng: 21.068554687500068 },
        { lat: 39.026269531249994, lng: 21.03408203125008 },
        { lat: 39.036767578124994, lng: 20.922753906250023 },
        { lat: 39.00854492187503, lng: 20.77968750000002 },
        { lat: 39.03515625000002, lng: 20.71337890625 },
        { lat: 39.067480468750034, lng: 20.69130859375005 },
        { lat: 39.14770507812505, lng: 20.571679687500023 },
        { lat: 39.25527343750002, lng: 20.468261718749996 },
        { lat: 39.32709960937501, lng: 20.300781250000057 },
        { lat: 39.545800781249966, lng: 20.19140625 },
        { lat: 39.641259765624966, lng: 20.099414062500074 },
        { lat: 39.709423828125004, lng: 20.001269531250074 },
        { lat: 39.710693359375, lng: 20.022558593750063 },
        { lat: 39.69912109375002, lng: 20.059765624999983 },
        { lat: 39.66162109375003, lng: 20.13105468750004 },
        { lat: 39.65351562499998, lng: 20.206835937500017 },
        { lat: 39.678369140624966, lng: 20.24824218750001 },
        { lat: 39.701171875, lng: 20.272070312499974 },
        { lat: 39.73857421874999, lng: 20.287597656250057 },
        { lat: 39.7822265625, lng: 20.29384765625008 },
        { lat: 39.79667968750002, lng: 20.30615234375 },
        { lat: 39.79174804687497, lng: 20.36406250000007 },
        { lat: 39.802636718749994, lng: 20.382421875 },
        { lat: 39.84179687500005, lng: 20.381640625000017 },
        { lat: 39.890625, lng: 20.344238281250025 },
        { lat: 39.95078125000006, lng: 20.311328125000074 },
        { lat: 39.97944335937503, lng: 20.311132812500034 },
        { lat: 39.991064453125006, lng: 20.338476562500002 },
        { lat: 40.0171875, lng: 20.38369140625008 },
        { lat: 40.049462890624994, lng: 20.408007812500074 },
        { lat: 40.065576171874994, lng: 20.4560546875 },
        { lat: 40.068505859374966, lng: 20.527050781250068 },
        { lat: 40.08266601562502, lng: 20.60625 },
        { lat: 40.11738281249998, lng: 20.657421875000068 },
        { lat: 40.151757812499966, lng: 20.664941406249994 },
        { lat: 40.24638671874996, lng: 20.69697265625004 },
        { lat: 40.29267578124998, lng: 20.717871093750034 },
        { lat: 40.33491210937498, lng: 20.751660156249983 },
        { lat: 40.391894531250045, lng: 20.77001953125 },
        { lat: 40.44545898437502, lng: 20.80605468750005 },
        { lat: 40.46791992187499, lng: 20.881640625000017 },
        { lat: 40.49438476562506, lng: 20.95019531250003 },
        { lat: 40.563378906249966, lng: 21.001953125 },
        { lat: 40.62246093750002, lng: 21.030859375000034 },
        { lat: 40.65864257812501, lng: 21.031054687500074 },
        { lat: 40.7177734375, lng: 20.987890625000063 },
        { lat: 40.775292968749994, lng: 20.95576171875001 },
        { lat: 40.84990234374999, lng: 20.96425781250005 },
        { lat: 40.85615234375004, lng: 21.1 },
        { lat: 40.863134765625034, lng: 21.147558593750006 },
        { lat: 40.867138671874955, lng: 21.32373046875 },
        { lat: 40.90717773437503, lng: 21.404101562500045 },
        { lat: 40.90361328125002, lng: 21.459667968749983 },
        { lat: 40.86894531249996, lng: 21.575781250000034 },
        { lat: 40.896337890625034, lng: 21.627539062500006 },
        { lat: 40.95043945312506, lng: 21.77949218750004 },
        { lat: 41.10742187499997, lng: 21.929492187500042 },
        { lat: 41.13095703125006, lng: 21.99335937500001 },
        { lat: 41.140527343749966, lng: 22.138867187500068 },
        { lat: 41.15864257812501, lng: 22.18447265625005 },
        { lat: 41.15517578125002, lng: 22.23769531250005 },
        { lat: 41.123388671875034, lng: 22.400781250000048 },
        { lat: 41.118505859375006, lng: 22.49355468750005 },
        { lat: 41.14018554687499, lng: 22.603613281249977 },
        { lat: 41.17851562499998, lng: 22.724804687500068 },
        { lat: 41.31274414062506, lng: 22.75507812500004 },
        { lat: 41.33198242187498, lng: 22.783886718750036 },
        { lat: 41.33735351562501, lng: 22.859277343750023 },
        { lat: 41.33627929687506, lng: 22.91601562500003 },
        { lat: 41.32563476562501, lng: 23.025585937500065 },
        { lat: 41.32207031249999, lng: 23.155957031250065 },
        { lat: 41.38496093750001, lng: 23.239843750000034 },
        { lat: 41.38964843749999, lng: 23.372070312500057 },
        { lat: 41.39873046874998, lng: 23.433398437500017 },
        { lat: 41.38603515624998, lng: 23.53583984375001 },
        { lat: 41.386767578125045, lng: 23.63515625000008 },
        { lat: 41.41298828125005, lng: 23.762304687500063 },
        { lat: 41.45595703125002, lng: 23.880859375000057 },
        { lat: 41.452294921874966, lng: 23.973535156250023 },
        { lat: 41.460058593750034, lng: 24.011328124999977 },
        { lat: 41.469091796875034, lng: 24.03291015625004 },
        { lat: 41.527246093749966, lng: 24.056054687500048 },
        { lat: 41.53081054687499, lng: 24.230371093750023 },
        { lat: 41.525048828124966, lng: 24.28945312500008 },
        { lat: 41.523535156250006, lng: 24.38671875 },
        { lat: 41.55522460937499, lng: 24.487890625 },
        { lat: 41.55253906249995, lng: 24.518261718750065 },
        { lat: 41.46738281250003, lng: 24.56933593749997 },
        { lat: 41.44272460937497, lng: 24.59599609375007 },
        { lat: 41.41997070312496, lng: 24.65107421875001 },
        { lat: 41.356103515624994, lng: 24.773730468750045 },
        { lat: 41.37290039062506, lng: 24.79580078125002 },
        { lat: 41.394238281249955, lng: 24.846875 },
        { lat: 41.36499023437503, lng: 24.99355468750008 },
        { lat: 41.31577148437506, lng: 25.13339843750006 },
        { lat: 41.243554687499994, lng: 25.251171875000068 },
        { lat: 41.264355468749955, lng: 25.381933593750063 },
        { lat: 41.29980468749999, lng: 25.52705078125004 },
        { lat: 41.31010742187496, lng: 25.621484375000023 },
        { lat: 41.31503906249998, lng: 25.723925781250017 },
        { lat: 41.330419921875006, lng: 25.784960937500014 },
        { lat: 41.31191406249996, lng: 25.923339843750057 },
        { lat: 41.35068359375006, lng: 26.066406250000057 },
        { lat: 41.3857421875, lng: 26.135351562499977 },
        { lat: 41.43486328124999, lng: 26.155175781250023 },
        { lat: 41.52153320312495, lng: 26.143554687500057 },
        { lat: 41.60820312500001, lng: 26.11123046875005 },
        { lat: 41.64018554687496, lng: 26.076953125000074 },
        { lat: 41.673242187500044, lng: 26.066015625000063 },
        { lat: 41.704150390625045, lng: 26.085546875000063 },
        { lat: 41.72568359374998, lng: 26.10742187499997 },
        { lat: 41.74379882812502, lng: 26.200585937500048 },
        { lat: 41.716552734375, lng: 26.320898437500034 },
        { lat: 41.696337890625045, lng: 26.41054687499999 },
        { lat: 41.66337890624999, lng: 26.4625 },
        { lat: 41.63325195312498, lng: 26.49501953125008 },
        { lat: 41.60722656250002, lng: 26.54453125000003 },
        { lat: 41.60126953125003, lng: 26.581347656250074 },
        { lat: 41.51215820312501, lng: 26.60976562499999 },
        { lat: 41.401757812499994, lng: 26.62490234375008 },
        { lat: 41.354150390624966, lng: 26.60234374999999 },
        { lat: 41.343115234375034, lng: 26.536425781250074 },
      ],
    ],
  },
  {
    code: "HU",
    coordinates: [
      [
        { lat: 48.405322265624996, lng: 22.131835937499996 },
        { lat: 48.413427734375, lng: 22.227148437500006 },
        { lat: 48.412158203124996, lng: 22.23115234375001 },
        { lat: 48.407373046874994, lng: 22.253710937500017 },
        { lat: 48.360888671874996, lng: 22.269433593750023 },
        { lat: 48.3580078125, lng: 22.27216796875001 },
        { lat: 48.327294921874994, lng: 22.29511718750001 },
        { lat: 48.28662109375, lng: 22.316699218750017 },
        { lat: 48.2560546875, lng: 22.350195312500006 },
        { lat: 48.24331054687499, lng: 22.423828125 },
        { lat: 48.205371093749996, lng: 22.520117187500006 },
        { lat: 48.134033203125, lng: 22.58242187500002 },
        { lat: 48.104394531249994, lng: 22.676367187500006 },
        { lat: 48.10361328125, lng: 22.68310546875 },
        { lat: 48.10703125, lng: 22.701562500000023 },
        { lat: 48.109619140625, lng: 22.769140625 },
        { lat: 48.09521484375, lng: 22.7822265625 },
        { lat: 48.060302734375, lng: 22.836230468750017 },
        { lat: 48.029541015625, lng: 22.857226562500014 },
        { lat: 47.9970703125, lng: 22.846484375000014 },
        { lat: 47.960302734375, lng: 22.856054687500006 },
        { lat: 47.947265625, lng: 22.87666015625001 },
        { lat: 47.92255859375, lng: 22.85175781250001 },
        { lat: 47.79902343749999, lng: 22.6767578125 },
        { lat: 47.76630859375, lng: 22.6083984375 },
        { lat: 47.759570312499996, lng: 22.562890625000023 },
        { lat: 47.77255859374999, lng: 22.49140625000001 },
        { lat: 47.762646484375, lng: 22.41748046875 },
        { lat: 47.736230468749994, lng: 22.35146484375002 },
        { lat: 47.72783203124999, lng: 22.290625 },
        { lat: 47.69638671875, lng: 22.24462890625 },
        { lat: 47.629052734374994, lng: 22.18505859375 },
        { lat: 47.572021484375, lng: 22.111914062500006 },
        { lat: 47.53662109375, lng: 22.037988281250023 },
        { lat: 47.505029296874994, lng: 21.99970703125001 },
        { lat: 47.395703125, lng: 21.99531250000001 },
        { lat: 47.36425781249999, lng: 21.95429687500001 },
        { lat: 47.332568359374996, lng: 21.899218750000014 },
        { lat: 47.304589843749994, lng: 21.86933593750001 },
        { lat: 47.138134765625, lng: 21.785449218750017 },
        { lat: 47.08481445312499, lng: 21.721777343750006 },
        { lat: 47.043896484375, lng: 21.661425781250017 },
        { lat: 47.00654296875, lng: 21.651464843750002 },
        { lat: 46.963769531249994, lng: 21.652636718750017 },
        { lat: 46.87836914062499, lng: 21.584179687500008 },
        { lat: 46.78974609375, lng: 21.494433593750017 },
        { lat: 46.753369140625, lng: 21.47705078125 },
        { lat: 46.70429687499999, lng: 21.4970703125 },
        { lat: 46.647851562499994, lng: 21.411035156250023 },
        { lat: 46.62075195312499, lng: 21.361328125 },
        { lat: 46.6078125, lng: 21.320214843750023 },
        { lat: 46.5724609375, lng: 21.29453125 },
        { lat: 46.486376953124996, lng: 21.252246093750017 },
        { lat: 46.44775390625, lng: 21.26328125 },
        { lat: 46.4123046875, lng: 21.264550781250023 },
        { lat: 46.391552734375, lng: 21.191796875000023 },
        { lat: 46.352685546874994, lng: 21.17041015625 },
        { lat: 46.30434570312499, lng: 21.151953125 },
        { lat: 46.282421875, lng: 21.121679687500006 },
        { lat: 46.242236328124996, lng: 21.039843750000017 },
        { lat: 46.259716796875, lng: 20.837011718750002 },
        { lat: 46.24624023437499, lng: 20.76025390625 },
        { lat: 46.21748046875, lng: 20.737402343750006 },
        { lat: 46.19443359375, lng: 20.732714843750017 },
        { lat: 46.172802734375, lng: 20.707421875000023 },
        { lat: 46.145654296874994, lng: 20.661035156250023 },
        { lat: 46.13349609374999, lng: 20.613671875000023 },
        { lat: 46.166943359375, lng: 20.508105468750017 },
        { lat: 46.1330078125, lng: 20.28095703125001 },
        { lat: 46.10859375, lng: 20.241796875 },
        { lat: 46.126025390624996, lng: 20.21015625000001 },
        { lat: 46.141894531249996, lng: 20.161425781250017 },
        { lat: 46.161474609375, lng: 19.93408203125 },
        { lat: 46.145898437499994, lng: 19.84443359375001 },
        { lat: 46.151904296874996, lng: 19.724511718750023 },
        { lat: 46.169189453125, lng: 19.61347656250001 },
        { lat: 46.155175781249994, lng: 19.53076171875 },
        { lat: 46.08735351562499, lng: 19.45751953125 },
        { lat: 46.06445312499999, lng: 19.421289062500023 },
        { lat: 46.0498046875, lng: 19.392871093750017 },
        { lat: 46.02851562499999, lng: 19.330273437500008 },
        { lat: 46.002880859375, lng: 19.278125 },
        { lat: 45.984423828124996, lng: 19.208398437500023 },
        { lat: 45.98701171875, lng: 19.146289062500017 },
        { lat: 46.01616210937499, lng: 19.087304687500023 },
        { lat: 46.00952148437499, lng: 19.066210937500017 },
        { lat: 45.982666015625, lng: 19.047656250000017 },
        { lat: 45.959716796875, lng: 19.015722656250006 },
        { lat: 45.931396484375, lng: 18.927832031250006 },
        { lat: 45.93173828125, lng: 18.905371093750006 },
        { lat: 45.93173828125, lng: 18.900292968750023 },
        { lat: 45.91083984374999, lng: 18.8330078125 },
        { lat: 45.899365234375, lng: 18.721777343750006 },
        { lat: 45.907470703125, lng: 18.666015625 },
        { lat: 45.81328125, lng: 18.564648437500008 },
        { lat: 45.796142578125, lng: 18.533593750000023 },
        { lat: 45.767333984375, lng: 18.437304687500017 },
        { lat: 45.75302734375, lng: 18.358300781250023 },
        { lat: 45.764453125, lng: 18.290625 },
        { lat: 45.765478515625, lng: 18.263964843750014 },
        { lat: 45.77026367187499, lng: 17.9638671875 },
        { lat: 45.790429687499994, lng: 17.80712890625 },
        { lat: 45.82724609375, lng: 17.706445312500023 },
        { lat: 45.868359375, lng: 17.6396484375 },
        { lat: 45.91376953125, lng: 17.60703125 },
        { lat: 45.941308593749994, lng: 17.52919921875002 },
        { lat: 45.951074218749994, lng: 17.406347656250006 },
        { lat: 45.996142578124996, lng: 17.310644531250002 },
        { lat: 46.076611328125, lng: 17.2421875 },
        { lat: 46.14033203125, lng: 17.14960937500001 },
        { lat: 46.187304687499996, lng: 17.03271484375 },
        { lat: 46.25366210937499, lng: 16.93994140625 },
        { lat: 46.339306640625, lng: 16.871484375000023 },
        { lat: 46.41640624999999, lng: 16.748046875 },
        { lat: 46.485009765624994, lng: 16.569921875 },
        { lat: 46.49990234374999, lng: 16.516210937500006 },
        { lat: 46.5220703125, lng: 16.505664062500017 },
        { lat: 46.607226562499996, lng: 16.41845703125 },
        { lat: 46.638671875, lng: 16.38125 },
        { lat: 46.680810546874994, lng: 16.384570312500017 },
        { lat: 46.70478515625, lng: 16.3671875 },
        { lat: 46.721630859375, lng: 16.33544921875 },
        { lat: 46.78251953124999, lng: 16.318457031250006 },
        { lat: 46.82797851562499, lng: 16.308496093750023 },
        { lat: 46.857275390625, lng: 16.283593750000023 },
        { lat: 46.86328125, lng: 16.093066406250017 },
        { lat: 46.971923828125, lng: 16.252539062500006 },
        { lat: 47.002197265625, lng: 16.331835937500017 },
        { lat: 46.996972656249994, lng: 16.423925781250006 },
        { lat: 47.006787109375, lng: 16.453417968750017 },
        { lat: 47.02246093749999, lng: 16.461230468750014 },
        { lat: 47.057861328125, lng: 16.476953125000023 },
        { lat: 47.091259765625, lng: 16.484765625000023 },
        { lat: 47.12265625, lng: 16.49267578125 },
        { lat: 47.140380859375, lng: 16.482812500000023 },
        { lat: 47.145898437499994, lng: 16.438378906250023 },
        { lat: 47.2234375, lng: 16.416894531250023 },
        { lat: 47.252734375, lng: 16.439746093750014 },
        { lat: 47.27314453125, lng: 16.462597656250008 },
        { lat: 47.36743164062499, lng: 16.434375 },
        { lat: 47.39951171875, lng: 16.44287109375 },
        { lat: 47.404541015625, lng: 16.514746093750006 },
        { lat: 47.424658203125, lng: 16.57441406250001 },
        { lat: 47.447558593749996, lng: 16.623046875 },
        { lat: 47.47661132812499, lng: 16.636621093750023 },
        { lat: 47.536035156249994, lng: 16.676562500000017 },
        { lat: 47.60888671875, lng: 16.639746093750006 },
        { lat: 47.65629882812499, lng: 16.43212890625 },
        { lat: 47.674462890624994, lng: 16.421289062500023 },
        { lat: 47.69506835937499, lng: 16.469628906250023 },
        { lat: 47.724462890625, lng: 16.52109375 },
        { lat: 47.747363281249996, lng: 16.55097656250001 },
        { lat: 47.750537109374996, lng: 16.590917968750006 },
        { lat: 47.739013671875, lng: 16.6474609375 },
        { lat: 47.68627929687499, lng: 16.74755859375 },
        { lat: 47.678662109375, lng: 16.785937500000017 },
        { lat: 47.69399414062499, lng: 16.823046875000017 },
        { lat: 47.697265625, lng: 16.862695312500023 },
        { lat: 47.6953125, lng: 16.973437500000017 },
        { lat: 47.707568359374996, lng: 17.06660156250001 },
        { lat: 47.76376953124999, lng: 17.04560546875001 },
        { lat: 47.804541015625, lng: 17.0458984375 },
        { lat: 47.837109375, lng: 17.030078125000014 },
        { lat: 47.872949218749994, lng: 17.039941406250023 },
        { lat: 47.90087890624999, lng: 17.077734375 },
        { lat: 47.963623046875, lng: 17.0890625 },
        { lat: 48.00595703125, lng: 17.147363281250023 },
        { lat: 48.012060546875, lng: 17.174609375000017 },
        { lat: 48.004345703125, lng: 17.277246093750023 },
        { lat: 47.993359375, lng: 17.301562500000014 },
        { lat: 47.99091796875, lng: 17.317285156250023 },
        { lat: 47.887597656249994, lng: 17.48066406250001 },
        { lat: 47.80991210937499, lng: 17.63525390625 },
        { lat: 47.770166015624994, lng: 17.76191406250001 },
        { lat: 47.766894531249996, lng: 17.94794921875001 },
        { lat: 47.76342773437499, lng: 18.145605468750006 },
        { lat: 47.777001953124994, lng: 18.47626953125001 },
        { lat: 47.787158203124996, lng: 18.72421875 },
        { lat: 47.806494140625, lng: 18.740625 },
        { lat: 47.852880859375, lng: 18.77802734375001 },
        { lat: 47.89267578125, lng: 18.748339843750017 },
        { lat: 47.939453125, lng: 18.750097656250006 },
        { lat: 48.000292968749996, lng: 18.791894531250023 },
        { lat: 48.050830078124996, lng: 18.914160156250006 },
        { lat: 48.073046875, lng: 19.26513671875 },
        { lat: 48.110693359375, lng: 19.466992187500008 },
        { lat: 48.162109375, lng: 19.497460937500023 },
        { lat: 48.212841796875, lng: 19.564257812500014 },
        { lat: 48.223095703125, lng: 19.625390625000023 },
        { lat: 48.1998046875, lng: 19.70917968750001 },
        { lat: 48.155029296875, lng: 19.81005859375 },
        { lat: 48.13134765625, lng: 19.89863281250001 },
        { lat: 48.146630859374994, lng: 19.950390625 },
        { lat: 48.222021484375, lng: 20.12861328125001 },
        { lat: 48.295556640624994, lng: 20.333789062500017 },
        { lat: 48.4951171875, lng: 20.475 },
        { lat: 48.52690429687499, lng: 20.490039062500014 },
        { lat: 48.549707031249994, lng: 20.643164062500006 },
        { lat: 48.54565429687499, lng: 20.866601562500023 },
        { lat: 48.519677734374994, lng: 20.981152343750008 },
        { lat: 48.505908203124996, lng: 21.067285156250023 },
        { lat: 48.510595703125, lng: 21.196386718750006 },
        { lat: 48.553466796875, lng: 21.382421875 },
        { lat: 48.55224609375, lng: 21.451367187500008 },
        { lat: 48.521875, lng: 21.504687500000017 },
        { lat: 48.495703125, lng: 21.56318359375001 },
        { lat: 48.463671875, lng: 21.602636718750006 },
        { lat: 48.418505859374996, lng: 21.63251953125001 },
        { lat: 48.40146484375, lng: 21.64863281250001 },
        { lat: 48.378369140625, lng: 21.674609375000014 },
        { lat: 48.346582031249994, lng: 21.721484375000017 },
        { lat: 48.33808593749999, lng: 21.766992187500023 },
        { lat: 48.393359375, lng: 22.111328125 },
        { lat: 48.405322265624996, lng: 22.131835937499996 },
      ],
    ],
  },
  {
    code: "IT",
    coordinates: [
      [
        { lat: 36.75703124999998, lng: 12.051269531250028 },
        { lat: 36.74599609374996, lng: 12.003320312500023 },
        { lat: 36.780371093750034, lng: 11.940625 },
        { lat: 36.82861328124999, lng: 11.93642578125008 },
        { lat: 36.84306640625002, lng: 11.948046875000045 },
        { lat: 36.82094726562505, lng: 12.024218750000017 },
        { lat: 36.77636718750003, lng: 12.048046874999981 },
        { lat: 36.75703124999998, lng: 12.051269531250028 },
      ],
      [
        { lat: 38.220312500000034, lng: 15.57656250000005 },
        { lat: 38.10664062499995, lng: 15.508886718750034 },
        { lat: 38.06293945312504, lng: 15.475683593750004 },
        { lat: 37.78481445312502, lng: 15.234472656249977 },
        { lat: 37.720556640625006, lng: 15.206835937500045 },
        { lat: 37.65073242187498, lng: 15.18984375000005 },
        { lat: 37.589550781249955, lng: 15.164843750000015 },
        { lat: 37.53188476562502, lng: 15.131054687500068 },
        { lat: 37.45859375, lng: 15.099511718750021 },
        { lat: 37.37548828125006, lng: 15.10566406250004 },
        { lat: 37.334716796875, lng: 15.116992187500045 },
        { lat: 37.308007812499966, lng: 15.14599609375 },
        { lat: 37.282861328124994, lng: 15.193652343750017 },
        { lat: 37.24433593749998, lng: 15.230273437500017 },
        { lat: 37.20917968750001, lng: 15.174121093750044 },
        { lat: 37.138720703125045, lng: 15.23603515625004 },
        { lat: 37.09692382812506, lng: 15.288671875 },
        { lat: 37.05517578124997, lng: 15.295703125000015 },
        { lat: 37.013281250000055, lng: 15.294531250000064 },
        { lat: 36.93481445312497, lng: 15.18515625000006 },
        { lat: 36.89160156250006, lng: 15.142382812500045 },
        { lat: 36.83925781250005, lng: 15.115820312500063 },
        { lat: 36.78525390625006, lng: 15.104296875000017 },
        { lat: 36.73647460937496, lng: 15.11630859375006 },
        { lat: 36.687841796875006, lng: 15.112597656250017 },
        { lat: 36.69389648437502, lng: 15.002441406250055 },
        { lat: 36.723535156249994, lng: 14.8896484375 },
        { lat: 36.71040039062498, lng: 14.775976562500004 },
        { lat: 36.76660156249999, lng: 14.614355468750036 },
        { lat: 36.77675781250002, lng: 14.555468750000044 },
        { lat: 36.798681640625034, lng: 14.501855468750023 },
        { lat: 36.97285156249998, lng: 14.367285156250063 },
        { lat: 37.04643554687499, lng: 14.259082031250045 },
        { lat: 37.103662109374994, lng: 14.142968750000023 },
        { lat: 37.10712890624998, lng: 14.024316406249994 },
        { lat: 37.10063476562502, lng: 13.905468750000038 },
        { lat: 37.135888671874994, lng: 13.800585937500074 },
        { lat: 37.25415039062503, lng: 13.587109375000011 },
        { lat: 37.34873046875, lng: 13.360937500000034 },
        { lat: 37.410351562499955, lng: 13.264941406250017 },
        { lat: 37.45180664062505, lng: 13.221093750000051 },
        { lat: 37.47929687499996, lng: 13.169921875000028 },
        { lat: 37.50654296875001, lng: 13.040332031249989 },
        { lat: 37.57050781249998, lng: 12.924121093750045 },
        { lat: 37.57519531250005, lng: 12.871191406250006 },
        { lat: 37.56738281249997, lng: 12.75732421875 },
        { lat: 37.57182617187499, lng: 12.699023437500017 },
        { lat: 37.594335937500034, lng: 12.640234375000034 },
        { lat: 37.66953125, lng: 12.52675781250008 },
        { lat: 37.773779296875006, lng: 12.454394531249989 },
        { lat: 37.819775390624955, lng: 12.43554687499997 },
        { lat: 37.93872070312503, lng: 12.486816406250028 },
        { lat: 38.05292968750004, lng: 12.547656250000072 },
        { lat: 38.0849609375, lng: 12.601660156250063 },
        { lat: 38.10791015625006, lng: 12.664355468750045 },
        { lat: 38.141699218750006, lng: 12.702343750000068 },
        { lat: 38.18305664062498, lng: 12.734375 },
        { lat: 38.063720703125, lng: 12.850683593750006 },
        { lat: 38.03486328124998, lng: 12.902734375000023 },
        { lat: 38.04130859374998, lng: 12.955468750000023 },
        { lat: 38.08408203124998, lng: 13.049023437499983 },
        { lat: 38.13090820312502, lng: 13.056835937500066 },
        { lat: 38.19033203125005, lng: 13.159960937500045 },
        { lat: 38.19145507812502, lng: 13.291113281250034 },
        { lat: 38.180517578125006, lng: 13.351660156250004 },
        { lat: 38.12680664062498, lng: 13.383496093750011 },
        { lat: 38.110253906249994, lng: 13.43349609375008 },
        { lat: 38.103125, lng: 13.491308593750034 },
        { lat: 38.00073242187497, lng: 13.68154296875008 },
        { lat: 37.98403320312502, lng: 13.73486328125 },
        { lat: 37.981201171875, lng: 13.788867187499989 },
        { lat: 38.02416992187503, lng: 13.936621093749977 },
        { lat: 38.04052734375, lng: 14.05 },
        { lat: 38.01684570312506, lng: 14.287695312500006 },
        { lat: 38.04257812500006, lng: 14.416210937499983 },
        { lat: 38.045507812500034, lng: 14.505957031250063 },
        { lat: 38.085058593750006, lng: 14.636718750000055 },
        { lat: 38.15078125, lng: 14.737207031250023 },
        { lat: 38.1669921875, lng: 14.789648437500036 },
        { lat: 38.17167968749998, lng: 14.845898437500038 },
        { lat: 38.167578125000034, lng: 14.981933593750057 },
        { lat: 38.15273437500002, lng: 15.11875 },
        { lat: 38.16806640625003, lng: 15.176074218750072 },
        { lat: 38.211035156250006, lng: 15.224023437500078 },
        { lat: 38.230371093750016, lng: 15.279589843750017 },
        { lat: 38.217333984375045, lng: 15.340722656250051 },
        { lat: 38.290869140625, lng: 15.498730468750011 },
        { lat: 38.29589843749997, lng: 15.568359375000057 },
        { lat: 38.26757812499997, lng: 15.634667968750078 },
        { lat: 38.220312500000034, lng: 15.57656250000005 },
      ],
      [
        { lat: 39.06752929687496, lng: 8.478906250000023 },
        { lat: 38.968652343749994, lng: 8.421484375000034 },
        { lat: 39.03867187500003, lng: 8.36093750000006 },
        { lat: 39.09877929687502, lng: 8.358593750000011 },
        { lat: 39.115917968749955, lng: 8.366796875 },
        { lat: 39.090625, lng: 8.440625 },
        { lat: 39.06752929687496, lng: 8.478906250000023 },
      ],
      [
        { lat: 40.70561523437499, lng: 13.938281250000074 },
        { lat: 40.69697265625001, lng: 13.893652343750034 },
        { lat: 40.70874023437502, lng: 13.867675781250055 },
        { lat: 40.72407226562504, lng: 13.853515625000027 },
        { lat: 40.76181640625, lng: 13.871191406250063 },
        { lat: 40.73940429687505, lng: 13.962109375000038 },
        { lat: 40.718164062499994, lng: 13.96083984375005 },
        { lat: 40.70561523437499, lng: 13.938281250000074 },
      ],
      [
        { lat: 41.03984375, lng: 8.28603515625008 },
        { lat: 40.994140624999964, lng: 8.252734375000045 },
        { lat: 40.997460937500044, lng: 8.205664062500034 },
        { lat: 41.03129882812502, lng: 8.224023437500051 },
        { lat: 41.09912109375006, lng: 8.267382812499989 },
        { lat: 41.121875, lng: 8.320214843750023 },
        { lat: 41.10161132812502, lng: 8.34375 },
        { lat: 41.06274414062503, lng: 8.318945312500034 },
        { lat: 41.03984375, lng: 8.28603515625008 },
      ],
      [
        { lat: 40.88203124999998, lng: 9.632031250000011 },
        { lat: 40.818115234375, lng: 9.68203125000008 },
        { lat: 40.55620117187502, lng: 9.794335937500051 },
        { lat: 40.49956054687504, lng: 9.805273437500063 },
        { lat: 40.441503906250006, lng: 9.7828125 },
        { lat: 40.400292968749966, lng: 9.754199218750045 },
        { lat: 40.268408203125006, lng: 9.642968750000023 },
        { lat: 40.15922851562498, lng: 9.659472656250017 },
        { lat: 40.091796875, lng: 9.700781249999977 },
        { lat: 40.01704101562495, lng: 9.706738281250038 },
        { lat: 39.92436523437499, lng: 9.68603515625 },
        { lat: 39.354394531249966, lng: 9.616992187500074 },
        { lat: 39.253564453125016, lng: 9.58359375 },
        { lat: 39.16601562500005, lng: 9.5625 },
        { lat: 39.139550781249994, lng: 9.486328125 },
        { lat: 39.16752929687499, lng: 9.388085937500051 },
        { lat: 39.21679687499999, lng: 9.264160156250028 },
        { lat: 39.21381835937501, lng: 9.206933593750021 },
        { lat: 39.196972656249955, lng: 9.14931640625008 },
        { lat: 39.211279296875034, lng: 9.101757812500068 },
        { lat: 39.23916015625002, lng: 9.056347656250068 },
        { lat: 39.04326171874999, lng: 9.02265625000004 },
        { lat: 38.963720703125034, lng: 8.966601562500074 },
        { lat: 38.91289062499999, lng: 8.881347656250028 },
        { lat: 38.90966796875006, lng: 8.801171875000023 },
        { lat: 38.926708984374955, lng: 8.718554687500074 },
        { lat: 38.92656250000001, lng: 8.648535156250034 },
        { lat: 38.96430664062498, lng: 8.59541015625004 },
        { lat: 39.03032226562502, lng: 8.553320312499977 },
        { lat: 39.110498046875016, lng: 8.48623046875008 },
        { lat: 39.205712890624966, lng: 8.418164062500068 },
        { lat: 39.29179687500002, lng: 8.410742187499975 },
        { lat: 39.48159179687502, lng: 8.399121093750011 },
        { lat: 39.523046875000034, lng: 8.418652343750011 },
        { lat: 39.56279296874996, lng: 8.447070312500017 },
        { lat: 39.64770507812503, lng: 8.461035156250006 },
        { lat: 39.72167968749999, lng: 8.451171875000057 },
        { lat: 39.74809570312496, lng: 8.471093750000023 },
        { lat: 39.72167968749999, lng: 8.510742187500028 },
        { lat: 39.731591796874994, lng: 8.540527343750057 },
        { lat: 39.76967773437502, lng: 8.538671875000034 },
        { lat: 39.83920898437506, lng: 8.547753906250023 },
        { lat: 39.89746093750003, lng: 8.495898437500017 },
        { lat: 39.91723632812497, lng: 8.4078125 },
        { lat: 39.97817382812505, lng: 8.399316406250051 },
        { lat: 40.03764648437498, lng: 8.40859375000008 },
        { lat: 40.077587890624955, lng: 8.455078125000057 },
        { lat: 40.130712890625034, lng: 8.470800781250063 },
        { lat: 40.29267578124998, lng: 8.471289062500063 },
        { lat: 40.35234375, lng: 8.409179687500028 },
        { lat: 40.44267578124999, lng: 8.385351562500063 },
        { lat: 40.50053710937496, lng: 8.353222656249983 },
        { lat: 40.55864257812499, lng: 8.295507812500032 },
        { lat: 40.60595703125003, lng: 8.230273437500074 },
        { lat: 40.651611328125, lng: 8.189941406250028 },
        { lat: 40.77104492187501, lng: 8.18085937500004 },
        { lat: 40.87070312500006, lng: 8.203808593750011 },
        { lat: 40.91333007812503, lng: 8.22421875 },
        { lat: 40.90703124999999, lng: 8.245214843750006 },
        { lat: 40.857519531250034, lng: 8.31015625 },
        { lat: 40.846337890624994, lng: 8.36328125 },
        { lat: 40.834326171875034, lng: 8.46845703125001 },
        { lat: 40.85019531250006, lng: 8.571875 },
        { lat: 40.895263671875, lng: 8.698925781250068 },
        { lat: 40.94990234375004, lng: 8.821191406250023 },
        { lat: 41.11035156250003, lng: 8.998144531250006 },
        { lat: 41.142919921875006, lng: 9.107226562500045 },
        { lat: 41.18515625, lng: 9.163085937500057 },
        { lat: 41.242187499999964, lng: 9.182128906250027 },
        { lat: 41.257080078125, lng: 9.228417968750023 },
        { lat: 41.201660156249964, lng: 9.283007812500045 },
        { lat: 41.19589843750006, lng: 9.350781250000011 },
        { lat: 41.15014648437497, lng: 9.455175781250034 },
        { lat: 41.10634765625002, lng: 9.500195312500068 },
        { lat: 41.05366210937504, lng: 9.53876953125001 },
        { lat: 41.03051757812503, lng: 9.57568359375 },
        { lat: 41.01728515624998, lng: 9.615332031249977 },
        { lat: 41.00488281250003, lng: 9.621191406250034 },
        { lat: 40.99248046874998, lng: 9.589746093750023 },
        { lat: 40.93212890625006, lng: 9.553710937500057 },
        { lat: 40.91474609374998, lng: 9.574023437500017 },
        { lat: 40.88203124999998, lng: 9.632031250000011 },
      ],
      [
        { lat: 42.85815429687503, lng: 10.395117187500034 },
        { lat: 42.819189453125006, lng: 10.428320312500063 },
        { lat: 42.796582031250004, lng: 10.432226562500063 },
        { lat: 42.77099609375006, lng: 10.409960937500045 },
        { lat: 42.71318359374999, lng: 10.419335937499994 },
        { lat: 42.761132812499994, lng: 10.335644531250011 },
        { lat: 42.736914062500034, lng: 10.208984375000057 },
        { lat: 42.742041015625006, lng: 10.13125 },
        { lat: 42.78505859374996, lng: 10.10976562500008 },
        { lat: 42.81030273437497, lng: 10.127539062500063 },
        { lat: 42.815771484375006, lng: 10.248242187500068 },
        { lat: 42.82807617187504, lng: 10.285742187500063 },
        { lat: 42.82231445312502, lng: 10.358984375000063 },
        { lat: 42.85815429687503, lng: 10.395117187500034 },
      ],
      [
        { lat: 46.98476562499999, lng: 12.130761718750051 },
        { lat: 46.93525390625004, lng: 12.154101562500017 },
        { lat: 46.83588867187504, lng: 12.267968750000023 },
        { lat: 46.75981445312499, lng: 12.330078125 },
        { lat: 46.70263671874997, lng: 12.388281250000034 },
        { lat: 46.672509765624966, lng: 12.479199218749983 },
        { lat: 46.654101562500045, lng: 12.5986328125 },
        { lat: 46.64746093750003, lng: 12.699804687500006 },
        { lat: 46.62587890624996, lng: 12.805566406250051 },
        { lat: 46.572656249999966, lng: 13.16875 },
        { lat: 46.55791015624999, lng: 13.3515625 },
        { lat: 46.55556640625002, lng: 13.490039062500045 },
        { lat: 46.52026367187503, lng: 13.7 },
        { lat: 46.46289062499997, lng: 13.679687500000057 },
        { lat: 46.44853515624999, lng: 13.63710937500008 },
        { lat: 46.41508789062502, lng: 13.563281250000044 },
        { lat: 46.36918945312498, lng: 13.478515625 },
        { lat: 46.31752929687502, lng: 13.399511718749977 },
        { lat: 46.26162109375002, lng: 13.378222656250017 },
        { lat: 46.224951171875006, lng: 13.39960937500001 },
        { lat: 46.212304687499994, lng: 13.420996093750006 },
        { lat: 46.223535156249994, lng: 13.449804687500034 },
        { lat: 46.21660156249998, lng: 13.491796875000063 },
        { lat: 46.19658203124999, lng: 13.544726562499987 },
        { lat: 46.17705078125002, lng: 13.63251953125004 },
        { lat: 46.15776367187498, lng: 13.634960937499983 },
        { lat: 46.13310546875004, lng: 13.616601562500078 },
        { lat: 46.08911132812503, lng: 13.54804687500004 },
        { lat: 46.03955078124997, lng: 13.486425781250034 },
        { lat: 46.009228515625004, lng: 13.480273437500017 },
        { lat: 45.987109375000045, lng: 13.487695312500023 },
        { lat: 45.973779296874994, lng: 13.509179687500051 },
        { lat: 45.97978515624996, lng: 13.6005859375 },
        { lat: 45.961669921875, lng: 13.613964843750068 },
        { lat: 45.834130859374966, lng: 13.569628906250017 },
        { lat: 45.81235351562506, lng: 13.58339843750005 },
        { lat: 45.7919921875, lng: 13.663476562500021 },
        { lat: 45.761279296875045, lng: 13.7216796875 },
        { lat: 45.68041992187499, lng: 13.831152343750006 },
        { lat: 45.61484375000006, lng: 13.874707031250066 },
        { lat: 45.592871093750006, lng: 13.8447265625 },
        { lat: 45.58198242187501, lng: 13.775976562500034 },
        { lat: 45.58759765625001, lng: 13.71982421875006 },
        { lat: 45.62724609375002, lng: 13.783300781250006 },
        { lat: 45.77094726562498, lng: 13.62832031250005 },
        { lat: 45.770703125, lng: 13.558203124999977 },
        { lat: 45.70996093749997, lng: 13.465136718750045 },
        { lat: 45.771386718749966, lng: 13.206347656250074 },
        { lat: 45.74658203124997, lng: 13.15673828125 },
        { lat: 45.69790039062502, lng: 13.1201171875 },
        { lat: 45.6375, lng: 13.0302734375 },
        { lat: 45.61079101562504, lng: 12.903027343750011 },
        { lat: 45.54428710937497, lng: 12.761230468749972 },
        { lat: 45.497216796874994, lng: 12.61171875000008 },
        { lat: 45.46166992187503, lng: 12.497558593749998 },
        { lat: 45.467919921874966, lng: 12.43212890625 },
        { lat: 45.54492187500002, lng: 12.536132812500057 },
        { lat: 45.546289062500016, lng: 12.491796875000063 },
        { lat: 45.49199218749999, lng: 12.353808593750015 },
        { lat: 45.44604492187503, lng: 12.27431640625008 },
        { lat: 45.36884765625003, lng: 12.248828125000045 },
        { lat: 45.24150390625001, lng: 12.225683593750034 },
        { lat: 45.20771484374998, lng: 12.28632812500004 },
        { lat: 45.03979492187506, lng: 12.39248046875008 },
        { lat: 44.96796874999998, lng: 12.523437500000027 },
        { lat: 44.89941406250006, lng: 12.49794921875008 },
        { lat: 44.84521484375002, lng: 12.463574218750011 },
        { lat: 44.798339843749964, lng: 12.384472656250068 },
        { lat: 44.833105468750034, lng: 12.31904296875004 },
        { lat: 44.832226562499955, lng: 12.278906250000034 },
        { lat: 44.72250976562498, lng: 12.248339843750045 },
        { lat: 44.42944335937506, lng: 12.304980468750017 },
        { lat: 44.22387695312499, lng: 12.396289062500074 },
        { lat: 44.13422851562503, lng: 12.486816406250028 },
        { lat: 43.994726562500034, lng: 12.691113281250011 },
        { lat: 43.92119140624999, lng: 12.907031250000017 },
        { lat: 43.68608398437504, lng: 13.29531250000008 },
        { lat: 43.61166992187498, lng: 13.508203125000023 },
        { lat: 43.57128906250003, lng: 13.56416015625004 },
        { lat: 43.38989257812499, lng: 13.693261718750051 },
        { lat: 43.180371093749955, lng: 13.804687500000028 },
        { lat: 42.85156250000003, lng: 13.924902343750004 },
        { lat: 42.68955078125006, lng: 14.010449218750011 },
        { lat: 42.50644531250006, lng: 14.182714843750032 },
        { lat: 42.24428710937502, lng: 14.54072265625004 },
        { lat: 42.05253906249995, lng: 14.86611328125008 },
        { lat: 41.93403320312498, lng: 15.16875 },
        { lat: 41.913232421874994, lng: 15.404980468749983 },
        { lat: 41.939453125, lng: 15.964062500000038 },
        { lat: 41.928125, lng: 16.0615234375 },
        { lat: 41.896191406249976, lng: 16.164648437500034 },
        { lat: 41.814013671875045, lng: 16.189160156250068 },
        { lat: 41.75849609375001, lng: 16.15126953125008 },
        { lat: 41.700781250000055, lng: 16.03369140625 },
        { lat: 41.62084960937503, lng: 15.913769531250011 },
        { lat: 41.51206054687498, lng: 15.900488281250034 },
        { lat: 41.435400390625006, lng: 16.01259765625005 },
        { lat: 41.232031250000034, lng: 16.551855468750063 },
        { lat: 41.062158203124994, lng: 17.10341796875008 },
        { lat: 40.975439453125006, lng: 17.275195312500074 },
        { lat: 40.84057617187506, lng: 17.474218750000034 },
        { lat: 40.655175781250016, lng: 17.954980468749994 },
        { lat: 40.56494140625003, lng: 18.03613281250003 },
        { lat: 40.370849609375, lng: 18.328222656250006 },
        { lat: 40.221044921875034, lng: 18.460644531249983 },
        { lat: 40.104833984375006, lng: 18.485839843750057 },
        { lat: 39.986865234375045, lng: 18.42255859375004 },
        { lat: 39.903613281250045, lng: 18.393457031250076 },
        { lat: 39.82138671874998, lng: 18.34375 },
        { lat: 39.85253906250002, lng: 18.219335937500034 },
        { lat: 39.93696289062498, lng: 18.077929687500014 },
        { lat: 40.28017578125002, lng: 17.865039062500074 },
        { lat: 40.31494140625, lng: 17.476171875000063 },
        { lat: 40.34023437499999, lng: 17.395800781250042 },
        { lat: 40.399072265624994, lng: 17.257714843750048 },
        { lat: 40.43789062499999, lng: 17.24941406250005 },
        { lat: 40.48642578125003, lng: 17.21533203125003 },
        { lat: 40.50278320312498, lng: 17.179980468750042 },
        { lat: 40.51347656250001, lng: 17.03125 },
        { lat: 40.45805664062502, lng: 16.92822265625 },
        { lat: 40.32646484375002, lng: 16.80703125000008 },
        { lat: 40.13720703125003, lng: 16.669628906250068 },
        { lat: 39.85966796874996, lng: 16.52998046875004 },
        { lat: 39.74755859375002, lng: 16.521875 },
        { lat: 39.63891601562503, lng: 16.597753906249977 },
        { lat: 39.578320312500004, lng: 16.824316406250063 },
        { lat: 39.48159179687502, lng: 16.999218750000068 },
        { lat: 39.38061523437497, lng: 17.114550781250017 },
        { lat: 39.136572265625006, lng: 17.122949218750048 },
        { lat: 38.998095703125045, lng: 17.174609375000017 },
        { lat: 38.919335937499966, lng: 17.09853515625005 },
        { lat: 38.93979492187506, lng: 16.951464843750017 },
        { lat: 38.88969726562499, lng: 16.755468750000063 },
        { lat: 38.80014648437503, lng: 16.61669921875003 },
        { lat: 38.71479492187495, lng: 16.55898437500008 },
        { lat: 38.493554687499994, lng: 16.57421875 },
        { lat: 38.40908203125002, lng: 16.54560546875001 },
        { lat: 38.249560546875045, lng: 16.28242187500004 },
        { lat: 38.08637695312501, lng: 16.144140625000034 },
        { lat: 38.01865234374998, lng: 16.10976562500005 },
        { lat: 37.941845703124955, lng: 16.05683593750001 },
        { lat: 37.93911132812502, lng: 15.724511718750078 },
        { lat: 38.03422851562504, lng: 15.645800781250015 },
        { lat: 38.175390625000034, lng: 15.64306640625 },
        { lat: 38.262304687500055, lng: 15.7001953125 },
        { lat: 38.302978515625, lng: 15.822363281250032 },
        { lat: 38.483496093750006, lng: 15.904785156250027 },
        { lat: 38.61391601562502, lng: 15.87890625 },
        { lat: 38.67172851562498, lng: 15.926953125000011 },
        { lat: 38.712597656249955, lng: 15.972363281250038 },
        { lat: 38.736425781250006, lng: 16.065527343750006 },
        { lat: 38.759228515624955, lng: 16.19677734375 },
        { lat: 38.94111328124998, lng: 16.20996093750003 },
        { lat: 39.023828125000016, lng: 16.10742187500003 },
        { lat: 39.13945312499996, lng: 16.071484375000065 },
        { lat: 39.35361328124998, lng: 16.02363281250001 },
        { lat: 39.62651367187499, lng: 15.854394531250078 },
        { lat: 39.870068359374955, lng: 15.763671875000055 },
        { lat: 39.99018554687501, lng: 15.692773437499994 },
        { lat: 40.05283203125006, lng: 15.58515625000001 },
        { lat: 40.05214843750002, lng: 15.390917968750074 },
        { lat: 40.07001953125001, lng: 15.294531250000064 },
        { lat: 40.23901367187497, lng: 14.950878906250042 },
        { lat: 40.26474609374998, lng: 14.926953125000038 },
        { lat: 40.30957031250006, lng: 14.929101562500025 },
        { lat: 40.377490234375045, lng: 14.986132812500017 },
        { lat: 40.469335937500006, lng: 14.94765625000008 },
        { lat: 40.556054687499994, lng: 14.90693359375004 },
        { lat: 40.629980468750034, lng: 14.839550781250013 },
        { lat: 40.66840820312498, lng: 14.76572265625006 },
        { lat: 40.64477539062503, lng: 14.611230468750023 },
        { lat: 40.62641601562504, lng: 14.556933593750074 },
        { lat: 40.632714843749994, lng: 14.459375 },
        { lat: 40.59985351562502, lng: 14.382714843750023 },
        { lat: 40.59882812500001, lng: 14.339941406250004 },
        { lat: 40.728710937500004, lng: 14.460546875000064 },
        { lat: 40.75932617187502, lng: 14.428125 },
        { lat: 40.81264648437505, lng: 14.308886718750074 },
        { lat: 40.82070312499999, lng: 14.147167968750068 },
        { lat: 40.827148437499964, lng: 14.102343749999989 },
        { lat: 40.79394531250006, lng: 14.07587890625004 },
        { lat: 40.81225585937506, lng: 14.044335937500078 },
        { lat: 40.87031249999998, lng: 14.047656250000044 },
        { lat: 41.129980468750034, lng: 13.859765625000051 },
        { lat: 41.23564453124999, lng: 13.733398437500057 },
        { lat: 41.254492187500006, lng: 13.669726562500074 },
        { lat: 41.23217773437497, lng: 13.554785156250006 },
        { lat: 41.27851562500001, lng: 13.361914062500063 },
        { lat: 41.28886718749999, lng: 13.246875 },
        { lat: 41.277685546875006, lng: 13.183398437500017 },
        { lat: 41.24384765624995, lng: 13.088671875000072 },
        { lat: 41.26621093749997, lng: 13.041015625000055 },
        { lat: 41.30092773437505, lng: 13.024218750000015 },
        { lat: 41.40874023437499, lng: 12.849218750000063 },
        { lat: 41.469677734374955, lng: 12.630859374999972 },
        { lat: 41.81264648437502, lng: 12.205664062500032 },
        { lat: 41.94086914062504, lng: 12.075292968750032 },
        { lat: 42.08203125000003, lng: 11.807031250000023 },
        { lat: 42.287548828124955, lng: 11.637304687500063 },
        { lat: 42.36293945312505, lng: 11.498437500000023 },
        { lat: 42.423291015624976, lng: 11.29628906250005 },
        { lat: 42.41572265624995, lng: 11.249707031250066 },
        { lat: 42.39311523437499, lng: 11.188867187500023 },
        { lat: 42.38989257812503, lng: 11.141210937499977 },
        { lat: 42.41660156250006, lng: 11.103222656250066 },
        { lat: 42.44409179687497, lng: 11.141796875000011 },
        { lat: 42.45659179687502, lng: 11.184765625000068 },
        { lat: 42.53515625000006, lng: 11.167773437500074 },
        { lat: 42.738720703124955, lng: 10.937792968750017 },
        { lat: 42.80429687499998, lng: 10.803125 },
        { lat: 42.844677734374955, lng: 10.765136718750028 },
        { lat: 42.89995117187502, lng: 10.737109374999989 },
        { lat: 42.93632812499998, lng: 10.708398437500023 },
        { lat: 42.95717773437505, lng: 10.644628906249977 },
        { lat: 42.95361328125003, lng: 10.59023437499999 },
        { lat: 42.96752929687503, lng: 10.51484375000001 },
        { lat: 43.06513671875001, lng: 10.517285156250066 },
        { lat: 43.14013671875003, lng: 10.532324218750032 },
        { lat: 43.20380859375001, lng: 10.520800781250074 },
        { lat: 43.371191406250006, lng: 10.447558593750074 },
        { lat: 43.513085937499966, lng: 10.320507812500038 },
        { lat: 43.85209960937502, lng: 10.245800781250011 },
        { lat: 43.947509765625, lng: 10.188085937500063 },
        { lat: 44.01997070312504, lng: 10.047656250000044 },
        { lat: 44.10117187500006, lng: 9.73085937500008 },
        { lat: 44.319238281249994, lng: 9.289355468750015 },
        { lat: 44.32299804687502, lng: 9.195996093750011 },
        { lat: 44.40776367187499, lng: 8.930371093750068 },
        { lat: 44.42231445312501, lng: 8.765820312500038 },
        { lat: 44.346142578124955, lng: 8.551953125000068 },
        { lat: 44.13652343749996, lng: 8.292382812500023 },
        { lat: 43.91894531250006, lng: 8.081640625 },
        { lat: 43.87675781249998, lng: 8.004980468750006 },
        { lat: 43.80258789062498, lng: 7.73330078125008 },
        { lat: 43.76713867187504, lng: 7.4931640625 },
        { lat: 43.82294921875004, lng: 7.490527343750017 },
        { lat: 43.864892578124966, lng: 7.482031250000062 },
        { lat: 43.91108398437495, lng: 7.522656250000068 },
        { lat: 43.96542968750003, lng: 7.589648437500045 },
        { lat: 44.03364257812498, lng: 7.651464843750034 },
        { lat: 44.08315429687502, lng: 7.677148437500023 },
        { lat: 44.11601562499996, lng: 7.665039062500028 },
        { lat: 44.16484375, lng: 7.637207031250056 },
        { lat: 44.16835937499996, lng: 7.599414062500074 },
        { lat: 44.12739257812498, lng: 7.370898437500074 },
        { lat: 44.13798828125001, lng: 7.318554687500068 },
        { lat: 44.20170898437502, lng: 7.149414062500056 },
        { lat: 44.280029296875, lng: 6.967285156249999 },
        { lat: 44.33574218749996, lng: 6.900195312499989 },
        { lat: 44.39204101562498, lng: 6.874804687500074 },
        { lat: 44.42817382812498, lng: 6.893847656250045 },
        { lat: 44.46328125000002, lng: 6.87861328125004 },
        { lat: 44.51069335937498, lng: 6.842968750000068 },
        { lat: 44.564550781250034, lng: 6.875195312500068 },
        { lat: 44.631640625000045, lng: 6.931933593750074 },
        { lat: 44.677148437499966, lng: 6.96035156250008 },
        { lat: 44.68896484374999, lng: 7.007910156250006 },
        { lat: 44.716699218750044, lng: 7.030664062500023 },
        { lat: 44.82729492187502, lng: 6.99267578125 },
        { lat: 44.84501953124999, lng: 6.972851562500068 },
        { lat: 44.858740234375034, lng: 6.93984375000008 },
        { lat: 44.86030273437498, lng: 6.889355468750011 },
        { lat: 44.883154296875034, lng: 6.801074218750045 },
        { lat: 44.92138671875, lng: 6.738183593750023 },
        { lat: 44.972998046875034, lng: 6.724707031250034 },
        { lat: 45.02260742187502, lng: 6.69140625 },
        { lat: 45.06816406249995, lng: 6.634765625000028 },
        { lat: 45.11796874999999, lng: 6.627734375000017 },
        { lat: 45.14428710937503, lng: 6.692285156250022 },
        { lat: 45.14531249999995, lng: 6.780371093750006 },
        { lat: 45.135644531250044, lng: 6.842285156250028 },
        { lat: 45.21557617187497, lng: 6.98125 },
        { lat: 45.222607421874976, lng: 7.03242187500004 },
        { lat: 45.23994140624998, lng: 7.078320312500039 },
        { lat: 45.349023437499994, lng: 7.116796874999977 },
        { lat: 45.381738281249994, lng: 7.14638671875005 },
        { lat: 45.40092773437498, lng: 7.153417968749977 },
        { lat: 45.423681640625006, lng: 7.126074218750006 },
        { lat: 45.50048828125003, lng: 7.013671875000028 },
        { lat: 45.58056640625, lng: 6.962402343750057 },
        { lat: 45.67036132812498, lng: 6.881445312500006 },
        { lat: 45.71000976562499, lng: 6.80625 },
        { lat: 45.740869140624966, lng: 6.790917968750023 },
        { lat: 45.78007812499996, lng: 6.789160156250034 },
        { lat: 45.81455078125006, lng: 6.804492187500045 },
        { lat: 45.86835937500001, lng: 6.940820312500023 },
        { lat: 45.92578124999997, lng: 7.021093750000034 },
        { lat: 45.90380859375003, lng: 7.055761718749976 },
        { lat: 45.88041992187499, lng: 7.129003906249976 },
        { lat: 45.912353515625, lng: 7.327929687500017 },
        { lat: 45.94443359375006, lng: 7.451562500000051 },
        { lat: 45.978173828124994, lng: 7.538574218750028 },
        { lat: 45.97221679687502, lng: 7.592578125000016 },
        { lat: 45.92182617187498, lng: 7.787890625000016 },
        { lat: 45.947460937499955, lng: 7.85234375 },
        { lat: 46.01591796874996, lng: 7.9931640625 },
        { lat: 46.051904296875016, lng: 8.014257812500034 },
        { lat: 46.16093750000002, lng: 8.125195312500068 },
        { lat: 46.18759765625003, lng: 8.127246093750044 },
        { lat: 46.25600585937502, lng: 8.081542968750057 },
        { lat: 46.27104492187499, lng: 8.095703125000028 },
        { lat: 46.34121093749996, lng: 8.231933593750057 },
        { lat: 46.403417968750034, lng: 8.298535156250038 },
        { lat: 46.44511718750001, lng: 8.370703125 },
        { lat: 46.44604492187503, lng: 8.422558593749983 },
        { lat: 46.43188476562497, lng: 8.436816406250045 },
        { lat: 46.40278320312498, lng: 8.442968750000063 },
        { lat: 46.28286132812499, lng: 8.438476562500028 },
        { lat: 46.24589843750002, lng: 8.458398437500021 },
        { lat: 46.159814453124966, lng: 8.565429687500057 },
        { lat: 46.11079101562501, lng: 8.641699218750063 },
        { lat: 46.07714843749999, lng: 8.818554687500011 },
        { lat: 46.06103515625, lng: 8.826757812500004 },
        { lat: 45.996191406250034, lng: 8.77802734375004 },
        { lat: 45.91870117187506, lng: 8.88515625 },
        { lat: 45.86196289062505, lng: 8.904296875 },
        { lat: 45.83002929687501, lng: 8.953710937500034 },
        { lat: 45.845703125, lng: 9.023730468750074 },
        { lat: 45.87558593750006, lng: 9.046679687500045 },
        { lat: 45.928125, lng: 9.019140625000034 },
        { lat: 45.98310546875004, lng: 8.99892578125008 },
        { lat: 46.01489257812503, lng: 9.003027343750034 },
        { lat: 46.051464843750004, lng: 9.02236328125008 },
        { lat: 46.102441406249994, lng: 9.07099609375004 },
        { lat: 46.21923828125, lng: 9.203417968750017 },
        { lat: 46.28676757812499, lng: 9.251074218750034 },
        { lat: 46.39125976562505, lng: 9.259765625000028 },
        { lat: 46.475195312500006, lng: 9.260156250000023 },
        { lat: 46.49555664062498, lng: 9.304394531250068 },
        { lat: 46.48066406249995, lng: 9.399316406250021 },
        { lat: 46.48232421875002, lng: 9.427636718750023 },
        { lat: 46.43081054687502, lng: 9.440625 },
        { lat: 46.34877929687499, lng: 9.481054687499975 },
        { lat: 46.306201171875045, lng: 9.528710937500021 },
        { lat: 46.29609375000001, lng: 9.57958984375 },
        { lat: 46.29589843749997, lng: 9.639453125000017 },
        { lat: 46.34604492187498, lng: 9.78779296875004 },
        { lat: 46.36777343750006, lng: 9.884472656250011 },
        { lat: 46.36181640624999, lng: 9.939257812500074 },
        { lat: 46.32768554687496, lng: 9.971679687500028 },
        { lat: 46.23808593750002, lng: 10.041015625000028 },
        { lat: 46.22797851562501, lng: 10.08056640625 },
        { lat: 46.23823242187495, lng: 10.128320312500051 },
        { lat: 46.25351562500006, lng: 10.14521484375004 },
        { lat: 46.28798828124996, lng: 10.1298828125 },
        { lat: 46.36284179687502, lng: 10.109667968750074 },
        { lat: 46.420751953125006, lng: 10.081933593750023 },
        { lat: 46.44790039062505, lng: 10.045605468750068 },
        { lat: 46.483203125000045, lng: 10.038281250000011 },
        { lat: 46.54677734375002, lng: 10.061230468750068 },
        { lat: 46.59990234375002, lng: 10.087011718750063 },
        { lat: 46.614355468750034, lng: 10.1375 },
        { lat: 46.62109374999997, lng: 10.195507812500066 },
        { lat: 46.564843749999966, lng: 10.272265625000072 },
        { lat: 46.547070312499976, lng: 10.363085937500017 },
        { lat: 46.55004882812497, lng: 10.4306640625 },
        { lat: 46.582861328125006, lng: 10.442480468750006 },
        { lat: 46.618847656249955, lng: 10.438281250000045 },
        { lat: 46.66503906250006, lng: 10.39794921875 },
        { lat: 46.73486328124997, lng: 10.406054687500045 },
        { lat: 46.86494140625001, lng: 10.452832031249981 },
        { lat: 46.85512695312505, lng: 10.47939453125008 },
        { lat: 46.85371093750001, lng: 10.579785156250011 },
        { lat: 46.84638671874995, lng: 10.689257812500017 },
        { lat: 46.79331054687497, lng: 10.759765625 },
        { lat: 46.775244140625034, lng: 10.828906250000045 },
        { lat: 46.76948242187501, lng: 10.927343750000034 },
        { lat: 46.777001953125016, lng: 10.993261718750032 },
        { lat: 46.796972656250006, lng: 11.025097656250038 },
        { lat: 46.85913085937497, lng: 11.063476562500057 },
        { lat: 46.93618164062505, lng: 11.133886718750006 },
        { lat: 46.975683593750006, lng: 11.244433593750045 },
        { lat: 46.983056640624994, lng: 11.433203125000063 },
        { lat: 46.99741210937498, lng: 11.52753906250001 },
        { lat: 46.99658203125, lng: 11.625488281250055 },
        { lat: 46.98466796874996, lng: 11.699414062500011 },
        { lat: 46.986083984375, lng: 11.775683593750017 },
        { lat: 47.03969726562499, lng: 11.969531250000074 },
        { lat: 47.082128906250006, lng: 12.169433593750027 },
        { lat: 47.075, lng: 12.19716796875008 },
        { lat: 47.060888671875034, lng: 12.201269531250034 },
        { lat: 47.028173828125034, lng: 12.165527343750028 },
        { lat: 46.98476562499999, lng: 12.130761718750051 },
      ],
      [
        { lat: 43.93457031250003, lng: 12.396875 },
        { lat: 43.89409179687496, lng: 12.426367187500063 },
        { lat: 43.901416015625045, lng: 12.48525390625008 },
        { lat: 43.95297851562506, lng: 12.514648437500028 },
        { lat: 43.98974609375, lng: 12.503710937500017 },
        { lat: 43.98242187500003, lng: 12.44111328125004 },
        { lat: 43.93457031250003, lng: 12.396875 },
      ],
    ],
  },
  {
    code: "IS",
    coordinates: [
      [
        { lat: 66.228515625, lng: -15.543115234374993 },
        { lat: 66.2248046875, lng: -15.428466796874998 },
        { lat: 66.259130859375, lng: -15.240917968749981 },
        { lat: 66.281689453125, lng: -15.162402343749987 },
        { lat: 66.359716796875, lng: -14.969970703125 },
        { lat: 66.3814453125, lng: -14.856103515624994 },
        { lat: 66.376123046875, lng: -14.6806640625 },
        { lat: 66.38154296875, lng: -14.595849609374993 },
        { lat: 66.373974609375, lng: -14.593896484374993 },
        { lat: 66.34228515625, lng: -14.70166015625 },
        { lat: 66.33144531249998, lng: -14.788232421874993 },
        { lat: 66.28427734374999, lng: -14.912207031249977 },
        { lat: 66.177880859375, lng: -15.029980468749983 },
        { lat: 66.12563476562498, lng: -15.117382812499985 },
        { lat: 66.10244140625, lng: -15.116406249999983 },
        { lat: 66.061279296875, lng: -15.01030273437499 },
        { lat: 66.037890625, lng: -14.89404296875 },
        { lat: 66.05908203125, lng: -14.787158203124987 },
        { lat: 66.050830078125, lng: -14.740429687499981 },
        { lat: 66.02021484375, lng: -14.698193359374983 },
        { lat: 65.989892578125, lng: -14.674365234374987 },
        { lat: 65.95986328125, lng: -14.668994140624989 },
        { lat: 65.89697265625, lng: -14.688232421875 },
        { lat: 65.8337890625, lng: -14.752539062499975 },
        { lat: 65.780908203125, lng: -14.839306640624983 },
        { lat: 65.76425781249999, lng: -14.827099609374981 },
        { lat: 65.7556640625, lng: -14.757519531249981 },
        { lat: 65.78994140625, lng: -14.426220703124983 },
        { lat: 65.78740234375, lng: -14.391845703124998 },
        { lat: 65.770361328125, lng: -14.372802734375 },
        { lat: 65.738720703125, lng: -14.369091796874983 },
        { lat: 65.710107421875, lng: -14.350878906249989 },
        { lat: 65.68447265625, lng: -14.318164062499989 },
        { lat: 65.658251953125, lng: -14.328369140625 },
        { lat: 65.575341796875, lng: -14.473388671875 },
        { lat: 65.62753906249999, lng: -14.302294921874989 },
        { lat: 65.64228515624998, lng: -14.166943359374983 },
        { lat: 65.616064453125, lng: -13.935449218749994 },
        { lat: 65.58593749999999, lng: -13.840722656249993 },
        { lat: 65.5330078125, lng: -13.785253906249977 },
        { lat: 65.550537109375, lng: -13.705126953124987 },
        { lat: 65.54951171875, lng: -13.6703125 },
        { lat: 65.5193359375, lng: -13.617871093749983 },
        { lat: 65.487158203125, lng: -13.616015624999989 },
        { lat: 65.44130859375, lng: -13.654443359374994 },
        { lat: 65.398974609375, lng: -13.667773437499987 },
        { lat: 65.381591796875, lng: -13.708007812499998 },
        { lat: 65.368994140625, lng: -13.783251953124987 },
        { lat: 65.35478515624999, lng: -13.804785156249977 },
        { lat: 65.322509765625, lng: -13.771630859374994 },
        { lat: 65.290966796875, lng: -13.722851562499983 },
        { lat: 65.289501953125, lng: -13.653466796874994 },
        { lat: 65.275, lng: -13.64111328125 },
        { lat: 65.25747070312498, lng: -13.639550781249994 },
        { lat: 65.236962890625, lng: -13.64892578125 },
        { lat: 65.2228515625, lng: -13.671582031249983 },
        { lat: 65.21513671875, lng: -13.70742187499999 },
        { lat: 65.192529296875, lng: -13.7548828125 },
        { lat: 65.143017578125, lng: -13.580810546874998 },
        { lat: 65.124658203125, lng: -13.55859375 },
        { lat: 65.09765625, lng: -13.556103515624983 },
        { lat: 65.068115234375, lng: -13.569677734374975 },
        { lat: 65.0359375, lng: -13.599316406249983 },
        { lat: 65.016845703125, lng: -13.65185546875 },
        { lat: 65.01372070312499, lng: -13.777246093749994 },
        { lat: 64.99287109375, lng: -13.85400390625 },
        { lat: 64.95800781249999, lng: -13.827832031249983 },
        { lat: 64.914013671875, lng: -13.829833984374998 },
        { lat: 64.862158203125, lng: -13.852929687499994 },
        { lat: 64.783642578125, lng: -13.951660156249998 },
        { lat: 64.74189453125, lng: -14.04443359375 },
        { lat: 64.714794921875, lng: -14.13515625 },
        { lat: 64.724365234375, lng: -14.296972656249977 },
        { lat: 64.74521484375, lng: -14.385107421874977 },
        { lat: 64.67744140625, lng: -14.375292968749989 },
        { lat: 64.635693359375, lng: -14.465380859374989 },
        { lat: 64.600830078125, lng: -14.448339843749977 },
        { lat: 64.58310546875, lng: -14.4169921875 },
        { lat: 64.538330078125, lng: -14.432568359374983 },
        { lat: 64.493994140625, lng: -14.475390624999989 },
        { lat: 64.445947265625, lng: -14.547070312499983 },
        { lat: 64.415966796875, lng: -14.628222656249987 },
        { lat: 64.379833984375, lng: -14.78955078125 },
        { lat: 64.319677734375, lng: -14.927392578124993 },
        { lat: 64.2958984375, lng: -15.021582031249977 },
        { lat: 64.296923828125, lng: -15.255859375 },
        { lat: 64.258203125, lng: -15.494970703124977 },
        { lat: 64.17666015625, lng: -15.832910156249993 },
        { lat: 64.11123046875, lng: -16.060449218749994 },
        { lat: 64.03720703125, lng: -16.236035156249983 },
        { lat: 63.91635742187499, lng: -16.46806640624999 },
        { lat: 63.865478515625, lng: -16.640332031249983 },
        { lat: 63.85175781249999, lng: -16.739697265624983 },
        { lat: 63.84091796874999, lng: -16.933056640624983 },
        { lat: 63.80810546874999, lng: -17.095117187499994 },
        { lat: 63.74658203125, lng: -17.633447265624994 },
        { lat: 63.71298828125, lng: -17.81572265624999 },
        { lat: 63.682373046875, lng: -17.83925781249999 },
        { lat: 63.636376953124994, lng: -17.91484374999999 },
        { lat: 63.61972656249999, lng: -17.919580078124994 },
        { lat: 63.606884765625, lng: -17.886376953124994 },
        { lat: 63.590185546875, lng: -17.880273437499994 },
        { lat: 63.53574218749999, lng: -17.946923828124994 },
        { lat: 63.496337890625, lng: -18.08002929687498 },
        { lat: 63.496972656249994, lng: -18.142919921874977 },
        { lat: 63.53085937499999, lng: -18.21904296874999 },
        { lat: 63.52968749999999, lng: -18.252197265625 },
        { lat: 63.52451171874999, lng: -18.265234374999977 },
        { lat: 63.5138671875, lng: -18.26601562499999 },
        { lat: 63.473193359375, lng: -18.222265624999977 },
        { lat: 63.45424804687499, lng: -18.302832031249977 },
        { lat: 63.406689453125, lng: -18.65361328124999 },
        { lat: 63.44199218749999, lng: -19.250195312499983 },
        { lat: 63.478515625, lng: -19.486572265625 },
        { lat: 63.536572265625, lng: -19.778271484374983 },
        { lat: 63.55205078125, lng: -19.95195312499999 },
        { lat: 63.55581054687499, lng: -20.198144531249994 },
        { lat: 63.63710937499999, lng: -20.40043945312499 },
        { lat: 63.68735351562499, lng: -20.494042968749994 },
        { lat: 63.708203125, lng: -20.501562499999977 },
        { lat: 63.731982421874996, lng: -20.49101562499999 },
        { lat: 63.74819335937499, lng: -20.469970703125 },
        { lat: 63.756982421874994, lng: -20.4384765625 },
        { lat: 63.757861328125, lng: -20.371728515624994 },
        { lat: 63.76494140625, lng: -20.363037109375 },
        { lat: 63.80517578124999, lng: -20.41396484374999 },
        { lat: 63.792138671874994, lng: -20.46269531249999 },
        { lat: 63.73535156250001, lng: -20.592968749999983 },
        { lat: 63.73740234374999, lng: -20.65092773437499 },
        { lat: 63.76577148437499, lng: -20.727050781249996 },
        { lat: 63.79335937499999, lng: -20.729931640624983 },
        { lat: 63.80390625, lng: -20.878759765624977 },
        { lat: 63.83837890624999, lng: -21.00810546874999 },
        { lat: 63.887939453125, lng: -21.136572265624977 },
        { lat: 63.9068359375, lng: -21.15576171875 },
        { lat: 63.934423828125006, lng: -21.09404296874999 },
        { lat: 63.93984374999999, lng: -21.10595703125 },
        { lat: 63.94453125, lng: -21.15239257812499 },
        { lat: 63.93544921875, lng: -21.246240234374994 },
        { lat: 63.87280273437501, lng: -21.387597656249994 },
        { lat: 63.8583984375, lng: -21.448632812499994 },
        { lat: 63.84375, lng: -22.37255859375 },
        { lat: 63.83725585937499, lng: -22.606884765624983 },
        { lat: 63.827734375, lng: -22.652197265624977 },
        { lat: 63.868505859375, lng: -22.693017578124994 },
        { lat: 63.95947265625001, lng: -22.729394531249994 },
        { lat: 64.019384765625, lng: -22.74296874999999 },
        { lat: 64.048388671875, lng: -22.733642578125 },
        { lat: 64.083203125, lng: -22.701171875 },
        { lat: 64.077294921875, lng: -22.650927734374985 },
        { lat: 64.049609375, lng: -22.60307617187499 },
        { lat: 64.0103515625, lng: -22.559814453125 },
        { lat: 63.99145507812499, lng: -22.51005859374999 },
        { lat: 64.039208984375, lng: -22.187597656249977 },
        { lat: 64.071337890625, lng: -22.056640625 },
        { lat: 64.10185546874999, lng: -22.0009765625 },
        { lat: 64.153759765625, lng: -21.935449218749994 },
        { lat: 64.180322265625, lng: -21.865917968749983 },
        { lat: 64.205419921875, lng: -21.832763671875 },
        { lat: 64.28486328125, lng: -21.767578125 },
        { lat: 64.32177734375, lng: -21.72255859374999 },
        { lat: 64.3490234375, lng: -21.668652343749983 },
        { lat: 64.3666015625, lng: -21.60600585937499 },
        { lat: 64.379150390625, lng: -21.463330078124983 },
        { lat: 64.3978515625, lng: -21.55717773437499 },
        { lat: 64.3978515625, lng: -21.646679687499983 },
        { lat: 64.313916015625, lng: -21.95122070312499 },
        { lat: 64.313916015625, lng: -22.053369140624994 },
        { lat: 64.327001953125, lng: -22.049072265625 },
        { lat: 64.35068359375, lng: -22.00600585937499 },
        { lat: 64.3916015625, lng: -21.901269531249994 },
        { lat: 64.394677734375, lng: -21.97319335937499 },
        { lat: 64.41318359375, lng: -22.000683593749983 },
        { lat: 64.452197265625, lng: -22.003808593749994 },
        { lat: 64.514990234375, lng: -21.95034179687499 },
        { lat: 64.597802734375, lng: -21.702392578125 },
        { lat: 64.610009765625, lng: -21.616650390624983 },
        { lat: 64.6263671875, lng: -21.590625 },
        { lat: 64.63974609375, lng: -21.623144531249977 },
        { lat: 64.647705078125, lng: -21.674951171874994 },
        { lat: 64.562548828125, lng: -21.924414062499977 },
        { lat: 64.533056640625, lng: -22.10600585937499 },
        { lat: 64.538818359375, lng: -22.159960937499985 },
        { lat: 64.571875, lng: -22.25390625 },
        { lat: 64.586572265625, lng: -22.2841796875 },
        { lat: 64.6244140625, lng: -22.32470703125 },
        { lat: 64.647216796875, lng: -22.32011718749999 },
        { lat: 64.71396484375, lng: -22.233593749999983 },
        { lat: 64.726904296875, lng: -22.24755859375 },
        { lat: 64.73349609375, lng: -22.30703125 },
        { lat: 64.794970703125, lng: -22.467041015625 },
        { lat: 64.788818359375, lng: -22.720312499999977 },
        { lat: 64.824365234375, lng: -23.346972656249985 },
        { lat: 64.80927734375, lng: -23.476464843749994 },
        { lat: 64.75654296875, lng: -23.68994140625 },
        { lat: 64.73916015625, lng: -23.818994140624994 },
        { lat: 64.750634765625, lng: -23.878564453124994 },
        { lat: 64.778515625, lng: -23.93276367187499 },
        { lat: 64.81611328125, lng: -23.98198242187499 },
        { lat: 64.863427734375, lng: -24.02617187499999 },
        { lat: 64.896435546875, lng: -24.007031249999983 },
        { lat: 64.915234375, lng: -23.924414062499977 },
        { lat: 64.924169921875, lng: -23.86381835937499 },
        { lat: 64.912744140625, lng: -23.693212890624977 },
        { lat: 64.945849609375, lng: -23.485302734374983 },
        { lat: 64.952783203125, lng: -23.352685546874994 },
        { lat: 64.95800781249999, lng: -23.31459960937499 },
        { lat: 64.99326171875, lng: -23.236523437499983 },
        { lat: 65.0021484375, lng: -23.197998046874996 },
        { lat: 64.98979492187499, lng: -23.137890624999983 },
        { lat: 64.965869140625, lng: -23.108837890624983 },
        { lat: 65.00302734375, lng: -22.899511718749977 },
        { lat: 65.0216796875, lng: -22.82768554687499 },
        { lat: 65.03310546875, lng: -22.819580078125 },
        { lat: 65.046484375, lng: -22.7880859375 },
        { lat: 65.02636718749999, lng: -22.68398437499999 },
        { lat: 65.02573242187499, lng: -22.599707031249977 },
        { lat: 65.03955078125, lng: -22.494482421874977 },
        { lat: 65.045654296875, lng: -22.308447265624977 },
        { lat: 65.048779296875, lng: -21.89213867187499 },
        { lat: 65.0791015625, lng: -21.82978515624998 },
        { lat: 65.105908203125, lng: -21.80043945312499 },
        { lat: 65.17373046875, lng: -21.76372070312499 },
        { lat: 65.1876953125, lng: -21.779980468749983 },
        { lat: 65.125244140625, lng: -22.039990234374983 },
        { lat: 65.126220703125, lng: -22.09931640624998 },
        { lat: 65.159326171875, lng: -22.40029296874999 },
        { lat: 65.19677734375, lng: -22.50908203124999 },
        { lat: 65.22685546875, lng: -22.47343749999999 },
        { lat: 65.2916015625, lng: -22.31396484375 },
        { lat: 65.3435546875, lng: -22.149316406249994 },
        { lat: 65.39970703125, lng: -21.906982421875 },
        { lat: 65.421533203125, lng: -21.850244140624994 },
        { lat: 65.44736328125, lng: -21.844384765624994 },
        { lat: 65.49345703125, lng: -22.005761718749994 },
        { lat: 65.480712890625, lng: -22.311474609374983 },
        { lat: 65.535400390625, lng: -22.38969726562499 },
        { lat: 65.5677734375, lng: -22.64360351562499 },
        { lat: 65.547412109375, lng: -22.812646484374994 },
        { lat: 65.58046875, lng: -22.902490234374994 },
        { lat: 65.534765625, lng: -23.122070312499996 },
        { lat: 65.468603515625, lng: -23.604541015624985 },
        { lat: 65.42275390625, lng: -23.796484374999974 },
        { lat: 65.407568359375, lng: -23.89990234375 },
        { lat: 65.44501953125, lng: -24.018994140624983 },
        { lat: 65.48720703124998, lng: -24.223974609374977 },
        { lat: 65.500341796875, lng: -24.454785156249983 },
        { lat: 65.5251953125, lng: -24.475683593749977 },
        { lat: 65.601220703125, lng: -24.341064453125 },
        { lat: 65.614990234375, lng: -24.248925781249994 },
        { lat: 65.6080078125, lng: -24.156103515624977 },
        { lat: 65.55498046875, lng: -23.97900390625 },
        { lat: 65.53837890625, lng: -23.85673828124999 },
        { lat: 65.61621093749999, lng: -24.010009765625 },
        { lat: 65.646142578125, lng: -24.006005859374994 },
        { lat: 65.69091796874999, lng: -24.017578125 },
        { lat: 65.71015625, lng: -24.065039062499977 },
        { lat: 65.759716796875, lng: -24.111914062499977 },
        { lat: 65.77646484375, lng: -24.092626953124974 },
        { lat: 65.78232421875, lng: -24.03242187499998 },
        { lat: 65.76557617187498, lng: -23.909082031249994 },
        { lat: 65.67958984374998, lng: -23.615917968749983 },
        { lat: 65.69482421875, lng: -23.47197265624999 },
        { lat: 65.726513671875, lng: -23.39296875 },
        { lat: 65.75, lng: -23.285351562499983 },
        { lat: 65.762255859375, lng: -23.31591796875 },
        { lat: 65.763720703125, lng: -23.56928710937498 },
        { lat: 65.781201171875, lng: -23.704736328124994 },
        { lat: 65.80634765625, lng: -23.77324218749999 },
        { lat: 65.84921875, lng: -23.832617187499974 },
        { lat: 65.868896484375, lng: -23.811718749999983 },
        { lat: 65.8845703125, lng: -23.741308593749977 },
        { lat: 65.880029296875, lng: -23.52495117187499 },
        { lat: 65.954296875, lng: -23.66748046875 },
        { lat: 65.99697265625, lng: -23.766552734374983 },
        { lat: 66.017578125, lng: -23.77734375 },
        { lat: 66.04345703125, lng: -23.77055664062499 },
        { lat: 66.060791015625, lng: -23.75712890624999 },
        { lat: 66.06943359375, lng: -23.737158203124977 },
        { lat: 66.02607421875, lng: -23.488867187499977 },
        { lat: 66.02421874999999, lng: -23.434472656249994 },
        { lat: 66.05224609375, lng: -23.48466796874999 },
        { lat: 66.093408203125, lng: -23.59355468749999 },
        { lat: 66.108837890625, lng: -23.598535156249994 },
        { lat: 66.12158203125, lng: -23.552636718749994 },
        { lat: 66.14501953125, lng: -23.52998046874998 },
        { lat: 66.164404296875, lng: -23.527929687499977 },
        { lat: 66.181005859375, lng: -23.45253906249999 },
        { lat: 66.18173828125, lng: -23.376562499999977 },
        { lat: 66.16660156249999, lng: -23.3 },
        { lat: 66.08623046874999, lng: -23.06254882812499 },
        { lat: 66.06367187499998, lng: -23.028515624999983 },
        { lat: 66.033935546875, lng: -23.017285156249983 },
        { lat: 65.9970703125, lng: -23.028906249999977 },
        { lat: 65.98212890625, lng: -23.018994140624983 },
        { lat: 65.99482421875, lng: -22.926220703124983 },
        { lat: 65.979296875, lng: -22.852246093749983 },
        { lat: 65.98349609375, lng: -22.81533203124999 },
        { lat: 66.03901367187498, lng: -22.723339843749983 },
        { lat: 66.025927734375, lng: -22.659863281249983 },
        { lat: 65.999951171875, lng: -22.621582031249996 },
        { lat: 65.97646484375, lng: -22.609716796874977 },
        { lat: 65.944189453125, lng: -22.60405273437499 },
        { lat: 65.87695312499999, lng: -22.620214843749974 },
        { lat: 65.86748046875, lng: -22.61601562499999 },
        { lat: 65.905419921875, lng: -22.551562499999985 },
        { lat: 65.90830078125, lng: -22.44169921874999 },
        { lat: 65.927392578125, lng: -22.42753906249999 },
        { lat: 65.998095703125, lng: -22.42421875 },
        { lat: 66.057666015625, lng: -22.43315429687499 },
        { lat: 66.07001953124998, lng: -22.4453125 },
        { lat: 66.152587890625, lng: -22.80644531249999 },
        { lat: 66.1720703125, lng: -22.869238281249977 },
        { lat: 66.212744140625, lng: -22.947900390624994 },
        { lat: 66.233203125, lng: -22.931982421874977 },
        { lat: 66.25146484375, lng: -22.861621093749985 },
        { lat: 66.258740234375, lng: -22.755517578124994 },
        { lat: 66.257763671875, lng: -22.509375 },
        { lat: 66.26630859375, lng: -22.48442382812499 },
        { lat: 66.28774414062498, lng: -22.532128906249994 },
        { lat: 66.3015625, lng: -22.646093749999977 },
        { lat: 66.313916015625, lng: -22.672753906249994 },
        { lat: 66.3376953125, lng: -22.686230468749983 },
        { lat: 66.32470703125, lng: -22.82133789062499 },
        { lat: 66.324169921875, lng: -22.972021484374974 },
        { lat: 66.338720703125, lng: -23.116943359375 },
        { lat: 66.3572265625, lng: -23.11992187499999 },
        { lat: 66.384375, lng: -23.062695312499983 },
        { lat: 66.429443359375, lng: -22.944335937499996 },
        { lat: 66.440625, lng: -22.88920898437499 },
        { lat: 66.432763671875, lng: -22.723730468749977 },
        { lat: 66.44541015625, lng: -22.559326171875 },
        { lat: 66.43012695312498, lng: -22.426123046874977 },
        { lat: 66.385498046875, lng: -22.320458984374994 },
        { lat: 66.30712890625, lng: -22.17021484374999 },
        { lat: 66.256982421875, lng: -21.966992187499983 },
        { lat: 66.24125976562499, lng: -21.948388671874994 },
        { lat: 66.2001953125, lng: -21.84023437499999 },
        { lat: 66.089697265625, lng: -21.625292968749985 },
        { lat: 66.02558593749998, lng: -21.406884765624994 },
        { lat: 66.00927734375, lng: -21.396777343749985 },
        { lat: 65.990087890625, lng: -21.432714843749977 },
        { lat: 65.967578125, lng: -21.51665039062499 },
        { lat: 65.955078125, lng: -21.497460937499994 },
        { lat: 65.93876953125, lng: -21.387792968749977 },
        { lat: 65.89531249999999, lng: -21.308789062499983 },
        { lat: 65.87646484375, lng: -21.303466796875 },
        { lat: 65.74189453125, lng: -21.374902343749994 },
        { lat: 65.713330078125, lng: -21.412841796875 },
        { lat: 65.6982421875, lng: -21.456640624999977 },
        { lat: 65.723583984375, lng: -21.658447265625 },
        { lat: 65.68076171875, lng: -21.6103515625 },
        { lat: 65.63515625, lng: -21.466259765624983 },
        { lat: 65.60966796875, lng: -21.43364257812499 },
        { lat: 65.58466796875, lng: -21.45512695312499 },
        { lat: 65.57890624999999, lng: -21.439404296874983 },
        { lat: 65.592431640625, lng: -21.386621093749994 },
        { lat: 65.57822265624999, lng: -21.36474609375 },
        { lat: 65.536376953125, lng: -21.373876953124977 },
        { lat: 65.50166015625, lng: -21.396337890624977 },
        { lat: 65.474072265625, lng: -21.43217773437499 },
        { lat: 65.462158203125, lng: -21.421875 },
        { lat: 65.4658203125, lng: -21.365478515625 },
        { lat: 65.45869140625, lng: -21.31254882812499 },
        { lat: 65.42060546875, lng: -21.22998046875 },
        { lat: 65.304248046875, lng: -21.162988281249994 },
        { lat: 65.2666015625, lng: -21.12968749999999 },
        { lat: 65.3, lng: -21.105712890625 },
        { lat: 65.3849609375, lng: -21.075585937499994 },
        { lat: 65.428369140625, lng: -21.047314453124983 },
        { lat: 65.4302734375, lng: -21.020849609374977 },
        { lat: 65.44453125, lng: -20.997998046874983 },
        { lat: 65.47119140625, lng: -20.978857421874974 },
        { lat: 65.565185546875, lng: -20.93974609374999 },
        { lat: 65.63642578125, lng: -20.804345703124994 },
        { lat: 65.658251953125, lng: -20.739697265624983 },
        { lat: 65.6630859375, lng: -20.678955078124996 },
        { lat: 65.65419921874998, lng: -20.6494140625 },
        { lat: 65.5794921875, lng: -20.54814453124999 },
        { lat: 65.566943359375, lng: -20.486523437499983 },
        { lat: 65.571044921875, lng: -20.454833984375 },
        { lat: 65.621728515625, lng: -20.411523437499994 },
        { lat: 65.71904296875, lng: -20.356640624999983 },
        { lat: 65.827734375, lng: -20.344091796874977 },
        { lat: 65.947705078125, lng: -20.373925781249994 },
        { lat: 66.033251953125, lng: -20.356591796874994 },
        { lat: 66.084375, lng: -20.292138671874994 },
        { lat: 66.10009765625, lng: -20.20751953125 },
        { lat: 66.08046875, lng: -20.10268554687499 },
        { lat: 66.049267578125, lng: -20.026074218749983 },
        { lat: 65.930126953125, lng: -19.874755859374996 },
        { lat: 65.8677734375, lng: -19.752636718749983 },
        { lat: 65.80078125, lng: -19.647851562499994 },
        { lat: 65.779052734375, lng: -19.59355468749999 },
        { lat: 65.76806640625, lng: -19.489697265624983 },
        { lat: 65.77236328125, lng: -19.461816406249994 },
        { lat: 65.787841796875, lng: -19.443261718749994 },
        { lat: 65.814453125, lng: -19.43388671874999 },
        { lat: 65.984912109375, lng: -19.45625 },
        { lat: 66.03798828125, lng: -19.427050781249985 },
        { lat: 66.07568359374999, lng: -19.382958984374994 },
        { lat: 66.097900390625, lng: -19.1953125 },
        { lat: 66.121533203125, lng: -19.093212890624983 },
        { lat: 66.1603515625, lng: -18.99375 },
        { lat: 66.18115234375, lng: -18.911328124999983 },
        { lat: 66.183935546875, lng: -18.845898437499983 },
        { lat: 66.168798828125, lng: -18.777539062499983 },
        { lat: 66.1357421875, lng: -18.70620117187499 },
        { lat: 66.071337890625, lng: -18.594921874999983 },
        { lat: 65.96455078125, lng: -18.454931640624977 },
        { lat: 65.884716796875, lng: -18.276953124999974 },
        { lat: 65.7580078125, lng: -18.183642578124985 },
        { lat: 65.736572265625, lng: -18.163720703124994 },
        { lat: 65.73408203125, lng: -18.141943359374977 },
        { lat: 65.750537109375, lng: -18.118408203125 },
        { lat: 65.77392578125, lng: -18.103320312499985 },
        { lat: 65.8302734375, lng: -18.099023437499994 },
        { lat: 65.905029296875, lng: -18.148876953124983 },
        { lat: 66.0931640625, lng: -18.315332031249994 },
        { lat: 66.12880859375, lng: -18.318212890624977 },
        { lat: 66.157421875, lng: -18.29716796874999 },
        { lat: 66.160546875, lng: -18.179882812499983 },
        { lat: 66.14331054687499, lng: -17.906982421875 },
        { lat: 66.114111328125, lng: -17.81982421875 },
        { lat: 65.999169921875, lng: -17.63432617187499 },
        { lat: 65.97138671875, lng: -17.582226562499983 },
        { lat: 65.964404296875, lng: -17.550439453124994 },
        { lat: 65.9783203125, lng: -17.53901367187498 },
        { lat: 65.999658203125, lng: -17.467041015625 },
        { lat: 66.025537109375, lng: -17.417236328125 },
        { lat: 66.0888671875, lng: -17.33427734374999 },
        { lat: 66.20283203125, lng: -17.15302734374998 },
        { lat: 66.206201171875, lng: -17.11538085937499 },
        { lat: 66.197216796875, lng: -17.062451171874983 },
        { lat: 66.1673828125, lng: -16.96953124999999 },
        { lat: 66.14345703125, lng: -16.925439453124994 },
        { lat: 66.125244140625, lng: -16.838037109374994 },
        { lat: 66.131640625, lng: -16.7484375 },
        { lat: 66.17158203125, lng: -16.624755859375 },
        { lat: 66.195947265625, lng: -16.485009765624994 },
        { lat: 66.25253906249999, lng: -16.437109374999977 },
        { lat: 66.278369140625, lng: -16.428076171874977 },
        { lat: 66.446728515625, lng: -16.540673828124994 },
        { lat: 66.48115234375, lng: -16.493359374999983 },
        { lat: 66.522900390625, lng: -16.249316406249985 },
        { lat: 66.52607421875, lng: -16.035888671875 },
        { lat: 66.51464843749999, lng: -15.985400390624987 },
        { lat: 66.432861328125, lng: -15.850927734374975 },
        { lat: 66.39169921875, lng: -15.759765625 },
        { lat: 66.35859375, lng: -15.713769531249996 },
        { lat: 66.2857421875, lng: -15.702783203124994 },
        { lat: 66.2587890625, lng: -15.647363281249996 },
        { lat: 66.228515625, lng: -15.543115234374993 },
      ],
    ],
  },
  {
    code: "IE",
    coordinates: [
      [
        { lat: 53.91313476562499, lng: -9.948193359374926 },
        { lat: 53.884570312500045, lng: -9.952441406249989 },
        { lat: 53.920556640624994, lng: -10.026513671874994 },
        { lat: 53.95971679687497, lng: -10.0625 },
        { lat: 53.977685546874994, lng: -10.265722656249947 },
        { lat: 54.01684570312497, lng: -10.181054687499937 },
        { lat: 54.005224609375006, lng: -10.139746093749949 },
        { lat: 54.00361328125004, lng: -9.99638671874996 },
        { lat: 53.987207031249994, lng: -9.956152343749949 },
        { lat: 53.91313476562499, lng: -9.948193359374926 },
      ],
      [
        { lat: 55.00332031250005, lng: -7.40141601562496 },
        { lat: 54.905126953125034, lng: -7.445996093749982 },
        { lat: 54.87709960937499, lng: -7.451269531249977 },
        { lat: 54.82543945312506, lng: -7.502197265624972 },
        { lat: 54.767968749999966, lng: -7.55039062499992 },
        { lat: 54.745703125000055, lng: -7.606445312499972 },
        { lat: 54.72802734375, lng: -7.689990234374932 },
        { lat: 54.71044921874997, lng: -7.7375 },
        { lat: 54.71928710937499, lng: -7.797265624999937 },
        { lat: 54.71787109374998, lng: -7.872949218749994 },
        { lat: 54.698339843750006, lng: -7.910595703124955 },
        { lat: 54.68334960937505, lng: -7.908740234374933 },
        { lat: 54.66606445312499, lng: -7.886132812499937 },
        { lat: 54.639697265625045, lng: -7.819824218750028 },
        { lat: 54.61582031250006, lng: -7.746289062499954 },
        { lat: 54.59492187499998, lng: -7.754394531249999 },
        { lat: 54.57124023437504, lng: -7.793798828124949 },
        { lat: 54.51245117187505, lng: -8.044335937500023 },
        { lat: 54.47695312500002, lng: -8.118945312499932 },
        { lat: 54.45351562500002, lng: -8.14482421874996 },
        { lat: 54.41425781250004, lng: -8.118261718749977 },
        { lat: 54.29658203125004, lng: -7.918457031249943 },
        { lat: 54.283789062500006, lng: -7.884472656249955 },
        { lat: 54.21528320312498, lng: -7.854931640624983 },
        { lat: 54.186669921875016, lng: -7.678759765624959 },
        { lat: 54.14384765625002, lng: -7.606542968750005 },
        { lat: 54.13359375, lng: -7.544433593749942 },
        { lat: 54.137304687500006, lng: -7.409423828124972 },
        { lat: 54.12124023437502, lng: -7.355175781249955 },
        { lat: 54.13344726562502, lng: -7.324511718750017 },
        { lat: 54.156005859375, lng: -7.306738281249949 },
        { lat: 54.21411132812503, lng: -7.193066406249955 },
        { lat: 54.23950195312506, lng: -7.155468749999926 },
        { lat: 54.27490234374997, lng: -7.17807617187492 },
        { lat: 54.301806640625045, lng: -7.202587890624955 },
        { lat: 54.35537109375002, lng: -7.133496093749983 },
        { lat: 54.40825195312496, lng: -7.049707031249965 },
        { lat: 54.40668945312501, lng: -7.007714843749937 },
        { lat: 54.37431640624998, lng: -6.93613281249992 },
        { lat: 54.3291015625, lng: -6.877246093749932 },
        { lat: 54.294042968750055, lng: -6.869238281249977 },
        { lat: 54.268652343750034, lng: -6.858349609374982 },
        { lat: 54.21435546874997, lng: -6.802587890624977 },
        { lat: 54.19560546874999, lng: -6.766601562499942 },
        { lat: 54.184716796874994, lng: -6.669531249999977 },
        { lat: 54.163427734375006, lng: -6.646875 },
        { lat: 54.08476562499996, lng: -6.664208984374965 },
        { lat: 54.05864257812496, lng: -6.649804687499937 },
        { lat: 54.05727539062505, lng: -6.548144531249932 },
        { lat: 54.063623046874994, lng: -6.440283203124977 },
        { lat: 54.06064453125003, lng: -6.402587890624943 },
        { lat: 54.07709960937501, lng: -6.363671875000023 },
        { lat: 54.094873046874966, lng: -6.303662109374955 },
        { lat: 54.08872070312506, lng: -6.218017578125 },
        { lat: 54.05351562499999, lng: -6.17573242187501 },
        { lat: 54.01723632812496, lng: -6.156933593749982 },
        { lat: 54.00361328125004, lng: -6.230664062500011 },
        { lat: 54.01103515625004, lng: -6.307617187499972 },
        { lat: 53.987207031249994, lng: -6.345166015624983 },
        { lat: 53.941308593750044, lng: -6.347607421874926 },
        { lat: 53.88217773437498, lng: -6.32158203124996 },
        { lat: 53.840234374999966, lng: -6.270117187499949 },
        { lat: 53.74570312499998, lng: -6.229003906250028 },
        { lat: 53.64086914062503, lng: -6.194873046874989 },
        { lat: 53.57753906250002, lng: -6.141845703124943 },
        { lat: 53.498925781249994, lng: -6.130957031249949 },
        { lat: 53.460302734375006, lng: -6.13876953124992 },
        { lat: 53.390869140625, lng: -6.129101562499926 },
        { lat: 53.36640624999998, lng: -6.151660156249989 },
        { lat: 53.30122070312504, lng: -6.134716796874983 },
        { lat: 53.16630859374999, lng: -6.072265624999971 },
        { lat: 53.091162109375034, lng: -6.04501953124992 },
        { lat: 52.927099609375006, lng: -6.027392578124989 },
        { lat: 52.865625, lng: -6.071484374999983 },
        { lat: 52.807275390625016, lng: -6.13066406249996 },
        { lat: 52.73813476562498, lng: -6.169335937499937 },
        { lat: 52.66347656250005, lng: -6.19921875 },
        { lat: 52.54311523437502, lng: -6.217236328124926 },
        { lat: 52.402001953124966, lng: -6.345410156249926 },
        { lat: 52.36694335937503, lng: -6.399951171874932 },
        { lat: 52.345361328124994, lng: -6.463183593749932 },
        { lat: 52.246679687500034, lng: -6.325 },
        { lat: 52.20268554687495, lng: -6.437939453124954 },
        { lat: 52.18881835937498, lng: -6.561083984374989 },
        { lat: 52.21352539062502, lng: -6.69731445312496 },
        { lat: 52.210498046875045, lng: -6.782226562500028 },
        { lat: 52.178564453125006, lng: -6.859716796875005 },
        { lat: 52.15922851562499, lng: -6.890234375 },
        { lat: 52.16855468750003, lng: -6.914648437500006 },
        { lat: 52.24951171875, lng: -6.965771484374926 },
        { lat: 52.16591796875002, lng: -7.00327148437492 },
        { lat: 52.13930664062502, lng: -7.081787109374943 },
        { lat: 52.14497070312501, lng: -7.216210937499966 },
        { lat: 52.122705078124994, lng: -7.440869140624984 },
        { lat: 52.09887695312503, lng: -7.527294921874926 },
        { lat: 52.06162109375, lng: -7.563183593749955 },
        { lat: 52.01855468750003, lng: -7.589843749999972 },
        { lat: 51.99311523437498, lng: -7.624902343749994 },
        { lat: 51.979736328125, lng: -7.664550781249999 },
        { lat: 51.94799804687502, lng: -7.837988281249977 },
        { lat: 51.93530273437502, lng: -7.87216796874992 },
        { lat: 51.86577148437499, lng: -7.952490234374949 },
        { lat: 51.82558593750005, lng: -8.057812499999926 },
        { lat: 51.81352539062498, lng: -8.14501953125 },
        { lat: 51.85400390624997, lng: -8.222460937499989 },
        { lat: 51.878320312500044, lng: -8.254296874999966 },
        { lat: 51.89067382812498, lng: -8.290234374999926 },
        { lat: 51.888769531250034, lng: -8.4091796875 },
        { lat: 51.87626953124999, lng: -8.371630859374989 },
        { lat: 51.84770507812502, lng: -8.347363281249926 },
        { lat: 51.792968749999964, lng: -8.335595703124937 },
        { lat: 51.73930664062495, lng: -8.349121093749943 },
        { lat: 51.71206054687502, lng: -8.407812499999977 },
        { lat: 51.70703125000006, lng: -8.47783203124996 },
        { lat: 51.6513671875, lng: -8.58828125 },
        { lat: 51.63618164062501, lng: -8.734472656249919 },
        { lat: 51.584912109374955, lng: -8.813427734374924 },
        { lat: 51.49824218749998, lng: -9.296484374999949 },
        { lat: 51.49721679687502, lng: -9.323876953125023 },
        { lat: 51.519287109375, lng: -9.390576171874926 },
        { lat: 51.52905273437502, lng: -9.462890625 },
        { lat: 51.522167968749955, lng: -9.534863281249926 },
        { lat: 51.47373046875003, lng: -9.737304687499943 },
        { lat: 51.483349609374955, lng: -9.835351562499937 },
        { lat: 51.603710937499955, lng: -9.710351562499966 },
        { lat: 51.66445312499999, lng: -9.542382812499937 },
        { lat: 51.68110351562501, lng: -9.524902343750028 },
        { lat: 51.68925781249999, lng: -9.579833984375027 },
        { lat: 51.647070312500006, lng: -9.899023437499947 },
        { lat: 51.61113281249996, lng: -10.009912109374966 },
        { lat: 51.60068359375006, lng: -10.120751953124994 },
        { lat: 51.65556640624996, lng: -10.06943359374992 },
        { lat: 51.730712890625, lng: -9.926416015624937 },
        { lat: 51.76611328125, lng: -9.849707031249919 },
        { lat: 51.780126953125034, lng: -9.802880859374994 },
        { lat: 51.82426757812495, lng: -9.749511718749941 },
        { lat: 51.87441406250005, lng: -9.598828124999983 },
        { lat: 51.77099609375003, lng: -10.084228515625028 },
        { lat: 51.78359375000002, lng: -10.21171875 },
        { lat: 51.81245117187504, lng: -10.241748046874958 },
        { lat: 51.79892578125003, lng: -10.341064453124943 },
        { lat: 51.86875, lng: -10.378710937499958 },
        { lat: 51.97451171875002, lng: -10.231591796874937 },
        { lat: 52.02001953125005, lng: -10.145849609374949 },
        { lat: 52.044580078124994, lng: -10.04404296874992 },
        { lat: 52.07983398437497, lng: -9.946044921875028 },
        { lat: 52.122949218749966, lng: -9.909667968749972 },
        { lat: 52.13666992187501, lng: -9.955810546874972 },
        { lat: 52.12573242187499, lng: -10.249511718749943 },
        { lat: 52.134912109374994, lng: -10.39023437499992 },
        { lat: 52.16909179687505, lng: -10.38261718749996 },
        { lat: 52.206933593750016, lng: -10.356689453125 },
        { lat: 52.27167968749998, lng: -10.210937499999972 },
        { lat: 52.28208007812506, lng: -10.132080078125 },
        { lat: 52.27592773437495, lng: -10.06176757812497 },
        { lat: 52.259326171875045, lng: -9.993115234374926 },
        { lat: 52.23764648437497, lng: -9.937304687499932 },
        { lat: 52.250097656250034, lng: -9.772119140624936 },
        { lat: 52.29145507812501, lng: -9.841064453124943 },
        { lat: 52.37548828125, lng: -9.853222656249926 },
        { lat: 52.403710937499966, lng: -9.906054687499958 },
        { lat: 52.44267578124999, lng: -9.838476562499949 },
        { lat: 52.46635742187502, lng: -9.761132812499994 },
        { lat: 52.54692382812502, lng: -9.632226562499937 },
        { lat: 52.559179687500034, lng: -9.586328125000023 },
        { lat: 52.57875976562502, lng: -9.33125 },
        { lat: 52.621142578125045, lng: -9.05615234375 },
        { lat: 52.679638671874955, lng: -8.783447265624943 },
        { lat: 52.712304687500044, lng: -8.923291015624926 },
        { lat: 52.755419921875045, lng: -8.990283203124989 },
        { lat: 52.66826171875004, lng: -9.097900390624972 },
        { lat: 52.634912109374994, lng: -9.175390624999949 },
        { lat: 52.617089843749994, lng: -9.394238281249955 },
        { lat: 52.626904296874955, lng: -9.463476562499949 },
        { lat: 52.653955078124966, lng: -9.56103515625 },
        { lat: 52.643652343750006, lng: -9.59135742187496 },
        { lat: 52.62275390625001, lng: -9.619531249999937 },
        { lat: 52.579980468749994, lng: -9.764355468749955 },
        { lat: 52.56972656250005, lng: -9.916601562499977 },
        { lat: 52.64819335937503, lng: -9.739599609374977 },
        { lat: 52.78115234375002, lng: -9.514990234374949 },
        { lat: 52.82319335937498, lng: -9.46489257812496 },
        { lat: 52.89624023437503, lng: -9.39365234374992 },
        { lat: 52.92875976562499, lng: -9.415722656249983 },
        { lat: 52.94726562500003, lng: -9.461962890624989 },
        { lat: 53.09755859375002, lng: -9.299218749999966 },
        { lat: 53.12485351562497, lng: -9.241894531249926 },
        { lat: 53.12924804687498, lng: -9.137597656249994 },
        { lat: 53.15307617187506, lng: -9.061132812499949 },
        { lat: 53.15317382812498, lng: -9.027441406249919 },
        { lat: 53.16206054687501, lng: -8.997167968749977 },
        { lat: 53.207080078125045, lng: -8.930126953124983 },
        { lat: 53.235742187500016, lng: -9.03354492187492 },
        { lat: 53.25048828125, lng: -9.140332031249926 },
        { lat: 53.23486328124999, lng: -9.470751953124989 },
        { lat: 53.23823242187498, lng: -9.51420898437496 },
        { lat: 53.252050781250034, lng: -9.555175781249972 },
        { lat: 53.27197265625003, lng: -9.581738281249955 },
        { lat: 53.323046875000045, lng: -9.601757812499955 },
        { lat: 53.33447265625006, lng: -9.6259765625 },
        { lat: 53.33447265625006, lng: -9.700585937499937 },
        { lat: 53.31884765624997, lng: -9.774072265624966 },
        { lat: 53.32036132812502, lng: -9.825390624999955 },
        { lat: 53.342724609374955, lng: -9.875781250000017 },
        { lat: 53.39497070312504, lng: -9.795410156249972 },
        { lat: 53.40727539062495, lng: -9.899023437499947 },
        { lat: 53.39702148437502, lng: -10.00390625 },
        { lat: 53.41284179687503, lng: -10.091259765624926 },
        { lat: 53.445605468750045, lng: -10.093994140624972 },
        { lat: 53.47832031249996, lng: -10.054394531249983 },
        { lat: 53.50932617187496, lng: -10.10625 },
        { lat: 53.54853515624995, lng: -10.116992187499932 },
        { lat: 53.56782226562498, lng: -10.061718749999955 },
        { lat: 53.56142578125002, lng: -10.001367187500021 },
        { lat: 53.590429687500055, lng: -9.878271484374977 },
        { lat: 53.60449218749999, lng: -9.720654296874926 },
        { lat: 53.63310546874996, lng: -9.855859374999937 },
        { lat: 53.657617187499994, lng: -9.909716796874989 },
        { lat: 53.69511718749999, lng: -9.912304687499983 },
        { lat: 53.72719726562502, lng: -9.901611328124943 },
        { lat: 53.781494140625, lng: -9.745068359374926 },
        { lat: 53.80541992187497, lng: -9.578222656249947 },
        { lat: 53.84116210937497, lng: -9.590527343749983 },
        { lat: 53.879833984374955, lng: -9.578857421875 },
        { lat: 53.89101562500002, lng: -9.747509765624983 },
        { lat: 53.863720703124955, lng: -9.9140625 },
        { lat: 53.937597656250006, lng: -9.896240234374998 },
        { lat: 54.00429687499999, lng: -9.856347656249966 },
        { lat: 54.04829101562498, lng: -9.848486328124949 },
        { lat: 54.095361328124994, lng: -9.85644531249997 },
        { lat: 54.07524414062499, lng: -9.934472656249966 },
        { lat: 54.1416015625, lng: -9.943603515624972 },
        { lat: 54.18710937500003, lng: -9.97709960937496 },
        { lat: 54.15576171875003, lng: -10.092675781249966 },
        { lat: 54.21582031250003, lng: -10.089697265624977 },
        { lat: 54.25781250000006, lng: -10.056396484374943 },
        { lat: 54.27602539062502, lng: -9.995947265624977 },
        { lat: 54.26811523437502, lng: -9.9359375 },
        { lat: 54.268896484375006, lng: -9.824560546874949 },
        { lat: 54.30043945312502, lng: -9.71713867187492 },
        { lat: 54.30854492187498, lng: -9.562304687499989 },
        { lat: 54.29863281250002, lng: -9.315527343750006 },
        { lat: 54.209619140624994, lng: -9.145898437499994 },
        { lat: 54.225537109374955, lng: -9.10209960937496 },
        { lat: 54.281787109375045, lng: -9.034277343749977 },
        { lat: 54.287988281249966, lng: -9.002441406249972 },
        { lat: 54.263476562500045, lng: -8.746777343749955 },
        { lat: 54.231103515625016, lng: -8.588037109374937 },
        { lat: 54.24121093750003, lng: -8.545556640624994 },
        { lat: 54.30361328125005, lng: -8.568457031249949 },
        { lat: 54.346875, lng: -8.623144531249977 },
        { lat: 54.40356445312497, lng: -8.554443359375027 },
        { lat: 54.44194335937498, lng: -8.470996093749989 },
        { lat: 54.461083984374966, lng: -8.415234374999983 },
        { lat: 54.48486328125003, lng: -8.286523437499966 },
        { lat: 54.50727539062498, lng: -8.230371093749994 },
        { lat: 54.58012695312499, lng: -8.1929687499999 },
        { lat: 54.640820312500004, lng: -8.133447265624966 },
        { lat: 54.609277343749966, lng: -8.456542968749972 },
        { lat: 54.68120117187496, lng: -8.763916015624972 },
        { lat: 54.732031250000034, lng: -8.715185546875006 },
        { lat: 54.76088867187505, lng: -8.650292968749994 },
        { lat: 54.782958984375, lng: -8.538281249999926 },
        { lat: 54.80947265624999, lng: -8.527685546874977 },
        { lat: 54.83154296875006, lng: -8.470996093749989 },
        { lat: 54.88945312500002, lng: -8.377294921874977 },
        { lat: 54.965087890624964, lng: -8.411718749999977 },
        { lat: 55.020410156249966, lng: -8.393261718749953 },
        { lat: 55.056445312500045, lng: -8.325781249999977 },
        { lat: 55.10820312500002, lng: -8.304687499999943 },
        { lat: 55.146289062500045, lng: -8.274609374999953 },
        { lat: 55.159912109374964, lng: -8.137695312499943 },
        { lat: 55.1953125, lng: -8.006103515624943 },
        { lat: 55.19189453125, lng: -7.958593749999949 },
        { lat: 55.20004882812498, lng: -7.80317382812501 },
        { lat: 55.18579101562499, lng: -7.750537109374932 },
        { lat: 55.24833984374996, lng: -7.762548828124976 },
        { lat: 55.25649414062502, lng: -7.667089843749977 },
        { lat: 55.24399414062506, lng: -7.629785156249937 },
        { lat: 55.19965820312498, lng: -7.613378906249977 },
        { lat: 55.17138671875, lng: -7.570019531249926 },
        { lat: 55.12221679687502, lng: -7.556640624999943 },
        { lat: 55.084228515625, lng: -7.585693359375001 },
        { lat: 55.05498046874998, lng: -7.634277343749972 },
        { lat: 55.02504882812502, lng: -7.589843749999972 },
        { lat: 54.97094726562503, lng: -7.65874023437496 },
        { lat: 54.993994140625006, lng: -7.584375 },
        { lat: 55.046972656250055, lng: -7.478417968749994 },
        { lat: 55.09028320312501, lng: -7.483935546874989 },
        { lat: 55.14472656249998, lng: -7.501953125 },
        { lat: 55.19384765625005, lng: -7.531445312499982 },
        { lat: 55.24794921874996, lng: -7.51787109374996 },
        { lat: 55.28178710937502, lng: -7.458300781249989 },
        { lat: 55.29877929687501, lng: -7.3017578125 },
        { lat: 55.360205078125, lng: -7.365966796875 },
        { lat: 55.365820312500006, lng: -7.308789062500011 },
        { lat: 55.35302734374997, lng: -7.246679687499949 },
        { lat: 55.30517578125, lng: -7.155322265624988 },
        { lat: 55.26762695312499, lng: -7.060253906249983 },
        { lat: 55.23789062500006, lng: -6.961669921874972 },
        { lat: 55.178320312500006, lng: -7.056396484375 },
        { lat: 55.13701171875002, lng: -7.172851562500028 },
        { lat: 55.091992187499976, lng: -7.218652343749937 },
        { lat: 55.027685546875034, lng: -7.376904296874926 },
        { lat: 55.00332031250005, lng: -7.40141601562496 },
      ],
    ],
  },
  {
    code: "LT",
    coordinates: [
      [
        { lat: 55.350488281249994, lng: 21.03173828125003 },
        { lat: 55.27890625000006, lng: 20.957812500000074 },
        { lat: 55.286669921875045, lng: 20.899804687500076 },
        { lat: 55.40195312499997, lng: 21.01406250000008 },
        { lat: 55.47680664062505, lng: 21.057617187500057 },
        { lat: 55.58310546875003, lng: 21.08789062500003 },
        { lat: 55.61650390624999, lng: 21.11484375 },
        { lat: 55.56816406250001, lng: 21.11572265625 },
        { lat: 55.48774414062498, lng: 21.10390625000008 },
        { lat: 55.350488281249994, lng: 21.03173828125003 },
      ],
      [
        { lat: 56.32558593750005, lng: 24.943847656249968 },
        { lat: 56.20039062500003, lng: 25.069921875 },
        { lat: 56.17841796874998, lng: 25.206933593750023 },
        { lat: 56.13017578125001, lng: 25.585742187500017 },
        { lat: 56.104833984375006, lng: 25.663183593750063 },
        { lat: 55.994335937499976, lng: 25.87636718750008 },
        { lat: 55.94013671875004, lng: 26.00419921874999 },
        { lat: 55.896875, lng: 26.085546875000063 },
        { lat: 55.81210937500006, lng: 26.209570312500006 },
        { lat: 55.75043945312501, lng: 26.28125 },
        { lat: 55.703808593750004, lng: 26.40107421875004 },
        { lat: 55.67241210937502, lng: 26.542871093750048 },
        { lat: 55.66752929687501, lng: 26.59355468750007 },
        { lat: 55.62265625, lng: 26.590820312500053 },
        { lat: 55.546484375000034, lng: 26.566601562500008 },
        { lat: 55.448144531249994, lng: 26.51923828125004 },
        { lat: 55.371923828125006, lng: 26.469531250000045 },
        { lat: 55.342480468749955, lng: 26.457617187500006 },
        { lat: 55.318017578125016, lng: 26.49531250000004 },
        { lat: 55.30644531249999, lng: 26.68125 },
        { lat: 55.29335937499999, lng: 26.76015625000008 },
        { lat: 55.27309570312502, lng: 26.775683593750045 },
        { lat: 55.24677734374998, lng: 26.734375 },
        { lat: 55.22490234374999, lng: 26.675 },
        { lat: 55.204199218750034, lng: 26.648437500000053 },
        { lat: 55.130175781250045, lng: 26.601171875000034 },
        { lat: 55.13959960937501, lng: 26.29179687500007 },
        { lat: 55.12451171875006, lng: 26.250781250000045 },
        { lat: 55.09013671874996, lng: 26.23125 },
        { lat: 55.050390625000034, lng: 26.21582031250003 },
        { lat: 55.003271484375034, lng: 26.175195312500023 },
        { lat: 54.96230468750005, lng: 26.092968750000068 },
        { lat: 54.947167968749966, lng: 25.964453124999977 },
        { lat: 54.91928710937497, lng: 25.85927734375005 },
        { lat: 54.83325195312502, lng: 25.780859375000063 },
        { lat: 54.71787109374998, lng: 25.722460937500074 },
        { lat: 54.63603515625002, lng: 25.723925781250017 },
        { lat: 54.59038085937502, lng: 25.731640625000068 },
        { lat: 54.564257812500045, lng: 25.72480468750001 },
        { lat: 54.53579101562502, lng: 25.68515625 },
        { lat: 54.460400390625004, lng: 25.62031250000004 },
        { lat: 54.377050781250006, lng: 25.56757812500004 },
        { lat: 54.33183593750001, lng: 25.54736328125 },
        { lat: 54.310693359374994, lng: 25.55751953125005 },
        { lat: 54.31010742187504, lng: 25.616894531250068 },
        { lat: 54.29296875, lng: 25.702539062499994 },
        { lat: 54.25966796874996, lng: 25.748144531250063 },
        { lat: 54.22119140625006, lng: 25.76503906250005 },
        { lat: 54.179785156250034, lng: 25.765234374999977 },
        { lat: 54.15698242187503, lng: 25.74921875000001 },
        { lat: 54.140478515625034, lng: 25.68056640625005 },
        { lat: 54.139892578125, lng: 25.573046875000014 },
        { lat: 54.15961914062501, lng: 25.510351562500034 },
        { lat: 54.17524414062501, lng: 25.497363281250045 },
        { lat: 54.21513671874996, lng: 25.52734375000003 },
        { lat: 54.26494140624999, lng: 25.505664062500045 },
        { lat: 54.29277343749996, lng: 25.461132812500036 },
        { lat: 54.25122070312502, lng: 25.370605468750057 },
        { lat: 54.25126953125004, lng: 25.28369140625003 },
        { lat: 54.214257812499966, lng: 25.179492187500014 },
        { lat: 54.15493164062505, lng: 25.111425781250002 },
        { lat: 54.13305664062503, lng: 25.04609375000004 },
        { lat: 54.14516601562502, lng: 24.869531250000023 },
        { lat: 54.118994140625006, lng: 24.82568359374997 },
        { lat: 53.99824218750001, lng: 24.78925781250001 },
        { lat: 53.97465820312499, lng: 24.768164062499977 },
        { lat: 53.97983398437498, lng: 24.620703125000063 },
        { lat: 53.93183593749998, lng: 24.47851562500003 },
        { lat: 53.892968749999966, lng: 24.31796875 },
        { lat: 53.91997070312495, lng: 24.236621093750042 },
        { lat: 53.95043945312503, lng: 24.19130859375005 },
        { lat: 53.94501953125001, lng: 24.103906250000023 },
        { lat: 53.93164062500002, lng: 24.00849609375004 },
        { lat: 53.93896484375, lng: 23.944433593750034 },
        { lat: 53.935693359374966, lng: 23.872558593750057 },
        { lat: 53.912255859374994, lng: 23.73369140624999 },
        { lat: 53.91982421875002, lng: 23.559082031250057 },
        { lat: 53.939794921875006, lng: 23.484667968750074 },
        { lat: 53.95893554687498, lng: 23.477636718750063 },
        { lat: 54.00595703124998, lng: 23.483007812500006 },
        { lat: 54.07900390625002, lng: 23.481347656250023 },
        { lat: 54.14345703125002, lng: 23.453613281250053 },
        { lat: 54.20048828124999, lng: 23.370117187499996 },
        { lat: 54.24033203125003, lng: 23.282324218750063 },
        { lat: 54.28144531249998, lng: 23.17031250000008 },
        { lat: 54.299462890624994, lng: 23.0875 },
        { lat: 54.30419921875, lng: 23.042187500000068 },
        { lat: 54.32788085937503, lng: 23.031933593750036 },
        { lat: 54.348339843750004, lng: 23.01552734375005 },
        { lat: 54.36635742187505, lng: 22.976757812500068 },
        { lat: 54.39052734374999, lng: 22.89394531250008 },
        { lat: 54.39580078124998, lng: 22.82373046874997 },
        { lat: 54.356787109375034, lng: 22.766210937499977 },
        { lat: 54.405615234375034, lng: 22.724316406250068 },
        { lat: 54.493017578125006, lng: 22.679882812500068 },
        { lat: 54.56293945312504, lng: 22.684472656250023 },
        { lat: 54.63261718750002, lng: 22.70966796875001 },
        { lat: 54.838476562500034, lng: 22.83125 },
        { lat: 54.87128906249998, lng: 22.824707031249996 },
        { lat: 54.928857421874966, lng: 22.736523437500068 },
        { lat: 54.970703124999964, lng: 22.627441406250057 },
        { lat: 55.05913085937496, lng: 22.56728515625005 },
        { lat: 55.06425781250002, lng: 22.346386718750068 },
        { lat: 55.059375, lng: 22.137890625000068 },
        { lat: 55.06367187499998, lng: 22.072363281250034 },
        { lat: 55.100732421874994, lng: 21.873925781250023 },
        { lat: 55.160351562499976, lng: 21.682714843750063 },
        { lat: 55.1953125, lng: 21.5546875 },
        { lat: 55.23442382812496, lng: 21.447070312500017 },
        { lat: 55.275537109374994, lng: 21.389257812500034 },
        { lat: 55.264453125000045, lng: 21.297558593750008 },
        { lat: 55.26411132812498, lng: 21.235742187500023 },
        { lat: 55.27119140624998, lng: 21.236328125000057 },
        { lat: 55.343798828125045, lng: 21.201074218750076 },
        { lat: 55.45502929687495, lng: 21.237890625000034 },
        { lat: 55.61772460937499, lng: 21.17109375000001 },
        { lat: 55.81342773437498, lng: 21.061914062500048 },
        { lat: 56.02294921875003, lng: 21.053808593750006 },
        { lat: 56.07006835937503, lng: 21.04609375000004 },
        { lat: 56.18813476562502, lng: 21.314648437500036 },
        { lat: 56.314550781250006, lng: 21.65351562500004 },
        { lat: 56.325976562500045, lng: 21.730566406250034 },
        { lat: 56.40078125, lng: 22.04287109375005 },
        { lat: 56.40673828125006, lng: 22.084570312500034 },
        { lat: 56.39287109374999, lng: 22.365917968750068 },
        { lat: 56.375097656250006, lng: 22.586914062500057 },
        { lat: 56.377294921875006, lng: 22.77324218749999 },
        { lat: 56.39643554687501, lng: 22.875585937500063 },
        { lat: 56.38041992187502, lng: 22.968261718750025 },
        { lat: 56.324072265625006, lng: 23.042968750000053 },
        { lat: 56.330664062500006, lng: 23.119824218749983 },
        { lat: 56.36713867187498, lng: 23.195898437500034 },
        { lat: 56.333837890625034, lng: 23.61269531250005 },
        { lat: 56.33461914062502, lng: 23.70673828125001 },
        { lat: 56.329248046874994, lng: 23.81269531250001 },
        { lat: 56.295263671875006, lng: 24.00820312500005 },
        { lat: 56.26425781249998, lng: 24.120703125000063 },
        { lat: 56.28300781249999, lng: 24.367871093750068 },
        { lat: 56.28408203125002, lng: 24.473632812500025 },
        { lat: 56.29628906250002, lng: 24.52900390625001 },
        { lat: 56.381298828125004, lng: 24.699511718750045 },
        { lat: 56.39589843749996, lng: 24.773242187500045 },
        { lat: 56.41118164062498, lng: 24.841015624999983 },
        { lat: 56.39819335937499, lng: 24.903027343750008 },
        { lat: 56.32558593750005, lng: 24.943847656249968 },
      ],
    ],
  },
  {
    code: "LU",
    coordinates: [
      [
        { lat: 50.120996093749994, lng: 6.116503906250017 },
        { lat: 50.09423828125, lng: 6.108300781250023 },
        { lat: 50.034375, lng: 6.109765625000023 },
        { lat: 49.97431640624999, lng: 6.138183593749999 },
        { lat: 49.91513671874999, lng: 6.204882812500017 },
        { lat: 49.87216796874999, lng: 6.256054687500011 },
        { lat: 49.837890625, lng: 6.324609375000023 },
        { lat: 49.805322265624994, lng: 6.44091796875 },
        { lat: 49.79848632812499, lng: 6.4873046875 },
        { lat: 49.75439453125, lng: 6.49375 },
        { lat: 49.7078125, lng: 6.484765625000023 },
        { lat: 49.68203125, lng: 6.444628906250017 },
        { lat: 49.644970703125, lng: 6.40673828125 },
        { lat: 49.599609375, lng: 6.378320312500023 },
        { lat: 49.5126953125, lng: 6.348437500000017 },
        { lat: 49.452734375, lng: 6.344335937500005 },
        { lat: 49.47753906249999, lng: 6.27734375 },
        { lat: 49.4943359375, lng: 6.2421875 },
        { lat: 49.498925781249994, lng: 6.181054687500023 },
        { lat: 49.485205078125, lng: 6.119921875000016 },
        { lat: 49.45463867187499, lng: 6.074121093750023 },
        { lat: 49.44545898437499, lng: 6.011425781250011 },
        { lat: 49.45463867187499, lng: 5.95947265625 },
        { lat: 49.47753906249999, lng: 5.928906250000011 },
        { lat: 49.48974609375, lng: 5.9013671875 },
        { lat: 49.505078125, lng: 5.82343750000001 },
        { lat: 49.53828125, lng: 5.78974609375001 },
        { lat: 49.55380859375, lng: 5.8154296875 },
        { lat: 49.57832031249999, lng: 5.837597656250011 },
        { lat: 49.61284179687499, lng: 5.856542968750006 },
        { lat: 49.644775390625, lng: 5.88037109375 },
        { lat: 49.732177734375, lng: 5.8037109375 },
        { lat: 49.75888671875, lng: 5.787988281250023 },
        { lat: 49.80830078125, lng: 5.725 },
        { lat: 49.833349609375, lng: 5.725781250000011 },
        { lat: 49.857177734375, lng: 5.740820312500006 },
        { lat: 49.875634765624994, lng: 5.735253906250023 },
        { lat: 49.91962890625, lng: 5.744042968750023 },
        { lat: 49.961230468749996, lng: 5.7880859375 },
        { lat: 50.0126953125, lng: 5.817382812499999 },
        { lat: 50.0828125, lng: 5.866894531250011 },
        { lat: 50.1671875, lng: 5.976269531250011 },
        { lat: 50.154296875, lng: 6.054785156250006 },
        { lat: 50.154589843749996, lng: 6.089062500000011 },
        { lat: 50.12377929687499, lng: 6.110058593750011 },
        { lat: 50.120996093749994, lng: 6.116503906250017 },
      ],
    ],
  },
  {
    code: "LV",
    coordinates: [
      [
        { lat: 57.528125, lng: 27.351953125000023 },
        { lat: 57.524023437500006, lng: 27.4697265625 },
        { lat: 57.508154296875, lng: 27.511132812500023 },
        { lat: 57.42978515624999, lng: 27.538671875 },
        { lat: 57.36811523437499, lng: 27.672753906250023 },
        { lat: 57.31694335937499, lng: 27.796875 },
        { lat: 57.293310546875, lng: 27.828613281249996 },
        { lat: 57.247705078124994, lng: 27.838281250000023 },
        { lat: 57.194482421874994, lng: 27.830273437500008 },
        { lat: 57.16689453125, lng: 27.814550781250002 },
        { lat: 57.135107421875, lng: 27.762792968750006 },
        { lat: 57.054638671875, lng: 27.717382812500006 },
        { lat: 56.97807617187499, lng: 27.71113281250001 },
        { lat: 56.84565429687499, lng: 27.639453125000017 },
        { lat: 56.843212890625, lng: 27.655664062500023 },
        { lat: 56.86708984375, lng: 27.806054687500023 },
        { lat: 56.853417968749994, lng: 27.8486328125 },
        { lat: 56.82416992187499, lng: 27.88154296875001 },
        { lat: 56.741064453125, lng: 27.89208984375 },
        { lat: 56.7037109375, lng: 27.94140625 },
        { lat: 56.6453125, lng: 27.991601562500023 },
        { lat: 56.599853515625, lng: 28.00751953125001 },
        { lat: 56.545703125, lng: 28.103125 },
        { lat: 56.510693359375, lng: 28.110839843749996 },
        { lat: 56.386865234375, lng: 28.169238281250014 },
        { lat: 56.315576171875, lng: 28.191699218750017 },
        { lat: 56.260400390624994, lng: 28.20205078125002 },
        { lat: 56.190332031249994, lng: 28.17333984375 },
        { lat: 56.142919921875, lng: 28.14794921875 },
        { lat: 56.145800781249996, lng: 28.11787109375001 },
        { lat: 56.13330078125, lng: 28.032031250000017 },
        { lat: 56.07617187499999, lng: 27.896289062500017 },
        { lat: 55.941552734374994, lng: 27.694238281250023 },
        { lat: 55.91171875, lng: 27.642285156250008 },
        { lat: 55.8091796875, lng: 27.589453125 },
        { lat: 55.798779296875, lng: 27.576757812500006 },
        { lat: 55.803515625, lng: 27.45917968750001 },
        { lat: 55.805957031249996, lng: 27.427148437500023 },
        { lat: 55.80390625, lng: 27.309179687500006 },
        { lat: 55.83056640624999, lng: 27.052539062500017 },
        { lat: 55.81293945312499, lng: 26.953027343750023 },
        { lat: 55.709228515625, lng: 26.82246093750001 },
        { lat: 55.693994140625, lng: 26.771875 },
        { lat: 55.679638671875, lng: 26.620214843750006 },
        { lat: 55.667529296874996, lng: 26.593554687500017 },
        { lat: 55.672412109374996, lng: 26.54287109375002 },
        { lat: 55.70380859375, lng: 26.40107421875001 },
        { lat: 55.750439453125, lng: 26.28125 },
        { lat: 55.812109375, lng: 26.209570312500006 },
        { lat: 55.896875, lng: 26.085546875 },
        { lat: 55.94013671874999, lng: 26.004199218750017 },
        { lat: 55.9943359375, lng: 25.876367187500023 },
        { lat: 56.104833984375, lng: 25.663183593750002 },
        { lat: 56.130175781249996, lng: 25.585742187500017 },
        { lat: 56.17841796875, lng: 25.206933593750023 },
        { lat: 56.200390625, lng: 25.069921875 },
        { lat: 56.325585937499994, lng: 24.943847656249996 },
        { lat: 56.39819335937499, lng: 24.903027343750008 },
        { lat: 56.41118164062499, lng: 24.841015625 },
        { lat: 56.3958984375, lng: 24.773242187500014 },
        { lat: 56.381298828125, lng: 24.699511718750017 },
        { lat: 56.2962890625, lng: 24.52900390625001 },
        { lat: 56.28408203125, lng: 24.473632812499996 },
        { lat: 56.283007812499996, lng: 24.36787109375001 },
        { lat: 56.26425781249999, lng: 24.120703125 },
        { lat: 56.29526367187499, lng: 24.008203125000023 },
        { lat: 56.329248046875, lng: 23.81269531250001 },
        { lat: 56.334619140625, lng: 23.70673828125001 },
        { lat: 56.333837890625, lng: 23.612695312500023 },
        { lat: 56.36713867187499, lng: 23.195898437500006 },
        { lat: 56.3306640625, lng: 23.11982421875001 },
        { lat: 56.324072265625, lng: 23.04296875 },
        { lat: 56.380419921874996, lng: 22.96826171875 },
        { lat: 56.39643554687499, lng: 22.875585937500006 },
        { lat: 56.377294921875, lng: 22.773242187500017 },
        { lat: 56.37509765625, lng: 22.5869140625 },
        { lat: 56.39287109374999, lng: 22.36591796875001 },
        { lat: 56.40673828125, lng: 22.084570312500006 },
        { lat: 56.40078125, lng: 22.042871093750023 },
        { lat: 56.325976562499996, lng: 21.730566406250006 },
        { lat: 56.31455078125, lng: 21.65351562500001 },
        { lat: 56.188134765625, lng: 21.314648437500008 },
        { lat: 56.070068359375, lng: 21.04609375000001 },
        { lat: 56.258935546875, lng: 21.014941406250017 },
        { lat: 56.636572265625, lng: 21.03144531250001 },
        { lat: 56.82373046875, lng: 21.071289062499996 },
        { lat: 56.932763671875, lng: 21.257421875 },
        { lat: 57.01767578125, lng: 21.35078125000001 },
        { lat: 57.131005859375, lng: 21.405078125000017 },
        { lat: 57.23583984375, lng: 21.421484375 },
        { lat: 57.3224609375, lng: 21.45917968750001 },
        { lat: 57.57099609374999, lng: 21.72871093750001 },
        { lat: 57.59785156249999, lng: 21.9423828125 },
        { lat: 57.666796875, lng: 22.2314453125 },
        { lat: 57.724267578124994, lng: 22.55458984375002 },
        { lat: 57.651171875, lng: 22.616992187500017 },
        { lat: 57.595361328124994, lng: 22.64863281250001 },
        { lat: 57.39208984374999, lng: 23.03779296875001 },
        { lat: 57.323828125, lng: 23.136816406250006 },
        { lat: 57.08974609375, lng: 23.28730468750001 },
        { lat: 56.97104492187499, lng: 23.647753906250017 },
        { lat: 57.00849609375, lng: 23.93115234375 },
        { lat: 57.06611328125, lng: 24.054296875 },
        { lat: 57.172314453125, lng: 24.28125 },
        { lat: 57.250048828124996, lng: 24.382617187500017 },
        { lat: 57.325, lng: 24.403222656250023 },
        { lat: 57.64531249999999, lng: 24.36298828125001 },
        { lat: 57.784130859375, lng: 24.301562500000017 },
        { lat: 57.87060546874999, lng: 24.322558593750017 },
        { lat: 57.86616210937499, lng: 24.3625 },
        { lat: 57.907861328125, lng: 24.458886718750023 },
        { lat: 57.98525390625, lng: 24.775781250000023 },
        { lat: 57.988720703125004, lng: 24.83906250000001 },
        { lat: 58.00458984375, lng: 24.911328125 },
        { lat: 58.063427734375004, lng: 25.11103515625001 },
        { lat: 58.032128906249994, lng: 25.175195312500023 },
        { lat: 57.99658203124999, lng: 25.22871093750001 },
        { lat: 57.996142578125, lng: 25.258300781249996 },
        { lat: 58.009375, lng: 25.27265625000001 },
        { lat: 58.0322265625, lng: 25.268652343750006 },
        { lat: 58.048486328124994, lng: 25.282617187500023 },
        { lat: 58.039453125, lng: 25.34003906250001 },
        { lat: 57.942773437499994, lng: 25.5712890625 },
        { lat: 57.920166015625, lng: 25.66015625 },
        { lat: 57.913818359375, lng: 25.72089843750001 },
        { lat: 57.8685546875, lng: 25.79375 },
        { lat: 57.838183593749996, lng: 25.99111328125002 },
        { lat: 57.814746093749996, lng: 26.015234375 },
        { lat: 57.78554687499999, lng: 26.030371093750006 },
        { lat: 57.662744140625, lng: 26.21503906250001 },
        { lat: 57.60107421875, lng: 26.29804687500001 },
        { lat: 57.54448242187499, lng: 26.46210937500001 },
        { lat: 57.531005859375, lng: 26.532617187500023 },
        { lat: 57.588720703125, lng: 26.819726562500023 },
        { lat: 57.608789062499994, lng: 26.89980468750002 },
        { lat: 57.60913085937499, lng: 26.96601562500001 },
        { lat: 57.578759765625, lng: 27.03339843750001 },
        { lat: 57.538330078125, lng: 27.187109375 },
        { lat: 57.52548828124999, lng: 27.326562500000023 },
        { lat: 57.528125, lng: 27.351953125000023 },
      ],
    ],
  },
  {
    code: "LI",
    coordinates: [
      [
        { lat: 47.05737304687499, lng: 9.580273437500011 },
        { lat: 47.062744140625, lng: 9.502343750000023 },
        { lat: 47.06225585937499, lng: 9.487695312500023 },
        { lat: 47.09750976562499, lng: 9.4794921875 },
        { lat: 47.17265625, lng: 9.484277343750023 },
        { lat: 47.270751953125, lng: 9.527539062500011 },
        { lat: 47.25463867187499, lng: 9.536816406250011 },
        { lat: 47.234130859375, lng: 9.542187500000011 },
        { lat: 47.212255859375, lng: 9.551074218750017 },
        { lat: 47.185498046875, lng: 9.555761718750006 },
        { lat: 47.15791015625, lng: 9.571875 },
        { lat: 47.132080078125, lng: 9.601171875 },
        { lat: 47.10712890625, lng: 9.610546875000011 },
        { lat: 47.075830078124994, lng: 9.595703125 },
        { lat: 47.05737304687499, lng: 9.580273437500011 },
      ],
    ],
  },
  {
    code: "MC",
    coordinates: [
      [
        { lat: 43.750439453125, lng: 7.43867187500001 },
        { lat: 43.731738281249996, lng: 7.377734375000018 },
        { lat: 43.753222656249996, lng: 7.380078125000012 },
        { lat: 43.76533203125, lng: 7.395019531249999 },
        { lat: 43.770898437499994, lng: 7.414453125000023 },
        { lat: 43.761474609375, lng: 7.436914062500023 },
        { lat: 43.750439453125, lng: 7.43867187500001 },
      ],
    ],
  },
  {
    code: "MD",
    coordinates: [
      [
        { lat: 45.450439453125, lng: 28.2125 },
        { lat: 45.51376953124999, lng: 28.1625 },
        { lat: 45.569140625, lng: 28.111914062500002 },
        { lat: 45.598974609375, lng: 28.074707031249996 },
        { lat: 45.61274414062499, lng: 28.09033203125 },
        { lat: 45.62827148437499, lng: 28.130859375 },
        { lat: 45.647119140624994, lng: 28.159765625 },
        { lat: 45.7130859375, lng: 28.15625 },
        { lat: 45.788867187499996, lng: 28.13496093750001 },
        { lat: 45.825537109375, lng: 28.115527343750014 },
        { lat: 45.883056640625, lng: 28.113574218750014 },
        { lat: 45.972607421875, lng: 28.099707031250006 },
        { lat: 46.138671875, lng: 28.119140625 },
        { lat: 46.347558593749994, lng: 28.199609375000023 },
        { lat: 46.45126953125, lng: 28.24433593750001 },
        { lat: 46.50805664062499, lng: 28.22265625 },
        { lat: 46.6408203125, lng: 28.23945312500001 },
        { lat: 46.70639648437499, lng: 28.2046875 },
        { lat: 46.79208984375, lng: 28.15 },
        { lat: 46.97841796874999, lng: 28.07177734375 },
        { lat: 47.043212890625, lng: 27.97421875 },
        { lat: 47.114501953125, lng: 27.853808593750017 },
        { lat: 47.16831054687499, lng: 27.80234375 },
        { lat: 47.227587890624996, lng: 27.76796875000002 },
        { lat: 47.286425781249996, lng: 27.696191406250023 },
        { lat: 47.34052734375, lng: 27.614062500000017 },
        { lat: 47.475634765624996, lng: 27.51582031250001 },
        { lat: 47.536669921874996, lng: 27.46484375 },
        { lat: 47.553125, lng: 27.44921875 },
        { lat: 47.63974609374999, lng: 27.336914062499996 },
        { lat: 47.71796875, lng: 27.277929687500002 },
        { lat: 47.7822265625, lng: 27.248144531250006 },
        { lat: 47.841748046875, lng: 27.230859375000023 },
        { lat: 47.959277343749996, lng: 27.15205078125001 },
        { lat: 48.04765625, lng: 27.080371093750017 },
        { lat: 48.110498046874994, lng: 27.01220703125 },
        { lat: 48.155029296875, lng: 26.980761718750017 },
        { lat: 48.2111328125, lng: 26.900976562500006 },
        { lat: 48.255810546875, lng: 26.78730468750001 },
        { lat: 48.263476562499996, lng: 26.71376953125002 },
        { lat: 48.25986328124999, lng: 26.618945312500014 },
        { lat: 48.294140625, lng: 26.640429687500014 },
        { lat: 48.387158203125, lng: 26.847070312500023 },
        { lat: 48.37192382812499, lng: 26.90058593750001 },
        { lat: 48.36826171875, lng: 27.00849609375001 },
        { lat: 48.371435546875, lng: 27.228515625 },
        { lat: 48.43271484375, lng: 27.336914062499996 },
        { lat: 48.415625, lng: 27.40380859375 },
        { lat: 48.44306640624999, lng: 27.458398437500023 },
        { lat: 48.477734375, lng: 27.549218750000023 },
        { lat: 48.47041015625, lng: 27.56220703125001 },
        { lat: 48.46489257812499, lng: 27.57373046875 },
        { lat: 48.449511718749996, lng: 27.714453125 },
        { lat: 48.416259765625, lng: 27.82001953125001 },
        { lat: 48.36523437499999, lng: 27.890625 },
        { lat: 48.333544921874996, lng: 27.963378906249996 },
        { lat: 48.3212890625, lng: 28.038476562500023 },
        { lat: 48.29580078124999, lng: 28.080078125 },
        { lat: 48.25703125, lng: 28.088476562500002 },
        { lat: 48.23798828124999, lng: 28.158789062500002 },
        { lat: 48.238574218749996, lng: 28.291015625 },
        { lat: 48.213037109374994, lng: 28.34716796875 },
        { lat: 48.161425781249996, lng: 28.326953125000017 },
        { lat: 48.144433593749994, lng: 28.34052734375001 },
        { lat: 48.162109375, lng: 28.3875 },
        { lat: 48.146875, lng: 28.42304687500001 },
        { lat: 48.10869140624999, lng: 28.441992187500006 },
        { lat: 48.09052734375, lng: 28.46308593750001 },
        { lat: 48.15029296874999, lng: 28.53046875000001 },
        { lat: 48.144384765625, lng: 28.601660156250002 },
        { lat: 48.119580078125, lng: 28.773828125000023 },
        { lat: 47.995654296874996, lng: 28.865820312500002 },
        { lat: 47.951123046875, lng: 28.923144531250017 },
        { lat: 47.933007812499994, lng: 28.973339843750008 },
        { lat: 47.95234375, lng: 29.036914062500017 },
        { lat: 47.975439453125, lng: 29.09296875000001 },
        { lat: 47.96455078125, lng: 29.125390625000023 },
        { lat: 47.882421875, lng: 29.19482421875 },
        { lat: 47.775, lng: 29.211132812500015 },
        { lat: 47.73154296875, lng: 29.210742187500017 },
        { lat: 47.65859375, lng: 29.186035156250004 },
        { lat: 47.580859375, lng: 29.150878906249996 },
        { lat: 47.53037109375, lng: 29.122949218750023 },
        { lat: 47.489697265625, lng: 29.134863281250006 },
        { lat: 47.4556640625, lng: 29.159765625 },
        { lat: 47.444482421874994, lng: 29.200585937500023 },
        { lat: 47.375732421875, lng: 29.333789062500014 },
        { lat: 47.328027343749994, lng: 29.383398437500002 },
        { lat: 47.292626953124994, lng: 29.455664062500002 },
        { lat: 47.29072265625, lng: 29.510644531250023 },
        { lat: 47.27099609375, lng: 29.539160156250002 },
        { lat: 47.246826171875, lng: 29.549316406249996 },
        { lat: 47.185546875, lng: 29.541796875000017 },
        { lat: 47.12802734375, lng: 29.51093750000001 },
        { lat: 47.091113281249996, lng: 29.51503906250002 },
        { lat: 47.047509765624994, lng: 29.563476562499996 },
        { lat: 46.99672851562499, lng: 29.568652343750017 },
        { lat: 46.964013671874994, lng: 29.571972656250008 },
        { lat: 46.938818359375, lng: 29.597753906250006 },
        { lat: 46.88291015624999, lng: 29.7197265625 },
        { lat: 46.82890625, lng: 29.87783203125002 },
        { lat: 46.782421875, lng: 29.918066406250006 },
        { lat: 46.723779296874994, lng: 29.942480468750006 },
        { lat: 46.625, lng: 29.93476562500001 },
        { lat: 46.538867187499996, lng: 29.924316406249996 },
        { lat: 46.423095703125, lng: 30.13105468750001 },
        { lat: 46.4015625, lng: 30.107519531250002 },
        { lat: 46.377832031249994, lng: 30.075683593750004 },
        { lat: 46.360205078125, lng: 29.878027343750006 },
        { lat: 46.35053710937499, lng: 29.837890625 },
        { lat: 46.437792968749996, lng: 29.751953125 },
        { lat: 46.44873046875, lng: 29.706835937500017 },
        { lat: 46.416748046875, lng: 29.664550781249996 },
        { lat: 46.39882812499999, lng: 29.614941406250008 },
        { lat: 46.407763671874996, lng: 29.555078125000026 },
        { lat: 46.43466796875, lng: 29.491015625000014 },
        { lat: 46.45375976562499, lng: 29.458789062500017 },
        { lat: 46.455957031249994, lng: 29.4328125 },
        { lat: 46.436914062499994, lng: 29.392871093750017 },
        { lat: 46.445068359375, lng: 29.33955078125001 },
        { lat: 46.466601562499996, lng: 29.304882812500008 },
        { lat: 46.392626953124996, lng: 29.254589843750008 },
        { lat: 46.376953125, lng: 29.223828125 },
        { lat: 46.379345703125, lng: 29.20458984375 },
        { lat: 46.50498046875, lng: 29.20078125 },
        { lat: 46.523974609374996, lng: 29.186230468750008 },
        { lat: 46.526904296874996, lng: 29.146289062500017 },
        { lat: 46.497021484375, lng: 29.049902343750006 },
        { lat: 46.45849609375, lng: 28.958398437500023 },
        { lat: 46.424121093749996, lng: 28.92744140625001 },
        { lat: 46.362255859375, lng: 28.930566406250023 },
        { lat: 46.288427734375, lng: 28.94375 },
        { lat: 46.17646484374999, lng: 29.00625 },
        { lat: 46.12763671875, lng: 28.971875 },
        { lat: 46.049951171874994, lng: 28.94775390625 },
        { lat: 45.978662109374994, lng: 28.849511718750023 },
        { lat: 45.937158203124994, lng: 28.73876953125 },
        { lat: 45.85200195312499, lng: 28.729296875000014 },
        { lat: 45.79384765624999, lng: 28.667578125 },
        { lat: 45.735791015625, lng: 28.562304687500017 },
        { lat: 45.665771484375, lng: 28.491601562500023 },
        { lat: 45.617822265624994, lng: 28.50947265625001 },
        { lat: 45.572412109374994, lng: 28.513769531250002 },
        { lat: 45.54155273437499, lng: 28.501757812500017 },
        { lat: 45.517724609374994, lng: 28.4990234375 },
        { lat: 45.507177734375, lng: 28.47138671875001 },
        { lat: 45.49858398437499, lng: 28.310351562500014 },
        { lat: 45.48388671875, lng: 28.26484375000001 },
        { lat: 45.450439453125, lng: 28.2125 },
      ],
    ],
  },
  {
    code: "MK",
    coordinates: [
      [
        { lat: 42.31396484375, lng: 22.344042968750014 },
        { lat: 42.165087890624996, lng: 22.49824218750001 },
        { lat: 42.104833984375, lng: 22.582714843750008 },
        { lat: 42.059130859374996, lng: 22.68232421875001 },
        { lat: 42.025683593749996, lng: 22.79609375000001 },
        { lat: 41.993603515625, lng: 22.83681640625002 },
        { lat: 41.835205078125, lng: 22.9091796875 },
        { lat: 41.77509765624999, lng: 22.943945312500006 },
        { lat: 41.757177734375, lng: 22.991992187500014 },
        { lat: 41.73984375, lng: 23.00361328125001 },
        { lat: 41.71694335937499, lng: 23.005664062500017 },
        { lat: 41.60561523437499, lng: 22.951464843750014 },
        { lat: 41.356103515624994, lng: 22.9296875 },
        { lat: 41.336279296875, lng: 22.916015625 },
        { lat: 41.337353515625, lng: 22.859277343750023 },
        { lat: 41.331982421875, lng: 22.783886718750008 },
        { lat: 41.312744140625, lng: 22.75507812500001 },
        { lat: 41.178515625, lng: 22.72480468750001 },
        { lat: 41.14018554687499, lng: 22.603613281250006 },
        { lat: 41.118505859375, lng: 22.493554687500023 },
        { lat: 41.123388671875, lng: 22.400781250000023 },
        { lat: 41.155175781249994, lng: 22.237695312500023 },
        { lat: 41.158642578125, lng: 22.18447265625002 },
        { lat: 41.14052734374999, lng: 22.13886718750001 },
        { lat: 41.13095703125, lng: 21.99335937500001 },
        { lat: 41.10742187499999, lng: 21.929492187500017 },
        { lat: 40.950439453125, lng: 21.77949218750001 },
        { lat: 40.896337890625, lng: 21.627539062500006 },
        { lat: 40.868945312499996, lng: 21.57578125 },
        { lat: 40.903613281249996, lng: 21.45966796875001 },
        { lat: 40.907177734375, lng: 21.404101562500017 },
        { lat: 40.867138671875, lng: 21.32373046875 },
        { lat: 40.863134765625, lng: 21.147558593750006 },
        { lat: 40.85615234375, lng: 21.1 },
        { lat: 40.849902343749996, lng: 20.964257812500023 },
        { lat: 40.871533203125, lng: 20.95859375 },
        { lat: 40.903125, lng: 20.93349609375002 },
        { lat: 40.917919921875, lng: 20.870214843750006 },
        { lat: 40.9052734375, lng: 20.740820312500006 },
        { lat: 40.928369140624994, lng: 20.709277343750017 },
        { lat: 41.061669921874994, lng: 20.656054687500017 },
        { lat: 41.083056640624996, lng: 20.61445312500001 },
        { lat: 41.12783203124999, lng: 20.56787109375 },
        { lat: 41.272607421874994, lng: 20.48896484375001 },
        { lat: 41.336083984374994, lng: 20.487011718750008 },
        { lat: 41.39140624999999, lng: 20.49238281250001 },
        { lat: 41.521289062499996, lng: 20.448632812500023 },
        { lat: 41.554101562499994, lng: 20.4755859375 },
        { lat: 41.574755859374996, lng: 20.516210937500002 },
        { lat: 41.62705078125, lng: 20.5166015625 },
        { lat: 41.706494140625, lng: 20.505175781250014 },
        { lat: 41.862353515624996, lng: 20.553125 },
        { lat: 41.873681640624994, lng: 20.566210937500017 },
        { lat: 41.8662109375, lng: 20.57851562500002 },
        { lat: 41.853808593749996, lng: 20.694921875 },
        { lat: 41.87353515625, lng: 20.725 },
        { lat: 41.904296875, lng: 20.744140625 },
        { lat: 42.018359375, lng: 20.750390625000023 },
        { lat: 42.07104492187499, lng: 20.778125 },
        { lat: 42.171289062499994, lng: 21.05976562500001 },
        { lat: 42.175, lng: 21.142480468750023 },
        { lat: 42.128955078124996, lng: 21.206054687499996 },
        { lat: 42.099511718749994, lng: 21.25634765625 },
        { lat: 42.100390625, lng: 21.28662109375 },
        { lat: 42.130078125, lng: 21.297558593750008 },
        { lat: 42.187158203124994, lng: 21.331738281250008 },
        { lat: 42.21982421875, lng: 21.389550781250023 },
        { lat: 42.24765625, lng: 21.560839843750017 },
        { lat: 42.247509765625, lng: 21.5625 },
        { lat: 42.242138671875, lng: 21.618261718750006 },
        { lat: 42.267724609374994, lng: 21.7392578125 },
        { lat: 42.303125, lng: 21.81464843750001 },
        { lat: 42.308398437499996, lng: 21.85302734375 },
        { lat: 42.322070312499996, lng: 21.904101562500017 },
        { lat: 42.320068359375, lng: 21.9775390625 },
        { lat: 42.30463867187499, lng: 22.052050781250017 },
        { lat: 42.325, lng: 22.14667968750001 },
        { lat: 42.358154296875, lng: 22.23974609375 },
        { lat: 42.349853515625, lng: 22.277050781250008 },
        { lat: 42.321728515625, lng: 22.3173828125 },
        { lat: 42.31396484375, lng: 22.344042968750014 },
      ],
    ],
  },
  {
    code: "MT",
    coordinates: [
      [
        { lat: 35.85273437499998, lng: 14.566210937499987 },
        { lat: 35.82021484374999, lng: 14.532714843750028 },
        { lat: 35.82167968750005, lng: 14.436425781250021 },
        { lat: 35.872265624999955, lng: 14.352343750000044 },
        { lat: 35.97841796874999, lng: 14.35126953125001 },
        { lat: 35.95742187499999, lng: 14.448339843750063 },
        { lat: 35.88627929687496, lng: 14.537011718749993 },
        { lat: 35.85273437499998, lng: 14.566210937499987 },
      ],
      [
        { lat: 36.027587890624964, lng: 14.313476562500028 },
        { lat: 36.01215820312503, lng: 14.253613281250011 },
        { lat: 36.04223632812503, lng: 14.19423828125008 },
        { lat: 36.060400390625006, lng: 14.180371093750011 },
        { lat: 36.075781250000034, lng: 14.26328125 },
        { lat: 36.062304687500045, lng: 14.3037109375 },
        { lat: 36.036230468750055, lng: 14.320898437500034 },
        { lat: 36.027587890624964, lng: 14.313476562500028 },
      ],
    ],
  },
  {
    code: "ME",
    coordinates: [
      [
        { lat: 43.53330078125, lng: 19.1943359375 },
        { lat: 43.521044921874996, lng: 19.19160156250001 },
        { lat: 43.485009765624994, lng: 19.19648437500001 },
        { lat: 43.449951171875, lng: 19.21875 },
        { lat: 43.413964843749994, lng: 19.298242187500023 },
        { lat: 43.342822265624996, lng: 19.414648437500006 },
        { lat: 43.21225585937499, lng: 19.551562500000017 },
        { lat: 43.1734375, lng: 19.614453125 },
        { lat: 43.16396484374999, lng: 19.670996093750006 },
        { lat: 43.10976562499999, lng: 19.781152343750023 },
        { lat: 43.096533203125, lng: 19.858007812500006 },
        { lat: 43.081640625, lng: 19.94404296875001 },
        { lat: 42.968505859375, lng: 20.167871093750023 },
        { lat: 42.935449218749994, lng: 20.26845703125002 },
        { lat: 42.892871093749996, lng: 20.339941406250006 },
        { lat: 42.852783203125, lng: 20.34765625 },
        { lat: 42.827929687499996, lng: 20.344335937500006 },
        { lat: 42.798828125, lng: 20.215136718750017 },
        { lat: 42.754638671875, lng: 20.19257812500001 },
        { lat: 42.759765625, lng: 20.129980468750006 },
        { lat: 42.760058593749996, lng: 20.054296875 },
        { lat: 42.73203125, lng: 20.029492187500008 },
        { lat: 42.685839843749996, lng: 20.065722656250017 },
        { lat: 42.63154296875, lng: 20.089257812500023 },
        { lat: 42.557080078125, lng: 20.0703125 },
        { lat: 42.54726562499999, lng: 20.063964843749996 },
        { lat: 42.54990234374999, lng: 20.045703125000017 },
        { lat: 42.506689453125, lng: 19.9390625 },
        { lat: 42.486328125, lng: 19.859765625000023 },
        { lat: 42.476171875, lng: 19.78828125000001 },
        { lat: 42.496923828125, lng: 19.754492187500006 },
        { lat: 42.525146484375, lng: 19.73779296875 },
        { lat: 42.60693359375, lng: 19.74072265625 },
        { lat: 42.634521484375, lng: 19.727832031250017 },
        { lat: 42.64794921875, lng: 19.703417968750017 },
        { lat: 42.628564453124994, lng: 19.65449218750001 },
        { lat: 42.5654296875, lng: 19.597460937500017 },
        { lat: 42.491943359375, lng: 19.54453125 },
        { lat: 42.415380859375, lng: 19.465136718750017 },
        { lat: 42.34189453125, lng: 19.39960937500001 },
        { lat: 42.249267578125, lng: 19.329003906250023 },
        { lat: 42.17255859375, lng: 19.28066406250002 },
        { lat: 42.12929687499999, lng: 19.330859375000017 },
        { lat: 42.069091796875, lng: 19.361425781250002 },
        { lat: 42.0240234375, lng: 19.352148437500006 },
        { lat: 41.99775390624999, lng: 19.361132812500017 },
        { lat: 41.91884765624999, lng: 19.345507812500017 },
        { lat: 41.869091796875, lng: 19.342382812500006 },
        { lat: 41.948632812499994, lng: 19.18642578125002 },
        { lat: 42.06049804687499, lng: 19.12226562500001 },
        { lat: 42.249462890625, lng: 18.89423828125001 },
        { lat: 42.378076171874994, lng: 18.632910156250006 },
        { lat: 42.39838867187499, lng: 18.619042968750023 },
        { lat: 42.423144531249996, lng: 18.633398437500006 },
        { lat: 42.442724609375, lng: 18.645898437500023 },
        { lat: 42.44418945312499, lng: 18.591601562500017 },
        { lat: 42.428515625, lng: 18.553515625000017 },
        { lat: 42.43291015624999, lng: 18.517480468750023 },
        { lat: 42.481103515624994, lng: 18.476660156250006 },
        { lat: 42.52294921875, lng: 18.438085937500006 },
        { lat: 42.55971679687499, lng: 18.436328125000017 },
        { lat: 42.564501953124996, lng: 18.453906250000017 },
        { lat: 42.57919921875, lng: 18.480078125 },
        { lat: 42.6201171875, lng: 18.534960937500017 },
        { lat: 42.6416015625, lng: 18.5458984375 },
        { lat: 42.674169921875, lng: 18.543261718750017 },
        { lat: 42.777246093749994, lng: 18.46601562500001 },
        { lat: 42.84409179687499, lng: 18.455078125 },
        { lat: 42.96845703124999, lng: 18.44384765625 },
        { lat: 42.997900390625, lng: 18.46015625000001 },
        { lat: 43.01215820312499, lng: 18.48847656250001 },
        { lat: 43.027685546875, lng: 18.623632812500002 },
        { lat: 43.124609375, lng: 18.621875 },
        { lat: 43.153662109375, lng: 18.629980468750002 },
        { lat: 43.19394531249999, lng: 18.656835937500006 },
        { lat: 43.230810546875, lng: 18.674218750000023 },
        { lat: 43.283544921875, lng: 18.74921875000001 },
        { lat: 43.346337890624994, lng: 18.85107421875 },
        { lat: 43.348193359374996, lng: 18.895605468750006 },
        { lat: 43.33945312499999, lng: 18.934667968750006 },
        { lat: 43.285400390625, lng: 18.97871093750001 },
        { lat: 43.292431640625, lng: 19.026660156250017 },
        { lat: 43.357324218749994, lng: 19.03671875 },
        { lat: 43.44238281249999, lng: 18.97382812500001 },
        { lat: 43.496728515624994, lng: 18.940234375000017 },
        { lat: 43.526660156249996, lng: 18.95068359375 },
        { lat: 43.542333984375, lng: 18.97421875 },
        { lat: 43.53251953124999, lng: 19.0283203125 },
        { lat: 43.51772460937499, lng: 19.080078125 },
        { lat: 43.52773437499999, lng: 19.11279296875 },
        { lat: 43.535449218749996, lng: 19.164355468750014 },
        { lat: 43.53330078125, lng: 19.1943359375 },
      ],
    ],
  },
  {
    code: "NL",
    coordinates: [
      [
        { lat: 12.144580078124989, lng: -68.205810546875 },
        { lat: 12.032080078124977, lng: -68.25434570312495 },
        { lat: 12.082275390625, lng: -68.28222656249994 },
        { lat: 12.171728515625006, lng: -68.287255859375 },
        { lat: 12.20673828125004, lng: -68.30712890624994 },
        { lat: 12.228076171875031, lng: -68.34843749999993 },
        { lat: 12.257519531249997, lng: -68.37109375000003 },
        { lat: 12.301953124999983, lng: -68.36923828125 },
        { lat: 12.23125, lng: -68.21948242187494 },
        { lat: 12.144580078124989, lng: -68.205810546875 },
      ],
      [
        { lat: 17.49565429687499, lng: -62.9375 },
        { lat: 17.475048828124983, lng: -62.96171875 },
        { lat: 17.476904296875006, lng: -62.983105468749955 },
        { lat: 17.496826171875057, lng: -62.99716796874998 },
        { lat: 17.530371093750063, lng: -62.999609375000034 },
        { lat: 17.521191406249955, lng: -62.97934570312497 },
        { lat: 17.516064453124983, lng: -62.97177734374995 },
        { lat: 17.50927734375003, lng: -62.9654296875 },
        { lat: 17.49565429687499, lng: -62.9375 },
      ],
      [
        { lat: 17.623144531250034, lng: -63.232666015625 },
        { lat: 17.61958007812501, lng: -63.24160156249994 },
        { lat: 17.628662109375, lng: -63.254492187500006 },
        { lat: 17.645263671875, lng: -63.252148437499955 },
        { lat: 17.65180664062501, lng: -63.241650390624955 },
        { lat: 17.647216796875057, lng: -63.233496093749984 },
        { lat: 17.634130859375063, lng: -63.22690429687498 },
        { lat: 17.623144531250034, lng: -63.232666015625 },
      ],
      [
        { lat: 51.38647460937503, lng: 4.226171875000034 },
        { lat: 51.34873046874998, lng: 4.211425781250057 },
        { lat: 51.30708007812501, lng: 4.17255859375004 },
        { lat: 51.24707031250006, lng: 4.040039062500057 },
        { lat: 51.207666015625016, lng: 3.902050781250011 },
        { lat: 51.212597656249955, lng: 3.83076171875004 },
        { lat: 51.23320312499998, lng: 3.78193359375004 },
        { lat: 51.25483398437504, lng: 3.755664062500017 },
        { lat: 51.27568359375002, lng: 3.681835937500068 },
        { lat: 51.28618164062501, lng: 3.580273437499983 },
        { lat: 51.26362304687495, lng: 3.51708984375 },
        { lat: 51.242236328125045, lng: 3.471972656250045 },
        { lat: 51.24575195312505, lng: 3.43251953125008 },
        { lat: 51.26362304687495, lng: 3.40283203125 },
        { lat: 51.29111328125006, lng: 3.380078125000068 },
        { lat: 51.37768554687503, lng: 3.35009765625 },
        { lat: 51.393505859374955, lng: 3.425781250000057 },
        { lat: 51.3994140625, lng: 3.589453125 },
        { lat: 51.36914062500006, lng: 3.716503906250039 },
        { lat: 51.35449218749999, lng: 3.883398437500005 },
        { lat: 51.39594726562501, lng: 4.011035156249989 },
        { lat: 51.36064453125002, lng: 4.11152343750004 },
        { lat: 51.38647460937503, lng: 4.226171875000034 },
      ],
      [
        { lat: 51.73945312500001, lng: 3.94912109375008 },
        { lat: 51.68491210937498, lng: 4.04677734375008 },
        { lat: 51.66748046875, lng: 4.067578125000068 },
        { lat: 51.648779296875006, lng: 4.07509765625008 },
        { lat: 51.627050781250006, lng: 3.950976562500017 },
        { lat: 51.693994140624966, lng: 3.81904296875004 },
        { lat: 51.67822265625005, lng: 3.731835937500052 },
        { lat: 51.70991210937501, lng: 3.699023437500017 },
        { lat: 51.729687499999955, lng: 3.698535156250017 },
        { lat: 51.746435546875006, lng: 3.789062499999972 },
        { lat: 51.73945312500001, lng: 3.94912109375008 },
      ],
      [
        { lat: 53.07070312500005, lng: 4.886132812500023 },
        { lat: 52.99980468749998, lng: 4.787109375 },
        { lat: 53.019628906250034, lng: 4.726757812500068 },
        { lat: 53.036035156249994, lng: 4.70917968750004 },
        { lat: 53.091308593749964, lng: 4.739843750000063 },
        { lat: 53.18330078124998, lng: 4.886425781249983 },
        { lat: 53.07070312500005, lng: 4.886132812500023 },
      ],
      [
        { lat: 53.308007812499994, lng: 5.10859375000004 },
        { lat: 53.23457031250004, lng: 4.923730468750051 },
        { lat: 53.24624023437502, lng: 4.907910156250011 },
        { lat: 53.310205078124994, lng: 5.02705078125004 },
        { lat: 53.308007812499994, lng: 5.10859375000004 },
      ],
      [
        { lat: 51.38647460937503, lng: 4.226171875000034 },
        { lat: 51.401513671874994, lng: 4.13886718750001 },
        { lat: 51.443212890625034, lng: 4.006542968750067 },
        { lat: 51.409375, lng: 3.821875 },
        { lat: 51.44990234374998, lng: 3.693554687500068 },
        { lat: 51.45390624999999, lng: 3.5869140625 },
        { lat: 51.486181640625006, lng: 3.520507812499972 },
        { lat: 51.54077148437503, lng: 3.448925781250068 },
        { lat: 51.57666015625006, lng: 3.499609374999977 },
        { lat: 51.58911132812499, lng: 3.548632812500017 },
        { lat: 51.596044921875006, lng: 3.743945312500017 },
        { lat: 51.57421875, lng: 3.886035156250017 },
        { lat: 51.45576171875001, lng: 4.141308593750068 },
        { lat: 51.45668945312502, lng: 4.205761718750068 },
        { lat: 51.47163085937498, lng: 4.27412109375004 },
        { lat: 51.50390624999997, lng: 4.239355468750063 },
        { lat: 51.519287109375, lng: 4.175488281250011 },
        { lat: 51.551123046875, lng: 4.080468750000023 },
        { lat: 51.595849609374966, lng: 4.004785156250051 },
        { lat: 51.61030273437498, lng: 4.182617187500057 },
        { lat: 51.633447265624994, lng: 4.158007812500017 },
        { lat: 51.67290039062502, lng: 4.134570312500017 },
        { lat: 51.810546875, lng: 3.946875 },
        { lat: 51.84780273437505, lng: 3.978906250000023 },
        { lat: 51.92773437499999, lng: 4.02607421875004 },
        { lat: 51.99409179687501, lng: 4.084863281250023 },
        { lat: 52.01191406249998, lng: 4.13173828125008 },
        { lat: 52.05898437499999, lng: 4.208789062500045 },
        { lat: 52.19682617187502, lng: 4.376269531250074 },
        { lat: 52.30917968749997, lng: 4.482812500000022 },
        { lat: 52.44257812499998, lng: 4.562109375 },
        { lat: 52.80976562500001, lng: 4.678320312500063 },
        { lat: 52.87211914062502, lng: 4.712695312500045 },
        { lat: 52.941308593749966, lng: 4.76875 },
        { lat: 52.92827148437498, lng: 4.839062500000011 },
        { lat: 52.90834960937502, lng: 4.887988281250045 },
        { lat: 52.96064453125001, lng: 5.061230468750068 },
        { lat: 53.09648437499996, lng: 5.358398437500056 },
        { lat: 53.21406250000004, lng: 5.44599609375004 },
        { lat: 53.268701171874966, lng: 5.532031250000074 },
        { lat: 53.375195312500004, lng: 5.873535156249999 },
        { lat: 53.407080078125006, lng: 6.062207031250068 },
        { lat: 53.41528320312499, lng: 6.35322265625004 },
        { lat: 53.434277343749955, lng: 6.563574218749977 },
        { lat: 53.44116210937502, lng: 6.816210937500045 },
        { lat: 53.375390625000044, lng: 6.912402343749989 },
        { lat: 53.32729492187502, lng: 6.96816406250008 },
        { lat: 53.30058593749999, lng: 7.05800781250008 },
        { lat: 53.28227539062499, lng: 7.197265625000028 },
        { lat: 53.187207031249976, lng: 7.188964843750028 },
        { lat: 52.99951171875003, lng: 7.189941406250057 },
        { lat: 52.966210937499994, lng: 7.179492187500045 },
        { lat: 52.88701171875002, lng: 7.117089843750051 },
        { lat: 52.74477539062499, lng: 7.050878906250063 },
        { lat: 52.65136718749997, lng: 7.033007812500045 },
        { lat: 52.63354492187497, lng: 7.013183593750028 },
        { lat: 52.63408203125002, lng: 6.74843750000008 },
        { lat: 52.617871093749976, lng: 6.710742187500045 },
        { lat: 52.59765625000006, lng: 6.705371093750016 },
        { lat: 52.573583984375034, lng: 6.71875 },
        { lat: 52.549658203125034, lng: 6.712402343750028 },
        { lat: 52.530175781249966, lng: 6.69160156250004 },
        { lat: 52.49921874999998, lng: 6.702929687500045 },
        { lat: 52.464013671874994, lng: 6.748828125000074 },
        { lat: 52.442285156250016, lng: 6.832519531249971 },
        { lat: 52.440283203125034, lng: 6.92207031250001 },
        { lat: 52.44409179687502, lng: 6.96816406250008 },
        { lat: 52.41899414062495, lng: 7.001855468750022 },
        { lat: 52.38022460937498, lng: 7.035156250000057 },
        { lat: 52.33149414062501, lng: 7.032617187500079 },
        { lat: 52.26601562499999, lng: 7.019628906250006 },
        { lat: 52.20551757812501, lng: 6.977246093750068 },
        { lat: 52.13579101562502, lng: 6.855078125000034 },
        { lat: 52.111230468749966, lng: 6.800390625 },
        { lat: 52.09868164062499, lng: 6.749023437500028 },
        { lat: 52.080224609374966, lng: 6.724511718749994 },
        { lat: 52.056884765625, lng: 6.712988281250062 },
        { lat: 52.03618164062496, lng: 6.715625 },
        { lat: 51.98017578125001, lng: 6.802441406250068 },
        { lat: 51.96738281249997, lng: 6.800390625 },
        { lat: 51.93828125000002, lng: 6.775195312500017 },
        { lat: 51.91088867187503, lng: 6.741796875000062 },
        { lat: 51.853955078124955, lng: 6.517578125000028 },
        { lat: 51.85839843749997, lng: 6.425 },
        { lat: 51.830029296874976, lng: 6.372167968749977 },
        { lat: 51.82465820312504, lng: 6.355664062500011 },
        { lat: 51.85073242187502, lng: 6.29707031250004 },
        { lat: 51.88076171875002, lng: 6.166503906249999 },
        { lat: 51.870410156250045, lng: 6.1171875 },
        { lat: 51.853955078124955, lng: 6.089843750000028 },
        { lat: 51.83398437499997, lng: 6.007617187500045 },
        { lat: 51.802685546875004, lng: 5.948730468750057 },
        { lat: 51.762402343749955, lng: 5.948535156250017 },
        { lat: 51.65825195312499, lng: 6.052734375 },
        { lat: 51.63779296874998, lng: 6.08935546875 },
        { lat: 51.59892578124996, lng: 6.091113281250016 },
        { lat: 51.55009765624996, lng: 6.1416015625 },
        { lat: 51.48891601562502, lng: 6.193261718750051 },
        { lat: 51.45, lng: 6.198828125000034 },
        { lat: 51.41059570312498, lng: 6.192871093750057 },
        { lat: 51.35483398437498, lng: 6.166210937500039 },
        { lat: 51.22412109374999, lng: 6.075878906250011 },
        { lat: 51.19902343750004, lng: 6.074804687500063 },
        { lat: 51.17998046874996, lng: 6.082421875000023 },
        { lat: 51.174707031249966, lng: 6.113378906250034 },
        { lat: 51.16484374999998, lng: 6.136914062500011 },
        { lat: 51.14741210937501, lng: 6.129980468750034 },
        { lat: 51.05668945312498, lng: 5.961035156250063 },
        { lat: 51.04082031250004, lng: 5.939257812500074 },
        { lat: 51.0453125, lng: 5.86835937500001 },
        { lat: 51.030126953125006, lng: 5.857519531250034 },
        { lat: 51.00566406249999, lng: 5.867187500000057 },
        { lat: 50.98422851562506, lng: 5.894726562500068 },
        { lat: 50.97294921874999, lng: 5.955078125 },
        { lat: 50.94995117187499, lng: 6.0068359375 },
        { lat: 50.904882812500055, lng: 6.048437500000034 },
        { lat: 50.75043945312503, lng: 5.993945312500017 },
        { lat: 50.754541015624994, lng: 5.797363281250028 },
        { lat: 50.759570312500045, lng: 5.7470703125 },
        { lat: 50.774658203125, lng: 5.693652343750045 },
        { lat: 50.774755859375006, lng: 5.69355468750001 },
        { lat: 50.80595703124999, lng: 5.669140625000011 },
        { lat: 50.843603515625, lng: 5.639453125000017 },
        { lat: 50.86665039062501, lng: 5.647558593750063 },
        { lat: 50.93212890625003, lng: 5.736621093750016 },
        { lat: 50.95024414062498, lng: 5.75 },
        { lat: 50.95991210937498, lng: 5.740820312500063 },
        { lat: 50.98876953124999, lng: 5.749804687500017 },
        { lat: 51.08642578125, lng: 5.818261718750022 },
        { lat: 51.125634765624994, lng: 5.827148437500057 },
        { lat: 51.153076171875, lng: 5.796484375000033 },
        { lat: 51.16948242187496, lng: 5.752343750000023 },
        { lat: 51.1984375, lng: 5.60878906250008 },
        { lat: 51.23930664062499, lng: 5.540429687499994 },
        { lat: 51.275, lng: 5.508789062500028 },
        { lat: 51.285058593749966, lng: 5.476855468750017 },
        { lat: 51.27299804687502, lng: 5.429785156250034 },
        { lat: 51.259716796874955, lng: 5.310839843750045 },
        { lat: 51.278955078124966, lng: 5.214160156250045 },
        { lat: 51.34648437499995, lng: 5.099902343750045 },
        { lat: 51.406835937500006, lng: 5.073437500000068 },
        { lat: 51.453125, lng: 5.05947265625008 },
        { lat: 51.46909179687498, lng: 5.03095703125004 },
        { lat: 51.445361328125045, lng: 4.992578125000023 },
        { lat: 51.40776367187501, lng: 4.943945312499977 },
        { lat: 51.40327148437498, lng: 4.84804687500008 },
        { lat: 51.41206054687501, lng: 4.820703125000023 },
        { lat: 51.432812499999955, lng: 4.816015625000033 },
        { lat: 51.452734375000034, lng: 4.810546875 },
        { lat: 51.47739257812498, lng: 4.784179687500028 },
        { lat: 51.49111328125002, lng: 4.755664062499989 },
        { lat: 51.421728515625006, lng: 4.633984375000068 },
        { lat: 51.42192382812496, lng: 4.588769531250023 },
        { lat: 51.44858398437498, lng: 4.531640625000023 },
        { lat: 51.47470703124998, lng: 4.503417968750028 },
        { lat: 51.459814453125055, lng: 4.44091796875 },
        { lat: 51.42758789062506, lng: 4.384765625000028 },
        { lat: 51.36708984374999, lng: 4.40400390625004 },
        { lat: 51.356005859375045, lng: 4.373730468749983 },
        { lat: 51.36152343750001, lng: 4.304492187500017 },
        { lat: 51.38647460937503, lng: 4.226171875000034 },
      ],
      [
        { lat: 53.38574218750003, lng: 5.325781250000063 },
        { lat: 53.377783203125006, lng: 5.232617187500011 },
        { lat: 53.39179687500001, lng: 5.190234375000074 },
        { lat: 53.43144531249998, lng: 5.415136718750063 },
        { lat: 53.44355468749998, lng: 5.557421874999988 },
        { lat: 53.438085937500034, lng: 5.582617187500063 },
        { lat: 53.38574218750003, lng: 5.325781250000063 },
      ],
      [
        { lat: 53.45883789062497, lng: 5.929296875 },
        { lat: 53.442626953124964, lng: 5.732031250000034 },
        { lat: 53.45488281249999, lng: 5.665332031250045 },
        { lat: 53.46650390625004, lng: 5.654296875000028 },
        { lat: 53.47338867187503, lng: 5.708105468750063 },
        { lat: 53.47509765625, lng: 5.876269531250045 },
        { lat: 53.464990234374994, lng: 5.928222656250057 },
        { lat: 53.45883789062497, lng: 5.929296875 },
      ],
      [
        { lat: 53.51074218749999, lng: 6.33339843750008 },
        { lat: 53.476806640625, lng: 6.193261718750051 },
        { lat: 53.48393554687504, lng: 6.159277343750034 },
        { lat: 53.49375, lng: 6.167675781250068 },
        { lat: 53.514990234375055, lng: 6.290917968750051 },
        { lat: 53.51074218749999, lng: 6.33339843750008 },
      ],
      [
        { lat: 53.58251953125006, lng: 6.734765625000051 },
        { lat: 53.579199218750006, lng: 6.64208984375 },
        { lat: 53.60566406249995, lng: 6.668554687500062 },
        { lat: 53.62548828125, lng: 6.754589843750011 },
        { lat: 53.62548828125, lng: 6.800878906250005 },
        { lat: 53.58251953125006, lng: 6.734765625000051 },
      ],
    ],
  },
  {
    code: "NO",
    coordinates: [
      [
        { lat: 60.30756835937501, lng: 5.085839843750022 },
        { lat: 60.188769531250045, lng: 5.089062500000068 },
        { lat: 60.19775390625003, lng: 4.996972656250051 },
        { lat: 60.243310546874966, lng: 4.955566406250057 },
        { lat: 60.27241210937495, lng: 4.943554687499983 },
        { lat: 60.341162109375, lng: 4.950781250000034 },
        { lat: 60.412060546874976, lng: 4.93007812499999 },
        { lat: 60.44726562500005, lng: 4.95722656250004 },
        { lat: 60.452050781249966, lng: 4.990625 },
        { lat: 60.38896484374998, lng: 5.050195312500051 },
        { lat: 60.30756835937501, lng: 5.085839843750022 },
      ],
      [
        { lat: 61.08457031250004, lng: 4.958691406250067 },
        { lat: 61.071923828125016, lng: 4.870117187500057 },
        { lat: 61.08271484375001, lng: 4.79902343750004 },
        { lat: 61.17822265625003, lng: 4.824414062500068 },
        { lat: 61.19384765624999, lng: 4.861621093749989 },
        { lat: 61.199365234374966, lng: 4.91542968750005 },
        { lat: 61.14824218750004, lng: 4.973242187500006 },
        { lat: 61.08457031250004, lng: 4.958691406250067 },
      ],
      [
        { lat: 63.33759765625003, lng: 8.10273437500004 },
        { lat: 63.33691406249997, lng: 8.004687500000045 },
        { lat: 63.35234375000001, lng: 7.888281250000035 },
        { lat: 63.38505859375002, lng: 7.815332031250023 },
        { lat: 63.413916015625034, lng: 7.804003906250016 },
        { lat: 63.44980468749998, lng: 7.938378906250023 },
        { lat: 63.47080078124998, lng: 8.073535156250045 },
        { lat: 63.43134765625003, lng: 8.13613281250008 },
        { lat: 63.36640625000003, lng: 8.140917968750074 },
        { lat: 63.33759765625003, lng: 8.10273437500004 },
      ],
      [
        { lat: 63.66713867187503, lng: 8.470800781250063 },
        { lat: 63.664794921874964, lng: 8.356152343750068 },
        { lat: 63.687158203125016, lng: 8.287109375000028 },
        { lat: 63.73183593749996, lng: 8.451269531250063 },
        { lat: 63.77431640624999, lng: 8.708886718750051 },
        { lat: 63.80131835937499, lng: 8.7333984375 },
        { lat: 63.804638671874955, lng: 8.764648437500057 },
        { lat: 63.771435546874955, lng: 8.809179687500063 },
        { lat: 63.72597656250002, lng: 8.81484375000008 },
        { lat: 63.703466796875034, lng: 8.78652343750008 },
        { lat: 63.66713867187503, lng: 8.470800781250063 },
      ],
      [
        { lat: 64.865869140625, lng: 11.2314453125 },
        { lat: 64.838037109375, lng: 11.179003906250045 },
        { lat: 64.86040039062502, lng: 11.0625 },
        { lat: 64.84311523437506, lng: 10.832519531249972 },
        { lat: 64.87031250000001, lng: 10.739843750000032 },
        { lat: 64.92324218750002, lng: 10.8134765625 },
        { lat: 64.97871093749995, lng: 11.020996093749998 },
        { lat: 64.97617187499998, lng: 11.132617187500017 },
        { lat: 64.90791015625001, lng: 11.246191406250063 },
        { lat: 64.865869140625, lng: 11.2314453125 },
      ],
      [
        { lat: 65.62651367187505, lng: 11.96796875000001 },
        { lat: 65.595703125, lng: 11.901855468750057 },
        { lat: 65.60454101562502, lng: 11.778320312500028 },
        { lat: 65.63095703124998, lng: 11.765136718749998 },
        { lat: 65.68388671875002, lng: 11.800390624999977 },
        { lat: 65.70590820312506, lng: 11.87539062500008 },
        { lat: 65.70156249999997, lng: 11.972363281250038 },
        { lat: 65.679443359375, lng: 12.003222656250017 },
        { lat: 65.62651367187505, lng: 11.96796875000001 },
      ],
      [
        { lat: 65.90195312500003, lng: 12.509570312500045 },
        { lat: 65.89907226562497, lng: 12.429492187500074 },
        { lat: 65.93994140625003, lng: 12.430175781250028 },
        { lat: 65.97709960937507, lng: 12.476074218750057 },
        { lat: 66.00190429687495, lng: 12.548828125000057 },
        { lat: 66.00854492187496, lng: 12.642382812500015 },
        { lat: 66.01137695312502, lng: 12.747070312500028 },
        { lat: 65.99169921875003, lng: 12.778808593749998 },
        { lat: 65.96386718750003, lng: 12.718652343750023 },
        { lat: 65.90195312500003, lng: 12.509570312500045 },
      ],
      [
        { lat: 66.04326171875005, lng: 12.419921875 },
        { lat: 66.03662109375003, lng: 12.327343750000038 },
        { lat: 66.08076171874995, lng: 12.3427734375 },
        { lat: 66.12265625000006, lng: 12.417675781250068 },
        { lat: 66.15131835937503, lng: 12.44638671875006 },
        { lat: 66.18500976562495, lng: 12.46132812500008 },
        { lat: 66.210546875, lng: 12.527441406250063 },
        { lat: 66.17792968750004, lng: 12.620800781250068 },
        { lat: 66.12246093750002, lng: 12.62265625 },
        { lat: 66.07192382812502, lng: 12.576367187500068 },
        { lat: 66.04326171875005, lng: 12.419921875 },
      ],
      [
        { lat: 67.87412109375, lng: 12.971777343750063 },
        { lat: 67.82124023437498, lng: 12.824023437500074 },
        { lat: 67.9177734375, lng: 12.877929687500057 },
        { lat: 68.01547851562503, lng: 12.95771484375004 },
        { lat: 68.07133789062505, lng: 13.068066406250068 },
        { lat: 68.0494140625, lng: 13.122851562500017 },
        { lat: 68.002685546875, lng: 13.097753906250063 },
        { lat: 67.9564453125, lng: 13.098242187499975 },
        { lat: 67.93457031249997, lng: 13.074609375000051 },
        { lat: 67.87412109375, lng: 12.971777343750063 },
      ],
      [
        { lat: 68.26533203125003, lng: 13.872851562500045 },
        { lat: 68.2482421875, lng: 13.932324218750011 },
        { lat: 68.25322265625005, lng: 14.087695312500045 },
        { lat: 68.246826171875, lng: 14.118847656250068 },
        { lat: 68.21860351562499, lng: 14.096777343750034 },
        { lat: 68.18754882812499, lng: 14.029296875000028 },
        { lat: 68.16850585937502, lng: 13.887695312500057 },
        { lat: 68.12109375000006, lng: 13.824023437500044 },
        { lat: 68.10498046875006, lng: 13.778417968750004 },
        { lat: 68.10478515625002, lng: 13.65615234375005 },
        { lat: 68.09384765624999, lng: 13.583984375 },
        { lat: 68.05166015625002, lng: 13.495214843750032 },
        { lat: 68.08276367187506, lng: 13.424218750000051 },
        { lat: 68.06069335937498, lng: 13.404394531250006 },
        { lat: 68.02124023437503, lng: 13.391503906250051 },
        { lat: 68.00966796875, lng: 13.35205078125 },
        { lat: 67.995361328125, lng: 13.22939453125005 },
        { lat: 68.08725585937498, lng: 13.199511718750015 },
        { lat: 68.12060546875003, lng: 13.255957031250063 },
        { lat: 68.16044921875007, lng: 13.300195312499994 },
        { lat: 68.16655273437507, lng: 13.367968750000045 },
        { lat: 68.16323242187502, lng: 13.4287109375 },
        { lat: 68.2490234375, lng: 13.537988281250051 },
        { lat: 68.27338867187498, lng: 13.687695312499983 },
        { lat: 68.276123046875, lng: 13.78408203125008 },
        { lat: 68.26533203125003, lng: 13.872851562500045 },
      ],
      [
        { lat: 68.943115234375, lng: 15.207128906250006 },
        { lat: 68.842431640625, lng: 15.337207031250045 },
        { lat: 68.78359375000002, lng: 15.39658203125006 },
        { lat: 68.67241210937502, lng: 15.348437500000017 },
        { lat: 68.61630859375003, lng: 15.222070312500025 },
        { lat: 68.60634765624997, lng: 15.02705078125001 },
        { lat: 68.61098632812502, lng: 14.890234375000036 },
        { lat: 68.63798828125, lng: 14.804003906250044 },
        { lat: 68.66826171875005, lng: 14.793261718750072 },
        { lat: 68.67719726562501, lng: 14.743457031250045 },
        { lat: 68.638330078125, lng: 14.612109375000017 },
        { lat: 68.63305664062497, lng: 14.520800781250074 },
        { lat: 68.66323242187498, lng: 14.40468750000005 },
        { lat: 68.71142578125006, lng: 14.37343750000008 },
        { lat: 68.771875, lng: 14.496679687500036 },
        { lat: 68.81884765625, lng: 14.553710937500028 },
        { lat: 68.81469726562503, lng: 14.6904296875 },
        { lat: 68.80009765624999, lng: 14.72460937500003 },
        { lat: 68.79096679687501, lng: 14.801855468750032 },
        { lat: 68.84755859375, lng: 14.848828125000011 },
        { lat: 68.88666992187495, lng: 14.837988281250032 },
        { lat: 68.91386718749999, lng: 14.872363281250015 },
        { lat: 68.894287109375, lng: 15.0375 },
        { lat: 69.00053710937507, lng: 15.037792968750068 },
        { lat: 69.00800781249998, lng: 15.101855468750045 },
        { lat: 69.00395507812505, lng: 15.128125 },
        { lat: 68.98154296875, lng: 15.175585937500074 },
        { lat: 68.943115234375, lng: 15.207128906250006 },
      ],
      [
        { lat: 68.56123046875001, lng: 15.760351562500007 },
        { lat: 68.55419921875, lng: 15.772363281250051 },
        { lat: 68.65048828124998, lng: 15.908593750000023 },
        { lat: 68.68051757812498, lng: 16.05957031250003 },
        { lat: 68.71401367187505, lng: 16.068945312500006 },
        { lat: 68.74643554687498, lng: 16.12744140625 },
        { lat: 68.799365234375, lng: 16.120800781250068 },
        { lat: 68.8423828125, lng: 16.15058593750001 },
        { lat: 68.853759765625, lng: 16.227539062500057 },
        { lat: 68.86831054687505, lng: 16.275585937499983 },
        { lat: 68.87631835937498, lng: 16.328906250000017 },
        { lat: 68.841552734375, lng: 16.425195312499994 },
        { lat: 68.80292968749995, lng: 16.4796875 },
        { lat: 68.71655273437503, lng: 16.54736328125003 },
        { lat: 68.63300781249998, lng: 16.519238281250068 },
        { lat: 68.56787109375003, lng: 16.337988281250006 },
        { lat: 68.53847656249998, lng: 16.193945312500063 },
        { lat: 68.46367187500002, lng: 16.048437499999977 },
        { lat: 68.40249023437498, lng: 15.975292968750011 },
        { lat: 68.38925781250006, lng: 15.9125 },
        { lat: 68.39423828125001, lng: 15.872753906249983 },
        { lat: 68.409033203125, lng: 15.837402343749972 },
        { lat: 68.40908203125, lng: 15.763671875000055 },
        { lat: 68.35600585937502, lng: 15.682519531250051 },
        { lat: 68.31284179687503, lng: 15.4375 },
        { lat: 68.32529296874998, lng: 15.34140625 },
        { lat: 68.37822265625002, lng: 15.337011718750007 },
        { lat: 68.37382812500002, lng: 15.27968750000005 },
        { lat: 68.31040039062498, lng: 15.187890625000078 },
        { lat: 68.28920898437501, lng: 15.098046875000078 },
        { lat: 68.28271484375003, lng: 15.037695312500036 },
        { lat: 68.30659179687501, lng: 14.926855468750034 },
        { lat: 68.198486328125, lng: 14.628906249999972 },
        { lat: 68.17827148437505, lng: 14.349511718750078 },
        { lat: 68.19077148437503, lng: 14.257519531249983 },
        { lat: 68.25693359375, lng: 14.257226562500023 },
        { lat: 68.34155273437503, lng: 14.437792968750044 },
        { lat: 68.40034179687501, lng: 14.585839843749994 },
        { lat: 68.44140625000001, lng: 15.09531250000006 },
        { lat: 68.61582031250003, lng: 15.412597656250027 },
        { lat: 68.805322265625, lng: 15.489257812500028 },
        { lat: 68.87373046874998, lng: 15.564257812500017 },
        { lat: 68.91240234375005, lng: 15.52900390625004 },
        { lat: 68.919189453125, lng: 15.443652343750047 },
        { lat: 68.97856445312502, lng: 15.43847656249997 },
        { lat: 69.04345703125003, lng: 15.483007812500006 },
        { lat: 69.13256835937506, lng: 15.649511718749977 },
        { lat: 69.17050781250006, lng: 15.741992187499987 },
        { lat: 69.27788085937499, lng: 15.89267578125006 },
        { lat: 69.30205078125002, lng: 15.965332031250028 },
        { lat: 69.30205078125002, lng: 16.04804687500001 },
        { lat: 69.27392578124997, lng: 16.129492187500063 },
        { lat: 69.21640624999998, lng: 16.11484375 },
        { lat: 69.11264648437496, lng: 15.99267578125 },
        { lat: 69.02421875000002, lng: 15.811718749999981 },
        { lat: 68.96074218750005, lng: 15.833789062500045 },
        { lat: 68.90849609375005, lng: 15.905859374999977 },
        { lat: 68.81918945312498, lng: 15.923535156250038 },
        { lat: 68.73320312500005, lng: 15.927929687500038 },
        { lat: 68.617041015625, lng: 15.790722656250066 },
        { lat: 68.56123046875001, lng: 15.760351562500007 },
      ],
      [
        { lat: 69.59624023437502, lng: 17.503027343750034 },
        { lat: 69.5390625, lng: 17.62324218750001 },
        { lat: 69.55654296875, lng: 17.67734375 },
        { lat: 69.56303710937497, lng: 17.78369140625 },
        { lat: 69.54296875, lng: 17.862792968750057 },
        { lat: 69.50664062500005, lng: 17.927441406250068 },
        { lat: 69.50498046874998, lng: 18.004101562500068 },
        { lat: 69.45751953125, lng: 18.05224609375 },
        { lat: 69.39575195312503, lng: 18.076757812500034 },
        { lat: 69.34960937500003, lng: 18.021093750000063 },
        { lat: 69.32871093750003, lng: 17.94208984375004 },
        { lat: 69.27431640624997, lng: 17.920703125000045 },
        { lat: 69.19814453125, lng: 17.95068359375003 },
        { lat: 69.172021484375, lng: 17.773535156249977 },
        { lat: 69.16040039062503, lng: 17.568164062500074 },
        { lat: 69.19682617187499, lng: 17.487890625000063 },
        { lat: 69.13002929687497, lng: 17.32363281250008 },
        { lat: 69.02592773437499, lng: 17.160937500000074 },
        { lat: 69.013671875, lng: 17.08251953124997 },
        { lat: 69.04663085937503, lng: 17.077050781250023 },
        { lat: 69.06938476562503, lng: 16.96015625000001 },
        { lat: 69.07070312499997, lng: 16.81044921875008 },
        { lat: 69.09511718749997, lng: 16.81542968750003 },
        { lat: 69.11235351562502, lng: 16.842578125000045 },
        { lat: 69.13789062499998, lng: 16.971777343750063 },
        { lat: 69.190625, lng: 16.997558593749996 },
        { lat: 69.28471679687505, lng: 16.974121093750025 },
        { lat: 69.33037109375002, lng: 16.996875 },
        { lat: 69.36191406250005, lng: 17.001757812500045 },
        { lat: 69.39882812500002, lng: 17.083007812499996 },
        { lat: 69.38149414062497, lng: 17.36083984375003 },
        { lat: 69.41669921875004, lng: 17.394531250000057 },
        { lat: 69.43886718750002, lng: 17.373437500000023 },
        { lat: 69.47768554687502, lng: 17.22988281250008 },
        { lat: 69.50380859375002, lng: 17.25195312500003 },
        { lat: 69.52714843750005, lng: 17.355566406250002 },
        { lat: 69.53017578124997, lng: 17.45361328125 },
        { lat: 69.569677734375, lng: 17.483105468750068 },
        { lat: 69.58686523437495, lng: 17.488183593750023 },
        { lat: 69.59624023437502, lng: 17.503027343750034 },
      ],
      [
        { lat: 69.79677734375002, lng: 29.956152343750006 },
        { lat: 69.767529296875, lng: 29.766210937500006 },
        { lat: 69.79160156250002, lng: 29.74423828125006 },
        { lat: 69.82905273437501, lng: 29.785937500000014 },
        { lat: 69.90556640625005, lng: 29.83583984374999 },
        { lat: 69.90244140625003, lng: 29.91396484374999 },
        { lat: 69.87324218749995, lng: 29.992968750000017 },
        { lat: 69.83837890625006, lng: 30.055175781249968 },
        { lat: 69.79677734375002, lng: 29.956152343750006 },
      ],
      [
        { lat: 70.08974609375002, lng: 20.779199218750023 },
        { lat: 70.06650390624998, lng: 20.72529296875004 },
        { lat: 70.05703125, lng: 20.642578125000057 },
        { lat: 70.07143554687502, lng: 20.598046875000048 },
        { lat: 70.08090820312496, lng: 20.534667968750025 },
        { lat: 70.0765625, lng: 20.46425781250005 },
        { lat: 70.11914062500006, lng: 20.40507812499999 },
        { lat: 70.15488281250003, lng: 20.41171875 },
        { lat: 70.20332031249995, lng: 20.492773437500006 },
        { lat: 70.230859375, lng: 20.654882812500006 },
        { lat: 70.21953124999999, lng: 20.78603515625008 },
        { lat: 70.20546874999997, lng: 20.819433593750034 },
        { lat: 70.08974609375002, lng: 20.779199218750023 },
      ],
      [
        { lat: 70.06640625000006, lng: 19.25507812500001 },
        { lat: 70.01196289062497, lng: 19.34375 },
        { lat: 70.01718749999998, lng: 19.42226562500005 },
        { lat: 70.037744140625, lng: 19.445898437499977 },
        { lat: 70.04790039062502, lng: 19.49951171874997 },
        { lat: 70.019140625, lng: 19.60781250000002 },
        { lat: 69.97016601562498, lng: 19.592285156250057 },
        { lat: 69.90839843750001, lng: 19.44238281249997 },
        { lat: 69.82026367187501, lng: 19.334765625000074 },
        { lat: 69.7998046875, lng: 19.197070312500017 },
        { lat: 69.81044921875005, lng: 19.13085937500003 },
        { lat: 69.75957031250007, lng: 19.0078125 },
        { lat: 69.70668945312505, lng: 18.909179687500057 },
        { lat: 69.63984375000001, lng: 18.806933593750017 },
        { lat: 69.60537109374998, lng: 18.80068359375008 },
        { lat: 69.57900390624997, lng: 18.784765625000034 },
        { lat: 69.55283203125006, lng: 18.410253906250034 },
        { lat: 69.53549804687496, lng: 18.27412109375001 },
        { lat: 69.557861328125, lng: 18.12988281250003 },
        { lat: 69.60209960937503, lng: 18.06152343750003 },
        { lat: 69.62612304687497, lng: 18.08349609374997 },
        { lat: 69.63574218749997, lng: 18.22744140625008 },
        { lat: 69.67675781249997, lng: 18.232031250000034 },
        { lat: 69.70180664062502, lng: 18.268457031249994 },
        { lat: 69.71547851562497, lng: 18.315039062500006 },
        { lat: 69.76787109374999, lng: 18.34931640625004 },
        { lat: 69.78154296875002, lng: 18.40625 },
        { lat: 69.76865234375006, lng: 18.512402343750068 },
        { lat: 69.80659179687495, lng: 18.583984374999968 },
        { lat: 69.81303710937505, lng: 18.624316406250017 },
        { lat: 69.781640625, lng: 18.67402343750004 },
        { lat: 69.82485351562504, lng: 18.69794921875001 },
        { lat: 69.86430664062499, lng: 18.67402343750004 },
        { lat: 69.89091796875002, lng: 18.6865234375 },
        { lat: 69.96010742187497, lng: 18.823828125 },
        { lat: 70.01054687500005, lng: 18.883203125000023 },
        { lat: 70.04301757812499, lng: 18.968652343750023 },
        { lat: 70.037841796875, lng: 19.05097656250001 },
        { lat: 70.08569335937497, lng: 19.074902343750068 },
        { lat: 70.13466796875002, lng: 19.05097656250001 },
        { lat: 70.16660156250003, lng: 19.06005859374997 },
        { lat: 70.24414062500003, lng: 19.13271484375005 },
        { lat: 70.2474609375, lng: 19.212695312500074 },
        { lat: 70.17856445312498, lng: 19.249414062500023 },
        { lat: 70.06640625000006, lng: 19.25507812500001 },
      ],
      [
        { lat: 70.21669921875002, lng: 19.76748046875005 },
        { lat: 70.20498046875005, lng: 19.818359375000025 },
        { lat: 70.212255859375, lng: 19.868652343750057 },
        { lat: 70.20190429687503, lng: 19.910449218750045 },
        { lat: 70.14926757812506, lng: 19.99414062500003 },
        { lat: 70.12856445312502, lng: 20.084277343750017 },
        { lat: 70.10205078125003, lng: 20.088476562500063 },
        { lat: 70.076220703125, lng: 20.005957031250034 },
        { lat: 70.06845703125003, lng: 19.897265625000017 },
        { lat: 70.07744140624997, lng: 19.780859375 },
        { lat: 70.11049804687497, lng: 19.746679687500063 },
        { lat: 70.16533203125005, lng: 19.71083984375005 },
        { lat: 70.21909179687498, lng: 19.61347656250001 },
        { lat: 70.26616210937507, lng: 19.59902343749999 },
        { lat: 70.273583984375, lng: 19.68378906250004 },
        { lat: 70.21669921875002, lng: 19.76748046875005 },
      ],
      [
        { lat: 70.54931640625003, lng: 23.615332031250034 },
        { lat: 70.5025390625, lng: 23.63398437500004 },
        { lat: 70.46396484375003, lng: 23.641015625000048 },
        { lat: 70.40815429687495, lng: 23.54775390625005 },
        { lat: 70.33496093750006, lng: 23.332812500000045 },
        { lat: 70.31528320312503, lng: 23.34511718750005 },
        { lat: 70.29648437500003, lng: 23.27070312500001 },
        { lat: 70.28261718750005, lng: 23.15917968750003 },
        { lat: 70.29609374999995, lng: 23.100292968750008 },
        { lat: 70.35883789062504, lng: 23.108398437500057 },
        { lat: 70.37763671874995, lng: 23.090625 },
        { lat: 70.35278320312503, lng: 23.005957031250063 },
        { lat: 70.38466796874997, lng: 22.91787109375005 },
        { lat: 70.41674804687503, lng: 22.917773437500045 },
        { lat: 70.444580078125, lng: 22.941015625000063 },
        { lat: 70.4869140625, lng: 23.022460937500057 },
        { lat: 70.51606445312501, lng: 23.15839843750004 },
        { lat: 70.505126953125, lng: 23.248046875 },
        { lat: 70.61708984374995, lng: 23.546679687500017 },
        { lat: 70.59365234375, lng: 23.57890624999999 },
        { lat: 70.54931640625003, lng: 23.615332031250034 },
      ],
      [
        { lat: 70.56738281249997, lng: 24.01757812500003 },
        { lat: 70.52749023437502, lng: 23.82714843750003 },
        { lat: 70.561865234375, lng: 23.716601562500074 },
        { lat: 70.5970703125, lng: 23.67011718750001 },
        { lat: 70.67524414062501, lng: 23.66328125000004 },
        { lat: 70.72280273437502, lng: 23.689160156250068 },
        { lat: 70.74736328125005, lng: 23.778417968750063 },
        { lat: 70.72939453125002, lng: 23.836523437499977 },
        { lat: 70.71435546874996, lng: 23.852050781250057 },
        { lat: 70.699609375, lng: 23.95644531250008 },
        { lat: 70.65058593749995, lng: 24.07832031250004 },
        { lat: 70.56738281249997, lng: 24.01757812500003 },
      ],
      [
        { lat: 70.81577148437503, lng: 23.440527343750063 },
        { lat: 70.78442382812506, lng: 23.420898437500057 },
        { lat: 70.75390625000006, lng: 23.38710937499999 },
        { lat: 70.72167968749997, lng: 23.30517578125 },
        { lat: 70.59409179687499, lng: 23.068164062500045 },
        { lat: 70.57353515624997, lng: 22.92890625000001 },
        { lat: 70.55351562499999, lng: 22.88476562499997 },
        { lat: 70.54155273437505, lng: 22.829101562499996 },
        { lat: 70.55903320312495, lng: 22.656054687500017 },
        { lat: 70.53315429687501, lng: 22.60537109375008 },
        { lat: 70.51586914062506, lng: 22.557519531250023 },
        { lat: 70.50917968750002, lng: 22.432226562500063 },
        { lat: 70.514794921875, lng: 22.358691406250017 },
        { lat: 70.56210937500006, lng: 22.16875 },
        { lat: 70.61333007812502, lng: 22.05576171875003 },
        { lat: 70.65712890624997, lng: 21.994531250000076 },
        { lat: 70.65629882812503, lng: 22.170019531250034 },
        { lat: 70.66689453125, lng: 22.232617187499983 },
        { lat: 70.65766601562498, lng: 22.350292968750068 },
        { lat: 70.70258789062498, lng: 22.420996093750006 },
        { lat: 70.69716796875002, lng: 22.570703125000023 },
        { lat: 70.72841796875, lng: 22.858105468750068 },
        { lat: 70.71098632812502, lng: 22.963574218750036 },
        { lat: 70.81547851562507, lng: 23.204687500000063 },
        { lat: 70.81274414062506, lng: 23.28017578125008 },
        { lat: 70.84257812499999, lng: 23.395605468750034 },
        { lat: 70.81577148437503, lng: 23.440527343750063 },
      ],
      [
        { lat: 70.6779296875, lng: 27.898046875 },
        { lat: 70.66425781249998, lng: 27.998828125000017 },
        { lat: 70.704345703125, lng: 28.215625 },
        { lat: 70.66796875000003, lng: 28.271777343750014 },
        { lat: 70.57690429687506, lng: 28.202734375 },
        { lat: 70.440185546875, lng: 28.191015625 },
        { lat: 70.36040039062499, lng: 28.166015625000057 },
        { lat: 70.28764648437502, lng: 28.166015625000057 },
        { lat: 70.24858398437505, lng: 28.192968750000034 },
        { lat: 70.40341796875005, lng: 28.280078125000017 },
        { lat: 70.44306640624995, lng: 28.309863281250045 },
        { lat: 70.50136718750002, lng: 28.43730468749999 },
        { lat: 70.61879882812497, lng: 28.484765625000076 },
        { lat: 70.75966796874997, lng: 28.609375 },
        { lat: 70.84150390624995, lng: 28.749804687500074 },
        { lat: 70.86396484375, lng: 28.831542968750025 },
        { lat: 70.86074218749997, lng: 29.102343750000045 },
        { lat: 70.829931640625, lng: 29.21855468750002 },
        { lat: 70.761474609375, lng: 29.32109375000002 },
        { lat: 70.73413085937503, lng: 29.3976562500001 },
        { lat: 70.70502929687495, lng: 29.63906250000005 },
        { lat: 70.66855468749998, lng: 29.721972656250074 },
        { lat: 70.646826171875, lng: 29.7375 },
        { lat: 70.64252929687501, lng: 29.796484375000063 },
        { lat: 70.69438476562499, lng: 29.959375 },
        { lat: 70.70297851562498, lng: 30.065136718750097 },
        { lat: 70.62216796875003, lng: 30.23769531250005 },
        { lat: 70.56230468750002, lng: 30.203027343749994 },
        { lat: 70.54331054687503, lng: 30.213183593750017 },
        { lat: 70.54716796875002, lng: 30.42207031250004 },
        { lat: 70.52368164062503, lng: 30.59589843750004 },
        { lat: 70.40112304687501, lng: 30.926367187500002 },
        { lat: 70.34384765625, lng: 30.960644531250093 },
        { lat: 70.27441406249997, lng: 30.944140625000017 },
        { lat: 70.1978515625, lng: 30.468945312500097 },
        { lat: 70.12470703125004, lng: 30.26298828125007 },
        { lat: 70.09648437500005, lng: 29.925878906250063 },
        { lat: 70.14541015625, lng: 28.781152343750055 },
        { lat: 70.09252929687506, lng: 28.804296875000063 },
        { lat: 69.97675781249998, lng: 29.601367187500017 },
        { lat: 69.943701171875, lng: 29.646875 },
        { lat: 69.87407226562505, lng: 29.621386718750014 },
        { lat: 69.81821289062503, lng: 29.620996093749994 },
        { lat: 69.780126953125, lng: 29.635937500000036 },
        { lat: 69.74458007812504, lng: 29.694628906250014 },
        { lat: 69.727880859375, lng: 29.79208984375006 },
        { lat: 69.73666992187502, lng: 29.990332031250006 },
        { lat: 69.71757812500005, lng: 30.08828125 },
        { lat: 69.74594726562503, lng: 30.15517578125005 },
        { lat: 69.841162109375, lng: 30.18007812500005 },
        { lat: 69.86220703125002, lng: 30.237597656250014 },
        { lat: 69.83457031249998, lng: 30.34882812500004 },
        { lat: 69.73281250000002, lng: 30.397265625000074 },
        { lat: 69.722265625, lng: 30.428320312500006 },
        { lat: 69.79487304687497, lng: 30.484375 },
        { lat: 69.78964843749998, lng: 30.594531250000014 },
        { lat: 69.79570312500005, lng: 30.714453125 },
        { lat: 69.78344726562506, lng: 30.869726562500006 },
        { lat: 69.65175781250005, lng: 30.924121093750017 },
        { lat: 69.605810546875, lng: 30.922460937500002 },
        { lat: 69.56123046874998, lng: 30.896679687500097 },
        { lat: 69.53842773437503, lng: 30.86074218749999 },
        { lat: 69.52851562499998, lng: 30.788867187500074 },
        { lat: 69.532568359375, lng: 30.615429687500093 },
        { lat: 69.58471679687497, lng: 30.379687500000017 },
        { lat: 69.63378906250003, lng: 30.22753906250003 },
        { lat: 69.63583984375, lng: 30.180175781249975 },
        { lat: 69.62988281250003, lng: 30.159765625 },
        { lat: 69.58056640625003, lng: 30.196484375000093 },
        { lat: 69.54277343750005, lng: 30.18671875000004 },
        { lat: 69.501611328125, lng: 30.163769531250093 },
        { lat: 69.46425781250002, lng: 30.13183593749997 },
        { lat: 69.43286132812501, lng: 30.087304687500048 },
        { lat: 69.39248046874997, lng: 29.99404296874999 },
        { lat: 69.36044921875003, lng: 29.83271484375004 },
        { lat: 69.29814453125005, lng: 29.38828125 },
        { lat: 69.27060546875, lng: 29.35302734375003 },
        { lat: 69.097021484375, lng: 29.20996093750003 },
        { lat: 69.07153320312504, lng: 29.170898437500053 },
        { lat: 69.049951171875, lng: 29.11855468750005 },
        { lat: 69.02197265625, lng: 28.96582031250003 },
        { lat: 69.06059570312505, lng: 28.891894531250074 },
        { lat: 69.11899414062503, lng: 28.832617187500063 },
        { lat: 69.17690429687502, lng: 28.846289062500006 },
        { lat: 69.28798828125, lng: 29.024902343749968 },
        { lat: 69.36669921874997, lng: 29.19179687500005 },
        { lat: 69.39394531250002, lng: 29.238867187500063 },
        { lat: 69.47299804687503, lng: 29.333398437500048 },
        { lat: 69.67143554687505, lng: 29.141601562500025 },
        { lat: 69.73149414062505, lng: 28.800390625000063 },
        { lat: 69.82275390624997, lng: 28.411718750000034 },
        { lat: 69.87143554687503, lng: 28.269140625000034 },
        { lat: 69.97167968750003, lng: 28.047265625000023 },
        { lat: 70.06166992187497, lng: 27.889941406250045 },
        { lat: 70.06484375, lng: 27.747851562500042 },
        { lat: 70.042236328125, lng: 27.591699218750023 },
        { lat: 69.96005859375006, lng: 27.34804687500005 },
        { lat: 69.91870117187497, lng: 27.205664062499977 },
        { lat: 69.90649414062497, lng: 27.127539062500063 },
        { lat: 69.90468749999995, lng: 27.108691406250042 },
        { lat: 69.928125, lng: 26.93427734375004 },
        { lat: 69.93305664062498, lng: 26.740234375000025 },
        { lat: 69.92631835937502, lng: 26.584277343750045 },
        { lat: 69.91503906250003, lng: 26.525390625000057 },
        { lat: 69.78193359375001, lng: 26.308203125000034 },
        { lat: 69.71469726562498, lng: 26.15615234375005 },
        { lat: 69.69155273437497, lng: 26.07246093750004 },
        { lat: 69.65263671875005, lng: 26.011523437500074 },
        { lat: 69.58862304687497, lng: 25.961523437500006 },
        { lat: 69.36650390625002, lng: 25.850195312500063 },
        { lat: 69.28266601562498, lng: 25.767187500000034 },
        { lat: 69.23144531250003, lng: 25.748632812500063 },
        { lat: 69.07612304687501, lng: 25.768164062500063 },
        { lat: 68.99013671874998, lng: 25.748339843750014 },
        { lat: 68.91914062500001, lng: 25.646679687499983 },
        { lat: 68.88715820312498, lng: 25.575292968750006 },
        { lat: 68.88061523437497, lng: 25.48085937500005 },
        { lat: 68.862451171875, lng: 25.357128906250068 },
        { lat: 68.82133789062507, lng: 25.249121093750006 },
        { lat: 68.76528320312502, lng: 25.172851562499996 },
        { lat: 68.63959960937498, lng: 25.0869140625 },
        { lat: 68.59326171875006, lng: 24.94140625000003 },
        { lat: 68.60649414062499, lng: 24.802441406250036 },
        { lat: 68.65283203125001, lng: 24.703222656249974 },
        { lat: 68.68867187500004, lng: 24.49052734374999 },
        { lat: 68.71152343749998, lng: 24.33203125000003 },
        { lat: 68.760888671875, lng: 24.154101562500017 },
        { lat: 68.7984375, lng: 23.99736328125007 },
        { lat: 68.80590820312503, lng: 23.85400390625 },
        { lat: 68.75839843750003, lng: 23.772558593750006 },
        { lat: 68.71386718750003, lng: 23.70703125 },
        { lat: 68.67763671875, lng: 23.4625 },
        { lat: 68.64897460937502, lng: 23.324023437500017 },
        { lat: 68.64257812499997, lng: 23.144335937500017 },
        { lat: 68.67436523437505, lng: 23.07167968750005 },
        { lat: 68.69531249999997, lng: 22.811035156250057 },
        { lat: 68.72021484374997, lng: 22.500683593750068 },
        { lat: 68.719873046875, lng: 22.410937500000074 },
        { lat: 68.776611328125, lng: 22.382910156250063 },
        { lat: 68.855859375, lng: 22.300390625000034 },
        { lat: 68.9927734375, lng: 22.0796875 },
        { lat: 69.04111328124998, lng: 21.98945312500001 },
        { lat: 69.15449218749998, lng: 21.81972656250008 },
        { lat: 69.27070312499995, lng: 21.621777343750068 },
        { lat: 69.273583984375, lng: 21.59375 },
        { lat: 69.277490234375, lng: 21.461230468750045 },
        { lat: 69.27368164062503, lng: 21.26679687500004 },
        { lat: 69.24726562499997, lng: 21.14375 },
        { lat: 69.21411132812496, lng: 21.06611328125001 },
        { lat: 69.18657226562505, lng: 21.052636718750023 },
        { lat: 69.080810546875, lng: 21.12783203125008 },
        { lat: 69.05444335937503, lng: 21.10449218750003 },
        { lat: 69.04174804687503, lng: 21.065722656250017 },
        { lat: 69.07143554687502, lng: 20.889257812500063 },
        { lat: 69.069482421875, lng: 20.675878906250006 },
        { lat: 69.036865234375, lng: 20.622167968750006 },
        { lat: 69.03330078124998, lng: 20.491992187500017 },
        { lat: 69.02089843750005, lng: 20.116699218750057 },
        { lat: 68.934326171875, lng: 20.282324218750034 },
        { lat: 68.89965820312503, lng: 20.33710937500001 },
        { lat: 68.84873046875002, lng: 20.348046875000023 },
        { lat: 68.75405273437502, lng: 20.31943359375003 },
        { lat: 68.67314453125007, lng: 20.240039062500042 },
        { lat: 68.60732421875, lng: 20.147460937499996 },
        { lat: 68.54204101562502, lng: 19.96884765625003 },
        { lat: 68.4775390625, lng: 20.240039062500042 },
        { lat: 68.39038085937503, lng: 20.055957031250014 },
        { lat: 68.35639648437501, lng: 19.969824218750063 },
        { lat: 68.36225585937497, lng: 19.87001953125005 },
        { lat: 68.39243164062498, lng: 19.691210937500045 },
        { lat: 68.46533203125, lng: 19.25898437500001 },
        { lat: 68.49272460937499, lng: 19.05263671875008 },
        { lat: 68.50112304687502, lng: 18.868261718749977 },
        { lat: 68.50004882812507, lng: 18.769824218750017 },
        { lat: 68.56240234374997, lng: 18.378613281250068 },
        { lat: 68.55541992187497, lng: 18.303027343750045 },
        { lat: 68.52841796874998, lng: 18.16259765625003 },
        { lat: 68.46777343749997, lng: 18.14707031250006 },
        { lat: 68.31684570312495, lng: 18.15595703125001 },
        { lat: 68.20063476562498, lng: 18.17666015625005 },
        { lat: 68.133447265625, lng: 18.125 },
        { lat: 68.08784179687501, lng: 18.073242187500025 },
        { lat: 67.96489257812502, lng: 17.916699218750008 },
        { lat: 68.04843749999998, lng: 17.564746093750074 },
        { lat: 68.10380859374999, lng: 17.324609375000023 },
        { lat: 68.03012695312498, lng: 17.170507812500063 },
        { lat: 67.89501953125, lng: 16.783593750000023 },
        { lat: 67.62832031250002, lng: 16.585546874999974 },
        { lat: 67.61958007812501, lng: 16.57412109375005 },
        { lat: 67.55175781250006, lng: 16.457128906250034 },
        { lat: 67.52060546875, lng: 16.30712890625003 },
        { lat: 67.50517578125006, lng: 16.193554687500068 },
        { lat: 67.42583007812507, lng: 16.12744140625 },
        { lat: 67.31206054687506, lng: 16.281542968750045 },
        { lat: 67.25200195312499, lng: 16.360644531249985 },
        { lat: 67.15507812500007, lng: 16.434277343749983 },
        { lat: 67.093359375, lng: 16.420703125000074 },
        { lat: 67.05498046875002, lng: 16.40351562500004 },
        { lat: 66.97641601562498, lng: 16.23769531250008 },
        { lat: 66.76884765625007, lng: 15.884179687500021 },
        { lat: 66.55209960937506, lng: 15.55703125000005 },
        { lat: 66.48984374999996, lng: 15.422949218750006 },
        { lat: 66.30595703124999, lng: 15.483789062500051 },
        { lat: 66.25205078125002, lng: 15.37490234375008 },
        { lat: 66.19106445312505, lng: 15.153320312500057 },
        { lat: 66.16752929687503, lng: 15.0400390625 },
        { lat: 66.1537109375, lng: 14.91796875 },
        { lat: 66.12934570312498, lng: 14.543261718750044 },
        { lat: 65.932275390625, lng: 14.609960937500036 },
        { lat: 65.84501953125007, lng: 14.635156250000023 },
        { lat: 65.79326171874999, lng: 14.634570312500074 },
        { lat: 65.74287109374995, lng: 14.595800781249977 },
        { lat: 65.64638671875002, lng: 14.549511718750068 },
        { lat: 65.30146484374998, lng: 14.479687500000038 },
        { lat: 65.26435546874998, lng: 14.42626953125 },
        { lat: 65.17084960937504, lng: 14.352441406250051 },
        { lat: 64.946142578125, lng: 14.115136718750023 },
        { lat: 64.79677734375001, lng: 13.92480468749997 },
        { lat: 64.58154296874997, lng: 13.650292968750023 },
        { lat: 64.51357421874997, lng: 13.873535156250028 },
        { lat: 64.46401367187498, lng: 14.077636718750028 },
        { lat: 64.38774414062502, lng: 14.119921875000017 },
        { lat: 64.26030273437507, lng: 14.148046874999977 },
        { lat: 64.17353515624998, lng: 14.141210937500006 },
        { lat: 64.09550781250007, lng: 14.063281250000045 },
        { lat: 64.04072265625001, lng: 14.002734375000044 },
        { lat: 64.01401367187498, lng: 13.960546875000063 },
        { lat: 64.040625, lng: 13.670703125000074 },
        { lat: 64.07480468750003, lng: 13.299609375000074 },
        { lat: 64.07509765625, lng: 13.203515625000023 },
        { lat: 64.05048828124995, lng: 12.987597656250017 },
        { lat: 64, lng: 12.792773437500017 },
        { lat: 63.95742187499999, lng: 12.690039062500032 },
        { lat: 63.94047851562502, lng: 12.6625 },
        { lat: 63.84355468749999, lng: 12.532714843750057 },
        { lat: 63.671191406250045, lng: 12.30195312500004 },
        { lat: 63.59594726562499, lng: 12.17519531250005 },
        { lat: 63.49223632812498, lng: 12.212109375000011 },
        { lat: 63.291699218750004, lng: 11.99990234375005 },
        { lat: 63.089160156250045, lng: 12.138671874999972 },
        { lat: 63.08251953125002, lng: 12.144628906250034 },
        { lat: 63.000634765625016, lng: 12.218164062500023 },
        { lat: 62.94785156250003, lng: 12.141015625000023 },
        { lat: 62.91948242187501, lng: 12.108593750000068 },
        { lat: 62.82592773437497, lng: 12.11962890625 },
        { lat: 62.72133789062496, lng: 12.13984375000004 },
        { lat: 62.660009765625006, lng: 12.121875 },
        { lat: 62.59189453124998, lng: 12.114550781250045 },
        { lat: 62.28559570312501, lng: 12.303515625000074 },
        { lat: 62.213769531250044, lng: 12.301367187500006 },
        { lat: 62.16743164062501, lng: 12.291992187500057 },
        { lat: 61.97685546875001, lng: 12.233691406250074 },
        { lat: 61.720751953125045, lng: 12.155371093750004 },
        { lat: 61.653466796875016, lng: 12.292089843750063 },
        { lat: 61.57299804687497, lng: 12.486816406250028 },
        { lat: 61.54130859375001, lng: 12.59609375 },
        { lat: 61.44570312499997, lng: 12.75751953125004 },
        { lat: 61.35229492187506, lng: 12.88076171875008 },
        { lat: 61.29028320312503, lng: 12.86367187500008 },
        { lat: 61.22182617187502, lng: 12.828222656250034 },
        { lat: 61.17397460937505, lng: 12.776367187500057 },
        { lat: 61.10825195312497, lng: 12.727832031250017 },
        { lat: 61.059863281250074, lng: 12.706054687500028 },
        { lat: 61.04682617187498, lng: 12.683007812500021 },
        { lat: 61.041503906249964, lng: 12.467578125000017 },
        { lat: 61.023193359374964, lng: 12.353710937500011 },
        { lat: 61.00268554687506, lng: 12.294140625000038 },
        { lat: 60.89213867187498, lng: 12.314648437500038 },
        { lat: 60.68964843749995, lng: 12.445312500000027 },
        { lat: 60.54565429687502, lng: 12.553808593750006 },
        { lat: 60.450732421875045, lng: 12.588671874999989 },
        { lat: 60.35449218749997, lng: 12.552832031250063 },
        { lat: 60.305224609375074, lng: 12.515820312499983 },
        { lat: 60.23886718750006, lng: 12.514648437500028 },
        { lat: 60.106787109375055, lng: 12.486132812500074 },
        { lat: 60.04003906250006, lng: 12.402050781249981 },
        { lat: 59.96723632812495, lng: 12.291992187500057 },
        { lat: 59.91289062499999, lng: 12.169238281250074 },
        { lat: 59.897607421874994, lng: 12.071875 },
        { lat: 59.89130859375004, lng: 11.98828125 },
        { lat: 59.86367187499999, lng: 11.93212890625 },
        { lat: 59.78247070312497, lng: 11.88125 },
        { lat: 59.697167968749994, lng: 11.834277343750044 },
        { lat: 59.59228515625002, lng: 11.680761718750032 },
        { lat: 59.55576171874998, lng: 11.684863281250074 },
        { lat: 59.431445312500045, lng: 11.743359375000011 },
        { lat: 59.28989257812498, lng: 11.798144531250072 },
        { lat: 59.15756835937503, lng: 11.75185546875005 },
        { lat: 59.01865234374998, lng: 11.712207031250045 },
        { lat: 58.926074218750024, lng: 11.64277343750004 },
        { lat: 58.893017578124955, lng: 11.543554687500063 },
        { lat: 58.90952148437503, lng: 11.470703125000057 },
        { lat: 59.03652343749996, lng: 11.388281250000063 },
        { lat: 59.065722656250045, lng: 11.386425781250038 },
        { lat: 59.104541015625074, lng: 11.36591796875004 },
        { lat: 59.143212890625016, lng: 11.132128906250017 },
        { lat: 59.141796875, lng: 11.090820312500028 },
        { lat: 59.164453125000016, lng: 10.998925781250051 },
        { lat: 59.17084960937498, lng: 10.945019531250066 },
        { lat: 59.18393554687497, lng: 10.834472656250028 },
        { lat: 59.29599609374997, lng: 10.742578125000051 },
        { lat: 59.38920898437505, lng: 10.644921875000051 },
        { lat: 59.42817382812501, lng: 10.631054687500068 },
        { lat: 59.602490234374976, lng: 10.634375 },
        { lat: 59.68002929687497, lng: 10.604492187499972 },
        { lat: 59.76455078124996, lng: 10.595312500000063 },
        { lat: 59.69580078125, lng: 10.533886718750068 },
        { lat: 59.587109374999955, lng: 10.569531250000038 },
        { lat: 59.54150390625, lng: 10.49375 },
        { lat: 59.51933593750002, lng: 10.39814453125004 },
        { lat: 59.455664062500006, lng: 10.407128906249994 },
        { lat: 59.44360351562502, lng: 10.446386718750006 },
        { lat: 59.37749023437507, lng: 10.45458984375 },
        { lat: 59.279638671875034, lng: 10.431347656250068 },
        { lat: 59.062060546875024, lng: 10.2431640625 },
        { lat: 59.03867187500006, lng: 10.205175781249977 },
        { lat: 59.009277343750036, lng: 10.179394531250066 },
        { lat: 59.02880859375, lng: 10.083105468749977 },
        { lat: 58.96821289062501, lng: 9.959570312500034 },
        { lat: 58.95849609374997, lng: 9.842578125000017 },
        { lat: 59.02705078124998, lng: 9.80019531250008 },
        { lat: 59.1177734375, lng: 9.635156250000023 },
        { lat: 59.11269531250002, lng: 9.557226562500063 },
        { lat: 59.067919921875074, lng: 9.627148437500011 },
        { lat: 59.00971679687501, lng: 9.696093750000017 },
        { lat: 58.97119140624997, lng: 9.65693359375004 },
        { lat: 58.946044921875, lng: 9.618457031250017 },
        { lat: 58.93300781250002, lng: 9.551074218750045 },
        { lat: 58.85683593750005, lng: 9.309960937500051 },
        { lat: 58.80566406249999, lng: 9.395800781250017 },
        { lat: 58.74755859375, lng: 9.322949218750011 },
        { lat: 58.73901367187503, lng: 9.23867187500008 },
        { lat: 58.711865234375004, lng: 9.19375 },
        { lat: 58.675, lng: 9.178125 },
        { lat: 58.569970703125044, lng: 8.928417968750011 },
        { lat: 58.30058593750004, lng: 8.521386718750051 },
        { lat: 58.224462890625006, lng: 8.312207031250068 },
        { lat: 58.145312500000045, lng: 8.166113281250063 },
        { lat: 58.14726562499998, lng: 8.037402343750045 },
        { lat: 58.079980468749966, lng: 7.875585937500034 },
        { lat: 58.02094726562501, lng: 7.465917968750062 },
        { lat: 58.04765625000004, lng: 7.194140625000017 },
        { lat: 58.024218750000074, lng: 7.0048828125 },
        { lat: 58.070507812499976, lng: 6.903417968750034 },
        { lat: 58.102294921874964, lng: 6.890234375 },
        { lat: 58.120751953125016, lng: 6.895312500000074 },
        { lat: 58.14287109374999, lng: 6.912304687500068 },
        { lat: 58.15073242187497, lng: 6.877050781250006 },
        { lat: 58.15454101562497, lng: 6.802832031250063 },
        { lat: 58.132226562500044, lng: 6.771093749999977 },
        { lat: 58.08154296875003, lng: 6.766796875000011 },
        { lat: 58.068310546874976, lng: 6.7314453125 },
        { lat: 58.09731445312502, lng: 6.590527343750068 },
        { lat: 58.12343750000002, lng: 6.555078125000023 },
        { lat: 58.17636718749998, lng: 6.605761718750045 },
        { lat: 58.224023437499994, lng: 6.692480468750063 },
        { lat: 58.23378906250002, lng: 6.676757812500056 },
        { lat: 58.26274414062499, lng: 6.659863281250067 },
        { lat: 58.26640625000002, lng: 6.61757812500008 },
        { lat: 58.25942382812502, lng: 6.491503906250045 },
        { lat: 58.26796874999999, lng: 6.389062500000051 },
        { lat: 58.375146484374966, lng: 6.054687500000057 },
        { lat: 58.43232421874998, lng: 5.976562500000028 },
        { lat: 58.52363281250002, lng: 5.706835937500074 },
        { lat: 58.62041015625001, lng: 5.585937500000028 },
        { lat: 58.72651367187495, lng: 5.517285156249983 },
        { lat: 58.822656250000016, lng: 5.522460937499972 },
        { lat: 58.975195312500006, lng: 5.55556640625008 },
        { lat: 59.012890624999955, lng: 5.612207031250051 },
        { lat: 58.95947265625, lng: 5.854296874999989 },
        { lat: 58.87026367187502, lng: 6.099023437500023 },
        { lat: 58.87465820312503, lng: 6.137304687500006 },
        { lat: 58.944677734375006, lng: 6.214160156250045 },
        { lat: 59.000927734375004, lng: 6.363281250000028 },
        { lat: 59.01645507812506, lng: 6.321093750000074 },
        { lat: 58.95195312500007, lng: 6.099414062500017 },
        { lat: 58.987695312499966, lng: 6.016992187500023 },
        { lat: 59.060498046874976, lng: 5.88916015625 },
        { lat: 59.097949218750045, lng: 5.88916015625 },
        { lat: 59.135449218749955, lng: 5.948730468750057 },
        { lat: 59.18613281249997, lng: 5.968554687500017 },
        { lat: 59.23398437500006, lng: 5.937304687500045 },
        { lat: 59.299072265625, lng: 5.951855468750068 },
        { lat: 59.36816406250002, lng: 6.050683593750051 },
        { lat: 59.43808593749998, lng: 6.19892578125004 },
        { lat: 59.505566406249955, lng: 6.305664062500028 },
        { lat: 59.547119140625, lng: 6.415332031250073 },
        { lat: 59.560986328124976, lng: 6.403906250000062 },
        { lat: 59.534521484375006, lng: 6.278515625000011 },
        { lat: 59.4896484375, lng: 6.15859375000008 },
        { lat: 59.414453124999966, lng: 6.017382812500017 },
        { lat: 59.35346679687498, lng: 5.845214843749999 },
        { lat: 59.32983398437503, lng: 5.717968750000011 },
        { lat: 59.310253906249955, lng: 5.657324218750005 },
        { lat: 59.29121093749998, lng: 5.564062500000034 },
        { lat: 59.20380859375005, lng: 5.467578125000074 },
        { lat: 59.166357421875034, lng: 5.362304687500028 },
        { lat: 59.16254882812498, lng: 5.173242187500079 },
        { lat: 59.226464843750016, lng: 5.131640625000045 },
        { lat: 59.453662109375045, lng: 5.18505859375 },
        { lat: 59.564306640625034, lng: 5.2421875 },
        { lat: 59.642578124999964, lng: 5.304882812500068 },
        { lat: 59.65576171875, lng: 5.403515625000011 },
        { lat: 59.71308593749995, lng: 5.472460937500017 },
        { lat: 59.71308593749995, lng: 5.529687500000023 },
        { lat: 59.68662109374998, lng: 5.579492187500051 },
        { lat: 59.66093749999998, lng: 5.77216796875004 },
        { lat: 59.73398437500003, lng: 5.867285156250063 },
        { lat: 59.74467773437499, lng: 5.991015625000045 },
        { lat: 59.81835937499999, lng: 6.216601562499988 },
        { lat: 59.83178710937497, lng: 6.211914062500028 },
        { lat: 59.815576171874966, lng: 6.059277343750011 },
        { lat: 59.81318359375001, lng: 5.96669921875008 },
        { lat: 59.79467773437498, lng: 5.833984375000028 },
        { lat: 59.80791015625002, lng: 5.763476562500045 },
        { lat: 59.863085937500045, lng: 5.73046875 },
        { lat: 59.912792968749955, lng: 5.78359375000008 },
        { lat: 60.031494140625, lng: 5.996484375000023 },
        { lat: 60.08349609375003, lng: 6.069921875000063 },
        { lat: 60.13208007812497, lng: 6.111816406250057 },
        { lat: 60.16513671875003, lng: 6.10517578125004 },
        { lat: 60.23349609375003, lng: 6.140527343750051 },
        { lat: 60.35297851562504, lng: 6.348730468750006 },
        { lat: 60.40756835937503, lng: 6.518066406250057 },
        { lat: 60.360595703124964, lng: 6.57363281250008 },
        { lat: 60.21362304687497, lng: 6.526367187500057 },
        { lat: 60.152929687500034, lng: 6.526855468750057 },
        { lat: 60.36723632812498, lng: 6.660937500000016 },
        { lat: 60.41816406249998, lng: 6.71992187500004 },
        { lat: 60.45410156250002, lng: 6.787109375000057 },
        { lat: 60.47822265624995, lng: 6.949707031250057 },
        { lat: 60.511962890625, lng: 6.995703125 },
        { lat: 60.50078125000002, lng: 6.806347656250067 },
        { lat: 60.419091796874994, lng: 6.346972656250017 },
        { lat: 60.34624023437499, lng: 6.1533203125 },
        { lat: 60.290136718750006, lng: 6.10175781250004 },
        { lat: 60.20556640625003, lng: 5.967382812500034 },
        { lat: 60.15063476562503, lng: 5.904394531249977 },
        { lat: 60.07001953125001, lng: 5.8765625 },
        { lat: 60.02622070312498, lng: 5.800878906250034 },
        { lat: 60.01000976562497, lng: 5.698828125000034 },
        { lat: 59.90776367187501, lng: 5.557031250000023 },
        { lat: 59.825585937499966, lng: 5.494531250000079 },
        { lat: 59.760107421875034, lng: 5.353417968749994 },
        { lat: 59.70976562499998, lng: 5.263867187500068 },
        { lat: 59.69179687499996, lng: 5.234472656250034 },
        { lat: 59.64228515625001, lng: 5.186035156249999 },
        { lat: 59.63881835937502, lng: 5.145800781250074 },
        { lat: 59.66782226562498, lng: 5.110742187500051 },
        { lat: 59.73168945312502, lng: 5.10488281250008 },
        { lat: 59.833691406250004, lng: 5.119238281250006 },
        { lat: 59.90708007812504, lng: 5.187109375000063 },
        { lat: 59.97875976562501, lng: 5.219531249999988 },
        { lat: 60.045703125000045, lng: 5.174414062500034 },
        { lat: 60.087939453125045, lng: 5.205664062500006 },
        { lat: 60.086474609374996, lng: 5.265429687500017 },
        { lat: 60.06723632812498, lng: 5.37646484375 },
        { lat: 60.0703125, lng: 5.494531250000079 },
        { lat: 60.12319335937502, lng: 5.688574218749977 },
        { lat: 60.15410156250002, lng: 5.657617187500079 },
        { lat: 60.15849609375002, lng: 5.573828125000063 },
        { lat: 60.15410156250002, lng: 5.41738281250008 },
        { lat: 60.20571289062505, lng: 5.285839843750011 },
        { lat: 60.30839843750002, lng: 5.183593750000056 },
        { lat: 60.445605468750074, lng: 5.13710937500008 },
        { lat: 60.484814453124976, lng: 5.168164062500011 },
        { lat: 60.62456054687501, lng: 5.546484375 },
        { lat: 60.68798828124997, lng: 5.64833984375005 },
        { lat: 60.694287109375004, lng: 5.589355468750028 },
        { lat: 60.617333984374966, lng: 5.447363281250063 },
        { lat: 60.569580078125, lng: 5.244042968750022 },
        { lat: 60.63598632812503, lng: 5.115820312500005 },
        { lat: 60.70751953125006, lng: 5.049121093750016 },
        { lat: 60.858544921874994, lng: 5.0107421875 },
        { lat: 60.936132812500006, lng: 5.024609375000068 },
        { lat: 61.03818359375, lng: 5.008593750000017 },
        { lat: 61.07133789062501, lng: 5.095410156250011 },
        { lat: 61.05371093749997, lng: 5.192480468750006 },
        { lat: 61.047167968750045, lng: 5.288183593750034 },
        { lat: 61.05610351562501, lng: 5.505273437500023 },
        { lat: 61.11733398437496, lng: 5.983984375000034 },
        { lat: 61.08095703125002, lng: 6.292578125000033 },
        { lat: 61.08427734375007, lng: 6.41796875 },
        { lat: 61.13701171875007, lng: 6.60986328125 },
        { lat: 61.142431640625, lng: 6.777832031250028 },
        { lat: 61.10214843749997, lng: 6.903417968750034 },
        { lat: 61.05595703125007, lng: 6.97207031250008 },
        { lat: 60.994140625, lng: 6.980566406250034 },
        { lat: 60.95292968750004, lng: 7.038671875000063 },
        { lat: 60.96630859375, lng: 7.077929687500074 },
        { lat: 61.01528320312505, lng: 7.046679687499989 },
        { lat: 61.09116210937503, lng: 7.040136718750006 },
        { lat: 61.177148437499966, lng: 7.545019531250006 },
        { lat: 61.210546875000034, lng: 7.604492187500057 },
        { lat: 61.22216796875, lng: 7.403906250000035 },
        { lat: 61.30058593749999, lng: 7.346582031250079 },
        { lat: 61.41923828125001, lng: 7.452539062500079 },
        { lat: 61.43461914062502, lng: 7.442578125000011 },
        { lat: 61.372021484374976, lng: 7.331152343750035 },
        { lat: 61.28393554687497, lng: 7.276269531250051 },
        { lat: 61.21362304687502, lng: 7.29804687500004 },
        { lat: 61.180957031250045, lng: 7.275976562500006 },
        { lat: 61.16596679687501, lng: 7.17353515625001 },
        { lat: 61.16054687499996, lng: 6.942578125000011 },
        { lat: 61.190380859375004, lng: 6.794335937500023 },
        { lat: 61.20659179687501, lng: 6.657031250000017 },
        { lat: 61.2291015625, lng: 6.610253906250079 },
        { lat: 61.279296875, lng: 6.62587890625008 },
        { lat: 61.28964843749998, lng: 6.599902343750017 },
        { lat: 61.244531250000016, lng: 6.543066406249976 },
        { lat: 61.15458984374999, lng: 6.49257812499999 },
        { lat: 61.13388671875004, lng: 6.383496093750068 },
        { lat: 61.16728515625002, lng: 6.082519531250028 },
        { lat: 61.147607421874994, lng: 5.646777343749989 },
        { lat: 61.10234375000001, lng: 5.451269531250034 },
        { lat: 61.10825195312497, lng: 5.32460937500008 },
        { lat: 61.18754882812505, lng: 5.106738281250017 },
        { lat: 61.250585937500006, lng: 5.021679687500011 },
        { lat: 61.37768554687497, lng: 4.98994140625004 },
        { lat: 61.43359375, lng: 5.002734375000074 },
        { lat: 61.457128906250006, lng: 5.172460937500005 },
        { lat: 61.45546875000002, lng: 5.25830078125 },
        { lat: 61.48549804687499, lng: 5.338671875000017 },
        { lat: 61.505029296875, lng: 5.267578125000028 },
        { lat: 61.543359374999966, lng: 5.167578125000063 },
        { lat: 61.62016601562499, lng: 5.099414062500045 },
        { lat: 61.64521484375004, lng: 4.996679687500063 },
        { lat: 61.71069335937505, lng: 4.927832031249977 },
        { lat: 61.80957031250003, lng: 4.910351562500068 },
        { lat: 61.878320312499994, lng: 4.93007812499999 },
        { lat: 61.90043945312498, lng: 4.985058593750011 },
        { lat: 61.88540039062502, lng: 5.116992187500074 },
        { lat: 61.896923828124976, lng: 5.465332031249972 },
        { lat: 61.82709960937495, lng: 5.793261718749989 },
        { lat: 61.7875, lng: 6.01582031250004 },
        { lat: 61.807421875000045, lng: 6.466699218750051 },
        { lat: 61.869775390625044, lng: 6.730761718750045 },
        { lat: 61.88701171874998, lng: 6.682324218750011 },
        { lat: 61.85097656250002, lng: 6.395898437500023 },
        { lat: 61.85244140624996, lng: 6.131152343749989 },
        { lat: 61.92290039062502, lng: 5.66445312500005 },
        { lat: 61.945605468750045, lng: 5.47304687500005 },
        { lat: 61.935595703125045, lng: 5.266894531250045 },
        { lat: 61.956982421874955, lng: 5.159570312500051 },
        { lat: 62.02666015625001, lng: 5.096484375000074 },
        { lat: 62.15991210937499, lng: 5.143164062500063 },
        { lat: 62.188671874999976, lng: 5.240917968750011 },
        { lat: 62.15390625, lng: 5.293847656250051 },
        { lat: 62.151708984375006, lng: 5.357714843750074 },
        { lat: 62.20737304687498, lng: 5.422363281250028 },
        { lat: 62.239111328125055, lng: 5.484277343750023 },
        { lat: 62.31088867187503, lng: 5.533300781250063 },
        { lat: 62.37890625000003, lng: 5.718164062500051 },
        { lat: 62.38466796875005, lng: 5.79628906250008 },
        { lat: 62.41601562500003, lng: 5.908300781249977 },
        { lat: 62.40712890624999, lng: 5.979785156250074 },
        { lat: 62.37568359374998, lng: 6.025585937500068 },
        { lat: 62.349609375, lng: 6.083496093750057 },
        { lat: 62.35278320312503, lng: 6.208984375000056 },
        { lat: 62.407275390625045, lng: 6.580078125000057 },
        { lat: 62.42329101562501, lng: 6.620019531250023 },
        { lat: 62.46806640624999, lng: 6.692382812500028 },
        { lat: 62.448095703125, lng: 6.457128906250063 },
        { lat: 62.416308593750024, lng: 6.261718750000057 },
        { lat: 62.40747070312497, lng: 6.136132812500051 },
        { lat: 62.447167968749994, lng: 6.118457031250074 },
        { lat: 62.482421874999964, lng: 6.164746093750011 },
        { lat: 62.519921874999966, lng: 6.2375 },
        { lat: 62.583837890625034, lng: 6.272851562499994 },
        { lat: 62.61113281249999, lng: 6.352929687500051 },
        { lat: 62.60966796875004, lng: 6.439453125000028 },
        { lat: 62.62128906250001, lng: 6.61835937500004 },
        { lat: 62.63789062500003, lng: 6.744628906250028 },
        { lat: 62.62675781249999, lng: 6.961132812500068 },
        { lat: 62.602294921874964, lng: 7.283789062499976 },
        { lat: 62.54282226562503, lng: 7.491796875 },
        { lat: 62.54819335937506, lng: 7.570117187500045 },
        { lat: 62.56401367187499, lng: 7.653125 },
        { lat: 62.585595703125016, lng: 7.690722656250016 },
        { lat: 62.610302734375004, lng: 7.527441406250063 },
        { lat: 62.64550781249997, lng: 7.518164062500033 },
        { lat: 62.672070312499976, lng: 7.538378906250075 },
        { lat: 62.72099609374999, lng: 7.804687500000057 },
        { lat: 62.731835937499994, lng: 8.095507812500074 },
        { lat: 62.77124023437503, lng: 8.045507812500006 },
        { lat: 62.71176757812498, lng: 7.408398437500068 },
        { lat: 62.75234374999999, lng: 7.242089843750023 },
        { lat: 62.75200195312501, lng: 7.110839843750028 },
        { lat: 62.72880859374999, lng: 7.02490234375 },
        { lat: 62.70073242187504, lng: 6.779980468750011 },
        { lat: 62.72070312500003, lng: 6.734960937500006 },
        { lat: 62.789648437500034, lng: 6.781542968750073 },
        { lat: 62.90273437499999, lng: 6.928222656250028 },
        { lat: 62.93046875000004, lng: 6.940429687500028 },
        { lat: 62.957666015624994, lng: 7.00849609375004 },
        { lat: 63.02329101562503, lng: 7.389062500000022 },
        { lat: 63.09951171875002, lng: 7.571875 },
        { lat: 63.10917968750005, lng: 7.654296875000056 },
        { lat: 63.103857421875006, lng: 7.73603515625001 },
        { lat: 63.11279296874997, lng: 7.860351562500028 },
        { lat: 63.090966796874966, lng: 8.100585937500028 },
        { lat: 62.99550781249996, lng: 8.211132812500011 },
        { lat: 62.96552734374998, lng: 8.310546875 },
        { lat: 62.84624023437501, lng: 8.623144531250006 },
        { lat: 62.88056640625001, lng: 8.609179687499989 },
        { lat: 63.04218749999998, lng: 8.33857421875004 },
        { lat: 63.08217773437505, lng: 8.235156250000015 },
        { lat: 63.161523437500044, lng: 8.158007812500017 },
        { lat: 63.236523437499955, lng: 8.18447265625008 },
        { lat: 63.28657226562502, lng: 8.271484375000028 },
        { lat: 63.313378906249966, lng: 8.580175781250034 },
        { lat: 63.34233398437501, lng: 8.635546875000045 },
        { lat: 63.39208984375003, lng: 8.64101562499999 },
        { lat: 63.426123046875034, lng: 8.59375 },
        { lat: 63.42416992187498, lng: 8.48017578125001 },
        { lat: 63.445263671875004, lng: 8.386523437500017 },
        { lat: 63.49887695312503, lng: 8.360742187500023 },
        { lat: 63.53510742187504, lng: 8.398144531249983 },
        { lat: 63.60117187499998, lng: 8.576171875000028 },
        { lat: 63.62260742187502, lng: 8.673632812500074 },
        { lat: 63.64589843750005, lng: 8.842382812500006 },
        { lat: 63.59365234374996, lng: 9.135839843750004 },
        { lat: 63.56625976562497, lng: 9.158105468750023 },
        { lat: 63.500390624999966, lng: 9.075878906250038 },
        { lat: 63.46342773437498, lng: 9.08417968750004 },
        { lat: 63.45932617187504, lng: 9.156054687500045 },
        { lat: 63.57036132812502, lng: 9.32363281250008 },
        { lat: 63.58569335937502, lng: 9.520703125000068 },
        { lat: 63.609570312500004, lng: 9.602246093750068 },
        { lat: 63.62456054687504, lng: 9.696875 },
        { lat: 63.52416992187502, lng: 9.83222656250004 },
        { lat: 63.492041015625055, lng: 9.891503906250023 },
        { lat: 63.478857421875034, lng: 9.936035156250055 },
        { lat: 63.39526367187506, lng: 9.97919921875004 },
        { lat: 63.39082031250004, lng: 10.020996093750028 },
        { lat: 63.43271484375003, lng: 10.08056640625 },
        { lat: 63.45478515625001, lng: 10.188574218750063 },
        { lat: 63.46933593750003, lng: 10.340039062500011 },
        { lat: 63.447216796874976, lng: 10.590917968750063 },
        { lat: 63.463574218750004, lng: 10.704492187500023 },
        { lat: 63.46127929687501, lng: 10.76015625000008 },
        { lat: 63.53632812500001, lng: 10.70673828125004 },
        { lat: 63.55800781249999, lng: 10.673632812500045 },
        { lat: 63.625, lng: 10.725292968750068 },
        { lat: 63.65117187500004, lng: 10.779199218750051 },
        { lat: 63.698193359374955, lng: 10.952539062500023 },
        { lat: 63.71918945312495, lng: 11.11787109375004 },
        { lat: 63.763818359374994, lng: 11.225781250000068 },
        { lat: 63.804833984374994, lng: 11.370703125000032 },
        { lat: 63.837695312500045, lng: 11.347949218750017 },
        { lat: 63.87573242187497, lng: 11.307617187500057 },
        { lat: 63.878125, lng: 11.213867187500057 },
        { lat: 63.898876953124976, lng: 11.175585937500074 },
        { lat: 63.948193359374976, lng: 11.294628906250066 },
        { lat: 64.00297851562505, lng: 11.457617187500063 },
        { lat: 64.02451171875, lng: 11.429199218750028 },
        { lat: 64.04887695312499, lng: 11.306640625000027 },
        { lat: 64.03051757812496, lng: 11.213574218750068 },
        { lat: 63.988134765625034, lng: 11.075195312500028 },
        { lat: 63.92109374999998, lng: 10.91425781250004 },
        { lat: 63.9015625, lng: 10.966699218750051 },
        { lat: 63.845214843749964, lng: 11.047265625000023 },
        { lat: 63.770214843749955, lng: 10.934863281250045 },
        { lat: 63.571044921874964, lng: 10.339160156250017 },
        { lat: 63.51269531250001, lng: 10.055078125000051 },
        { lat: 63.52177734375007, lng: 9.924023437499983 },
        { lat: 63.576220703125045, lng: 9.892773437500011 },
        { lat: 63.61650390625001, lng: 9.832324218750045 },
        { lat: 63.699511718750045, lng: 9.767480468750078 },
        { lat: 63.697314453125045, lng: 9.6572265625 },
        { lat: 63.67895507812503, lng: 9.594628906250023 },
        { lat: 63.70615234374998, lng: 9.56728515625005 },
        { lat: 63.794824218749994, lng: 9.614746093750057 },
        { lat: 63.864892578124994, lng: 9.708007812500028 },
        { lat: 63.917822265625006, lng: 9.86445312500004 },
        { lat: 63.98173828124999, lng: 9.939453125000028 },
        { lat: 64.08315429687504, lng: 10.009960937500011 },
        { lat: 64.17963867187498, lng: 10.236230468749994 },
        { lat: 64.41831054687499, lng: 10.565625 },
        { lat: 64.494482421875, lng: 10.833984375000027 },
        { lat: 64.57773437499998, lng: 10.932324218750068 },
        { lat: 64.61455078125002, lng: 11.090429687500032 },
        { lat: 64.67949218750002, lng: 11.225390624999989 },
        { lat: 64.6859375, lng: 11.331347656249989 },
        { lat: 64.744384765625, lng: 11.523828125000051 },
        { lat: 64.81391601562495, lng: 11.632910156250063 },
        { lat: 64.81826171874997, lng: 11.56171875000004 },
        { lat: 64.77299804687507, lng: 11.392480468750023 },
        { lat: 64.75478515625, lng: 11.296777343750051 },
        { lat: 64.82939453125002, lng: 11.303515625000017 },
        { lat: 64.90590820312497, lng: 11.349902343750044 },
        { lat: 64.975830078125, lng: 11.489355468750032 },
        { lat: 65.178955078125, lng: 12.159667968749998 },
        { lat: 65.14536132812496, lng: 12.226562500000028 },
        { lat: 65.08598632812506, lng: 12.30654296875008 },
        { lat: 65.09941406250005, lng: 12.508398437499977 },
        { lat: 65.21440429687502, lng: 12.738378906250034 },
        { lat: 65.33925781249997, lng: 12.915527343750057 },
        { lat: 65.31748046874998, lng: 12.819824218750028 },
        { lat: 65.26635742187503, lng: 12.715332031250057 },
        { lat: 65.19531250000003, lng: 12.511718750000055 },
        { lat: 65.18408203124996, lng: 12.41757812500006 },
        { lat: 65.19331054687497, lng: 12.363867187500032 },
        { lat: 65.24072265624997, lng: 12.33398437499997 },
        { lat: 65.25610351562499, lng: 12.263378906250066 },
        { lat: 65.24545898437503, lng: 12.199609375000051 },
        { lat: 65.27915039062498, lng: 12.133886718749977 },
        { lat: 65.36235351562505, lng: 12.122167968750004 },
        { lat: 65.48623046874997, lng: 12.20625 },
        { lat: 65.56816406250007, lng: 12.272851562500051 },
        { lat: 65.63017578124999, lng: 12.34482421875006 },
        { lat: 65.80615234375006, lng: 12.627734375000044 },
        { lat: 65.90219726562496, lng: 12.68886718750008 },
        { lat: 65.952880859375, lng: 12.816796875000023 },
        { lat: 65.94160156250001, lng: 12.983007812500032 },
        { lat: 65.95625, lng: 13.033105468750051 },
        { lat: 66.01918945312502, lng: 12.976074218750057 },
        { lat: 66.06909179687497, lng: 12.794921875 },
        { lat: 66.10043945312506, lng: 12.783789062500063 },
        { lat: 66.18276367187505, lng: 13.387109375000051 },
        { lat: 66.17998046875002, lng: 13.674414062500034 },
        { lat: 66.22104492187502, lng: 13.75966796875008 },
        { lat: 66.24736328125005, lng: 13.915820312500015 },
        { lat: 66.29755859374997, lng: 14.034179687500057 },
        { lat: 66.31972656249997, lng: 13.973144531250057 },
        { lat: 66.27358398437497, lng: 13.68134765625004 },
        { lat: 66.251904296875, lng: 13.498925781250078 },
        { lat: 66.25258789062497, lng: 13.416406250000051 },
        { lat: 66.23671875000002, lng: 13.35205078125 },
        { lat: 66.23066406250004, lng: 13.118847656250011 },
        { lat: 66.43081054687502, lng: 13.068164062500074 },
        { lat: 66.53940429687503, lng: 13.104687500000068 },
        { lat: 66.53715820312502, lng: 13.191601562500011 },
        { lat: 66.64082031250001, lng: 13.211425781250028 },
        { lat: 66.70185546875001, lng: 13.311816406250074 },
        { lat: 66.71552734374995, lng: 13.45039062500004 },
        { lat: 66.74165039062504, lng: 13.520214843750068 },
        { lat: 66.79482421875002, lng: 13.62109375 },
        { lat: 66.78247070312499, lng: 13.78798828125008 },
        { lat: 66.79433593750002, lng: 13.959472656250027 },
        { lat: 66.81938476562507, lng: 13.9169921875 },
        { lat: 66.85166015624998, lng: 13.704101562500057 },
        { lat: 66.90708007812496, lng: 13.651562500000011 },
        { lat: 66.93803710937499, lng: 13.726660156250034 },
        { lat: 66.96079101562499, lng: 13.808398437500074 },
        { lat: 66.96489257812505, lng: 13.880175781250045 },
        { lat: 67.07309570312506, lng: 14.022363281250051 },
        { lat: 67.11923828125003, lng: 14.10878906250008 },
        { lat: 67.11123046875002, lng: 14.205566406249972 },
        { lat: 67.15893554687506, lng: 14.34033203125 },
        { lat: 67.14267578125003, lng: 14.472656250000028 },
        { lat: 67.17387695312499, lng: 14.600683593750004 },
        { lat: 67.194482421875, lng: 14.775585937500011 },
        { lat: 67.20244140625002, lng: 15.41572265625004 },
        { lat: 67.24667968749996, lng: 15.434765625000011 },
        { lat: 67.25693359375003, lng: 15.300097656250044 },
        { lat: 67.26831054687503, lng: 14.82441406250001 },
        { lat: 67.26743164062502, lng: 14.581542968750028 },
        { lat: 67.25595703125, lng: 14.479296875000045 },
        { lat: 67.27138671875005, lng: 14.441699218750045 },
        { lat: 67.29785156250003, lng: 14.448339843750063 },
        { lat: 67.33974609375002, lng: 14.53662109375 },
        { lat: 67.38603515625005, lng: 14.578515625000023 },
        { lat: 67.49902343749997, lng: 14.754980468750004 },
        { lat: 67.57426757812502, lng: 14.961914062500055 },
        { lat: 67.555029296875, lng: 15.120507812500051 },
        { lat: 67.48315429687503, lng: 15.289160156250034 },
        { lat: 67.47416992187505, lng: 15.409375 },
        { lat: 67.45092773437503, lng: 15.465332031250028 },
        { lat: 67.35175781249997, lng: 15.55292968750004 },
        { lat: 67.34853515625005, lng: 15.594433593750038 },
        { lat: 67.44384765625, lng: 15.575683593750055 },
        { lat: 67.52138671875, lng: 15.691503906250004 },
        { lat: 67.54282226562499, lng: 15.661328124999983 },
        { lat: 67.514794921875, lng: 15.48730468749997 },
        { lat: 67.54394531249997, lng: 15.35400390625 },
        { lat: 67.6021484375, lng: 15.24873046875004 },
        { lat: 67.65537109375003, lng: 15.218652343750051 },
        { lat: 67.70795898437498, lng: 15.284082031250053 },
        { lat: 67.73442382812505, lng: 15.345800781250006 },
        { lat: 67.76528320312502, lng: 15.303906250000011 },
        { lat: 67.68256835937495, lng: 15.040820312500044 },
        { lat: 67.66333007812506, lng: 14.854687500000066 },
        { lat: 67.67490234375, lng: 14.781347656250034 },
        { lat: 67.749853515625, lng: 14.821093750000044 },
        { lat: 67.80932617187501, lng: 14.798925781250063 },
        { lat: 67.95576171875, lng: 15.0484375 },
        { lat: 67.972705078125, lng: 15.134277343749998 },
        { lat: 67.9609375, lng: 15.274414062500028 },
        { lat: 67.91962890625004, lng: 15.400878906250057 },
        { lat: 67.92622070312495, lng: 15.506640625000017 },
        { lat: 67.94829101562502, lng: 15.621386718750017 },
        { lat: 67.987890625, lng: 15.605761718750044 },
        { lat: 68.00361328125001, lng: 15.356933593750055 },
        { lat: 68.03647460937503, lng: 15.292871093750081 },
        { lat: 68.06875, lng: 15.316015624999977 },
        { lat: 68.10283203125005, lng: 15.486816406250057 },
        { lat: 68.16435546875007, lng: 15.656640625000023 },
        { lat: 68.18217773437503, lng: 15.851269531250066 },
        { lat: 68.22871093750003, lng: 16.007910156250006 },
        { lat: 68.21816406250002, lng: 16.0380859375 },
        { lat: 68.19990234375001, lng: 16.064550781249977 },
        { lat: 68.02734375000003, lng: 16.120800781250068 },
        { lat: 67.88657226562506, lng: 16.2607421875 },
        { lat: 67.88144531249998, lng: 16.312304687500017 },
        { lat: 68.00122070312506, lng: 16.258593750000074 },
        { lat: 68.03564453125006, lng: 16.308691406249977 },
        { lat: 68.06181640625005, lng: 16.372167968750034 },
        { lat: 68.09160156249999, lng: 16.39199218750008 },
        { lat: 68.10175781250001, lng: 16.319238281249994 },
        { lat: 68.14453125000003, lng: 16.259765625000057 },
        { lat: 68.28125, lng: 16.174804687500057 },
        { lat: 68.31674804687502, lng: 16.203808593750008 },
        { lat: 68.38955078125002, lng: 16.387890625000036 },
        { lat: 68.40629882812507, lng: 16.61884765625001 },
        { lat: 68.35527343750005, lng: 16.864941406250068 },
        { lat: 68.35468750000004, lng: 16.95136718750001 },
        { lat: 68.36840820312497, lng: 17.094042968750017 },
        { lat: 68.4103515625, lng: 17.33613281250004 },
        { lat: 68.42631835937505, lng: 17.478515625 },
        { lat: 68.42626953125006, lng: 17.552832031250063 },
        { lat: 68.44746093750001, lng: 17.57119140625005 },
        { lat: 68.46108398437501, lng: 17.50234375000008 },
        { lat: 68.47431640624998, lng: 17.48017578124998 },
        { lat: 68.48193359375003, lng: 17.42617187499999 },
        { lat: 68.45927734375002, lng: 17.202343750000068 },
        { lat: 68.46645507812495, lng: 16.584863281250023 },
        { lat: 68.490673828125, lng: 16.52529296875005 },
        { lat: 68.53256835937503, lng: 16.51435546875004 },
        { lat: 68.59267578125002, lng: 16.579882812500074 },
        { lat: 68.62578125000002, lng: 16.65185546875 },
        { lat: 68.68540039062498, lng: 16.88466796875008 },
        { lat: 68.69345703125003, lng: 17.131152343750045 },
        { lat: 68.799365234375, lng: 17.39082031250001 },
        { lat: 68.87875976562503, lng: 17.490039062500042 },
        { lat: 69.001123046875, lng: 17.54628906250005 },
        { lat: 69.10004882812501, lng: 17.704589843750057 },
        { lat: 69.15629882812499, lng: 18.101464843749994 },
        { lat: 69.18120117187502, lng: 18.117480468750074 },
        { lat: 69.23261718750001, lng: 18.07539062500001 },
        { lat: 69.32524414062505, lng: 18.078710937499977 },
        { lat: 69.43310546875, lng: 18.1875 },
        { lat: 69.47060546875, lng: 18.259765625 },
        { lat: 69.47509765625003, lng: 18.293164062500065 },
        { lat: 69.43984375000002, lng: 18.37871093749999 },
        { lat: 69.36484375000003, lng: 18.48261718750004 },
        { lat: 69.321875, lng: 18.6455078125 },
        { lat: 69.31445312499997, lng: 18.85898437500006 },
        { lat: 69.33559570312501, lng: 18.915917968750023 },
        { lat: 69.37841796875006, lng: 18.75 },
        { lat: 69.434375, lng: 18.62441406250005 },
        { lat: 69.49057617187498, lng: 18.614453125000068 },
        { lat: 69.520361328125, lng: 18.67402343750004 },
        { lat: 69.51704101562494, lng: 18.766601562500057 },
        { lat: 69.52333984375, lng: 18.88281250000003 },
        { lat: 69.56113281250006, lng: 18.99111328125005 },
        { lat: 69.58769531250005, lng: 19.006835937500057 },
        { lat: 69.62373046875, lng: 19.011328125 },
        { lat: 69.66040039062503, lng: 19.038378906250017 },
        { lat: 69.74785156249999, lng: 19.197265625000057 },
        { lat: 69.80473632812505, lng: 19.68701171875 },
        { lat: 69.781640625, lng: 19.722460937500014 },
        { lat: 69.61293945312505, lng: 19.695996093750036 },
        { lat: 69.50380859375002, lng: 19.639746093750034 },
        { lat: 69.42402343750001, lng: 19.64150390625005 },
        { lat: 69.50380859375002, lng: 19.736816406249996 },
        { lat: 69.72211914062498, lng: 19.864648437500023 },
        { lat: 69.824609375, lng: 19.960546875000034 },
        { lat: 69.883447265625, lng: 20.068945312500006 },
        { lat: 69.89672851562503, lng: 20.14638671875005 },
        { lat: 69.92719726562501, lng: 20.22304687500005 },
        { lat: 69.94531249999997, lng: 20.324218750000057 },
        { lat: 69.92192382812502, lng: 20.35517578125004 },
        { lat: 69.86762695312495, lng: 20.38720703125 },
        { lat: 69.67695312500001, lng: 20.33271484375001 },
        { lat: 69.61665039062498, lng: 20.338183593750045 },
        { lat: 69.53583984374995, lng: 20.277148437500045 },
        { lat: 69.35566406250004, lng: 20.04375 },
        { lat: 69.33266601562497, lng: 20.054492187500074 },
        { lat: 69.34121093750002, lng: 20.107226562500074 },
        { lat: 69.37094726562502, lng: 20.197656250000023 },
        { lat: 69.54208984375, lng: 20.48671875000002 },
        { lat: 69.52050781250003, lng: 20.739453124999983 },
        { lat: 69.53452148437506, lng: 20.742578125000023 },
        { lat: 69.58471679687497, lng: 20.661523437500023 },
        { lat: 69.6328125, lng: 20.5625 },
        { lat: 69.69233398437495, lng: 20.532714843750053 },
        { lat: 69.85107421874997, lng: 20.545996093750002 },
        { lat: 69.91391601562496, lng: 20.622070312500057 },
        { lat: 69.90732421874998, lng: 20.840332031250025 },
        { lat: 69.91601562499997, lng: 20.971093750000023 },
        { lat: 69.887451171875, lng: 21.03212890625002 },
        { lat: 69.88950195312498, lng: 21.163085937500057 },
        { lat: 70.00322265625005, lng: 21.253710937500042 },
        { lat: 70.01318359375006, lng: 21.432910156250045 },
        { lat: 69.93803710937502, lng: 21.590234375000048 },
        { lat: 69.887451171875, lng: 21.779589843750074 },
        { lat: 69.81469726562503, lng: 21.931738281250063 },
        { lat: 69.83457031249998, lng: 21.97470703125003 },
        { lat: 70.00424804687499, lng: 21.892578125 },
        { lat: 70.066064453125, lng: 21.802734375 },
        { lat: 70.09819335937503, lng: 21.60781250000008 },
        { lat: 70.17446289062505, lng: 21.400390625 },
        { lat: 70.208251953125, lng: 21.346289062499977 },
        { lat: 70.23339843749997, lng: 21.355761718750045 },
        { lat: 70.25766601562503, lng: 21.53876953125004 },
        { lat: 70.22988281249997, lng: 21.78027343750003 },
        { lat: 70.29335937500002, lng: 21.995507812499994 },
        { lat: 70.27597656250003, lng: 22.054394531250008 },
        { lat: 70.30917968750003, lng: 22.219433593750065 },
        { lat: 70.264501953125, lng: 22.321972656250065 },
        { lat: 70.277734375, lng: 22.384765625 },
        { lat: 70.33759765624995, lng: 22.421191406250042 },
        { lat: 70.374755859375, lng: 22.684570312500057 },
        { lat: 70.34047851562501, lng: 22.851660156249977 },
        { lat: 70.30498046874999, lng: 22.941210937500017 },
        { lat: 70.23676757812504, lng: 22.98281250000005 },
        { lat: 70.10185546874999, lng: 23.046484375000063 },
        { lat: 70.029052734375, lng: 23.17695312500001 },
        { lat: 69.993310546875, lng: 23.25791015625006 },
        { lat: 69.98339843750003, lng: 23.35390625000008 },
        { lat: 70.01977539062497, lng: 23.400195312500017 },
        { lat: 70.06357421875, lng: 23.310253906250068 },
        { lat: 70.10483398437496, lng: 23.28603515625002 },
        { lat: 70.20722656249995, lng: 23.3291015625 },
        { lat: 70.2474609375, lng: 23.37939453125003 },
        { lat: 70.399755859375, lng: 23.661230468750063 },
        { lat: 70.47875976562503, lng: 23.89716796875001 },
        { lat: 70.48535156250006, lng: 24.03847656250002 },
        { lat: 70.66240234375005, lng: 24.28554687500008 },
        { lat: 70.69458007812503, lng: 24.355566406250034 },
        { lat: 70.70200195312503, lng: 24.420019531250034 },
        { lat: 70.74531249999998, lng: 24.40351562500004 },
        { lat: 70.77270507812497, lng: 24.268164062500006 },
        { lat: 70.82631835937497, lng: 24.263476562500017 },
        { lat: 70.89155273437501, lng: 24.441796875000023 },
        { lat: 71.00102539062505, lng: 24.658007812500014 },
        { lat: 71.00844726562502, lng: 24.764746093750006 },
        { lat: 70.97802734374997, lng: 24.83164062500003 },
        { lat: 70.92861328125002, lng: 25.042187500000036 },
        { lat: 70.87202148437495, lng: 25.171191406250014 },
        { lat: 70.84350585937499, lng: 25.264648437500057 },
        { lat: 70.84941406250003, lng: 25.32539062500001 },
        { lat: 70.891943359375, lng: 25.375585937500006 },
        { lat: 70.91186523437499, lng: 25.43593750000005 },
        { lat: 70.90068359375, lng: 25.569824218750057 },
        { lat: 70.87333984375003, lng: 25.649707031250074 },
        { lat: 70.8697265625, lng: 25.711914062500053 },
        { lat: 70.85317382812502, lng: 25.768164062500063 },
        { lat: 70.816796875, lng: 25.78144531250001 },
        { lat: 70.77714843749997, lng: 25.665625 },
        { lat: 70.67197265625006, lng: 25.468261718750053 },
        { lat: 70.55239257812502, lng: 25.273535156250006 },
        { lat: 70.489404296875, lng: 25.209277343750045 },
        { lat: 70.32402343750005, lng: 25.14638671875002 },
        { lat: 70.21821289062498, lng: 24.99423828125003 },
        { lat: 70.14399414062495, lng: 24.982714843749985 },
        { lat: 70.10903320312502, lng: 25.04384765625002 },
        { lat: 70.13647460937503, lng: 25.21181640625005 },
        { lat: 70.23549804687505, lng: 25.418847656250023 },
        { lat: 70.34057617187503, lng: 25.470507812500074 },
        { lat: 70.62539062499997, lng: 25.988085937500014 },
        { lat: 70.78261718750002, lng: 26.230859375000076 },
        { lat: 70.91279296875001, lng: 26.506933593750006 },
        { lat: 70.93974609374999, lng: 26.66132812500004 },
        { lat: 70.85356445312502, lng: 26.733984375 },
        { lat: 70.740966796875, lng: 26.675488281250068 },
        { lat: 70.66914062500001, lng: 26.558203125000063 },
        { lat: 70.63623046874997, lng: 26.644628906250006 },
        { lat: 70.55087890624998, lng: 26.628125 },
        { lat: 70.50346679687502, lng: 26.601171875000034 },
        { lat: 70.45380859375001, lng: 26.583984375 },
        { lat: 70.41000976562496, lng: 26.58505859375003 },
        { lat: 70.42167968750003, lng: 26.666113281250034 },
        { lat: 70.51137695312502, lng: 26.98935546875006 },
        { lat: 70.60844726562499, lng: 27.071289062500057 },
        { lat: 70.68120117187507, lng: 27.14726562500007 },
        { lat: 70.74404296875, lng: 27.18369140625003 },
        { lat: 70.80356445312502, lng: 27.309375 },
        { lat: 70.80400390625005, lng: 27.546484375000063 },
        { lat: 70.827392578125, lng: 27.555664062500057 },
        { lat: 70.91000976562506, lng: 27.26904296875003 },
        { lat: 70.94721679687498, lng: 27.23525390625008 },
        { lat: 70.99672851562504, lng: 27.331640624999977 },
        { lat: 71.09130859375003, lng: 27.597070312500048 },
        { lat: 71.08085937500005, lng: 27.73349609375006 },
        { lat: 71.059375, lng: 27.81503906250006 },
        { lat: 71.04301757812507, lng: 28.141699218750002 },
        { lat: 70.97529296875004, lng: 28.392285156250068 },
        { lat: 70.86943359375005, lng: 28.38271484375008 },
        { lat: 70.82519531249999, lng: 28.326855468750065 },
        { lat: 70.79794921875006, lng: 28.271875 },
        { lat: 70.71757812500002, lng: 27.950976562500045 },
        { lat: 70.6779296875, lng: 27.898046875 },
      ],
      [
        { lat: 71.14208984375, lng: 25.58632812500005 },
        { lat: 71.10385742187503, lng: 25.85351562500003 },
        { lat: 71.104638671875, lng: 25.94501953125001 },
        { lat: 71.033154296875, lng: 26.077636718750025 },
        { lat: 71.03950195312495, lng: 26.146875 },
        { lat: 70.99580078125004, lng: 26.13378906250003 },
        { lat: 70.97509765625, lng: 25.999707031250068 },
        { lat: 70.9625, lng: 25.791308593750074 },
        { lat: 70.95380859375001, lng: 25.76015625000002 },
        { lat: 70.960791015625, lng: 25.582031250000057 },
        { lat: 71.01958007812497, lng: 25.482031250000034 },
        { lat: 71.03413085937504, lng: 25.31494140625 },
        { lat: 71.05297851562506, lng: 25.315234375000074 },
        { lat: 71.09741210937503, lng: 25.423437499999977 },
        { lat: 71.14208984375, lng: 25.58632812500005 },
      ],
      [
        { lat: 70.83916015625002, lng: -8.953564453124983 },
        { lat: 70.83266601562502, lng: -9.045800781249937 },
        { lat: 70.85488281250001, lng: -9.098876953125 },
        { lat: 70.91591796875002, lng: -8.964648437499932 },
        { lat: 71.03066406250002, lng: -8.520800781250017 },
        { lat: 71.14013671875003, lng: -8.343701171874983 },
        { lat: 71.17768554687495, lng: -8.001367187499966 },
        { lat: 71.11689453125001, lng: -7.978808593749989 },
        { lat: 71.04125976562497, lng: -8.002099609374937 },
        { lat: 70.98115234374998, lng: -8.30234375 },
        { lat: 70.94042968750003, lng: -8.635351562499977 },
        { lat: 70.83916015625002, lng: -8.953564453124983 },
      ],
      [
        { lat: 74.39101562500002, lng: 19.219335937500006 },
        { lat: 74.35214843749999, lng: 19.098535156249994 },
        { lat: 74.41064453125003, lng: 18.917578125 },
        { lat: 74.48569335937503, lng: 18.797460937500034 },
        { lat: 74.51416015624997, lng: 18.86123046875008 },
        { lat: 74.51791992187503, lng: 19.182910156250045 },
        { lat: 74.47895507812498, lng: 19.261523437500074 },
        { lat: 74.45673828124998, lng: 19.274707031250017 },
        { lat: 74.39101562500002, lng: 19.219335937500006 },
      ],
      [
        { lat: 78.59570312499997, lng: 21.60810546875004 },
        { lat: 78.57202148437503, lng: 21.74560546874997 },
        { lat: 78.57695312500007, lng: 22.04316406250004 },
        { lat: 78.40766601562495, lng: 22.207324218750074 },
        { lat: 78.22817382812497, lng: 22.29951171875004 },
        { lat: 78.215234375, lng: 22.449316406250002 },
        { lat: 78.23994140624998, lng: 22.734570312500008 },
        { lat: 78.25195312500001, lng: 22.988867187500063 },
        { lat: 78.23862304687498, lng: 23.119238281250063 },
        { lat: 78.18627929687497, lng: 23.351660156250063 },
        { lat: 78.14946289062502, lng: 23.45195312500007 },
        { lat: 78.12050781249995, lng: 23.36464843750005 },
        { lat: 78.08808593750004, lng: 23.151953125000063 },
        { lat: 77.99150390624999, lng: 23.11669921874997 },
        { lat: 77.95786132812498, lng: 23.33056640625003 },
        { lat: 77.87543945312495, lng: 23.683984375000076 },
        { lat: 77.86474609375, lng: 23.883007812500036 },
        { lat: 77.89853515625006, lng: 24.238281250000025 },
        { lat: 77.83442382812495, lng: 24.571484375000068 },
        { lat: 77.756591796875, lng: 24.901855468750057 },
        { lat: 77.65825195312505, lng: 24.12978515625005 },
        { lat: 77.630615234375, lng: 24.06191406250008 },
        { lat: 77.55771484374998, lng: 23.95498046875005 },
        { lat: 77.49775390625004, lng: 23.84121093750005 },
        { lat: 77.46235351562501, lng: 23.736132812500045 },
        { lat: 77.40141601562502, lng: 23.505175781250074 },
        { lat: 77.38032226562498, lng: 23.380859375000053 },
        { lat: 77.38505859374999, lng: 23.101367187500042 },
        { lat: 77.36079101562501, lng: 22.99667968750003 },
        { lat: 77.31137695312498, lng: 22.899511718750063 },
        { lat: 77.27578125000002, lng: 22.80175781250003 },
        { lat: 77.26665039062502, lng: 22.55371093750003 },
        { lat: 77.31591796875003, lng: 22.426953125000065 },
        { lat: 77.33110351562502, lng: 22.46884765625006 },
        { lat: 77.36010742187506, lng: 22.486621093750045 },
        { lat: 77.42934570312502, lng: 22.442480468750034 },
        { lat: 77.500146484375, lng: 22.67890625000004 },
        { lat: 77.53935546875007, lng: 22.732617187500065 },
        { lat: 77.553515625, lng: 22.685351562500045 },
        { lat: 77.54960937500002, lng: 22.62031250000001 },
        { lat: 77.57114257812506, lng: 22.448242187500057 },
        { lat: 77.57011718750002, lng: 22.397265625000045 },
        { lat: 77.52885742187505, lng: 22.25458984375004 },
        { lat: 77.50117187500001, lng: 22.056835937500065 },
        { lat: 77.494140625, lng: 21.85615234375004 },
        { lat: 77.44096679687502, lng: 21.049902343750006 },
        { lat: 77.45966796874998, lng: 20.928125 },
        { lat: 77.56533203125002, lng: 20.873144531250063 },
        { lat: 77.61948242187503, lng: 21.201074218750076 },
        { lat: 77.71093750000003, lng: 21.25146484375003 },
        { lat: 77.77177734374997, lng: 21.33417968750001 },
        { lat: 77.81210937500003, lng: 21.430859375000068 },
        { lat: 77.91606445312499, lng: 21.6083984375 },
        { lat: 77.92353515624998, lng: 21.653125 },
        { lat: 78.00576171874997, lng: 21.210449218750025 },
        { lat: 78.0591796875, lng: 21.035449218750074 },
        { lat: 78.16586914062498, lng: 20.844921875000068 },
        { lat: 78.25214843749998, lng: 20.786425781250074 },
        { lat: 78.32558593750002, lng: 20.528320312500053 },
        { lat: 78.41938476562504, lng: 20.560253906249983 },
        { lat: 78.41201171875002, lng: 20.372753906250068 },
        { lat: 78.47783203125005, lng: 20.227929687500048 },
        { lat: 78.51479492187502, lng: 20.36269531250008 },
        { lat: 78.55673828125003, lng: 21.046875 },
        { lat: 78.59755859375, lng: 21.454785156250068 },
        { lat: 78.59570312499997, lng: 21.60810546875004 },
      ],
      [
        { lat: 78.64892578124997, lng: 26.875976562500057 },
        { lat: 78.64648437500001, lng: 26.729492187500057 },
        { lat: 78.72026367187505, lng: 26.459570312500034 },
        { lat: 78.78432617187502, lng: 26.407714843750057 },
        { lat: 78.81049804687495, lng: 26.455761718750065 },
        { lat: 78.81147460937498, lng: 26.58593750000003 },
        { lat: 78.723974609375, lng: 26.788769531250068 },
        { lat: 78.69750976562503, lng: 27.007617187500045 },
        { lat: 78.64892578124997, lng: 26.875976562500057 },
      ],
      [
        { lat: 78.610693359375, lng: 11.250292968750015 },
        { lat: 78.54169921874998, lng: 11.261718750000027 },
        { lat: 78.54858398437497, lng: 11.42421875 },
        { lat: 78.47509765624999, lng: 11.616308593750063 },
        { lat: 78.43608398437505, lng: 11.82568359375 },
        { lat: 78.40932617187502, lng: 11.884863281250063 },
        { lat: 78.37490234375002, lng: 11.929394531250068 },
        { lat: 78.30561523437504, lng: 12.056152343750057 },
        { lat: 78.232568359375, lng: 12.116406250000068 },
        { lat: 78.224853515625, lng: 11.96503906250004 },
        { lat: 78.32900390625, lng: 11.75654296875004 },
        { lat: 78.38823242187499, lng: 11.586523437500032 },
        { lat: 78.43876953125007, lng: 11.372460937500023 },
        { lat: 78.44125976562503, lng: 11.19921875 },
        { lat: 78.46328125, lng: 11.121289062500011 },
        { lat: 78.64472656250001, lng: 10.840625 },
        { lat: 78.68652343749999, lng: 10.788867187500074 },
        { lat: 78.75385742187495, lng: 10.628417968750057 },
        { lat: 78.8375, lng: 10.557617187500028 },
        { lat: 78.90292968750003, lng: 10.55820312500006 },
        { lat: 78.8875, lng: 10.77285156250008 },
        { lat: 78.84638671874997, lng: 10.960839843750023 },
        { lat: 78.75336914062504, lng: 11.123925781250021 },
        { lat: 78.724462890625, lng: 11.152929687500063 },
        { lat: 78.68603515625, lng: 11.078222656250034 },
        { lat: 78.64057617187498, lng: 11.15498046875004 },
        { lat: 78.610693359375, lng: 11.250292968750015 },
      ],
      [
        { lat: 78.91206054687504, lng: 29.047070312500068 },
        { lat: 78.90576171875, lng: 29.345410156250097 },
        { lat: 78.92163085937503, lng: 29.645117187500063 },
        { lat: 78.90473632812494, lng: 29.69667968750005 },
        { lat: 78.85209960937497, lng: 29.31054687499997 },
        { lat: 78.88007812500001, lng: 28.881152343750014 },
        { lat: 78.88720703125003, lng: 28.494531250000023 },
        { lat: 78.8287109375, lng: 28.037890625000074 },
        { lat: 78.85214843749999, lng: 27.88906250000005 },
        { lat: 78.908447265625, lng: 28.120996093750048 },
        { lat: 78.92705078125007, lng: 28.374023437499968 },
        { lat: 78.96142578124997, lng: 28.41474609375001 },
        { lat: 78.96733398437502, lng: 28.511132812500023 },
        { lat: 78.97084960937502, lng: 28.845214843750057 },
        { lat: 78.91206054687504, lng: 29.047070312500068 },
      ],
      [
        { lat: 79.90673828125, lng: 16.78671875000003 },
        { lat: 79.90478515625003, lng: 16.838476562500006 },
        { lat: 79.91542968749998, lng: 16.888964843750074 },
        { lat: 79.94345703125, lng: 16.92558593750007 },
        { lat: 79.95893554687498, lng: 16.96640625000003 },
        { lat: 79.940771484375, lng: 17.219433593750068 },
        { lat: 79.88466796875002, lng: 17.578222656249977 },
        { lat: 79.85703125, lng: 17.68476562500001 },
        { lat: 79.80004882812501, lng: 17.834570312499977 },
        { lat: 79.70424804687505, lng: 17.956152343750063 },
        { lat: 79.63500976562497, lng: 17.85976562500005 },
        { lat: 79.56953124999995, lng: 17.732617187500008 },
        { lat: 79.53334960937505, lng: 17.6875 },
        { lat: 79.48134765625002, lng: 17.733984375 },
        { lat: 79.43076171875, lng: 17.715039062500068 },
        { lat: 79.38593750000004, lng: 17.66875 },
        { lat: 79.43706054687505, lng: 17.86103515625004 },
        { lat: 79.60058593749997, lng: 18.272070312500034 },
        { lat: 79.61069335937498, lng: 18.333300781250074 },
        { lat: 79.60517578125001, lng: 18.39736328125008 },
        { lat: 79.57158203125002, lng: 18.58144531250008 },
        { lat: 79.48818359375, lng: 18.7484375 },
        { lat: 79.46059570312497, lng: 18.785253906250034 },
        { lat: 79.42666015624997, lng: 18.815234375000017 },
        { lat: 79.38476562499997, lng: 18.83242187500005 },
        { lat: 79.33666992187503, lng: 18.822949218749983 },
        { lat: 79.30317382812495, lng: 18.807421875000017 },
        { lat: 79.28149414062497, lng: 18.720019531250074 },
        { lat: 79.26171875000001, lng: 18.677832031250006 },
        { lat: 79.26025390625, lng: 18.772265625000074 },
        { lat: 79.23427734375005, lng: 18.88007812500001 },
        { lat: 79.179150390625, lng: 18.97900390625 },
        { lat: 79.15703125000002, lng: 19.089453125000034 },
        { lat: 79.17568359375, lng: 19.490234375000057 },
        { lat: 79.14682617187498, lng: 19.750878906250023 },
        { lat: 79.05620117187499, lng: 19.893554687500057 },
        { lat: 79.07670898437502, lng: 20.11376953124997 },
        { lat: 79.125, lng: 20.11445312500004 },
        { lat: 79.14565429687502, lng: 20.162695312500006 },
        { lat: 79.12924804687506, lng: 20.458203125000068 },
        { lat: 79.10664062499998, lng: 20.61103515625004 },
        { lat: 79.05913085937507, lng: 20.767187500000063 },
        { lat: 78.98139648437495, lng: 20.50068359375001 },
        { lat: 78.90668945312501, lng: 20.7203125 },
        { lat: 78.85263671875, lng: 21.089648437500017 },
        { lat: 78.79584960937498, lng: 21.312207031250068 },
        { lat: 78.77202148437502, lng: 21.35253906250003 },
        { lat: 78.74042968749998, lng: 21.38876953125003 },
        { lat: 78.69941406249995, lng: 21.243945312500017 },
        { lat: 78.67626953125004, lng: 21.096289062500034 },
        { lat: 78.67231445312495, lng: 20.72480468750004 },
        { lat: 78.64326171874998, lng: 20.387011718750045 },
        { lat: 78.62270507812497, lng: 19.76875 },
        { lat: 78.60957031249995, lng: 19.67675781250003 },
        { lat: 78.59785156249998, lng: 19.65498046875004 },
        { lat: 78.562158203125, lng: 19.61855468750008 },
        { lat: 78.47978515624999, lng: 19.380664062500017 },
        { lat: 78.37939453125006, lng: 19.150488281250034 },
        { lat: 78.3189453125, lng: 19.055664062500057 },
        { lat: 78.23422851562506, lng: 18.98378906250008 },
        { lat: 78.18247070312498, lng: 18.957617187499977 },
        { lat: 78.13227539062498, lng: 19.00869140625008 },
        { lat: 78.08149414062501, lng: 18.9951171875 },
        { lat: 78.04169921875001, lng: 18.822070312500074 },
        { lat: 78.04008789062502, lng: 18.712304687500023 },
        { lat: 78.04799804687505, lng: 18.574609375000023 },
        { lat: 78.025048828125, lng: 18.439257812500074 },
        { lat: 77.99057617187498, lng: 18.4306640625 },
        { lat: 77.94204101562502, lng: 18.438671875000036 },
        { lat: 77.79394531249997, lng: 18.40400390625001 },
        { lat: 77.68227539062497, lng: 18.361914062500034 },
        { lat: 77.57856445312498, lng: 18.29873046875005 },
        { lat: 77.52260742187502, lng: 18.227929687500023 },
        { lat: 77.50703124999995, lng: 18.13740234375004 },
        { lat: 77.49677734375001, lng: 17.84707031250005 },
        { lat: 77.39936523437495, lng: 17.623339843750017 },
        { lat: 77.22524414062502, lng: 17.442480468750034 },
        { lat: 77.15688476562505, lng: 17.34863281250003 },
        { lat: 77.04892578124998, lng: 17.15253906250004 },
        { lat: 77.01064453125, lng: 17.18789062500005 },
        { lat: 76.96918945312498, lng: 17.249023437500057 },
        { lat: 76.89492187499997, lng: 17.141992187500023 },
        { lat: 76.81162109375002, lng: 16.976660156250006 },
        { lat: 76.77939453125006, lng: 16.979882812500023 },
        { lat: 76.72036132812502, lng: 17.03554687499999 },
        { lat: 76.65898437500005, lng: 17.06269531250004 },
        { lat: 76.60615234375001, lng: 16.935156250000063 },
        { lat: 76.57929687499994, lng: 16.700488281250045 },
        { lat: 76.60932617187495, lng: 16.46191406250003 },
        { lat: 76.64477539062497, lng: 16.345800781250006 },
        { lat: 76.70151367187499, lng: 16.238085937500074 },
        { lat: 76.73852539062497, lng: 16.123828125000074 },
        { lat: 76.76074218749997, lng: 16.004492187500006 },
        { lat: 76.88642578125001, lng: 15.546777343750021 },
        { lat: 77.085107421875, lng: 15.124218749999983 },
        { lat: 77.16235351562499, lng: 14.73847656250001 },
        { lat: 77.1990234375, lng: 14.486914062500006 },
        { lat: 77.23447265625003, lng: 14.365820312500032 },
        { lat: 77.28212890624997, lng: 14.24755859375 },
        { lat: 77.33559570312502, lng: 14.145312500000045 },
        { lat: 77.40322265625005, lng: 14.050390624999977 },
        { lat: 77.44521484375, lng: 14.004199218750074 },
        { lat: 77.50820312500002, lng: 13.995703125000034 },
        { lat: 77.545166015625, lng: 14.026074218750011 },
        { lat: 77.56411132812505, lng: 14.07128906249997 },
        { lat: 77.57963867187502, lng: 14.377636718750038 },
        { lat: 77.57084960937499, lng: 14.48779296875 },
        { lat: 77.53793945312503, lng: 14.596289062500004 },
        { lat: 77.525048828125, lng: 14.69501953125004 },
        { lat: 77.68881835937506, lng: 14.920800781250023 },
        { lat: 77.78247070312503, lng: 16.205957031250023 },
        { lat: 77.79868164062506, lng: 16.619140625 },
        { lat: 77.79770507812503, lng: 17.033300781250006 },
        { lat: 77.841943359375, lng: 16.96875 },
        { lat: 77.89799804687505, lng: 16.91406250000003 },
        { lat: 77.91157226562495, lng: 16.852929687500023 },
        { lat: 77.88022460937506, lng: 16.539648437500063 },
        { lat: 77.84711914062497, lng: 16.060058593750057 },
        { lat: 77.84707031249995, lng: 15.82636718750004 },
        { lat: 77.86914062500003, lng: 15.58535156250005 },
        { lat: 77.85698242187502, lng: 15.344824218750004 },
        { lat: 77.80903320312504, lng: 15.096875 },
        { lat: 77.77866210937506, lng: 14.846875 },
        { lat: 77.76645507812506, lng: 14.60390625000005 },
        { lat: 77.77138671875, lng: 14.089941406250063 },
        { lat: 77.796240234375, lng: 13.9625 },
        { lat: 77.85380859374999, lng: 13.791113281250004 },
        { lat: 77.88330078124997, lng: 13.749609375 },
        { lat: 77.91943359375004, lng: 13.714160156250045 },
        { lat: 78.028125, lng: 13.68056640625005 },
        { lat: 78.05761718750004, lng: 13.717675781250051 },
        { lat: 78.07460937500005, lng: 13.770117187500006 },
        { lat: 78.08500976562502, lng: 13.824023437500044 },
        { lat: 78.08554687500006, lng: 13.936914062500051 },
        { lat: 78.06684570312498, lng: 14.04775390625008 },
        { lat: 78.00507812500001, lng: 14.307226562500006 },
        { lat: 78.07138671874999, lng: 14.248144531250034 },
        { lat: 78.151220703125, lng: 14.994726562500004 },
        { lat: 78.220947265625, lng: 15.34140625 },
        { lat: 78.23271484375002, lng: 15.519433593750053 },
        { lat: 78.22758789062505, lng: 15.698046875000019 },
        { lat: 78.26469726562503, lng: 15.658691406249998 },
        { lat: 78.2990234375, lng: 15.657128906250023 },
        { lat: 78.32705078125005, lng: 15.783886718750011 },
        { lat: 78.33911132812503, lng: 15.87539062500008 },
        { lat: 78.35288085937498, lng: 16.15029296875005 },
        { lat: 78.35043945312499, lng: 16.776953125 },
        { lat: 78.36938476562497, lng: 17.00292968750003 },
        { lat: 78.41713867187502, lng: 17.171972656250006 },
        { lat: 78.40048828124999, lng: 16.991796875000063 },
        { lat: 78.39726562500005, lng: 16.811230468750036 },
        { lat: 78.40717773437504, lng: 16.72656250000003 },
        { lat: 78.448876953125, lng: 16.535351562500068 },
        { lat: 78.50356445312502, lng: 16.44863281250008 },
        { lat: 78.612890625, lng: 16.696582031250042 },
        { lat: 78.66362304687505, lng: 16.78261718750008 },
        { lat: 78.65629882812507, lng: 16.53046875000004 },
        { lat: 78.638525390625, lng: 16.44628906250003 },
        { lat: 78.53813476562507, lng: 16.157519531250014 },
        { lat: 78.493017578125, lng: 15.94404296875004 },
        { lat: 78.47133789062505, lng: 15.680664062500028 },
        { lat: 78.47324218749998, lng: 15.417382812500023 },
        { lat: 78.48754882812497, lng: 15.35996093750006 },
        { lat: 78.55410156250002, lng: 15.279394531249977 },
        { lat: 78.5890625, lng: 15.254199218750017 },
        { lat: 78.60830078124997, lng: 15.264941406250074 },
        { lat: 78.66313476562505, lng: 15.34833984375001 },
        { lat: 78.72119140625006, lng: 15.391601562500027 },
        { lat: 78.77119140625, lng: 15.384179687500021 },
        { lat: 78.78120117187501, lng: 15.322753906250027 },
        { lat: 78.73232421875002, lng: 15.225292968750068 },
        { lat: 78.66425781250001, lng: 15.137304687500004 },
        { lat: 78.63012695312497, lng: 15.01630859375004 },
        { lat: 78.639453125, lng: 14.891796875000068 },
        { lat: 78.66557617187499, lng: 14.838671874999989 },
        { lat: 78.70556640624997, lng: 14.792382812500081 },
        { lat: 78.720947265625, lng: 14.74355468750008 },
        { lat: 78.720947265625, lng: 14.689257812500017 },
        { lat: 78.70498046875001, lng: 14.577636718750028 },
        { lat: 78.67539062500003, lng: 14.467187500000078 },
        { lat: 78.63051757812497, lng: 14.505273437500021 },
        { lat: 78.58056640625, lng: 14.515429687500044 },
        { lat: 78.54091796875, lng: 14.467773437500027 },
        { lat: 78.49248046874999, lng: 14.431835937500068 },
        { lat: 78.46196289062499, lng: 14.545605468750068 },
        { lat: 78.414599609375, lng: 14.638281250000034 },
        { lat: 78.39238281250005, lng: 14.499511718749998 },
        { lat: 78.35991210937499, lng: 14.363281250000059 },
        { lat: 78.30986328125002, lng: 14.23828125 },
        { lat: 78.27089843749997, lng: 14.110449218750063 },
        { lat: 78.26674804687502, lng: 13.907617187500023 },
        { lat: 78.24516601562506, lng: 13.654980468750068 },
        { lat: 78.2375, lng: 13.150195312499987 },
        { lat: 78.30107421874999, lng: 12.91279296875004 },
        { lat: 78.33125, lng: 12.869531250000023 },
        { lat: 78.35146484375005, lng: 12.822167968750051 },
        { lat: 78.384765625, lng: 12.664648437500034 },
        { lat: 78.482958984375, lng: 12.434765625000011 },
        { lat: 78.59467773437504, lng: 12.257910156250034 },
        { lat: 78.60551757812502, lng: 12.13828125 },
        { lat: 78.64238281249999, lng: 11.961718750000072 },
        { lat: 78.67421875, lng: 11.865527343750017 },
        { lat: 78.71640625000006, lng: 11.77382812500008 },
        { lat: 78.766259765625, lng: 11.746289062500068 },
        { lat: 78.81166992187502, lng: 11.755175781250017 },
        { lat: 78.83188476562502, lng: 11.86103515625001 },
        { lat: 78.88295898437495, lng: 11.611035156250038 },
        { lat: 78.95039062500004, lng: 11.365429687500011 },
        { lat: 78.972998046875, lng: 11.456152343750032 },
        { lat: 78.98295898437499, lng: 11.547558593749981 },
        { lat: 78.90449218750001, lng: 12.274902343750028 },
        { lat: 78.91425781249995, lng: 12.323437500000068 },
        { lat: 78.95322265624998, lng: 12.4033203125 },
        { lat: 78.96635742187499, lng: 12.375 },
        { lat: 78.97534179687506, lng: 12.253125 },
        { lat: 78.97509765625, lng: 12.08730468750008 },
        { lat: 78.98315429687503, lng: 12.04580078125008 },
        { lat: 79.02529296875002, lng: 11.981835937499994 },
        { lat: 79.07724609375003, lng: 11.925683593750023 },
        { lat: 79.11186523437506, lng: 11.901953124999977 },
        { lat: 79.15234375000006, lng: 11.892773437500068 },
        { lat: 79.21308593749998, lng: 12.016113281250057 },
        { lat: 79.26752929687498, lng: 12.083984375000027 },
        { lat: 79.29267578124995, lng: 11.978320312499987 },
        { lat: 79.291162109375, lng: 11.679296875 },
        { lat: 79.28349609375005, lng: 11.579785156250068 },
        { lat: 79.20527343749998, lng: 11.616406250000066 },
        { lat: 79.15126953125, lng: 11.521191406250038 },
        { lat: 79.10913085937503, lng: 11.338867187500028 },
        { lat: 79.12963867187503, lng: 11.208105468750032 },
        { lat: 79.23295898437503, lng: 11.107226562500074 },
        { lat: 79.30488281249995, lng: 10.975390625000045 },
        { lat: 79.35019531250003, lng: 10.925781250000057 },
        { lat: 79.4154296875, lng: 10.888085937500023 },
        { lat: 79.46284179687498, lng: 10.834375 },
        { lat: 79.52016601562502, lng: 10.737597656250017 },
        { lat: 79.55551757812503, lng: 10.725 },
        { lat: 79.58164062500002, lng: 10.737011718750068 },
        { lat: 79.64091796875002, lng: 10.810742187500068 },
        { lat: 79.69033203124997, lng: 10.754589843750011 },
        { lat: 79.73359374999997, lng: 10.686230468750011 },
        { lat: 79.75825195312504, lng: 10.682128906249998 },
        { lat: 79.78867187499999, lng: 10.746386718750017 },
        { lat: 79.79877929687503, lng: 10.804003906250045 },
        { lat: 79.79658203125001, lng: 10.86591796875004 },
        { lat: 79.76030273437502, lng: 11.049609375000072 },
        { lat: 79.71699218749998, lng: 11.150390625 },
        { lat: 79.72045898437497, lng: 11.185253906249981 },
        { lat: 79.78486328125004, lng: 11.250585937500063 },
        { lat: 79.79941406249998, lng: 11.343652343750023 },
        { lat: 79.82060546875003, lng: 11.702343750000011 },
        { lat: 79.737548828125, lng: 12.101757812500011 },
        { lat: 79.71909179687502, lng: 12.205175781250034 },
        { lat: 79.713134765625, lng: 12.287792968750068 },
        { lat: 79.75, lng: 12.245214843750006 },
        { lat: 79.797900390625, lng: 12.219140625000023 },
        { lat: 79.81596679687507, lng: 12.279980468749981 },
        { lat: 79.77324218750007, lng: 12.602441406250051 },
        { lat: 79.77578124999995, lng: 12.753515625 },
        { lat: 79.83173828124998, lng: 13.107519531250006 },
        { lat: 79.860986328125, lng: 13.69287109374997 },
        { lat: 79.81694335937499, lng: 13.914160156250034 },
        { lat: 79.79340820312501, lng: 13.925683593750078 },
        { lat: 79.76171875000003, lng: 13.921093750000011 },
        { lat: 79.75219726562501, lng: 13.907031249999989 },
        { lat: 79.71528320312497, lng: 13.777539062500011 },
        { lat: 79.68515624999998, lng: 13.03925781250004 },
        { lat: 79.56948242187502, lng: 12.555371093750068 },
        { lat: 79.58808593750001, lng: 13.215136718749989 },
        { lat: 79.57480468750005, lng: 13.333789062500017 },
        { lat: 79.48076171874999, lng: 13.383593750000044 },
        { lat: 79.4708984375, lng: 13.431640625000057 },
        { lat: 79.45722656249998, lng: 13.601269531250068 },
        { lat: 79.42915039062495, lng: 13.716210937500023 },
        { lat: 79.37568359374998, lng: 13.833691406250068 },
        { lat: 79.33964843750002, lng: 13.957226562500011 },
        { lat: 79.34414062500005, lng: 14.029589843750017 },
        { lat: 79.38310546874999, lng: 14.05585937500004 },
        { lat: 79.42929687499998, lng: 14.026367187500057 },
        { lat: 79.48193359375006, lng: 14.011132812500078 },
        { lat: 79.53867187499998, lng: 14.019824218750072 },
        { lat: 79.58564453124995, lng: 14.039843750000045 },
        { lat: 79.61870117187502, lng: 14.17841796875004 },
        { lat: 79.72597656250002, lng: 14.379785156250023 },
        { lat: 79.79873046875002, lng: 14.59365234375008 },
        { lat: 79.76640625000002, lng: 14.831835937500015 },
        { lat: 79.67534179687502, lng: 15.05234375 },
        { lat: 79.54545898437502, lng: 15.251269531250045 },
        { lat: 79.406787109375, lng: 15.443945312500032 },
        { lat: 79.23486328124997, lng: 15.660156250000028 },
        { lat: 79.17426757812498, lng: 15.764062500000051 },
        { lat: 79.159912109375, lng: 15.858496093750004 },
        { lat: 78.98105468750006, lng: 16.294531250000034 },
        { lat: 78.97612304687502, lng: 16.34375 },
        { lat: 79.11210937500002, lng: 16.253515625000034 },
        { lat: 79.34238281250003, lng: 16.027539062499983 },
        { lat: 79.51923828125001, lng: 15.875097656250034 },
        { lat: 79.58686523437501, lng: 15.840722656250051 },
        { lat: 79.68183593750001, lng: 15.81611328125001 },
        { lat: 79.70903320312505, lng: 15.82578125 },
        { lat: 79.73359374999997, lng: 15.845117187500051 },
        { lat: 79.83510742187497, lng: 15.955761718750038 },
        { lat: 79.88442382812497, lng: 16.100195312500063 },
        { lat: 79.95395507812503, lng: 16.056640625000057 },
        { lat: 80.00732421874997, lng: 16.093847656250002 },
        { lat: 80.04946289062501, lng: 16.24570312500003 },
        { lat: 80.05258789062503, lng: 16.38662109375005 },
        { lat: 80.02050781249999, lng: 16.524023437500063 },
        { lat: 79.90673828125, lng: 16.78671875000003 },
      ],
      [
        { lat: 80.11914062499999, lng: 32.52597656250006 },
        { lat: 80.08144531249997, lng: 31.577636718750025 },
        { lat: 80.10791015625003, lng: 31.48193359374997 },
        { lat: 80.21796874999998, lng: 33.01914062500006 },
        { lat: 80.22871093749995, lng: 33.098632812499964 },
        { lat: 80.24233398437497, lng: 33.38398437500004 },
        { lat: 80.21743164062497, lng: 33.62929687499999 },
        { lat: 80.19814453125002, lng: 33.556640624999964 },
        { lat: 80.11914062499999, lng: 32.52597656250006 },
      ],
      [
        { lat: 80.30092773437502, lng: 18.74160156250002 },
        { lat: 80.24560546875003, lng: 18.525 },
        { lat: 80.28818359374998, lng: 18.162207031250034 },
        { lat: 80.331787109375, lng: 18.205566406249968 },
        { lat: 80.35834960937498, lng: 18.29169921875004 },
        { lat: 80.34833984374998, lng: 18.519335937500045 },
        { lat: 80.30092773437502, lng: 18.74160156250002 },
      ],
      [
        { lat: 80.24995117187501, lng: 20.897851562500023 },
        { lat: 80.23881835937505, lng: 20.99843750000008 },
        { lat: 80.242919921875, lng: 21.549218750000023 },
        { lat: 80.21845703124998, lng: 21.654882812500063 },
        { lat: 80.1591796875, lng: 21.69667968750005 },
        { lat: 80.13876953125, lng: 21.780664062500023 },
        { lat: 80.13247070312497, lng: 21.897753906250074 },
        { lat: 80.059716796875, lng: 22.19023437500007 },
        { lat: 80.04921874999995, lng: 22.28974609374998 },
        { lat: 80.08964843750005, lng: 22.37636718750005 },
        { lat: 80.19028320312503, lng: 22.44267578125007 },
        { lat: 80.308349609375, lng: 22.44619140625008 },
        { lat: 80.36552734375002, lng: 22.417871093750076 },
        { lat: 80.40224609375005, lng: 22.450781250000034 },
        { lat: 80.41645507812501, lng: 22.54882812500003 },
        { lat: 80.41264648437505, lng: 22.672070312499983 },
        { lat: 80.4330078125, lng: 22.792578125000034 },
        { lat: 80.46899414062497, lng: 22.896875 },
        { lat: 80.473974609375, lng: 23.00800781250004 },
        { lat: 80.44667968750005, lng: 23.25136718750005 },
        { lat: 80.42524414062501, lng: 23.315429687500057 },
        { lat: 80.38085937500003, lng: 23.250097656250063 },
        { lat: 80.31762695312503, lng: 23.224609375000025 },
        { lat: 80.18696289062498, lng: 23.114550781250074 },
        { lat: 80.17885742187502, lng: 23.353320312500045 },
        { lat: 80.20654296874997, lng: 23.68798828125003 },
        { lat: 80.24438476562503, lng: 23.77294921875 },
        { lat: 80.30458984375005, lng: 23.952929687500074 },
        { lat: 80.295166015625, lng: 24.14296875000008 },
        { lat: 80.303125, lng: 24.234082031250068 },
        { lat: 80.32929687500001, lng: 24.28017578125005 },
        { lat: 80.36040039062503, lng: 24.29755859375004 },
        { lat: 80.35517578124995, lng: 24.402636718750045 },
        { lat: 80.295166015625, lng: 24.546679687500074 },
        { lat: 80.28583984374994, lng: 24.61367187500005 },
        { lat: 80.30131835937499, lng: 24.736328124999968 },
        { lat: 80.30068359374997, lng: 24.785937500000045 },
        { lat: 80.27666015625005, lng: 24.907031250000045 },
        { lat: 80.23310546874995, lng: 25.47128906250006 },
        { lat: 80.20976562499999, lng: 25.666894531250023 },
        { lat: 80.18803710937502, lng: 25.751171875000068 },
        { lat: 80.17514648437505, lng: 25.83632812500008 },
        { lat: 80.17548828125004, lng: 26.43671875000001 },
        { lat: 80.16000976562498, lng: 26.86083984375 },
        { lat: 80.12548828124997, lng: 27.01718750000006 },
        { lat: 80.05922851562497, lng: 27.148339843750023 },
        { lat: 79.90659179687506, lng: 27.19863281250008 },
        { lat: 79.86538085937498, lng: 27.079882812500045 },
        { lat: 79.67744140625001, lng: 26.22109375000005 },
        { lat: 79.61704101562503, lng: 26.00585937499997 },
        { lat: 79.56137695312498, lng: 25.902050781250065 },
        { lat: 79.43974609375007, lng: 25.726367187500074 },
        { lat: 79.40302734374995, lng: 25.641210937500034 },
        { lat: 79.34506835937505, lng: 25.23906249999999 },
        { lat: 79.33886718750003, lng: 25.145117187500034 },
        { lat: 79.36723632812505, lng: 24.842871093750006 },
        { lat: 79.36459960937502, lng: 24.750585937500034 },
        { lat: 79.301611328125, lng: 24.383398437500034 },
        { lat: 79.26347656250005, lng: 24.2568359375 },
        { lat: 79.21547851562502, lng: 24.132910156250063 },
        { lat: 79.19428710937498, lng: 23.94775390625 },
        { lat: 79.20561523437506, lng: 23.758789062500057 },
        { lat: 79.23066406250001, lng: 22.903710937500023 },
        { lat: 79.26435546874995, lng: 22.789160156250034 },
        { lat: 79.32905273437497, lng: 22.69570312500002 },
        { lat: 79.41186523437497, lng: 22.865527343750045 },
        { lat: 79.38105468750001, lng: 21.911425781250017 },
        { lat: 79.39785156249997, lng: 20.861132812500017 },
        { lat: 79.40952148437503, lng: 20.805566406250048 },
        { lat: 79.44150390624998, lng: 20.760839843750006 },
        { lat: 79.46337890625, lng: 20.399511718750006 },
        { lat: 79.489599609375, lng: 20.128222656250074 },
        { lat: 79.53378906250002, lng: 19.90019531250007 },
        { lat: 79.591162109375, lng: 19.674609375000045 },
        { lat: 79.61796875000005, lng: 19.746679687500063 },
        { lat: 79.63364257812503, lng: 19.821093750000045 },
        { lat: 79.64023437500006, lng: 20.014843750000065 },
        { lat: 79.63227539062504, lng: 20.187109375 },
        { lat: 79.63276367187495, lng: 20.493457031250074 },
        { lat: 79.69052734375, lng: 20.56484375000005 },
        { lat: 79.70717773437502, lng: 20.686816406250014 },
        { lat: 79.748583984375, lng: 20.784082031250023 },
        { lat: 79.774658203125, lng: 20.460742187500045 },
        { lat: 79.778564453125, lng: 20.123437500000076 },
        { lat: 79.74418945312502, lng: 19.89863281250004 },
        { lat: 79.72861328125003, lng: 19.63808593750005 },
        { lat: 79.72656249999997, lng: 19.4 },
        { lat: 79.736328125, lng: 18.94208984375001 },
        { lat: 79.7607421875, lng: 18.725 },
        { lat: 79.82451171875002, lng: 18.428027343750017 },
        { lat: 79.859716796875, lng: 18.32470703125 },
        { lat: 79.88735351562505, lng: 18.284765625000034 },
        { lat: 79.92919921875003, lng: 18.25537109375 },
        { lat: 79.96669921875005, lng: 18.594628906250023 },
        { lat: 79.99624023437502, lng: 18.72646484375005 },
        { lat: 80.03662109375, lng: 18.855957031250053 },
        { lat: 80.05957031250004, lng: 18.343847656250006 },
        { lat: 80.09340820312502, lng: 18.129492187500034 },
        { lat: 80.14311523437502, lng: 17.91689453125005 },
        { lat: 80.17114257812503, lng: 18.089453125000034 },
        { lat: 80.19350585937497, lng: 18.77929687499997 },
        { lat: 80.17480468749997, lng: 18.961914062500057 },
        { lat: 80.138671875, lng: 19.14296875000008 },
        { lat: 80.11640624999998, lng: 19.343359375000063 },
        { lat: 80.16323242187502, lng: 19.537109375 },
        { lat: 80.18540039062499, lng: 19.354687500000068 },
        { lat: 80.26323242187505, lng: 19.19140625 },
        { lat: 80.30185546875002, lng: 19.156933593750008 },
        { lat: 80.33154296875003, lng: 19.178320312500006 },
        { lat: 80.33598632812505, lng: 19.263769531250006 },
        { lat: 80.323095703125, lng: 19.327441406250017 },
        { lat: 80.25, lng: 19.568457031250006 },
        { lat: 80.227197265625, lng: 19.751074218749977 },
        { lat: 80.29472656249999, lng: 19.80224609375003 },
        { lat: 80.32680664062505, lng: 19.81035156250007 },
        { lat: 80.35336914062503, lng: 19.777148437500045 },
        { lat: 80.40234374999997, lng: 19.691308593750076 },
        { lat: 80.462548828125, lng: 19.614355468750034 },
        { lat: 80.47783203124999, lng: 19.733300781249994 },
        { lat: 80.47119140624997, lng: 19.85117187500003 },
        { lat: 80.42998046875, lng: 20.104296875000017 },
        { lat: 80.40092773437505, lng: 20.359375 },
        { lat: 80.37163085937502, lng: 20.475878906250045 },
        { lat: 80.298681640625, lng: 20.693457031250034 },
        { lat: 80.24995117187501, lng: 20.897851562500023 },
      ],
    ],
  },
  {
    code: "PL",
    coordinates: [
      [
        { lat: 54.4591796875, lng: 19.604394531250023 },
        { lat: 54.447070312499996, lng: 19.64423828125001 },
        { lat: 54.433984375, lng: 19.92431640625 },
        { lat: 54.420751953125, lng: 20.20820312500001 },
        { lat: 54.406640625, lng: 20.66474609375001 },
        { lat: 54.391796875, lng: 21.140527343750023 },
        { lat: 54.37646484374999, lng: 21.634179687500023 },
        { lat: 54.35986328125, lng: 22.16845703125 },
        { lat: 54.35009765625, lng: 22.731835937500023 },
        { lat: 54.356787109375, lng: 22.766210937500006 },
        { lat: 54.39580078124999, lng: 22.82373046875 },
        { lat: 54.39052734375, lng: 22.893945312500023 },
        { lat: 54.366357421875, lng: 22.97675781250001 },
        { lat: 54.34833984375, lng: 23.015527343750023 },
        { lat: 54.327880859375, lng: 23.031933593750008 },
        { lat: 54.30419921875, lng: 23.04218750000001 },
        { lat: 54.299462890625, lng: 23.0875 },
        { lat: 54.2814453125, lng: 23.17031250000002 },
        { lat: 54.24033203125, lng: 23.282324218750006 },
        { lat: 54.200488281249996, lng: 23.370117187499996 },
        { lat: 54.14345703125, lng: 23.453613281249996 },
        { lat: 54.07900390625, lng: 23.481347656250023 },
        { lat: 54.00595703125, lng: 23.483007812500006 },
        { lat: 53.95893554687499, lng: 23.477636718750006 },
        { lat: 53.939794921875, lng: 23.484667968750017 },
        { lat: 53.59921875, lng: 23.598925781250017 },
        { lat: 53.270947265625, lng: 23.78925781250001 },
        { lat: 53.112109375, lng: 23.859179687500017 },
        { lat: 53.0275390625, lng: 23.887109375000023 },
        { lat: 52.9048828125, lng: 23.909375 },
        { lat: 52.81875, lng: 23.916308593750017 },
        { lat: 52.770263671875, lng: 23.915429687500023 },
        { lat: 52.70361328125, lng: 23.901269531250023 },
        { lat: 52.664208984375, lng: 23.844726562499996 },
        { lat: 52.5515625, lng: 23.479589843750006 },
        { lat: 52.5162109375, lng: 23.410937500000017 },
        { lat: 52.428369140624994, lng: 23.303320312500006 },
        { lat: 52.337890625, lng: 23.2041015625 },
        { lat: 52.306982421875, lng: 23.18125 },
        { lat: 52.28662109375, lng: 23.175097656250017 },
        { lat: 52.25693359375, lng: 23.19697265625001 },
        { lat: 52.208447265625, lng: 23.327148437499996 },
        { lat: 52.16953125, lng: 23.458398437500023 },
        { lat: 52.140380859375, lng: 23.50117187500001 },
        { lat: 52.103076171874996, lng: 23.597949218750017 },
        { lat: 52.069580078125, lng: 23.63330078125 },
        { lat: 52.040380859375, lng: 23.652441406250006 },
        { lat: 51.972998046875, lng: 23.65107421875001 },
        { lat: 51.879785156249994, lng: 23.607421875 },
        { lat: 51.80932617187499, lng: 23.62568359375001 },
        { lat: 51.76240234375, lng: 23.581347656250017 },
        { lat: 51.710253906249996, lng: 23.54482421875002 },
        { lat: 51.618896484375, lng: 23.539648437500006 },
        { lat: 51.51791992187499, lng: 23.605273437500017 },
        { lat: 51.448974609375, lng: 23.65888671875001 },
        { lat: 51.39492187499999, lng: 23.6796875 },
        { lat: 51.352490234375, lng: 23.657617187500023 },
        { lat: 51.31005859374999, lng: 23.66445312500002 },
        { lat: 51.26513671875, lng: 23.712207031250017 },
        { lat: 51.126220703125, lng: 23.863476562500008 },
        { lat: 50.992529296875, lng: 23.938085937500006 },
        { lat: 50.9404296875, lng: 23.985742187500023 },
        { lat: 50.87275390625, lng: 24.095800781250002 },
        { lat: 50.84497070312499, lng: 24.105761718750017 },
        { lat: 50.81953125, lng: 24.061621093750002 },
        { lat: 50.816162109375, lng: 24.025976562500006 },
        { lat: 50.809375, lng: 23.9970703125 },
        { lat: 50.785595703125, lng: 23.978417968750023 },
        { lat: 50.76015625, lng: 24.007324218749996 },
        { lat: 50.722802734374994, lng: 24.046289062500023 },
        { lat: 50.61704101562499, lng: 24.0947265625 },
        { lat: 50.53046875, lng: 24.089941406250006 },
        { lat: 50.50844726562499, lng: 24.052636718750023 },
        { lat: 50.45703125, lng: 24.004980468750006 },
        { lat: 50.410058593749994, lng: 23.97265625 },
        { lat: 50.37734375, lng: 23.711718750000017 },
        { lat: 50.327050781249994, lng: 23.649023437500002 },
        { lat: 50.229833984375, lng: 23.506152343750017 },
        { lat: 50.17392578125, lng: 23.408593750000023 },
        { lat: 50.0728515625, lng: 23.264453125000017 },
        { lat: 49.899072265624994, lng: 23.03632812500001 },
        { lat: 49.82636718749999, lng: 22.952246093750006 },
        { lat: 49.766259765624994, lng: 22.890722656250006 },
        { lat: 49.606201171875, lng: 22.706152343750006 },
        { lat: 49.539013671875, lng: 22.649414062499996 },
        { lat: 49.483691406249996, lng: 22.66064453125 },
        { lat: 49.353808593749996, lng: 22.71992187500001 },
        { lat: 49.295166015625, lng: 22.732421875 },
        { lat: 49.240966796875, lng: 22.721972656250017 },
        { lat: 49.192724609375, lng: 22.70234375 },
        { lat: 49.171191406249996, lng: 22.705664062500006 },
        { lat: 49.13623046875, lng: 22.760156250000023 },
        { lat: 49.08125, lng: 22.847070312500023 },
        { lat: 49.062744140625, lng: 22.85205078125 },
        { lat: 49.03891601562499, lng: 22.839746093750023 },
        { lat: 49.020751953125, lng: 22.80976562500001 },
        { lat: 49.03994140624999, lng: 22.701269531250006 },
        { lat: 49.077197265624996, lng: 22.579980468750023 },
        { lat: 49.07270507812499, lng: 22.538671875 },
        { lat: 49.081298828125, lng: 22.473046875000023 },
        { lat: 49.153222656249994, lng: 22.202539062500023 },
        { lat: 49.209521484374996, lng: 22.020117187500006 },
        { lat: 49.24609375, lng: 22.00214843750001 },
        { lat: 49.299072265625, lng: 21.967675781250023 },
        { lat: 49.34345703125, lng: 21.890136718749996 },
        { lat: 49.38193359375, lng: 21.71210937500001 },
        { lat: 49.411962890625, lng: 21.6396484375 },
        { lat: 49.428759765624996, lng: 21.35048828125002 },
        { lat: 49.429443359375, lng: 21.225 },
        { lat: 49.417041015624996, lng: 21.136132812500023 },
        { lat: 49.418261718749996, lng: 21.079394531250017 },
        { lat: 49.33984375, lng: 21.00117187500001 },
        { lat: 49.31708984375, lng: 20.947265625 },
        { lat: 49.314697265625, lng: 20.868457031250014 },
        { lat: 49.328662109374996, lng: 20.79951171875001 },
        { lat: 49.369921875, lng: 20.729003906249996 },
        { lat: 49.39169921875, lng: 20.616113281250023 },
        { lat: 49.381201171875, lng: 20.534570312500023 },
        { lat: 49.39018554687499, lng: 20.474511718750023 },
        { lat: 49.392333984375, lng: 20.422656250000017 },
        { lat: 49.384082031249996, lng: 20.404687500000023 },
        { lat: 49.38525390624999, lng: 20.362988281250008 },
        { lat: 49.365527343749996, lng: 20.302539062500017 },
        { lat: 49.337646484375, lng: 20.23652343750001 },
        { lat: 49.31640625, lng: 20.163671875 },
        { lat: 49.27075195312499, lng: 20.10761718750001 },
        { lat: 49.181298828124994, lng: 20.057617187499996 },
        { lat: 49.22138671874999, lng: 19.916113281250006 },
        { lat: 49.204003906249994, lng: 19.868945312500017 },
        { lat: 49.192333984375, lng: 19.80224609375 },
        { lat: 49.204394531249996, lng: 19.756640625000014 },
        { lat: 49.235205078125, lng: 19.767382812500014 },
        { lat: 49.269970703125, lng: 19.787988281250023 },
        { lat: 49.3185546875, lng: 19.787011718750023 },
        { lat: 49.37216796875, lng: 19.77392578125 },
        { lat: 49.389599609375, lng: 19.730078125 },
        { lat: 49.396044921874996, lng: 19.664160156250006 },
        { lat: 49.40664062499999, lng: 19.630273437500023 },
        { lat: 49.424365234374996, lng: 19.62666015625001 },
        { lat: 49.447119140625, lng: 19.593066406250017 },
        { lat: 49.504785156249994, lng: 19.534765625 },
        { lat: 49.5763671875, lng: 19.47968750000001 },
        { lat: 49.59770507812499, lng: 19.44160156250001 },
        { lat: 49.563623046874994, lng: 19.386230468749996 },
        { lat: 49.524853515625, lng: 19.30234375 },
        { lat: 49.51142578125, lng: 19.25019531250001 },
        { lat: 49.4, lng: 19.1494140625 },
        { lat: 49.396240234375, lng: 18.968359375 },
        { lat: 49.44829101562499, lng: 18.95722656250001 },
        { lat: 49.498291015625, lng: 18.93818359375001 },
        { lat: 49.510791015624996, lng: 18.83222656250001 },
        { lat: 49.54013671875, lng: 18.82929687500001 },
        { lat: 49.613720703125, lng: 18.806933593750017 },
        { lat: 49.7578125, lng: 18.594628906250023 },
        { lat: 49.81791992187499, lng: 18.56884765625 },
        { lat: 49.841113281249996, lng: 18.5771484375 },
        { lat: 49.879345703125, lng: 18.562402343750023 },
        { lat: 49.902392578124996, lng: 18.516210937500006 },
        { lat: 49.929833984374994, lng: 18.348437500000017 },
        { lat: 49.9140625, lng: 18.305273437500006 },
        { lat: 49.93027343749999, lng: 18.26630859375001 },
        { lat: 49.964746093749994, lng: 18.205273437500008 },
        { lat: 49.9927734375, lng: 18.09921875 },
        { lat: 50.007275390625, lng: 18.087695312500017 },
        { lat: 50.03193359375, lng: 18.04951171875001 },
        { lat: 50.03525390625, lng: 18.028320312499996 },
        { lat: 50.020263671875, lng: 18.0146484375 },
        { lat: 49.999072265624996, lng: 17.983789062500023 },
        { lat: 49.97226562499999, lng: 17.874804687500014 },
        { lat: 49.983300781249994, lng: 17.83125 },
        { lat: 50.006591796875, lng: 17.79169921875001 },
        { lat: 50.05678710937499, lng: 17.74658203125 },
        { lat: 50.10078125, lng: 17.68105468750002 },
        { lat: 50.11640625, lng: 17.627050781250002 },
        { lat: 50.139501953125, lng: 17.596289062500006 },
        { lat: 50.157470703125, lng: 17.58935546875 },
        { lat: 50.1935546875, lng: 17.709277343750017 },
        { lat: 50.230761718749996, lng: 17.735449218750006 },
        { lat: 50.298632812499996, lng: 17.720117187500023 },
        { lat: 50.307177734374996, lng: 17.702246093750006 },
        { lat: 50.284228515624996, lng: 17.654687500000023 },
        { lat: 50.2640625, lng: 17.554589843750023 },
        { lat: 50.25478515624999, lng: 17.462304687500023 },
        { lat: 50.25478515624999, lng: 17.41523437500001 },
        { lat: 50.378320312499994, lng: 17.151953125 },
        { lat: 50.41611328125, lng: 16.980761718750017 },
        { lat: 50.427050781249996, lng: 16.88007812500001 },
        { lat: 50.414501953125, lng: 16.869140625 },
        { lat: 50.34521484375, lng: 16.91474609375001 },
        { lat: 50.25971679687499, lng: 16.99335937500001 },
        { lat: 50.2369140625, lng: 16.989648437500023 },
        { lat: 50.20195312499999, lng: 16.895312500000014 },
        { lat: 50.18671875, lng: 16.841796875 },
        { lat: 50.15703125, lng: 16.778613281250017 },
        { lat: 50.116064453125, lng: 16.72529296875001 },
        { lat: 50.097460937499996, lng: 16.679101562500023 },
        { lat: 50.1021484375, lng: 16.63916015625 },
        { lat: 50.121923828125, lng: 16.5966796875 },
        { lat: 50.248388671875, lng: 16.487597656250017 },
        { lat: 50.34521484375, lng: 16.350488281250023 },
        { lat: 50.36689453125, lng: 16.334179687500008 },
        { lat: 50.371875, lng: 16.291308593750017 },
        { lat: 50.394091796874996, lng: 16.230761718750017 },
        { lat: 50.423730468749994, lng: 16.210351562500023 },
        { lat: 50.4546875, lng: 16.24072265625 },
        { lat: 50.4830078125, lng: 16.282519531250017 },
        { lat: 50.50048828125, lng: 16.35664062500001 },
        { lat: 50.516894531249996, lng: 16.379101562500008 },
        { lat: 50.541650390624994, lng: 16.39228515625001 },
        { lat: 50.57363281249999, lng: 16.419726562500017 },
        { lat: 50.58515625, lng: 16.4125 },
        { lat: 50.621386718749996, lng: 16.359960937500006 },
        { lat: 50.655615234375, lng: 16.2822265625 },
        { lat: 50.629931640624996, lng: 16.06640625 },
        { lat: 50.611621093749996, lng: 16.007226562500023 },
        { lat: 50.63544921875, lng: 15.973828125000011 },
        { lat: 50.670263671875, lng: 15.948535156250017 },
        { lat: 50.67690429687499, lng: 15.893945312500023 },
        { lat: 50.70869140625, lng: 15.819238281250023 },
        { lat: 50.739697265625, lng: 15.730566406250006 },
        { lat: 50.748876953125, lng: 15.643945312500023 },
        { lat: 50.79384765624999, lng: 15.463964843750006 },
        { lat: 50.796289062499994, lng: 15.394628906250007 },
        { lat: 50.811767578125, lng: 15.354394531250021 },
        { lat: 50.845751953124996, lng: 15.312597656250004 },
        { lat: 50.88300781249999, lng: 15.277050781250011 },
        { lat: 50.958544921874996, lng: 15.258593750000017 },
        { lat: 50.99287109375, lng: 15.125976562499998 },
        { lat: 51.01435546875, lng: 14.99375 },
        { lat: 51.00341796875, lng: 14.984472656250006 },
        { lat: 50.92724609375, lng: 14.989941406250011 },
        { lat: 50.88657226562499, lng: 14.982910156249998 },
        { lat: 50.861376953124996, lng: 14.895800781250015 },
        { lat: 50.858984375, lng: 14.809375 },
        { lat: 50.871630859374996, lng: 14.814257812500015 },
        { lat: 51.008740234375, lng: 14.91748046875 },
        { lat: 51.09511718749999, lng: 14.963867187499998 },
        { lat: 51.252734375, lng: 15.016601562499998 },
        { lat: 51.3771484375, lng: 14.953125 },
        { lat: 51.435351562499996, lng: 14.935546875 },
        { lat: 51.46333007812499, lng: 14.905957031250013 },
        { lat: 51.523876953125, lng: 14.724707031250004 },
        { lat: 51.544921875, lng: 14.7109375 },
        { lat: 51.62714843749999, lng: 14.738671875000025 },
        { lat: 51.66171875, lng: 14.724902343750015 },
        { lat: 51.698193359375, lng: 14.681347656250013 },
        { lat: 51.770800781249996, lng: 14.623925781250023 },
        { lat: 51.832373046875, lng: 14.601660156250006 },
        { lat: 51.904833984374996, lng: 14.674902343750006 },
        { lat: 51.95800781249999, lng: 14.69296875 },
        { lat: 52.030859375, lng: 14.724804687500011 },
        { lat: 52.07080078124999, lng: 14.748144531250004 },
        { lat: 52.081835937499996, lng: 14.752539062500004 },
        { lat: 52.11020507812499, lng: 14.704589843749998 },
        { lat: 52.150048828124994, lng: 14.692382812500002 },
        { lat: 52.20747070312499, lng: 14.705371093750015 },
        { lat: 52.25, lng: 14.679882812500011 },
        { lat: 52.277636718749996, lng: 14.615625 },
        { lat: 52.31416015625, lng: 14.57392578125001 },
        { lat: 52.35966796874999, lng: 14.554589843750021 },
        { lat: 52.431103515625, lng: 14.569726562500025 },
        { lat: 52.528515625, lng: 14.619433593750015 },
        { lat: 52.64560546875, lng: 14.514062500000021 },
        { lat: 52.782519531249996, lng: 14.253710937500015 },
        { lat: 52.878222656249996, lng: 14.128613281250011 },
        { lat: 52.932861328125, lng: 14.138867187500011 },
        { lat: 52.98232421875, lng: 14.193652343750017 },
        { lat: 53.0267578125, lng: 14.293164062500011 },
        { lat: 53.10556640624999, lng: 14.368554687500021 },
        { lat: 53.199023437499996, lng: 14.410937500000017 },
        { lat: 53.216748046875, lng: 14.412304687500011 },
        { lat: 53.28349609374999, lng: 14.41455078125 },
        { lat: 53.556445312499996, lng: 14.298730468750023 },
        { lat: 53.624755859375, lng: 14.279882812500004 },
        { lat: 53.70712890625, lng: 14.266113281249998 },
        { lat: 53.729638671875, lng: 14.258886718750006 },
        { lat: 53.671875, lng: 14.487597656250019 },
        { lat: 53.63935546874999, lng: 14.58349609375 },
        { lat: 53.67587890625, lng: 14.571582031250017 },
        { lat: 53.70732421874999, lng: 14.552148437500021 },
        { lat: 53.75351562499999, lng: 14.56494140625 },
        { lat: 53.823193359375, lng: 14.558398437500017 },
        { lat: 53.858740234375, lng: 14.350878906250017 },
        { lat: 53.870751953125, lng: 14.213671875000017 },
        { lat: 53.91904296875, lng: 14.1982421875 },
        { lat: 53.950341796875, lng: 14.21142578125 },
        { lat: 53.931933593749996, lng: 14.249316406250017 },
        { lat: 53.92470703125, lng: 14.384179687500023 },
        { lat: 54.018310546875, lng: 14.715722656250023 },
        { lat: 54.139892578125, lng: 15.288378906250017 },
        { lat: 54.253955078124996, lng: 15.9 },
        { lat: 54.266357421875, lng: 16.042773437500017 },
        { lat: 54.290380859375, lng: 16.186328125000017 },
        { lat: 54.333056640624996, lng: 16.239355468750006 },
        { lat: 54.36162109374999, lng: 16.292285156250014 },
        { lat: 54.436865234375, lng: 16.375585937500006 },
        { lat: 54.55380859375, lng: 16.55976562500001 },
        { lat: 54.59638671875, lng: 16.88544921875001 },
        { lat: 54.65185546875, lng: 17.00703125000001 },
        { lat: 54.729541015624996, lng: 17.26191406250001 },
        { lat: 54.816699218749996, lng: 17.84296875000001 },
        { lat: 54.83583984375, lng: 18.085644531250008 },
        { lat: 54.838183593749996, lng: 18.32343750000001 },
        { lat: 54.76943359375, lng: 18.53515625 },
        { lat: 54.6845703125, lng: 18.75927734375 },
        { lat: 54.633349609374996, lng: 18.799609375000017 },
        { lat: 54.665283203125, lng: 18.678320312500006 },
        { lat: 54.741503906249996, lng: 18.5015625 },
        { lat: 54.7447265625, lng: 18.436230468750008 },
        { lat: 54.512890625, lng: 18.58710937500001 },
        { lat: 54.430908203125, lng: 18.66962890625001 },
        { lat: 54.369580078125, lng: 18.836425781249996 },
        { lat: 54.34892578124999, lng: 18.97626953125001 },
        { lat: 54.386083984375, lng: 19.407128906250023 },
        { lat: 54.434619140624996, lng: 19.56015625 },
        { lat: 54.4591796875, lng: 19.604394531250023 },
      ],
    ],
  },
  {
    code: "PT",
    coordinates: [
      [
        { lat: 32.868603515624976, lng: -17.190869140624926 },
        { lat: 32.81586914062498, lng: -17.054492187499932 },
        { lat: 32.84140625000003, lng: -16.92919921875 },
        { lat: 32.77353515624998, lng: -16.77397460937499 },
        { lat: 32.75800781250001, lng: -16.693261718749966 },
        { lat: 32.70971679687503, lng: -16.765283203124994 },
        { lat: 32.648291015625034, lng: -16.837402343749943 },
        { lat: 32.66279296874998, lng: -17.018261718749926 },
        { lat: 32.721875, lng: -17.17119140624999 },
        { lat: 32.76684570312503, lng: -17.226025390624983 },
        { lat: 32.80737304687503, lng: -17.241015625000017 },
        { lat: 32.868603515624976, lng: -17.190869140624926 },
      ],
      [
        { lat: 36.95996093750003, lng: -25.02734375 },
        { lat: 36.94155273437502, lng: -25.03154296874999 },
        { lat: 36.948876953124994, lng: -25.08837890625 },
        { lat: 36.94335937500003, lng: -25.15991210937503 },
        { lat: 36.99653320312501, lng: -25.198388671874934 },
        { lat: 37.01855468749997, lng: -25.163525390624955 },
        { lat: 37.02402343750003, lng: -25.082910156249966 },
        { lat: 37.00019531249998, lng: -25.044335937499994 },
        { lat: 36.95996093750003, lng: -25.02734375 },
      ],
      [
        { lat: 37.84091796875, lng: -25.648974609374985 },
        { lat: 37.83403320312502, lng: -25.585498046874932 },
        { lat: 37.84863281249997, lng: -25.2666015625 },
        { lat: 37.837890625, lng: -25.18193359374996 },
        { lat: 37.764355468749955, lng: -25.19072265624999 },
        { lat: 37.73500976562502, lng: -25.251123046874937 },
        { lat: 37.71533203125, lng: -25.43901367187493 },
        { lat: 37.76289062500001, lng: -25.73447265624992 },
        { lat: 37.82607421874999, lng: -25.833691406249983 },
        { lat: 37.872412109375034, lng: -25.847851562499923 },
        { lat: 37.89404296875, lng: -25.84589843749998 },
        { lat: 37.9111328125, lng: -25.783740234375014 },
        { lat: 37.84091796875, lng: -25.648974609374985 },
      ],
      [
        { lat: 38.45268554687502, lng: -28.14726562499996 },
        { lat: 38.412744140624966, lng: -28.064794921875034 },
        { lat: 38.404150390625006, lng: -28.18974609374999 },
        { lat: 38.384667968750016, lng: -28.231152343749983 },
        { lat: 38.41289062500002, lng: -28.33242187500002 },
        { lat: 38.40864257812504, lng: -28.45449218750002 },
        { lat: 38.462548828124994, lng: -28.53115234374999 },
        { lat: 38.51855468750003, lng: -28.54882812499997 },
        { lat: 38.553027343750045, lng: -28.51025390625 },
        { lat: 38.55336914062502, lng: -28.402148437500014 },
        { lat: 38.45268554687502, lng: -28.14726562499996 },
      ],
      [
        { lat: 38.525, lng: -28.641308593749983 },
        { lat: 38.52236328125002, lng: -28.74384765624998 },
        { lat: 38.5984375, lng: -28.842041015625 },
        { lat: 38.638476562500045, lng: -28.697753906249996 },
        { lat: 38.614062500000045, lng: -28.65541992187499 },
        { lat: 38.58632812499999, lng: -28.624218749999955 },
        { lat: 38.55073242187501, lng: -28.605810546875034 },
        { lat: 38.525, lng: -28.641308593749983 },
      ],
      [
        { lat: 38.55561523437504, lng: -27.778466796874966 },
        { lat: 38.54355468749998, lng: -27.825878906249923 },
        { lat: 38.62055664062504, lng: -28.09233398437496 },
        { lat: 38.65537109375003, lng: -28.18725585937503 },
        { lat: 38.74389648437503, lng: -28.310644531250002 },
        { lat: 38.63632812500006, lng: -27.962646484375 },
        { lat: 38.55561523437504, lng: -27.778466796874966 },
      ],
      [
        { lat: 38.643457031249994, lng: -27.075244140624957 },
        { lat: 38.63403320312503, lng: -27.09531249999995 },
        { lat: 38.66103515625002, lng: -27.30283203124995 },
        { lat: 38.69785156250006, lng: -27.361914062500006 },
        { lat: 38.765820312499955, lng: -27.38593750000001 },
        { lat: 38.788964843749966, lng: -27.35102539062501 },
        { lat: 38.80268554687501, lng: -27.259667968749966 },
        { lat: 38.78984374999995, lng: -27.127001953125017 },
        { lat: 38.7412109375, lng: -27.04194335937501 },
        { lat: 38.67890625000001, lng: -27.041992187500025 },
        { lat: 38.643457031249994, lng: -27.075244140624957 },
      ],
      [
        { lat: 39.40693359375001, lng: -31.137109374999937 },
        { lat: 39.35893554687502, lng: -31.18134765624998 },
        { lat: 39.3759765625, lng: -31.25761718749999 },
        { lat: 39.39409179687496, lng: -31.282958984375 },
        { lat: 39.49677734375001, lng: -31.26083984375003 },
        { lat: 39.520849609375034, lng: -31.199853515624937 },
        { lat: 39.479443359374955, lng: -31.13862304687498 },
        { lat: 39.40693359375001, lng: -31.137109374999937 },
      ],
      [
        { lat: 41.819970703124994, lng: -8.173535156249955 },
        { lat: 41.81196289062498, lng: -8.152490234374937 },
        { lat: 41.81420898437499, lng: -8.094433593749926 },
        { lat: 41.851904296875034, lng: -7.990966796874972 },
        { lat: 41.883642578125, lng: -7.920849609374982 },
        { lat: 41.87055664062501, lng: -7.896386718749994 },
        { lat: 41.88847656250002, lng: -7.693066406249955 },
        { lat: 41.87397460937498, lng: -7.644677734374937 },
        { lat: 41.85795898437502, lng: -7.612597656249988 },
        { lat: 41.83598632812498, lng: -7.512597656249966 },
        { lat: 41.83369140624995, lng: -7.40361328124996 },
        { lat: 41.864404296874994, lng: -7.268554687499972 },
        { lat: 41.89526367187497, lng: -7.209619140624966 },
        { lat: 41.92939453125001, lng: -7.198339843749978 },
        { lat: 41.95522460937502, lng: -7.195361328124989 },
        { lat: 41.9716796875, lng: -7.177929687499983 },
        { lat: 41.98115234374998, lng: -7.147119140625023 },
        { lat: 41.964208984375006, lng: -7.09912109375 },
        { lat: 41.95063476562498, lng: -7.030468749999955 },
        { lat: 41.945263671874955, lng: -6.865527343749932 },
        { lat: 41.96416015624999, lng: -6.833203124999926 },
        { lat: 41.958496093749964, lng: -6.777294921874983 },
        { lat: 41.9345703125, lng: -6.70361328125 },
        { lat: 41.9423828125, lng: -6.61826171874992 },
        { lat: 41.91308593749997, lng: -6.575341796874966 },
        { lat: 41.874121093750034, lng: -6.557519531249966 },
        { lat: 41.78955078125003, lng: -6.552587890624948 },
        { lat: 41.70405273437501, lng: -6.558984375000023 },
        { lat: 41.672509765624994, lng: -6.542187499999954 },
        { lat: 41.664404296875034, lng: -6.48466796874996 },
        { lat: 41.66538085937503, lng: -6.391699218749949 },
        { lat: 41.642187500000034, lng: -6.308056640624954 },
        { lat: 41.60180664062497, lng: -6.243115234374955 },
        { lat: 41.560449218749994, lng: -6.221679687499943 },
        { lat: 41.53203125, lng: -6.2125 },
        { lat: 41.51591796874995, lng: -6.244335937499955 },
        { lat: 41.45502929687501, lng: -6.28935546874996 },
        { lat: 41.37539062500002, lng: -6.403125 },
        { lat: 41.3037109375, lng: -6.56591796875 },
        { lat: 41.21450195312502, lng: -6.690136718749983 },
        { lat: 41.10771484375002, lng: -6.775781249999937 },
        { lat: 41.06240234375002, lng: -6.8828125 },
        { lat: 41.038037109374955, lng: -6.915527343749999 },
        { lat: 41.009130859375, lng: -6.928466796874972 },
        { lat: 40.87832031250002, lng: -6.857714843749932 },
        { lat: 40.777490234374994, lng: -6.835888671874926 },
        { lat: 40.65405273437497, lng: -6.818359375 },
        { lat: 40.619091796874955, lng: -6.829833984374943 },
        { lat: 40.48315429687497, lng: -6.835693359374971 },
        { lat: 40.44326171875002, lng: -6.852050781249943 },
        { lat: 40.410986328125006, lng: -6.847949218749988 },
        { lat: 40.37626953124996, lng: -6.82177734375 },
        { lat: 40.343115234375034, lng: -6.8101562499999 },
        { lat: 40.30073242187504, lng: -6.85888671875 },
        { lat: 40.251611328124966, lng: -6.948437499999955 },
        { lat: 40.208349609375034, lng: -7.01469726562496 },
        { lat: 40.16791992187498, lng: -7.032617187499965 },
        { lat: 40.14262695312496, lng: -7.027832031249972 },
        { lat: 40.05683593749998, lng: -6.91640625 },
        { lat: 40.02182617187506, lng: -6.896093749999949 },
        { lat: 39.937109375000034, lng: -6.911181640624989 },
        { lat: 39.79838867187502, lng: -6.975390624999932 },
        { lat: 39.713964843750034, lng: -7.03671875 },
        { lat: 39.70556640625, lng: -7.04741210937496 },
        { lat: 39.681689453125045, lng: -7.117675781249972 },
        { lat: 39.6806640625, lng: -7.454101562499943 },
        { lat: 39.66157226562501, lng: -7.535693359374961 },
        { lat: 39.644726562499955, lng: -7.524218749999932 },
        { lat: 39.53618164062496, lng: -7.44511718749996 },
        { lat: 39.47832031249999, lng: -7.362695312499966 },
        { lat: 39.46513671874996, lng: -7.335449218749999 },
        { lat: 39.33813476562502, lng: -7.30576171874992 },
        { lat: 39.13520507812498, lng: -7.172412109374932 },
        { lat: 39.10708007812502, lng: -7.042968749999942 },
        { lat: 39.05644531250002, lng: -6.997949218749993 },
        { lat: 38.98525390624999, lng: -7.00625 },
        { lat: 38.907031250000045, lng: -7.046044921874937 },
        { lat: 38.82695312499999, lng: -7.125488281249971 },
        { lat: 38.77050781250002, lng: -7.219921874999925 },
        { lat: 38.71455078125001, lng: -7.28154296874996 },
        { lat: 38.649365234374955, lng: -7.286376953124972 },
        { lat: 38.56684570312501, lng: -7.30595703124996 },
        { lat: 38.50146484375003, lng: -7.335791015625006 },
        { lat: 38.45742187500002, lng: -7.343017578124943 },
        { lat: 38.181005859375006, lng: -7.106396484374982 },
        { lat: 38.194433593750006, lng: -6.974804687499982 },
        { lat: 38.18789062499999, lng: -6.957568359374932 },
        { lat: 38.121972656249966, lng: -6.981103515624937 },
        { lat: 38.04472656249996, lng: -7.022851562500023 },
        { lat: 38.030029296875, lng: -7.072509765625 },
        { lat: 38.00634765625006, lng: -7.185449218749994 },
        { lat: 37.90644531250004, lng: -7.292236328125 },
        { lat: 37.786376953125, lng: -7.378906249999971 },
        { lat: 37.72827148437497, lng: -7.443945312499921 },
        { lat: 37.58549804687502, lng: -7.503515624999977 },
        { lat: 37.523583984375016, lng: -7.496044921874954 },
        { lat: 37.42802734374999, lng: -7.467187499999937 },
        { lat: 37.17944335937497, lng: -7.406152343749937 },
        { lat: 37.168310546875034, lng: -7.493603515624983 },
        { lat: 37.00571289062503, lng: -7.834130859374994 },
        { lat: 37.00541992187496, lng: -7.939697265625 },
        { lat: 37.077050781249994, lng: -8.136767578124932 },
        { lat: 37.10004882812498, lng: -8.484326171874955 },
        { lat: 37.12133789062506, lng: -8.597656249999943 },
        { lat: 37.07460937500002, lng: -8.739111328124977 },
        { lat: 37.07568359374997, lng: -8.8484375 },
        { lat: 37.01601562499999, lng: -8.935351562499987 },
        { lat: 37.03227539062502, lng: -8.997802734375028 },
        { lat: 37.16606445312502, lng: -8.92626953125 },
        { lat: 37.43081054687502, lng: -8.814160156249983 },
        { lat: 37.59243164062502, lng: -8.818554687500011 },
        { lat: 37.73281250000002, lng: -8.791845703124977 },
        { lat: 37.871875, lng: -8.822656249999936 },
        { lat: 37.95869140625001, lng: -8.87895507812496 },
        { lat: 38.18383789062497, lng: -8.80224609374997 },
        { lat: 38.299755859374955, lng: -8.810937499999966 },
        { lat: 38.44667968750005, lng: -8.881103515624943 },
        { lat: 38.42431640625003, lng: -8.668310546874947 },
        { lat: 38.48242187500006, lng: -8.73398437499992 },
        { lat: 38.518164062500034, lng: -8.798876953124989 },
        { lat: 38.50996093749998, lng: -8.861621093749987 },
        { lat: 38.512109374999966, lng: -8.914794921874972 },
        { lat: 38.45522460937502, lng: -9.09599609374996 },
        { lat: 38.438183593750004, lng: -9.186718749999953 },
        { lat: 38.44809570312498, lng: -9.213281249999937 },
        { lat: 38.53896484375002, lng: -9.203369140624972 },
        { lat: 38.65673828125002, lng: -9.250390624999964 },
        { lat: 38.68779296874996, lng: -9.17783203124992 },
        { lat: 38.69667968749999, lng: -9.09331054687493 },
        { lat: 38.746875, lng: -9.021484374999943 },
        { lat: 38.80292968749998, lng: -8.977050781249972 },
        { lat: 38.90302734375004, lng: -9.000488281249943 },
        { lat: 38.998095703125045, lng: -8.93808593749992 },
        { lat: 39.07817382812502, lng: -8.79160156249992 },
        { lat: 39.06596679687502, lng: -8.867480468749932 },
        { lat: 39.016064453124955, lng: -8.954296874999955 },
        { lat: 38.834667968749955, lng: -9.091015625000011 },
        { lat: 38.74277343749997, lng: -9.13579101562496 },
        { lat: 38.712792968749994, lng: -9.252294921875004 },
        { lat: 38.697900390624994, lng: -9.35673828124996 },
        { lat: 38.70751953125, lng: -9.410205078124932 },
        { lat: 38.73085937500002, lng: -9.474121093749972 },
        { lat: 38.79877929687501, lng: -9.479736328124972 },
        { lat: 38.852929687500016, lng: -9.474755859374937 },
        { lat: 38.96044921875, lng: -9.431445312499987 },
        { lat: 39.11210937499999, lng: -9.41435546874996 },
        { lat: 39.248144531250006, lng: -9.35283203124996 },
        { lat: 39.28427734374997, lng: -9.35722656249996 },
        { lat: 39.338281249999966, lng: -9.374755859374972 },
        { lat: 39.39111328125, lng: -9.319628906249932 },
        { lat: 39.426025390625, lng: -9.251416015624983 },
        { lat: 39.542578125000034, lng: -9.148291015624949 },
        { lat: 39.820556640625, lng: -9.004052734374966 },
        { lat: 40.11567382812498, lng: -8.837841796874926 },
        { lat: 40.151806640624976, lng: -8.851318359375028 },
        { lat: 40.179443359375, lng: -8.886621093750023 },
        { lat: 40.25908203124999, lng: -8.8726562499999 },
        { lat: 40.60566406249998, lng: -8.772412109374926 },
        { lat: 40.65092773437495, lng: -8.731591796874966 },
        { lat: 40.75253906250006, lng: -8.684619140624989 },
        { lat: 40.91650390624997, lng: -8.673974609374936 },
        { lat: 41.02949218749998, lng: -8.655566406249932 },
        { lat: 41.086279296875006, lng: -8.659814453124994 },
        { lat: 41.154492187499955, lng: -8.674609374999989 },
        { lat: 41.28466796875003, lng: -8.73837890624992 },
        { lat: 41.56000976562498, lng: -8.805664062499943 },
        { lat: 41.65195312500006, lng: -8.810839843749932 },
        { lat: 41.69838867187502, lng: -8.75541992187493 },
        { lat: 41.70517578124998, lng: -8.846386718749983 },
        { lat: 41.764599609375004, lng: -8.887597656249937 },
        { lat: 41.83208007812499, lng: -8.878222656249989 },
        { lat: 41.941064453124994, lng: -8.777148437500017 },
        { lat: 42.008496093749955, lng: -8.68295898437492 },
        { lat: 42.05273437499999, lng: -8.589648437499989 },
        { lat: 42.0693359375, lng: -8.538085937499972 },
        { lat: 42.115087890625006, lng: -8.322558593749932 },
        { lat: 42.13740234375001, lng: -8.266064453124983 },
        { lat: 42.133691406249966, lng: -8.213085937499926 },
        { lat: 42.11186523437496, lng: -8.204199218749977 },
        { lat: 42.06938476562501, lng: -8.17358398437497 },
        { lat: 42.039941406249966, lng: -8.139306640624994 },
        { lat: 42.01816406250006, lng: -8.129980468749977 },
        { lat: 41.92709960937498, lng: -8.213330078124983 },
        { lat: 41.895849609375006, lng: -8.224755859374994 },
        { lat: 41.83696289062502, lng: -8.18125 },
        { lat: 41.819970703124994, lng: -8.173535156249955 },
      ],
    ],
  },
  {
    code: "RO",
    coordinates: [
      [
        { lat: 45.450439453125, lng: 28.2125 },
        { lat: 45.347119140625, lng: 28.317675781250017 },
        { lat: 45.2921875, lng: 28.451269531250006 },
        { lat: 45.234130859375, lng: 28.7607421875 },
        { lat: 45.240966796875, lng: 28.78828125000001 },
        { lat: 45.251904296875, lng: 28.791406250000023 },
        { lat: 45.266894531249996, lng: 28.769824218750017 },
        { lat: 45.28623046875, lng: 28.7666015625 },
        { lat: 45.309863281249996, lng: 28.78173828125 },
        { lat: 45.311083984374996, lng: 28.824316406250002 },
        { lat: 45.289941406249994, lng: 28.894335937500017 },
        { lat: 45.320556640625, lng: 29.027441406250006 },
        { lat: 45.4029296875, lng: 29.223535156250026 },
        { lat: 45.41967773437499, lng: 29.403710937500023 },
        { lat: 45.37080078125, lng: 29.567675781250017 },
        { lat: 45.313916015625, lng: 29.651953125 },
        { lat: 45.259912109374994, lng: 29.705859375000014 },
        { lat: 45.193212890625, lng: 29.6890625 },
        { lat: 45.151660156249996, lng: 29.678613281250023 },
        { lat: 44.979638671874994, lng: 29.635351562500002 },
        { lat: 44.91547851562499, lng: 29.60546875 },
        { lat: 44.843408203124994, lng: 29.557519531250023 },
        { lat: 44.757568359375, lng: 29.048242187500023 },
        { lat: 44.798828125, lng: 29.081054687500004 },
        { lat: 44.871142578124996, lng: 29.069140625000017 },
        { lat: 44.92568359374999, lng: 29.04775390625002 },
        { lat: 44.975048828125, lng: 29.0953125 },
        { lat: 44.992919921875, lng: 28.98066406250001 },
        { lat: 44.9658203125, lng: 28.930566406250023 },
        { lat: 44.91865234374999, lng: 28.891503906250023 },
        { lat: 44.810009765625, lng: 28.92617187500002 },
        { lat: 44.749951171875, lng: 28.870410156250017 },
        { lat: 44.71630859375, lng: 28.84902343750002 },
        { lat: 44.636865234374994, lng: 28.84648437500002 },
        { lat: 44.602490234375, lng: 28.813574218750006 },
        { lat: 44.5650390625, lng: 28.807031250000023 },
        { lat: 44.57475585937499, lng: 28.88818359375 },
        { lat: 44.506103515625, lng: 28.851757812500008 },
        { lat: 44.37421875, lng: 28.69921875 },
        { lat: 44.295654296875, lng: 28.645410156250023 },
        { lat: 43.983837890625, lng: 28.658593750000023 },
        { lat: 43.797412109374996, lng: 28.590722656250023 },
        { lat: 43.742236328124996, lng: 28.585351562500023 },
        { lat: 43.740478515625, lng: 28.4234375 },
        { lat: 43.744775390624994, lng: 28.37519531250001 },
        { lat: 43.77285156249999, lng: 28.221972656250017 },
        { lat: 43.822412109374994, lng: 28.05 },
        { lat: 43.918603515624994, lng: 27.94892578125001 },
        { lat: 43.987353515624996, lng: 27.884277343749996 },
        { lat: 43.956298828125, lng: 27.738574218750017 },
        { lat: 43.964599609375, lng: 27.710742187500017 },
        { lat: 43.997802734375, lng: 27.6708984375 },
        { lat: 44.020068359374996, lng: 27.56103515625 },
        { lat: 44.0205078125, lng: 27.425390625 },
        { lat: 44.146142578124994, lng: 27.120703125 },
        { lat: 44.167382812499994, lng: 27.0869140625 },
        { lat: 44.14619140625, lng: 26.847753906250006 },
        { lat: 44.08398437499999, lng: 26.4892578125 },
        { lat: 44.007275390625, lng: 26.2158203125 },
        { lat: 43.870556640625, lng: 25.933398437500017 },
        { lat: 43.76684570312499, lng: 25.81884765625 },
        { lat: 43.711767578125, lng: 25.686132812500006 },
        { lat: 43.670800781249994, lng: 25.4970703125 },
        { lat: 43.686328125, lng: 25.15966796875 },
        { lat: 43.738427734374994, lng: 24.808203125 },
        { lat: 43.794384765625, lng: 24.430566406250023 },
        { lat: 43.763476562499996, lng: 24.22675781250001 },
        { lat: 43.786669921874996, lng: 23.95078125 },
        { lat: 43.853564453124996, lng: 23.534570312500023 },
        { lat: 43.873876953125, lng: 23.224609375 },
        { lat: 43.83447265625, lng: 22.919042968750006 },
        { lat: 43.864550781249996, lng: 22.867675781249996 },
        { lat: 43.8990234375, lng: 22.8564453125 },
        { lat: 43.947900390624994, lng: 22.868261718750002 },
        { lat: 43.987207031249994, lng: 22.91132812500001 },
        { lat: 44.01699218749999, lng: 22.9853515625 },
        { lat: 44.047216796875, lng: 23.0244140625 },
        { lat: 44.07797851562499, lng: 23.02851562500001 },
        { lat: 44.12729492187499, lng: 22.945410156250002 },
        { lat: 44.195214843749994, lng: 22.775195312500017 },
        { lat: 44.23779296875, lng: 22.705078125 },
        { lat: 44.248291015625, lng: 22.687890625000023 },
        { lat: 44.286474609375, lng: 22.683300781250008 },
        { lat: 44.316455078124996, lng: 22.64794921875 },
        { lat: 44.33833007812499, lng: 22.581835937500017 },
        { lat: 44.377978515624996, lng: 22.530664062500023 },
        { lat: 44.435449218749994, lng: 22.49453125000002 },
        { lat: 44.489599609375, lng: 22.502343750000023 },
        { lat: 44.540332031249996, lng: 22.554003906250017 },
        { lat: 44.562353515625, lng: 22.6201171875 },
        { lat: 44.555517578125, lng: 22.70078125 },
        { lat: 44.569921875, lng: 22.734375 },
        { lat: 44.605517578124996, lng: 22.72089843750001 },
        { lat: 44.6509765625, lng: 22.64208984375 },
        { lat: 44.70625, lng: 22.49765625 },
        { lat: 44.676123046875, lng: 22.350683593750006 },
        { lat: 44.560693359374994, lng: 22.200976562500014 },
        { lat: 44.541943359375, lng: 22.093066406250017 },
        { lat: 44.61987304687499, lng: 22.026953125 },
        { lat: 44.66611328125, lng: 21.909277343750006 },
        { lat: 44.6806640625, lng: 21.740234375 },
        { lat: 44.71044921874999, lng: 21.636132812500023 },
        { lat: 44.755419921874996, lng: 21.597070312500023 },
        { lat: 44.790087890624996, lng: 21.52314453125001 },
        { lat: 44.82666015625, lng: 21.36005859375001 },
        { lat: 44.86181640625, lng: 21.357910156249996 },
        { lat: 44.870068359375, lng: 21.384375 },
        { lat: 44.873388671875, lng: 21.442187500000017 },
        { lat: 44.880810546875, lng: 21.519921875000023 },
        { lat: 44.90068359374999, lng: 21.532324218750006 },
        { lat: 44.918847656249994, lng: 21.533203125 },
        { lat: 44.9419921875, lng: 21.471972656250017 },
        { lat: 44.95771484375, lng: 21.409960937500017 },
        { lat: 44.9734375, lng: 21.377734375000017 },
        { lat: 44.990771484374996, lng: 21.35703125 },
        { lat: 45.008984375, lng: 21.352929687500023 },
        { lat: 45.021386718749994, lng: 21.37109375 },
        { lat: 45.022216796875, lng: 21.395898437500023 },
        { lat: 45.032958984375, lng: 21.420703125000017 },
        { lat: 45.075146484375, lng: 21.434472656250023 },
        { lat: 45.10986328125, lng: 21.467871093750006 },
        { lat: 45.122265625, lng: 21.491796875 },
        { lat: 45.147900390625, lng: 21.490234375 },
        { lat: 45.171875, lng: 21.465429687500002 },
        { lat: 45.192529296874994, lng: 21.431445312500017 },
        { lat: 45.205078125, lng: 21.381738281250023 },
        { lat: 45.24130859375, lng: 21.22646484375002 },
        { lat: 45.291748046875, lng: 21.147851562500023 },
        { lat: 45.29355468749999, lng: 21.099902343750017 },
        { lat: 45.321533203125, lng: 21.023828125000023 },
        { lat: 45.36533203125, lng: 20.941796875000023 },
        { lat: 45.427539062499996, lng: 20.87080078125001 },
        { lat: 45.46787109375, lng: 20.794042968750002 },
        { lat: 45.484423828124996, lng: 20.774218750000017 },
        { lat: 45.50009765625, lng: 20.7724609375 },
        { lat: 45.517480468749994, lng: 20.786523437500023 },
        { lat: 45.536474609375, lng: 20.78603515625002 },
        { lat: 45.597460937499996, lng: 20.76582031250001 },
        { lat: 45.662011718749994, lng: 20.779296875 },
        { lat: 45.722509765625, lng: 20.775781250000023 },
        { lat: 45.74980468749999, lng: 20.775 },
        { lat: 45.758105468749996, lng: 20.760156250000023 },
        { lat: 45.748974609375, lng: 20.746875 },
        { lat: 45.73740234375, lng: 20.727832031250017 },
        { lat: 45.735253906249994, lng: 20.709277343750017 },
        { lat: 45.77939453124999, lng: 20.652734375000023 },
        { lat: 45.869482421875, lng: 20.581152343750006 },
        { lat: 45.89951171875, lng: 20.532617187500023 },
        { lat: 45.94077148437499, lng: 20.43798828125 },
        { lat: 45.975488281249994, lng: 20.35859375 },
        { lat: 46.05068359374999, lng: 20.301367187500006 },
        { lat: 46.10859375, lng: 20.241796875 },
        { lat: 46.1330078125, lng: 20.28095703125001 },
        { lat: 46.166943359375, lng: 20.508105468750017 },
        { lat: 46.13349609374999, lng: 20.613671875000023 },
        { lat: 46.145654296874994, lng: 20.661035156250023 },
        { lat: 46.172802734375, lng: 20.707421875000023 },
        { lat: 46.19443359375, lng: 20.732714843750017 },
        { lat: 46.21748046875, lng: 20.737402343750006 },
        { lat: 46.24624023437499, lng: 20.76025390625 },
        { lat: 46.259716796875, lng: 20.837011718750002 },
        { lat: 46.242236328124996, lng: 21.039843750000017 },
        { lat: 46.282421875, lng: 21.121679687500006 },
        { lat: 46.30434570312499, lng: 21.151953125 },
        { lat: 46.352685546874994, lng: 21.17041015625 },
        { lat: 46.391552734375, lng: 21.191796875000023 },
        { lat: 46.4123046875, lng: 21.264550781250023 },
        { lat: 46.44775390625, lng: 21.26328125 },
        { lat: 46.486376953124996, lng: 21.252246093750017 },
        { lat: 46.5724609375, lng: 21.29453125 },
        { lat: 46.6078125, lng: 21.320214843750023 },
        { lat: 46.62075195312499, lng: 21.361328125 },
        { lat: 46.647851562499994, lng: 21.411035156250023 },
        { lat: 46.70429687499999, lng: 21.4970703125 },
        { lat: 46.753369140625, lng: 21.47705078125 },
        { lat: 46.78974609375, lng: 21.494433593750017 },
        { lat: 46.87836914062499, lng: 21.584179687500008 },
        { lat: 46.963769531249994, lng: 21.652636718750017 },
        { lat: 47.00654296875, lng: 21.651464843750002 },
        { lat: 47.043896484375, lng: 21.661425781250017 },
        { lat: 47.08481445312499, lng: 21.721777343750006 },
        { lat: 47.138134765625, lng: 21.785449218750017 },
        { lat: 47.304589843749994, lng: 21.86933593750001 },
        { lat: 47.332568359374996, lng: 21.899218750000014 },
        { lat: 47.36425781249999, lng: 21.95429687500001 },
        { lat: 47.395703125, lng: 21.99531250000001 },
        { lat: 47.505029296874994, lng: 21.99970703125001 },
        { lat: 47.53662109375, lng: 22.037988281250023 },
        { lat: 47.572021484375, lng: 22.111914062500006 },
        { lat: 47.629052734374994, lng: 22.18505859375 },
        { lat: 47.69638671875, lng: 22.24462890625 },
        { lat: 47.72783203124999, lng: 22.290625 },
        { lat: 47.736230468749994, lng: 22.35146484375002 },
        { lat: 47.762646484375, lng: 22.41748046875 },
        { lat: 47.77255859374999, lng: 22.49140625000001 },
        { lat: 47.759570312499996, lng: 22.562890625000023 },
        { lat: 47.76630859375, lng: 22.6083984375 },
        { lat: 47.79902343749999, lng: 22.6767578125 },
        { lat: 47.92255859375, lng: 22.85175781250001 },
        { lat: 47.947265625, lng: 22.87666015625001 },
        { lat: 47.96425781249999, lng: 22.912890625000014 },
        { lat: 48.00654296874999, lng: 23.054785156250006 },
        { lat: 48.049121093749996, lng: 23.0908203125 },
        { lat: 48.08740234375, lng: 23.139453125000014 },
        { lat: 48.084521484374996, lng: 23.20263671875 },
        { lat: 47.98999023437499, lng: 23.408203125 },
        { lat: 47.995849609375, lng: 23.628710937500017 },
        { lat: 47.992333984374994, lng: 23.669042968750006 },
        { lat: 47.990380859374994, lng: 23.682031250000023 },
        { lat: 47.9826171875, lng: 23.708984375 },
        { lat: 47.935791015625, lng: 24.001855468750023 },
        { lat: 47.94101562499999, lng: 24.04736328125 },
        { lat: 47.944775390625, lng: 24.05976562500001 },
        { lat: 47.906054687499996, lng: 24.177734375 },
        { lat: 47.911181640624996, lng: 24.28193359375001 },
        { lat: 47.938037109374996, lng: 24.380957031250006 },
        { lat: 47.947119140625, lng: 24.48408203125001 },
        { lat: 47.931054687499994, lng: 24.578906250000014 },
        { lat: 47.87651367187499, lng: 24.650976562500006 },
        { lat: 47.76083984375, lng: 24.837890625 },
        { lat: 47.7177734375, lng: 24.893359375000017 },
        { lat: 47.72412109375, lng: 24.979101562500002 },
        { lat: 47.745703125, lng: 25.073828125 },
        { lat: 47.823095703125, lng: 25.16962890625001 },
        { lat: 47.910791015624994, lng: 25.464257812500023 },
        { lat: 47.932470703125, lng: 25.689257812500017 },
        { lat: 47.967578125, lng: 25.90869140625 },
        { lat: 47.992529296875, lng: 26.162695312500006 },
        { lat: 48.064355468749994, lng: 26.236230468750023 },
        { lat: 48.113232421875, lng: 26.276953125 },
        { lat: 48.203759765624994, lng: 26.3056640625 },
        { lat: 48.22998046875, lng: 26.4423828125 },
        { lat: 48.248486328125, lng: 26.57246093750001 },
        { lat: 48.25986328124999, lng: 26.618945312500014 },
        { lat: 48.263476562499996, lng: 26.71376953125002 },
        { lat: 48.255810546875, lng: 26.78730468750001 },
        { lat: 48.2111328125, lng: 26.900976562500006 },
        { lat: 48.155029296875, lng: 26.980761718750017 },
        { lat: 48.110498046874994, lng: 27.01220703125 },
        { lat: 48.04765625, lng: 27.080371093750017 },
        { lat: 47.959277343749996, lng: 27.15205078125001 },
        { lat: 47.841748046875, lng: 27.230859375000023 },
        { lat: 47.7822265625, lng: 27.248144531250006 },
        { lat: 47.71796875, lng: 27.277929687500002 },
        { lat: 47.63974609374999, lng: 27.336914062499996 },
        { lat: 47.553125, lng: 27.44921875 },
        { lat: 47.536669921874996, lng: 27.46484375 },
        { lat: 47.475634765624996, lng: 27.51582031250001 },
        { lat: 47.34052734375, lng: 27.614062500000017 },
        { lat: 47.286425781249996, lng: 27.696191406250023 },
        { lat: 47.227587890624996, lng: 27.76796875000002 },
        { lat: 47.16831054687499, lng: 27.80234375 },
        { lat: 47.114501953125, lng: 27.853808593750017 },
        { lat: 47.043212890625, lng: 27.97421875 },
        { lat: 46.97841796874999, lng: 28.07177734375 },
        { lat: 46.79208984375, lng: 28.15 },
        { lat: 46.70639648437499, lng: 28.2046875 },
        { lat: 46.6408203125, lng: 28.23945312500001 },
        { lat: 46.50805664062499, lng: 28.22265625 },
        { lat: 46.45126953125, lng: 28.24433593750001 },
        { lat: 46.347558593749994, lng: 28.199609375000023 },
        { lat: 46.138671875, lng: 28.119140625 },
        { lat: 45.972607421875, lng: 28.099707031250006 },
        { lat: 45.883056640625, lng: 28.113574218750014 },
        { lat: 45.825537109375, lng: 28.115527343750014 },
        { lat: 45.788867187499996, lng: 28.13496093750001 },
        { lat: 45.7130859375, lng: 28.15625 },
        { lat: 45.647119140624994, lng: 28.159765625 },
        { lat: 45.62827148437499, lng: 28.130859375 },
        { lat: 45.61274414062499, lng: 28.09033203125 },
        { lat: 45.598974609375, lng: 28.074707031249996 },
        { lat: 45.569140625, lng: 28.111914062500002 },
        { lat: 45.51376953124999, lng: 28.1625 },
        { lat: 45.450439453125, lng: 28.2125 },
      ],
    ],
  },
  {
    code: "SK",
    coordinates: [
      [
        { lat: 49.07270507812499, lng: 22.538671875 },
        { lat: 49.031396484374994, lng: 22.52412109375001 },
        { lat: 48.98325195312499, lng: 22.483203125000014 },
        { lat: 48.93354492187499, lng: 22.432031250000023 },
        { lat: 48.873486328125, lng: 22.389453125000017 },
        { lat: 48.745068359375, lng: 22.332617187500006 },
        { lat: 48.68583984374999, lng: 22.295214843750017 },
        { lat: 48.56850585937499, lng: 22.142871093750017 },
        { lat: 48.405322265624996, lng: 22.131835937499996 },
        { lat: 48.393359375, lng: 22.111328125 },
        { lat: 48.33808593749999, lng: 21.766992187500023 },
        { lat: 48.346582031249994, lng: 21.721484375000017 },
        { lat: 48.378369140625, lng: 21.674609375000014 },
        { lat: 48.40146484375, lng: 21.64863281250001 },
        { lat: 48.418505859374996, lng: 21.63251953125001 },
        { lat: 48.463671875, lng: 21.602636718750006 },
        { lat: 48.495703125, lng: 21.56318359375001 },
        { lat: 48.521875, lng: 21.504687500000017 },
        { lat: 48.55224609375, lng: 21.451367187500008 },
        { lat: 48.553466796875, lng: 21.382421875 },
        { lat: 48.510595703125, lng: 21.196386718750006 },
        { lat: 48.505908203124996, lng: 21.067285156250023 },
        { lat: 48.519677734374994, lng: 20.981152343750008 },
        { lat: 48.54565429687499, lng: 20.866601562500023 },
        { lat: 48.549707031249994, lng: 20.643164062500006 },
        { lat: 48.52690429687499, lng: 20.490039062500014 },
        { lat: 48.4951171875, lng: 20.475 },
        { lat: 48.295556640624994, lng: 20.333789062500017 },
        { lat: 48.222021484375, lng: 20.12861328125001 },
        { lat: 48.146630859374994, lng: 19.950390625 },
        { lat: 48.13134765625, lng: 19.89863281250001 },
        { lat: 48.155029296875, lng: 19.81005859375 },
        { lat: 48.1998046875, lng: 19.70917968750001 },
        { lat: 48.223095703125, lng: 19.625390625000023 },
        { lat: 48.212841796875, lng: 19.564257812500014 },
        { lat: 48.162109375, lng: 19.497460937500023 },
        { lat: 48.110693359375, lng: 19.466992187500008 },
        { lat: 48.073046875, lng: 19.26513671875 },
        { lat: 48.050830078124996, lng: 18.914160156250006 },
        { lat: 48.000292968749996, lng: 18.791894531250023 },
        { lat: 47.939453125, lng: 18.750097656250006 },
        { lat: 47.89267578125, lng: 18.748339843750017 },
        { lat: 47.852880859375, lng: 18.77802734375001 },
        { lat: 47.806494140625, lng: 18.740625 },
        { lat: 47.787158203124996, lng: 18.72421875 },
        { lat: 47.777001953124994, lng: 18.47626953125001 },
        { lat: 47.76342773437499, lng: 18.145605468750006 },
        { lat: 47.766894531249996, lng: 17.94794921875001 },
        { lat: 47.770166015624994, lng: 17.76191406250001 },
        { lat: 47.80991210937499, lng: 17.63525390625 },
        { lat: 47.887597656249994, lng: 17.48066406250001 },
        { lat: 47.99091796875, lng: 17.317285156250023 },
        { lat: 47.993359375, lng: 17.301562500000014 },
        { lat: 48.004345703125, lng: 17.277246093750023 },
        { lat: 48.012060546875, lng: 17.174609375000017 },
        { lat: 48.00595703125, lng: 17.147363281250023 },
        { lat: 48.03955078125, lng: 17.0859375 },
        { lat: 48.083251953125, lng: 17.06787109375 },
        { lat: 48.198095703125, lng: 16.97265625 },
        { lat: 48.3869140625, lng: 16.86542968750001 },
        { lat: 48.44140625, lng: 16.862695312500023 },
        { lat: 48.503515625, lng: 16.90449218750001 },
        { lat: 48.550927734374994, lng: 16.943359375 },
        { lat: 48.58857421874999, lng: 16.948828125 },
        { lat: 48.59882812499999, lng: 16.953125 },
        { lat: 48.676904296874994, lng: 16.985253906250023 },
        { lat: 48.78076171875, lng: 17.063281250000017 },
        { lat: 48.841064453125, lng: 17.13564453125002 },
        { lat: 48.8609375, lng: 17.1884765625 },
        { lat: 48.842822265624996, lng: 17.296875 },
        { lat: 48.827783203124994, lng: 17.482617187500008 },
        { lat: 48.841845703124996, lng: 17.62539062500002 },
        { lat: 48.888134765625, lng: 17.758496093750008 },
        { lat: 48.92861328124999, lng: 17.830859375000017 },
        { lat: 48.971142578125, lng: 17.892675781250006 },
        { lat: 48.99873046874999, lng: 17.91328125000001 },
        { lat: 49.011962890625, lng: 17.940722656250017 },
        { lat: 49.036523437499994, lng: 18.050878906250006 },
        { lat: 49.06513671875, lng: 18.0859375 },
        { lat: 49.1193359375, lng: 18.100390625000017 },
        { lat: 49.17978515625, lng: 18.109960937500006 },
        { lat: 49.22456054687499, lng: 18.132617187500017 },
        { lat: 49.257373046874996, lng: 18.160937500000017 },
        { lat: 49.33623046874999, lng: 18.36484375 },
        { lat: 49.363916015624994, lng: 18.383105468750017 },
        { lat: 49.390917968749996, lng: 18.415820312500014 },
        { lat: 49.42109375, lng: 18.47607421875 },
        { lat: 49.464697265625, lng: 18.534570312500023 },
        { lat: 49.491455078125, lng: 18.596484375000017 },
        { lat: 49.48847656249999, lng: 18.676171875000023 },
        { lat: 49.493994140625, lng: 18.74970703125001 },
        { lat: 49.50922851562499, lng: 18.807031250000023 },
        { lat: 49.510791015624996, lng: 18.83222656250001 },
        { lat: 49.498291015625, lng: 18.93818359375001 },
        { lat: 49.44829101562499, lng: 18.95722656250001 },
        { lat: 49.396240234375, lng: 18.968359375 },
        { lat: 49.4, lng: 19.1494140625 },
        { lat: 49.51142578125, lng: 19.25019531250001 },
        { lat: 49.524853515625, lng: 19.30234375 },
        { lat: 49.563623046874994, lng: 19.386230468749996 },
        { lat: 49.59770507812499, lng: 19.44160156250001 },
        { lat: 49.5763671875, lng: 19.47968750000001 },
        { lat: 49.504785156249994, lng: 19.534765625 },
        { lat: 49.447119140625, lng: 19.593066406250017 },
        { lat: 49.424365234374996, lng: 19.62666015625001 },
        { lat: 49.40664062499999, lng: 19.630273437500023 },
        { lat: 49.396044921874996, lng: 19.664160156250006 },
        { lat: 49.389599609375, lng: 19.730078125 },
        { lat: 49.37216796875, lng: 19.77392578125 },
        { lat: 49.3185546875, lng: 19.787011718750023 },
        { lat: 49.269970703125, lng: 19.787988281250023 },
        { lat: 49.235205078125, lng: 19.767382812500014 },
        { lat: 49.204394531249996, lng: 19.756640625000014 },
        { lat: 49.192333984375, lng: 19.80224609375 },
        { lat: 49.204003906249994, lng: 19.868945312500017 },
        { lat: 49.22138671874999, lng: 19.916113281250006 },
        { lat: 49.181298828124994, lng: 20.057617187499996 },
        { lat: 49.27075195312499, lng: 20.10761718750001 },
        { lat: 49.31640625, lng: 20.163671875 },
        { lat: 49.337646484375, lng: 20.23652343750001 },
        { lat: 49.365527343749996, lng: 20.302539062500017 },
        { lat: 49.38525390624999, lng: 20.362988281250008 },
        { lat: 49.384082031249996, lng: 20.404687500000023 },
        { lat: 49.392333984375, lng: 20.422656250000017 },
        { lat: 49.39018554687499, lng: 20.474511718750023 },
        { lat: 49.381201171875, lng: 20.534570312500023 },
        { lat: 49.39169921875, lng: 20.616113281250023 },
        { lat: 49.369921875, lng: 20.729003906249996 },
        { lat: 49.328662109374996, lng: 20.79951171875001 },
        { lat: 49.314697265625, lng: 20.868457031250014 },
        { lat: 49.31708984375, lng: 20.947265625 },
        { lat: 49.33984375, lng: 21.00117187500001 },
        { lat: 49.418261718749996, lng: 21.079394531250017 },
        { lat: 49.417041015624996, lng: 21.136132812500023 },
        { lat: 49.429443359375, lng: 21.225 },
        { lat: 49.428759765624996, lng: 21.35048828125002 },
        { lat: 49.411962890625, lng: 21.6396484375 },
        { lat: 49.38193359375, lng: 21.71210937500001 },
        { lat: 49.34345703125, lng: 21.890136718749996 },
        { lat: 49.299072265625, lng: 21.967675781250023 },
        { lat: 49.24609375, lng: 22.00214843750001 },
        { lat: 49.209521484374996, lng: 22.020117187500006 },
        { lat: 49.153222656249994, lng: 22.202539062500023 },
        { lat: 49.081298828125, lng: 22.473046875000023 },
        { lat: 49.07270507812499, lng: 22.538671875 },
      ],
    ],
  },
  {
    code: "RS",
    coordinates: [
      [
        { lat: 46.151904296875045, lng: 19.72451171875008 },
        { lat: 46.145898437499966, lng: 19.84443359375001 },
        { lat: 46.161474609375034, lng: 19.934082031250057 },
        { lat: 46.14189453124996, lng: 20.161425781250017 },
        { lat: 46.12602539062502, lng: 20.210156250000068 },
        { lat: 46.10859375, lng: 20.241796875000034 },
        { lat: 46.05068359375002, lng: 20.301367187500006 },
        { lat: 45.975488281249994, lng: 20.35859375000004 },
        { lat: 45.940771484375006, lng: 20.43798828125003 },
        { lat: 45.89951171875006, lng: 20.53261718750005 },
        { lat: 45.86948242187506, lng: 20.581152343749977 },
        { lat: 45.779394531250006, lng: 20.65273437499999 },
        { lat: 45.735253906249994, lng: 20.709277343750074 },
        { lat: 45.73740234374998, lng: 20.727832031250017 },
        { lat: 45.74897460937501, lng: 20.746875 },
        { lat: 45.75810546875002, lng: 20.76015625000005 },
        { lat: 45.74980468750002, lng: 20.775 },
        { lat: 45.72250976562506, lng: 20.775781250000023 },
        { lat: 45.662011718749994, lng: 20.77929687500003 },
        { lat: 45.59746093749999, lng: 20.76582031250004 },
        { lat: 45.53647460937498, lng: 20.78603515625008 },
        { lat: 45.51748046875002, lng: 20.78652343750008 },
        { lat: 45.500097656250034, lng: 20.772460937500057 },
        { lat: 45.48442382812504, lng: 20.774218750000074 },
        { lat: 45.467871093750034, lng: 20.794042968750002 },
        { lat: 45.42753906249999, lng: 20.87080078125001 },
        { lat: 45.365332031250034, lng: 20.94179687499999 },
        { lat: 45.32153320312497, lng: 21.023828125000023 },
        { lat: 45.293554687500055, lng: 21.09990234375007 },
        { lat: 45.29174804687505, lng: 21.14785156250005 },
        { lat: 45.24130859374998, lng: 21.22646484374999 },
        { lat: 45.20507812499997, lng: 21.381738281250023 },
        { lat: 45.192529296874994, lng: 21.431445312500017 },
        { lat: 45.171875, lng: 21.465429687500002 },
        { lat: 45.147900390624955, lng: 21.490234375 },
        { lat: 45.12226562499998, lng: 21.491796875000063 },
        { lat: 45.10986328125003, lng: 21.46787109375006 },
        { lat: 45.07514648437498, lng: 21.434472656250023 },
        { lat: 45.032958984375, lng: 21.420703125000045 },
        { lat: 45.02221679687503, lng: 21.39589843750005 },
        { lat: 45.02138671875002, lng: 21.37109374999997 },
        { lat: 45.00898437499998, lng: 21.352929687500023 },
        { lat: 44.99077148437502, lng: 21.357031250000034 },
        { lat: 44.973437500000045, lng: 21.37773437499999 },
        { lat: 44.95771484375004, lng: 21.40996093750007 },
        { lat: 44.941992187500034, lng: 21.471972656250017 },
        { lat: 44.91884765625002, lng: 21.533203125000057 },
        { lat: 44.900683593750045, lng: 21.532324218750063 },
        { lat: 44.88081054687498, lng: 21.519921875000023 },
        { lat: 44.87338867187498, lng: 21.442187500000074 },
        { lat: 44.87006835937501, lng: 21.384375 },
        { lat: 44.86181640625003, lng: 21.357910156250053 },
        { lat: 44.82666015624997, lng: 21.36005859375004 },
        { lat: 44.79008789062499, lng: 21.52314453125004 },
        { lat: 44.75541992187502, lng: 21.597070312500023 },
        { lat: 44.71044921874999, lng: 21.63613281250005 },
        { lat: 44.680664062499964, lng: 21.740234375000057 },
        { lat: 44.666113281250034, lng: 21.909277343750034 },
        { lat: 44.61987304687503, lng: 22.026953125 },
        { lat: 44.541943359374955, lng: 22.093066406250074 },
        { lat: 44.560693359374966, lng: 22.200976562500014 },
        { lat: 44.67612304687503, lng: 22.350683593750063 },
        { lat: 44.70625, lng: 22.497656249999977 },
        { lat: 44.65097656249998, lng: 22.64208984375 },
        { lat: 44.605517578125045, lng: 22.720898437499983 },
        { lat: 44.56992187499998, lng: 22.734375 },
        { lat: 44.55551757812498, lng: 22.700781250000063 },
        { lat: 44.562353515625034, lng: 22.620117187500057 },
        { lat: 44.54033203124999, lng: 22.554003906250017 },
        { lat: 44.48959960937506, lng: 22.50234375000005 },
        { lat: 44.43544921875002, lng: 22.49453125000005 },
        { lat: 44.37797851562496, lng: 22.53066406250005 },
        { lat: 44.338330078124955, lng: 22.58183593750007 },
        { lat: 44.31645507812504, lng: 22.647949218750057 },
        { lat: 44.28647460937506, lng: 22.683300781250068 },
        { lat: 44.248291015625, lng: 22.687890625000023 },
        { lat: 44.23779296875, lng: 22.705078125000053 },
        { lat: 44.22021484374997, lng: 22.66748046875003 },
        { lat: 44.194091796874964, lng: 22.626562500000034 },
        { lat: 44.148583984375016, lng: 22.60341796875005 },
        { lat: 44.075292968750034, lng: 22.597460937500074 },
        { lat: 44.01801757812498, lng: 22.469042968750017 },
        { lat: 44.00742187500006, lng: 22.42080078125005 },
        { lat: 43.96953125, lng: 22.399023437500063 },
        { lat: 43.86210937500001, lng: 22.36542968750004 },
        { lat: 43.78129882812499, lng: 22.36962890625003 },
        { lat: 43.74013671875005, lng: 22.386914062500068 },
        { lat: 43.706640625000055, lng: 22.39482421874999 },
        { lat: 43.665478515625004, lng: 22.436328125000017 },
        { lat: 43.60224609375001, lng: 22.474121093749996 },
        { lat: 43.51884765624999, lng: 22.499121093750006 },
        { lat: 43.454492187500016, lng: 22.554589843750048 },
        { lat: 43.39106445312498, lng: 22.69697265625001 },
        { lat: 43.35415039062502, lng: 22.767578125 },
        { lat: 43.300732421874955, lng: 22.819726562500048 },
        { lat: 43.252343749999966, lng: 22.85957031250001 },
        { lat: 43.18798828124999, lng: 22.976855468749985 },
        { lat: 43.142041015624955, lng: 22.967968750000065 },
        { lat: 43.09707031250005, lng: 22.94228515625005 },
        { lat: 43.07597656250002, lng: 22.915234375000068 },
        { lat: 43.01826171874998, lng: 22.85683593750005 },
        { lat: 42.985742187499994, lng: 22.799902343750002 },
        { lat: 42.88393554687505, lng: 22.706152343750006 },
        { lat: 42.87846679687499, lng: 22.558105468750057 },
        { lat: 42.87031250000004, lng: 22.522753906250045 },
        { lat: 42.842480468749955, lng: 22.466796875 },
        { lat: 42.791650390624994, lng: 22.439257812500074 },
        { lat: 42.75078125000002, lng: 22.465625 },
        { lat: 42.70947265625003, lng: 22.46328125000008 },
        { lat: 42.62910156250001, lng: 22.436230468749983 },
        { lat: 42.543310546875034, lng: 22.472070312500023 },
        { lat: 42.50390625, lng: 22.524218750000074 },
        { lat: 42.48120117187497, lng: 22.53242187500004 },
        { lat: 42.440966796875045, lng: 22.523535156250006 },
        { lat: 42.359130859374964, lng: 22.445703125000048 },
        { lat: 42.32885742187503, lng: 22.42207031250004 },
        { lat: 42.31396484375003, lng: 22.344042968750045 },
        { lat: 42.32172851562501, lng: 22.31738281250003 },
        { lat: 42.34985351562506, lng: 22.277050781250065 },
        { lat: 42.35815429687506, lng: 22.23974609375003 },
        { lat: 42.325, lng: 22.146679687500065 },
        { lat: 42.30463867187498, lng: 22.052050781250074 },
        { lat: 42.32006835937503, lng: 21.97753906249997 },
        { lat: 42.32207031249999, lng: 21.904101562500045 },
        { lat: 42.308398437500045, lng: 21.85302734375003 },
        { lat: 42.303125, lng: 21.81464843750001 },
        { lat: 42.26772460937502, lng: 21.73925781250003 },
        { lat: 42.24213867187504, lng: 21.618261718750063 },
        { lat: 42.247509765624976, lng: 21.5625 },
        { lat: 42.28081054687501, lng: 21.541601562499977 },
        { lat: 42.32841796875002, lng: 21.51894531250008 },
        { lat: 42.35, lng: 21.52998046875001 },
        { lat: 42.38745117187497, lng: 21.60986328125003 },
        { lat: 42.423242187499994, lng: 21.61904296875005 },
        { lat: 42.595458984375, lng: 21.73066406250004 },
        { lat: 42.65151367187505, lng: 21.752148437500068 },
        { lat: 42.66982421875005, lng: 21.752929687500057 },
        { lat: 42.681982421875034, lng: 21.723828125000068 },
        { lat: 42.681494140625006, lng: 21.6625 },
        { lat: 42.751416015624955, lng: 21.390625 },
        { lat: 42.83154296875003, lng: 21.40302734375001 },
        { lat: 42.87470703125004, lng: 21.323144531250076 },
        { lat: 42.913232421874966, lng: 21.237109375000045 },
        { lat: 42.95620117187502, lng: 21.22265625000003 },
        { lat: 43.043017578125045, lng: 21.127050781250006 },
        { lat: 43.09169921875002, lng: 21.057031250000023 },
        { lat: 43.11601562499998, lng: 20.96767578125005 },
        { lat: 43.15166015624996, lng: 20.890722656250006 },
        { lat: 43.17343750000006, lng: 20.844433593750065 },
        { lat: 43.21396484375006, lng: 20.823828125000034 },
        { lat: 43.237939453125044, lng: 20.823828125000034 },
        { lat: 43.26108398437506, lng: 20.800585937500017 },
        { lat: 43.25859374999999, lng: 20.763378906250068 },
        { lat: 43.22636718749999, lng: 20.70058593750008 },
        { lat: 43.19863281250002, lng: 20.623144531250002 },
        { lat: 43.17841796875001, lng: 20.609667968750014 },
        { lat: 43.130371093749964, lng: 20.637597656250023 },
        { lat: 43.09985351562497, lng: 20.65761718750002 },
        { lat: 43.070947265625044, lng: 20.648535156250034 },
        { lat: 43.03417968750002, lng: 20.62402343750003 },
        { lat: 42.953027343749994, lng: 20.475097656250057 },
        { lat: 42.92456054687497, lng: 20.458398437500023 },
        { lat: 42.87905273437502, lng: 20.48681640625003 },
        { lat: 42.85791015625, lng: 20.468847656250034 },
        { lat: 42.82792968750002, lng: 20.344335937500063 },
        { lat: 42.852783203125, lng: 20.34765625000003 },
        { lat: 42.89287109375002, lng: 20.339941406250063 },
        { lat: 42.935449218749966, lng: 20.26845703125005 },
        { lat: 42.96850585937506, lng: 20.16787109375008 },
        { lat: 43.081640625, lng: 19.944042968750036 },
        { lat: 43.096533203125006, lng: 19.858007812500006 },
        { lat: 43.10976562500005, lng: 19.781152343750076 },
        { lat: 43.16396484374999, lng: 19.670996093750006 },
        { lat: 43.17343750000006, lng: 19.61445312500004 },
        { lat: 43.21225585937506, lng: 19.551562500000017 },
        { lat: 43.34282226562502, lng: 19.414648437500006 },
        { lat: 43.413964843750016, lng: 19.298242187500023 },
        { lat: 43.449951171875, lng: 19.21875 },
        { lat: 43.48500976562502, lng: 19.196484375000068 },
        { lat: 43.52104492187499, lng: 19.19160156250004 },
        { lat: 43.53330078125, lng: 19.19433593749997 },
        { lat: 43.584375, lng: 19.254492187500063 },
        { lat: 43.59179687500003, lng: 19.30078125 },
        { lat: 43.59345703125001, lng: 19.360351562500057 },
        { lat: 43.56757812499998, lng: 19.399609375000068 },
        { lat: 43.56206054687499, lng: 19.451269531250002 },
        { lat: 43.595166015624976, lng: 19.47998046875 },
        { lat: 43.642871093750045, lng: 19.495117187500057 },
        { lat: 43.703564453124955, lng: 19.488183593750076 },
        { lat: 43.844775390625045, lng: 19.364062500000017 },
        { lat: 43.943310546874955, lng: 19.257226562499994 },
        { lat: 43.96503906250004, lng: 19.245019531249994 },
        { lat: 43.98344726562496, lng: 19.26806640625 },
        { lat: 43.99335937500004, lng: 19.305273437500034 },
        { lat: 43.98510742187502, lng: 19.34521484375 },
        { lat: 43.97802734375, lng: 19.449414062499983 },
        { lat: 43.98710937499999, lng: 19.54951171875004 },
        { lat: 44.011083984375, lng: 19.583691406249983 },
        { lat: 44.04345703125003, lng: 19.583789062500017 },
        { lat: 44.073486328125, lng: 19.547167968750017 },
        { lat: 44.15449218749998, lng: 19.43017578124997 },
        { lat: 44.22583007812506, lng: 19.33886718750003 },
        { lat: 44.28056640625002, lng: 19.231542968750006 },
        { lat: 44.302539062500045, lng: 19.15185546875003 },
        { lat: 44.33027343750001, lng: 19.128320312500023 },
        { lat: 44.359960937500006, lng: 19.118457031250074 },
        { lat: 44.41455078125003, lng: 19.127343750000023 },
        { lat: 44.48378906250002, lng: 19.132421875000063 },
        { lat: 44.52734375, lng: 19.15136718750003 },
        { lat: 44.609570312499976, lng: 19.22314453125 },
        { lat: 44.69677734374997, lng: 19.29189453125005 },
        { lat: 44.780664062500016, lng: 19.33447265625003 },
        { lat: 44.858544921874994, lng: 19.35683593750005 },
        { lat: 44.88090820312502, lng: 19.348632812500057 },
        { lat: 44.8974609375, lng: 19.31269531250004 },
        { lat: 44.914257812499955, lng: 19.23681640625003 },
        { lat: 44.89960937500001, lng: 19.131542968750065 },
        { lat: 44.87133789062503, lng: 19.042089843750063 },
        { lat: 44.86918945312502, lng: 19.007128906250045 },
        { lat: 44.90400390625001, lng: 18.99550781250008 },
        { lat: 44.91938476562504, lng: 19.00957031249999 },
        { lat: 44.91752929687502, lng: 19.037597656250025 },
        { lat: 44.910986328125006, lng: 19.060546875 },
        { lat: 44.92675781250003, lng: 19.085253906250042 },
        { lat: 44.973779296875016, lng: 19.1 },
        { lat: 45.13720703125, lng: 19.062890625000023 },
        { lat: 45.151708984375034, lng: 19.129687500000045 },
        { lat: 45.17548828124998, lng: 19.13076171875008 },
        { lat: 45.19624023437504, lng: 19.13691406250001 },
        { lat: 45.16777343750002, lng: 19.205957031250048 },
        { lat: 45.16728515624999, lng: 19.303027343750017 },
        { lat: 45.17299804687502, lng: 19.388085937500023 },
        { lat: 45.1890625, lng: 19.400976562500063 },
        { lat: 45.2125, lng: 19.4 },
        { lat: 45.230615234375016, lng: 19.38232421875 },
        { lat: 45.24541015625002, lng: 19.35224609375001 },
        { lat: 45.26806640625003, lng: 19.330273437500068 },
        { lat: 45.277978515624994, lng: 19.27285156250008 },
        { lat: 45.33691406249999, lng: 19.093066406250045 },
        { lat: 45.39951171875006, lng: 19.004687500000074 },
        { lat: 45.46582031249997, lng: 19.007617187500045 },
        { lat: 45.50219726562503, lng: 19.033300781250034 },
        { lat: 45.51499023437506, lng: 19.064257812500045 },
        { lat: 45.527246093749966, lng: 19.055078125000023 },
        { lat: 45.55800781250002, lng: 18.953710937499977 },
        { lat: 45.60083007812503, lng: 18.91787109375005 },
        { lat: 45.65581054687496, lng: 18.947265625 },
        { lat: 45.76708984374997, lng: 18.89453125 },
        { lat: 45.83574218750002, lng: 18.839062499999983 },
        { lat: 45.86552734374995, lng: 18.8935546875 },
        { lat: 45.90761718750002, lng: 18.90107421875001 },
        { lat: 45.931738281250034, lng: 18.905371093750006 },
        { lat: 45.93139648437497, lng: 18.927832031250034 },
        { lat: 45.95971679687497, lng: 19.015722656250006 },
        { lat: 45.98266601562503, lng: 19.047656250000045 },
        { lat: 46.00952148437499, lng: 19.06621093750007 },
        { lat: 46.01616210937502, lng: 19.087304687500023 },
        { lat: 45.987011718750004, lng: 19.146289062500045 },
        { lat: 45.98442382812502, lng: 19.208398437499994 },
        { lat: 46.00288085937498, lng: 19.278125 },
        { lat: 46.028515624999955, lng: 19.330273437500068 },
        { lat: 46.04980468750002, lng: 19.392871093750017 },
        { lat: 46.06445312499999, lng: 19.421289062500023 },
        { lat: 46.08735351562504, lng: 19.457519531250057 },
        { lat: 46.155175781249994, lng: 19.530761718750057 },
        { lat: 46.169189453125, lng: 19.61347656250001 },
        { lat: 46.151904296875045, lng: 19.72451171875008 },
      ],
    ],
  },
  {
    code: "SM",
    coordinates: [
      [
        { lat: 43.90141601562499, lng: 12.485253906250023 },
        { lat: 43.894091796874996, lng: 12.426367187500006 },
        { lat: 43.93457031249999, lng: 12.396875 },
        { lat: 43.982421875, lng: 12.441113281250011 },
        { lat: 43.98974609375, lng: 12.503710937500017 },
        { lat: 43.952978515625, lng: 12.514648437499998 },
        { lat: 43.90141601562499, lng: 12.485253906250023 },
      ],
    ],
  },
  {
    code: "RU",
    coordinates: [
      [
        { lat: 43.409326171874966, lng: 146.0456054687501 },
        { lat: 43.407128906249966, lng: 146.03232421875003 },
        { lat: 43.42036132812501, lng: 146.0280273437501 },
        { lat: 43.43359375000003, lng: 146.04892578125006 },
        { lat: 43.44902343749999, lng: 146.08857421875 },
        { lat: 43.44018554687503, lng: 146.10078125000004 },
        { lat: 43.42919921875003, lng: 146.08632812500005 },
        { lat: 43.42148437500006, lng: 146.06992187500006 },
        { lat: 43.409326171874966, lng: 146.0456054687501 },
      ],
      [
        { lat: 43.45952148437499, lng: 145.8815429687501 },
        { lat: 43.45454101562504, lng: 145.89560546875012 },
        { lat: 43.45537109375002, lng: 145.91386718750002 },
        { lat: 43.45703125, lng: 145.93115234374997 },
        { lat: 43.445458984375044, lng: 145.94111328125004 },
        { lat: 43.42646484375001, lng: 145.9435546875001 },
        { lat: 43.425634765625006, lng: 145.93115234374997 },
        { lat: 43.422314453124955, lng: 145.90722656249997 },
        { lat: 43.419824218749966, lng: 145.89394531250005 },
        { lat: 43.43305664062501, lng: 145.88652343750002 },
        { lat: 43.44379882812498, lng: 145.8815429687501 },
        { lat: 43.450439453125, lng: 145.86914062500003 },
        { lat: 43.457861328125006, lng: 145.86914062500003 },
        { lat: 43.45952148437499, lng: 145.8815429687501 },
      ],
      [
        { lat: 43.62539062500002, lng: 146.35878906250005 },
        { lat: 43.61992187499999, lng: 146.33232421875007 },
        { lat: 43.62539062500002, lng: 146.28818359375006 },
        { lat: 43.629833984374955, lng: 146.27382812500005 },
        { lat: 43.638623046874955, lng: 146.28369140625003 },
        { lat: 43.65185546875, lng: 146.31015625000006 },
        { lat: 43.6474609375, lng: 146.33330078125002 },
        { lat: 43.644140625000034, lng: 146.3498046875001 },
        { lat: 43.62539062500002, lng: 146.35878906250005 },
      ],
      [
        { lat: 43.743798828124994, lng: 146.71396484375012 },
        { lat: 43.71635742187499, lng: 146.6830078125 },
        { lat: 43.74047851562503, lng: 146.60859375 },
        { lat: 43.797021484374994, lng: 146.61347656250004 },
        { lat: 43.81298828125005, lng: 146.62197265625 },
        { lat: 43.86049804687505, lng: 146.824609375 },
        { lat: 43.82915039062496, lng: 146.88408203125002 },
        { lat: 43.80415039062504, lng: 146.89902343750006 },
        { lat: 43.743798828124994, lng: 146.71396484375012 },
      ],
      [
        { lat: 44.49765625, lng: 146.20761718750006 },
        { lat: 44.42460937500004, lng: 146.35595703125003 },
        { lat: 44.44042968749997, lng: 146.5677734375 },
        { lat: 44.374658203124994, lng: 146.51621093750006 },
        { lat: 44.37568359375001, lng: 146.43652343749997 },
        { lat: 44.28095703125001, lng: 146.29619140625002 },
        { lat: 44.26865234374998, lng: 146.17294921875012 },
        { lat: 44.24594726562506, lng: 146.11230468750003 },
        { lat: 44.10371093750004, lng: 145.91406249999997 },
        { lat: 44.047753906249994, lng: 145.88730468750012 },
        { lat: 43.94072265624996, lng: 145.76699218749997 },
        { lat: 43.84511718750002, lng: 145.58681640625 },
        { lat: 43.66459960937502, lng: 145.5558593750001 },
        { lat: 43.73706054687502, lng: 145.43925781250002 },
        { lat: 43.81035156249995, lng: 145.42617187500005 },
        { lat: 43.870898437500045, lng: 145.46171875000005 },
        { lat: 43.999072265625045, lng: 145.66630859375002 },
        { lat: 44.07153320312506, lng: 145.74833984375002 },
        { lat: 44.129003906250034, lng: 145.77333984375005 },
        { lat: 44.19301757812502, lng: 145.851953125 },
        { lat: 44.24858398437499, lng: 145.89023437500006 },
        { lat: 44.27265624999998, lng: 145.94042968749997 },
        { lat: 44.500146484374966, lng: 146.11210937500007 },
        { lat: 44.49765625, lng: 146.20761718750006 },
      ],
      [
        { lat: 45.317626953125, lng: 148.59951171875 },
        { lat: 45.247167968750034, lng: 148.41464843750012 },
        { lat: 45.21684570312495, lng: 148.26230468750006 },
        { lat: 45.070166015625034, lng: 148.0052734375 },
        { lat: 44.99038085937502, lng: 147.91376953125 },
        { lat: 44.958593750000034, lng: 147.78408203125 },
        { lat: 44.97714843749998, lng: 147.65781250000012 },
        { lat: 44.94472656250005, lng: 147.621875 },
        { lat: 44.886572265625006, lng: 147.60957031250004 },
        { lat: 44.835546875, lng: 147.56308593750006 },
        { lat: 44.67763671874999, lng: 147.31015625000006 },
        { lat: 44.553564453125034, lng: 147.20742187499997 },
        { lat: 44.53125, lng: 147.09843750000002 },
        { lat: 44.404296875, lng: 146.8974609375 },
        { lat: 44.513085937500044, lng: 146.93349609375 },
        { lat: 44.56572265625001, lng: 146.9742187500001 },
        { lat: 44.663330078125, lng: 147.14091796875007 },
        { lat: 44.766210937500006, lng: 147.15478515625003 },
        { lat: 44.856054687500006, lng: 147.24658203124997 },
        { lat: 44.94521484374996, lng: 147.43046875000005 },
        { lat: 45.062451171874955, lng: 147.5578125000001 },
        { lat: 45.09301757812497, lng: 147.65791015625004 },
        { lat: 45.19072265624999, lng: 147.76943359375 },
        { lat: 45.22563476562499, lng: 147.88554687500007 },
        { lat: 45.30029296875, lng: 147.87265625000006 },
        { lat: 45.38330078125006, lng: 147.9240234375001 },
        { lat: 45.37773437499999, lng: 147.96455078125 },
        { lat: 45.262109375000044, lng: 148.05605468750002 },
        { lat: 45.25820312500005, lng: 148.13007812500004 },
        { lat: 45.28242187500001, lng: 148.32421874999997 },
        { lat: 45.48466796874999, lng: 148.61230468749994 },
        { lat: 45.52065429687505, lng: 148.70664062500006 },
        { lat: 45.52646484374998, lng: 148.77265625000004 },
        { lat: 45.510009765625, lng: 148.8122070312501 },
        { lat: 45.48608398437502, lng: 148.82617187500003 },
        { lat: 45.455908203125006, lng: 148.82539062500004 },
        { lat: 45.41352539062498, lng: 148.80302734375002 },
        { lat: 45.36269531250002, lng: 148.83710937500004 },
        { lat: 45.32397460937503, lng: 148.79072265625007 },
        { lat: 45.317626953125, lng: 148.59951171875 },
      ],
      [
        { lat: 45.48823242187501, lng: 47.983007812500006 },
        { lat: 45.46997070312503, lng: 47.967675781249994 },
        { lat: 45.56206054687496, lng: 47.92031250000005 },
        { lat: 45.61816406250003, lng: 47.917578125 },
        { lat: 45.647070312500034, lng: 47.947167968749994 },
        { lat: 45.554052734375006, lng: 47.987109375000074 },
        { lat: 45.48823242187501, lng: 47.983007812500006 },
      ],
      [
        { lat: 45.64204101562501, lng: 149.68769531250004 },
        { lat: 45.59135742187499, lng: 149.53886718750005 },
        { lat: 45.593359375000034, lng: 149.44707031250002 },
        { lat: 45.839794921874955, lng: 149.66591796875005 },
        { lat: 45.87607421874998, lng: 149.79628906250005 },
        { lat: 46.02192382812504, lng: 149.9623046875 },
        { lat: 46.200341796874966, lng: 150.3087890625001 },
        { lat: 46.21342773437496, lng: 150.34863281250003 },
        { lat: 46.208544921875045, lng: 150.553125 },
        { lat: 46.012304687500034, lng: 150.23457031250004 },
        { lat: 45.93320312499998, lng: 150.1950195312501 },
        { lat: 45.84936523437506, lng: 150.05664062499997 },
        { lat: 45.82246093749998, lng: 149.95410156250003 },
        { lat: 45.78315429687498, lng: 149.88339843750012 },
        { lat: 45.64204101562501, lng: 149.68769531250004 },
      ],
      [
        { lat: 46.89716796874998, lng: 152.00205078125006 },
        { lat: 46.78710937500005, lng: 151.815625 },
        { lat: 46.78833007812502, lng: 151.7541015625001 },
        { lat: 46.82880859375001, lng: 151.72343750000005 },
        { lat: 46.852685546874994, lng: 151.71533203125003 },
        { lat: 46.868994140625034, lng: 151.86435546875003 },
        { lat: 47.014990234375006, lng: 152.03984375000002 },
        { lat: 47.110449218750006, lng: 152.16582031250002 },
        { lat: 47.14340820312498, lng: 152.23466796875 },
        { lat: 47.1421875, lng: 152.28886718750007 },
        { lat: 46.89716796874998, lng: 152.00205078125006 },
      ],
      [
        { lat: 47.762939453124964, lng: 153.10107421874994 },
        { lat: 47.706103515625045, lng: 153.05380859375012 },
        { lat: 47.713476562500034, lng: 153.00410156250004 },
        { lat: 47.72792968750005, lng: 152.98427734374997 },
        { lat: 47.797021484374994, lng: 153.04912109375007 },
        { lat: 47.808740234374994, lng: 153.07919921875003 },
        { lat: 47.762939453124964, lng: 153.10107421874994 },
      ],
      [
        { lat: 48.79028320312502, lng: 154.08125 },
        { lat: 48.73876953125, lng: 154.04296875 },
        { lat: 48.755712890625006, lng: 154.00068359375 },
        { lat: 48.77250976562496, lng: 153.99228515625006 },
        { lat: 48.832128906250034, lng: 154.09169921875 },
        { lat: 48.904443359375016, lng: 154.12636718750005 },
        { lat: 48.90493164062502, lng: 154.19902343750002 },
        { lat: 48.89208984374997, lng: 154.22841796875005 },
        { lat: 48.85717773437497, lng: 154.20468750000012 },
        { lat: 48.79028320312502, lng: 154.08125 },
      ],
      [
        { lat: 49.31201171875, lng: 154.81044921875005 },
        { lat: 49.267675781250034, lng: 154.71484375000003 },
        { lat: 49.29404296874998, lng: 154.61093750000006 },
        { lat: 49.38061523437503, lng: 154.61298828125004 },
        { lat: 49.64692382812501, lng: 154.82490234375004 },
        { lat: 49.63037109375003, lng: 154.8996093750001 },
        { lat: 49.56640625000006, lng: 154.88330078124997 },
        { lat: 49.46826171875003, lng: 154.80234375000006 },
        { lat: 49.34790039062503, lng: 154.82988281250002 },
        { lat: 49.31201171875, lng: 154.81044921875005 },
      ],
      [
        { lat: 50.30219726562501, lng: 155.9210937500001 },
        { lat: 50.20205078125005, lng: 155.7923828125 },
        { lat: 50.17724609374997, lng: 155.60751953125003 },
        { lat: 50.14560546875, lng: 155.51640625000007 },
        { lat: 50.07778320312505, lng: 155.4489257812501 },
        { lat: 50.04125976562497, lng: 155.39716796875004 },
        { lat: 50.06118164062505, lng: 155.28867187500006 },
        { lat: 50.094628906250016, lng: 155.24306640625 },
        { lat: 50.21279296875002, lng: 155.24306640625 },
        { lat: 50.264550781249994, lng: 155.19511718750002 },
        { lat: 50.29785156250003, lng: 155.21835937500012 },
        { lat: 50.29326171874999, lng: 155.32675781250006 },
        { lat: 50.368945312500045, lng: 155.43388671875007 },
        { lat: 50.400732421875034, lng: 155.68017578124997 },
        { lat: 50.48242187499997, lng: 155.77275390625007 },
        { lat: 50.68413085937502, lng: 155.88476562499997 },
        { lat: 50.756933593750034, lng: 156.0016601562501 },
        { lat: 50.771875, lng: 156.096875 },
        { lat: 50.671289062499994, lng: 156.12285156250002 },
        { lat: 50.55927734374998, lng: 156.10058593749997 },
        { lat: 50.451757812500034, lng: 156.04443359375003 },
        { lat: 50.30219726562501, lng: 155.9210937500001 },
      ],
      [
        { lat: 50.65761718750005, lng: 156.40507812500002 },
        { lat: 50.6337890625, lng: 156.36542968750004 },
        { lat: 50.6390625, lng: 156.32578125000012 },
        { lat: 50.702148437499964, lng: 156.19628906250003 },
        { lat: 50.73188476562498, lng: 156.16796874999994 },
        { lat: 50.78471679687502, lng: 156.2130859375001 },
        { lat: 50.86210937499996, lng: 156.37646484374994 },
        { lat: 50.85957031249998, lng: 156.45585937500007 },
        { lat: 50.84296874999998, lng: 156.4875 },
        { lat: 50.75122070312503, lng: 156.48310546875004 },
        { lat: 50.65761718750005, lng: 156.40507812500002 },
      ],
      [
        { lat: 50.82192382812502, lng: 155.64482421875002 },
        { lat: 50.810595703125045, lng: 155.55351562500002 },
        { lat: 50.837304687499966, lng: 155.51279296875006 },
        { lat: 50.86962890624997, lng: 155.48349609375012 },
        { lat: 50.91357421875006, lng: 155.46738281250006 },
        { lat: 50.93447265625005, lng: 155.56855468750004 },
        { lat: 50.910498046875055, lng: 155.63964843749997 },
        { lat: 50.84536132812502, lng: 155.65361328125007 },
        { lat: 50.82192382812502, lng: 155.64482421875002 },
      ],
      [
        { lat: 54.393945312499966, lng: 142.76103515625 },
        { lat: 54.14096679687503, lng: 142.97617187500006 },
        { lat: 54.08569335937497, lng: 142.98593750000006 },
        { lat: 54.02880859375003, lng: 142.96708984375005 },
        { lat: 53.95561523437502, lng: 142.92656250000007 },
        { lat: 53.87836914062501, lng: 142.91142578125002 },
        { lat: 53.810937500000044, lng: 142.93642578125005 },
        { lat: 53.79423828125002, lng: 142.91796875000003 },
        { lat: 53.488671875000016, lng: 143.09550781250002 },
        { lat: 53.29604492187505, lng: 143.22363281250003 },
        { lat: 53.21728515624997, lng: 143.25996093750004 },
        { lat: 53.134375, lng: 143.28789062500007 },
        { lat: 52.96308593749998, lng: 143.32470703125003 },
        { lat: 52.700048828125034, lng: 143.33261718750012 },
        { lat: 52.61357421874999, lng: 143.32363281250005 },
        { lat: 52.529150390625034, lng: 143.29511718750004 },
        { lat: 52.47866210937505, lng: 143.26425781250012 },
        { lat: 52.44291992187496, lng: 143.20097656250002 },
        { lat: 52.349365234375, lng: 143.17226562500005 },
        { lat: 52.08374023437497, lng: 143.15556640625 },
        { lat: 51.94448242187502, lng: 143.190625 },
        { lat: 51.847900390624964, lng: 143.2505859375001 },
        { lat: 51.74433593750001, lng: 143.29472656250002 },
        { lat: 51.63237304687504, lng: 143.29951171875 },
        { lat: 51.58325195312497, lng: 143.32050781250004 },
        { lat: 51.520605468750006, lng: 143.41777343750007 },
        { lat: 51.47148437500002, lng: 143.45546875 },
        { lat: 51.40190429687499, lng: 143.46738281250012 },
        { lat: 51.29921875000002, lng: 143.47294921875002 },
        { lat: 51.27705078125004, lng: 143.48876953125003 },
        { lat: 51.24628906249998, lng: 143.53417968749997 },
        { lat: 50.50673828125005, lng: 143.73603515625004 },
        { lat: 50.28261718750002, lng: 143.81601562500006 },
        { lat: 49.895751953125, lng: 144.04794921875003 },
        { lat: 49.661474609375055, lng: 144.14130859375007 },
        { lat: 49.54975585937504, lng: 144.199609375 },
        { lat: 49.43203125000002, lng: 144.23994140625004 },
        { lat: 49.311328125000045, lng: 144.27207031250012 },
        { lat: 49.180517578125034, lng: 144.3412109375 },
        { lat: 49.051074218750045, lng: 144.4317382812501 },
        { lat: 48.93583984375002, lng: 144.6068359375 },
        { lat: 48.871240234374994, lng: 144.68554687499997 },
        { lat: 48.81953125000004, lng: 144.70664062500006 },
        { lat: 48.64028320312502, lng: 144.71376953125 },
        { lat: 48.678564453125006, lng: 144.67265625000002 },
        { lat: 48.814843749999966, lng: 144.62099609375005 },
        { lat: 48.89355468750002, lng: 144.53632812500004 },
        { lat: 48.98637695312502, lng: 144.41181640625004 },
        { lat: 49.06977539062503, lng: 144.28378906250006 },
        { lat: 49.20854492187496, lng: 144.12548828124997 },
        { lat: 49.249169921874994, lng: 144.04873046875 },
        { lat: 49.27631835937501, lng: 143.96777343750003 },
        { lat: 49.30859375000002, lng: 143.81914062500002 },
        { lat: 49.31201171875, lng: 143.73232421875 },
        { lat: 49.290673828124994, lng: 143.3822265625 },
        { lat: 49.26284179687502, lng: 143.23632812500003 },
        { lat: 49.198828125000034, lng: 143.10498046875 },
        { lat: 49.10541992187501, lng: 143.02685546874997 },
        { lat: 48.91777343749999, lng: 142.97167968750003 },
        { lat: 48.246875, lng: 142.65097656250006 },
        { lat: 48.07216796875002, lng: 142.57421874999997 },
        { lat: 47.884912109374966, lng: 142.54589843749997 },
        { lat: 47.73789062500003, lng: 142.55693359375002 },
        { lat: 47.68398437499996, lng: 142.57900390625005 },
        { lat: 47.536914062500045, lng: 142.67011718750004 },
        { lat: 47.45239257812506, lng: 142.74541015625002 },
        { lat: 47.416162109375016, lng: 142.80078125000003 },
        { lat: 47.39179687499995, lng: 142.86396484375 },
        { lat: 47.36186523437499, lng: 142.90546875000004 },
        { lat: 47.32275390625, lng: 142.94033203125005 },
        { lat: 47.22270507812495, lng: 143.0055664062501 },
        { lat: 47.00078125, lng: 143.08925781249997 },
        { lat: 46.84404296875002, lng: 143.17792968750004 },
        { lat: 46.79487304687504, lng: 143.21767578125005 },
        { lat: 46.807373046875, lng: 143.31865234375002 },
        { lat: 46.8056640625, lng: 143.384375 },
        { lat: 46.79199218749997, lng: 143.44726562500003 },
        { lat: 46.752050781250006, lng: 143.48564453125002 },
        { lat: 46.57509765625002, lng: 143.54033203125007 },
        { lat: 46.406054687500045, lng: 143.57871093750003 },
        { lat: 46.360693359375034, lng: 143.58066406250012 },
        { lat: 46.23017578125001, lng: 143.50859375000007 },
        { lat: 46.17460937499996, lng: 143.490625 },
        { lat: 46.11582031249998, lng: 143.48232421875005 },
        { lat: 46.06948242187505, lng: 143.4634765625001 },
        { lat: 46.02866210937498, lng: 143.43164062500003 },
        { lat: 46.222021484375034, lng: 143.41865234375004 },
        { lat: 46.35849609375003, lng: 143.37031250000004 },
        { lat: 46.47622070312502, lng: 143.35214843750006 },
        { lat: 46.55898437500002, lng: 143.28232421875006 },
        { lat: 46.592626953125034, lng: 143.04785156250003 },
        { lat: 46.605273437500045, lng: 142.82929687500004 },
        { lat: 46.62021484375006, lng: 142.7955078125001 },
        { lat: 46.67065429687502, lng: 142.74736328125007 },
        { lat: 46.71083984375005, lng: 142.69189453124997 },
        { lat: 46.716210937499994, lng: 142.63574218749997 },
        { lat: 46.700781250000034, lng: 142.57802734375002 },
        { lat: 46.64423828124998, lng: 142.47880859375007 },
        { lat: 46.55468750000003, lng: 142.4064453125001 },
        { lat: 46.45869140625001, lng: 142.35 },
        { lat: 46.35756835937502, lng: 142.30400390625007 },
        { lat: 46.0888671875, lng: 142.20859375000006 },
        { lat: 45.99926757812503, lng: 142.14970703125005 },
        { lat: 45.91704101562499, lng: 142.07714843749994 },
        { lat: 45.961621093750004, lng: 142.015625 },
        { lat: 46.01347656249999, lng: 141.96162109375004 },
        { lat: 46.08828125000005, lng: 141.92998046875007 },
        { lat: 46.17075195312497, lng: 141.91630859375007 },
        { lat: 46.451074218749966, lng: 141.83037109375002 },
        { lat: 46.694189453125034, lng: 141.86650390625002 },
        { lat: 47.030322265625045, lng: 142.01103515625007 },
        { lat: 47.14028320312496, lng: 142.0386718750001 },
        { lat: 47.24467773437502, lng: 142.01689453125 },
        { lat: 47.347705078125045, lng: 141.98417968750002 },
        { lat: 47.543798828125006, lng: 141.9625 },
        { lat: 47.58745117187502, lng: 141.9640625000001 },
        { lat: 47.700634765624976, lng: 142.015625 },
        { lat: 47.808349609375, lng: 142.07597656250007 },
        { lat: 47.90214843750002, lng: 142.14921875000007 },
        { lat: 48.01337890625001, lng: 142.18173828125012 },
        { lat: 48.29008789062498, lng: 142.13535156250006 },
        { lat: 48.47709960937499, lng: 142.02871093750005 },
        { lat: 48.65468750000002, lng: 141.89726562500007 },
        { lat: 48.70195312499996, lng: 141.87304687500003 },
        { lat: 48.750097656250006, lng: 141.86630859375003 },
        { lat: 48.97216796875006, lng: 141.97958984375006 },
        { lat: 49.078466796875034, lng: 142.02011718750006 },
        { lat: 49.31206054687501, lng: 142.06650390625012 },
        { lat: 49.43964843749998, lng: 142.10869140625007 },
        { lat: 49.56914062499999, lng: 142.1422851562501 },
        { lat: 50.21674804687501, lng: 142.153125 },
        { lat: 50.312109375, lng: 142.14306640624997 },
        { lat: 50.514990234375034, lng: 142.07109375000007 },
        { lat: 50.630468750000034, lng: 142.06601562500006 },
        { lat: 50.776464843750006, lng: 142.10048828125 },
        { lat: 50.89018554687499, lng: 142.14726562500002 },
        { lat: 50.99848632812503, lng: 142.20791015625005 },
        { lat: 51.22255859375002, lng: 142.20673828125004 },
        { lat: 51.429394531249976, lng: 142.09072265625005 },
        { lat: 51.52050781249997, lng: 142.00595703125012 },
        { lat: 51.630029296874994, lng: 141.87294921874997 },
        { lat: 51.690185546875, lng: 141.771875 },
        { lat: 51.73632812499997, lng: 141.72236328125004 },
        { lat: 51.751806640625034, lng: 141.771875 },
        { lat: 51.78920898437502, lng: 141.80810546875003 },
        { lat: 51.846777343750006, lng: 141.72099609375007 },
        { lat: 51.93334960937497, lng: 141.66845703125003 },
        { lat: 52.27294921874997, lng: 141.66083984375004 },
        { lat: 52.35913085937502, lng: 141.68242187500002 },
        { lat: 52.45483398437499, lng: 141.74755859374997 },
        { lat: 52.555615234375004, lng: 141.8033203125001 },
        { lat: 52.79350585937499, lng: 141.85556640625012 },
        { lat: 53.03891601562506, lng: 141.87363281250006 },
        { lat: 53.13847656249999, lng: 141.83886718749997 },
        { lat: 53.33950195312502, lng: 141.82353515625007 },
        { lat: 53.38945312499996, lng: 141.85244140625 },
        { lat: 53.456396484375034, lng: 141.96445312500006 },
        { lat: 53.49560546875003, lng: 142.1419921875 },
        { lat: 53.484033203124966, lng: 142.1798828125001 },
        { lat: 53.40546875000004, lng: 142.31894531250012 },
        { lat: 53.402539062499976, lng: 142.37050781250005 },
        { lat: 53.410742187500034, lng: 142.4240234375001 },
        { lat: 53.44746093749998, lng: 142.52617187500002 },
        { lat: 53.536767578124966, lng: 142.58349609374997 },
        { lat: 53.58759765625001, lng: 142.50917968750005 },
        { lat: 53.652636718750045, lng: 142.55253906250007 },
        { lat: 53.67436523437501, lng: 142.67958984375005 },
        { lat: 53.73017578125001, lng: 142.68886718750005 },
        { lat: 53.73676757812504, lng: 142.64287109375002 },
        { lat: 53.816015625, lng: 142.6830078125 },
        { lat: 53.89570312499998, lng: 142.70595703124997 },
        { lat: 53.968408203124966, lng: 142.67021484375007 },
        { lat: 54.14853515624998, lng: 142.46660156250007 },
        { lat: 54.280712890625004, lng: 142.33496093749997 },
        { lat: 54.278955078124994, lng: 142.55166015625 },
        { lat: 54.30361328125005, lng: 142.615625 },
        { lat: 54.35820312499999, lng: 142.66621093750004 },
        { lat: 54.41611328125006, lng: 142.69277343750005 },
        { lat: 54.393945312499966, lng: 142.76103515625 },
      ],
      [
        { lat: 54.56499023437502, lng: 168.03906249999997 },
        { lat: 54.51274414062502, lng: 168.08134765625007 },
        { lat: 54.69765625000002, lng: 167.67734375000012 },
        { lat: 54.79497070312496, lng: 167.4880859375 },
        { lat: 54.85585937500002, lng: 167.44150390625012 },
        { lat: 54.85693359374997, lng: 167.51171875000003 },
        { lat: 54.797753906249994, lng: 167.59248046875 },
        { lat: 54.77016601562496, lng: 167.71064453125004 },
        { lat: 54.69047851562499, lng: 167.8826171875 },
        { lat: 54.56499023437502, lng: 168.03906249999997 },
      ],
      [
        { lat: 55.100439453125034, lng: 137.17861328125005 },
        { lat: 54.9267578125, lng: 137.05527343750006 },
        { lat: 54.923974609375044, lng: 136.96943359375004 },
        { lat: 54.960644531249955, lng: 136.90273437500005 },
        { lat: 54.946044921875, lng: 136.76513671874997 },
        { lat: 54.956152343750034, lng: 136.71464843750002 },
        { lat: 55.009375, lng: 136.7953125 },
        { lat: 55.092724609374955, lng: 136.99570312500006 },
        { lat: 55.09174804687504, lng: 137.07753906250005 },
        { lat: 55.10781250000002, lng: 137.15605468750007 },
        { lat: 55.100439453125034, lng: 137.17861328125005 },
      ],
      [
        { lat: 55.09262695312503, lng: 137.94052734375012 },
        { lat: 55.0533203125, lng: 138.03125 },
        { lat: 55.06005859374997, lng: 138.1720703125001 },
        { lat: 55.03354492187498, lng: 138.20615234375012 },
        { lat: 54.99091796875001, lng: 138.09648437500007 },
        { lat: 54.90087890625006, lng: 138.01660156249997 },
        { lat: 54.820703124999966, lng: 137.99121093750003 },
        { lat: 54.78901367187498, lng: 137.95947265624997 },
        { lat: 54.749560546875045, lng: 137.87011718749997 },
        { lat: 54.69692382812496, lng: 137.79023437500004 },
        { lat: 54.663232421875044, lng: 137.72148437500005 },
        { lat: 54.653271484374955, lng: 137.66113281250003 },
        { lat: 54.825830078125016, lng: 137.52558593750004 },
        { lat: 54.873388671875034, lng: 137.46269531250002 },
        { lat: 54.79238281249996, lng: 137.2760742187501 },
        { lat: 54.79057617187495, lng: 137.23291015624997 },
        { lat: 54.89101562499999, lng: 137.27519531250002 },
        { lat: 55.000683593749955, lng: 137.38437500000012 },
        { lat: 55.016015624999966, lng: 137.43554687499997 },
        { lat: 55.1630859375, lng: 137.54365234375 },
        { lat: 55.19702148437497, lng: 137.5773437500001 },
        { lat: 55.11005859375004, lng: 137.91044921875002 },
        { lat: 55.09262695312503, lng: 137.94052734375012 },
      ],
      [
        { lat: 54.955664062500006, lng: 20.677734375000025 },
        { lat: 54.94702148437503, lng: 20.774023437500034 },
        { lat: 54.90947265625002, lng: 20.8875 },
        { lat: 54.90268554687506, lng: 20.995898437500017 },
        { lat: 54.93520507812502, lng: 21.18886718750008 },
        { lat: 55.107763671875006, lng: 21.222851562500065 },
        { lat: 55.26411132812498, lng: 21.235742187500023 },
        { lat: 55.264453125000045, lng: 21.297558593750008 },
        { lat: 55.275537109374994, lng: 21.389257812500034 },
        { lat: 55.23442382812496, lng: 21.447070312500017 },
        { lat: 55.1953125, lng: 21.5546875 },
        { lat: 55.160351562499976, lng: 21.682714843750063 },
        { lat: 55.100732421874994, lng: 21.873925781250023 },
        { lat: 55.06367187499998, lng: 22.072363281250034 },
        { lat: 55.059375, lng: 22.137890625000068 },
        { lat: 55.06425781250002, lng: 22.346386718750068 },
        { lat: 55.05913085937496, lng: 22.56728515625005 },
        { lat: 54.970703124999964, lng: 22.627441406250057 },
        { lat: 54.928857421874966, lng: 22.736523437500068 },
        { lat: 54.87128906249998, lng: 22.824707031249996 },
        { lat: 54.838476562500034, lng: 22.83125 },
        { lat: 54.63261718750002, lng: 22.70966796875001 },
        { lat: 54.56293945312504, lng: 22.684472656250023 },
        { lat: 54.493017578125006, lng: 22.679882812500068 },
        { lat: 54.405615234375034, lng: 22.724316406250068 },
        { lat: 54.356787109375034, lng: 22.766210937499977 },
        { lat: 54.35009765625003, lng: 22.73183593750008 },
        { lat: 54.35986328125005, lng: 22.168457031250053 },
        { lat: 54.37646484374997, lng: 21.634179687500023 },
        { lat: 54.39179687499998, lng: 21.14052734375008 },
        { lat: 54.40664062499999, lng: 20.664746093750036 },
        { lat: 54.420751953125034, lng: 20.20820312500004 },
        { lat: 54.433984374999966, lng: 19.92431640625003 },
        { lat: 54.44707031249995, lng: 19.644238281250068 },
        { lat: 54.45917968750003, lng: 19.604394531250023 },
        { lat: 54.54482421874999, lng: 19.758496093750068 },
        { lat: 54.63383789062499, lng: 19.85888671875 },
        { lat: 54.75, lng: 19.944140625000074 },
        { lat: 54.83046875, lng: 19.953222656250034 },
        { lat: 54.92119140625002, lng: 19.974511718750023 },
        { lat: 54.956494140625004, lng: 20.107617187500068 },
        { lat: 54.951269531250006, lng: 20.396679687500068 },
        { lat: 54.994873046875, lng: 20.520312500000017 },
        { lat: 55.102636718750034, lng: 20.67890625000001 },
        { lat: 55.23203125, lng: 20.845703125000057 },
        { lat: 55.286669921875045, lng: 20.899804687500076 },
        { lat: 55.27890625000006, lng: 20.957812500000074 },
        { lat: 55.18364257812502, lng: 20.859375 },
        { lat: 54.982373046874955, lng: 20.594824218750006 },
        { lat: 54.955664062500006, lng: 20.677734375000025 },
      ],
      [
        { lat: 54.83906249999998, lng: 166.65029296875005 },
        { lat: 54.69409179687502, lng: 166.64511718750006 },
        { lat: 54.76762695312499, lng: 166.5212890625 },
        { lat: 54.82685546874998, lng: 166.46367187500002 },
        { lat: 54.83808593749995, lng: 166.38173828125005 },
        { lat: 54.86455078125001, lng: 166.32480468750006 },
        { lat: 54.93652343750002, lng: 166.2298828125 },
        { lat: 55.03037109375006, lng: 166.11972656250012 },
        { lat: 55.07656250000005, lng: 166.08232421875007 },
        { lat: 55.13569335937501, lng: 166.06630859375 },
        { lat: 55.19047851562499, lng: 165.99189453125007 },
        { lat: 55.29453125000003, lng: 165.75107421875006 },
        { lat: 55.30693359374998, lng: 165.83046874999997 },
        { lat: 55.351464843749994, lng: 165.93125 },
        { lat: 55.323974609375, lng: 166.21191406249997 },
        { lat: 55.311962890624955, lng: 166.27578125000005 },
        { lat: 55.24233398437496, lng: 166.22998046875003 },
        { lat: 55.16542968750002, lng: 166.24804687499997 },
        { lat: 55.00561523437497, lng: 166.404296875 },
        { lat: 54.94990234375001, lng: 166.47949218749997 },
        { lat: 54.90771484375003, lng: 166.5773437500001 },
        { lat: 54.83906249999998, lng: 166.65029296875005 },
      ],
      [
        { lat: 59.01875, lng: 150.58994140625006 },
        { lat: 59.007421875, lng: 150.5111328125 },
        { lat: 59.03476562500006, lng: 150.47177734375003 },
        { lat: 59.05405273437498, lng: 150.47021484375 },
        { lat: 59.09721679687498, lng: 150.59248046875004 },
        { lat: 59.16015625000002, lng: 150.6662109375 },
        { lat: 59.122460937499994, lng: 150.71269531250002 },
        { lat: 59.09521484375003, lng: 150.7277343750001 },
        { lat: 59.01875, lng: 150.58994140625006 },
      ],
      [
        { lat: 58.603369140625, lng: 163.63515625000002 },
        { lat: 58.509375, lng: 163.47138671875004 },
        { lat: 58.52465820312505, lng: 163.44726562500003 },
        { lat: 58.54614257812501, lng: 163.4318359375001 },
        { lat: 58.578955078125006, lng: 163.42724609374997 },
        { lat: 58.640869140625, lng: 163.57675781250012 },
        { lat: 58.798535156249976, lng: 163.7265625 },
        { lat: 58.929736328125074, lng: 163.78447265625007 },
        { lat: 58.97236328124995, lng: 163.76660156249997 },
        { lat: 59.015039062500016, lng: 163.7609375000001 },
        { lat: 59.09619140625005, lng: 164.20214843749997 },
        { lat: 59.22675781250001, lng: 164.51738281250002 },
        { lat: 59.22114257812501, lng: 164.57265625 },
        { lat: 59.112207031250016, lng: 164.62929687500005 },
        { lat: 58.97075195312499, lng: 164.66162109374997 },
        { lat: 58.885595703125034, lng: 164.61572265624997 },
        { lat: 58.838085937499955, lng: 164.27880859374994 },
        { lat: 58.74375, lng: 163.96005859375006 },
        { lat: 58.603369140625, lng: 163.63515625000002 },
      ],
      [
        { lat: 65.18208007812501, lng: 35.8161132812501 },
        { lat: 65.14267578124998, lng: 35.84843750000002 },
        { lat: 65.0779296875, lng: 35.85839843750003 },
        { lat: 65.036474609375, lng: 35.8273437500001 },
        { lat: 65.00146484374997, lng: 35.84228515625003 },
        { lat: 64.97666015625, lng: 35.77871093750005 },
        { lat: 65.05761718749997, lng: 35.68007812499999 },
        { lat: 65.05878906250004, lng: 35.621386718750074 },
        { lat: 65.093603515625, lng: 35.55859374999997 },
        { lat: 65.15107421875001, lng: 35.52890625000006 },
        { lat: 65.16708984374998, lng: 35.585742187500074 },
        { lat: 65.15712890625, lng: 35.60869140625002 },
        { lat: 65.19755859375005, lng: 35.72910156250006 },
        { lat: 65.18208007812501, lng: 35.8161132812501 },
      ],
      [
        { lat: 66.502197265625, lng: 70.02070312500004 },
        { lat: 66.48974609375006, lng: 69.84472656249997 },
        { lat: 66.56533203125, lng: 69.65136718750001 },
        { lat: 66.71596679687505, lng: 69.46933593750006 },
        { lat: 66.75107421875, lng: 69.50273437500002 },
        { lat: 66.73901367187503, lng: 69.6164062500001 },
        { lat: 66.73647460937505, lng: 69.800390625 },
        { lat: 66.71166992187497, lng: 69.91757812500006 },
        { lat: 66.69589843750003, lng: 70.07666015624996 },
        { lat: 66.627197265625, lng: 70.05761718749996 },
        { lat: 66.59946289062502, lng: 70.0572265625 },
        { lat: 66.56909179687506, lng: 70.11005859375004 },
        { lat: 66.51757812500003, lng: 70.05917968750006 },
        { lat: 66.502197265625, lng: 70.02070312500004 },
      ],
      [
        { lat: 66.70170898437507, lng: 42.713671875000074 },
        { lat: 66.68808593750003, lng: 42.67558593750002 },
        { lat: 66.73505859375001, lng: 42.47734375000002 },
        { lat: 66.77036132812503, lng: 42.460058593750055 },
        { lat: 66.785546875, lng: 42.46855468750002 },
        { lat: 66.7955078125, lng: 42.5474609375 },
        { lat: 66.78222656250003, lng: 42.631445312500006 },
        { lat: 66.73530273437498, lng: 42.690722656250074 },
        { lat: 66.70170898437507, lng: 42.713671875000074 },
      ],
      [
        { lat: 68.9404296875, lng: -179.79853515625 },
        { lat: 68.906494140625, lng: -179.59541015625 },
        { lat: 68.91713867187505, lng: -179.51450195312503 },
        { lat: 68.91240234375005, lng: -179.47084960937502 },
        { lat: 68.85297851562501, lng: -179.35595703125 },
        { lat: 68.82519531250006, lng: -179.279296875 },
        { lat: 68.75410156249995, lng: -178.873876953125 },
        { lat: 68.67514648437503, lng: -178.68930664062498 },
        { lat: 68.58564453125001, lng: -178.53852539062498 },
        { lat: 68.60307617187502, lng: -178.61367187500002 },
        { lat: 68.66044921875005, lng: -178.75146484375003 },
        { lat: 68.593017578125, lng: -178.7365234375 },
        { lat: 68.54599609375, lng: -178.69262695312503 },
        { lat: 68.50175781250005, lng: -178.47392578125 },
        { lat: 68.46665039062499, lng: -178.24448242187503 },
        { lat: 68.4248046875, lng: -178.09746093750002 },
        { lat: 68.38842773437497, lng: -178.04868164062503 },
        { lat: 68.32275390625, lng: -178.01870117187497 },
        { lat: 68.26489257812503, lng: -178.05581054687494 },
        { lat: 68.2865234375, lng: -177.92241210937496 },
        { lat: 68.33798828125, lng: -177.79677734374997 },
        { lat: 68.37822265625002, lng: -177.86181640624997 },
        { lat: 68.51855468750003, lng: -178.284521484375 },
        { lat: 68.56567382812503, lng: -178.37304687500003 },
        { lat: 68.54140624999997, lng: -178.24985351562498 },
        { lat: 68.36279296875, lng: -177.68320312499998 },
        { lat: 68.29438476562501, lng: -177.52724609375002 },
        { lat: 68.28115234374997, lng: -177.59321289062504 },
        { lat: 68.2412109375, lng: -177.63935546875004 },
        { lat: 68.22421875, lng: -177.58920898437503 },
        { lat: 68.23686523437502, lng: -177.52089843749994 },
        { lat: 68.24516601562502, lng: -177.40751953124996 },
        { lat: 68.222509765625, lng: -177.297412109375 },
        { lat: 68.17465820312503, lng: -177.171826171875 },
        { lat: 68.119140625, lng: -176.90727539062502 },
        { lat: 67.67807617187503, lng: -175.34521484374997 },
        { lat: 67.60205078125, lng: -175.30986328125002 },
        { lat: 67.56650390625003, lng: -175.26591796875002 },
        { lat: 67.52109375000003, lng: -175.23955078125 },
        { lat: 67.44667968749997, lng: -175.23251953124998 },
        { lat: 67.35737304687497, lng: -175.37470703124995 },
        { lat: 67.365380859375, lng: -175.155078125 },
        { lat: 67.37695312499997, lng: -175.122802734375 },
        { lat: 67.41342773437503, lng: -175.065625 },
        { lat: 67.4375, lng: -175.00268554687494 },
        { lat: 67.40756835937498, lng: -174.91806640625003 },
        { lat: 67.34887695312503, lng: -174.849853515625 },
        { lat: 67.26850585937498, lng: -174.869921875 },
        { lat: 67.20346679687498, lng: -174.93041992187497 },
        { lat: 67.09301757812503, lng: -174.93813476562497 },
        { lat: 67.00024414062506, lng: -174.88505859375 },
        { lat: 66.96137695312504, lng: -174.82871093750003 },
        { lat: 66.91679687500002, lng: -174.78364257812498 },
        { lat: 66.78432617187502, lng: -174.77119140625004 },
        { lat: 66.72490234374999, lng: -174.87011718750003 },
        { lat: 66.62314453125006, lng: -174.92490234375 },
        { lat: 66.61313476562506, lng: -174.8642578125 },
        { lat: 66.60341796875002, lng: -174.674658203125 },
        { lat: 66.58540039062501, lng: -174.61245117187494 },
        { lat: 66.53793945312499, lng: -174.503759765625 },
        { lat: 66.49218750000003, lng: -174.47773437500004 },
        { lat: 66.42988281250001, lng: -174.45375976562494 },
        { lat: 66.37197265625005, lng: -174.418701171875 },
        { lat: 66.34423828124997, lng: -174.39409179687496 },
        { lat: 66.34833984375001, lng: -174.36606445312503 },
        { lat: 66.428466796875, lng: -174.256982421875 },
        { lat: 66.45234374999998, lng: -174.206005859375 },
        { lat: 66.47309570312504, lng: -174.084765625 },
        { lat: 66.38251953124995, lng: -174.01772460937502 },
        { lat: 66.22958984374998, lng: -174.06503906249998 },
        { lat: 66.22968750000001, lng: -174.025439453125 },
        { lat: 66.24580078125001, lng: -173.99448242187498 },
        { lat: 66.286767578125, lng: -173.95546874999997 },
        { lat: 66.31049804687495, lng: -173.899951171875 },
        { lat: 66.36606445312498, lng: -173.83203125000003 },
        { lat: 66.43466796875003, lng: -173.77397460937502 },
        { lat: 66.48828125000003, lng: -173.84252929687503 },
        { lat: 66.52177734375002, lng: -173.92094726562502 },
        { lat: 66.540625, lng: -174.10185546875002 },
        { lat: 66.58071289062502, lng: -174.196337890625 },
        { lat: 66.63188476562503, lng: -174.23159179687497 },
        { lat: 66.65263671875002, lng: -174.13959960937498 },
        { lat: 66.68979492187503, lng: -174.06059570312496 },
        { lat: 66.77861328125002, lng: -174.00551757812502 },
        { lat: 66.827392578125, lng: -174.01884765624996 },
        { lat: 66.87548828125003, lng: -174.04101562499997 },
        { lat: 66.94287109375, lng: -174.08642578125 },
        { lat: 66.98203124999998, lng: -174.15434570312496 },
        { lat: 67.00156250000006, lng: -174.283544921875 },
        { lat: 67.03974609375, lng: -174.341845703125 },
        { lat: 67.037646484375, lng: -174.430908203125 },
        { lat: 67.04907226562506, lng: -174.5189453125 },
        { lat: 67.06303710937505, lng: -174.55449218749996 },
        { lat: 67.090625, lng: -174.55009765624993 },
        { lat: 67.103125, lng: -174.44760742187503 },
        { lat: 67.1064453125, lng: -173.88403320312497 },
        { lat: 67.144775390625, lng: -173.6796875 },
        { lat: 67.13276367187495, lng: -173.58657226562502 },
        { lat: 67.10517578125001, lng: -173.49399414062498 },
        { lat: 67.06909179687503, lng: -173.15781249999998 },
        { lat: 67.05224609374997, lng: -173.16762695312502 },
        { lat: 67.03510742187495, lng: -173.224169921875 },
        { lat: 66.95483398437503, lng: -173.32353515625 },
        { lat: 66.90922851562507, lng: -173.34306640625 },
        { lat: 66.85136718750002, lng: -173.34736328124995 },
        { lat: 66.84008789062503, lng: -173.25893554687497 },
        { lat: 66.86459960937503, lng: -173.175390625 },
        { lat: 66.91123046875003, lng: -173.21616210937495 },
        { lat: 66.96855468749999, lng: -173.22827148437503 },
        { lat: 66.99360351562504, lng: -173.19301757812497 },
        { lat: 66.99897460937495, lng: -173.14682617187498 },
        { lat: 66.95585937500007, lng: -173.05849609375 },
        { lat: 66.94213867187503, lng: -172.96259765625 },
        { lat: 66.925, lng: -172.64057617187504 },
        { lat: 66.93051757812506, lng: -172.54936523437502 },
        { lat: 66.952490234375, lng: -172.5201171875 },
        { lat: 66.97783203125002, lng: -172.582958984375 },
        { lat: 67.03398437499997, lng: -173.001904296875 },
        { lat: 67.06489257812497, lng: -173.00751953125 },
        { lat: 67.02680664062495, lng: -172.62104492187495 },
        { lat: 66.99174804687502, lng: -172.44731445312502 },
        { lat: 66.965576171875, lng: -172.27392578125003 },
        { lat: 66.97329101562497, lng: -172.03149414062503 },
        { lat: 66.93173828125003, lng: -171.79555664062502 },
        { lat: 66.818701171875, lng: -171.56958007812497 },
        { lat: 66.67675781250006, lng: -171.36049804687502 },
        { lat: 66.59272460937498, lng: -171.14926757812498 },
        { lat: 66.52973632812503, lng: -170.92666015625002 },
        { lat: 66.35722656250005, lng: -170.5556640625 },
        { lat: 66.34365234375005, lng: -170.50952148437503 },
        { lat: 66.32026367187498, lng: -170.47309570312498 },
        { lat: 66.29106445312499, lng: -170.54282226562498 },
        { lat: 66.24892578125002, lng: -170.604443359375 },
        { lat: 66.278076171875, lng: -170.48330078125002 },
        { lat: 66.29790039062503, lng: -170.3611328125 },
        { lat: 66.29404296874998, lng: -170.30122070312504 },
        { lat: 66.271875, lng: -170.24697265625 },
        { lat: 66.23642578125003, lng: -170.21162109375 },
        { lat: 66.20126953124998, lng: -170.191943359375 },
        { lat: 66.16928710937503, lng: -170.24394531250002 },
        { lat: 66.16347656250002, lng: -169.88881835937497 },
        { lat: 66.14311523437505, lng: -169.777880859375 },
        { lat: 66.05810546875006, lng: -169.72915039062502 },
        { lat: 65.99892578124997, lng: -169.83168945312497 },
        { lat: 66.00610351562503, lng: -169.89169921875 },
        { lat: 66.03100585937503, lng: -169.94931640625003 },
        { lat: 66.03349609375, lng: -170.00380859375 },
        { lat: 66.00805664062497, lng: -170.15942382812503 },
        { lat: 65.928515625, lng: -170.40102539062494 },
        { lat: 65.86542968749994, lng: -170.54067382812497 },
        { lat: 65.82358398437506, lng: -170.563037109375 },
        { lat: 65.71025390625005, lng: -170.54140624999994 },
        { lat: 65.65625, lng: -170.560986328125 },
        { lat: 65.62153320312501, lng: -170.66630859375 },
        { lat: 65.64262695312505, lng: -170.896875 },
        { lat: 65.66489257812506, lng: -171.00146484374997 },
        { lat: 65.69501953124997, lng: -171.11899414062503 },
        { lat: 65.73686523437505, lng: -171.23203124999995 },
        { lat: 65.80395507812504, lng: -171.37685546874997 },
        { lat: 65.81035156250002, lng: -171.42153320312502 },
        { lat: 65.79423828125002, lng: -171.45117187499997 },
        { lat: 65.75175781249999, lng: -171.40170898437498 },
        { lat: 65.69848632812496, lng: -171.30322265625 },
        { lat: 65.62807617187502, lng: -171.13442382812494 },
        { lat: 65.54995117187498, lng: -171.05424804687496 },
        { lat: 65.51103515625005, lng: -171.105859375 },
        { lat: 65.50209960937502, lng: -171.169970703125 },
        { lat: 65.50278320312498, lng: -171.21601562499998 },
        { lat: 65.52719726562498, lng: -171.36376953124997 },
        { lat: 65.53310546875002, lng: -171.46625976562498 },
        { lat: 65.51044921875004, lng: -171.79038085937503 },
        { lat: 65.495947265625, lng: -171.90712890625 },
        { lat: 65.50795898437497, lng: -171.94716796874997 },
        { lat: 65.54208984374996, lng: -171.957177734375 },
        { lat: 65.56694335937499, lng: -172.13149414062497 },
        { lat: 65.570458984375, lng: -172.23388671874994 },
        { lat: 65.58232421875002, lng: -172.28227539062496 },
        { lat: 65.617529296875, lng: -172.322265625 },
        { lat: 65.66962890624995, lng: -172.43569335937497 },
        { lat: 65.69003906250003, lng: -172.60771484375 },
        { lat: 65.69243164062507, lng: -172.71918945312498 },
        { lat: 65.68105468749997, lng: -172.78330078124998 },
        { lat: 65.61201171875, lng: -172.55654296874997 },
        { lat: 65.49599609375002, lng: -172.353955078125 },
        { lat: 65.47456054687501, lng: -172.39199218750002 },
        { lat: 65.44956054687505, lng: -172.41777343749993 },
        { lat: 65.44780273437505, lng: -172.30571289062502 },
        { lat: 65.45571289062497, lng: -172.23281250000002 },
        { lat: 65.42519531249997, lng: -172.211572265625 },
        { lat: 65.302734375, lng: -172.269873046875 },
        { lat: 65.27563476562497, lng: -172.30927734375004 },
        { lat: 65.24853515625006, lng: -172.66191406249993 },
        { lat: 65.22822265624998, lng: -172.57314453124997 },
        { lat: 65.221875, lng: -172.48208007812497 },
        { lat: 65.22670898437505, lng: -172.3787109375 },
        { lat: 65.20571289062502, lng: -172.28603515625002 },
        { lat: 65.12871093750007, lng: -172.22368164062502 },
        { lat: 65.04814453124997, lng: -172.21318359375 },
        { lat: 65.00214843750004, lng: -172.30434570312502 },
        { lat: 64.96474609374997, lng: -172.39873046874996 },
        { lat: 64.90795898437503, lng: -172.592822265625 },
        { lat: 64.88291015624998, lng: -172.79248046875 },
        { lat: 64.88920898437502, lng: -172.89736328124994 },
        { lat: 64.87661132812504, lng: -172.99912109374998 },
        { lat: 64.84716796875, lng: -173.06621093749996 },
        { lat: 64.81733398437495, lng: -173.08579101562498 },
        { lat: 64.83710937499998, lng: -172.99804687500003 },
        { lat: 64.82607421875005, lng: -172.896875 },
        { lat: 64.79052734375, lng: -172.80107421874993 },
        { lat: 64.76118164062498, lng: -172.81157226562493 },
        { lat: 64.72919921875004, lng: -172.90258789062503 },
        { lat: 64.70493164062506, lng: -172.9240234375 },
        { lat: 64.66401367187498, lng: -172.88906250000002 },
        { lat: 64.62885742187501, lng: -172.90087890624991 },
        { lat: 64.60991210937507, lng: -172.854150390625 },
        { lat: 64.60327148437503, lng: -172.746875 },
        { lat: 64.57788085937503, lng: -172.61611328125002 },
        { lat: 64.544189453125, lng: -172.48740234375 },
        { lat: 64.51533203124998, lng: -172.43662109374998 },
        { lat: 64.47465820312505, lng: -172.39384765624996 },
        { lat: 64.43154296874997, lng: -172.37875976562498 },
        { lat: 64.413916015625, lng: -172.40146484374998 },
        { lat: 64.40708007812503, lng: -172.69467773437503 },
        { lat: 64.41225585937502, lng: -172.73916015624997 },
        { lat: 64.45996093749997, lng: -172.75595703125 },
        { lat: 64.49892578125002, lng: -172.79150390624997 },
        { lat: 64.52607421875004, lng: -172.90317382812495 },
        { lat: 64.50737304687505, lng: -172.9490234375 },
        { lat: 64.36943359375002, lng: -172.91586914062495 },
        { lat: 64.32768554687502, lng: -172.96005859375003 },
        { lat: 64.2974609375, lng: -173.00913085937498 },
        { lat: 64.27973632812504, lng: -173.15742187499998 },
        { lat: 64.2896484375, lng: -173.27548828124998 },
        { lat: 64.35488281249997, lng: -173.37568359375004 },
        { lat: 64.410400390625, lng: -173.375537109375 },
        { lat: 64.44267578125002, lng: -173.30922851562502 },
        { lat: 64.487451171875, lng: -173.30932617187503 },
        { lat: 64.53955078125003, lng: -173.327490234375 },
        { lat: 64.47900390625001, lng: -173.39565429687502 },
        { lat: 64.42861328125, lng: -173.47495117187503 },
        { lat: 64.365478515625, lng: -173.60361328125003 },
        { lat: 64.35732421875002, lng: -173.66596679687504 },
        { lat: 64.36450195312497, lng: -173.72973632812497 },
        { lat: 64.40971679687505, lng: -173.8978515625 },
        { lat: 64.44897460937506, lng: -174.00136718749997 },
        { lat: 64.577783203125, lng: -174.20483398437503 },
        { lat: 64.63764648437503, lng: -174.318017578125 },
        { lat: 64.71777343749999, lng: -174.57055664062503 },
        { lat: 64.77597656250006, lng: -174.83046874999994 },
        { lat: 64.813671875, lng: -175.03603515625 },
        { lat: 64.80927734375001, lng: -175.14584960937498 },
        { lat: 64.79399414062499, lng: -175.25590820312493 },
        { lat: 64.80239257812502, lng: -175.39511718749998 },
        { lat: 64.81669921874999, lng: -175.44213867187494 },
        { lat: 64.84858398437501, lng: -175.48320312499996 },
        { lat: 64.86708984374997, lng: -175.52065429687497 },
        { lat: 64.94609374999999, lng: -175.71586914062493 },
        { lat: 65.01083984375003, lng: -175.85385742187498 },
        { lat: 65.05419921874997, lng: -175.85947265624995 },
        { lat: 65.10551757812505, lng: -175.83022460937497 },
        { lat: 65.23281250000005, lng: -175.85615234375 },
        { lat: 65.35249023437501, lng: -175.92294921875003 },
        { lat: 65.47104492187499, lng: -176.09326171875 },
        { lat: 65.54755859374994, lng: -176.54746093749998 },
        { lat: 65.60136718749997, lng: -176.92211914062503 },
        { lat: 65.613623046875, lng: -177.05625 },
        { lat: 65.60166015625003, lng: -177.17524414062498 },
        { lat: 65.50371093749999, lng: -177.48876953124997 },
        { lat: 65.48969726562498, lng: -177.69863281250002 },
        { lat: 65.48486328124997, lng: -178.31020507812502 },
        { lat: 65.49555664062501, lng: -178.4125 },
        { lat: 65.53720703124998, lng: -178.504638671875 },
        { lat: 65.59301757812497, lng: -178.525927734375 },
        { lat: 65.69663085937503, lng: -178.49931640625 },
        { lat: 65.74042968749998, lng: -178.50234375 },
        { lat: 65.75522460937498, lng: -178.52622070312498 },
        { lat: 65.75400390625, lng: -178.55854492187498 },
        { lat: 65.79536132812498, lng: -178.679150390625 },
        { lat: 65.86474609375, lng: -178.79106445312502 },
        { lat: 65.93647460937495, lng: -178.87934570312495 },
        { lat: 66.03276367187505, lng: -178.93906249999998 },
        { lat: 66.03754882812504, lng: -178.85825195312503 },
        { lat: 66.01367187500006, lng: -178.74672851562497 },
        { lat: 66.03725585937497, lng: -178.73056640625 },
        { lat: 66.12421875000001, lng: -178.693798828125 },
        { lat: 66.166015625, lng: -178.61625976562502 },
        { lat: 66.19843750000004, lng: -178.5865234375 },
        { lat: 66.31655273437502, lng: -178.53413085937498 },
        { lat: 66.40156250000004, lng: -178.52656250000004 },
        { lat: 66.35517578124998, lng: -178.615771484375 },
        { lat: 66.23725585937495, lng: -178.75278320312503 },
        { lat: 66.20268554687502, lng: -178.82084960937496 },
        { lat: 66.187060546875, lng: -178.86811523437498 },
        { lat: 66.17993164062499, lng: -178.91552734374997 },
        { lat: 66.203515625, lng: -179.02612304687503 },
        { lat: 66.23193359375003, lng: -179.10507812500003 },
        { lat: 66.34609375, lng: -179.10688476562504 },
        { lat: 66.37504882812505, lng: -179.14340820312503 },
        { lat: 66.35332031250005, lng: -179.17836914062497 },
        { lat: 66.312548828125, lng: -179.19267578125005 },
        { lat: 66.305078125, lng: -179.29316406249998 },
        { lat: 66.2875, lng: -179.34013671874996 },
        { lat: 66.21982421875003, lng: -179.3162109375 },
        { lat: 66.16259765625003, lng: -179.32719726562496 },
        { lat: 66.14106445312497, lng: -179.42265625 },
        { lat: 66.12788085937495, lng: -179.61616210937495 },
        { lat: 66.18413085937505, lng: -179.68330078124998 },
        { lat: 66.10576171874999, lng: -179.74086914062497 },
        { lat: 66.01796875000005, lng: -179.78364257812498 },
        { lat: 65.90087890624999, lng: -179.78969726562497 },
        { lat: 65.80380859375, lng: -179.7283203125 },
        { lat: 65.757568359375, lng: -179.640625 },
        { lat: 65.687841796875, lng: -179.44907226562503 },
        { lat: 65.63862304687504, lng: -179.365966796875 },
        { lat: 65.57524414062497, lng: -179.344384765625 },
        { lat: 65.51674804687497, lng: -179.352099609375 },
        { lat: 65.4453125, lng: -179.45166015625003 },
        { lat: 65.38627929687505, lng: -179.51933593749993 },
        { lat: 65.24414062500003, lng: -179.63515625000002 },
        { lat: 65.18720703124998, lng: -179.70458984374994 },
        { lat: 65.06723632812498, lng: -180 },
        { lat: 65.31196289062501, lng: -180 },
        { lat: 65.55678710937495, lng: -180 },
        { lat: 65.80156250000002, lng: -180 },
        { lat: 66.04628906250002, lng: -180 },
        { lat: 66.29106445312499, lng: -180 },
        { lat: 66.53583984375004, lng: -180 },
        { lat: 66.78056640625003, lng: -180 },
        { lat: 67.02534179687501, lng: -180 },
        { lat: 67.27011718750006, lng: -180 },
        { lat: 67.51484374999998, lng: -180 },
        { lat: 67.75961914062503, lng: -180 },
        { lat: 68.00439453124997, lng: -180 },
        { lat: 68.24912109375, lng: -180 },
        { lat: 68.49389648437497, lng: -180 },
        { lat: 68.738671875, lng: -180 },
        { lat: 68.98344726562503, lng: -179.999951171875 },
        { lat: 68.9404296875, lng: -179.79853515625 },
      ],
      [
        { lat: 69.18559570312502, lng: 50.265234375 },
        { lat: 69.08886718750003, lng: 50.283007812500074 },
        { lat: 69.04877929687504, lng: 50.220605468750044 },
        { lat: 69.03754882812495, lng: 50.16445312499999 },
        { lat: 69.09814453124997, lng: 50.140917968750074 },
        { lat: 69.12553710937505, lng: 50.0939453125001 },
        { lat: 69.05327148437507, lng: 49.92080078124999 },
        { lat: 68.97377929687502, lng: 49.83984375000003 },
        { lat: 68.85971679687496, lng: 49.62626953125002 },
        { lat: 68.77841796875003, lng: 49.180468750000074 },
        { lat: 68.74306640625002, lng: 48.91035156250004 },
        { lat: 68.73315429687501, lng: 48.66699218750002 },
        { lat: 68.80488281249998, lng: 48.4390625 },
        { lat: 68.94238281250003, lng: 48.31591796874997 },
        { lat: 68.98422851562503, lng: 48.29443359374997 },
        { lat: 69.04033203124999, lng: 48.27880859374997 },
        { lat: 69.096630859375, lng: 48.28027343749997 },
        { lat: 69.18388671875002, lng: 48.296289062499994 },
        { lat: 69.26923828125001, lng: 48.319921875 },
        { lat: 69.34565429687504, lng: 48.41386718750002 },
        { lat: 69.43603515624997, lng: 48.63134765625003 },
        { lat: 69.49472656250003, lng: 48.8449218750001 },
        { lat: 69.50927734374997, lng: 48.9533203125001 },
        { lat: 69.51123046875, lng: 49.22519531250006 },
        { lat: 69.30942382812503, lng: 49.9962890625001 },
        { lat: 69.25708007812503, lng: 50.16728515625002 },
        { lat: 69.18559570312502, lng: 50.265234375 },
      ],
      [
        { lat: 69.52983398437499, lng: 67.34492187500004 },
        { lat: 69.44252929687497, lng: 67.26396484375002 },
        { lat: 69.44716796875002, lng: 67.0978515625001 },
        { lat: 69.46704101562497, lng: 67.047265625 },
        { lat: 69.48320312499999, lng: 67.02587890624997 },
        { lat: 69.57539062500004, lng: 67.21611328125002 },
        { lat: 69.57211914062496, lng: 67.32890625000002 },
        { lat: 69.52983398437499, lng: 67.34492187500004 },
      ],
      [
        { lat: 68.90097656250003, lng: 161.46708984375002 },
        { lat: 68.89965820312503, lng: 161.42246093750003 },
        { lat: 68.96601562499995, lng: 161.45625 },
        { lat: 68.99560546875003, lng: 161.46113281250004 },
        { lat: 69.04443359375003, lng: 161.36406250000002 },
        { lat: 69.08159179687505, lng: 161.18251953125005 },
        { lat: 69.11025390625002, lng: 161.13652343750002 },
        { lat: 69.19702148437503, lng: 161.12548828124997 },
        { lat: 69.33359374999998, lng: 161.16455078125003 },
        { lat: 69.4056640625, lng: 161.08281250000005 },
        { lat: 69.46982421875, lng: 161.1107421875 },
        { lat: 69.54091796875002, lng: 161.32333984375006 },
        { lat: 69.595703125, lng: 161.40976562500003 },
        { lat: 69.63945312500002, lng: 161.50517578125007 },
        { lat: 69.63403320312497, lng: 161.52070312500004 },
        { lat: 69.59243164062502, lng: 161.61777343750006 },
        { lat: 69.50092773437495, lng: 161.60927734375005 },
        { lat: 69.43652343749997, lng: 161.54033203125002 },
        { lat: 69.41367187500003, lng: 161.3744140625 },
        { lat: 69.36933593749998, lng: 161.35087890625007 },
        { lat: 69.292822265625, lng: 161.37265625000006 },
        { lat: 69.19443359375003, lng: 161.37753906250006 },
        { lat: 69.10644531249997, lng: 161.39423828125 },
        { lat: 69.01601562500002, lng: 161.49472656250006 },
        { lat: 68.96958007812498, lng: 161.5169921875 },
        { lat: 68.92758789062503, lng: 161.50673828125005 },
        { lat: 68.90097656250003, lng: 161.46708984375002 },
      ],
      [
        { lat: 69.58046875, lng: 169.20078125000003 },
        { lat: 69.57143554687502, lng: 168.91572265625004 },
        { lat: 69.66435546875005, lng: 168.34804687500002 },
        { lat: 69.71333007812498, lng: 168.14433593750002 },
        { lat: 69.77583007812501, lng: 167.99267578124997 },
        { lat: 69.81962890625005, lng: 167.82128906250003 },
        { lat: 69.83686523437501, lng: 167.78886718750002 },
        { lat: 69.873046875, lng: 167.81396484374997 },
        { lat: 69.90107421875004, lng: 167.86474609375003 },
        { lat: 69.97490234375007, lng: 168.05957031249997 },
        { lat: 70.00839843750003, lng: 168.19628906249997 },
        { lat: 70.01567382812502, lng: 168.35791015625003 },
        { lat: 69.88261718749999, lng: 169.37480468750007 },
        { lat: 69.8560546875, lng: 169.42070312500002 },
        { lat: 69.83217773437502, lng: 169.43359374999997 },
        { lat: 69.77919921875, lng: 169.4181640625001 },
        { lat: 69.76958007812507, lng: 169.33242187500005 },
        { lat: 69.734765625, lng: 169.29912109375 },
        { lat: 69.62871093750005, lng: 169.2633789062501 },
        { lat: 69.60112304687502, lng: 169.2458007812501 },
        { lat: 69.58046875, lng: 169.20078125000003 },
      ],
      [
        { lat: 69.93486328124999, lng: 60.450488281250074 },
        { lat: 69.88549804687497, lng: 60.48066406250004 },
        { lat: 69.793701171875, lng: 60.4772460937501 },
        { lat: 69.72592773437506, lng: 60.44023437500002 },
        { lat: 69.71528320312501, lng: 60.32714843749997 },
        { lat: 69.68769531249997, lng: 60.215917968750055 },
        { lat: 69.71704101562503, lng: 60.02617187500001 },
        { lat: 69.69697265625001, lng: 59.91953125000006 },
        { lat: 69.695654296875, lng: 59.812792968750074 },
        { lat: 69.70620117187502, lng: 59.72460937499997 },
        { lat: 69.72104492187503, lng: 59.637011718750074 },
        { lat: 69.73862304687498, lng: 59.578222656250055 },
        { lat: 69.79086914062506, lng: 59.58125 },
        { lat: 69.86621093750003, lng: 59.50263671875005 },
        { lat: 69.89042968749999, lng: 59.38154296875003 },
        { lat: 69.89843750000003, lng: 59.26835937500002 },
        { lat: 69.92192382812502, lng: 59.14423828125004 },
        { lat: 69.91079101562497, lng: 59.08251953124997 },
        { lat: 69.88330078125006, lng: 59.004003906250055 },
        { lat: 69.89277343750004, lng: 58.952734375 },
        { lat: 70.05102539062503, lng: 58.68007812500005 },
        { lat: 70.08803710937502, lng: 58.63417968750005 },
        { lat: 70.12919921875003, lng: 58.60556640625006 },
        { lat: 70.15566406250002, lng: 58.56806640625004 },
        { lat: 70.26684570312503, lng: 58.47304687499999 },
        { lat: 70.31831054687504, lng: 58.519921875000044 },
        { lat: 70.350830078125, lng: 58.61533203125 },
        { lat: 70.35957031250001, lng: 58.678027343750074 },
        { lat: 70.43295898437503, lng: 58.79423828125002 },
        { lat: 70.46518554687503, lng: 59.005273437500044 },
        { lat: 70.46049804687505, lng: 59.04804687500004 },
        { lat: 70.43710937499998, lng: 59.08828124999999 },
        { lat: 70.36166992187498, lng: 59.30986328125002 },
        { lat: 70.31093750000005, lng: 59.42597656250003 },
        { lat: 70.24897460937503, lng: 59.52910156250002 },
        { lat: 70.19702148437503, lng: 59.63632812500001 },
        { lat: 70.10834960937498, lng: 59.95585937500001 },
        { lat: 70.02285156249997, lng: 60.172265625000044 },
        { lat: 69.96240234375, lng: 60.39257812499997 },
        { lat: 69.93486328124999, lng: 60.450488281250074 },
      ],
      [
        { lat: 70.541748046875, lng: 66.56093750000005 },
        { lat: 70.50146484375006, lng: 66.5685546875001 },
        { lat: 70.51489257812503, lng: 66.5158203125001 },
        { lat: 70.56103515625, lng: 66.4486328125 },
        { lat: 70.61577148437507, lng: 66.4076171875 },
        { lat: 70.72729492187506, lng: 66.39482421875002 },
        { lat: 70.75712890624999, lng: 66.4181640625001 },
        { lat: 70.77265624999995, lng: 66.44023437500007 },
        { lat: 70.76933593749999, lng: 66.46289062499997 },
        { lat: 70.69877929687502, lng: 66.45771484375004 },
        { lat: 70.541748046875, lng: 66.56093750000005 },
      ],
      [
        { lat: 70.82270507812504, lng: 160.71894531250004 },
        { lat: 70.80585937499998, lng: 160.6513671875 },
        { lat: 70.81972656250005, lng: 160.50478515625 },
        { lat: 70.85102539062504, lng: 160.43691406250005 },
        { lat: 70.92265625000003, lng: 160.44042968750003 },
        { lat: 70.93403320312498, lng: 160.44853515625002 },
        { lat: 70.92377929687501, lng: 160.5658203125 },
        { lat: 70.883544921875, lng: 160.64492187500005 },
        { lat: 70.82270507812504, lng: 160.71894531250004 },
      ],
      [
        { lat: 71.36499023437503, lng: 52.90332031250003 },
        { lat: 71.291259765625, lng: 52.99414062499997 },
        { lat: 71.237939453125, lng: 53.074023437500074 },
        { lat: 71.24189453124998, lng: 53.14140625000002 },
        { lat: 71.21528320312498, lng: 53.19257812500004 },
        { lat: 71.15971679687505, lng: 53.20517578125006 },
        { lat: 71.0650390625, lng: 53.0714843750001 },
        { lat: 71.03095703125001, lng: 53.04814453125002 },
        { lat: 70.99926757812503, lng: 53.10576171875002 },
        { lat: 70.98203124999998, lng: 53.120996093750044 },
        { lat: 70.96870117187501, lng: 53.02265625000009 },
        { lat: 71.01162109374997, lng: 53.0044921875 },
        { lat: 71.05361328125, lng: 52.94960937500005 },
        { lat: 71.08583984374998, lng: 52.835351562499994 },
        { lat: 71.11494140624998, lng: 52.788964843749994 },
        { lat: 71.18066406250003, lng: 52.73837890625006 },
        { lat: 71.25043945312495, lng: 52.5465820312501 },
        { lat: 71.23925781249997, lng: 52.4254882812501 },
        { lat: 71.270361328125, lng: 52.28945312499999 },
        { lat: 71.28491210937504, lng: 52.24960937500006 },
        { lat: 71.32504882812506, lng: 52.23984375 },
        { lat: 71.35683593750005, lng: 52.29658203125004 },
        { lat: 71.38505859375002, lng: 52.51259765624999 },
        { lat: 71.383349609375, lng: 52.61738281250004 },
        { lat: 71.35512695312497, lng: 52.7296875000001 },
        { lat: 71.38979492187502, lng: 52.7203125 },
        { lat: 71.40371093749998, lng: 52.732226562500074 },
        { lat: 71.3998046875, lng: 52.776757812499994 },
        { lat: 71.36499023437503, lng: 52.90332031250003 },
      ],
      [
        { lat: 70.826416015625, lng: 178.8615234375001 },
        { lat: 70.82207031249999, lng: 178.79257812500006 },
        { lat: 71.00058593750003, lng: 178.64824218749996 },
        { lat: 71.04736328124997, lng: 178.6283203125 },
        { lat: 71.10566406250004, lng: 178.68388671875013 },
        { lat: 71.177880859375, lng: 178.82900390625005 },
        { lat: 71.23110351562502, lng: 178.89111328125009 },
        { lat: 71.32451171875005, lng: 179.23505859375015 },
        { lat: 71.44765625, lng: 179.54765625000007 },
        { lat: 71.46621093750002, lng: 179.71591796875003 },
        { lat: 71.52333984375005, lng: 179.88642578125015 },
        { lat: 71.53774414062505, lng: 180 },
        { lat: 70.993017578125, lng: 180 },
        { lat: 70.97568359375003, lng: 179.88134765625003 },
        { lat: 70.89892578125003, lng: 179.64765625000004 },
        { lat: 70.88027343750001, lng: 179.15253906250004 },
        { lat: 70.826416015625, lng: 178.8615234375001 },
      ],
      [
        { lat: 71.50766601562503, lng: 137.95986328125005 },
        { lat: 71.4232421875, lng: 137.71181640625005 },
        { lat: 71.43393554687503, lng: 137.61289062500003 },
        { lat: 71.47460937499997, lng: 137.51181640625006 },
        { lat: 71.48349609375, lng: 137.45781250000007 },
        { lat: 71.47729492187497, lng: 137.40322265625005 },
        { lat: 71.46054687500003, lng: 137.34423828125003 },
        { lat: 71.45590820312498, lng: 137.26552734375 },
        { lat: 71.502197265625, lng: 137.07871093750012 },
        { lat: 71.52988281250003, lng: 137.06406250000006 },
        { lat: 71.542724609375, lng: 137.08183593750002 },
        { lat: 71.55615234374997, lng: 137.12949218750003 },
        { lat: 71.55712890625, lng: 137.16816406250004 },
        { lat: 71.57993164062503, lng: 137.28183593750012 },
        { lat: 71.58789062500006, lng: 137.81679687499997 },
        { lat: 71.58305664062505, lng: 137.8576171875001 },
        { lat: 71.54277343749999, lng: 137.93378906250004 },
        { lat: 71.50766601562503, lng: 137.95986328125005 },
      ],
      [
        { lat: 71.57705078124997, lng: -178.87646484375 },
        { lat: 71.54116210937502, lng: -178.43896484374994 },
        { lat: 71.52919921875, lng: -178.35356445312496 },
        { lat: 71.48164062499998, lng: -178.214697265625 },
        { lat: 71.46547851562497, lng: -178.13388671874998 },
        { lat: 71.43759765624998, lng: -178.05664062499994 },
        { lat: 71.39052734375, lng: -177.97480468749995 },
        { lat: 71.339990234375, lng: -177.81699218749995 },
        { lat: 71.28168945312501, lng: -177.58413085937497 },
        { lat: 71.26308593750004, lng: -177.53217773437504 },
        { lat: 71.21914062499997, lng: -177.498486328125 },
        { lat: 71.16689453124998, lng: -177.523583984375 },
        { lat: 71.06757812500001, lng: -177.82177734375 },
        { lat: 71.04194335937501, lng: -178.06269531250004 },
        { lat: 71.014794921875, lng: -178.52797851562494 },
        { lat: 70.93984375, lng: -179.156884765625 },
        { lat: 70.918994140625, lng: -179.415673828125 },
        { lat: 70.92343750000003, lng: -179.50668945312498 },
        { lat: 70.9716796875, lng: -179.73403320312502 },
        { lat: 70.993017578125, lng: -179.999951171875 },
        { lat: 71.18422851562497, lng: -179.999951171875 },
        { lat: 71.39970703124999, lng: -179.999951171875 },
        { lat: 71.53774414062505, lng: -179.999951171875 },
        { lat: 71.55097656249998, lng: -179.84487304687502 },
        { lat: 71.57797851562498, lng: -179.69101562500003 },
        { lat: 71.582421875, lng: -179.54638671874997 },
        { lat: 71.56665039062497, lng: -179.40205078125007 },
        { lat: 71.57167968750002, lng: -179.25649414062494 },
        { lat: 71.59619140625006, lng: -179.11157226562503 },
        { lat: 71.59321289062498, lng: -178.99404296874997 },
        { lat: 71.57705078124997, lng: -178.87646484375 },
      ],
      [
        { lat: 72.291259765625, lng: 77.6325195312501 },
        { lat: 72.28188476562501, lng: 77.14560546875012 },
        { lat: 72.29765625000005, lng: 76.90595703125004 },
        { lat: 72.317041015625, lng: 76.87109374999996 },
        { lat: 72.36557617187503, lng: 76.903125 },
        { lat: 72.43920898437503, lng: 77.14951171875012 },
        { lat: 72.48613281249999, lng: 77.26044921875004 },
        { lat: 72.56528320312503, lng: 77.37783203125 },
        { lat: 72.63085937499997, lng: 77.57871093750006 },
        { lat: 72.63120117187506, lng: 77.74853515625003 },
        { lat: 72.55322265624997, lng: 78.27910156250002 },
        { lat: 72.50429687500005, lng: 78.35292968750005 },
        { lat: 72.48242187500003, lng: 78.36513671875005 },
        { lat: 72.41699218750003, lng: 78.15449218750004 },
        { lat: 72.39248046875, lng: 78.00722656250005 },
        { lat: 72.30854492187495, lng: 77.78085937500012 },
        { lat: 72.291259765625, lng: 77.6325195312501 },
      ],
      [
        { lat: 72.72192382812497, lng: 79.50146484374997 },
        { lat: 72.710693359375, lng: 79.43066406249997 },
        { lat: 72.751611328125, lng: 78.88056640625003 },
        { lat: 72.80341796874995, lng: 78.69023437500002 },
        { lat: 72.85073242187502, lng: 78.63320312500005 },
        { lat: 72.89228515624995, lng: 78.65683593750006 },
        { lat: 73.0943359375, lng: 79.16425781250004 },
        { lat: 73.038623046875, lng: 79.35654296875006 },
        { lat: 72.98310546874998, lng: 79.4125 },
        { lat: 72.91865234374997, lng: 79.54130859375002 },
        { lat: 72.76933593750005, lng: 79.537890625 },
        { lat: 72.72192382812497, lng: 79.50146484374997 },
      ],
      [
        { lat: 72.87343750000002, lng: 74.660546875 },
        { lat: 72.86376953124999, lng: 74.6383789062501 },
        { lat: 72.88115234374999, lng: 74.5880859375001 },
        { lat: 72.90766601562498, lng: 74.4347656250001 },
        { lat: 72.975341796875, lng: 74.18066406250003 },
        { lat: 73.02153320312499, lng: 74.10019531250005 },
        { lat: 73.07436523437502, lng: 74.14238281250002 },
        { lat: 73.10908203124998, lng: 74.19853515625 },
        { lat: 73.13046874999998, lng: 74.40878906250005 },
        { lat: 73.12177734374998, lng: 74.59990234375007 },
        { lat: 73.10815429687496, lng: 74.72529296875004 },
        { lat: 73.0625, lng: 74.9615234375 },
        { lat: 73.03271484375006, lng: 74.742578125 },
        { lat: 72.96904296875003, lng: 74.64726562500007 },
        { lat: 72.92929687500003, lng: 74.66015625000001 },
        { lat: 72.90771484375, lng: 74.69716796875 },
        { lat: 72.87343750000002, lng: 74.660546875 },
      ],
      [
        { lat: 73.08984374999996, lng: 120.2613281250001 },
        { lat: 73.04487304687495, lng: 120.00791015625006 },
        { lat: 73.04541015624996, lng: 119.79208984375005 },
        { lat: 73.12431640625007, lng: 119.64042968750002 },
        { lat: 73.15546875000001, lng: 119.76191406250003 },
        { lat: 73.16767578125001, lng: 119.96445312500012 },
        { lat: 73.15673828125, lng: 120.078515625 },
        { lat: 73.10727539062505, lng: 120.23681640624996 },
        { lat: 73.08984374999996, lng: 120.2613281250001 },
      ],
      [
        { lat: 73.30830078124998, lng: 55.31982421875002 },
        { lat: 73.26860351562505, lng: 55.78730468750004 },
        { lat: 73.25615234375002, lng: 56.13769531250003 },
        { lat: 73.22553710937498, lng: 56.350488281249994 },
        { lat: 73.201171875, lng: 56.42958984375005 },
        { lat: 73.13916015624996, lng: 56.39746093749997 },
        { lat: 73.11367187500002, lng: 56.3346679687501 },
        { lat: 73.0330078125, lng: 56.18896484374997 },
        { lat: 72.98320312499999, lng: 56.16699218750003 },
        { lat: 72.90498046874995, lng: 56.19287109374997 },
        { lat: 72.84809570312501, lng: 56.170507812500006 },
        { lat: 72.80659179687497, lng: 56.121679687500006 },
        { lat: 72.78940429687503, lng: 56.08378906250002 },
        { lat: 72.78950195312498, lng: 55.81972656250005 },
        { lat: 72.76640625000007, lng: 55.723437500000074 },
        { lat: 72.72153320312498, lng: 55.71845703125004 },
        { lat: 72.67172851562506, lng: 55.70097656250001 },
        { lat: 72.59907226562498, lng: 55.61640625000004 },
        { lat: 72.57539062499995, lng: 55.44130859375005 },
        { lat: 72.54907226562503, lng: 55.40332031249997 },
        { lat: 72.50131835937498, lng: 55.416894531250044 },
        { lat: 72.46508789062506, lng: 55.35595703124997 },
        { lat: 72.40869140625003, lng: 55.3595703125001 },
        { lat: 72.37783203125004, lng: 55.39042968750002 },
        { lat: 72.31362304687502, lng: 55.39912109375009 },
        { lat: 72.22065429687498, lng: 55.51806640624997 },
        { lat: 72.18232421875001, lng: 55.494921875000074 },
        { lat: 72.10688476562497, lng: 55.40332031249997 },
        { lat: 72.014892578125, lng: 55.375 },
        { lat: 71.93535156250005, lng: 55.29785156249997 },
        { lat: 71.86923828124998, lng: 55.47109375 },
        { lat: 71.783349609375, lng: 55.54667968750001 },
        { lat: 71.68989257812495, lng: 55.61367187499999 },
        { lat: 71.50756835937503, lng: 55.81933593749997 },
        { lat: 71.34560546874997, lng: 56.0431640625001 },
        { lat: 71.10737304687504, lng: 56.45439453125002 },
        { lat: 70.92700195312504, lng: 56.894824218750074 },
        { lat: 70.87602539062505, lng: 57.065625 },
        { lat: 70.79228515625003, lng: 57.48359375000009 },
        { lat: 70.76582031249998, lng: 57.55644531250001 },
        { lat: 70.72880859374999, lng: 57.62539062500005 },
        { lat: 70.66103515625005, lng: 57.44716796875006 },
        { lat: 70.63603515625002, lng: 57.263671874999964 },
        { lat: 70.60512695312502, lng: 57.24697265625005 },
        { lat: 70.58911132812506, lng: 57.14589843750005 },
        { lat: 70.64653320312502, lng: 56.64882812500005 },
        { lat: 70.65537109375003, lng: 56.621679687500006 },
        { lat: 70.69746093750001, lng: 56.568652343750074 },
        { lat: 70.72880859374999, lng: 56.51005859375002 },
        { lat: 70.73413085937503, lng: 56.38574218749997 },
        { lat: 70.71474609374997, lng: 56.260058593750074 },
        { lat: 70.67670898437495, lng: 56.33476562500002 },
        { lat: 70.66494140625005, lng: 56.4171875000001 },
        { lat: 70.59355468750007, lng: 56.561328125000074 },
        { lat: 70.56640625000003, lng: 56.49970703125004 },
        { lat: 70.56298828124997, lng: 56.43457031249997 },
        { lat: 70.65786132812502, lng: 56.142480468749994 },
        { lat: 70.64614257812502, lng: 56.11474609375002 },
        { lat: 70.61835937499995, lng: 56.0871093750001 },
        { lat: 70.64926757812503, lng: 55.94160156250004 },
        { lat: 70.62631835937496, lng: 55.90722656250003 },
        { lat: 70.61557617187503, lng: 55.796875 },
        { lat: 70.64189453125005, lng: 55.70673828125003 },
        { lat: 70.67524414062501, lng: 55.706445312499994 },
        { lat: 70.69218749999999, lng: 55.687304687500074 },
        { lat: 70.666015625, lng: 55.2369140625 },
        { lat: 70.66674804687497, lng: 55.051660156249994 },
        { lat: 70.678125, lng: 54.86708984375005 },
        { lat: 70.741845703125, lng: 54.64511718750006 },
        { lat: 70.71323242187503, lng: 54.608203125000074 },
        { lat: 70.68007812500002, lng: 54.60117187500006 },
        { lat: 70.69331054687495, lng: 54.51738281250002 },
        { lat: 70.74467773437505, lng: 54.33261718750006 },
        { lat: 70.76489257812497, lng: 54.19941406250009 },
        { lat: 70.81445312500003, lng: 53.72236328125009 },
        { lat: 70.87353515625, lng: 53.383593750000074 },
        { lat: 70.90058593750001, lng: 53.46777343749997 },
        { lat: 70.91464843750003, lng: 53.61357421875002 },
        { lat: 70.95083007812502, lng: 53.615625 },
        { lat: 71.00068359374995, lng: 53.59257812500001 },
        { lat: 71.05229492187499, lng: 53.587792968749994 },
        { lat: 71.08691406250003, lng: 53.670507812500006 },
        { lat: 71.07041015625003, lng: 53.85703125000006 },
        { lat: 71.12670898437497, lng: 53.83427734375007 },
        { lat: 71.13759765624997, lng: 53.922265625000044 },
        { lat: 71.10522460937503, lng: 54.0939453125001 },
        { lat: 71.12548828125, lng: 54.155664062499994 },
        { lat: 71.19628906250003, lng: 53.88613281250005 },
        { lat: 71.29667968750005, lng: 53.59082031250003 },
        { lat: 71.33276367187503, lng: 53.62216796875 },
        { lat: 71.34252929687497, lng: 53.51523437500006 },
        { lat: 71.34013671875002, lng: 53.40996093750002 },
        { lat: 71.39916992187497, lng: 53.31904296875004 },
        { lat: 71.47724609374998, lng: 53.33251953124997 },
        { lat: 71.530126953125, lng: 53.41162109375003 },
        { lat: 71.54165039062505, lng: 53.363867187500055 },
        { lat: 71.49501953125005, lng: 52.90898437500002 },
        { lat: 71.50566406249999, lng: 52.678710937499964 },
        { lat: 71.53686523437503, lng: 52.41884765624999 },
        { lat: 71.49023437500006, lng: 52.17998046875002 },
        { lat: 71.47470703124998, lng: 51.937890625000044 },
        { lat: 71.49130859375, lng: 51.812597656250006 },
        { lat: 71.52514648437506, lng: 51.69160156250004 },
        { lat: 71.571142578125, lng: 51.59042968750006 },
        { lat: 71.64809570312497, lng: 51.511328125 },
        { lat: 71.77680664062498, lng: 51.43867187500004 },
        { lat: 71.82553710937506, lng: 51.42861328125005 },
        { lat: 71.934375, lng: 51.4435546875001 },
        { lat: 71.97978515625005, lng: 51.48222656250002 },
        { lat: 72.07119140625, lng: 51.58251953124997 },
        { lat: 72.09936523437497, lng: 51.653125 },
        { lat: 72.14213867187497, lng: 51.805468750000074 },
        { lat: 72.15322265625002, lng: 51.88544921875004 },
        { lat: 72.13115234375005, lng: 52.068652343750074 },
        { lat: 72.12973632812502, lng: 52.252050781250006 },
        { lat: 72.153955078125, lng: 52.33232421875001 },
        { lat: 72.19672851562501, lng: 52.40673828125002 },
        { lat: 72.25234374999997, lng: 52.46191406249997 },
        { lat: 72.28403320312502, lng: 52.58613281250003 },
        { lat: 72.30097656250001, lng: 52.62207031250003 },
        { lat: 72.33686523437495, lng: 52.66191406250002 },
        { lat: 72.39096679687506, lng: 52.7057617187501 },
        { lat: 72.43696289062501, lng: 52.71386718749997 },
        { lat: 72.48295898437505, lng: 52.74873046875004 },
        { lat: 72.54985351562499, lng: 52.86367187499999 },
        { lat: 72.59125976562501, lng: 52.82324218749997 },
        { lat: 72.61928710937502, lng: 52.83906250000003 },
        { lat: 72.66889648437501, lng: 52.91660156250006 },
        { lat: 72.68232421874998, lng: 52.68310546875003 },
        { lat: 72.70405273437498, lng: 52.60498046874997 },
        { lat: 72.73735351562502, lng: 52.52851562500004 },
        { lat: 72.76855468749997, lng: 52.55058593750002 },
        { lat: 72.791357421875, lng: 52.5792968750001 },
        { lat: 72.87524414062501, lng: 52.8122070312501 },
        { lat: 72.89995117187502, lng: 52.913183593750055 },
        { lat: 72.91357421875003, lng: 53.02421875000002 },
        { lat: 72.91323242187505, lng: 53.13496093750004 },
        { lat: 72.90375976562498, lng: 53.25351562500006 },
        { lat: 72.91674804687506, lng: 53.3698242187501 },
        { lat: 72.97314453125, lng: 53.2472656250001 },
        { lat: 73.011181640625, lng: 53.23710937500007 },
        { lat: 73.10400390625, lng: 53.18896484375003 },
        { lat: 73.14755859375, lng: 53.1979492187501 },
        { lat: 73.182958984375, lng: 53.2511718750001 },
        { lat: 73.22456054687495, lng: 53.3576171875001 },
        { lat: 73.23837890625003, lng: 53.51220703124997 },
        { lat: 73.26025390625006, lng: 53.633691406250044 },
        { lat: 73.29326171875002, lng: 53.75322265625007 },
        { lat: 73.29897460937502, lng: 53.865625 },
        { lat: 73.27646484374998, lng: 54.09101562500004 },
        { lat: 73.28134765624998, lng: 54.2023437500001 },
        { lat: 73.29946289062505, lng: 54.32763671875002 },
        { lat: 73.37001953125002, lng: 54.67607421875001 },
        { lat: 73.38764648437498, lng: 54.80390625000004 },
        { lat: 73.38325195312495, lng: 54.940625 },
        { lat: 73.3568359375, lng: 55.12138671875007 },
        { lat: 73.30830078124998, lng: 55.31982421875002 },
      ],
      [
        { lat: 73.09501953125005, lng: 70.67392578125006 },
        { lat: 73.048095703125, lng: 70.38037109375003 },
        { lat: 73.04448242187503, lng: 70.29833984375003 },
        { lat: 73.05629882812497, lng: 70.11865234374997 },
        { lat: 73.03715820312507, lng: 70.04072265625004 },
        { lat: 73.08452148437505, lng: 69.92011718750004 },
        { lat: 73.12661132812498, lng: 69.9303710937501 },
        { lat: 73.16923828125007, lng: 69.98564453125006 },
        { lat: 73.22431640625001, lng: 70.01875 },
        { lat: 73.359375, lng: 69.9958984375 },
        { lat: 73.44472656249997, lng: 70.1496093750001 },
        { lat: 73.47763671874999, lng: 70.35 },
        { lat: 73.51440429687501, lng: 70.94023437500002 },
        { lat: 73.50419921875002, lng: 71.02324218750007 },
        { lat: 73.47797851562498, lng: 71.14121093750005 },
        { lat: 73.44775390625006, lng: 71.23164062500008 },
        { lat: 73.37221679687502, lng: 71.351171875 },
        { lat: 73.34208984375002, lng: 71.444921875 },
        { lat: 73.283154296875, lng: 71.5895507812501 },
        { lat: 73.22480468750001, lng: 71.63046875000006 },
        { lat: 73.17397460937497, lng: 71.6261718750001 },
        { lat: 73.162451171875, lng: 71.35566406250004 },
        { lat: 73.11962890624999, lng: 70.88671874999997 },
        { lat: 73.09501953125005, lng: 70.67392578125006 },
      ],
      [
        { lat: 73.44580078125, lng: 76.75605468750004 },
        { lat: 73.43950195312505, lng: 76.659375 },
        { lat: 73.476220703125, lng: 76.23447265625012 },
        { lat: 73.523486328125, lng: 76.08310546875005 },
        { lat: 73.554296875, lng: 76.13955078125005 },
        { lat: 73.5552734375, lng: 76.25068359375003 },
        { lat: 73.44580078125, lng: 76.75605468750004 },
      ],
      [
        { lat: 73.456640625, lng: 75.50371093750002 },
        { lat: 73.432275390625, lng: 75.34433593750006 },
        { lat: 73.47739257812506, lng: 75.375 },
        { lat: 73.540625, lng: 75.56972656250005 },
        { lat: 73.57363281250002, lng: 75.93017578125003 },
        { lat: 73.55991210937496, lng: 76.039453125 },
        { lat: 73.54926757812495, lng: 76.05156250000007 },
        { lat: 73.48149414062499, lng: 75.90097656249999 },
        { lat: 73.45913085937497, lng: 75.82714843749997 },
        { lat: 73.456640625, lng: 75.50371093750002 },
      ],
      [
        { lat: 73.89589843750005, lng: 142.18486328125005 },
        { lat: 73.85156249999996, lng: 142.43505859374997 },
        { lat: 73.80307617187506, lng: 142.63916015624997 },
        { lat: 73.56875, lng: 143.34375 },
        { lat: 73.52084960937503, lng: 143.41074218750012 },
        { lat: 73.45888671875002, lng: 143.46396484375006 },
        { lat: 73.24643554687498, lng: 143.49130859375012 },
        { lat: 73.231298828125, lng: 143.45146484375007 },
        { lat: 73.22075195312499, lng: 143.19326171875005 },
        { lat: 73.24482421875001, lng: 142.84160156250002 },
        { lat: 73.25332031249995, lng: 142.58691406249997 },
        { lat: 73.25288085937495, lng: 142.34218750000005 },
        { lat: 73.28168945312498, lng: 142.12636718750005 },
        { lat: 73.31083984375003, lng: 141.59667968750003 },
        { lat: 73.38920898437502, lng: 141.18271484375006 },
        { lat: 73.44604492187497, lng: 140.75400390625006 },
        { lat: 73.45200195312503, lng: 140.66279296875004 },
        { lat: 73.4353515625, lng: 140.39248046875 },
        { lat: 73.36142578125006, lng: 140.02695312500006 },
        { lat: 73.35522460937503, lng: 139.92509765625002 },
        { lat: 73.35522460937503, lng: 139.785546875 },
        { lat: 73.42573242187501, lng: 139.68554687499994 },
        { lat: 73.44858398437503, lng: 139.92011718750004 },
        { lat: 73.45751953125, lng: 140.15517578125 },
        { lat: 73.48300781250003, lng: 140.3806640625 },
        { lat: 73.56455078125003, lng: 140.59355468750002 },
        { lat: 73.62915039062497, lng: 140.6974609375001 },
        { lat: 73.77753906250001, lng: 140.8837890625 },
        { lat: 73.83154296875, lng: 140.9835937500001 },
        { lat: 73.86586914062497, lng: 141.08476562500002 },
        { lat: 73.87646484375, lng: 141.18994140624997 },
        { lat: 73.871875, lng: 141.3119140625 },
        { lat: 73.90419921874997, lng: 141.68193359375002 },
        { lat: 73.91494140625002, lng: 141.9318359375001 },
        { lat: 73.89589843750005, lng: 142.18486328125005 },
      ],
      [
        { lat: 73.85009765625003, lng: 124.54296875000003 },
        { lat: 73.84790039062503, lng: 124.48173828125007 },
        { lat: 73.87460937499998, lng: 124.36640625000003 },
        { lat: 73.91030273437497, lng: 124.33574218750002 },
        { lat: 73.928369140625, lng: 124.33652343750006 },
        { lat: 73.94301757812497, lng: 124.42968749999996 },
        { lat: 73.93383789062504, lng: 124.54765625000002 },
        { lat: 73.90039062499997, lng: 124.63691406250003 },
        { lat: 73.88803710937503, lng: 124.65292968750005 },
        { lat: 73.85009765625003, lng: 124.54296875000003 },
      ],
      [
        { lat: 74.07177734375, lng: 83.5490234375001 },
        { lat: 74.04843750000003, lng: 83.49580078125008 },
        { lat: 74.05166015625, lng: 83.45 },
        { lat: 74.03955078125, lng: 83.41064453124997 },
        { lat: 74.07534179687502, lng: 83.15898437500002 },
        { lat: 74.09160156250003, lng: 82.8177734375 },
        { lat: 74.12890625, lng: 82.90292968750012 },
        { lat: 74.151611328125, lng: 83.14980468750005 },
        { lat: 74.12236328124999, lng: 83.51347656250002 },
        { lat: 74.08945312500002, lng: 83.6183593750001 },
        { lat: 74.07177734375, lng: 83.5490234375001 },
      ],
      [
        { lat: 74.09086914062507, lng: 82.70996093750003 },
        { lat: 74.05644531250007, lng: 82.61279296874996 },
        { lat: 74.07578125, lng: 82.478125 },
        { lat: 74.09921874999998, lng: 82.3815429687501 },
        { lat: 74.131103515625, lng: 82.32939453125002 },
        { lat: 74.14926757812498, lng: 82.38242187500012 },
        { lat: 74.16142578125005, lng: 82.52558593750004 },
        { lat: 74.14853515625, lng: 82.61103515625004 },
        { lat: 74.11123046875005, lng: 82.68896484375003 },
        { lat: 74.09086914062507, lng: 82.70996093750003 },
      ],
      [
        { lat: 73.91362304687502, lng: 136.1974609375001 },
        { lat: 73.88500976562506, lng: 136.12167968750012 },
        { lat: 73.92910156249995, lng: 136.0514648437501 },
        { lat: 74.05952148437497, lng: 135.71455078125004 },
        { lat: 74.12143554687498, lng: 135.63339843750012 },
        { lat: 74.17968750000003, lng: 135.4486328125 },
        { lat: 74.20170898437499, lng: 135.40244140625012 },
        { lat: 74.25336914062495, lng: 135.38701171875007 },
        { lat: 74.21992187499998, lng: 135.62832031250005 },
        { lat: 74.09033203125006, lng: 136.03681640625004 },
        { lat: 73.98496093749998, lng: 136.25917968750005 },
        { lat: 73.91362304687502, lng: 136.1974609375001 },
      ],
      [
        { lat: 73.99946289062501, lng: 141.01025390625003 },
        { lat: 73.91865234374998, lng: 140.50722656250005 },
        { lat: 73.92167968750005, lng: 140.40947265625002 },
        { lat: 74.00458984374997, lng: 140.18320312500012 },
        { lat: 74.18427734375001, lng: 140.10156249999997 },
        { lat: 74.23671875000002, lng: 140.19355468750007 },
        { lat: 74.25722656250002, lng: 140.30029296874997 },
        { lat: 74.26645507812503, lng: 140.40742187500004 },
        { lat: 74.27377929687503, lng: 140.84921875000006 },
        { lat: 74.26464843750003, lng: 140.94433593750003 },
        { lat: 74.24272460937502, lng: 141.03857421875003 },
        { lat: 74.20932617187503, lng: 141.07949218749997 },
        { lat: 74.16782226562503, lng: 141.09746093750002 },
        { lat: 74.05039062499998, lng: 141.046875 },
        { lat: 73.99946289062501, lng: 141.01025390625003 },
      ],
      [
        { lat: 74.45942382812501, lng: 84.75898437500003 },
        { lat: 74.39980468750002, lng: 84.71044921875003 },
        { lat: 74.43032226562502, lng: 84.42890625000004 },
        { lat: 74.45444335937498, lng: 84.38945312500007 },
        { lat: 74.49042968750001, lng: 84.54033203125007 },
        { lat: 74.51235351562504, lng: 84.6798828125001 },
        { lat: 74.51552734374998, lng: 84.87285156250007 },
        { lat: 74.45942382812501, lng: 84.75898437500003 },
      ],
      [
        { lat: 74.40043945312499, lng: 113.38720703124997 },
        { lat: 74.35297851562498, lng: 113.353125 },
        { lat: 74.31713867187497, lng: 113.29921875 },
        { lat: 74.27270507812497, lng: 113.25888671875012 },
        { lat: 74.23930664062502, lng: 113.19023437500007 },
        { lat: 74.19682617187507, lng: 112.97763671875012 },
        { lat: 74.10292968750002, lng: 112.81132812500007 },
        { lat: 74.09506835937502, lng: 112.78242187500003 },
        { lat: 74.14624023437497, lng: 112.19580078124996 },
        { lat: 74.16323242187497, lng: 112.10507812500006 },
        { lat: 74.21923828125003, lng: 111.91210937500001 },
        { lat: 74.27294921875003, lng: 111.64296875 },
        { lat: 74.35307617187502, lng: 111.50341796874997 },
        { lat: 74.36831054687502, lng: 111.57011718750007 },
        { lat: 74.37431640624999, lng: 111.6375 },
        { lat: 74.36381835937499, lng: 111.87978515625 },
        { lat: 74.38876953124999, lng: 111.94921875000003 },
        { lat: 74.456298828125, lng: 111.98281250000004 },
        { lat: 74.49624023437497, lng: 111.98935546875012 },
        { lat: 74.52675781249997, lng: 112.00761718750002 },
        { lat: 74.54897460937504, lng: 112.08447265624996 },
        { lat: 74.47958984375003, lng: 112.95175781250005 },
        { lat: 74.44101562499998, lng: 113.28623046875012 },
        { lat: 74.40043945312499, lng: 113.38720703124997 },
      ],
      [
        { lat: 74.981298828125, lng: 86.653125 },
        { lat: 74.96298828125, lng: 86.73710937500007 },
        { lat: 74.99194335937506, lng: 87.00058593750012 },
        { lat: 74.982568359375, lng: 87.05214843750005 },
        { lat: 74.93989257812501, lng: 87.12431640625007 },
        { lat: 74.86191406250003, lng: 87.01171874999997 },
        { lat: 74.83076171874998, lng: 86.92714843750005 },
        { lat: 74.848291015625, lng: 86.69199218750012 },
        { lat: 74.85087890624997, lng: 86.39052734375 },
        { lat: 74.89350585937498, lng: 86.25859375000002 },
        { lat: 74.93896484375, lng: 86.33066406250012 },
        { lat: 74.965966796875, lng: 86.50449218750012 },
        { lat: 74.99282226562497, lng: 86.60546874999996 },
        { lat: 74.981298828125, lng: 86.653125 },
      ],
      [
        { lat: 75.41938476562501, lng: 82.17236328125003 },
        { lat: 75.38696289062497, lng: 82.20878906250007 },
        { lat: 75.35053710937501, lng: 82.22158203125 },
        { lat: 75.33896484375005, lng: 82.17929687500012 },
        { lat: 75.34096679687502, lng: 82.05009765625007 },
        { lat: 75.24711914062499, lng: 81.97851562499997 },
        { lat: 75.26279296874998, lng: 81.90507812500002 },
        { lat: 75.31650390625, lng: 81.8605468750001 },
        { lat: 75.28051757812506, lng: 81.69765625000005 },
        { lat: 75.28891601562498, lng: 81.65478515625001 },
        { lat: 75.33095703125001, lng: 81.5792968750001 },
        { lat: 75.33955078124998, lng: 81.53212890625 },
        { lat: 75.367919921875, lng: 81.50058593750012 },
        { lat: 75.45141601562506, lng: 81.71210937500004 },
        { lat: 75.40703125000007, lng: 81.8421875 },
        { lat: 75.40996093750005, lng: 81.92656250000002 },
        { lat: 75.46000976562502, lng: 81.90976562500006 },
        { lat: 75.49770507812495, lng: 81.9127929687501 },
        { lat: 75.51347656249999, lng: 82.021875 },
        { lat: 75.515625, lng: 82.165625 },
        { lat: 75.41938476562501, lng: 82.17236328125003 },
      ],
      [
        { lat: 75.37075195312505, lng: 146.79521484375007 },
        { lat: 75.36430664062507, lng: 147.06035156250007 },
        { lat: 75.43798828124997, lng: 147.44355468750004 },
        { lat: 75.44052734375003, lng: 147.49697265625 },
        { lat: 75.41352539062495, lng: 148.43242187500002 },
        { lat: 75.38745117187497, lng: 148.5088867187501 },
        { lat: 75.33647460937497, lng: 148.51884765625002 },
        { lat: 75.309375, lng: 148.48916015625 },
        { lat: 75.27241210937498, lng: 148.475 },
        { lat: 75.23637695312502, lng: 148.59013671875007 },
        { lat: 75.228125, lng: 148.89218750000006 },
        { lat: 75.262060546875, lng: 149.08320312500004 },
        { lat: 75.24458007812501, lng: 149.64531250000002 },
        { lat: 75.21923828125, lng: 150.10390625 },
        { lat: 75.16401367187501, lng: 150.28066406250005 },
        { lat: 75.134326171875, lng: 150.41718750000004 },
        { lat: 75.099853515625, lng: 150.53056640625007 },
        { lat: 75.12016601562507, lng: 150.61289062500012 },
        { lat: 75.15532226562502, lng: 150.69033203125 },
        { lat: 75.16240234375005, lng: 150.75693359375006 },
        { lat: 75.15654296875002, lng: 150.82236328125006 },
        { lat: 74.944580078125, lng: 150.6462890625 },
        { lat: 74.9189453125, lng: 150.5802734375 },
        { lat: 74.86679687500003, lng: 150.33125 },
        { lat: 74.79531249999997, lng: 149.83808593750004 },
        { lat: 74.77260742187505, lng: 149.596875 },
        { lat: 74.7724609375, lng: 149.0501953125 },
        { lat: 74.80043945312502, lng: 148.296875 },
        { lat: 74.82568359375003, lng: 148.09238281250006 },
        { lat: 74.85732421874998, lng: 147.971875 },
        { lat: 74.931982421875, lng: 147.7409179687501 },
        { lat: 74.95893554687498, lng: 147.62685546875 },
        { lat: 74.98427734375, lng: 147.2570312500001 },
        { lat: 74.99843750000005, lng: 147.14404296874997 },
        { lat: 75.0625, lng: 146.9249023437501 },
        { lat: 75.11420898437501, lng: 146.7033203125001 },
        { lat: 75.19829101562497, lng: 146.14853515625012 },
        { lat: 75.29555664062498, lng: 146.18613281250006 },
        { lat: 75.39375, lng: 146.2576171875 },
        { lat: 75.48090820312501, lng: 146.34296875000004 },
        { lat: 75.55820312500003, lng: 146.43847656250003 },
        { lat: 75.58178710937506, lng: 146.5375 },
        { lat: 75.51044921874997, lng: 146.7509765625 },
        { lat: 75.42866210937504, lng: 146.7482421875001 },
        { lat: 75.37075195312505, lng: 146.79521484375007 },
      ],
      [
        { lat: 75.40957031250005, lng: 135.9486328125 },
        { lat: 75.38198242187502, lng: 135.74589843750002 },
        { lat: 75.38955078124997, lng: 135.45195312500007 },
        { lat: 75.46323242187506, lng: 135.47304687499997 },
        { lat: 75.49584960937503, lng: 135.52343749999997 },
        { lat: 75.57646484375002, lng: 135.59267578125005 },
        { lat: 75.636474609375, lng: 135.56123046875004 },
        { lat: 75.70996093750006, lng: 135.57841796875002 },
        { lat: 75.76630859374998, lng: 135.61386718750012 },
        { lat: 75.84526367187499, lng: 135.69863281249997 },
        { lat: 75.79848632812497, lng: 135.78828125000004 },
        { lat: 75.72924804687497, lng: 135.84921875000012 },
        { lat: 75.69438476562497, lng: 135.90478515624997 },
        { lat: 75.6255859375, lng: 136.12734375 },
        { lat: 75.60556640625, lng: 136.16894531249997 },
        { lat: 75.521923828125, lng: 135.98339843749997 },
        { lat: 75.48613281250002, lng: 135.96513671875 },
        { lat: 75.43837890624997, lng: 136.02050781249997 },
        { lat: 75.40957031250005, lng: 135.9486328125 },
      ],
      [
        { lat: 76.121728515625, lng: 152.8859375 },
        { lat: 76.08579101562506, lng: 152.78632812500004 },
        { lat: 76.14360351562502, lng: 152.55859375000003 },
        { lat: 76.17480468749997, lng: 152.64277343750004 },
        { lat: 76.19482421874997, lng: 152.79941406250006 },
        { lat: 76.18515625000002, lng: 152.83505859375006 },
        { lat: 76.16342773437498, lng: 152.86376953125003 },
        { lat: 76.121728515625, lng: 152.8859375 },
      ],
      [
        { lat: 75.82895507812503, lng: 140.04873046875 },
        { lat: 75.80981445312506, lng: 140.15214843750002 },
        { lat: 75.82241210937505, lng: 140.27441406249997 },
        { lat: 75.79584960937495, lng: 140.38906250000005 },
        { lat: 75.68979492187503, lng: 140.4962890625 },
        { lat: 75.66318359375003, lng: 140.54667968750002 },
        { lat: 75.64394531250002, lng: 140.60214843750012 },
        { lat: 75.63413085937506, lng: 140.65673828125003 },
        { lat: 75.63071289062498, lng: 140.81591796874994 },
        { lat: 75.65200195312495, lng: 140.88925781250006 },
        { lat: 75.70048828124999, lng: 140.94414062500007 },
        { lat: 75.74951171875003, lng: 140.94042968750003 },
        { lat: 75.79892578125006, lng: 140.92656250000002 },
        { lat: 75.86684570312502, lng: 140.92578124999994 },
        { lat: 75.92734375, lng: 140.95029296875003 },
        { lat: 75.96450195312501, lng: 140.9853515625 },
        { lat: 75.98896484374995, lng: 141.03261718750005 },
        { lat: 76.06376953125002, lng: 141.29931640625003 },
        { lat: 76.13715820312495, lng: 141.48544921875012 },
        { lat: 76.10805664062497, lng: 141.74228515625012 },
        { lat: 76.04355468749998, lng: 142.00146484374997 },
        { lat: 75.90361328125007, lng: 142.46035156250005 },
        { lat: 75.86342773437495, lng: 142.66953125000012 },
        { lat: 75.82690429687497, lng: 142.92675781250003 },
        { lat: 75.81362304687502, lng: 143.18515625000006 },
        { lat: 75.82231445312502, lng: 143.31113281250006 },
        { lat: 75.86040039062505, lng: 143.55996093749997 },
        { lat: 75.86367187500002, lng: 143.68583984375002 },
        { lat: 75.58559570312502, lng: 145.25527343750005 },
        { lat: 75.56406249999998, lng: 145.30976562500004 },
        { lat: 75.53046874999998, lng: 145.35996093750006 },
        { lat: 75.48974609375003, lng: 145.02343749999997 },
        { lat: 75.41606445312505, lng: 144.803125 },
        { lat: 75.36557617187506, lng: 144.7267578125001 },
        { lat: 75.32451171875005, lng: 144.81425781250007 },
        { lat: 75.2689453125, lng: 144.88349609375004 },
        { lat: 75.10229492187497, lng: 144.40781250000006 },
        { lat: 75.05917968749998, lng: 144.21601562500004 },
        { lat: 75.04467773437506, lng: 144.0197265625 },
        { lat: 75.08398437499997, lng: 143.62587890625 },
        { lat: 75.08286132812499, lng: 143.39609375000006 },
        { lat: 75.11689453125001, lng: 143.1703125 },
        { lat: 75.217431640625, lng: 142.92207031250004 },
        { lat: 75.26782226562503, lng: 142.82011718750007 },
        { lat: 75.33764648437506, lng: 142.72949218749997 },
        { lat: 75.44887695312497, lng: 142.699609375 },
        { lat: 75.54458007812502, lng: 142.73447265625012 },
        { lat: 75.57177734375006, lng: 142.86757812500005 },
        { lat: 75.63325195312495, lng: 142.98603515625004 },
        { lat: 75.65986328124995, lng: 143.00244140624997 },
        { lat: 75.71328125000002, lng: 142.941796875 },
        { lat: 75.72089843749995, lng: 142.55156250000007 },
        { lat: 75.69169921875005, lng: 142.30791015625007 },
        { lat: 75.66064453125003, lng: 142.08623046875002 },
        { lat: 75.45756835937505, lng: 142.1510742187501 },
        { lat: 75.39267578124998, lng: 142.19882812500006 },
        { lat: 75.34614257812501, lng: 142.26474609375006 },
        { lat: 75.13325195312498, lng: 142.61679687500012 },
        { lat: 75.10307617187505, lng: 142.69697265625004 },
        { lat: 75.06240234375002, lng: 142.92968749999997 },
        { lat: 74.9703125, lng: 143.12792968749997 },
        { lat: 74.86777343749996, lng: 142.77822265625005 },
        { lat: 74.83740234375, lng: 142.62607421875006 },
        { lat: 74.82041015625, lng: 142.47275390625006 },
        { lat: 74.82856445312498, lng: 142.37841796874997 },
        { lat: 74.84990234375007, lng: 142.28740234375007 },
        { lat: 74.89960937499998, lng: 142.18417968750006 },
        { lat: 74.95097656250005, lng: 142.1 },
        { lat: 74.99125976562499, lng: 141.9873046875 },
        { lat: 74.982568359375, lng: 141.74843750000005 },
        { lat: 74.94716796875, lng: 141.52998046875004 },
        { lat: 74.92319335937498, lng: 141.31044921875 },
        { lat: 74.8818359375, lng: 140.66074218750006 },
        { lat: 74.85605468749998, lng: 140.46386718749997 },
        { lat: 74.846923828125, lng: 140.26787109375 },
        { lat: 74.89477539062497, lng: 140.01103515625002 },
        { lat: 74.96376953125, lng: 139.75820312500005 },
        { lat: 74.96406249999995, lng: 139.68125 },
        { lat: 74.94560546875002, lng: 139.605859375 },
        { lat: 74.904052734375, lng: 139.54804687500004 },
        { lat: 74.83779296875, lng: 139.51230468750012 },
        { lat: 74.74921874999998, lng: 139.430078125 },
        { lat: 74.68681640625007, lng: 139.3255859375 },
        { lat: 74.65966796875003, lng: 139.21533203125003 },
        { lat: 74.65654296875002, lng: 139.09912109374997 },
        { lat: 74.67368164062506, lng: 138.98173828125002 },
        { lat: 74.70092773437499, lng: 138.865625 },
        { lat: 74.79746093750003, lng: 138.09228515625003 },
        { lat: 74.82700195312503, lng: 138.00136718750005 },
        { lat: 74.87084960937497, lng: 137.91503906249997 },
        { lat: 75.00854492187497, lng: 137.68300781250005 },
        { lat: 75.04057617187502, lng: 137.56806640625004 },
        { lat: 75.05419921875003, lng: 137.4469726562501 },
        { lat: 75.12373046874998, lng: 137.21796875000004 },
        { lat: 75.23500976562502, lng: 137.00625 },
        { lat: 75.270361328125, lng: 136.9623046875 },
        { lat: 75.32553710937498, lng: 136.94765625000002 },
        { lat: 75.36533203125, lng: 136.98242187500003 },
        { lat: 75.34658203125, lng: 137.16601562499997 },
        { lat: 75.34863281249997, lng: 137.28974609375004 },
        { lat: 75.55439453124998, lng: 137.21523437500005 },
        { lat: 75.74941406249998, lng: 137.26884765625002 },
        { lat: 75.781640625, lng: 137.35849609375006 },
        { lat: 75.75957031250002, lng: 137.70654296875003 },
        { lat: 75.82338867187497, lng: 137.59355468750002 },
        { lat: 75.90966796874997, lng: 137.50117187500004 },
        { lat: 75.95522460937502, lng: 137.56054687499997 },
        { lat: 75.98818359374997, lng: 137.625390625 },
        { lat: 76.01567382812507, lng: 137.77441406250003 },
        { lat: 76.02778320312495, lng: 137.97705078124997 },
        { lat: 76.04726562500002, lng: 138.03867187500012 },
        { lat: 76.08051757812495, lng: 138.09599609375007 },
        { lat: 76.11494140624994, lng: 138.20761718750003 },
        { lat: 76.130078125, lng: 138.43066406250003 },
        { lat: 76.19970703124999, lng: 138.81396484374997 },
        { lat: 76.19672851562501, lng: 138.91953125000006 },
        { lat: 76.16010742187501, lng: 139.01757812499994 },
        { lat: 76.10834960937503, lng: 139.10917968750007 },
        { lat: 76.080712890625, lng: 139.211328125 },
        { lat: 76.01342773437497, lng: 139.52851562500004 },
        { lat: 75.95307617187501, lng: 139.74335937500004 },
        { lat: 75.82895507812503, lng: 140.04873046875 },
      ],
      [
        { lat: 76.278125, lng: 96.5324218750001 },
        { lat: 76.26381835937498, lng: 96.6139648437501 },
        { lat: 76.22124023437502, lng: 96.5896484375 },
        { lat: 76.233740234375, lng: 96.48671875 },
        { lat: 76.21215820312503, lng: 96.3507812500001 },
        { lat: 76.177490234375, lng: 96.35341796874998 },
        { lat: 76.121728515625, lng: 96.30058593750002 },
        { lat: 76.15546874999995, lng: 96.1087890625 },
        { lat: 76.16025390625003, lng: 95.84453125000002 },
        { lat: 76.19365234374999, lng: 95.67861328125004 },
        { lat: 76.21474609375002, lng: 95.31113281250006 },
        { lat: 76.26162109375, lng: 95.32207031250007 },
        { lat: 76.2890625, lng: 95.37988281250003 },
        { lat: 76.24960937500003, lng: 95.59443359375004 },
        { lat: 76.29389648437498, lng: 95.7862304687501 },
        { lat: 76.271875, lng: 96.15097656250006 },
        { lat: 76.30537109375001, lng: 96.27070312500004 },
        { lat: 76.278125, lng: 96.5324218750001 },
      ],
      [
        { lat: 76.19916992187498, lng: 96.85390625 },
        { lat: 76.18842773437501, lng: 96.79785156249997 },
        { lat: 76.19575195312498, lng: 96.75449218750012 },
        { lat: 76.20693359375005, lng: 96.73935546875006 },
        { lat: 76.25786132812502, lng: 96.74023437499997 },
        { lat: 76.32416992187504, lng: 96.83291015625 },
        { lat: 76.34482421874998, lng: 96.83525390625002 },
        { lat: 76.35522460937497, lng: 96.87792968750001 },
        { lat: 76.34340820312505, lng: 96.99023437499997 },
        { lat: 76.315380859375, lng: 97.04531250000005 },
        { lat: 76.30258789062498, lng: 97.05302734375002 },
        { lat: 76.23652343750004, lng: 96.9742187500001 },
        { lat: 76.19916992187498, lng: 96.85390625 },
      ],
      [
        { lat: 76.62089843749999, lng: 112.47802734375001 },
        { lat: 76.55297851562501, lng: 112.63251953125004 },
        { lat: 76.50957031250005, lng: 112.66083984375004 },
        { lat: 76.499267578125, lng: 112.61416015625004 },
        { lat: 76.48295898437505, lng: 112.58652343750012 },
        { lat: 76.45239257812506, lng: 112.57480468750012 },
        { lat: 76.450048828125, lng: 112.531640625 },
        { lat: 76.48378906250005, lng: 112.39482421875 },
        { lat: 76.53798828124998, lng: 112.296875 },
        { lat: 76.54931640624997, lng: 112.15380859374997 },
        { lat: 76.60297851562498, lng: 112.00273437500002 },
        { lat: 76.626171875, lng: 111.96894531250004 },
        { lat: 76.63286132812505, lng: 112.01113281250005 },
        { lat: 76.618359375, lng: 112.28144531250003 },
        { lat: 76.64379882812506, lng: 112.39414062500006 },
        { lat: 76.62089843749999, lng: 112.47802734375001 },
      ],
      [
        { lat: 76.59936523437497, lng: 97.58837890624997 },
        { lat: 76.58442382812504, lng: 97.53525390625012 },
        { lat: 76.59072265625, lng: 97.43037109375003 },
        { lat: 76.62885742187501, lng: 97.34169921875 },
        { lat: 76.68959960937497, lng: 97.31035156250002 },
        { lat: 76.706689453125, lng: 97.38164062500007 },
        { lat: 76.59936523437497, lng: 97.58837890624997 },
      ],
      [
        { lat: 76.65991210937506, lng: 149.15019531250002 },
        { lat: 76.64824218750007, lng: 148.3986328125 },
        { lat: 76.67695312499995, lng: 148.44814453125 },
        { lat: 76.74658203125003, lng: 148.71962890624997 },
        { lat: 76.78208007812498, lng: 149.4064453125001 },
        { lat: 76.74721679687497, lng: 149.26835937500002 },
        { lat: 76.67700195312497, lng: 149.20478515625 },
        { lat: 76.65991210937506, lng: 149.15019531250002 },
      ],
      [
        { lat: 76.23759765624999, lng: 67.76533203125008 },
        { lat: 76.16127929687497, lng: 67.36523437500003 },
        { lat: 76.10815429687499, lng: 67.12695312499997 },
        { lat: 76.07226562500006, lng: 66.89316406250006 },
        { lat: 76.04702148437497, lng: 66.65742187500004 },
        { lat: 75.98369140625003, lng: 66.28242187500004 },
        { lat: 75.904638671875, lng: 65.61914062500003 },
        { lat: 75.83945312500006, lng: 65.20156250000005 },
        { lat: 75.788232421875, lng: 64.74453125 },
        { lat: 75.71967773437498, lng: 64.26259765625005 },
        { lat: 75.67260742187499, lng: 63.77929687500002 },
        { lat: 75.66875, lng: 63.65947265625001 },
        { lat: 75.60307617187505, lng: 63.31669921875007 },
        { lat: 75.57573242187505, lng: 63.045996093750006 },
        { lat: 75.42773437500003, lng: 62.06611328125004 },
        { lat: 75.31962890625002, lng: 61.61621093750003 },
        { lat: 75.31083984375002, lng: 61.4865234375001 },
        { lat: 75.31484375000002, lng: 61.35595703124997 },
        { lat: 75.28100585937497, lng: 61.248828125000074 },
        { lat: 75.22255859374997, lng: 61.147265625000074 },
        { lat: 75.16367187500003, lng: 60.935644531250006 },
        { lat: 75.11083984375003, lng: 60.829199218750006 },
        { lat: 75.06860351562503, lng: 60.719238281249964 },
        { lat: 75.05502929687503, lng: 60.65537109375006 },
        { lat: 75.05927734375001, lng: 60.533789062500055 },
        { lat: 75.05473632812505, lng: 60.47558593750003 },
        { lat: 75.00756835937501, lng: 60.27685546875003 },
        { lat: 74.97075195312497, lng: 60.24111328125005 },
        { lat: 74.94614257812503, lng: 60.45488281250007 },
        { lat: 74.90463867187503, lng: 60.501367187499994 },
        { lat: 74.875341796875, lng: 60.43916015625003 },
        { lat: 74.83701171875, lng: 60.30078125000003 },
        { lat: 74.79658203124995, lng: 60.22246093750002 },
        { lat: 74.75585937499999, lng: 60.08007812499998 },
        { lat: 74.74462890625003, lng: 59.98232421875005 },
        { lat: 74.74589843750002, lng: 59.74726562500003 },
        { lat: 74.69545898437505, lng: 59.73466796875008 },
        { lat: 74.66445312500002, lng: 59.77148437500003 },
        { lat: 74.63701171875003, lng: 59.75273437500001 },
        { lat: 74.61015624999999, lng: 59.67402343750003 },
        { lat: 74.61372070312501, lng: 59.59599609375007 },
        { lat: 74.69296874999996, lng: 59.24013671875005 },
        { lat: 74.66577148437503, lng: 59.18203125 },
        { lat: 74.61083984375001, lng: 59.15703125000007 },
        { lat: 74.55190429687502, lng: 59.14609375000006 },
        { lat: 74.50751953124994, lng: 59.100976562499994 },
        { lat: 74.48554687500001, lng: 59.040429687499994 },
        { lat: 74.46269531250005, lng: 58.92822265624997 },
        { lat: 74.49892578124997, lng: 58.53466796875003 },
        { lat: 74.464208984375, lng: 58.50214843750003 },
        { lat: 74.42182617187498, lng: 58.56201171874997 },
        { lat: 74.32802734374997, lng: 58.6457031250001 },
        { lat: 74.28925781249997, lng: 58.66503906250003 },
        { lat: 74.22739257812498, lng: 58.617871093750104 },
        { lat: 74.12885742187498, lng: 58.44140625000002 },
        { lat: 74.01381835937498, lng: 57.76738281250002 },
        { lat: 73.97392578125003, lng: 57.77841796875007 },
        { lat: 73.8978515625, lng: 57.85341796875005 },
        { lat: 73.85043945312503, lng: 57.87226562500003 },
        { lat: 73.80507812500002, lng: 57.84492187500009 },
        { lat: 73.769189453125, lng: 57.755957031250006 },
        { lat: 73.76816406250003, lng: 57.657421875000104 },
        { lat: 73.77548828125003, lng: 57.60371093750003 },
        { lat: 73.82563476562504, lng: 57.448535156250074 },
        { lat: 73.838037109375, lng: 57.3130859375 },
        { lat: 73.81455078125, lng: 57.290917968749994 },
        { lat: 73.74604492187498, lng: 57.464257812499994 },
        { lat: 73.65820312500003, lng: 57.542578125000055 },
        { lat: 73.61030273437495, lng: 57.459765625000074 },
        { lat: 73.50439453125006, lng: 57.134375 },
        { lat: 73.36655273437503, lng: 56.96386718750002 },
        { lat: 73.30429687500003, lng: 56.63417968749999 },
        { lat: 73.29721679687503, lng: 56.43037109375004 },
        { lat: 73.314111328125, lng: 56.228320312500074 },
        { lat: 73.34589843749998, lng: 56.03457031250005 },
        { lat: 73.3568359375, lng: 55.54921875 },
        { lat: 73.39204101562498, lng: 55.28017578124999 },
        { lat: 73.45385742187506, lng: 55.00683593750003 },
        { lat: 73.44941406250004, lng: 54.768652343750055 },
        { lat: 73.41850585937505, lng: 54.56582031250005 },
        { lat: 73.35097656249997, lng: 54.29990234375006 },
        { lat: 73.48100585937497, lng: 54.13154296875004 },
        { lat: 73.54204101562499, lng: 54.20458984374997 },
        { lat: 73.69711914062505, lng: 53.838671875000074 },
        { lat: 73.76616210937499, lng: 53.76289062500009 },
        { lat: 73.80053710937497, lng: 53.851367187500074 },
        { lat: 73.82231445312507, lng: 53.963476562500006 },
        { lat: 73.88574218750001, lng: 54.1740234375001 },
        { lat: 73.93564453124998, lng: 54.386328125000055 },
        { lat: 73.95131835937497, lng: 54.60566406250009 },
        { lat: 73.95957031250006, lng: 54.64267578125006 },
        { lat: 74.03398437500002, lng: 54.73339843749997 },
        { lat: 74.09575195312499, lng: 54.83125 },
        { lat: 74.12910156249994, lng: 54.92031250000005 },
        { lat: 74.18662109375003, lng: 55.022851562499994 },
        { lat: 74.41962890624997, lng: 55.34091796875006 },
        { lat: 74.43613281249998, lng: 55.41640625000005 },
        { lat: 74.48129882812503, lng: 56.0783203125001 },
        { lat: 74.49609375000003, lng: 56.13710937500005 },
        { lat: 74.54218749999998, lng: 55.94746093750004 },
        { lat: 74.54121093749998, lng: 55.751757812500074 },
        { lat: 74.55610351562498, lng: 55.661523437499994 },
        { lat: 74.59052734374998, lng: 55.61035156250003 },
        { lat: 74.627685546875, lng: 55.5822265625001 },
        { lat: 74.65629882812507, lng: 55.65966796874997 },
        { lat: 74.79609375000004, lng: 55.913671875 },
        { lat: 74.89750976562499, lng: 56.217871093750006 },
        { lat: 74.95708007812505, lng: 56.4987304687501 },
        { lat: 74.97294921874999, lng: 56.42851562500002 },
        { lat: 75.01347656249999, lng: 56.3400390625001 },
        { lat: 75.00336914062498, lng: 55.99804687499997 },
        { lat: 75.058740234375, lng: 55.86318359375005 },
        { lat: 75.090625, lng: 55.821191406249994 },
        { lat: 75.12490234374995, lng: 55.81005859374997 },
        { lat: 75.16835937500002, lng: 55.92070312500002 },
        { lat: 75.19423828124997, lng: 56.03554687499999 },
        { lat: 75.18657226562499, lng: 56.162207031250006 },
        { lat: 75.164306640625, lng: 56.288671875 },
        { lat: 75.13818359375, lng: 56.38906250000005 },
        { lat: 75.09609375000005, lng: 56.485253906249994 },
        { lat: 75.09775390625003, lng: 56.57031250000002 },
        { lat: 75.24438476562497, lng: 56.87626953125002 },
        { lat: 75.27773437500002, lng: 56.82929687500003 },
        { lat: 75.32841796875005, lng: 56.809472656249994 },
        { lat: 75.351416015625, lng: 56.84443359375009 },
        { lat: 75.37509765625003, lng: 56.98945312500004 },
        { lat: 75.38383789062505, lng: 57.0875 },
        { lat: 75.3732421875, lng: 57.30175781250003 },
        { lat: 75.34125976562498, lng: 57.60683593749999 },
        { lat: 75.35644531249997, lng: 57.63154296875004 },
        { lat: 75.45449218749997, lng: 57.70820312500004 },
        { lat: 75.50668945312503, lng: 57.7833984375001 },
        { lat: 75.59252929687503, lng: 58.09365234375005 },
        { lat: 75.61899414062498, lng: 58.07255859375002 },
        { lat: 75.6630859375, lng: 58.05830078125003 },
        { lat: 75.71977539062502, lng: 58.418359375000044 },
        { lat: 75.77680664062497, lng: 58.65273437499999 },
        { lat: 75.85478515625007, lng: 58.88125 },
        { lat: 75.87172851562497, lng: 58.994726562500006 },
        { lat: 75.87373046875001, lng: 59.110449218750055 },
        { lat: 75.90703125000005, lng: 59.34658203125005 },
        { lat: 75.94584960937505, lng: 59.7819335937501 },
        { lat: 75.98383789062498, lng: 60.03613281250002 },
        { lat: 76.06655273437505, lng: 60.11816406250003 },
        { lat: 76.09624023437505, lng: 60.27929687499997 },
        { lat: 76.108642578125, lng: 60.60615234375005 },
        { lat: 76.10405273437505, lng: 60.730566406250006 },
        { lat: 76.06879882812495, lng: 60.80117187499999 },
        { lat: 76.07128906250003, lng: 60.94218750000001 },
        { lat: 76.08925781249997, lng: 60.99775390625009 },
        { lat: 76.11987304687497, lng: 61.05390625000004 },
        { lat: 76.16904296875006, lng: 61.03691406250008 },
        { lat: 76.232958984375, lng: 61.034375 },
        { lat: 76.27353515625003, lng: 61.15693359375009 },
        { lat: 76.28203125000007, lng: 61.20166015624997 },
        { lat: 76.29848632812505, lng: 61.56943359375 },
        { lat: 76.29101562500003, lng: 61.787109375000036 },
        { lat: 76.2416015625, lng: 62.23730468750003 },
        { lat: 76.23046875000003, lng: 62.47109375000005 },
        { lat: 76.24521484375003, lng: 62.782031250000074 },
        { lat: 76.23666992187498, lng: 62.97148437500002 },
        { lat: 76.30952148437497, lng: 63.526171875000024 },
        { lat: 76.37817382812501, lng: 64.4634765625 },
        { lat: 76.426025390625, lng: 64.7076171875 },
        { lat: 76.48432617187497, lng: 64.95 },
        { lat: 76.49672851562502, lng: 65.0728515625 },
        { lat: 76.499658203125, lng: 65.19716796875005 },
        { lat: 76.51791992187498, lng: 65.30976562500004 },
        { lat: 76.56782226562501, lng: 65.52841796875 },
        { lat: 76.57866210937502, lng: 65.6369140625001 },
        { lat: 76.57929687499994, lng: 65.75517578125002 },
        { lat: 76.61333007812505, lng: 65.86289062499999 },
        { lat: 76.68793945312497, lng: 65.95888671875005 },
        { lat: 76.74609375000003, lng: 66.06298828125003 },
        { lat: 76.821044921875, lng: 66.34521484374997 },
        { lat: 76.923828125, lng: 66.82880859375008 },
        { lat: 76.96376953125005, lng: 67.26367187500003 },
        { lat: 77.00776367187504, lng: 67.53496093750007 },
        { lat: 77.01157226562499, lng: 67.65185546874996 },
        { lat: 76.990625, lng: 68.0172851562501 },
        { lat: 76.93369140625003, lng: 68.48574218750005 },
        { lat: 76.87065429687499, lng: 68.69912109374998 },
        { lat: 76.78959960937499, lng: 68.87333984375007 },
        { lat: 76.76054687500002, lng: 68.91171875000006 },
        { lat: 76.707666015625, lng: 68.94169921875 },
        { lat: 76.65971679687502, lng: 68.89052734375 },
        { lat: 76.61049804687502, lng: 68.8580078125 },
        { lat: 76.57294921875001, lng: 68.8998046875 },
        { lat: 76.44941406249998, lng: 68.55859374999997 },
        { lat: 76.3134765625, lng: 68.22236328125003 },
        { lat: 76.28486328125001, lng: 68.1654296875 },
        { lat: 76.23759765624999, lng: 67.76533203125008 },
      ],
      [
        { lat: 77.02666015625007, lng: 96.28544921875002 },
        { lat: 77.00727539062501, lng: 96.25351562500012 },
        { lat: 76.99213867187495, lng: 96.20986328125 },
        { lat: 77.00253906250002, lng: 96.09140625000012 },
        { lat: 76.97495117187499, lng: 95.85468750000004 },
        { lat: 76.990625, lng: 95.76582031250004 },
        { lat: 77.02133789062503, lng: 95.68085937500004 },
        { lat: 77.01152343749999, lng: 95.36406250000007 },
        { lat: 77.01884765624999, lng: 95.27031250000007 },
        { lat: 77.056494140625, lng: 95.42070312500007 },
        { lat: 77.09755859375002, lng: 95.85410156250006 },
        { lat: 77.20551757812501, lng: 96.52841796875006 },
        { lat: 77.154052734375, lng: 96.56191406250005 },
        { lat: 77.12958984374998, lng: 96.56132812500002 },
        { lat: 77.07119140625, lng: 96.42431640624997 },
        { lat: 77.02666015625007, lng: 96.28544921875002 },
      ],
      [
        { lat: 77.18881835937498, lng: 89.51425781250005 },
        { lat: 77.18398437499995, lng: 89.29951171875004 },
        { lat: 77.20991210937501, lng: 89.17929687500006 },
        { lat: 77.22680664062497, lng: 89.14169921875012 },
        { lat: 77.27197265625003, lng: 89.20048828125002 },
        { lat: 77.30146484375001, lng: 89.28154296875002 },
        { lat: 77.31103515624999, lng: 89.61621093749997 },
        { lat: 77.28032226562505, lng: 89.67958984375 },
        { lat: 77.25449218750003, lng: 89.66582031250002 },
        { lat: 77.18881835937498, lng: 89.51425781250005 },
      ],
      [
        { lat: 77.24267578125003, lng: 107.41474609375004 },
        { lat: 77.24150390625003, lng: 107.30224609375003 },
        { lat: 77.28901367187495, lng: 107.26953125000003 },
        { lat: 77.34663085937498, lng: 107.36640625000003 },
        { lat: 77.34711914062498, lng: 107.48642578125006 },
        { lat: 77.33002929687495, lng: 107.59365234375005 },
        { lat: 77.31967773437498, lng: 107.62929687500004 },
        { lat: 77.29980468750003, lng: 107.66455078125003 },
        { lat: 77.26826171874998, lng: 107.67949218750006 },
        { lat: 77.24267578125003, lng: 107.41474609375004 },
      ],
      [
        { lat: 77.65209960937503, lng: 104.81425781250002 },
        { lat: 77.59472656249997, lng: 104.96523437500005 },
        { lat: 77.54921875000002, lng: 105.308984375 },
        { lat: 77.52524414062503, lng: 105.71025390625007 },
        { lat: 77.4888671875, lng: 105.89453125000003 },
        { lat: 77.44760742187503, lng: 105.98339843750003 },
        { lat: 77.39052734375002, lng: 106.05957031249997 },
        { lat: 77.35200195312501, lng: 105.7341796875 },
        { lat: 77.237841796875, lng: 105.38457031250007 },
        { lat: 77.17470703125002, lng: 104.91191406250002 },
        { lat: 77.13266601562498, lng: 104.3236328125 },
        { lat: 77.101806640625, lng: 104.20244140625002 },
        { lat: 77.09233398437505, lng: 105.32021484375 },
        { lat: 77.10068359375003, lng: 105.6458984375 },
        { lat: 77.00146484375, lng: 105.71201171875006 },
        { lat: 76.99750976562498, lng: 105.82216796875005 },
        { lat: 77.04531250000005, lng: 106.14541015625 },
        { lat: 77.04785156250003, lng: 106.33867187500002 },
        { lat: 77.01376953125, lng: 106.70507812499997 },
        { lat: 77.03178710937505, lng: 106.78369140624997 },
        { lat: 77.034375, lng: 106.9416015625001 },
        { lat: 76.990966796875, lng: 107.27890625000006 },
        { lat: 76.92656250000002, lng: 107.42978515625006 },
        { lat: 76.82202148437503, lng: 107.19023437500002 },
        { lat: 76.73046875000003, lng: 106.94091796875003 },
        { lat: 76.573388671875, lng: 106.63876953125012 },
        { lat: 76.58627929687505, lng: 106.54550781250012 },
        { lat: 76.58945312499998, lng: 106.38466796875005 },
        { lat: 76.51225585937499, lng: 106.41357421874997 },
        { lat: 76.51469726562505, lng: 106.68320312500012 },
        { lat: 76.480078125, lng: 106.82539062500004 },
        { lat: 76.524072265625, lng: 107.15771484374997 },
        { lat: 76.51010742187498, lng: 107.62421875000003 },
        { lat: 76.52231445312496, lng: 107.72216796875001 },
        { lat: 76.56967773437503, lng: 107.90224609375005 },
        { lat: 76.66064453125003, lng: 107.9499023437501 },
        { lat: 76.71845703124998, lng: 108.02792968750006 },
        { lat: 76.73784179687502, lng: 108.18164062500001 },
        { lat: 76.71953125000002, lng: 108.35205078125003 },
        { lat: 76.72011718749997, lng: 108.6383789062501 },
        { lat: 76.74921875000004, lng: 109.36933593750004 },
        { lat: 76.71186523437498, lng: 109.9811523437501 },
        { lat: 76.75839843750003, lng: 110.47148437500007 },
        { lat: 76.72304687500002, lng: 111.11484375000012 },
        { lat: 76.68666992187498, lng: 111.39248046875 },
        { lat: 76.62231445312503, lng: 111.60058593749997 },
        { lat: 76.60356445312502, lng: 111.78613281250003 },
        { lat: 76.55341796875001, lng: 111.93867187500008 },
        { lat: 76.48032226562506, lng: 112.09394531250004 },
        { lat: 76.42055664062504, lng: 112.01679687500004 },
        { lat: 76.38046875000003, lng: 111.94267578125002 },
        { lat: 76.42397460937501, lng: 112.14277343750004 },
        { lat: 76.43466796874998, lng: 112.2970703125001 },
        { lat: 76.40830078125003, lng: 112.41328125000003 },
        { lat: 76.38354492187506, lng: 112.61953125 },
        { lat: 76.21884765624998, lng: 112.68417968750012 },
        { lat: 76.18691406249997, lng: 112.742578125 },
        { lat: 76.12963867187503, lng: 112.7984375000001 },
        { lat: 76.07719726562499, lng: 112.721875 },
        { lat: 76.05356445312498, lng: 112.65625 },
        { lat: 76.05859375000003, lng: 112.8189453125001 },
        { lat: 76.11411132812505, lng: 113.04667968750007 },
        { lat: 76.13291015624998, lng: 113.09404296875002 },
        { lat: 76.17451171875001, lng: 113.15039062499997 },
        { lat: 76.21523437500005, lng: 113.06601562500006 },
        { lat: 76.23974609374996, lng: 112.9879882812501 },
        { lat: 76.25810546874999, lng: 113.08603515625006 },
        { lat: 76.25166015625001, lng: 113.2726562500001 },
        { lat: 76.178857421875, lng: 113.36552734375006 },
        { lat: 76.11210937499999, lng: 113.42773437499997 },
        { lat: 75.89165039062502, lng: 113.5638671875 },
        { lat: 75.92128906250002, lng: 113.85722656250007 },
        { lat: 75.85600585937505, lng: 113.87099609375005 },
        { lat: 75.70478515624998, lng: 113.7487304687501 },
        { lat: 75.59267578125005, lng: 113.61992187500002 },
        { lat: 75.56840820312499, lng: 113.56757812500003 },
        { lat: 75.56396484374996, lng: 113.48593750000012 },
        { lat: 75.621875, lng: 113.51718750000006 },
        { lat: 75.65668945312503, lng: 113.46904296875002 },
        { lat: 75.677880859375, lng: 113.39160156249996 },
        { lat: 75.69868164062498, lng: 113.12636718750005 },
        { lat: 75.83540039062501, lng: 112.62919921875002 },
        { lat: 75.84990234375005, lng: 112.49667968750006 },
        { lat: 75.84365234375002, lng: 112.46611328125007 },
        { lat: 75.83017578125003, lng: 112.45302734375 },
        { lat: 75.737646484375, lng: 112.72958984375012 },
        { lat: 75.571923828125, lng: 112.95566406250006 },
        { lat: 75.62050781250002, lng: 113.1615234375 },
        { lat: 75.61142578125003, lng: 113.24296875000007 },
        { lat: 75.53427734375006, lng: 113.35625 },
        { lat: 75.50205078125006, lng: 113.55888671875 },
        { lat: 75.45063476562498, lng: 113.72617187500012 },
        { lat: 75.29296875, lng: 113.61357421875006 },
        { lat: 75.01503906249997, lng: 112.92490234375012 },
        { lat: 74.85317382812502, lng: 112.19199218750012 },
        { lat: 74.74003906250006, lng: 111.86826171875006 },
        { lat: 74.65844726562496, lng: 111.2990234375001 },
        { lat: 74.54809570312506, lng: 110.8927734375001 },
        { lat: 74.46606445312503, lng: 110.37353515625003 },
        { lat: 74.378662109375, lng: 110.22587890625002 },
        { lat: 74.32197265624998, lng: 109.84033203124997 },
        { lat: 74.29306640625002, lng: 109.8664062500001 },
        { lat: 74.26132812499998, lng: 109.91132812500008 },
        { lat: 74.20888671875005, lng: 109.86386718750005 },
        { lat: 74.16918945312503, lng: 109.8102539062501 },
        { lat: 74.08881835937501, lng: 109.51083984375012 },
        { lat: 74.03232421875002, lng: 109.075 },
        { lat: 73.69409179687497, lng: 108.19951171875002 },
        { lat: 73.625, lng: 107.76542968750006 },
        { lat: 73.62104492187501, lng: 107.27109375000006 },
        { lat: 73.58940429687505, lng: 107.16699218749997 },
        { lat: 73.37666015624995, lng: 106.79423828125002 },
        { lat: 73.3306640625, lng: 106.67939453125004 },
        { lat: 73.3080078125, lng: 106.1886718750001 },
        { lat: 72.95927734375002, lng: 105.67714843750005 },
        { lat: 72.84101562499998, lng: 105.39277343750004 },
        { lat: 72.77705078125001, lng: 105.14394531250004 },
        { lat: 72.78994140624997, lng: 105.402734375 },
        { lat: 72.836669921875, lng: 105.7082031250001 },
        { lat: 72.94985351562505, lng: 106.06669921875002 },
        { lat: 73.002001953125, lng: 106.1595703125 },
        { lat: 73.06054687500001, lng: 106.20878906250002 },
        { lat: 73.10639648437495, lng: 106.31503906250006 },
        { lat: 73.13940429687503, lng: 106.47792968750005 },
        { lat: 73.17729492187502, lng: 107.10878906250005 },
        { lat: 73.16313476562507, lng: 107.36875 },
        { lat: 73.17314453125007, lng: 107.750390625 },
        { lat: 73.235595703125, lng: 108.00126953125007 },
        { lat: 73.25791015625, lng: 108.15097656250006 },
        { lat: 73.26586914062503, lng: 108.28535156250004 },
        { lat: 73.310205078125, lng: 108.35146484375 },
        { lat: 73.31904296875004, lng: 108.57539062500004 },
        { lat: 73.37841796875006, lng: 109.08994140625006 },
        { lat: 73.39960937500001, lng: 109.16562500000012 },
        { lat: 73.48745117187497, lng: 109.33105468749997 },
        { lat: 73.45400390625, lng: 109.637109375 },
        { lat: 73.47246093750002, lng: 109.85527343750002 },
        { lat: 73.62890625, lng: 110.42871093749997 },
        { lat: 73.68916015625004, lng: 110.77333984375 },
        { lat: 73.73071289062497, lng: 110.86816406249996 },
        { lat: 73.75976562500003, lng: 110.79921875000005 },
        { lat: 73.77993164062505, lng: 110.72236328125008 },
        { lat: 73.72602539062498, lng: 110.38828125000006 },
        { lat: 73.70854492187507, lng: 110.09121093750005 },
        { lat: 73.72255859375, lng: 109.75273437500002 },
        { lat: 73.74375, lng: 109.70673828125004 },
        { lat: 73.80024414062501, lng: 109.66562500000012 },
        { lat: 73.88125, lng: 109.7741210937501 },
        { lat: 73.93061523437501, lng: 109.86914062500003 },
        { lat: 73.99438476562503, lng: 110.08388671875005 },
        { lat: 74.01743164062503, lng: 110.26142578125008 },
        { lat: 73.947900390625, lng: 110.92011718750004 },
        { lat: 73.93935546875002, lng: 111.05625 },
        { lat: 74.05283203125003, lng: 111.13085937500003 },
        { lat: 74.04736328125, lng: 111.34140625000012 },
        { lat: 74.02851562499997, lng: 111.55058593750007 },
        { lat: 74.00483398437504, lng: 111.45996093750003 },
        { lat: 73.96855468750002, lng: 111.22812500000012 },
        { lat: 73.88486328124999, lng: 111.29951171875008 },
        { lat: 73.827734375, lng: 111.40039062500003 },
        { lat: 73.745263671875, lng: 111.80371093749997 },
        { lat: 73.70893554687498, lng: 112.14726562500007 },
        { lat: 73.71113281249998, lng: 112.40000000000012 },
        { lat: 73.74609374999999, lng: 112.79541015625003 },
        { lat: 73.77114257812502, lng: 112.85595703125003 },
        { lat: 73.83564453125004, lng: 112.9396484375001 },
        { lat: 73.96206054687502, lng: 112.83593750000001 },
        { lat: 73.94570312499997, lng: 112.93496093750005 },
        { lat: 73.91386718750007, lng: 113.03281250000005 },
        { lat: 73.83740234375003, lng: 113.18154296875 },
        { lat: 73.707421875, lng: 113.32685546875004 },
        { lat: 73.647607421875, lng: 113.4162109375001 },
        { lat: 73.58276367187501, lng: 113.36445312500004 },
        { lat: 73.45957031249998, lng: 113.15693359375004 },
        { lat: 73.39150390624997, lng: 113.27695312500006 },
        { lat: 73.34609375000002, lng: 113.49091796875004 },
        { lat: 73.14511718750003, lng: 113.48759765625007 },
        { lat: 73.04785156250001, lng: 113.47460937500003 },
        { lat: 72.94189453125003, lng: 113.36933593750004 },
        { lat: 72.89721679687497, lng: 113.24736328125007 },
        { lat: 72.8306640625, lng: 113.12783203125 },
        { lat: 72.76948242187498, lng: 113.15820312500003 },
        { lat: 72.73017578124995, lng: 113.18613281250012 },
        { lat: 72.65737304687497, lng: 113.31220703125004 },
        { lat: 72.63452148437503, lng: 113.66455078124997 },
        { lat: 72.65415039062503, lng: 113.71191406249997 },
        { lat: 72.67709960937498, lng: 113.63007812500004 },
        { lat: 72.71103515624998, lng: 113.39140625000002 },
        { lat: 72.73886718750006, lng: 113.29814453125 },
        { lat: 72.80585937500001, lng: 113.21552734375008 },
        { lat: 72.87832031250005, lng: 113.31152343750003 },
        { lat: 72.93217773437499, lng: 113.41748046875003 },
        { lat: 73.05434570312502, lng: 113.5427734375 },
        { lat: 73.142236328125, lng: 113.5814453125 },
        { lat: 73.23261718750001, lng: 113.55888671875 },
        { lat: 73.273583984375, lng: 113.63916015624997 },
        { lat: 73.31796874999998, lng: 113.76523437500006 },
        { lat: 73.32656249999995, lng: 113.82929687500004 },
        { lat: 73.34580078124998, lng: 113.88623046875003 },
        { lat: 73.36743164062503, lng: 113.79511718750003 },
        { lat: 73.378564453125, lng: 113.711328125 },
        { lat: 73.43364257812502, lng: 113.539453125 },
        { lat: 73.50498046874998, lng: 113.51035156250012 },
        { lat: 73.53339843750001, lng: 113.85693359375003 },
        { lat: 73.58466796874995, lng: 114.06054687500003 },
        { lat: 73.60717773437503, lng: 114.81601562500006 },
        { lat: 73.70258789062501, lng: 115.33769531250007 },
        { lat: 73.67607421875002, lng: 116.49550781250004 },
        { lat: 73.59916992187499, lng: 117.30859375000001 },
        { lat: 73.58979492187504, lng: 118.45019531249997 },
        { lat: 73.53789062500002, lng: 118.87089843750007 },
        { lat: 73.51835937500005, lng: 118.9112304687501 },
        { lat: 73.48120117187503, lng: 118.93642578125 },
        { lat: 73.464501953125, lng: 118.75449218750005 },
        { lat: 73.46440429687507, lng: 118.45703124999997 },
        { lat: 73.36723632812499, lng: 118.37656250000008 },
        { lat: 73.246533203125, lng: 118.43027343750012 },
        { lat: 73.11728515625006, lng: 118.9603515625 },
        { lat: 73.06396484375003, lng: 119.42529296874997 },
        { lat: 72.97910156250006, lng: 119.75039062499998 },
        { lat: 72.971337890625, lng: 119.92167968750002 },
        { lat: 72.98110351562502, lng: 120.59794921875 },
        { lat: 72.93671875000004, lng: 120.9971679687501 },
        { lat: 72.97084960937497, lng: 121.35429687500003 },
        { lat: 72.96967773437501, lng: 121.7478515625 },
        { lat: 72.96088867187498, lng: 121.88603515625006 },
        { lat: 72.89721679687497, lng: 122.02978515624997 },
        { lat: 72.88056640624995, lng: 122.26015625 },
        { lat: 72.877783203125, lng: 122.5375 },
        { lat: 72.89082031250001, lng: 122.6920898437501 },
        { lat: 72.906494140625, lng: 122.75195312500003 },
        { lat: 72.931298828125, lng: 122.730859375 },
        { lat: 72.97065429687501, lng: 122.50195312499997 },
        { lat: 73.01669921874998, lng: 122.52675781250005 },
        { lat: 73.02792968750006, lng: 122.61523437499997 },
        { lat: 72.96464843750005, lng: 122.99931640625 },
        { lat: 72.95488281250002, lng: 123.16035156250008 },
        { lat: 73.00180664062496, lng: 123.301171875 },
        { lat: 73.08564453125001, lng: 123.40458984375002 },
        { lat: 73.14418945312502, lng: 123.4616210937501 },
        { lat: 73.17290039062502, lng: 123.521875 },
        { lat: 73.17734375000003, lng: 123.5724609375001 },
        { lat: 73.19326171875, lng: 123.62226562500003 },
        { lat: 73.26162109374997, lng: 123.50097656250001 },
        { lat: 73.34731445312501, lng: 123.38388671875006 },
        { lat: 73.40249023437497, lng: 123.35527343750002 },
        { lat: 73.43081054687497, lng: 123.32265625 },
        { lat: 73.53291015624998, lng: 123.30507812499998 },
        { lat: 73.63686523437502, lng: 123.41621093750004 },
        { lat: 73.666357421875, lng: 123.49111328125004 },
        { lat: 73.62675781250002, lng: 123.796875 },
        { lat: 73.68930664062505, lng: 123.93388671875 },
        { lat: 73.71230468750002, lng: 124.01904296874999 },
        { lat: 73.75483398437498, lng: 124.3880859375 },
        { lat: 73.75126953125007, lng: 124.54121093750003 },
        { lat: 73.711767578125, lng: 124.79628906250004 },
        { lat: 73.52060546874998, lng: 125.61708984375 },
        { lat: 73.447412109375, lng: 125.59853515625004 },
        { lat: 73.46845703125, lng: 125.79443359374997 },
        { lat: 73.498095703125, lng: 125.88789062500004 },
        { lat: 73.51748046875005, lng: 126.10742187499997 },
        { lat: 73.548193359375, lng: 126.25449218750012 },
        { lat: 73.53666992187505, lng: 126.29599609375013 },
        { lat: 73.50629882812498, lng: 126.34492187500005 },
        { lat: 73.46367187500002, lng: 126.30888671875006 },
        { lat: 73.41977539062503, lng: 126.25742187500006 },
        { lat: 73.39418945312495, lng: 126.29248046875003 },
        { lat: 73.38876953125003, lng: 126.33544921874997 },
        { lat: 73.33491210937498, lng: 126.55253906250006 },
        { lat: 73.43417968750003, lng: 126.83847656250005 },
        { lat: 73.52822265625002, lng: 126.95517578125012 },
        { lat: 73.54746093750003, lng: 127.03134765625008 },
        { lat: 73.48154296875, lng: 127.74033203125012 },
        { lat: 73.44555664062506, lng: 127.95507812499997 },
        { lat: 73.42563476562498, lng: 127.996875 },
        { lat: 73.390771484375, lng: 128.02568359375007 },
        { lat: 73.35239257812498, lng: 128.14169921875006 },
        { lat: 73.33056640624997, lng: 128.2814453125 },
        { lat: 73.30073242187504, lng: 128.26416015624994 },
        { lat: 73.26748046875, lng: 128.25781250000003 },
        { lat: 73.26240234374994, lng: 128.58701171875012 },
        { lat: 73.2333984375, lng: 128.73046875000003 },
        { lat: 73.19023437499999, lng: 128.88867187500003 },
        { lat: 73.13935546875, lng: 128.87167968750012 },
        { lat: 73.11059570312501, lng: 128.91337890625002 },
        { lat: 73.10751953125, lng: 129.05917968750012 },
        { lat: 73.11235351562502, lng: 129.10058593750003 },
        { lat: 73.04541015624996, lng: 129.05371093749997 },
        { lat: 72.97260742187498, lng: 128.85351562499997 },
        { lat: 72.94326171875002, lng: 128.73525390625005 },
        { lat: 72.895166015625, lng: 128.5990234375 },
        { lat: 72.885888671875, lng: 128.6740234375001 },
        { lat: 72.8724609375, lng: 129.01728515625004 },
        { lat: 72.77573242187499, lng: 129.22910156250012 },
        { lat: 72.70517578125003, lng: 129.250390625 },
        { lat: 72.67695312499995, lng: 129.11757812500005 },
        { lat: 72.58588867187498, lng: 128.81533203124997 },
        { lat: 72.55014648437498, lng: 128.63339843750006 },
        { lat: 72.54731445312501, lng: 128.50849609375004 },
        { lat: 72.53515625000003, lng: 128.41826171875002 },
        { lat: 72.495849609375, lng: 128.54941406250012 },
        { lat: 72.4857421875, lng: 129.1166015625 },
        { lat: 72.43769531249998, lng: 129.28134765625006 },
        { lat: 72.31547851562505, lng: 129.41171875000006 },
        { lat: 72.16630859375, lng: 129.41064453124997 },
        { lat: 72.092041015625, lng: 129.28349609375007 },
        { lat: 72.07949218750002, lng: 128.93496093750005 },
        { lat: 72.24555664062501, lng: 128.47519531250006 },
        { lat: 72.30961914062499, lng: 128.19697265625 },
        { lat: 72.43403320312504, lng: 127.8034179687501 },
        { lat: 72.41318359375003, lng: 127.72607421874996 },
        { lat: 72.308251953125, lng: 127.84140625000012 },
        { lat: 72.25, lng: 128.0265625000001 },
        { lat: 72.08833007812504, lng: 128.3587890625 },
        { lat: 71.75532226562495, lng: 128.91142578125002 },
        { lat: 71.78242187499998, lng: 129.04013671875006 },
        { lat: 71.82460937500005, lng: 129.1166015625 },
        { lat: 71.87866210937503, lng: 129.15419921875005 },
        { lat: 71.95322265625003, lng: 129.12158203124997 },
        { lat: 71.91694335937501, lng: 129.21025390625007 },
        { lat: 71.8501953125, lng: 129.291796875 },
        { lat: 71.73930664062499, lng: 129.46083984374997 },
        { lat: 71.74482421874995, lng: 129.23417968750007 },
        { lat: 71.70756835937499, lng: 128.94902343750007 },
        { lat: 71.6634765625, lng: 128.84326171875003 },
        { lat: 71.60175781250004, lng: 128.92265625 },
        { lat: 71.59287109375, lng: 129.13427734374997 },
        { lat: 71.508837890625, lng: 129.22451171875005 },
        { lat: 71.40488281249998, lng: 129.3898437500001 },
        { lat: 71.11953125000002, lng: 129.76191406250004 },
        { lat: 71.06538085937501, lng: 130.02597656250006 },
        { lat: 70.94731445312502, lng: 130.28125 },
        { lat: 70.89252929687494, lng: 130.53710937500003 },
        { lat: 70.888330078125, lng: 130.66845703124994 },
        { lat: 70.96235351562498, lng: 130.75712890625002 },
        { lat: 70.935888671875, lng: 130.83193359375005 },
        { lat: 70.80356445312502, lng: 130.89804687500012 },
        { lat: 70.74609374999996, lng: 131.02158203125006 },
        { lat: 70.74218749999997, lng: 131.15742187500004 },
        { lat: 70.76552734375002, lng: 131.26826171875004 },
        { lat: 70.82827148437502, lng: 131.4323242187501 },
        { lat: 70.901025390625, lng: 131.56201171875003 },
        { lat: 71.10141601562506, lng: 131.76904296875003 },
        { lat: 71.20263671874997, lng: 131.90644531250004 },
        { lat: 71.24404296875, lng: 132.0353515625001 },
        { lat: 71.29321289062506, lng: 131.99082031250006 },
        { lat: 71.35019531250003, lng: 132.00371093750002 },
        { lat: 71.483984375, lng: 132.09882812500004 },
        { lat: 71.64277343750004, lng: 132.22763671875012 },
        { lat: 71.726220703125, lng: 132.32578125000012 },
        { lat: 71.89531250000005, lng: 132.56230468750007 },
        { lat: 71.9259765625, lng: 132.65390625000006 },
        { lat: 71.871484375, lng: 132.71582031249997 },
        { lat: 71.79873046875002, lng: 132.76855468749997 },
        { lat: 71.76757812499997, lng: 132.80361328125 },
        { lat: 71.75517578125002, lng: 132.8392578125 },
        { lat: 71.60668945312497, lng: 133.13085937499997 },
        { lat: 71.49096679687503, lng: 133.426171875 },
        { lat: 71.434228515625, lng: 133.68886718749997 },
        { lat: 71.37895507812502, lng: 134.10283203125002 },
        { lat: 71.38681640625003, lng: 134.70273437500012 },
        { lat: 71.46059570312505, lng: 134.8138671875 },
        { lat: 71.51503906250002, lng: 135.02236328125005 },
        { lat: 71.54350585937507, lng: 135.359375 },
        { lat: 71.6103515625, lng: 135.55917968750006 },
        { lat: 71.63056640625004, lng: 135.88476562499997 },
        { lat: 71.61958007812501, lng: 136.09033203125003 },
        { lat: 71.570751953125, lng: 136.40615234375005 },
        { lat: 71.41567382812505, lng: 137.1158203125001 },
        { lat: 71.35942382812505, lng: 137.31542968750003 },
        { lat: 71.29902343749998, lng: 137.41748046875003 },
        { lat: 71.20815429687505, lng: 137.6505859375001 },
        { lat: 71.163916015625, lng: 137.79785156249997 },
        { lat: 71.1333984375, lng: 137.9396484375001 },
        { lat: 71.14272460937502, lng: 137.99169921874997 },
        { lat: 71.16865234374998, lng: 137.97373046875012 },
        { lat: 71.19404296875001, lng: 137.90195312500006 },
        { lat: 71.22680664062503, lng: 137.84404296875005 },
        { lat: 71.26083984375002, lng: 138.01269531249994 },
        { lat: 71.28583984374998, lng: 138.03251953125002 },
        { lat: 71.30742187500002, lng: 138.090625 },
        { lat: 71.32553710937498, lng: 138.31406250000006 },
        { lat: 71.35859374999995, lng: 138.09716796875003 },
        { lat: 71.36342773437497, lng: 138.02216796875004 },
        { lat: 71.38408203124999, lng: 137.91835937499997 },
        { lat: 71.42978515624998, lng: 137.92734375000006 },
        { lat: 71.46352539062502, lng: 137.99570312500006 },
        { lat: 71.52597656250003, lng: 138.04833984375003 },
        { lat: 71.56616210937497, lng: 138.11845703125002 },
        { lat: 71.596337890625, lng: 138.23417968750007 },
        { lat: 71.60283203125006, lng: 138.3180664062501 },
        { lat: 71.56274414062497, lng: 138.52519531250002 },
        { lat: 71.63481445312502, lng: 138.67001953125012 },
        { lat: 71.62900390624998, lng: 138.78017578125 },
        { lat: 71.55605468750005, lng: 139.00488281249994 },
        { lat: 71.44477539062501, lng: 139.209375 },
        { lat: 71.44472656250001, lng: 139.32021484375 },
        { lat: 71.48925781250003, lng: 139.63212890625002 },
        { lat: 71.49150390625005, lng: 139.98417968750007 },
        { lat: 71.55766601562502, lng: 139.93876953125007 },
        { lat: 71.70043945312497, lng: 139.69511718750007 },
        { lat: 71.88496093749998, lng: 139.72294921875002 },
        { lat: 71.92670898437498, lng: 139.55234375000012 },
        { lat: 71.95136718750001, lng: 139.35927734375005 },
        { lat: 71.99833984374999, lng: 139.64023437500006 },
        { lat: 72.14858398437497, lng: 139.8470703125 },
        { lat: 72.16210937499997, lng: 140.01406249999997 },
        { lat: 72.19130859374995, lng: 140.1876953125 },
        { lat: 72.20961914062495, lng: 140.13437500000012 },
        { lat: 72.22568359375003, lng: 139.61699218750002 },
        { lat: 72.20766601562502, lng: 139.50527343749997 },
        { lat: 72.16347656249997, lng: 139.43046875000007 },
        { lat: 72.16347656249997, lng: 139.17636718750006 },
        { lat: 72.26440429687503, lng: 139.14501953124997 },
        { lat: 72.32973632812502, lng: 139.14082031250004 },
        { lat: 72.46650390624998, lng: 139.47363281249997 },
        { lat: 72.49609374999997, lng: 139.60117187500012 },
        { lat: 72.49311523437498, lng: 140.45058593750005 },
        { lat: 72.51894531250002, lng: 140.70507812500003 },
        { lat: 72.5869140625, lng: 141.07929687500004 },
        { lat: 72.630029296875, lng: 140.98320312500002 },
        { lat: 72.71699218750004, lng: 140.97285156250004 },
        { lat: 72.84282226562499, lng: 140.65234375000003 },
        { lat: 72.871630859375, lng: 140.67597656250004 },
        { lat: 72.89003906250001, lng: 140.7081054687501 },
        { lat: 72.89096679687503, lng: 140.80820312500006 },
        { lat: 72.85771484375002, lng: 141.30976562500004 },
        { lat: 72.78867187499998, lng: 141.51835937500005 },
        { lat: 72.72080078124999, lng: 142.06142578125005 },
        { lat: 72.69824218750003, lng: 143.51582031250004 },
        { lat: 72.673193359375, lng: 143.68095703125002 },
        { lat: 72.64301757812498, lng: 144.3039062500001 },
        { lat: 72.60991210937507, lng: 144.56865234375002 },
        { lat: 72.57021484374997, lng: 145.19931640625006 },
        { lat: 72.54208984375, lng: 145.4857421875 },
        { lat: 72.49736328125005, lng: 145.71416015625007 },
        { lat: 72.47138671875, lng: 146.08330078125007 },
        { lat: 72.442236328125, lng: 146.25292968749997 },
        { lat: 72.34970703125, lng: 146.234765625 },
        { lat: 72.36206054687503, lng: 145.46708984375002 },
        { lat: 72.39267578125003, lng: 145.21289062500003 },
        { lat: 72.39624023437497, lng: 144.89746093749997 },
        { lat: 72.38227539062494, lng: 144.77636718749997 },
        { lat: 72.30551757812506, lng: 144.5875976562501 },
        { lat: 72.26533203125004, lng: 144.36093750000003 },
        { lat: 72.25878906250003, lng: 144.16923828125002 },
        { lat: 72.19262695312497, lng: 144.29492187499997 },
        { lat: 72.17475585937495, lng: 144.47070312499997 },
        { lat: 72.25986328124998, lng: 145.03916015625006 },
        { lat: 72.30244140624995, lng: 146.59414062500005 },
        { lat: 72.29541015625003, lng: 146.83183593750007 },
        { lat: 72.23657226562503, lng: 146.80703125 },
        { lat: 72.12353515625, lng: 146.59921875000006 },
        { lat: 72.035498046875, lng: 146.40166015625005 },
        { lat: 71.94497070312497, lng: 146.11328125000003 },
        { lat: 71.94545898437497, lng: 146.00585937499997 },
        { lat: 72.1375, lng: 146.23027343750007 },
        { lat: 72.14648437499997, lng: 146.13730468750006 },
        { lat: 72.14228515625, lng: 146.05146484375004 },
        { lat: 72.221875, lng: 145.79941406250006 },
        { lat: 72.22587890624999, lng: 145.75859375000007 },
        { lat: 72.20634765625002, lng: 145.70966796875004 },
        { lat: 72.177587890625, lng: 145.71015625000004 },
        { lat: 72.06699218750002, lng: 145.66406249999994 },
        { lat: 72.02065429687502, lng: 145.75673828125005 },
        { lat: 71.94130859375002, lng: 145.75673828125005 },
        { lat: 71.89013671874997, lng: 145.40722656249997 },
        { lat: 71.89462890625, lng: 145.2711914062501 },
        { lat: 71.92714843749997, lng: 145.12578125000002 },
        { lat: 71.92607421875002, lng: 145.06396484374997 },
        { lat: 71.90102539062495, lng: 145.046875 },
        { lat: 71.85463867187502, lng: 145.07773437500012 },
        { lat: 71.83085937499999, lng: 145.07373046874997 },
        { lat: 71.79370117187504, lng: 145.01787109375007 },
        { lat: 71.75336914062501, lng: 144.9896484375 },
        { lat: 71.70737304687506, lng: 145.0755859375 },
        { lat: 71.69580078125, lng: 145.1885742187501 },
        { lat: 71.74648437500002, lng: 145.80478515625006 },
        { lat: 71.80834960937501, lng: 146.07324218749997 },
        { lat: 71.92207031250001, lng: 146.36796875000007 },
        { lat: 72.19750976562497, lng: 146.8947265625001 },
        { lat: 72.29204101562505, lng: 147.12705078125006 },
        { lat: 72.327880859375, lng: 147.26181640625006 },
        { lat: 72.34091796874998, lng: 147.433984375 },
        { lat: 72.31196289062504, lng: 148.40205078125004 },
        { lat: 72.25234374999997, lng: 148.96484375000003 },
        { lat: 72.16430664062497, lng: 149.50156250000012 },
        { lat: 72.09125976562501, lng: 149.76621093750012 },
        { lat: 71.9921875, lng: 149.9630859375001 },
        { lat: 71.95048828125002, lng: 149.99814453125012 },
        { lat: 71.89565429687505, lng: 150.01689453125002 },
        { lat: 71.84301757812497, lng: 149.88105468750004 },
        { lat: 71.82553710937506, lng: 149.27968750000005 },
        { lat: 71.79575195312503, lng: 149.04873046875005 },
        { lat: 71.76279296874998, lng: 148.96533203125003 },
        { lat: 71.744140625, lng: 148.95488281250002 },
        { lat: 71.71464843750002, lng: 148.92333984374997 },
        { lat: 71.69047851562497, lng: 148.9681640625 },
        { lat: 71.68793945312501, lng: 149.23789062500006 },
        { lat: 71.66401367187501, lng: 149.49804687500003 },
        { lat: 71.60146484374997, lng: 149.8571289062501 },
        { lat: 71.580712890625, lng: 149.9126953125001 },
        { lat: 71.52133789062498, lng: 150.02646484375012 },
        { lat: 71.51083984374998, lng: 150.06083984375002 },
        { lat: 71.5201171875, lng: 150.59980468750004 },
        { lat: 71.49887695312503, lng: 150.63486328125006 },
        { lat: 71.45522460937502, lng: 150.66777343750002 },
        { lat: 71.38583984375, lng: 150.5250976562501 },
        { lat: 71.33881835937501, lng: 150.38476562500003 },
        { lat: 71.22656249999997, lng: 150.09765624999997 },
        { lat: 71.26718749999998, lng: 150.24296875000007 },
        { lat: 71.36289062500003, lng: 150.82167968750005 },
        { lat: 71.38046874999998, lng: 150.96777343749997 },
        { lat: 71.37373046875001, lng: 151.14531250000007 },
        { lat: 71.28696289062502, lng: 151.58242187500002 },
        { lat: 71.21782226562505, lng: 151.759765625 },
        { lat: 71.02329101562503, lng: 152.09277343749997 },
        { lat: 71.00249023437506, lng: 151.99980468750007 },
        { lat: 70.98247070312499, lng: 151.76201171875002 },
        { lat: 70.83447265625001, lng: 152.50878906250003 },
        { lat: 70.83564453125001, lng: 152.79833984375003 },
        { lat: 70.87861328124995, lng: 153.46064453125004 },
        { lat: 70.87998046874996, lng: 153.79414062500004 },
        { lat: 70.97446289062503, lng: 154.41396484375 },
        { lat: 71.03422851562505, lng: 155.0294921875001 },
        { lat: 71.03862304687505, lng: 155.59589843750004 },
        { lat: 71.09550781250002, lng: 155.89521484375007 },
        { lat: 71.09375, lng: 156.68457031250003 },
        { lat: 71.07451171874999, lng: 157.44736328125012 },
        { lat: 71.03925781250001, lng: 158.03701171875005 },
        { lat: 70.93500976562497, lng: 158.70214843750003 },
        { lat: 70.79072265625, lng: 159.35068359375003 },
        { lat: 70.64965820312503, lng: 159.7279296875 },
        { lat: 70.60493164062498, lng: 159.80468750000003 },
        { lat: 70.506103515625, lng: 159.91181640625007 },
        { lat: 70.42363281249999, lng: 159.9585937500001 },
        { lat: 70.30966796875006, lng: 160.00644531250006 },
        { lat: 70.22138671875001, lng: 159.9833984375 },
        { lat: 70.15878906250003, lng: 159.88964843750003 },
        { lat: 70.0814453125, lng: 159.83144531250005 },
        { lat: 69.98999023437503, lng: 159.83916015625002 },
        { lat: 69.87021484375006, lng: 159.72939453125005 },
        { lat: 69.78496093749999, lng: 159.83251953125 },
        { lat: 69.72978515625005, lng: 160.11914062499997 },
        { lat: 69.65517578125002, lng: 160.73945312500004 },
        { lat: 69.60634765625002, lng: 160.91074218750012 },
        { lat: 69.45854492187502, lng: 160.9289062500001 },
        { lat: 69.33447265624997, lng: 160.98203125000006 },
        { lat: 69.09819335937507, lng: 161.03554687500005 },
        { lat: 69.03886718750005, lng: 161.14082031250007 },
        { lat: 68.98227539062496, lng: 161.30986328125005 },
        { lat: 68.90517578125, lng: 161.340625 },
        { lat: 68.65385742187505, lng: 161.12900390625006 },
        { lat: 68.60751953125003, lng: 160.99667968750012 },
        { lat: 68.53833007812506, lng: 160.85605468750006 },
        { lat: 68.5625, lng: 161.10449218749997 },
        { lat: 68.65390625000006, lng: 161.2301757812501 },
        { lat: 68.82299804687506, lng: 161.36513671875005 },
        { lat: 68.849853515625, lng: 161.4953125000001 },
        { lat: 68.90517578125, lng: 161.565625 },
        { lat: 69.06396484375003, lng: 161.565625 },
        { lat: 69.201708984375, lng: 161.48007812500012 },
        { lat: 69.30009765624999, lng: 161.48007812500012 },
        { lat: 69.379541015625, lng: 161.53691406250002 },
        { lat: 69.54511718749998, lng: 161.94511718750007 },
        { lat: 69.61157226562503, lng: 162.16601562499994 },
        { lat: 69.64907226562502, lng: 162.37568359375004 },
        { lat: 69.68276367187497, lng: 162.94462890625002 },
        { lat: 69.71474609375, lng: 163.20136718750004 },
        { lat: 69.69326171874995, lng: 163.49804687499997 },
        { lat: 69.70180664062502, lng: 163.7052734375001 },
        { lat: 69.73515625000007, lng: 163.94599609375004 },
        { lat: 69.71928710937505, lng: 164.1595703125 },
        { lat: 69.60913085937497, lng: 164.51328125000003 },
        { lat: 69.58442382812501, lng: 165.76074218749997 },
        { lat: 69.54599609374998, lng: 165.98046874999997 },
        { lat: 69.49956054687505, lng: 166.82031250000003 },
        { lat: 69.49990234375002, lng: 166.88437500000012 },
        { lat: 69.55444335937503, lng: 167.07314453125005 },
        { lat: 69.74033203125005, lng: 167.628125 },
        { lat: 69.72822265624998, lng: 167.8568359375 },
        { lat: 69.699169921875, lng: 167.95009765625 },
        { lat: 69.62563476562495, lng: 168.04765625000007 },
        { lat: 69.577392578125, lng: 168.15000000000012 },
        { lat: 69.447021484375, lng: 168.22998046874997 },
        { lat: 69.27148437500003, lng: 168.30302734375002 },
        { lat: 69.239501953125, lng: 168.42304687500004 },
        { lat: 69.22836914062503, lng: 168.5875976562501 },
        { lat: 69.163330078125, lng: 168.94619140625005 },
        { lat: 69.07954101562498, lng: 169.31064453125003 },
        { lat: 68.91962890625001, lng: 169.41464843750012 },
        { lat: 68.78603515624997, lng: 169.60986328124997 },
        { lat: 68.79868164062498, lng: 170.065625 },
        { lat: 68.825390625, lng: 170.53759765624994 },
        { lat: 69.04531250000005, lng: 170.99541015625002 },
        { lat: 69.13471679687495, lng: 170.99667968750006 },
        { lat: 69.26362304687501, lng: 170.88378906249997 },
        { lat: 69.38823242187497, lng: 170.71416015625007 },
        { lat: 69.58334960937506, lng: 170.58222656250004 },
        { lat: 69.62656249999998, lng: 170.16093750000007 },
        { lat: 69.68320312500006, lng: 170.201171875 },
        { lat: 69.7509765625, lng: 170.35957031250004 },
        { lat: 69.85654296875, lng: 170.503125 },
        { lat: 69.937890625, lng: 170.52539062499997 },
        { lat: 70.107568359375, lng: 170.48681640625003 },
        { lat: 70.09604492187506, lng: 170.86796875000005 },
        { lat: 70.07612304687498, lng: 171.24667968750012 },
        { lat: 70.000341796875, lng: 171.97050781250007 },
        { lat: 69.96835937499998, lng: 172.55957031249997 },
        { lat: 69.91977539062503, lng: 172.86923828125012 },
        { lat: 69.86494140624995, lng: 173.05634765625004 },
        { lat: 69.82382812499999, lng: 173.27744140625006 },
        { lat: 69.92402343750001, lng: 173.35332031250002 },
        { lat: 69.94682617187502, lng: 173.43867187500004 },
        { lat: 69.89111328125004, lng: 173.73339843750003 },
        { lat: 69.87412109375003, lng: 173.94804687500007 },
        { lat: 69.88164062500007, lng: 174.31943359375003 },
        { lat: 69.85566406250001, lng: 174.78554687499997 },
        { lat: 69.86005859375001, lng: 175.29560546875015 },
        { lat: 69.90415039062503, lng: 175.751171875 },
        { lat: 69.89531250000002, lng: 175.92148437500012 },
        { lat: 69.86030273437498, lng: 176.10751953125018 },
        { lat: 69.76850585937501, lng: 176.41044921875007 },
        { lat: 69.64599609375003, lng: 176.92441406250018 },
        { lat: 69.61162109375005, lng: 177.39453125 },
        { lat: 69.49560546875001, lng: 177.93369140625006 },
        { lat: 69.45297851562503, lng: 178.44277343750005 },
        { lat: 69.38720703124997, lng: 178.84833984375004 },
        { lat: 69.36210937500002, lng: 178.9069335937501 },
        { lat: 69.32597656250002, lng: 178.925 },
        { lat: 69.29580078125, lng: 178.95068359374997 },
        { lat: 69.25966796875002, lng: 179.27265624999998 },
        { lat: 69.01269531249997, lng: 179.86826171875 },
        { lat: 68.98344726562503, lng: 180 },
        { lat: 65.06723632812498, lng: 180 },
        { lat: 65.03417968749999, lng: 179.82734375000004 },
        { lat: 64.92094726562502, lng: 179.65136718750009 },
        { lat: 64.82202148437503, lng: 179.44824218750006 },
        { lat: 64.78159179687503, lng: 179.15 },
        { lat: 64.63110351562503, lng: 178.69843750000007 },
        { lat: 64.60297851562498, lng: 178.51953125000003 },
        { lat: 64.67226562499997, lng: 178.2853515625001 },
        { lat: 64.71704101562503, lng: 177.7486328125 },
        { lat: 64.77788085937499, lng: 177.58164062500012 },
        { lat: 64.93134765625, lng: 177.33701171875018 },
        { lat: 64.95361328125, lng: 177.25185546875005 },
        { lat: 65.01411132812498, lng: 177.17919921875003 },
        { lat: 65.08193359375002, lng: 176.88085937499997 },
        { lat: 65.03759765624997, lng: 176.6248046875 },
        { lat: 65.07124023437498, lng: 176.41308593750009 },
        { lat: 65.04731445312501, lng: 176.34101562500013 },
        { lat: 65.02524414062503, lng: 176.45214843750003 },
        { lat: 65.007177734375, lng: 176.64550781249997 },
        { lat: 65.01601562500002, lng: 176.94003906250012 },
        { lat: 64.99965820312497, lng: 177.03730468750004 },
        { lat: 64.947021484375, lng: 177.1234375 },
        { lat: 64.861669921875, lng: 177.22285156250004 },
        { lat: 64.804833984375, lng: 177.14824218750007 },
        { lat: 64.78666992187502, lng: 177.06875 },
        { lat: 64.84921875000006, lng: 176.83105468749997 },
        { lat: 64.83999023437505, lng: 176.55664062500003 },
        { lat: 64.85517578125001, lng: 176.42949218750002 },
        { lat: 64.96088867187498, lng: 176.06113281250012 },
        { lat: 64.84404296875007, lng: 175.78115234375008 },
        { lat: 64.78369140625003, lng: 175.39648437500009 },
        { lat: 64.77685546874997, lng: 175.09775390625018 },
        { lat: 64.68388671875005, lng: 174.54882812500009 },
        { lat: 64.68144531250007, lng: 174.69863281250005 },
        { lat: 64.74663085937502, lng: 175.09707031249997 },
        { lat: 64.74663085937502, lng: 175.33066406250015 },
        { lat: 64.78247070312506, lng: 175.6779296875 },
        { lat: 64.82529296874998, lng: 175.85859375000007 },
        { lat: 64.86518554687501, lng: 175.94589843750012 },
        { lat: 64.90473632812498, lng: 176.0565429687501 },
        { lat: 64.88476562499999, lng: 176.16923828125013 },
        { lat: 64.84301757812503, lng: 176.24697265624997 },
        { lat: 64.78383789062497, lng: 176.30087890625012 },
        { lat: 64.705126953125, lng: 176.35097656250005 },
        { lat: 64.66381835937503, lng: 176.28320312500009 },
        { lat: 64.641943359375, lng: 176.21943359375004 },
        { lat: 64.58583984375005, lng: 176.14091796875007 },
        { lat: 64.68242187499997, lng: 176.50761718749993 },
        { lat: 64.624853515625, lng: 176.73095703124997 },
        { lat: 64.63378906250003, lng: 176.84287109375006 },
        { lat: 64.71923828125003, lng: 177.04980468749991 },
        { lat: 64.7740234375, lng: 177.3875 },
        { lat: 64.76337890624998, lng: 177.42744140625015 },
        { lat: 64.73681640624997, lng: 177.46718750000005 },
        { lat: 64.57280273437505, lng: 177.4098632812501 },
        { lat: 64.44448242187501, lng: 177.43291015625002 },
        { lat: 64.30473632812507, lng: 177.6875 },
        { lat: 64.22226562500003, lng: 177.95332031250013 },
        { lat: 64.21958007812503, lng: 178.0447265625001 },
        { lat: 64.23525390625002, lng: 178.13056640625004 },
        { lat: 64.30908203124997, lng: 178.1639648437501 },
        { lat: 64.36440429687497, lng: 178.2294921874999 },
        { lat: 64.31440429687498, lng: 178.31298828125009 },
        { lat: 64.26088867187502, lng: 178.38144531250018 },
        { lat: 64.12788085937501, lng: 178.47714843750012 },
        { lat: 64.089013671875, lng: 178.47480468749998 },
        { lat: 64.011376953125, lng: 178.45136718750004 },
        { lat: 63.97563476562498, lng: 178.53603515625005 },
        { lat: 63.965283203125004, lng: 178.65029296875002 },
        { lat: 63.84233398437502, lng: 178.69248046875012 },
        { lat: 63.66708984375, lng: 178.73144531250003 },
        { lat: 63.650732421875055, lng: 178.68134765625015 },
        { lat: 63.650732421875055, lng: 178.62597656250009 },
        { lat: 63.605566406250006, lng: 178.44042968750009 },
        { lat: 63.57407226562497, lng: 178.46611328125002 },
        { lat: 63.55664062499997, lng: 178.65371093750005 },
        { lat: 63.52153320312501, lng: 178.7064453125001 },
        { lat: 63.43994140625, lng: 178.6688476562501 },
        { lat: 63.40229492187498, lng: 178.67871093749997 },
        { lat: 63.39477539062503, lng: 178.7440429687499 },
        { lat: 63.442431640625074, lng: 178.78671875000012 },
        { lat: 63.51025390625002, lng: 178.77539062499994 },
        { lat: 63.54033203125001, lng: 178.79296874999997 },
        { lat: 63.400244140625, lng: 178.91855468750018 },
        { lat: 63.34501953125002, lng: 178.92148437500006 },
        { lat: 63.282421874999976, lng: 179.028125 },
        { lat: 63.19018554687502, lng: 179.33232421875007 },
        { lat: 63.14721679687497, lng: 179.38857421874997 },
        { lat: 63.077734375000034, lng: 179.40507812499996 },
        { lat: 63.05791015625008, lng: 179.3290039062501 },
        { lat: 63.00830078124999, lng: 179.25957031250002 },
        { lat: 62.93984374999999, lng: 179.3021484375 },
        { lat: 62.883691406250016, lng: 179.38105468750004 },
        { lat: 62.86279296875003, lng: 179.51093750000004 },
        { lat: 62.773486328125045, lng: 179.5705078125001 },
        { lat: 62.6875, lng: 179.5705078125001 },
        { lat: 62.61308593750005, lng: 179.4772460937501 },
        { lat: 62.51035156249998, lng: 179.28867187500006 },
        { lat: 62.46918945312504, lng: 179.17695312500004 },
        { lat: 62.39643554687495, lng: 179.13388671875018 },
        { lat: 62.32036132812498, lng: 179.12070312500012 },
        { lat: 62.32368164062495, lng: 179.0446289062501 },
        { lat: 62.35527343750001, lng: 178.96386718749997 },
        { lat: 62.54697265624998, lng: 178.01923828125007 },
        { lat: 62.58281249999999, lng: 177.66308593750003 },
        { lat: 62.587451171875045, lng: 177.35126953125007 },
        { lat: 62.599023437500016, lng: 177.292578125 },
        { lat: 62.64448242187495, lng: 177.29589843749997 },
        { lat: 62.68525390625001, lng: 177.31582031249994 },
        { lat: 62.736962890624966, lng: 177.35966796875002 },
        { lat: 62.781347656250034, lng: 177.33896484375006 },
        { lat: 62.78422851562498, lng: 177.29833984374994 },
        { lat: 62.750439453124955, lng: 177.25869140625005 },
        { lat: 62.750341796875034, lng: 177.17265625000007 },
        { lat: 62.78955078125003, lng: 177.09121093750005 },
        { lat: 62.77724609374999, lng: 177.02353515625012 },
        { lat: 62.722216796875074, lng: 176.9900390625 },
        { lat: 62.69326171875002, lng: 176.96347656250012 },
        { lat: 62.658642578124976, lng: 176.96474609375 },
        { lat: 62.62656250000003, lng: 177.00800781250015 },
        { lat: 62.59160156250002, lng: 177.18964843749998 },
        { lat: 62.56098632812498, lng: 177.15947265625005 },
        { lat: 62.536083984374976, lng: 176.90742187500004 },
        { lat: 62.50576171875002, lng: 176.70253906250002 },
        { lat: 62.410839843749955, lng: 176.43652343750003 },
        { lat: 62.346044921875, lng: 176.32841796875007 },
        { lat: 62.184375, lng: 175.61386718750012 },
        { lat: 62.127929687499964, lng: 175.44199218750012 },
        { lat: 62.12133789062505, lng: 175.36582031250006 },
        { lat: 62.102392578125006, lng: 175.26787109375002 },
        { lat: 62.03442382812499, lng: 175.19238281250009 },
        { lat: 61.938867187499994, lng: 174.7975585937501 },
        { lat: 61.947900390624966, lng: 174.71503906249995 },
        { lat: 61.867626953124955, lng: 174.61054687500004 },
        { lat: 61.82363281249996, lng: 174.51435546875015 },
        { lat: 61.817529296874966, lng: 174.28496093750013 },
        { lat: 61.79516601562503, lng: 174.1388671875 },
        { lat: 61.67939453124998, lng: 173.82236328125 },
        { lat: 61.716064453125, lng: 173.6234375 },
        { lat: 61.55673828125003, lng: 173.39072265625 },
        { lat: 61.406640625000016, lng: 173.13183593749997 },
        { lat: 61.40620117187501, lng: 173.05458984375005 },
        { lat: 61.469189453124955, lng: 172.85654296875003 },
        { lat: 61.43613281249997, lng: 172.8068359375001 },
        { lat: 61.3755859375, lng: 172.83789062500003 },
        { lat: 61.311621093750006, lng: 172.90800781250002 },
        { lat: 61.29306640625006, lng: 172.86777343750003 },
        { lat: 61.31069335937499, lng: 172.78906250000003 },
        { lat: 61.314404296874955, lng: 172.73066406250004 },
        { lat: 61.29516601562503, lng: 172.69003906250012 },
        { lat: 61.24931640625002, lng: 172.6969726562501 },
        { lat: 61.19042968750002, lng: 172.58476562500007 },
        { lat: 61.18588867187497, lng: 172.49707031249997 },
        { lat: 61.16738281250002, lng: 172.39609375000006 },
        { lat: 61.116601562499994, lng: 172.36240234375006 },
        { lat: 61.061767578125, lng: 172.3927734375 },
        { lat: 60.997851562500045, lng: 172.21328125000005 },
        { lat: 60.915673828124994, lng: 172.06728515625002 },
        { lat: 60.900683593750045, lng: 171.99765625000006 },
        { lat: 60.86411132812498, lng: 171.91796875000003 },
        { lat: 60.83735351562503, lng: 171.83056640624997 },
        { lat: 60.843115234375055, lng: 171.72949218749997 },
        { lat: 60.72573242187502, lng: 171.48974609374997 },
        { lat: 60.52294921875002, lng: 170.94931640625012 },
        { lat: 60.496484375000044, lng: 170.79931640625003 },
        { lat: 60.43491210937503, lng: 170.60820312500007 },
        { lat: 60.39370117187496, lng: 170.58974609375005 },
        { lat: 60.342871093750006, lng: 170.5885742187501 },
        { lat: 60.259521484375, lng: 170.51230468750006 },
        { lat: 60.04780273437504, lng: 170.42343750000012 },
        { lat: 60.009765625, lng: 170.39648437500003 },
        { lat: 59.965527343749955, lng: 170.3509765625 },
        { lat: 59.98608398437497, lng: 170.15410156250002 },
        { lat: 60.067089843749955, lng: 169.9826171875001 },
        { lat: 60.104248046874964, lng: 169.92724609374997 },
        { lat: 60.1478515625, lng: 169.89755859375006 },
        { lat: 60.21791992187506, lng: 169.88701171875007 },
        { lat: 60.25024414062497, lng: 169.85429687500007 },
        { lat: 60.26538085937503, lng: 169.81474609375007 },
        { lat: 60.43803710937504, lng: 169.61835937500004 },
        { lat: 60.55664062500003, lng: 169.27568359375002 },
        { lat: 60.595947265624964, lng: 169.2267578125001 },
        { lat: 60.563818359375, lng: 168.78828125000004 },
        { lat: 60.562890625, lng: 168.67031249999997 },
        { lat: 60.59223632812501, lng: 168.46279296875 },
        { lat: 60.57392578125001, lng: 168.1375 },
        { lat: 60.50932617187498, lng: 167.74599609375005 },
        { lat: 60.46894531250003, lng: 167.62607421875006 },
        { lat: 60.40629882812504, lng: 167.22675781250004 },
        { lat: 60.30703125, lng: 166.9640625000001 },
        { lat: 59.94702148437501, lng: 166.4525390625 },
        { lat: 59.872412109375, lng: 166.33183593750007 },
        { lat: 59.85625, lng: 166.27304687500012 },
        { lat: 59.84946289062503, lng: 166.18652343749997 },
        { lat: 59.92207031249998, lng: 166.14892578125003 },
        { lat: 59.979345703125034, lng: 166.13603515625007 },
        { lat: 60.08881835937504, lng: 166.168359375 },
        { lat: 60.17832031249997, lng: 166.22978515625005 },
        { lat: 60.34609375000005, lng: 166.29248046874997 },
        { lat: 60.414257812499976, lng: 166.30810546874994 },
        { lat: 60.484814453124976, lng: 166.35214843750006 },
        { lat: 60.48037109375005, lng: 166.18017578125 },
        { lat: 60.35688476562501, lng: 165.94199218750006 },
        { lat: 60.236474609374994, lng: 165.58300781250003 },
        { lat: 60.20517578125003, lng: 165.41582031250007 },
        { lat: 60.13491210937502, lng: 165.28525390625012 },
        { lat: 60.12475585937497, lng: 165.19257812500004 },
        { lat: 60.098583984374976, lng: 165.08457031250006 },
        { lat: 59.94560546874998, lng: 165.07363281249997 },
        { lat: 59.860742187500016, lng: 165.01894531250005 },
        { lat: 59.843603515625, lng: 164.95371093750006 },
        { lat: 59.840966796874994, lng: 164.85429687500005 },
        { lat: 59.87421875000001, lng: 164.77939453125006 },
        { lat: 59.997460937499994, lng: 164.66972656250002 },
        { lat: 60.06127929687503, lng: 164.52529296875 },
        { lat: 60.072705078124955, lng: 164.44003906250006 },
        { lat: 60.05805664062498, lng: 164.37685546875005 },
        { lat: 59.97377929687505, lng: 164.25156250000012 },
        { lat: 59.897558593749984, lng: 164.11328125000003 },
        { lat: 59.984375, lng: 164.13505859375002 },
        { lat: 60.01733398437503, lng: 164.01757812499997 },
        { lat: 60.03706054687498, lng: 163.91289062500002 },
        { lat: 60.041113281250006, lng: 163.78007812500007 },
        { lat: 60.028027343749976, lng: 163.74384765625004 },
        { lat: 59.978417968750016, lng: 163.69003906250012 },
        { lat: 59.91406250000006, lng: 163.57431640625006 },
        { lat: 59.88676757812499, lng: 163.49375 },
        { lat: 59.8349609375, lng: 163.40996093750007 },
        { lat: 59.78144531250004, lng: 163.3648437500001 },
        { lat: 59.705419921875, lng: 163.32119140625 },
        { lat: 59.520019531249964, lng: 163.26904296874997 },
        { lat: 59.302587890625006, lng: 163.27285156250002 },
        { lat: 59.13139648437501, lng: 163.08486328125 },
        { lat: 59.148291015625006, lng: 163.01015625 },
        { lat: 59.13706054687503, lng: 162.97490234375007 },
        { lat: 59.11430664062501, lng: 162.94003906250006 },
        { lat: 59.02016601562502, lng: 163.00429687500005 },
        { lat: 58.986474609374994, lng: 162.96982421875012 },
        { lat: 58.963964843750034, lng: 162.9345703125 },
        { lat: 58.939257812500045, lng: 162.84726562500012 },
        { lat: 58.79990234375, lng: 162.64335937500002 },
        { lat: 58.70859375000003, lng: 162.45302734375 },
        { lat: 58.44741210937502, lng: 162.14160156249997 },
        { lat: 58.27285156249999, lng: 162.04921875000005 },
        { lat: 58.07690429687506, lng: 161.96005859375012 },
        { lat: 57.98095703125006, lng: 162.00195312500003 },
        { lat: 57.91826171874995, lng: 162.03964843750006 },
        { lat: 57.87465820312496, lng: 162.09794921875002 },
        { lat: 57.82915039062501, lng: 162.1974609375 },
        { lat: 57.77836914062499, lng: 162.41142578125002 },
        { lat: 57.74501953125002, lng: 162.39218750000012 },
        { lat: 57.71723632812495, lng: 162.39140625000002 },
        { lat: 57.7662109375, lng: 162.46699218750007 },
        { lat: 57.90410156250002, lng: 162.52197265624997 },
        { lat: 57.94824218750002, lng: 162.65429687499997 },
        { lat: 57.94609375, lng: 162.71835937500012 },
        { lat: 57.83730468749999, lng: 163.14501953125003 },
        { lat: 57.79038085937503, lng: 163.22578125000004 },
        { lat: 57.68681640624999, lng: 163.21386718750003 },
        { lat: 57.637402343749955, lng: 163.18789062500005 },
        { lat: 57.56484375, lng: 163.1087890625 },
        { lat: 57.47749023437498, lng: 162.95703124999997 },
        { lat: 57.35761718749998, lng: 162.77929687500003 },
        { lat: 57.284082031249994, lng: 162.76230468750012 },
        { lat: 57.24394531249999, lng: 162.76152343750002 },
        { lat: 57.10278320312503, lng: 162.80810546875003 },
        { lat: 57.02338867187501, lng: 162.81484375 },
        { lat: 56.87539062499996, lng: 162.79111328125012 },
        { lat: 56.81147460937501, lng: 162.80263671875 },
        { lat: 56.75683593749997, lng: 162.84990234375 },
        { lat: 56.72265625000003, lng: 162.92207031250004 },
        { lat: 56.741308593750006, lng: 163.04638671874997 },
        { lat: 56.725488281249966, lng: 163.16542968749997 },
        { lat: 56.68803710937499, lng: 163.2565429687501 },
        { lat: 56.56455078125006, lng: 163.24326171875012 },
        { lat: 56.447705078124955, lng: 163.29404296875003 },
        { lat: 56.232519531250006, lng: 163.33554687500012 },
        { lat: 56.17373046875002, lng: 163.26132812500006 },
        { lat: 56.13701171874998, lng: 163.18925781250007 },
        { lat: 56.044677734375, lng: 163.04736328125 },
        { lat: 56.033789062500006, lng: 162.97167968749997 },
        { lat: 56.065625, lng: 162.84033203125003 },
        { lat: 56.232275390625034, lng: 162.628125 },
        { lat: 56.33085937499996, lng: 162.71318359375007 },
        { lat: 56.39946289062499, lng: 162.89326171875004 },
        { lat: 56.44902343749995, lng: 162.97519531250006 },
        { lat: 56.521875, lng: 163.03837890625002 },
        { lat: 56.508056640625, lng: 162.94414062500002 },
        { lat: 56.47636718750002, lng: 162.8776367187501 },
        { lat: 56.49008789062498, lng: 162.67148437500006 },
        { lat: 56.454931640625, lng: 162.5890625000001 },
        { lat: 56.39912109375001, lng: 162.48867187500005 },
        { lat: 56.260693359374955, lng: 162.52822265625005 },
        { lat: 56.235498046874994, lng: 162.4611328125 },
        { lat: 56.18774414062503, lng: 162.33408203125006 },
        { lat: 56.12827148437498, lng: 162.14609375000006 },
        { lat: 56.08964843750001, lng: 162.08496093749997 },
        { lat: 55.84038085937496, lng: 161.9240234375 },
        { lat: 55.65483398437499, lng: 161.7755859375001 },
        { lat: 55.49614257812498, lng: 161.72392578125 },
        { lat: 55.358007812500006, lng: 161.72939453124997 },
        { lat: 55.205322265625, lng: 161.78496093750002 },
        { lat: 55.13891601562505, lng: 161.82421874999997 },
        { lat: 54.99799804687504, lng: 161.99609374999997 },
        { lat: 54.88613281249996, lng: 162.0802734375001 },
        { lat: 54.75214843750004, lng: 162.10556640625006 },
        { lat: 54.68867187499998, lng: 161.96689453125006 },
        { lat: 54.53295898437506, lng: 161.72568359375006 },
        { lat: 54.51625976562502, lng: 161.62480468750002 },
        { lat: 54.52055664062502, lng: 161.29404296875012 },
        { lat: 54.598242187500034, lng: 161.12988281249997 },
        { lat: 54.57836914062497, lng: 160.93554687500003 },
        { lat: 54.54135742187498, lng: 160.77265625 },
        { lat: 54.43085937500004, lng: 160.51718750000006 },
        { lat: 54.28823242187502, lng: 160.28886718750007 },
        { lat: 54.18916015625001, lng: 160.0744140625001 },
        { lat: 54.13085937500003, lng: 160.01015625000005 },
        { lat: 54.008398437500034, lng: 159.92177734375 },
        { lat: 53.78364257812498, lng: 159.84375 },
        { lat: 53.67265625000002, lng: 159.87089843750002 },
        { lat: 53.62084960937502, lng: 159.91425781250004 },
        { lat: 53.55219726562501, lng: 159.95585937500007 },
        { lat: 53.44770507812504, lng: 159.89912109375007 },
        { lat: 53.380761718749966, lng: 159.89765625000004 },
        { lat: 53.27490234375, lng: 160.00214843750007 },
        { lat: 53.129589843749955, lng: 160.02509765625004 },
        { lat: 53.125097656250034, lng: 159.94746093750004 },
        { lat: 53.2296875, lng: 159.77158203125012 },
        { lat: 53.237695312499966, lng: 159.5859375 },
        { lat: 53.11713867187501, lng: 159.13613281250005 },
        { lat: 53.04755859374995, lng: 158.95205078125005 },
        { lat: 52.90893554687505, lng: 158.74541015625002 },
        { lat: 52.935400390625006, lng: 158.68369140625006 },
        { lat: 53.014794921875016, lng: 158.63955078125005 },
        { lat: 53.05, lng: 158.5646484375001 },
        { lat: 53.032373046874966, lng: 158.47207031250005 },
        { lat: 52.95742187499996, lng: 158.43232421875004 },
        { lat: 52.92216796874999, lng: 158.56015625000003 },
        { lat: 52.873632812500034, lng: 158.6087890625 },
        { lat: 52.68842773437498, lng: 158.53369140624997 },
        { lat: 52.62666015625001, lng: 158.48076171875002 },
        { lat: 52.46030273437503, lng: 158.50039062500005 },
        { lat: 52.38315429687503, lng: 158.49316406249997 },
        { lat: 52.30498046875002, lng: 158.46347656250006 },
        { lat: 52.09086914062502, lng: 158.33164062500012 },
        { lat: 51.80961914062498, lng: 158.10351562500003 },
        { lat: 51.605322265625034, lng: 157.82324218750003 },
        { lat: 51.534570312499994, lng: 157.62890624999997 },
        { lat: 51.479882812499966, lng: 157.5309570312501 },
        { lat: 51.408935546875, lng: 157.48984375000006 },
        { lat: 51.21274414062498, lng: 157.20224609375006 },
        { lat: 51.006591796875, lng: 156.8474609375 },
        { lat: 50.96928710937504, lng: 156.74775390625004 },
        { lat: 51.04707031249998, lng: 156.72431640625004 },
        { lat: 51.12412109375006, lng: 156.71347656250006 },
        { lat: 51.22685546875002, lng: 156.67080078125 },
        { lat: 51.31162109375006, lng: 156.54345703124997 },
        { lat: 51.38027343750002, lng: 156.52119140625004 },
        { lat: 51.47509765625006, lng: 156.500390625 },
        { lat: 51.91303710937501, lng: 156.48984375000003 },
        { lat: 52.36655273437503, lng: 156.37734375 },
        { lat: 52.509375, lng: 156.36474609374997 },
        { lat: 52.62626953125002, lng: 156.22861328125006 },
        { lat: 52.74726562499998, lng: 156.15439453125012 },
        { lat: 52.86616210937504, lng: 156.11035156250003 },
        { lat: 53.00649414062502, lng: 156.0988281250001 },
        { lat: 53.744287109374966, lng: 155.95019531249997 },
        { lat: 53.928125, lng: 155.90488281250003 },
        { lat: 54.52148437500003, lng: 155.7064453125 },
        { lat: 54.86455078125001, lng: 155.62031250000004 },
        { lat: 55.199121093749966, lng: 155.5638671875 },
        { lat: 55.348486328125034, lng: 155.5548828125001 },
        { lat: 55.793554687500006, lng: 155.64345703125005 },
        { lat: 56.07221679687504, lng: 155.71660156250002 },
        { lat: 56.69521484375002, lng: 155.98251953125012 },
        { lat: 56.75200195312496, lng: 156.02539062500003 },
        { lat: 56.781591796875034, lng: 156.06748046875006 },
        { lat: 57.021191406250004, lng: 156.52929687500003 },
        { lat: 57.152246093749966, lng: 156.72841796875 },
        { lat: 57.290185546874994, lng: 156.8488281250001 },
        { lat: 57.46630859375, lng: 156.97675781250004 },
        { lat: 57.5609375, lng: 156.96357421875004 },
        { lat: 57.61577148437499, lng: 156.94824218750003 },
        { lat: 57.676904296874994, lng: 156.89990234375003 },
        { lat: 57.74794921874999, lng: 156.79160156250006 },
        { lat: 57.77963867187498, lng: 156.82988281250007 },
        { lat: 57.80366210937498, lng: 156.87197265625 },
        { lat: 57.83017578125006, lng: 156.9857421875 },
        { lat: 57.776806640625004, lng: 157.216796875 },
        { lat: 57.799267578124976, lng: 157.4503906250001 },
        { lat: 58.01977539062506, lng: 157.66640625000005 },
        { lat: 57.98593750000001, lng: 157.97460937500003 },
        { lat: 58.02529296875002, lng: 158.21044921875 },
        { lat: 58.00898437499998, lng: 158.27519531250007 },
        { lat: 58.083447265624955, lng: 158.32109375000002 },
        { lat: 58.162841796874964, lng: 158.44941406250004 },
        { lat: 58.281347656250034, lng: 158.68701171874997 },
        { lat: 58.42392578125003, lng: 159.03691406250002 },
        { lat: 58.51943359374996, lng: 159.21064453125004 },
        { lat: 58.610546874999955, lng: 159.30839843750007 },
        { lat: 58.695947265625044, lng: 159.45263671874997 },
        { lat: 58.803662109374955, lng: 159.5915039062501 },
        { lat: 59.127148437499955, lng: 159.8473632812501 },
        { lat: 59.39404296874997, lng: 160.35039062500007 },
        { lat: 59.54736328125003, lng: 160.54746093750006 },
        { lat: 59.601660156250006, lng: 160.71142578125003 },
        { lat: 59.626855468749966, lng: 160.85527343750002 },
        { lat: 59.84560546875005, lng: 161.2189453125001 },
        { lat: 60.02734375000003, lng: 161.44931640625003 },
        { lat: 60.152294921875004, lng: 161.75351562500012 },
        { lat: 60.23222656250002, lng: 161.84599609375002 },
        { lat: 60.42016601562502, lng: 162.0036132812501 },
        { lat: 60.466406250000034, lng: 162.06816406250002 },
        { lat: 60.536718749999984, lng: 162.26630859375004 },
        { lat: 60.65947265625002, lng: 162.71318359375007 },
        { lat: 60.782910156249955, lng: 162.97314453124997 },
        { lat: 60.80043945312496, lng: 163.35234375000007 },
        { lat: 60.84975585937499, lng: 163.4664062500001 },
        { lat: 60.87714843749995, lng: 163.58515625000004 },
        { lat: 60.916796875000045, lng: 163.70996093749997 },
        { lat: 61.02563476562502, lng: 163.55351562500002 },
        { lat: 61.084375, lng: 163.5892578125 },
        { lat: 61.11132812499997, lng: 163.61962890624997 },
        { lat: 61.240478515625, lng: 163.89335937500007 },
        { lat: 61.34379882812498, lng: 164.00546875000006 },
        { lat: 61.38823242187498, lng: 163.99208984375 },
        { lat: 61.419873046874955, lng: 163.97275390625006 },
        { lat: 61.461376953124976, lng: 163.80439453125004 },
        { lat: 61.558251953124994, lng: 163.83710937500004 },
        { lat: 61.64013671874997, lng: 163.88271484375 },
        { lat: 61.71069335937505, lng: 164.01953125000003 },
        { lat: 61.87387695312498, lng: 164.06796875000012 },
        { lat: 62.045019531250034, lng: 164.07421874999997 },
        { lat: 62.29223632812506, lng: 164.2072265625 },
        { lat: 62.346630859375004, lng: 164.2875 },
        { lat: 62.470556640625034, lng: 164.59833984375004 },
        { lat: 62.473779296874994, lng: 164.67070312500007 },
        { lat: 62.43188476562497, lng: 164.88769531250003 },
        { lat: 62.411523437500016, lng: 165.12412109375006 },
        { lat: 62.37397460937501, lng: 165.20810546875012 },
        { lat: 62.40576171874999, lng: 165.22568359375006 },
        { lat: 62.448193359375004, lng: 165.21386718749997 },
        { lat: 62.46298828125, lng: 165.28037109375012 },
        { lat: 62.44707031250004, lng: 165.41738281250005 },
        { lat: 62.49389648437499, lng: 165.39658203125006 },
        { lat: 62.51699218749999, lng: 165.04404296875006 },
        { lat: 62.57109375000002, lng: 164.7923828125 },
        { lat: 62.67548828124995, lng: 164.56699218750006 },
        { lat: 62.704638671875045, lng: 164.41835937499997 },
        { lat: 62.69658203124999, lng: 164.25566406250007 },
        { lat: 62.55092773437499, lng: 163.33173828125004 },
        { lat: 62.51142578125002, lng: 163.28710937500003 },
        { lat: 62.455371093750074, lng: 163.24423828125006 },
        { lat: 62.37299804687498, lng: 163.30214843750005 },
        { lat: 62.3369140625, lng: 163.25800781250004 },
        { lat: 62.313427734375004, lng: 163.21328125000005 },
        { lat: 62.25957031250004, lng: 163.16347656250005 },
        { lat: 62.1529296875, lng: 163.11845703125002 },
        { lat: 62.04990234375006, lng: 163.1310546875001 },
        { lat: 61.89106445312504, lng: 163.01767578125006 },
        { lat: 61.79150390625, lng: 163.00927734374997 },
        { lat: 61.736572265625, lng: 163.20761718750006 },
        { lat: 61.699462890624964, lng: 163.25781249999997 },
        { lat: 61.644775390625036, lng: 163.19785156250012 },
        { lat: 61.61142578124997, lng: 163.1388671875001 },
        { lat: 61.570556640625, lng: 163.08525390625 },
        { lat: 61.55405273437503, lng: 163.047265625 },
        { lat: 61.54418945312497, lng: 162.99394531250005 },
        { lat: 61.59770507812504, lng: 162.92167968750007 },
        { lat: 61.70502929687495, lng: 162.85595703125003 },
        { lat: 61.711279296875006, lng: 162.75234375000005 },
        { lat: 61.69511718749999, lng: 162.71787109375012 },
        { lat: 61.65258789062502, lng: 162.6990234375 },
        { lat: 61.650048828125044, lng: 162.6076171875 },
        { lat: 61.670117187499955, lng: 162.50644531250012 },
        { lat: 61.662109375, lng: 162.39257812500003 },
        { lat: 61.540673828124966, lng: 162.18837890625 },
        { lat: 60.96289062500002, lng: 161.03710937500003 },
        { lat: 60.892675781250034, lng: 160.91503906250003 },
        { lat: 60.753320312499966, lng: 160.76660156249994 },
        { lat: 60.73984375, lng: 160.48203125000006 },
        { lat: 60.70854492187499, lng: 160.36816406249997 },
        { lat: 60.66704101562507, lng: 160.2873046875001 },
        { lat: 60.63842773437499, lng: 160.1736328125 },
        { lat: 60.69072265624999, lng: 160.17734375000006 },
        { lat: 60.729638671875016, lng: 160.20107421875005 },
        { lat: 60.83154296874999, lng: 160.2257812500001 },
        { lat: 61.02548828124998, lng: 160.37890625000003 },
        { lat: 61.044775390625006, lng: 160.28125 },
        { lat: 61.04765625000007, lng: 160.1842773437501 },
        { lat: 61.007421875000034, lng: 160.00400390625012 },
        { lat: 60.943408203125045, lng: 159.88310546875002 },
        { lat: 60.956640625, lng: 159.79042968750002 },
        { lat: 61.013964843750045, lng: 159.83457031250006 },
        { lat: 61.12861328124995, lng: 159.94921874999994 },
        { lat: 61.234472656250034, lng: 159.91396484375 },
        { lat: 61.291796875000074, lng: 159.88310546875002 },
        { lat: 61.32392578124995, lng: 159.93085937500004 },
        { lat: 61.5375, lng: 160.16269531250012 },
        { lat: 61.64760742187499, lng: 160.246875 },
        { lat: 61.79335937500002, lng: 160.3173828125 },
        { lat: 61.83857421874998, lng: 160.32148437500004 },
        { lat: 61.894384765625006, lng: 160.309375 },
        { lat: 61.903857421875045, lng: 160.23779296874997 },
        { lat: 61.90283203125002, lng: 160.18251953125 },
        { lat: 61.758398437500006, lng: 159.72216796874997 },
        { lat: 61.71948242187497, lng: 159.55234375000012 },
        { lat: 61.781445312499976, lng: 159.4962890625001 },
        { lat: 61.808056640624976, lng: 159.4230468750001 },
        { lat: 61.91416015625003, lng: 159.29501953125012 },
        { lat: 61.929394531250004, lng: 159.18925781250007 },
        { lat: 61.92226562499999, lng: 159.07666015625003 },
        { lat: 61.85024414062496, lng: 158.82431640625012 },
        { lat: 61.810888671875034, lng: 158.54716796875007 },
        { lat: 61.82568359375003, lng: 158.3336914062501 },
        { lat: 61.76484374999998, lng: 158.15156250000004 },
        { lat: 61.75361328125001, lng: 158.07011718750002 },
        { lat: 61.795263671875055, lng: 157.79931640625003 },
        { lat: 61.798925781250006, lng: 157.46933593750012 },
        { lat: 61.7470703125, lng: 157.37070312500012 },
        { lat: 61.67568359375002, lng: 157.0841796875001 },
        { lat: 61.56518554687497, lng: 156.89179687500004 },
        { lat: 61.529638671875034, lng: 156.790625 },
        { lat: 61.48061523437499, lng: 156.68027343750006 },
        { lat: 61.27246093750003, lng: 156.62968750000002 },
        { lat: 61.20600585937498, lng: 156.4826171875001 },
        { lat: 61.15507812500001, lng: 156.34414062500005 },
        { lat: 60.99560546875003, lng: 156.05595703125002 },
        { lat: 60.77714843750002, lng: 155.85332031250007 },
        { lat: 60.682373046875, lng: 155.71611328125002 },
        { lat: 60.54985351562499, lng: 155.42783203125006 },
        { lat: 60.37666015624995, lng: 154.9708007812501 },
        { lat: 60.095019531250045, lng: 154.57822265625006 },
        { lat: 59.88378906249999, lng: 154.44072265625005 },
        { lat: 59.87675781249998, lng: 154.3898437500001 },
        { lat: 59.83334960937503, lng: 154.29306640625006 },
        { lat: 59.730371093750016, lng: 154.26660156250003 },
        { lat: 59.658398437500004, lng: 154.26884765625002 },
        { lat: 59.60034179687501, lng: 154.20917968750004 },
        { lat: 59.52851562500002, lng: 154.14980468749997 },
        { lat: 59.483398437499964, lng: 154.21289062499997 },
        { lat: 59.475146484375074, lng: 154.2721679687501 },
        { lat: 59.48144531250002, lng: 154.35761718750007 },
        { lat: 59.540087890625074, lng: 154.58251953124997 },
        { lat: 59.44960937500002, lng: 154.97128906250006 },
        { lat: 59.36015624999998, lng: 155.16669921875004 },
        { lat: 59.27021484374998, lng: 155.15302734375004 },
        { lat: 59.19013671875001, lng: 155.16044921875 },
        { lat: 59.19560546875004, lng: 155.01669921875006 },
        { lat: 59.18754882812501, lng: 154.82373046875 },
        { lat: 59.14130859375001, lng: 154.70351562500005 },
        { lat: 59.21655273437497, lng: 154.45800781250003 },
        { lat: 59.18784179687498, lng: 154.37597656250003 },
        { lat: 59.10859375, lng: 154.24667968750006 },
        { lat: 59.075537109375, lng: 154.01093750000004 },
        { lat: 59.11416015624996, lng: 153.89169921875012 },
        { lat: 59.22475585937505, lng: 153.69521484375005 },
        { lat: 59.21479492187495, lng: 153.36113281250002 },
        { lat: 59.09130859375003, lng: 153.27294921874997 },
        { lat: 59.094433593749955, lng: 153.19609375000005 },
        { lat: 59.08188476562498, lng: 153.07773437500012 },
        { lat: 58.9390625, lng: 152.8822265625 },
        { lat: 58.92626953124997, lng: 152.81787109375003 },
        { lat: 58.954101562499964, lng: 152.57558593750005 },
        { lat: 59.02641601562504, lng: 152.40068359375002 },
        { lat: 59.03076171875003, lng: 152.31962890625002 },
        { lat: 58.99702148437501, lng: 152.1652343750001 },
        { lat: 58.910449218750045, lng: 152.08789062499994 },
        { lat: 58.86669921875, lng: 151.70458984374997 },
        { lat: 58.875097656250034, lng: 151.32675781250006 },
        { lat: 59.08251953125003, lng: 151.12109375000003 },
        { lat: 59.16401367187501, lng: 151.50498046875003 },
        { lat: 59.14667968750004, lng: 151.73349609375006 },
        { lat: 59.16005859374999, lng: 151.99003906250002 },
        { lat: 59.22358398437498, lng: 152.26064453125 },
        { lat: 59.27792968750003, lng: 152.16953125000006 },
        { lat: 59.29057617187504, lng: 152.10449218749997 },
        { lat: 59.28408203125005, lng: 151.94238281249997 },
        { lat: 59.32324218750003, lng: 151.7980468750001 },
        { lat: 59.52412109375001, lng: 151.48574218750005 },
        { lat: 59.5611328125, lng: 151.34824218750012 },
        { lat: 59.58325195312498, lng: 151.1703125 },
        { lat: 59.585644531250004, lng: 151.03359375000005 },
        { lat: 59.571337890625045, lng: 150.98251953125012 },
        { lat: 59.52304687500006, lng: 150.91191406250002 },
        { lat: 59.475439453125034, lng: 150.86328124999997 },
        { lat: 59.46074218750007, lng: 150.82343750000004 },
        { lat: 59.46914062499999, lng: 150.72949218749997 },
        { lat: 59.506542968749976, lng: 150.61523437499997 },
        { lat: 59.494384765625, lng: 150.4835937500001 },
        { lat: 59.52495117187498, lng: 150.53984375000007 },
        { lat: 59.55634765625001, lng: 150.66728515625002 },
        { lat: 59.590722656249994, lng: 150.45722656250004 },
        { lat: 59.63886718750003, lng: 150.32558593750005 },
        { lat: 59.651269531249966, lng: 150.2025390625 },
        { lat: 59.77041015624999, lng: 149.64257812499994 },
        { lat: 59.76098632812503, lng: 149.42451171875 },
        { lat: 59.72846679687499, lng: 149.29042968749997 },
        { lat: 59.63051757812502, lng: 149.06523437500002 },
        { lat: 59.558789062499955, lng: 149.12773437500007 },
        { lat: 59.526757812500016, lng: 149.17539062500012 },
        { lat: 59.48818359374996, lng: 149.20498046875 },
        { lat: 59.48051757812502, lng: 149.1330078125001 },
        { lat: 59.475, lng: 148.925 },
        { lat: 59.532324218750006, lng: 148.79707031250004 },
        { lat: 59.44853515625008, lng: 148.70888671875 },
        { lat: 59.373535156249964, lng: 148.74414062499997 },
        { lat: 59.4, lng: 148.88964843749997 },
        { lat: 59.369140624999964, lng: 148.96464843750007 },
        { lat: 59.282714843750036, lng: 148.91406249999994 },
        { lat: 59.257910156250034, lng: 148.72666015625006 },
        { lat: 59.26230468750006, lng: 148.49121093749994 },
        { lat: 59.414208984374994, lng: 148.25742187500006 },
        { lat: 59.388037109375006, lng: 147.87460937500006 },
        { lat: 59.290673828124966, lng: 147.68789062499997 },
        { lat: 59.26855468749999, lng: 147.51445312500002 },
        { lat: 59.365722656249964, lng: 147.04003906250003 },
        { lat: 59.372949218750016, lng: 146.80371093750003 },
        { lat: 59.45698242187501, lng: 146.53720703125006 },
        { lat: 59.43046875000002, lng: 146.44433593749997 },
        { lat: 59.22148437499999, lng: 146.27343749999997 },
        { lat: 59.17055664062502, lng: 146.04951171875007 },
        { lat: 59.198388671874994, lng: 145.93164062499997 },
        { lat: 59.33032226562505, lng: 145.82910156249997 },
        { lat: 59.373730468750004, lng: 145.75644531250006 },
        { lat: 59.41352539062495, lng: 145.55458984375 },
        { lat: 59.37626953124998, lng: 144.48339843749997 },
        { lat: 59.40830078125003, lng: 144.1234375 },
        { lat: 59.41137695312505, lng: 143.86875 },
        { lat: 59.34365234375002, lng: 143.523828125 },
        { lat: 59.37011718749999, lng: 143.19218750000002 },
        { lat: 59.24013671874996, lng: 142.58027343750004 },
        { lat: 59.15263671874999, lng: 142.33037109375002 },
        { lat: 58.999658203125016, lng: 142.02539062499997 },
        { lat: 58.745263671874966, lng: 141.75468750000007 },
        { lat: 58.64902343749997, lng: 141.6029296875 },
        { lat: 58.52807617187502, lng: 141.3470703125 },
        { lat: 58.41684570312503, lng: 140.98769531250005 },
        { lat: 58.30346679687502, lng: 140.79023437500004 },
        { lat: 58.212158203124964, lng: 140.68496093749997 },
        { lat: 57.86542968749995, lng: 140.49511718749997 },
        { lat: 57.81367187499998, lng: 140.446875 },
        { lat: 57.6875, lng: 140.00234375000005 },
        { lat: 57.54931640625002, lng: 139.86152343750004 },
        { lat: 57.51416015624997, lng: 139.80332031250006 },
        { lat: 57.455712890624966, lng: 139.61923828125006 },
        { lat: 57.358300781250016, lng: 139.50664062500002 },
        { lat: 57.329687500000055, lng: 139.44384765625003 },
        { lat: 57.26152343750001, lng: 139.18164062499997 },
        { lat: 57.08813476562506, lng: 138.96572265625005 },
        { lat: 56.96552734375004, lng: 138.66210937500003 },
        { lat: 56.629003906250034, lng: 138.21777343749997 },
        { lat: 56.588525390624966, lng: 138.18007812500005 },
        { lat: 56.49868164062505, lng: 138.140625 },
        { lat: 56.43310546875, lng: 138.07382812500003 },
        { lat: 56.13935546875004, lng: 137.69150390625006 },
        { lat: 56.11210937499999, lng: 137.5729492187501 },
        { lat: 55.974755859374966, lng: 137.38408203125007 },
        { lat: 55.89228515624995, lng: 137.18984375 },
        { lat: 55.795263671875006, lng: 137.01210937500005 },
        { lat: 55.694189453125006, lng: 136.79355468750012 },
        { lat: 55.57670898437499, lng: 136.46025390625007 },
        { lat: 55.51000976562497, lng: 136.35117187500006 },
        { lat: 55.35224609374998, lng: 136.1751953125 },
        { lat: 55.16064453125003, lng: 135.75078125000002 },
        { lat: 55.11376953125, lng: 135.54062500000012 },
        { lat: 54.943310546874976, lng: 135.2625 },
        { lat: 54.903222656249994, lng: 135.234765625 },
        { lat: 54.84082031249997, lng: 135.21152343750012 },
        { lat: 54.73149414062499, lng: 135.25771484375005 },
        { lat: 54.70742187499999, lng: 135.325390625 },
        { lat: 54.692480468750034, lng: 135.43779296875002 },
        { lat: 54.583935546874955, lng: 135.85156249999997 },
        { lat: 54.61406249999995, lng: 136.2379882812501 },
        { lat: 54.613623046875055, lng: 136.5802734375001 },
        { lat: 54.62431640625002, lng: 136.7145507812501 },
        { lat: 54.62099609375005, lng: 136.797265625 },
        { lat: 54.561474609375004, lng: 136.82373046875003 },
        { lat: 54.45234374999998, lng: 136.82041015625006 },
        { lat: 54.35332031249995, lng: 136.77041015625 },
        { lat: 54.06064453125003, lng: 136.72939453125 },
        { lat: 53.93129882812505, lng: 136.68300781250005 },
        { lat: 53.804101562499994, lng: 136.71884765625006 },
        { lat: 53.781982421875, lng: 136.80263671875 },
        { lat: 53.839355468749964, lng: 136.88642578125004 },
        { lat: 53.848144531249964, lng: 137.01875 },
        { lat: 53.821679687500016, lng: 137.15537109375012 },
        { lat: 54.025244140625, lng: 137.25800781250004 },
        { lat: 54.05688476562505, lng: 137.17246093750012 },
        { lat: 54.128564453124994, lng: 137.09619140625003 },
        { lat: 54.182226562500006, lng: 137.14160156249994 },
        { lat: 54.28232421874998, lng: 137.37773437500002 },
        { lat: 54.29121093750001, lng: 137.5250976562501 },
        { lat: 54.283300781250006, lng: 137.66601562500003 },
        { lat: 54.156396484374994, lng: 137.51318359374997 },
        { lat: 54.130468750000034, lng: 137.45126953125006 },
        { lat: 54.12353515625006, lng: 137.40341796875012 },
        { lat: 54.10053710937498, lng: 137.3392578125 },
        { lat: 54.02758789062503, lng: 137.47646484375005 },
        { lat: 53.97045898437503, lng: 137.6227539062501 },
        { lat: 53.94672851562498, lng: 137.83476562500002 },
        { lat: 53.90332031250003, lng: 137.78613281249997 },
        { lat: 53.865820312500034, lng: 137.64482421875007 },
        { lat: 53.70708007812502, lng: 137.51699218750002 },
        { lat: 53.63159179687499, lng: 137.31367187500004 },
        { lat: 53.579199218750006, lng: 137.22148437500007 },
        { lat: 53.546142578125, lng: 137.25371093750007 },
        { lat: 53.538964843749966, lng: 137.3283203125001 },
        { lat: 53.56030273437506, lng: 137.73818359375 },
        { lat: 53.60356445312499, lng: 137.95048828125007 },
        { lat: 53.726416015625055, lng: 138.25292968749997 },
        { lat: 53.90927734375, lng: 138.37890624999997 },
        { lat: 53.959667968749955, lng: 138.49355468750005 },
        { lat: 53.959863281249994, lng: 138.5279296875001 },
        { lat: 53.947167968749994, lng: 138.56816406250007 },
        { lat: 53.81879882812495, lng: 138.56914062500002 },
        { lat: 53.67416992187498, lng: 138.40703125000002 },
        { lat: 53.59243164062502, lng: 138.29218750000004 },
        { lat: 53.52402343750003, lng: 138.24970703125004 },
        { lat: 53.52290039062498, lng: 138.32031250000003 },
        { lat: 53.537011718750016, lng: 138.45068359375003 },
        { lat: 53.57001953124998, lng: 138.51093750000004 },
        { lat: 53.744775390624966, lng: 138.66074218750012 },
        { lat: 53.869726562500034, lng: 138.6994140625 },
        { lat: 54.04375, lng: 138.72167968749997 },
        { lat: 54.14765624999998, lng: 138.70468750000006 },
        { lat: 54.22265625, lng: 138.71591796875006 },
        { lat: 54.29833984375003, lng: 138.65722656249997 },
        { lat: 54.32001953125001, lng: 138.695703125 },
        { lat: 54.21782226562498, lng: 139.10507812500012 },
        { lat: 54.19296874999998, lng: 139.31972656250005 },
        { lat: 54.27714843749999, lng: 139.707421875 },
        { lat: 54.256445312500034, lng: 139.79550781250006 },
        { lat: 54.205322265625, lng: 139.85839843750003 },
        { lat: 54.051562500000045, lng: 140.17871093749997 },
        { lat: 54.001025390625045, lng: 140.24169921875003 },
        { lat: 53.81259765625003, lng: 140.3470703125 },
        { lat: 53.59643554687503, lng: 140.68759765625012 },
        { lat: 53.49458007812498, lng: 141.00566406250007 },
        { lat: 53.45424804687502, lng: 141.0150390625 },
        { lat: 53.33447265625006, lng: 141.21767578124997 },
        { lat: 53.29277343749999, lng: 141.3737304687501 },
        { lat: 53.18398437500002, lng: 141.4020507812501 },
        { lat: 53.097265625000034, lng: 141.32792968750002 },
        { lat: 53.01528320312505, lng: 141.18125 },
        { lat: 53.09150390625001, lng: 140.88730468750012 },
        { lat: 53.087890625, lng: 140.83964843750002 },
        { lat: 53.03984374999999, lng: 140.87451171874997 },
        { lat: 52.89755859375003, lng: 141.08681640625 },
        { lat: 52.84013671874996, lng: 141.25585937499997 },
        { lat: 52.65258789062506, lng: 141.26591796875007 },
        { lat: 52.55014648437503, lng: 141.24501953125 },
        { lat: 52.435693359374994, lng: 141.13242187500006 },
        { lat: 52.36840820312497, lng: 141.16982421875005 },
        { lat: 52.27114257812505, lng: 141.32968750000006 },
        { lat: 52.234326171875004, lng: 141.40908203125 },
        { lat: 52.17851562500002, lng: 141.48525390625 },
        { lat: 52.05722656249997, lng: 141.385546875 },
        { lat: 51.92065429687505, lng: 141.36689453125004 },
        { lat: 51.860693359375006, lng: 141.25839843750006 },
        { lat: 51.72778320312502, lng: 141.12939453124997 },
        { lat: 51.61992187499999, lng: 140.93261718750003 },
        { lat: 51.41416015624998, lng: 140.83857421875004 },
        { lat: 51.23227539062506, lng: 140.68769531250004 },
        { lat: 51.05131835937496, lng: 140.67070312500002 },
        { lat: 50.986767578124955, lng: 140.64560546875006 },
        { lat: 50.800195312500044, lng: 140.5208984375 },
        { lat: 50.545996093750034, lng: 140.47636718750007 },
        { lat: 50.13076171874999, lng: 140.53544921875002 },
        { lat: 50.106689453124964, lng: 140.56406250000003 },
        { lat: 50.08242187500002, lng: 140.62451171874997 },
        { lat: 50.05371093750003, lng: 140.61328124999997 },
        { lat: 50.03334960937496, lng: 140.58457031250006 },
        { lat: 49.911474609375006, lng: 140.46269531250002 },
        { lat: 49.825585937499994, lng: 140.46455078125004 },
        { lat: 49.76166992187504, lng: 140.51132812500006 },
        { lat: 49.59614257812498, lng: 140.51718750000012 },
        { lat: 49.33149414062498, lng: 140.4310546875 },
        { lat: 49.28979492187499, lng: 140.39912109375 },
        { lat: 49.220849609374994, lng: 140.36435546875006 },
        { lat: 49.15917968750002, lng: 140.34863281249997 },
        { lat: 49.120019531249966, lng: 140.32558593749997 },
        { lat: 49.05390625000001, lng: 140.308984375 },
        { lat: 48.994824218749955, lng: 140.33369140625004 },
        { lat: 48.964111328125, lng: 140.3783203125 },
        { lat: 48.77285156250002, lng: 140.22421875000012 },
        { lat: 48.52368164062497, lng: 140.17060546875004 },
        { lat: 48.42265625000002, lng: 140.11328124999997 },
        { lat: 48.32377929687501, lng: 139.99843750000005 },
        { lat: 48.180566406249966, lng: 139.76074218750003 },
        { lat: 48.08989257812499, lng: 139.67626953124997 },
        { lat: 47.97529296874998, lng: 139.52050781250003 },
        { lat: 47.88735351562502, lng: 139.37265625000006 },
        { lat: 47.63486328125, lng: 139.16699218750003 },
        { lat: 47.38330078125, lng: 139.00136718750005 },
        { lat: 47.057226562500006, lng: 138.58681640625005 },
        { lat: 46.97622070312502, lng: 138.52968750000005 },
        { lat: 46.88984375000001, lng: 138.50048828124997 },
        { lat: 46.74506835937501, lng: 138.3917968750001 },
        { lat: 46.54340820312495, lng: 138.33691406250003 },
        { lat: 46.46293945312499, lng: 138.21015625000004 },
        { lat: 46.25073242187503, lng: 138.10634765625005 },
        { lat: 45.92851562500002, lng: 137.76914062500006 },
        { lat: 45.81835937500002, lng: 137.68544921875 },
        { lat: 45.639990234375034, lng: 137.4251953125 },
        { lat: 45.393505859374976, lng: 137.14697265624997 },
        { lat: 45.171142578125, lng: 136.80351562500002 },
        { lat: 45.08002929687498, lng: 136.73720703125 },
        { lat: 44.97817382812502, lng: 136.60410156250006 },
        { lat: 44.822119140625034, lng: 136.46044921875003 },
        { lat: 44.66679687499999, lng: 136.2511718750001 },
        { lat: 44.56201171874997, lng: 136.20869140625004 },
        { lat: 44.489111328125034, lng: 136.14228515625004 },
        { lat: 44.43984375000005, lng: 135.9870117187501 },
        { lat: 44.37353515625003, lng: 135.87460937500012 },
        { lat: 43.97148437500002, lng: 135.53320312500003 },
        { lat: 43.89882812500005, lng: 135.48906250000002 },
        { lat: 43.83500976562502, lng: 135.48339843749997 },
        { lat: 43.68461914062502, lng: 135.26015625 },
        { lat: 43.52573242187506, lng: 135.1310546875001 },
        { lat: 43.42656250000002, lng: 134.91699218749997 },
        { lat: 43.29057617187502, lng: 134.691796875 },
        { lat: 43.04213867187505, lng: 134.15644531250004 },
        { lat: 42.94746093750001, lng: 134.01044921875 },
        { lat: 42.82993164062506, lng: 133.709375 },
        { lat: 42.82822265624998, lng: 133.58671875000002 },
        { lat: 42.76386718750001, lng: 133.32949218750005 },
        { lat: 42.69697265624998, lng: 133.15996093750007 },
        { lat: 42.722802734374994, lng: 133.059375 },
        { lat: 42.80800781250002, lng: 132.99658203124997 },
        { lat: 42.805273437500006, lng: 132.92392578125012 },
        { lat: 42.79375, lng: 132.86357421875007 },
        { lat: 42.875830078125, lng: 132.70898437500003 },
        { lat: 42.87158203125003, lng: 132.57646484375002 },
        { lat: 42.90976562499998, lng: 132.48134765625 },
        { lat: 42.88330078125, lng: 132.30380859375006 },
        { lat: 43.23867187500002, lng: 132.334375 },
        { lat: 43.31352539062499, lng: 132.30957031249997 },
        { lat: 43.24506835937498, lng: 132.23320312500007 },
        { lat: 43.11894531249996, lng: 132.02871093749997 },
        { lat: 43.09541015624995, lng: 131.94726562499997 },
        { lat: 43.09516601562501, lng: 131.86660156249997 },
        { lat: 43.170751953125034, lng: 131.89833984375 },
        { lat: 43.280029296875, lng: 132.0130859375 },
        { lat: 43.296044921874994, lng: 131.97626953125004 },
        { lat: 43.30195312500004, lng: 131.93896484374997 },
        { lat: 43.25527343750002, lng: 131.79472656250002 },
        { lat: 43.20263671875006, lng: 131.72207031250005 },
        { lat: 42.99643554687506, lng: 131.51640625000007 },
        { lat: 42.82231445312502, lng: 131.39326171875 },
        { lat: 42.772119140624994, lng: 131.29248046875003 },
        { lat: 42.697412109374966, lng: 131.2453125000001 },
        { lat: 42.62602539062499, lng: 131.15830078125012 },
        { lat: 42.645166015624994, lng: 131.0248046875 },
        { lat: 42.63393554687502, lng: 130.94570312500005 },
        { lat: 42.67329101562504, lng: 130.75615234375007 },
        { lat: 42.656396484374966, lng: 130.709375 },
        { lat: 42.52294921875006, lng: 130.83417968750007 },
        { lat: 42.325781250000034, lng: 130.72988281250005 },
        { lat: 42.30253906249999, lng: 130.68730468750007 },
        { lat: 42.327783203124994, lng: 130.65800781250007 },
        { lat: 42.372509765624955, lng: 130.6515625000001 },
        { lat: 42.415625, lng: 130.61796875000007 },
        { lat: 42.47470703124997, lng: 130.55410156250005 },
        { lat: 42.535400390625, lng: 130.5269531250001 },
        { lat: 42.56733398437504, lng: 130.58447265625003 },
        { lat: 42.62324218749995, lng: 130.5765625 },
        { lat: 42.67431640624997, lng: 130.52060546875006 },
        { lat: 42.68554687500005, lng: 130.43925781250002 },
        { lat: 42.69985351562502, lng: 130.41992187499997 },
        { lat: 42.72705078124997, lng: 130.42480468749997 },
        { lat: 42.75541992187499, lng: 130.45273437500006 },
        { lat: 42.77910156250002, lng: 130.49296875000002 },
        { lat: 42.81162109375006, lng: 130.57724609375006 },
        { lat: 42.83583984375002, lng: 130.72246093750007 },
        { lat: 42.85683593750002, lng: 130.80332031250006 },
        { lat: 42.86333007812502, lng: 130.86855468750005 },
        { lat: 42.851757812499976, lng: 130.94287109375003 },
        { lat: 42.88310546874996, lng: 131.0055664062501 },
        { lat: 42.90224609375005, lng: 131.06855468750004 },
        { lat: 42.95629882812506, lng: 131.08349609374997 },
        { lat: 43.0380859375, lng: 131.0861328125 },
        { lat: 43.06245117187501, lng: 131.10898437500012 },
        { lat: 43.09760742187498, lng: 131.13554687500002 },
        { lat: 43.1421875, lng: 131.17558593750007 },
        { lat: 43.25776367187501, lng: 131.21191406250003 },
        { lat: 43.33764648437503, lng: 131.23935546875012 },
        { lat: 43.378076171874994, lng: 131.25732421875003 },
        { lat: 43.43305664062501, lng: 131.26181640625006 },
        { lat: 43.46904296874996, lng: 131.24394531250007 },
        { lat: 43.49042968749998, lng: 131.2091796875001 },
        { lat: 43.50556640625004, lng: 131.18242187500007 },
        { lat: 43.567089843749955, lng: 131.180078125 },
        { lat: 43.65087890624997, lng: 131.18359375000003 },
        { lat: 43.70473632812502, lng: 131.17421875 },
        { lat: 44.00292968750003, lng: 131.21328125000005 },
        { lat: 44.07158203124998, lng: 131.2552734375 },
        { lat: 44.46918945312498, lng: 131.12578125000005 },
        { lat: 44.59565429687498, lng: 131.08691406249997 },
        { lat: 44.65966796874997, lng: 131.06064453125012 },
        { lat: 44.75322265625002, lng: 131.00390625000003 },
        { lat: 44.79995117187505, lng: 130.96777343750003 },
        { lat: 44.844335937500034, lng: 130.9816406250001 },
        { lat: 44.88886718750004, lng: 131.03300781250007 },
        { lat: 44.91000976562498, lng: 131.08232421875002 },
        { lat: 44.92016601562503, lng: 131.2279296875 },
        { lat: 44.93613281249997, lng: 131.26826171875004 },
        { lat: 44.984033203124966, lng: 131.44687500000012 },
        { lat: 45.01313476562504, lng: 131.4875 },
        { lat: 45.08364257812502, lng: 131.57871093750006 },
        { lat: 45.13657226562506, lng: 131.61396484375004 },
        { lat: 45.20537109375004, lng: 131.65400390625 },
        { lat: 45.24262695312498, lng: 131.74208984375005 },
        { lat: 45.305273437500034, lng: 131.79492187499997 },
        { lat: 45.32685546875001, lng: 131.85185546875002 },
        { lat: 45.27373046875002, lng: 131.90927734375003 },
        { lat: 45.243994140625006, lng: 131.97753906250003 },
        { lat: 45.225976562499966, lng: 132.06738281249997 },
        { lat: 45.203271484375044, lng: 132.1813476562501 },
        { lat: 45.15996093750002, lng: 132.36298828125 },
        { lat: 45.122802734375, lng: 132.5490234375 },
        { lat: 45.09370117187501, lng: 132.665625 },
        { lat: 45.08056640625, lng: 132.72314453124997 },
        { lat: 45.061132812500034, lng: 132.83867187500007 },
        { lat: 45.046044921874994, lng: 132.88876953125003 },
        { lat: 45.029931640624994, lng: 132.93603515624997 },
        { lat: 45.074560546875034, lng: 133.01171874999997 },
        { lat: 45.130712890625006, lng: 133.1134765625001 },
        { lat: 45.220458984375, lng: 133.096875 },
        { lat: 45.321435546874966, lng: 133.11337890625006 },
        { lat: 45.49482421875004, lng: 133.18603515625003 },
        { lat: 45.545263671875006, lng: 133.2669921875 },
        { lat: 45.553076171875006, lng: 133.30957031249994 },
        { lat: 45.57221679687498, lng: 133.35546875000003 },
        { lat: 45.60468750000004, lng: 133.43642578125 },
        { lat: 45.651220703125, lng: 133.465625 },
        { lat: 45.70507812500005, lng: 133.44912109375 },
        { lat: 45.757666015625006, lng: 133.4757812500001 },
        { lat: 45.81044921875002, lng: 133.48466796875 },
        { lat: 45.878808593749994, lng: 133.51308593750002 },
        { lat: 45.897802734375055, lng: 133.551171875 },
        { lat: 45.92031250000002, lng: 133.60800781250012 },
        { lat: 45.95522460937502, lng: 133.6478515625 },
        { lat: 46.00893554687505, lng: 133.68574218750004 },
        { lat: 46.06962890624999, lng: 133.7111328125001 },
        { lat: 46.13974609375006, lng: 133.70068359374997 },
        { lat: 46.185937500000044, lng: 133.75019531250004 },
        { lat: 46.22426757812505, lng: 133.8328125 },
        { lat: 46.24775390625004, lng: 133.86132812500003 },
        { lat: 46.30908203125, lng: 133.87480468750002 },
        { lat: 46.33603515624998, lng: 133.8802734375 },
        { lat: 46.366943359374964, lng: 133.90273437500005 },
        { lat: 46.430566406249966, lng: 133.88671874999997 },
        { lat: 46.499121093750006, lng: 133.86660156250005 },
        { lat: 46.6142578125, lng: 133.95751953124997 },
        { lat: 46.71318359374999, lng: 134.02265625000004 },
        { lat: 46.85815429687503, lng: 134.03857421874997 },
        { lat: 46.88198242187502, lng: 134.04599609375006 },
        { lat: 46.95078125, lng: 134.07138671875012 },
        { lat: 46.978125, lng: 134.08642578124997 },
        { lat: 47.068994140624994, lng: 134.13691406250004 },
        { lat: 47.128076171874966, lng: 134.2021484375 },
        { lat: 47.19423828125002, lng: 134.18925781250007 },
        { lat: 47.25874023437503, lng: 134.16298828125005 },
        { lat: 47.30219726562501, lng: 134.1676757812501 },
        { lat: 47.352636718750055, lng: 134.22519531250006 },
        { lat: 47.37773437500001, lng: 134.26005859375002 },
        { lat: 47.41357421875003, lng: 134.2908203125 },
        { lat: 47.42949218749999, lng: 134.33945312500012 },
        { lat: 47.43823242187499, lng: 134.3825195312501 },
        { lat: 47.447363281250006, lng: 134.48349609375006 },
        { lat: 47.48515625, lng: 134.54189453125002 },
        { lat: 47.523876953124955, lng: 134.59619140624997 },
        { lat: 47.624853515625006, lng: 134.69580078124997 },
        { lat: 47.68447265624999, lng: 134.728125 },
        { lat: 47.71542968749998, lng: 134.75234375 },
        { lat: 47.801416015624994, lng: 134.6986328125 },
        { lat: 47.87426757812503, lng: 134.65029296875 },
        { lat: 47.975195312500055, lng: 134.59130859374997 },
        { lat: 48.02250976562501, lng: 134.56601562500006 },
        { lat: 48.082910156249966, lng: 134.60537109375 },
        { lat: 48.12016601562502, lng: 134.64726562500002 },
        { lat: 48.15332031250003, lng: 134.6693359375 },
        { lat: 48.21044921875003, lng: 134.6808593750001 },
        { lat: 48.25390625, lng: 134.66523437500004 },
        { lat: 48.321728515624955, lng: 134.56357421875012 },
        { lat: 48.35532226562506, lng: 134.45615234375006 },
        { lat: 48.36884765624995, lng: 134.33496093749997 },
        { lat: 48.373437500000016, lng: 134.29335937500005 },
        { lat: 48.35991210937502, lng: 134.20585937500007 },
        { lat: 48.273730468750045, lng: 133.84218750000005 },
        { lat: 48.20771484375001, lng: 133.67177734375005 },
        { lat: 48.13300781249998, lng: 133.57324218749994 },
        { lat: 48.09716796875003, lng: 133.46835937500006 },
        { lat: 48.10151367187504, lng: 133.30117187500005 },
        { lat: 48.10566406249998, lng: 133.14404296875003 },
        { lat: 48.06440429687504, lng: 133.02011718750006 },
        { lat: 47.979101562500055, lng: 132.8771484375001 },
        { lat: 47.940087890625016, lng: 132.77285156250005 },
        { lat: 47.94726562500006, lng: 132.70722656250007 },
        { lat: 47.890087890624955, lng: 132.6369140625001 },
        { lat: 47.768505859374955, lng: 132.5619140625 },
        { lat: 47.714990234374994, lng: 132.47626953125004 },
        { lat: 47.7294921875, lng: 132.38017578125002 },
        { lat: 47.71796874999998, lng: 132.14980468750005 },
        { lat: 47.68051757812497, lng: 131.78525390625012 },
        { lat: 47.68203125000002, lng: 131.55673828125012 },
        { lat: 47.72260742187504, lng: 131.4642578125 },
        { lat: 47.72783203125002, lng: 131.31933593749997 },
        { lat: 47.69765625, lng: 131.121875 },
        { lat: 47.69145507812499, lng: 131.002734375 },
        { lat: 47.70932617187498, lng: 130.96191406249997 },
        { lat: 47.75981445312496, lng: 130.93281250000007 },
        { lat: 47.84291992187502, lng: 130.9154296875 },
        { lat: 47.92944335937497, lng: 130.84863281249997 },
        { lat: 48.01923828124998, lng: 130.73261718750007 },
        { lat: 48.12763671875003, lng: 130.7121093750001 },
        { lat: 48.254589843749955, lng: 130.78720703125012 },
        { lat: 48.341503906249976, lng: 130.80429687500012 },
        { lat: 48.38842773437506, lng: 130.76347656250005 },
        { lat: 48.43037109374998, lng: 130.746875 },
        { lat: 48.48339843750002, lng: 130.65917968750003 },
        { lat: 48.57465820312498, lng: 130.59726562500012 },
        { lat: 48.602490234374955, lng: 130.5521484375 },
        { lat: 48.680126953124955, lng: 130.565625 },
        { lat: 48.773193359375, lng: 130.61718750000003 },
        { lat: 48.861181640625006, lng: 130.553125 },
        { lat: 48.866357421874994, lng: 130.35527343750002 },
        { lat: 48.89165039062499, lng: 130.1959960937501 },
        { lat: 48.97226562499998, lng: 130.03710937499994 },
        { lat: 49.19887695312505, lng: 129.79257812500006 },
        { lat: 49.27851562500001, lng: 129.6710937500001 },
        { lat: 49.28666992187499, lng: 129.59140625000012 },
        { lat: 49.32343750000001, lng: 129.53369140624997 },
        { lat: 49.38881835937502, lng: 129.4981445312501 },
        { lat: 49.38945312499996, lng: 129.44072265625007 },
        { lat: 49.38945312499996, lng: 129.38466796874997 },
        { lat: 49.362353515625045, lng: 129.35009765624997 },
        { lat: 49.353857421875006, lng: 129.30986328125002 },
        { lat: 49.378662109375, lng: 129.24843750000005 },
        { lat: 49.38139648437502, lng: 129.18515625000012 },
        { lat: 49.36206054687497, lng: 129.12011718750003 },
        { lat: 49.374658203124966, lng: 129.0651367187501 },
        { lat: 49.41923828124999, lng: 129.02031250000002 },
        { lat: 49.44892578125001, lng: 128.93828125000002 },
        { lat: 49.46376953125002, lng: 128.81933593750003 },
        { lat: 49.494726562500006, lng: 128.77031250000007 },
        { lat: 49.541845703125006, lng: 128.79101562500003 },
        { lat: 49.57695312499999, lng: 128.76904296874997 },
        { lat: 49.60014648437499, lng: 128.70400390624997 },
        { lat: 49.59423828125003, lng: 128.5267578125 },
        { lat: 49.55927734375001, lng: 128.23710937500007 },
        { lat: 49.56860351562506, lng: 127.99960937500008 },
        { lat: 49.62211914062501, lng: 127.81425781250007 },
        { lat: 49.67153320312496, lng: 127.71113281250003 },
        { lat: 49.71674804687504, lng: 127.69013671875008 },
        { lat: 49.760205078125004, lng: 127.63671874999997 },
        { lat: 49.801806640625045, lng: 127.55078124999997 },
        { lat: 49.8734375, lng: 127.50244140624997 },
        { lat: 49.97504882812498, lng: 127.49179687500012 },
        { lat: 50.07167968750005, lng: 127.51230468750013 },
        { lat: 50.20898437500003, lng: 127.590234375 },
        { lat: 50.298583984375, lng: 127.39531250000006 },
        { lat: 50.35014648437502, lng: 127.33720703125007 },
        { lat: 50.39360351562498, lng: 127.35117187500006 },
        { lat: 50.428076171875006, lng: 127.34082031249997 },
        { lat: 50.45351562500002, lng: 127.30605468749998 },
        { lat: 50.49418945312495, lng: 127.3082031250001 },
        { lat: 50.55009765624999, lng: 127.34716796874997 },
        { lat: 50.62133789062503, lng: 127.346875 },
        { lat: 50.707958984375004, lng: 127.30703125000005 },
        { lat: 50.82944335937506, lng: 127.19824218749997 },
        { lat: 50.985888671875045, lng: 127.02041015625 },
        { lat: 51.10014648437496, lng: 126.92480468749997 },
        { lat: 51.17231445312501, lng: 126.91152343749998 },
        { lat: 51.230126953124966, lng: 126.88769531249997 },
        { lat: 51.26137695312502, lng: 126.85439453125 },
        { lat: 51.31489257812501, lng: 126.83378906250007 },
        { lat: 51.37416992187502, lng: 126.84775390625006 },
        { lat: 51.41225585937505, lng: 126.82734375000008 },
        { lat: 51.44804687499996, lng: 126.80175781250001 },
        { lat: 51.50566406249999, lng: 126.80546875000007 },
        { lat: 51.54506835937502, lng: 126.77451171875006 },
        { lat: 51.566308593749994, lng: 126.70917968750008 },
        { lat: 51.60991210937499, lng: 126.6886718750001 },
        { lat: 51.70302734375005, lng: 126.70078125000006 },
        { lat: 51.78129882812499, lng: 126.65371093749998 },
        { lat: 51.925830078125045, lng: 126.51054687500002 },
        { lat: 52.031298828125045, lng: 126.46806640625002 },
        { lat: 52.12646484374997, lng: 126.45556640625003 },
        { lat: 52.17299804687505, lng: 126.39482421875002 },
        { lat: 52.214501953124966, lng: 126.39150390625007 },
        { lat: 52.286523437499994, lng: 126.38349609375008 },
        { lat: 52.30625, lng: 126.34628906250006 },
        { lat: 52.331640625000034, lng: 126.32421875000001 },
        { lat: 52.36201171875001, lng: 126.34169921875 },
        { lat: 52.39975585937506, lng: 126.312890625 },
        { lat: 52.44482421875, lng: 126.23759765625002 },
        { lat: 52.48383789062504, lng: 126.20292968750006 },
        { lat: 52.51914062500003, lng: 126.19443359375012 },
        { lat: 52.54663085937503, lng: 126.15664062500004 },
        { lat: 52.57333984374998, lng: 126.04589843749996 },
        { lat: 52.610205078125034, lng: 126.016015625 },
        { lat: 52.64301757812495, lng: 126.02324218750007 },
        { lat: 52.67348632812505, lng: 126.04707031250004 },
        { lat: 52.69199218749998, lng: 126.06015625000012 },
        { lat: 52.71586914062496, lng: 126.05605468749998 },
        { lat: 52.73945312499998, lng: 126.04814453125006 },
        { lat: 52.76787109374999, lng: 126.004296875 },
        { lat: 52.80068359375002, lng: 125.94160156250004 },
        { lat: 52.871533203124976, lng: 125.871875 },
        { lat: 52.89072265624998, lng: 125.78281250000012 },
        { lat: 52.89072265624998, lng: 125.728125 },
        { lat: 52.930810546874966, lng: 125.68076171875012 },
        { lat: 52.956298828125, lng: 125.69531249999996 },
        { lat: 53.00371093749998, lng: 125.69169921875002 },
        { lat: 53.042285156250045, lng: 125.64902343750012 },
        { lat: 53.057470703125006, lng: 125.59599609375007 },
        { lat: 53.04760742187506, lng: 125.54599609375005 },
        { lat: 53.08374023437503, lng: 125.42246093750005 },
        { lat: 53.16582031249999, lng: 125.22558593750003 },
        { lat: 53.20366210937495, lng: 125.075 },
        { lat: 53.19731445312499, lng: 124.9708984375001 },
        { lat: 53.172656250000045, lng: 124.90664062500005 },
        { lat: 53.129736328125006, lng: 124.88212890625 },
        { lat: 53.133837890625045, lng: 124.81230468750002 },
        { lat: 53.21064453124995, lng: 124.63984375000003 },
        { lat: 53.22963867187502, lng: 124.46591796875006 },
        { lat: 53.27094726562498, lng: 124.36914062499996 },
        { lat: 53.34086914062502, lng: 124.29140625 },
        { lat: 53.37011718750003, lng: 124.21992187500003 },
        { lat: 53.35869140625001, lng: 124.15429687499997 },
        { lat: 53.40561523437497, lng: 123.99472656250005 },
        { lat: 53.51098632812503, lng: 123.74091796875003 },
        { lat: 53.546533203124994, lng: 123.6078125 },
        { lat: 53.526660156250045, lng: 123.5597656250001 },
        { lat: 53.526464843750006, lng: 123.53476562500008 },
        { lat: 53.52944335937499, lng: 123.48945312500004 },
        { lat: 53.53076171874997, lng: 123.42402343750004 },
        { lat: 53.55561523437498, lng: 123.30957031250001 },
        { lat: 53.54458007812505, lng: 123.15410156250007 },
        { lat: 53.49770507812499, lng: 122.95761718750006 },
        { lat: 53.46850585937499, lng: 122.74472656250006 },
        { lat: 53.45698242187495, lng: 122.51582031250003 },
        { lat: 53.4625, lng: 122.38017578125002 },
        { lat: 53.48500976562499, lng: 122.33779296875 },
        { lat: 53.45146484374999, lng: 122.08886718750001 },
        { lat: 53.38359375000002, lng: 121.74394531250002 },
        { lat: 53.317041015624966, lng: 121.40546875000003 },
        { lat: 53.28457031250002, lng: 120.98544921875012 },
        { lat: 53.171826171874955, lng: 120.70410156249997 },
        { lat: 52.96806640625002, lng: 120.42128906249998 },
        { lat: 52.83989257812502, lng: 120.21816406250001 },
        { lat: 52.787207031250034, lng: 120.09453125000007 },
        { lat: 52.71821289062501, lng: 120.04433593750005 },
        { lat: 52.63291015625003, lng: 120.0675781250001 },
        { lat: 52.602490234374955, lng: 120.17275390625 },
        { lat: 52.62700195312499, lng: 120.36005859375004 },
        { lat: 52.61503906250004, lng: 120.52109375000012 },
        { lat: 52.56665039062502, lng: 120.65615234375 },
        { lat: 52.49360351562498, lng: 120.69921874999997 },
        { lat: 52.395898437499966, lng: 120.65039062499997 },
        { lat: 52.299902343750034, lng: 120.66542968749998 },
        { lat: 52.20546875, lng: 120.74453125000004 },
        { lat: 52.096533203125, lng: 120.74980468750007 },
        { lat: 51.97304687499999, lng: 120.68144531250006 },
        { lat: 51.84853515625002, lng: 120.51054687500006 },
        { lat: 51.722998046875034, lng: 120.23701171875003 },
        { lat: 51.60068359375006, lng: 120.06689453125003 },
        { lat: 51.42211914062499, lng: 119.96699218750008 },
        { lat: 51.26704101562504, lng: 119.81318359375004 },
        { lat: 51.17949218749995, lng: 119.75664062500006 },
        { lat: 51.10771484374999, lng: 119.74599609375 },
        { lat: 51.030126953125006, lng: 119.6849609375 },
        { lat: 50.94677734374997, lng: 119.57343750000003 },
        { lat: 50.863134765625006, lng: 119.51230468750012 },
        { lat: 50.779248046874955, lng: 119.50175781250002 },
        { lat: 50.70283203125001, lng: 119.44570312500005 },
        { lat: 50.633886718750006, lng: 119.34404296875002 },
        { lat: 50.56098632812498, lng: 119.2806640625 },
        { lat: 50.48417968749996, lng: 119.25585937499996 },
        { lat: 50.432519531250016, lng: 119.21669921874998 },
        { lat: 50.40600585937503, lng: 119.16367187500006 },
        { lat: 50.37983398437504, lng: 119.19189453125003 },
        { lat: 50.35390625, lng: 119.30156250000006 },
        { lat: 50.278955078124994, lng: 119.34628906250012 },
        { lat: 50.15493164062505, lng: 119.32607421875001 },
        { lat: 50.06640625000003, lng: 119.25986328125012 },
        { lat: 50.013378906249976, lng: 119.14746093750001 },
        { lat: 49.97885742187506, lng: 118.97949218749996 },
        { lat: 49.96284179687498, lng: 118.75595703125013 },
        { lat: 49.84448242187502, lng: 118.4515625 },
        { lat: 49.69277343750002, lng: 118.18662109375013 },
        { lat: 49.51347656250002, lng: 117.8734375 },
        { lat: 49.513525390625034, lng: 117.81259765625012 },
        { lat: 49.53583984375004, lng: 117.69843750000004 },
        { lat: 49.60942382812501, lng: 117.47714843750006 },
        { lat: 49.624853515625055, lng: 117.24560546874997 },
        { lat: 49.69296874999998, lng: 117.02167968750004 },
        { lat: 49.737792968749964, lng: 116.88896484375007 },
        { lat: 49.82377929687499, lng: 116.6833007812501 },
        { lat: 49.877050781250006, lng: 116.63154296875004 },
        { lat: 49.92031250000002, lng: 116.55117187499998 },
        { lat: 49.97807617187499, lng: 116.35117187500012 },
        { lat: 50.00927734375003, lng: 116.21679687500003 },
        { lat: 50.01079101562499, lng: 116.1345703125 },
        { lat: 49.95214843750003, lng: 115.92597656250008 },
        { lat: 49.90590820312502, lng: 115.79521484375002 },
        { lat: 49.88061523437503, lng: 115.71777343750003 },
        { lat: 49.88603515624995, lng: 115.58798828125005 },
        { lat: 49.89648437499997, lng: 115.42919921874996 },
        { lat: 49.91176757812496, lng: 115.3650390625 },
        { lat: 49.948876953124994, lng: 115.27451171875006 },
        { lat: 50.059423828125034, lng: 115.098046875 },
        { lat: 50.138574218749994, lng: 115.00332031250005 },
        { lat: 50.18305664062501, lng: 114.8795898437501 },
        { lat: 50.23369140625002, lng: 114.74316406249996 },
        { lat: 50.24570312500006, lng: 114.6749023437501 },
        { lat: 50.24145507812499, lng: 114.55400390625002 },
        { lat: 50.25546875, lng: 114.38632812500012 },
        { lat: 50.27441406250006, lng: 114.29707031250004 },
        { lat: 50.25727539062501, lng: 114.22177734375006 },
        { lat: 50.204736328124966, lng: 114.07070312500004 },
        { lat: 50.10112304687502, lng: 113.88115234375007 },
        { lat: 50.06152343750002, lng: 113.73242187499997 },
        { lat: 50.00703125000001, lng: 113.57421874999996 },
        { lat: 49.94160156250001, lng: 113.44550781250004 },
        { lat: 49.87431640624999, lng: 113.31904296875004 },
        { lat: 49.79716796874999, lng: 113.1641601562501 },
        { lat: 49.692529296874994, lng: 113.09208984375006 },
        { lat: 49.61625976562499, lng: 113.05556640625 },
        { lat: 49.569238281249994, lng: 112.91484375 },
        { lat: 49.52358398437502, lng: 112.80644531250007 },
        { lat: 49.50727539062498, lng: 112.69736328125012 },
        { lat: 49.532324218750034, lng: 112.494921875 },
        { lat: 49.51459960937498, lng: 112.37519531250003 },
        { lat: 49.42421875000002, lng: 112.07968750000006 },
        { lat: 49.41601562500006, lng: 111.93447265625005 },
        { lat: 49.40361328125002, lng: 111.83339843750004 },
        { lat: 49.39775390624996, lng: 111.7355468750001 },
        { lat: 49.37641601562498, lng: 111.57480468750012 },
        { lat: 49.360937500000034, lng: 111.5119140625001 },
        { lat: 49.342626953125034, lng: 111.42929687500006 },
        { lat: 49.355859374999966, lng: 111.3366210937501 },
        { lat: 49.304296875000034, lng: 111.20419921875012 },
        { lat: 49.16616210937505, lng: 110.82792968750002 },
        { lat: 49.142968750000016, lng: 110.70976562500002 },
        { lat: 49.137597656249994, lng: 110.63105468750003 },
        { lat: 49.187060546875045, lng: 110.52958984375 },
        { lat: 49.21997070312499, lng: 110.42783203125006 },
        { lat: 49.215869140625045, lng: 110.32138671875012 },
        { lat: 49.17041015625003, lng: 110.19990234375003 },
        { lat: 49.20561523437499, lng: 109.99453125000005 },
        { lat: 49.23930664062502, lng: 109.75039062500004 },
        { lat: 49.26987304687503, lng: 109.52871093749998 },
        { lat: 49.29633789062501, lng: 109.45371093750012 },
        { lat: 49.334912109374955, lng: 109.23671875000005 },
        { lat: 49.33535156250005, lng: 108.91992187499997 },
        { lat: 49.335644531250004, lng: 108.73300781250012 },
        { lat: 49.32280273437498, lng: 108.61367187500004 },
        { lat: 49.34150390624998, lng: 108.52246093750003 },
        { lat: 49.39638671875005, lng: 108.4069335937501 },
        { lat: 49.52480468750002, lng: 108.21308593750004 },
        { lat: 49.562646484374994, lng: 108.09804687500005 },
        { lat: 49.593994140624964, lng: 108.03378906250012 },
        { lat: 49.646875, lng: 108.00957031250007 },
        { lat: 49.65351562500004, lng: 107.96542968750012 },
        { lat: 49.691015625000034, lng: 107.93671875000004 },
        { lat: 49.74072265625003, lng: 107.93876953125002 },
        { lat: 49.849023437499994, lng: 107.93486328125 },
        { lat: 49.92470703125002, lng: 107.94785156250012 },
        { lat: 49.947802734375045, lng: 107.91660156250012 },
        { lat: 49.960009765625045, lng: 107.78681640625004 },
        { lat: 49.98310546875004, lng: 107.63095703125012 },
        { lat: 49.986669921875034, lng: 107.34707031249998 },
        { lat: 49.989404296874994, lng: 107.23330078125 },
        { lat: 50.03300781249999, lng: 107.14306640625003 },
        { lat: 50.086474609375045, lng: 107.04023437500004 },
        { lat: 50.19667968750002, lng: 106.94130859375005 },
        { lat: 50.24829101562506, lng: 106.85371093750004 },
        { lat: 50.312597656250006, lng: 106.71113281250004 },
        { lat: 50.32880859375004, lng: 106.57441406250004 },
        { lat: 50.317578124999955, lng: 106.36845703125 },
        { lat: 50.304589843749966, lng: 106.21787109375005 },
        { lat: 50.33256835937499, lng: 106.08251953124997 },
        { lat: 50.36791992187499, lng: 105.996484375 },
        { lat: 50.405371093750006, lng: 105.8751953125001 },
        { lat: 50.414160156250006, lng: 105.6925781250001 },
        { lat: 50.441259765625034, lng: 105.54160156250006 },
        { lat: 50.47373046874998, lng: 105.38359375000002 },
        { lat: 50.46049804687504, lng: 105.26669921875012 },
        { lat: 50.42958984375005, lng: 105.1859375 },
        { lat: 50.38994140624996, lng: 105.09472656249996 },
        { lat: 50.38291015625003, lng: 104.97695312500005 },
        { lat: 50.34184570312502, lng: 104.68535156250007 },
        { lat: 50.3171875, lng: 104.59638671875004 },
        { lat: 50.30615234375003, lng: 104.46630859375003 },
        { lat: 50.27529296875005, lng: 104.35390625000004 },
        { lat: 50.214453125, lng: 104.2599609375001 },
        { lat: 50.16943359374997, lng: 104.17968749999997 },
        { lat: 50.15424804687498, lng: 104.07871093750012 },
        { lat: 50.15727539062499, lng: 103.95849609374997 },
        { lat: 50.17182617187501, lng: 103.85615234375004 },
        { lat: 50.17607421874999, lng: 103.80263671875 },
        { lat: 50.15385742187499, lng: 103.72324218750006 },
        { lat: 50.138574218749994, lng: 103.63291015625006 },
        { lat: 50.164941406250044, lng: 103.49628906250003 },
        { lat: 50.18706054687502, lng: 103.42119140625002 },
        { lat: 50.200292968750034, lng: 103.3043945312501 },
        { lat: 50.264257812500034, lng: 103.2337890625 },
        { lat: 50.29072265624998, lng: 103.16171875000005 },
        { lat: 50.300634765625055, lng: 103.03945312500005 },
        { lat: 50.33325195312506, lng: 102.85966796875002 },
        { lat: 50.36655273437498, lng: 102.76542968750007 },
        { lat: 50.38715820312501, lng: 102.68330078125004 },
        { lat: 50.46132812500002, lng: 102.5462890625 },
        { lat: 50.52568359374998, lng: 102.4694335937501 },
        { lat: 50.53618164062499, lng: 102.40683593750012 },
        { lat: 50.544238281250045, lng: 102.33642578124997 },
        { lat: 50.585107421875016, lng: 102.28837890625007 },
        { lat: 50.634667968749994, lng: 102.28574218750005 },
        { lat: 50.66552734374997, lng: 102.30332031250006 },
        { lat: 50.71845703125001, lng: 102.31660156250003 },
        { lat: 50.76870117187502, lng: 102.27656250000004 },
        { lat: 50.79121093749998, lng: 102.23505859375004 },
        { lat: 50.82944335937506, lng: 102.21503906250004 },
        { lat: 50.90146484374998, lng: 102.22617187500006 },
        { lat: 50.97431640624998, lng: 102.21025390625002 },
        { lat: 51.05068359375002, lng: 102.19453125000004 },
        { lat: 51.107519531250034, lng: 102.15195312500005 },
        { lat: 51.21606445312503, lng: 102.14238281250007 },
        { lat: 51.260839843750006, lng: 102.16005859375005 },
        { lat: 51.31376953124996, lng: 102.15566406249998 },
        { lat: 51.35346679687495, lng: 102.1115234375001 },
        { lat: 51.382226562499966, lng: 101.97919921875004 },
        { lat: 51.421044921874966, lng: 101.82119140625 },
        { lat: 51.467187500000044, lng: 101.57089843750006 },
        { lat: 51.47148437500002, lng: 101.46435546874996 },
        { lat: 51.45263671875, lng: 101.38125 },
        { lat: 51.474755859374994, lng: 101.30449218750007 },
        { lat: 51.51328125, lng: 101.22324218750012 },
        { lat: 51.553027343750045, lng: 101.08535156249998 },
        { lat: 51.60424804687499, lng: 100.90361328125 },
        { lat: 51.66157226562503, lng: 100.71074218750007 },
        { lat: 51.713476562500034, lng: 100.53623046875006 },
        { lat: 51.72607421875003, lng: 100.46894531250003 },
        { lat: 51.729833984375006, lng: 100.23037109375 },
        { lat: 51.73710937499996, lng: 100.0345703125 },
        { lat: 51.755517578124994, lng: 99.92167968750002 },
        { lat: 51.827539062499994, lng: 99.78789062500002 },
        { lat: 51.87163085937502, lng: 99.71923828124997 },
        { lat: 51.892529296875004, lng: 99.61289062500005 },
        { lat: 51.89990234374999, lng: 99.53232421875006 },
        { lat: 51.923535156250004, lng: 99.40703125000002 },
        { lat: 51.998876953125006, lng: 99.176171875 },
        { lat: 52.034863281249955, lng: 99.09140625000006 },
        { lat: 52.035400390624964, lng: 99.03427734375006 },
        { lat: 52.10170898437499, lng: 98.95810546875006 },
        { lat: 52.117285156250055, lng: 98.89316406250006 },
        { lat: 52.07006835937503, lng: 98.84863281249997 },
        { lat: 51.95747070312501, lng: 98.80253906250007 },
        { lat: 51.90507812499998, lng: 98.76015625 },
        { lat: 51.801171875000044, lng: 98.64052734375005 },
        { lat: 51.717626953125006, lng: 98.3527343750001 },
        { lat: 51.674267578124955, lng: 98.303125 },
        { lat: 51.634570312500045, lng: 98.27685546875003 },
        { lat: 51.57841796874996, lng: 98.2375 },
        { lat: 51.50561523437505, lng: 98.21992187500004 },
        { lat: 51.485742187499994, lng: 98.18466796875006 },
        { lat: 51.483544921874994, lng: 98.103125 },
        { lat: 51.44995117187499, lng: 98.03759765625003 },
        { lat: 51.37705078124998, lng: 97.98916015625 },
        { lat: 51.34843750000002, lng: 97.94687500000012 },
        { lat: 51.28046875000001, lng: 97.9232421875 },
        { lat: 51.250732421875, lng: 97.92734375000012 },
        { lat: 51.21787109375006, lng: 97.91787109375 },
        { lat: 51.165185546874966, lng: 97.91083984375004 },
        { lat: 51.05166015625002, lng: 97.83574218750002 },
        { lat: 50.985253906249994, lng: 97.82529296875012 },
        { lat: 50.943359375, lng: 97.8561523437501 },
        { lat: 50.88715820312501, lng: 97.91982421875 },
        { lat: 50.85517578124998, lng: 97.953125 },
        { lat: 50.81767578124996, lng: 97.96416015625007 },
        { lat: 50.769140625000034, lng: 97.96191406249997 },
        { lat: 50.70205078125005, lng: 98.0011718750001 },
        { lat: 50.64462890624998, lng: 98.02978515625003 },
        { lat: 50.60380859375002, lng: 98.07890625000002 },
        { lat: 50.56855468750001, lng: 98.14501953124997 },
        { lat: 50.55717773437502, lng: 98.22050781250006 },
        { lat: 50.53325195312501, lng: 98.2794921875001 },
        { lat: 50.48696289062499, lng: 98.29267578125004 },
        { lat: 50.422998046875016, lng: 98.27734375000001 },
        { lat: 50.30244140624998, lng: 98.25029296875002 },
        { lat: 50.22768554687502, lng: 98.2 },
        { lat: 50.18056640625002, lng: 98.17011718750004 },
        { lat: 50.106591796874966, lng: 98.12197265625 },
        { lat: 50.077832031249955, lng: 98.10341796875004 },
        { lat: 50.01425781249998, lng: 98.00390625000003 },
        { lat: 49.996777343749976, lng: 97.93662109375006 },
        { lat: 49.94677734375, lng: 97.85390625 },
        { lat: 49.94453124999998, lng: 97.785546875 },
        { lat: 49.94462890625002, lng: 97.72070312499997 },
        { lat: 49.93359374999997, lng: 97.65097656250006 },
        { lat: 49.911474609375006, lng: 97.58935546875003 },
        { lat: 49.84311523437503, lng: 97.54082031250007 },
        { lat: 49.77304687500003, lng: 97.418359375 },
        { lat: 49.74145507812499, lng: 97.35976562500005 },
        { lat: 49.73081054687506, lng: 97.20859375000005 },
        { lat: 49.76171875000006, lng: 97.13691406250004 },
        { lat: 49.80502929687498, lng: 97.09765625000003 },
        { lat: 49.82988281249999, lng: 97.04912109375 },
        { lat: 49.88281250000003, lng: 96.98574218750005 },
        { lat: 49.91157226562501, lng: 96.71171875000002 },
        { lat: 49.89785156249999, lng: 96.6402343750001 },
        { lat: 49.87841796875003, lng: 96.59843750000002 },
        { lat: 49.892529296874955, lng: 96.54326171875007 },
        { lat: 49.91870117187506, lng: 96.50576171875005 },
        { lat: 49.91152343750002, lng: 96.46640625000012 },
        { lat: 49.89604492187496, lng: 96.38115234375007 },
        { lat: 49.90112304687503, lng: 96.31503906250012 },
        { lat: 49.954101562499964, lng: 96.22968750000003 },
        { lat: 49.98247070312499, lng: 96.11171875 },
        { lat: 49.998730468750004, lng: 96.06552734375006 },
        { lat: 49.99877929687503, lng: 96.01855468750003 },
        { lat: 49.973583984374955, lng: 95.98955078125006 },
        { lat: 49.960009765625045, lng: 95.9357421875001 },
        { lat: 49.990576171875034, lng: 95.89941406249997 },
        { lat: 50.012939453124964, lng: 95.851953125 },
        { lat: 50.0125, lng: 95.78935546875002 },
        { lat: 49.96601562500001, lng: 95.70781250000002 },
        { lat: 49.94384765625002, lng: 95.56718750000007 },
        { lat: 49.911230468750034, lng: 95.52265625000004 },
        { lat: 49.91552734375003, lng: 95.441796875 },
        { lat: 49.94121093750002, lng: 95.38564453125005 },
        { lat: 49.94414062499999, lng: 95.32949218750005 },
        { lat: 49.94384765625002, lng: 95.1662109375001 },
        { lat: 49.935449218749994, lng: 95.11142578125012 },
        { lat: 49.961572265624994, lng: 95.04433593750005 },
        { lat: 50.008251953125004, lng: 95.01289062500004 },
        { lat: 50.04375, lng: 94.93027343750006 },
        { lat: 50.04819335937506, lng: 94.8112304687501 },
        { lat: 50.04326171875002, lng: 94.71806640625002 },
        { lat: 50.02807617187506, lng: 94.67548828125004 },
        { lat: 50.02373046874996, lng: 94.61474609375003 },
        { lat: 50.08793945312499, lng: 94.56464843750004 },
        { lat: 50.13281249999997, lng: 94.496875 },
        { lat: 50.165722656250004, lng: 94.45849609374997 },
        { lat: 50.17963867187501, lng: 94.4001953125 },
        { lat: 50.221826171874994, lng: 94.35468750000004 },
        { lat: 50.30341796875001, lng: 94.346875 },
        { lat: 50.40488281249998, lng: 94.31933593749997 },
        { lat: 50.511376953124994, lng: 94.28701171875005 },
        { lat: 50.55639648437503, lng: 94.25107421875005 },
        { lat: 50.572851562500006, lng: 94.07578125000006 },
        { lat: 50.56884765625, lng: 93.98984375000006 },
        { lat: 50.57763671875, lng: 93.79541015624997 },
        { lat: 50.58369140624998, lng: 93.66201171875 },
        { lat: 50.585546875, lng: 93.6255859375001 },
        { lat: 50.59746093749996, lng: 93.50107421875006 },
        { lat: 50.60849609374998, lng: 93.38681640625006 },
        { lat: 50.615576171875006, lng: 93.27050781249997 },
        { lat: 50.606542968750034, lng: 93.22255859374998 },
        { lat: 50.60390625000002, lng: 93.103125 },
        { lat: 50.65454101562502, lng: 93.00986328125006 },
        { lat: 50.7125, lng: 92.97070312500003 },
        { lat: 50.74492187499999, lng: 92.96357421875004 },
        { lat: 50.77822265625002, lng: 92.94130859375005 },
        { lat: 50.78911132812502, lng: 92.85644531250003 },
        { lat: 50.778662109375006, lng: 92.77929687500003 },
        { lat: 50.710937499999964, lng: 92.738671875 },
        { lat: 50.683203125, lng: 92.68134765625004 },
        { lat: 50.68828124999999, lng: 92.6266601562501 },
        { lat: 50.725439453125006, lng: 92.57890625000002 },
        { lat: 50.765087890625004, lng: 92.48642578125012 },
        { lat: 50.803076171875, lng: 92.42636718750006 },
        { lat: 50.864160156250016, lng: 92.35478515625002 },
        { lat: 50.84980468750003, lng: 92.29580078125 },
        { lat: 50.81220703125001, lng: 92.27900390625004 },
        { lat: 50.77519531250002, lng: 92.2653320312501 },
        { lat: 50.700585937499994, lng: 92.19238281249997 },
        { lat: 50.691992187500034, lng: 92.10400390625003 },
        { lat: 50.697607421875034, lng: 91.95654296874997 },
        { lat: 50.693603515625, lng: 91.80429687500006 },
        { lat: 50.66552734374997, lng: 91.70634765625002 },
        { lat: 50.615136718749994, lng: 91.63417968750005 },
        { lat: 50.575537109375034, lng: 91.596875 },
        { lat: 50.56201171875003, lng: 91.52167968750003 },
        { lat: 50.522167968749976, lng: 91.4464843750001 },
        { lat: 50.46801757812506, lng: 91.41503906249997 },
        { lat: 50.470068359375034, lng: 91.34082031249997 },
        { lat: 50.46337890624999, lng: 91.30058593750002 },
        { lat: 50.45239257812497, lng: 91.2337890625 },
        { lat: 50.42260742187503, lng: 91.06279296875007 },
        { lat: 50.41547851562501, lng: 91.02158203125012 },
        { lat: 50.364160156250016, lng: 90.9171875000001 },
        { lat: 50.323730468749964, lng: 90.83808593750004 },
        { lat: 50.30595703124999, lng: 90.76074218749997 },
        { lat: 50.25942382812502, lng: 90.71435546874997 },
        { lat: 50.22236328125001, lng: 90.65507812500007 },
        { lat: 50.21333007812504, lng: 90.51689453125007 },
        { lat: 50.166894531249994, lng: 90.36484375000006 },
        { lat: 50.15117187499998, lng: 90.31132812500002 },
        { lat: 50.11669921874997, lng: 90.22451171875 },
        { lat: 50.10332031250002, lng: 90.1037109375001 },
        { lat: 50.09375, lng: 90.05371093750003 },
        { lat: 50.06928710937501, lng: 90.0049804687501 },
        { lat: 49.98432617187501, lng: 89.97734375000002 },
        { lat: 49.953515625000044, lng: 89.87802734375012 },
        { lat: 49.948095703125006, lng: 89.7442382812501 },
        { lat: 49.90302734374998, lng: 89.64384765625002 },
        { lat: 49.82329101562499, lng: 89.63427734375003 },
        { lat: 49.750488281249964, lng: 89.66953125000006 },
        { lat: 49.71748046875001, lng: 89.65410156250007 },
        { lat: 49.69970703125002, lng: 89.57919921875006 },
        { lat: 49.66054687500005, lng: 89.475 },
        { lat: 49.611523437500004, lng: 89.39560546875006 },
        { lat: 49.61113281250002, lng: 89.29921875000004 },
        { lat: 49.62705078125006, lng: 89.24394531250007 },
        { lat: 49.59570312499997, lng: 89.20292968750007 },
        { lat: 49.5322265625, lng: 89.17998046875 },
        { lat: 49.50136718750002, lng: 89.10947265625012 },
        { lat: 49.472802734374994, lng: 89.00839843750006 },
        { lat: 49.483740234375006, lng: 88.97060546875 },
        { lat: 49.50766601562498, lng: 88.94541015625012 },
        { lat: 49.539697265625016, lng: 88.9001953125 },
        { lat: 49.52763671874996, lng: 88.86386718750005 },
        { lat: 49.48154296874998, lng: 88.86035156249997 },
        { lat: 49.44843749999998, lng: 88.83164062500012 },
        { lat: 49.44624023437498, lng: 88.74785156250007 },
        { lat: 49.46455078124998, lng: 88.68271484375005 },
        { lat: 49.486132812500045, lng: 88.633203125 },
        { lat: 49.48256835937502, lng: 88.5443359375 },
        { lat: 49.47270507812496, lng: 88.45244140625002 },
        { lat: 49.48286132812498, lng: 88.39335937500007 },
        { lat: 49.47255859375002, lng: 88.33779296875005 },
        { lat: 49.451708984375045, lng: 88.19257812500004 },
        { lat: 49.381494140625016, lng: 88.13554687500002 },
        { lat: 49.2984375, lng: 88.13427734374997 },
        { lat: 49.25629882812501, lng: 88.11572265624997 },
        { lat: 49.219775390625045, lng: 88.0285156250001 },
        { lat: 49.186914062499994, lng: 87.98808593750002 },
        { lat: 49.164550781249964, lng: 87.9347656250001 },
        { lat: 49.16210937500003, lng: 87.81826171875005 },
        { lat: 49.16230468749995, lng: 87.8142578125 },
        { lat: 49.16582031249996, lng: 87.7625 },
        { lat: 49.147216796875, lng: 87.668359375 },
        { lat: 49.13237304687499, lng: 87.5765625 },
        { lat: 49.122412109375, lng: 87.5158203125001 },
        { lat: 49.09145507812502, lng: 87.47617187500006 },
        { lat: 49.07661132812501, lng: 87.41669921875004 },
        { lat: 49.085791015625, lng: 87.32285156250012 },
        { lat: 49.14765625000001, lng: 87.296875 },
        { lat: 49.216162109375, lng: 87.23369140625007 },
        { lat: 49.239794921875045, lng: 87.14804687500012 },
        { lat: 49.25458984375004, lng: 87.07060546875007 },
        { lat: 49.28730468750004, lng: 87.00097656249997 },
        { lat: 49.32207031250002, lng: 86.95292968750007 },
        { lat: 49.487890625000034, lng: 86.81210937500006 },
        { lat: 49.55859375000005, lng: 86.71435546874997 },
        { lat: 49.56269531250001, lng: 86.62646484374997 },
        { lat: 49.60971679687498, lng: 86.61425781249997 },
        { lat: 49.656689453124955, lng: 86.66533203125002 },
        { lat: 49.69555664062497, lng: 86.7306640625001 },
        { lat: 49.74868164062496, lng: 86.72871093750004 },
        { lat: 49.77729492187501, lng: 86.67548828125004 },
        { lat: 49.76914062500006, lng: 86.61015625000007 },
        { lat: 49.70776367187497, lng: 86.52226562500006 },
        { lat: 49.63847656249999, lng: 86.41796874999997 },
        { lat: 49.5875, lng: 86.29238281250004 },
        { lat: 49.54633789062495, lng: 86.24218749999997 },
        { lat: 49.49931640624996, lng: 86.1808593750001 },
        { lat: 49.50546874999998, lng: 86.09296875000004 },
        { lat: 49.50341796875, lng: 86.02958984375007 },
        { lat: 49.49931640624996, lng: 85.9744140625 },
        { lat: 49.55043945312499, lng: 85.93359374999997 },
        { lat: 49.556542968749994, lng: 85.88046875000006 },
        { lat: 49.605371093749994, lng: 85.49843750000005 },
        { lat: 49.62392578125005, lng: 85.37158203124996 },
        { lat: 49.599462890625034, lng: 85.29189453125 },
        { lat: 49.61582031249998, lng: 85.2326171875001 },
        { lat: 49.66484375000002, lng: 85.21015625000004 },
        { lat: 49.75073242187503, lng: 85.1365234375 },
        { lat: 49.821630859375006, lng: 85.07646484375007 },
        { lat: 49.894140625000034, lng: 85.00078125000002 },
        { lat: 49.95107421874999, lng: 84.97519531250012 },
        { lat: 50.01030273437499, lng: 84.99970703125004 },
        { lat: 50.061425781249994, lng: 84.9894531250001 },
        { lat: 50.087988281250006, lng: 84.9240234375001 },
        { lat: 50.09130859375005, lng: 84.83896484375006 },
        { lat: 50.20239257812503, lng: 84.60732421875005 },
        { lat: 50.21875, lng: 84.49902343750003 },
        { lat: 50.239160156249966, lng: 84.40097656250012 },
        { lat: 50.239160156249966, lng: 84.32324218749997 },
        { lat: 50.28823242187502, lng: 84.25781249999997 },
        { lat: 50.437451171874955, lng: 84.19453125000003 },
        { lat: 50.52055664062501, lng: 84.1759765625001 },
        { lat: 50.60473632812503, lng: 84.09931640625004 },
        { lat: 50.67685546875006, lng: 84.00234375 },
        { lat: 50.774658203125, lng: 83.94511718750007 },
        { lat: 50.81801757812505, lng: 83.859765625 },
        { lat: 50.88715820312501, lng: 83.71777343750003 },
        { lat: 50.935742187499955, lng: 83.58144531250005 },
        { lat: 50.99458007812503, lng: 83.35732421875005 },
        { lat: 50.99458007812503, lng: 83.27373046875006 },
        { lat: 50.98920898437501, lng: 83.16025390625012 },
        { lat: 50.96059570312505, lng: 83.09277343749997 },
        { lat: 50.89726562500002, lng: 83.0192382812501 },
        { lat: 50.89311523437496, lng: 82.91904296875006 },
        { lat: 50.89335937500001, lng: 82.76083984375012 },
        { lat: 50.86948242187503, lng: 82.71855468750002 },
        { lat: 50.82631835937505, lng: 82.69296875000012 },
        { lat: 50.77148437499997, lng: 82.61171875 },
        { lat: 50.72758789062498, lng: 82.49394531250007 },
        { lat: 50.74189453124998, lng: 82.32636718750003 },
        { lat: 50.71943359375003, lng: 82.21191406250003 },
        { lat: 50.710839843749966, lng: 82.098046875 },
        { lat: 50.766357421875, lng: 81.93369140625006 },
        { lat: 50.76440429687503, lng: 81.75205078125012 },
        { lat: 50.73911132812503, lng: 81.63388671875012 },
        { lat: 50.73984375, lng: 81.46591796875006 },
        { lat: 50.771142578124994, lng: 81.43144531250007 },
        { lat: 50.82368164062504, lng: 81.4515625 },
        { lat: 50.87104492187501, lng: 81.4376953125001 },
        { lat: 50.90976562499998, lng: 81.41015624999997 },
        { lat: 50.95649414062501, lng: 81.38828125000006 },
        { lat: 50.96640625, lng: 81.31914062500002 },
        { lat: 50.946289062499964, lng: 81.12460937500006 },
        { lat: 50.96875, lng: 81.0714843750001 },
        { lat: 51.01494140625001, lng: 81.0775390625 },
        { lat: 51.07236328124998, lng: 81.11240234375005 },
        { lat: 51.146582031250006, lng: 81.14101562500005 },
        { lat: 51.19106445312502, lng: 81.12724609375002 },
        { lat: 51.18569335937499, lng: 81.02675781250005 },
        { lat: 51.189794921875006, lng: 80.965625 },
        { lat: 51.24277343749998, lng: 80.93408203124997 },
        { lat: 51.28144531250004, lng: 80.87734375 },
        { lat: 51.28349609375002, lng: 80.81308593750012 },
        { lat: 51.293408203124976, lng: 80.73525390625 },
        { lat: 51.27734375, lng: 80.65048828125006 },
        { lat: 51.22421875, lng: 80.60546875000003 },
        { lat: 51.21660156249996, lng: 80.55068359375004 },
        { lat: 51.20175781250006, lng: 80.49101562500007 },
        { lat: 51.18334960937503, lng: 80.44804687500002 },
        { lat: 51.136376953124966, lng: 80.42148437500012 },
        { lat: 51.092626953125034, lng: 80.43359374999997 },
        { lat: 50.997607421875045, lng: 80.45224609375006 },
        { lat: 50.946289062499964, lng: 80.4236328125 },
        { lat: 50.919091796875016, lng: 80.34521484375003 },
        { lat: 50.92460937499999, lng: 80.27041015625005 },
        { lat: 50.91176757812505, lng: 80.22021484374997 },
        { lat: 50.85834960937498, lng: 80.12724609375002 },
        { lat: 50.83999023437499, lng: 80.08632812500004 },
        { lat: 50.80727539062499, lng: 80.07207031250007 },
        { lat: 50.75820312500002, lng: 80.06591796874997 },
        { lat: 50.774560546874966, lng: 79.98623046875 },
        { lat: 50.955468749999966, lng: 79.85966796875007 },
        { lat: 51.16000976562498, lng: 79.71640625000005 },
        { lat: 51.37797851562498, lng: 79.55429687500012 },
        { lat: 51.49311523437498, lng: 79.46884765625012 },
        { lat: 51.86811523437501, lng: 79.14873046875007 },
        { lat: 52.04741210937504, lng: 78.99208984375005 },
        { lat: 52.35703125000006, lng: 78.72148437500006 },
        { lat: 52.638427734375, lng: 78.47548828125005 },
        { lat: 52.9296875, lng: 78.19804687500002 },
        { lat: 53.09497070312503, lng: 78.03349609375007 },
        { lat: 53.269189453124994, lng: 77.85996093750006 },
        { lat: 53.317431640625045, lng: 77.79941406250006 },
        { lat: 53.379150390625, lng: 77.70439453125007 },
        { lat: 53.49877929687503, lng: 77.46923828124997 },
        { lat: 53.67011718749995, lng: 77.13242187500005 },
        { lat: 53.82265625000002, lng: 76.820703125 },
        { lat: 53.942529296875016, lng: 76.57568359374997 },
        { lat: 53.99321289062495, lng: 76.51308593750005 },
        { lat: 54.02255859374997, lng: 76.48476562500005 },
        { lat: 54.055273437500006, lng: 76.45859375000012 },
        { lat: 54.11352539062506, lng: 76.42207031250004 },
        { lat: 54.151513671874966, lng: 76.42167968750007 },
        { lat: 54.14526367187503, lng: 76.65458984375007 },
        { lat: 54.18247070312506, lng: 76.70302734375 },
        { lat: 54.321875, lng: 76.78896484375 },
        { lat: 54.44238281249999, lng: 76.8373046875 },
        { lat: 54.436865234375006, lng: 76.75937500000012 },
        { lat: 54.38710937499999, lng: 76.61552734375002 },
        { lat: 54.35107421875003, lng: 76.53916015625012 },
        { lat: 54.335693359375, lng: 76.496484375 },
        { lat: 54.31196289062498, lng: 76.26660156249997 },
        { lat: 54.25854492187503, lng: 76.14052734374998 },
        { lat: 54.16796875000003, lng: 75.88066406250007 },
        { lat: 54.114794921875045, lng: 75.69287109374996 },
        { lat: 54.10600585937501, lng: 75.6568359375 },
        { lat: 54.08964843749999, lng: 75.43720703125004 },
        { lat: 54.06850585937502, lng: 75.3981445312501 },
        { lat: 54.021728515625, lng: 75.39238281250007 },
        { lat: 53.970117187499966, lng: 75.37705078125005 },
        { lat: 53.89379882812506, lng: 75.22021484374997 },
        { lat: 53.82670898437496, lng: 75.0521484375 },
        { lat: 53.81923828125005, lng: 74.98896484375004 },
        { lat: 53.834033203125045, lng: 74.88681640625 },
        { lat: 53.82568359375003, lng: 74.83417968750004 },
        { lat: 53.754394531249964, lng: 74.68144531250007 },
        { lat: 53.64726562500002, lng: 74.45195312500007 },
        { lat: 53.60371093750001, lng: 74.43046875000002 },
        { lat: 53.550732421874955, lng: 74.42929687500006 },
        { lat: 53.504443359375045, lng: 74.40273437500005 },
        { lat: 53.487646484375006, lng: 74.35156250000001 },
        { lat: 53.52773437499999, lng: 74.27734375000003 },
        { lat: 53.57646484374996, lng: 74.20996093749997 },
        { lat: 53.61142578124997, lng: 74.06865234375002 },
        { lat: 53.61972656249998, lng: 73.85898437500006 },
        { lat: 53.602783203125, lng: 73.73115234375008 },
        { lat: 53.576269531250006, lng: 73.64296875 },
        { lat: 53.468896484374994, lng: 73.4699218750001 },
        { lat: 53.44755859374999, lng: 73.40693359375004 },
        { lat: 53.45439453124996, lng: 73.371875 },
        { lat: 53.506201171875034, lng: 73.3619140625 },
        { lat: 53.54316406250001, lng: 73.3268554687501 },
        { lat: 53.598388671875, lng: 73.28574218750006 },
        { lat: 53.707226562499955, lng: 73.30566406250003 },
        { lat: 53.81147460937498, lng: 73.39941406250003 },
        { lat: 53.868310546874994, lng: 73.55419921875003 },
        { lat: 53.92944335937503, lng: 73.67890625000004 },
        { lat: 53.996191406250034, lng: 73.71552734375004 },
        { lat: 54.04238281250002, lng: 73.71240234375001 },
        { lat: 54.06347656249997, lng: 73.66640625000005 },
        { lat: 54.06738281249997, lng: 73.61796875000007 },
        { lat: 54.04497070312502, lng: 73.58994140625 },
        { lat: 53.99931640624996, lng: 73.50566406250002 },
        { lat: 53.96284179687498, lng: 73.38066406250002 },
        { lat: 53.95561523437502, lng: 73.27656250000004 },
        { lat: 53.95781250000004, lng: 73.22988281250005 },
        { lat: 53.98076171874999, lng: 73.1193359375001 },
        { lat: 54.10732421875002, lng: 72.91406249999997 },
        { lat: 54.12451171874997, lng: 72.74101562500002 },
        { lat: 54.13432617187502, lng: 72.62226562500004 },
        { lat: 54.12158203125, lng: 72.5827148437501 },
        { lat: 54.09042968750006, lng: 72.56425781250007 },
        { lat: 54.05649414062498, lng: 72.57558593750005 },
        { lat: 54.023046875, lng: 72.59921875000005 },
        { lat: 53.99594726562498, lng: 72.58593750000003 },
        { lat: 53.975781249999955, lng: 72.53027343749997 },
        { lat: 53.94184570312498, lng: 72.44677734375001 },
        { lat: 53.96445312500006, lng: 72.40429687499997 },
        { lat: 54.05366210937501, lng: 72.3830078125001 },
        { lat: 54.12304687500003, lng: 72.38730468750006 },
        { lat: 54.18144531250002, lng: 72.3294921875 },
        { lat: 54.27211914062502, lng: 72.26914062500006 },
        { lat: 54.32563476562501, lng: 72.18603515625001 },
        { lat: 54.308447265625055, lng: 72.10537109375 },
        { lat: 54.231640624999955, lng: 72.065625 },
        { lat: 54.20566406249998, lng: 72.00449218750005 },
        { lat: 54.22148437500002, lng: 71.8874023437501 },
        { lat: 54.17802734375004, lng: 71.6771484375 },
        { lat: 54.15834960937502, lng: 71.33642578125003 },
        { lat: 54.21220703124998, lng: 71.09316406250005 },
        { lat: 54.26049804687497, lng: 71.05273437499997 },
        { lat: 54.36406250000002, lng: 71.15214843750007 },
        { lat: 54.45541992187498, lng: 71.159765625 },
        { lat: 54.53862304687496, lng: 71.15917968749997 },
        { lat: 54.59931640624998, lng: 71.18554687500003 },
        { lat: 54.71503906250001, lng: 71.12626953125002 },
        { lat: 54.95048828125001, lng: 70.99179687500005 },
        { lat: 55.127978515625045, lng: 70.91015624999997 },
        { lat: 55.26113281249999, lng: 70.79033203125006 },
        { lat: 55.30517578125, lng: 70.73808593750007 },
        { lat: 55.282373046874966, lng: 70.48632812500003 },
        { lat: 55.25317382812506, lng: 70.41718750000004 },
        { lat: 55.21225585937498, lng: 70.371484375 },
        { lat: 55.18359375, lng: 70.293359375 },
        { lat: 55.162451171875034, lng: 70.18242187500002 },
        { lat: 55.17675781250002, lng: 70.08740234375003 },
        { lat: 55.199072265625034, lng: 69.98173828125007 },
        { lat: 55.245654296875045, lng: 69.87021484375 },
        { lat: 55.30737304687499, lng: 69.74023437499997 },
        { lat: 55.356884765624955, lng: 69.49326171875006 },
        { lat: 55.37250976562504, lng: 69.24697265625004 },
        { lat: 55.389599609374955, lng: 68.9772460937501 },
        { lat: 55.358349609374976, lng: 68.8429687500001 },
        { lat: 55.30849609375005, lng: 68.71289062499997 },
        { lat: 55.20483398437497, lng: 68.5248046875 },
        { lat: 55.19443359374997, lng: 68.43847656250003 },
        { lat: 55.18652343749997, lng: 68.3019531250001 },
        { lat: 55.16093750000002, lng: 68.20625 },
        { lat: 55.11523437500003, lng: 68.2252929687501 },
        { lat: 55.05244140625001, lng: 68.24404296875 },
        { lat: 55.00302734374998, lng: 68.209375 },
        { lat: 54.97670898437505, lng: 68.15585937500006 },
        { lat: 54.959570312500006, lng: 68.07382812500006 },
        { lat: 54.95371093749998, lng: 67.93994140624997 },
        { lat: 54.94355468750004, lng: 67.82988281250002 },
        { lat: 54.87241210937503, lng: 67.69335937499997 },
        { lat: 54.8544921875, lng: 67.48466796875002 },
        { lat: 54.82880859375001, lng: 67.25732421874997 },
        { lat: 54.788183593750006, lng: 67.0983398437501 },
        { lat: 54.73789062500006, lng: 66.75449218750006 },
        { lat: 54.7154296875, lng: 66.55537109375004 },
        { lat: 54.667382812499994, lng: 66.22265624999997 },
        { lat: 54.659521484375006, lng: 65.9546875 },
        { lat: 54.69331054687504, lng: 65.9142578125001 },
        { lat: 54.61870117187502, lng: 65.70781250000007 },
        { lat: 54.623291015624964, lng: 65.476953125 },
        { lat: 54.59331054687502, lng: 65.434375 },
        { lat: 54.564453125, lng: 65.378125 },
        { lat: 54.55156250000002, lng: 65.31591796874997 },
        { lat: 54.51606445312498, lng: 65.23740234375006 },
        { lat: 54.44111328124998, lng: 65.19218750000007 },
        { lat: 54.364404296874994, lng: 65.1578125 },
        { lat: 54.340185546875034, lng: 65.08837890624997 },
        { lat: 54.36875, lng: 64.99541015625002 },
        { lat: 54.396630859374994, lng: 64.92675781250003 },
        { lat: 54.36855468750005, lng: 64.80927734375004 },
        { lat: 54.352246093750004, lng: 64.64990234374996 },
        { lat: 54.36215820312498, lng: 64.52509765625004 },
        { lat: 54.38417968750002, lng: 64.46123046875002 },
        { lat: 54.347412109375, lng: 64.19941406250004 },
        { lat: 54.302929687500004, lng: 64.06289062500005 },
        { lat: 54.27973632812498, lng: 64.03740234375002 },
        { lat: 54.267089843749964, lng: 64.00390625000003 },
        { lat: 54.23647460937505, lng: 63.847070312500044 },
        { lat: 54.24501953125002, lng: 63.721191406249964 },
        { lat: 54.24321289062498, lng: 63.70136718750004 },
        { lat: 54.22192382812502, lng: 63.58203124999997 },
        { lat: 54.18320312500003, lng: 63.413671875 },
        { lat: 54.17045898437501, lng: 63.292675781250104 },
        { lat: 54.17104492187505, lng: 63.19130859375005 },
        { lat: 54.13925781250006, lng: 63.12656250000006 },
        { lat: 54.10522460937506, lng: 63.0739257812501 },
        { lat: 54.069287109375004, lng: 62.63271484374999 },
        { lat: 54.04443359375, lng: 62.58828124999999 },
        { lat: 54.01318359375003, lng: 62.49902343750002 },
        { lat: 54.00263671875001, lng: 62.0402343750001 },
        { lat: 53.97993164062501, lng: 62.00234375 },
        { lat: 53.95439453124996, lng: 61.98564453125007 },
        { lat: 53.94648437500003, lng: 61.92871093750003 },
        { lat: 53.994921875000045, lng: 61.598144531249964 },
        { lat: 54.04926757812501, lng: 61.33369140625004 },
        { lat: 54.019482421874976, lng: 61.2310546875 },
        { lat: 53.96381835937501, lng: 61.14375 },
        { lat: 53.88247070312505, lng: 61.11318359375005 },
        { lat: 53.81298828125003, lng: 61.11318359375005 },
        { lat: 53.75346679687496, lng: 61.11318359375005 },
        { lat: 53.71044921875, lng: 61.07353515625008 },
        { lat: 53.65742187500004, lng: 60.9855468750001 },
        { lat: 53.621728515625044, lng: 60.979492187499964 },
        { lat: 53.58310546874998, lng: 61.09853515624999 },
        { lat: 53.550976562500004, lng: 61.24794921874999 },
        { lat: 53.565185546874964, lng: 61.3361328125001 },
        { lat: 53.587060546874994, lng: 61.40996093750002 },
        { lat: 53.58027343750004, lng: 61.474121093749964 },
        { lat: 53.55449218750002, lng: 61.51914062500006 },
        { lat: 53.52329101562506, lng: 61.53496093750001 },
        { lat: 53.50156249999998, lng: 61.5265625000001 },
        { lat: 53.48466796875002, lng: 61.49853515624997 },
        { lat: 53.45581054687499, lng: 61.40097656250006 },
        { lat: 53.465722656249966, lng: 61.31162109375006 },
        { lat: 53.445898437500006, lng: 61.22890624999999 },
        { lat: 53.406201171875004, lng: 61.18593750000005 },
        { lat: 53.33676757812498, lng: 61.16279296875004 },
        { lat: 53.28715820312501, lng: 61.199218749999964 },
        { lat: 53.27519531249995, lng: 61.3109375 },
        { lat: 53.239404296875044, lng: 61.436816406250074 },
        { lat: 53.22246093749996, lng: 61.576171874999964 },
        { lat: 53.22846679687504, lng: 61.65986328125003 },
        { lat: 53.173925781250034, lng: 61.766210937500055 },
        { lat: 53.10786132812498, lng: 62.01464843750003 },
        { lat: 53.05742187500001, lng: 62.08105468749997 },
        { lat: 53.00541992187498, lng: 62.08271484375003 },
        { lat: 52.96611328124996, lng: 62.037109374999964 },
        { lat: 52.94375, lng: 61.974218750000055 },
        { lat: 52.955908203125034, lng: 61.88857421874999 },
        { lat: 52.969384765625016, lng: 61.71933593750001 },
        { lat: 52.978515625, lng: 61.53359375 },
        { lat: 52.99599609375002, lng: 61.40078125000005 },
        { lat: 52.98906250000001, lng: 61.20693359375005 },
        { lat: 52.97246093750002, lng: 61.047460937500006 },
        { lat: 52.93334960937506, lng: 61.0065429687501 },
        { lat: 52.86015624999995, lng: 60.944726562499994 },
        { lat: 52.819433593750006, lng: 60.893261718750104 },
        { lat: 52.74472656249998, lng: 60.802343750000055 },
        { lat: 52.67578124999997, lng: 60.774414062499964 },
        { lat: 52.56982421874997, lng: 60.82128906250003 },
        { lat: 52.394775390625, lng: 60.979492187499964 },
        { lat: 52.33686523437504, lng: 60.994531250000044 },
        { lat: 52.28056640625002, lng: 60.937597656250006 },
        { lat: 52.2333984375, lng: 60.82841796875002 },
        { lat: 52.15083007812495, lng: 60.6703125 },
        { lat: 52.14633789062503, lng: 60.49931640625007 },
        { lat: 52.12558593750006, lng: 60.42548828125009 },
        { lat: 52.02451171874997, lng: 60.23369140625002 },
        { lat: 51.97646484374996, lng: 60.06552734375006 },
        { lat: 51.93325195312505, lng: 60.030273437499964 },
        { lat: 51.890625, lng: 60.067480468750006 },
        { lat: 51.83461914062502, lng: 60.28037109375001 },
        { lat: 51.77299804687498, lng: 60.3875 },
        { lat: 51.70390625000004, lng: 60.41835937499999 },
        { lat: 51.651171875000045, lng: 60.464746093749994 },
        { lat: 51.61694335937499, lng: 60.63037109375003 },
        { lat: 51.53706054687498, lng: 60.973535156250044 },
        { lat: 51.528710937499966, lng: 60.99335937500004 },
        { lat: 51.49238281250001, lng: 61.0148437500001 },
        { lat: 51.44189453125003, lng: 61.363085937500074 },
        { lat: 51.414746093750004, lng: 61.41132812500004 },
        { lat: 51.32460937500005, lng: 61.55468750000002 },
        { lat: 51.22968749999998, lng: 61.585058593750006 },
        { lat: 51.13701171875002, lng: 61.512207031249964 },
        { lat: 50.99023437500003, lng: 61.46503906250004 },
        { lat: 50.86103515625001, lng: 61.38945312500002 },
        { lat: 50.77480468750002, lng: 61.22685546875001 },
        { lat: 50.69550781250004, lng: 60.94228515625005 },
        { lat: 50.66372070312505, lng: 60.637988281250074 },
        { lat: 50.66918945312499, lng: 60.50849609375004 },
        { lat: 50.67915039062498, lng: 60.424804687499964 },
        { lat: 50.70415039062501, lng: 60.28808593750003 },
        { lat: 50.769775390624964, lng: 60.18671875000004 },
        { lat: 50.83417968749995, lng: 60.11210937500001 },
        { lat: 50.850292968749955, lng: 60.05859374999997 },
        { lat: 50.839697265625006, lng: 60.005273437500044 },
        { lat: 50.79926757812504, lng: 59.955175781250055 },
        { lat: 50.69018554687503, lng: 59.887792968750006 },
        { lat: 50.58203125, lng: 59.81240234375 },
        { lat: 50.543945312499964, lng: 59.75117187500004 },
        { lat: 50.492871093749955, lng: 59.523046875 },
        { lat: 50.511083984375034, lng: 59.49785156250002 },
        { lat: 50.58281249999999, lng: 59.52392578125002 },
        { lat: 50.60429687500002, lng: 59.49511718750003 },
        { lat: 50.62041015625002, lng: 59.45234375000009 },
        { lat: 50.64790039062501, lng: 59.17089843749997 },
        { lat: 50.66821289062497, lng: 59.064355468749994 },
        { lat: 50.676123046875006, lng: 58.98486328124997 },
        { lat: 50.694433593750006, lng: 58.88369140625005 },
        { lat: 50.737207031249994, lng: 58.8140625 },
        { lat: 50.868310546874994, lng: 58.66455078125003 },
        { lat: 50.971044921875034, lng: 58.547460937500055 },
        { lat: 51.063818359375034, lng: 58.35917968750007 },
        { lat: 51.08173828125004, lng: 58.18847656250002 },
        { lat: 51.07226562500006, lng: 58.17470703125005 },
        { lat: 51.06884765624997, lng: 58.04511718750009 },
        { lat: 51.091650390625, lng: 57.83886718750002 },
        { lat: 51.089013671874994, lng: 57.828906250000024 },
        { lat: 51.046875, lng: 57.76484375000004 },
        { lat: 50.98095703125003, lng: 57.71699218750005 },
        { lat: 50.925146484375006, lng: 57.65380859374997 },
        { lat: 50.89555664062502, lng: 57.55781250000003 },
        { lat: 50.88886718749998, lng: 57.44218750000001 },
        { lat: 50.94653320312503, lng: 57.3125 },
        { lat: 51.03603515625005, lng: 57.17900390625007 },
        { lat: 51.06518554687503, lng: 57.01171874999997 },
        { lat: 51.04555664062502, lng: 56.84960937499997 },
        { lat: 51.03159179687503, lng: 56.79033203125002 },
        { lat: 50.98085937499999, lng: 56.62021484375006 },
        { lat: 51.004492187500006, lng: 56.56689453124997 },
        { lat: 51.01953124999997, lng: 56.49140625000003 },
        { lat: 50.93608398437502, lng: 56.32558593749999 },
        { lat: 50.84462890625005, lng: 56.14394531250005 },
        { lat: 50.776269531249966, lng: 56.104492187499964 },
        { lat: 50.713525390624966, lng: 56.04970703124999 },
        { lat: 50.65375976562498, lng: 55.92919921874997 },
        { lat: 50.60205078125, lng: 55.79765625000002 },
        { lat: 50.582861328125, lng: 55.68623046875004 },
        { lat: 50.60180664062506, lng: 55.54228515625002 },
        { lat: 50.66528320312499, lng: 55.361132812500074 },
        { lat: 50.744726562500034, lng: 55.195214843749994 },
        { lat: 50.869775390625016, lng: 55.01484375000004 },
        { lat: 50.94135742187504, lng: 54.867968750000074 },
        { lat: 50.998095703125045, lng: 54.72714843750006 },
        { lat: 51.011572265625034, lng: 54.64160156250002 },
        { lat: 50.99023437500003, lng: 54.57294921875009 },
        { lat: 50.946044921875, lng: 54.54609375000004 },
        { lat: 50.91127929687502, lng: 54.565625 },
        { lat: 50.87988281250003, lng: 54.60625 },
        { lat: 50.78105468749996, lng: 54.6378906250001 },
        { lat: 50.66015625000002, lng: 54.65 },
        { lat: 50.59160156250002, lng: 54.63613281249999 },
        { lat: 50.55068359375002, lng: 54.59619140625003 },
        { lat: 50.535791015624994, lng: 54.555273437500006 },
        { lat: 50.54116210937502, lng: 54.51738281250002 },
        { lat: 50.58378906250002, lng: 54.47148437500002 },
        { lat: 50.673925781250006, lng: 54.44335937499997 },
        { lat: 50.78032226562499, lng: 54.42148437500006 },
        { lat: 50.91406249999997, lng: 54.29785156249997 },
        { lat: 50.995703125, lng: 54.1911132812501 },
        { lat: 51.04077148437503, lng: 54.13974609375 },
        { lat: 51.11518554687501, lng: 54.04150390624997 },
        { lat: 51.16118164062495, lng: 53.956835937500074 },
        { lat: 51.213720703125006, lng: 53.77646484375 },
        { lat: 51.25180664062503, lng: 53.688085937500006 },
        { lat: 51.39956054687502, lng: 53.53466796875003 },
        { lat: 51.444531249999955, lng: 53.448632812499994 },
        { lat: 51.48237304687504, lng: 53.33808593750004 },
        { lat: 51.49360351562501, lng: 53.2472656250001 },
        { lat: 51.484960937500034, lng: 53.22734375000002 },
        { lat: 51.463720703125034, lng: 53.03837890625007 },
        { lat: 51.466943359374994, lng: 52.902636718750074 },
        { lat: 51.49458007812503, lng: 52.8205078125001 },
        { lat: 51.497900390625, lng: 52.7350585937501 },
        { lat: 51.498144531250034, lng: 52.728125 },
        { lat: 51.47954101562499, lng: 52.63515624999999 },
        { lat: 51.48076171874996, lng: 52.617773437500006 },
        { lat: 51.481640624999955, lng: 52.57119140625005 },
        { lat: 51.512158203124955, lng: 52.496191406250006 },
        { lat: 51.59423828125, lng: 52.42304687500004 },
        { lat: 51.681298828124966, lng: 52.33105468749997 },
        { lat: 51.709375, lng: 52.21914062499999 },
        { lat: 51.67270507812498, lng: 52.00712890625002 },
        { lat: 51.55424804687502, lng: 51.77539062499997 },
        { lat: 51.483984375, lng: 51.60908203125003 },
        { lat: 51.482031250000034, lng: 51.47343750000002 },
        { lat: 51.47128906249997, lng: 51.39599609374997 },
        { lat: 51.47534179687503, lng: 51.344531250000074 },
        { lat: 51.49741210937497, lng: 51.30107421875002 },
        { lat: 51.540185546874994, lng: 51.29072265625004 },
        { lat: 51.59448242187503, lng: 51.26992187500005 },
        { lat: 51.6474609375, lng: 51.16347656250005 },
        { lat: 51.68164062500003, lng: 51.01787109375002 },
        { lat: 51.71918945312495, lng: 50.88242187500006 },
        { lat: 51.729199218749955, lng: 50.79394531249997 },
        { lat: 51.675146484375034, lng: 50.75615234375002 },
        { lat: 51.58916015625002, lng: 50.64394531250005 },
        { lat: 51.50561523437505, lng: 50.5163085937501 },
        { lat: 51.369726562500006, lng: 50.35371093750009 },
        { lat: 51.32158203125004, lng: 50.30927734375009 },
        { lat: 51.289501953124976, lng: 50.246875 },
        { lat: 51.25458984374998, lng: 50.104882812499994 },
        { lat: 51.19716796875002, lng: 49.93232421875003 },
        { lat: 51.131884765625045, lng: 49.82226562499997 },
        { lat: 51.10229492187506, lng: 49.66630859375002 },
        { lat: 51.08359375000006, lng: 49.49804687500003 },
        { lat: 51.027001953124994, lng: 49.424609375000074 },
        { lat: 50.934667968750006, lng: 49.379492187500006 },
        { lat: 50.851708984374966, lng: 49.32343750000003 },
        { lat: 50.72607421875006, lng: 49.05869140625006 },
        { lat: 50.64458007812496, lng: 48.9137695312501 },
        { lat: 50.60131835937502, lng: 48.80839843750002 },
        { lat: 50.606884765625004, lng: 48.734765625000044 },
        { lat: 50.61987304687499, lng: 48.65517578124999 },
        { lat: 50.61269531250005, lng: 48.625097656250006 },
        { lat: 50.55034179687504, lng: 48.66601562499997 },
        { lat: 50.35375976562506, lng: 48.700488281250074 },
        { lat: 50.228466796875004, lng: 48.749414062499994 },
        { lat: 50.156445312499976, lng: 48.784765625 },
        { lat: 50.099853515625, lng: 48.81796875 },
        { lat: 50.01313476562501, lng: 48.84326171875003 },
        { lat: 49.96240234374999, lng: 48.81025390625004 },
        { lat: 49.92832031250006, lng: 48.75898437500009 },
        { lat: 49.87470703124998, lng: 48.6 },
        { lat: 49.828515624999966, lng: 48.43427734375004 },
        { lat: 49.858251953125006, lng: 48.33496093750003 },
        { lat: 49.93193359374999, lng: 48.22480468750004 },
        { lat: 49.97001953125002, lng: 48.1813476562501 },
        { lat: 50.09360351562498, lng: 48.06074218750004 },
        { lat: 50.282324218750055, lng: 47.84960937500003 },
        { lat: 50.37797851562502, lng: 47.7057617187501 },
        { lat: 50.413574218749964, lng: 47.59960937499997 },
        { lat: 50.40273437499999, lng: 47.50361328125003 },
        { lat: 50.35795898437502, lng: 47.42919921874997 },
        { lat: 50.31811523437497, lng: 47.37636718750005 },
        { lat: 50.273535156250034, lng: 47.32646484375002 },
        { lat: 50.21748046874998, lng: 47.29472656250002 },
        { lat: 50.14023437499998, lng: 47.29765625000002 },
        { lat: 50.05849609375002, lng: 47.29521484375002 },
        { lat: 50.00087890625002, lng: 47.24833984375002 },
        { lat: 49.939062500000034, lng: 47.12958984375004 },
        { lat: 49.85273437500004, lng: 46.99199218750002 },
        { lat: 49.69697265625001, lng: 46.889550781249994 },
        { lat: 49.502246093750045, lng: 46.82314453125005 },
        { lat: 49.367089843750016, lng: 46.80205078125002 },
        { lat: 49.30385742187502, lng: 46.852929687499994 },
        { lat: 49.25258789062496, lng: 46.95341796875002 },
        { lat: 49.19990234374998, lng: 47.018164062500006 },
        { lat: 49.150292968749994, lng: 47.031347656250006 },
        { lat: 49.098339843749976, lng: 47.014257812500006 },
        { lat: 49.03833007812502, lng: 46.962207031250074 },
        { lat: 48.96962890624996, lng: 46.852929687499994 },
        { lat: 48.80556640625002, lng: 46.70263671875003 },
        { lat: 48.573876953124994, lng: 46.609179687500074 },
        { lat: 48.41225585937502, lng: 46.660937500000074 },
        { lat: 48.32358398437498, lng: 46.853125 },
        { lat: 48.28447265625002, lng: 47.00429687499999 },
        { lat: 48.23247070312499, lng: 47.06464843750003 },
        { lat: 48.12700195312498, lng: 47.11904296875005 },
        { lat: 48.02011718749998, lng: 47.1115234375001 },
        { lat: 47.947705078124955, lng: 47.09326171875003 },
        { lat: 47.87675781249999, lng: 47.13076171875005 },
        { lat: 47.79248046875006, lng: 47.202050781249994 },
        { lat: 47.74091796875004, lng: 47.292382812499994 },
        { lat: 47.768652343750006, lng: 47.38730468750006 },
        { lat: 47.80390624999998, lng: 47.48193359374997 },
        { lat: 47.78999023437498, lng: 47.600195312500006 },
        { lat: 47.76069335937498, lng: 47.934667968750006 },
        { lat: 47.74541015624996, lng: 48.109960937500006 },
        { lat: 47.70878906249996, lng: 48.16699218750003 },
        { lat: 47.589941406250006, lng: 48.27568359375002 },
        { lat: 47.45649414062498, lng: 48.41308593749997 },
        { lat: 47.320996093750004, lng: 48.55253906250002 },
        { lat: 47.262304687500034, lng: 48.600683593750006 },
        { lat: 47.100488281250016, lng: 48.71435546874997 },
        { lat: 46.954931640625034, lng: 48.83183593750001 },
        { lat: 46.77460937499998, lng: 48.959375 },
        { lat: 46.72578124999998, lng: 48.950292968750006 },
        { lat: 46.705419921875, lng: 48.88359375000007 },
        { lat: 46.71035156250005, lng: 48.77636718749997 },
        { lat: 46.73681640625, lng: 48.6935546875001 },
        { lat: 46.758691406250016, lng: 48.647070312500006 },
        { lat: 46.76591796874998, lng: 48.60527343750001 },
        { lat: 46.75712890624999, lng: 48.55839843750007 },
        { lat: 46.73432617187504, lng: 48.51855468749997 },
        { lat: 46.698632812500044, lng: 48.50234375000005 },
        { lat: 46.64995117187499, lng: 48.509179687499994 },
        { lat: 46.60561523437502, lng: 48.54121093750004 },
        { lat: 46.57709960937498, lng: 48.586035156250006 },
        { lat: 46.56645507812504, lng: 48.61015625000007 },
        { lat: 46.50795898437502, lng: 48.774316406249994 },
        { lat: 46.44213867187503, lng: 48.95898437499997 },
        { lat: 46.34882812500001, lng: 49.18427734375003 },
        { lat: 46.33715820312503, lng: 49.232226562500074 },
        { lat: 46.291601562500006, lng: 49.245898437500074 },
        { lat: 46.28173828125003, lng: 49.12548828124997 },
        { lat: 46.22846679687501, lng: 49.110644531250074 },
        { lat: 46.18920898437499, lng: 49.07958984375002 },
        { lat: 46.10048828125005, lng: 48.809960937499994 },
        { lat: 46.10073242187502, lng: 48.74257812500005 },
        { lat: 46.08618164062497, lng: 48.683691406250006 },
        { lat: 46.02875976562501, lng: 48.687304687500074 },
        { lat: 45.97622070312505, lng: 48.703417968750074 },
        { lat: 45.920556640624994, lng: 48.749609375000055 },
        { lat: 45.896826171875034, lng: 48.72958984375006 },
        { lat: 45.88886718750001, lng: 48.6896484375001 },
        { lat: 45.90576171875, lng: 48.6374023437501 },
        { lat: 45.93486328124996, lng: 48.58906250000004 },
        { lat: 45.94213867187503, lng: 48.53730468750004 },
        { lat: 45.93486328124996, lng: 48.48701171875009 },
        { lat: 45.77778320312504, lng: 48.25761718750002 },
        { lat: 45.73701171874998, lng: 48.15917968750003 },
        { lat: 45.72099609375002, lng: 48.052832031250006 },
        { lat: 45.66303710937501, lng: 47.83017578125006 },
        { lat: 45.66596679687498, lng: 47.763964843750074 },
        { lat: 45.686181640625016, lng: 47.70107421875005 },
        { lat: 45.65673828124997, lng: 47.649804687499994 },
        { lat: 45.58403320312499, lng: 47.63330078124997 },
        { lat: 45.63427734375003, lng: 47.57402343750002 },
        { lat: 45.67416992187506, lng: 47.50839843750006 },
        { lat: 45.687597656250034, lng: 47.47939453124999 },
        { lat: 45.67968750000003, lng: 47.46328125 },
        { lat: 45.60170898437505, lng: 47.524218750000074 },
        { lat: 45.530224609374955, lng: 47.5294921875001 },
        { lat: 45.49091796875004, lng: 47.51455078125005 },
        { lat: 45.455078125, lng: 47.48867187499999 },
        { lat: 45.433056640624955, lng: 47.454492187499994 },
        { lat: 45.42104492187499, lng: 47.41308593749997 },
        { lat: 45.29477539062503, lng: 47.39111328124997 },
        { lat: 45.217724609374976, lng: 47.3512695312501 },
        { lat: 45.14946289062502, lng: 47.296191406250074 },
        { lat: 45.024267578125006, lng: 47.22148437500002 },
        { lat: 44.969628906249966, lng: 47.161523437499994 },
        { lat: 44.905957031249955, lng: 47.11474609374997 },
        { lat: 44.816992187500034, lng: 47.083789062500074 },
        { lat: 44.83789062500003, lng: 47.03925781250003 },
        { lat: 44.87607421875, lng: 47.00292968750002 },
        { lat: 44.82558593750002, lng: 46.983691406250074 },
        { lat: 44.78256835937506, lng: 46.95742187500005 },
        { lat: 44.71826171875, lng: 46.841210937499994 },
        { lat: 44.656542968750045, lng: 46.755273437499994 },
        { lat: 44.560693359374966, lng: 46.71611328125002 },
        { lat: 44.503320312499994, lng: 46.7072265625001 },
        { lat: 44.45166015625006, lng: 46.7208984375001 },
        { lat: 44.42065429687503, lng: 46.753027343750006 },
        { lat: 44.387158203124955, lng: 46.9157226562501 },
        { lat: 44.34326171875, lng: 47.02363281250004 },
        { lat: 44.26166992187498, lng: 47.12265625000006 },
        { lat: 44.19238281249997, lng: 47.22988281250005 },
        { lat: 44.103125, lng: 47.30703125000005 },
        { lat: 43.99335937500004, lng: 47.36152343750004 },
        { lat: 43.77988281250006, lng: 47.42919921874997 },
        { lat: 43.55502929687498, lng: 47.462792968749994 },
        { lat: 43.83466796875004, lng: 47.562597656250055 },
        { lat: 43.88461914062498, lng: 47.64648437500003 },
        { lat: 43.805957031250045, lng: 47.62783203125005 },
        { lat: 43.684960937499994, lng: 47.56796875 },
        { lat: 43.50971679687498, lng: 47.5089843750001 },
        { lat: 43.381689453125034, lng: 47.48984375 },
        { lat: 43.27075195312497, lng: 47.511621093749994 },
        { lat: 43.21875, lng: 47.5128906250001 },
        { lat: 43.03505859375002, lng: 47.463183593750074 },
        { lat: 42.99975585937503, lng: 47.48886718750006 },
        { lat: 42.967138671875034, lng: 47.52900390625003 },
        { lat: 42.90346679687502, lng: 47.634863281250055 },
        { lat: 42.81093750000002, lng: 47.70908203125006 },
        { lat: 42.680712890625045, lng: 47.72773437500003 },
        { lat: 42.644775390625, lng: 47.7697265625001 },
        { lat: 42.61347656250001, lng: 47.82236328125006 },
        { lat: 42.35371093750004, lng: 48.080175781250006 },
        { lat: 42.18095703125002, lng: 48.22861328125006 },
        { lat: 42.080224609374994, lng: 48.30302734375002 },
        { lat: 41.95341796875002, lng: 48.38378906250003 },
        { lat: 41.923974609374966, lng: 48.426367187500006 },
        { lat: 41.905126953125034, lng: 48.47675781250004 },
        { lat: 41.84448242187503, lng: 48.572851562500006 },
        { lat: 41.77934570312499, lng: 48.51865234375006 },
        { lat: 41.66333007812497, lng: 48.43066406249997 },
        { lat: 41.60190429687498, lng: 48.39140625000007 },
        { lat: 41.545019531250034, lng: 48.29814453125002 },
        { lat: 41.48476562500002, lng: 48.14228515625004 },
        { lat: 41.45869140625004, lng: 48.05605468750005 },
        { lat: 41.33398437500003, lng: 47.96367187500007 },
        { lat: 41.212744140625034, lng: 47.86113281250007 },
        { lat: 41.19926757812502, lng: 47.79101562499997 },
        { lat: 41.21811523437506, lng: 47.59179687499997 },
        { lat: 41.22905273437496, lng: 47.52060546875006 },
        { lat: 41.28242187500001, lng: 47.31767578125002 },
        { lat: 41.315087890624994, lng: 47.26113281250005 },
        { lat: 41.45561523437501, lng: 47.2052734375001 },
        { lat: 41.51606445312501, lng: 47.14257812500003 },
        { lat: 41.55468750000006, lng: 47.06396484375003 },
        { lat: 41.5875, lng: 47.01015625000005 },
        { lat: 41.62138671874996, lng: 46.98779296875003 },
        { lat: 41.67041015625, lng: 46.93085937500004 },
        { lat: 41.74340820312503, lng: 46.82558593750005 },
        { lat: 41.812597656250006, lng: 46.74931640625002 },
        { lat: 41.83134765625002, lng: 46.690332031249994 },
        { lat: 41.80693359375001, lng: 46.616015625000074 },
        { lat: 41.800097656250045, lng: 46.571289062499964 },
        { lat: 41.812304687500045, lng: 46.552148437499994 },
        { lat: 41.87041015624999, lng: 46.5376953125 },
        { lat: 41.890966796875006, lng: 46.42988281250004 },
        { lat: 41.904638671875034, lng: 46.41152343750005 },
        { lat: 41.960351562499994, lng: 46.2677734375001 },
        { lat: 41.989892578124994, lng: 46.21269531250002 },
        { lat: 41.99204101562498, lng: 46.159765625 },
        { lat: 42.00874023437501, lng: 46.04843750000006 },
        { lat: 42.03540039062503, lng: 45.954003906249994 },
        { lat: 42.07070312500002, lng: 45.91035156250009 },
        { lat: 42.109960937500034, lng: 45.84599609375002 },
        { lat: 42.15888671874995, lng: 45.72656250000003 },
        { lat: 42.20507812500003, lng: 45.63857421875005 },
        { lat: 42.234716796875034, lng: 45.63427734374997 },
        { lat: 42.35737304687498, lng: 45.688378906249994 },
        { lat: 42.47504882812498, lng: 45.72753906249997 },
        { lat: 42.49809570312496, lng: 45.70527343750004 },
        { lat: 42.51767578125003, lng: 45.655566406250074 },
        { lat: 42.53574218749998, lng: 45.56289062499999 },
        { lat: 42.52978515625003, lng: 45.34375 },
        { lat: 42.64824218749999, lng: 45.20820312500004 },
        { lat: 42.675, lng: 45.16025390625006 },
        { lat: 42.69414062500002, lng: 45.07158203125002 },
        { lat: 42.73027343750002, lng: 44.94335937499997 },
        { lat: 42.75639648437499, lng: 44.870996093749994 },
        { lat: 42.74682617187499, lng: 44.850488281249994 },
        { lat: 42.61679687499998, lng: 44.77109375000006 },
        { lat: 42.709619140624966, lng: 44.69179687499999 },
        { lat: 42.73471679687503, lng: 44.64433593750002 },
        { lat: 42.748486328124976, lng: 44.57646484375002 },
        { lat: 42.7486328125, lng: 44.50585937500002 },
        { lat: 42.703515624999966, lng: 44.32949218749999 },
        { lat: 42.65361328125002, lng: 44.19970703125002 },
        { lat: 42.616357421874994, lng: 44.10273437500004 },
        { lat: 42.59560546875002, lng: 44.004687500000074 },
        { lat: 42.56655273437505, lng: 43.957421875000044 },
        { lat: 42.571533203125, lng: 43.825976562500074 },
        { lat: 42.593847656250006, lng: 43.75986328125 },
        { lat: 42.61699218750002, lng: 43.73837890625 },
        { lat: 42.65751953125002, lng: 43.749902343750044 },
        { lat: 42.702978515625034, lng: 43.79541015624997 },
        { lat: 42.72778320312503, lng: 43.79873046875005 },
        { lat: 42.747021484374955, lng: 43.78261718750005 },
        { lat: 42.80771484374998, lng: 43.62304687500003 },
        { lat: 42.844482421875, lng: 43.55781250000009 },
        { lat: 42.89667968749998, lng: 43.34794921875002 },
        { lat: 42.9890625, lng: 43.089160156250074 },
        { lat: 43.04965820312506, lng: 43.00019531250004 },
        { lat: 43.09150390624998, lng: 42.991601562499994 },
        { lat: 43.13261718749998, lng: 42.890039062499994 },
        { lat: 43.169580078124966, lng: 42.76064453125005 },
        { lat: 43.159082031249966, lng: 42.660253906250006 },
        { lat: 43.15512695312506, lng: 42.566015625 },
        { lat: 43.22421875, lng: 42.41904296875006 },
        { lat: 43.22807617187498, lng: 42.2796875 },
        { lat: 43.20732421875002, lng: 42.1222656250001 },
        { lat: 43.19912109375005, lng: 42.087792968749994 },
        { lat: 43.19013671874998, lng: 42.05 },
        { lat: 43.21923828124997, lng: 41.58056640624997 },
        { lat: 43.276318359374955, lng: 41.460742187500074 },
        { lat: 43.33339843750005, lng: 41.35820312500002 },
        { lat: 43.37446289062498, lng: 41.083105468750055 },
        { lat: 43.41806640624998, lng: 40.94199218750006 },
        { lat: 43.479931640624955, lng: 40.801660156249994 },
        { lat: 43.53388671875004, lng: 40.64804687500006 },
        { lat: 43.51201171875002, lng: 40.518945312500044 },
        { lat: 43.54272460937497, lng: 40.34228515625002 },
        { lat: 43.56977539062498, lng: 40.15019531250007 },
        { lat: 43.553125, lng: 40.084570312500006 },
        { lat: 43.48486328125, lng: 40.02373046875001 },
        { lat: 43.419824218749966, lng: 39.97832031250002 },
        { lat: 43.472802734375016, lng: 39.873632812500006 },
        { lat: 43.727880859375034, lng: 39.51669921875006 },
        { lat: 43.89726562499999, lng: 39.329394531250074 },
        { lat: 44.28808593750003, lng: 38.71728515624997 },
        { lat: 44.318017578124994, lng: 38.635839843750006 },
        { lat: 44.374462890624955, lng: 38.311816406250074 },
        { lat: 44.41967773437503, lng: 38.18125 },
        { lat: 44.698828125000034, lng: 37.851464843749994 },
        { lat: 44.66137695312506, lng: 37.704882812500074 },
        { lat: 44.67084960937503, lng: 37.5724609375001 },
        { lat: 44.69526367187504, lng: 37.49511718750003 },
        { lat: 44.73535156250003, lng: 37.41132812500004 },
        { lat: 44.78837890624999, lng: 37.352343750000074 },
        { lat: 44.90502929687503, lng: 37.28408203125005 },
        { lat: 44.97197265624999, lng: 37.20478515625003 },
        { lat: 45.069580078125, lng: 36.944433593750006 },
        { lat: 45.12646484375003, lng: 36.65078125 },
        { lat: 45.15131835937504, lng: 36.62763671875004 },
        { lat: 45.18549804687498, lng: 36.61914062500002 },
        { lat: 45.25175781249999, lng: 36.87304687499997 },
        { lat: 45.289697265624994, lng: 36.941210937500074 },
        { lat: 45.34003906250001, lng: 36.81103515625003 },
        { lat: 45.34833984375004, lng: 36.761621093749994 },
        { lat: 45.371875, lng: 36.72041015625004 },
        { lat: 45.40971679687502, lng: 36.79375 },
        { lat: 45.42705078124999, lng: 36.8659179687501 },
        { lat: 45.38359375000002, lng: 36.977832031250074 },
        { lat: 45.302880859374994, lng: 37.10351562500003 },
        { lat: 45.272314453125006, lng: 37.21357421875004 },
        { lat: 45.31093750000005, lng: 37.264257812500006 },
        { lat: 45.37719726562506, lng: 37.6471679687501 },
        { lat: 45.42973632812499, lng: 37.672949218750006 },
        { lat: 45.488378906250034, lng: 37.671875 },
        { lat: 45.48632812499997, lng: 37.634375 },
        { lat: 45.49951171875, lng: 37.609960937500006 },
        { lat: 45.56469726562506, lng: 37.61240234375006 },
        { lat: 45.65405273437506, lng: 37.669238281250074 },
        { lat: 45.79956054687503, lng: 37.840917968750055 },
        { lat: 46.001708984375, lng: 37.93310546875003 },
        { lat: 46.047753906249966, lng: 38.014257812500006 },
        { lat: 46.01708984375002, lng: 38.073828125 },
        { lat: 45.969873046874994, lng: 38.06972656250005 },
        { lat: 45.93481445312506, lng: 38.07958984375002 },
        { lat: 46.00283203125005, lng: 38.13281250000002 },
        { lat: 46.09482421875006, lng: 38.18359374999997 },
        { lat: 46.095361328124994, lng: 38.311816406250074 },
        { lat: 46.08002929687495, lng: 38.40039062499997 },
        { lat: 46.09052734374998, lng: 38.49228515625006 },
        { lat: 46.241943359375, lng: 38.31523437500007 },
        { lat: 46.39433593749996, lng: 38.07773437500006 },
        { lat: 46.38286132812502, lng: 37.97753906249997 },
        { lat: 46.40649414062503, lng: 37.913867187500074 },
        { lat: 46.532080078125034, lng: 37.80957031249997 },
        { lat: 46.63613281250002, lng: 37.76650390624999 },
        { lat: 46.63378906249997, lng: 37.86738281250004 },
        { lat: 46.618017578125055, lng: 37.96796875000009 },
        { lat: 46.69067382812503, lng: 38.15947265625002 },
        { lat: 46.70126953125006, lng: 38.22998046875003 },
        { lat: 46.678320312500006, lng: 38.34345703125004 },
        { lat: 46.663671875000034, lng: 38.50097656249997 },
        { lat: 46.73217773437506, lng: 38.48798828125009 },
        { lat: 46.813085937500006, lng: 38.43867187500003 },
        { lat: 46.87304687500005, lng: 38.630761718750044 },
        { lat: 46.906152343750044, lng: 38.80107421875002 },
        { lat: 47.02343750000006, lng: 39.12675781250002 },
        { lat: 47.04414062500001, lng: 39.2707031250001 },
        { lat: 47.070898437500034, lng: 39.28906250000003 },
        { lat: 47.105761718750045, lng: 39.29345703125003 },
        { lat: 47.199511718750045, lng: 39.24453125 },
        { lat: 47.268847656250045, lng: 39.19570312499999 },
        { lat: 47.27221679687503, lng: 39.023730468750074 },
        { lat: 47.17568359374999, lng: 38.928320312500006 },
        { lat: 47.143945312499994, lng: 38.6681640625001 },
        { lat: 47.15034179687498, lng: 38.55244140625004 },
        { lat: 47.21220703124996, lng: 38.64433593750001 },
        { lat: 47.235839843749964, lng: 38.73603515625009 },
        { lat: 47.261621093749994, lng: 38.7619140625001 },
        { lat: 47.239111328125034, lng: 38.57724609375006 },
        { lat: 47.17553710937502, lng: 38.48476562500005 },
        { lat: 47.091455078124966, lng: 38.21435546875003 },
        { lat: 47.13559570312498, lng: 38.205859375000074 },
        { lat: 47.17524414062498, lng: 38.20136718750004 },
        { lat: 47.21274414062498, lng: 38.22119140624997 },
        { lat: 47.23696289062502, lng: 38.26533203125009 },
        { lat: 47.259033203125, lng: 38.28076171874997 },
        { lat: 47.276660156250045, lng: 38.28076171874997 },
        { lat: 47.28769531249998, lng: 38.24101562500002 },
        { lat: 47.29653320312499, lng: 38.20800781249997 },
        { lat: 47.32080078124997, lng: 38.20136718750004 },
        { lat: 47.34277343749999, lng: 38.21240234374997 },
        { lat: 47.373681640624994, lng: 38.243261718750055 },
        { lat: 47.40893554687497, lng: 38.2565429687501 },
        { lat: 47.47954101562499, lng: 38.25878906250003 },
        { lat: 47.559179687500034, lng: 38.28740234375007 },
        { lat: 47.609960937500006, lng: 38.36884765625004 },
        { lat: 47.622412109375034, lng: 38.51093750000003 },
        { lat: 47.66591796875002, lng: 38.640625 },
        { lat: 47.71411132812497, lng: 38.71894531250004 },
        { lat: 47.83701171874998, lng: 38.82226562499997 },
        { lat: 47.85512695312502, lng: 38.90029296875005 },
        { lat: 47.848486328125006, lng: 39.0578125000001 },
        { lat: 47.83740234375005, lng: 39.158496093750074 },
        { lat: 47.83374023437502, lng: 39.39101562499999 },
        { lat: 47.84121093750002, lng: 39.658496093750074 },
        { lat: 47.844824218750055, lng: 39.7359375 },
        { lat: 47.88754882812506, lng: 39.778710937500044 },
        { lat: 47.964453125, lng: 39.77578125 },
        { lat: 48.03530273437505, lng: 39.81396484375003 },
        { lat: 48.168359374999966, lng: 39.88505859375002 },
        { lat: 48.23793945312502, lng: 39.96103515625006 },
        { lat: 48.26889648437503, lng: 39.95791015625005 },
        { lat: 48.28193359375001, lng: 39.91816406250003 },
        { lat: 48.288427734375, lng: 39.866308593750006 },
        { lat: 48.30278320312502, lng: 39.84746093750002 },
        { lat: 48.331933593749994, lng: 39.849902343750074 },
        { lat: 48.360449218750034, lng: 39.88984375000004 },
        { lat: 48.41909179687499, lng: 39.882617187500074 },
        { lat: 48.484228515625034, lng: 39.857519531250006 },
        { lat: 48.54277343749996, lng: 39.8356445312501 },
        { lat: 48.571875, lng: 39.76542968750002 },
        { lat: 48.59121093749996, lng: 39.64472656250009 },
        { lat: 48.662451171875006, lng: 39.67041015625002 },
        { lat: 48.739355468750034, lng: 39.70458984375002 },
        { lat: 48.782080078125034, lng: 39.75585937500003 },
        { lat: 48.807714843750034, lng: 39.792871093749994 },
        { lat: 48.79375, lng: 39.90410156250002 },
        { lat: 48.80737304687505, lng: 39.98447265625006 },
        { lat: 48.82207031250002, lng: 40.00361328125004 },
        { lat: 48.851416015625034, lng: 39.989160156249994 },
        { lat: 48.877978515625045, lng: 39.86376953124997 },
        { lat: 48.91445312500002, lng: 39.753320312499994 },
        { lat: 48.95957031250006, lng: 39.705664062500006 },
        { lat: 49.007910156250034, lng: 39.68652343749997 },
        { lat: 49.03657226562501, lng: 39.75947265625004 },
        { lat: 49.064062500000034, lng: 39.889746093750006 },
        { lat: 49.12983398437501, lng: 39.976367187500074 },
        { lat: 49.20029296874998, lng: 40.07001953125003 },
        { lat: 49.25156250000003, lng: 40.10878906250005 },
        { lat: 49.307226562500006, lng: 40.12832031250005 },
        { lat: 49.36884765625004, lng: 40.12617187500004 },
        { lat: 49.431542968750016, lng: 40.05781250000004 },
        { lat: 49.49707031250006, lng: 40.05781250000004 },
        { lat: 49.54267578125001, lng: 40.09492187500004 },
        { lat: 49.576855468749955, lng: 40.080664062500006 },
        { lat: 49.59672851562501, lng: 40.03066406250005 },
        { lat: 49.59077148437504, lng: 39.95849609374997 },
        { lat: 49.56767578125004, lng: 39.87685546875005 },
        { lat: 49.57202148437503, lng: 39.780566406250074 },
        { lat: 49.65068359374999, lng: 39.626562500000055 },
        { lat: 49.72802734375003, lng: 39.462792968749994 },
        { lat: 49.73066406250004, lng: 39.36845703125002 },
        { lat: 49.74204101562503, lng: 39.3029296875001 },
        { lat: 49.78193359374998, lng: 39.24599609375005 },
        { lat: 49.833203124999955, lng: 39.21181640624999 },
        { lat: 49.85595703124997, lng: 39.17480468750003 },
        { lat: 49.84174804687501, lng: 39.1149414062501 },
        { lat: 49.81840820312495, lng: 39.02773437499999 },
        { lat: 49.82470703125, lng: 38.91835937499999 },
        { lat: 49.88432617187499, lng: 38.77666015625002 },
        { lat: 49.95288085937499, lng: 38.64775390625002 },
        { lat: 49.95458984375, lng: 38.55195312500004 },
        { lat: 49.964062499999976, lng: 38.45117187500003 },
        { lat: 50.05234375, lng: 38.258593750000074 },
        { lat: 50.05146484375001, lng: 38.2086914062501 },
        { lat: 50.02539062500003, lng: 38.177539062500074 },
        { lat: 49.954541015624976, lng: 38.16269531250006 },
        { lat: 49.93940429687501, lng: 38.14677734375002 },
        { lat: 49.927832031250055, lng: 38.1125 },
        { lat: 49.92001953125006, lng: 38.046875 },
        { lat: 49.964208984375006, lng: 37.95029296875006 },
        { lat: 50.10908203125004, lng: 37.704199218750006 },
        { lat: 50.214941406250006, lng: 37.60507812500006 },
        { lat: 50.291845703125034, lng: 37.58232421875002 },
        { lat: 50.340722656249966, lng: 37.501367187499994 },
        { lat: 50.411474609375006, lng: 37.422851562499964 },
        { lat: 50.417626953124994, lng: 37.343164062499994 },
        { lat: 50.39497070312501, lng: 37.25488281250003 },
        { lat: 50.36088867187499, lng: 37.1710937500001 },
        { lat: 50.35151367187504, lng: 37.13125 },
        { lat: 50.33955078124998, lng: 36.98847656250003 },
        { lat: 50.291845703125034, lng: 36.75908203125002 },
        { lat: 50.246240234374994, lng: 36.696386718750006 },
        { lat: 50.209228515625, lng: 36.61943359375007 },
        { lat: 50.23486328124997, lng: 36.55966796875006 },
        { lat: 50.28046875000004, lng: 36.49980468750002 },
        { lat: 50.29682617187498, lng: 36.3688476562501 },
        { lat: 50.28046875000004, lng: 36.306054687499994 },
        { lat: 50.31176757812503, lng: 36.2433593750001 },
        { lat: 50.367822265624994, lng: 36.18945312499997 },
        { lat: 50.408544921875006, lng: 36.11640625000009 },
        { lat: 50.41967773437497, lng: 36.00781249999997 },
        { lat: 50.43710937499998, lng: 35.890234375 },
        { lat: 50.40576171874997, lng: 35.79619140625002 },
        { lat: 50.34599609374998, lng: 35.67373046875005 },
        { lat: 50.36875, lng: 35.59111328125002 },
        { lat: 50.43999023437502, lng: 35.54550781250006 },
        { lat: 50.459912109375004, lng: 35.48847656250004 },
        { lat: 50.539697265624994, lng: 35.41162109375003 },
        { lat: 50.610937500000034, lng: 35.39169921875006 },
        { lat: 50.64223632812502, lng: 35.41162109375003 },
        { lat: 50.682080078124955, lng: 35.4401367187501 },
        { lat: 50.72768554687502, lng: 35.4401367187501 },
        { lat: 50.76757812499997, lng: 35.41738281250005 },
        { lat: 50.79892578125006, lng: 35.38320312499999 },
        { lat: 50.90429687500003, lng: 35.34609375 },
        { lat: 50.949902343749976, lng: 35.31474609375001 },
        { lat: 50.98691406249998, lng: 35.30908203125003 },
        { lat: 51.02114257812502, lng: 35.33476562500002 },
        { lat: 51.043896484374955, lng: 35.31191406250005 },
        { lat: 51.04677734375002, lng: 35.26914062500006 },
        { lat: 51.043896484374955, lng: 35.19804687500002 },
        { lat: 51.06098632812498, lng: 35.158105468749994 },
        { lat: 51.12084960937499, lng: 35.11533203125006 },
        { lat: 51.18066406250003, lng: 35.092578125000074 },
        { lat: 51.203417968750045, lng: 35.0640625 },
        { lat: 51.20175781250006, lng: 34.99023437499997 },
        { lat: 51.18920898437499, lng: 34.86855468749999 },
        { lat: 51.16933593750002, lng: 34.76035156250006 },
        { lat: 51.17221679687498, lng: 34.71230468750005 },
        { lat: 51.203125, lng: 34.616796875 },
        { lat: 51.23706054687506, lng: 34.491015625000074 },
        { lat: 51.24379882812499, lng: 34.234179687500074 },
        { lat: 51.25537109375006, lng: 34.21386718750003 },
        { lat: 51.27685546875, lng: 34.22841796875005 },
        { lat: 51.311669921874966, lng: 34.280664062499994 },
        { lat: 51.340185546875006, lng: 34.275 },
        { lat: 51.36323242187501, lng: 34.229882812499994 },
        { lat: 51.419921875, lng: 34.20654296875003 },
        { lat: 51.48408203125001, lng: 34.20927734375002 },
        { lat: 51.553808593750006, lng: 34.20087890625004 },
        { lat: 51.607958984375045, lng: 34.14677734375002 },
        { lat: 51.64497070312501, lng: 34.11542968750004 },
        { lat: 51.67915039062498, lng: 34.12109375000002 },
        { lat: 51.69223632812506, lng: 34.239160156249994 },
        { lat: 51.71650390625004, lng: 34.37929687500005 },
        { lat: 51.74150390624996, lng: 34.40273437499999 },
        { lat: 51.78041992187499, lng: 34.397851562499994 },
        { lat: 51.979638671874994, lng: 34.113085937500074 },
        { lat: 52.15595703125004, lng: 34.01533203125004 },
        { lat: 52.25146484375003, lng: 33.92207031250003 },
        { lat: 52.315625, lng: 33.81884765624997 },
        { lat: 52.34477539062504, lng: 33.735253906249994 },
        { lat: 52.33261718750006, lng: 33.61337890625006 },
        { lat: 52.33378906250002, lng: 33.4518554687501 },
        { lat: 52.35356445312496, lng: 33.28710937500002 },
        { lat: 52.340429687500034, lng: 33.14843750000003 },
        { lat: 52.25634765625006, lng: 32.899707031250074 },
        { lat: 52.252636718750004, lng: 32.806445312500074 },
        { lat: 52.27910156249999, lng: 32.64541015625005 },
        { lat: 52.30854492187504, lng: 32.507910156250006 },
        { lat: 52.307226562500034, lng: 32.435449218749994 },
        { lat: 52.29482421874999, lng: 32.39130859375004 },
        { lat: 52.272119140624994, lng: 32.36298828125003 },
        { lat: 52.114013671875, lng: 32.28281250000006 },
        { lat: 52.08295898437498, lng: 32.21679687500003 },
        { lat: 52.05058593749996, lng: 32.12226562500004 },
        { lat: 52.04501953124998, lng: 32.041601562500006 },
        { lat: 52.04663085937506, lng: 31.973828125000097 },
        { lat: 52.070898437500034, lng: 31.87558593750006 },
        { lat: 52.09941406249995, lng: 31.782421875000097 },
        { lat: 52.10107421875003, lng: 31.763378906250093 },
        { lat: 52.125830078125034, lng: 31.758593750000014 },
        { lat: 52.22065429687498, lng: 31.690625 },
        { lat: 52.26220703125, lng: 31.649902343749968 },
        { lat: 52.284814453124994, lng: 31.601562500000025 },
        { lat: 52.31230468749999, lng: 31.577343750000036 },
        { lat: 52.42602539062497, lng: 31.57656250000005 },
        { lat: 52.532470703125, lng: 31.585546875 },
        { lat: 52.546191406250045, lng: 31.615917968750097 },
        { lat: 52.633007812499955, lng: 31.526171875000017 },
        { lat: 52.69873046875003, lng: 31.51943359375005 },
        { lat: 52.73144531250003, lng: 31.563476562499968 },
        { lat: 52.75922851562501, lng: 31.56484375 },
        { lat: 52.798242187499966, lng: 31.53515624999997 },
        { lat: 52.86181640625003, lng: 31.44277343749999 },
        { lat: 52.93344726562498, lng: 31.35302734374997 },
        { lat: 52.98979492187499, lng: 31.295117187500093 },
        { lat: 53.01669921875006, lng: 31.258789062499968 },
        { lat: 53.060888671875, lng: 31.302929687500097 },
        { lat: 53.13896484375002, lng: 31.364550781250017 },
        { lat: 53.18481445312503, lng: 31.388378906250093 },
        { lat: 53.196044921875, lng: 31.41787109375005 },
        { lat: 53.20249023437498, lng: 31.56298828124997 },
        { lat: 53.20092773437503, lng: 31.668261718750017 },
        { lat: 53.18417968749998, lng: 31.74746093750005 },
        { lat: 53.146875, lng: 31.777441406250063 },
        { lat: 53.106201171875, lng: 31.849707031250006 },
        { lat: 53.08945312500006, lng: 32.05546875000002 },
        { lat: 53.091162109375034, lng: 32.14199218750005 },
        { lat: 53.128369140624976, lng: 32.2506835937501 },
        { lat: 53.21059570312505, lng: 32.42626953124997 },
        { lat: 53.270312500000045, lng: 32.46933593750006 },
        { lat: 53.31240234374999, lng: 32.578027343749994 },
        { lat: 53.32890624999998, lng: 32.644433593749994 },
        { lat: 53.33632812499999, lng: 32.70429687500004 },
        { lat: 53.37143554687503, lng: 32.71025390625001 },
        { lat: 53.41943359375003, lng: 32.70644531250005 },
        { lat: 53.44814453125002, lng: 32.6857421875001 },
        { lat: 53.546972656250006, lng: 32.469628906249994 },
        { lat: 53.579248046874994, lng: 32.44238281249997 },
        { lat: 53.617285156250034, lng: 32.425195312499994 },
        { lat: 53.6533203125, lng: 32.45097656250002 },
        { lat: 53.69291992187499, lng: 32.45019531249997 },
        { lat: 53.78125, lng: 32.20039062500004 },
        { lat: 53.796875, lng: 31.99218750000003 },
        { lat: 53.79194335937498, lng: 31.820800781249968 },
        { lat: 53.81044921875002, lng: 31.754199218750017 },
        { lat: 53.85498046875005, lng: 31.783007812500014 },
        { lat: 53.93500976562501, lng: 31.825292968750006 },
        { lat: 54.00078124999998, lng: 31.83779296874999 },
        { lat: 54.030712890624955, lng: 31.82597656250007 },
        { lat: 54.05590820312503, lng: 31.79199218749997 },
        { lat: 54.111181640625, lng: 31.628417968749968 },
        { lat: 54.195947265624966, lng: 31.403613281250017 },
        { lat: 54.29169921875001, lng: 31.29912109375002 },
        { lat: 54.391650390625045, lng: 31.245507812500048 },
        { lat: 54.452978515625, lng: 31.184765625000093 },
        { lat: 54.491796875, lng: 31.074804687500063 },
        { lat: 54.51708984375003, lng: 31.081933593749998 },
        { lat: 54.61093750000003, lng: 31.154882812500063 },
        { lat: 54.625341796875034, lng: 31.152148437500017 },
        { lat: 54.64848632812496, lng: 31.12128906250004 },
        { lat: 54.69589843750003, lng: 30.98417968750007 },
        { lat: 54.78325195312499, lng: 30.79882812499997 },
        { lat: 54.806005859375, lng: 30.79101562499997 },
        { lat: 54.8609375, lng: 30.80449218750007 },
        { lat: 54.91499023437498, lng: 30.829882812500014 },
        { lat: 54.94072265624999, lng: 30.86679687500006 },
        { lat: 55.05048828124998, lng: 30.977734375000097 },
        { lat: 55.08779296875002, lng: 30.977734375000097 },
        { lat: 55.13759765625005, lng: 30.958886718749994 },
        { lat: 55.223437500000045, lng: 30.877441406250025 },
        { lat: 55.27871093750002, lng: 30.814453124999968 },
        { lat: 55.306982421875006, lng: 30.810546874999968 },
        { lat: 55.330273437499955, lng: 30.82099609375004 },
        { lat: 55.36040039062496, lng: 30.86181640625003 },
        { lat: 55.397412109374955, lng: 30.900585937500097 },
        { lat: 55.525341796874976, lng: 30.908789062500002 },
        { lat: 55.57001953125004, lng: 30.906835937500063 },
        { lat: 55.59638671874998, lng: 30.88222656249999 },
        { lat: 55.607519531250034, lng: 30.855957031249975 },
        { lat: 55.60112304687498, lng: 30.80078125000003 },
        { lat: 55.62211914062499, lng: 30.72167968749997 },
        { lat: 55.65546875000004, lng: 30.662304687500036 },
        { lat: 55.666259765625, lng: 30.625585937500006 },
        { lat: 55.700292968750006, lng: 30.586718750000014 },
        { lat: 55.76879882812503, lng: 30.47539062500007 },
        { lat: 55.78681640624998, lng: 30.45625 },
        { lat: 55.84521484375006, lng: 30.23359375000004 },
        { lat: 55.83642578125003, lng: 30.04267578125004 },
        { lat: 55.84526367187498, lng: 29.93701171874997 },
        { lat: 55.83232421875002, lng: 29.881640625000077 },
        { lat: 55.79511718749998, lng: 29.82392578125004 },
        { lat: 55.770410156249994, lng: 29.74414062499997 },
        { lat: 55.76972656249995, lng: 29.684570312499968 },
        { lat: 55.751171874999976, lng: 29.630078125000097 },
        { lat: 55.6845703125, lng: 29.482226562500074 },
        { lat: 55.72485351562505, lng: 29.41298828124999 },
        { lat: 55.784375, lng: 29.353417968750048 },
        { lat: 55.83471679687506, lng: 29.373144531250066 },
        { lat: 55.88105468749998, lng: 29.39794921874997 },
        { lat: 55.912207031250034, lng: 29.39609375 },
        { lat: 55.93872070312499, lng: 29.375 },
        { lat: 55.967871093750006, lng: 29.283007812500077 },
        { lat: 56.02114257812502, lng: 29.087402343749996 },
        { lat: 56.02177734374996, lng: 29.03173828125003 },
        { lat: 56.002099609375044, lng: 28.94746093750001 },
        { lat: 55.94257812499998, lng: 28.79472656250007 },
        { lat: 55.95537109375001, lng: 28.740820312500002 },
        { lat: 56.00263671874998, lng: 28.69082031250005 },
        { lat: 56.06176757812503, lng: 28.636914062500065 },
        { lat: 56.09199218749998, lng: 28.563964843750057 },
        { lat: 56.089013671874994, lng: 28.407031250000045 },
        { lat: 56.08671875, lng: 28.39208984375003 },
        { lat: 56.05253906250002, lng: 28.31630859375005 },
        { lat: 56.055908203125, lng: 28.284277343750006 },
        { lat: 56.14291992187503, lng: 28.14794921875003 },
        { lat: 56.19033203125002, lng: 28.173339843750053 },
        { lat: 56.26040039062499, lng: 28.20205078125002 },
        { lat: 56.31557617187505, lng: 28.191699218750045 },
        { lat: 56.38686523437499, lng: 28.169238281250014 },
        { lat: 56.51069335937501, lng: 28.110839843749996 },
        { lat: 56.54570312500004, lng: 28.103125 },
        { lat: 56.59985351562506, lng: 28.00751953125001 },
        { lat: 56.64531249999999, lng: 27.99160156250005 },
        { lat: 56.70371093749998, lng: 27.941406250000057 },
        { lat: 56.741064453125034, lng: 27.89208984375003 },
        { lat: 56.82416992187501, lng: 27.88154296875001 },
        { lat: 56.85341796875002, lng: 27.848632812500057 },
        { lat: 56.867089843750044, lng: 27.806054687499994 },
        { lat: 56.84321289062498, lng: 27.655664062499994 },
        { lat: 56.84565429687504, lng: 27.639453125000074 },
        { lat: 56.97807617187502, lng: 27.71113281250004 },
        { lat: 57.05463867187498, lng: 27.717382812500063 },
        { lat: 57.13510742187503, lng: 27.762792968750063 },
        { lat: 57.16689453125002, lng: 27.81455078125003 },
        { lat: 57.19448242187505, lng: 27.83027343750004 },
        { lat: 57.247705078124966, lng: 27.83828125000008 },
        { lat: 57.293310546875006, lng: 27.828613281249968 },
        { lat: 57.31694335937504, lng: 27.796875 },
        { lat: 57.36811523437498, lng: 27.672753906250023 },
        { lat: 57.429785156250034, lng: 27.538671875000063 },
        { lat: 57.508154296875006, lng: 27.51113281250005 },
        { lat: 57.52402343750003, lng: 27.469726562500053 },
        { lat: 57.528125, lng: 27.35195312500005 },
        { lat: 57.55029296874998, lng: 27.354296875000074 },
        { lat: 57.61254882812503, lng: 27.371777343749983 },
        { lat: 57.66679687499998, lng: 27.4 },
        { lat: 57.72495117187503, lng: 27.491992187500045 },
        { lat: 57.76420898437501, lng: 27.514746093749977 },
        { lat: 57.7994140625, lng: 27.542089843750063 },
        { lat: 57.841015624999955, lng: 27.75283203125008 },
        { lat: 57.85673828124997, lng: 27.776953125000034 },
        { lat: 57.87070312500007, lng: 27.778515625000068 },
        { lat: 57.88413085937503, lng: 27.76875 },
        { lat: 57.90546875000004, lng: 27.721972656250017 },
        { lat: 57.93461914062501, lng: 27.673437499999974 },
        { lat: 58.013916015625, lng: 27.644140625000063 },
        { lat: 58.1380859375, lng: 27.571093750000017 },
        { lat: 58.22133789062499, lng: 27.502441406250057 },
        { lat: 58.270068359375045, lng: 27.48779296875 },
        { lat: 58.326269531250034, lng: 27.505566406250065 },
        { lat: 58.381494140625016, lng: 27.53007812499999 },
        { lat: 58.43525390624996, lng: 27.531347656250006 },
        { lat: 58.733056640624966, lng: 27.427050781250074 },
        { lat: 58.78725585937499, lng: 27.434179687500002 },
        { lat: 58.84130859375, lng: 27.464453125000034 },
        { lat: 58.88627929687502, lng: 27.513085937499994 },
        { lat: 58.94497070312496, lng: 27.62177734375004 },
        { lat: 59.05200195312503, lng: 27.757617187500074 },
        { lat: 59.19267578124999, lng: 27.849511718750048 },
        { lat: 59.277636718750074, lng: 27.89765625000001 },
        { lat: 59.297021484375016, lng: 27.93818359375001 },
        { lat: 59.301708984374976, lng: 28.016406250000045 },
        { lat: 59.32783203124998, lng: 28.046093750000068 },
        { lat: 59.34326171875003, lng: 28.061328125000045 },
        { lat: 59.357568359374994, lng: 28.128320312500023 },
        { lat: 59.374414062499966, lng: 28.15107421875004 },
        { lat: 59.40307617187503, lng: 28.13300781250001 },
        { lat: 59.453173828125045, lng: 28.06582031250008 },
        { lat: 59.484277343749966, lng: 28.0125 },
        { lat: 59.554003906250045, lng: 28.063964843750053 },
        { lat: 59.64716796875003, lng: 28.046289062499994 },
        { lat: 59.724755859375016, lng: 28.013964843750074 },
        { lat: 59.781542968750045, lng: 28.05800781250008 },
        { lat: 59.78652343749999, lng: 28.13115234375007 },
        { lat: 59.72465820312501, lng: 28.2125 },
        { lat: 59.69252929687502, lng: 28.33457031250003 },
        { lat: 59.73408203124998, lng: 28.42373046875008 },
        { lat: 59.81425781250004, lng: 28.453906250000017 },
        { lat: 59.84956054687495, lng: 28.51816406250003 },
        { lat: 59.81806640625004, lng: 28.603906250000023 },
        { lat: 59.80668945312502, lng: 28.747656249999974 },
        { lat: 59.811914062500016, lng: 28.86689453125004 },
        { lat: 59.82875976562499, lng: 28.947265625000053 },
        { lat: 59.854785156250045, lng: 28.981542968750038 },
        { lat: 59.90156249999998, lng: 29.013378906250036 },
        { lat: 59.96098632812502, lng: 29.0791015625 },
        { lat: 59.999755859375, lng: 29.147265625000042 },
        { lat: 59.9556640625, lng: 29.669726562500074 },
        { lat: 59.87358398437507, lng: 30.12255859374997 },
        { lat: 59.90429687499999, lng: 30.156835937500002 },
        { lat: 59.95712890625003, lng: 30.172656250000017 },
        { lat: 60.00258789062496, lng: 30.059960937499994 },
        { lat: 60.0263671875, lng: 29.976757812500097 },
        { lat: 60.120849609375, lng: 29.872265625000043 },
        { lat: 60.19531249999997, lng: 29.721191406249968 },
        { lat: 60.20185546874998, lng: 29.569335937499968 },
        { lat: 60.17592773437502, lng: 29.37041015625002 },
        { lat: 60.19145507812499, lng: 29.069140625000017 },
        { lat: 60.33154296875, lng: 28.812695312500008 },
        { lat: 60.37529296875004, lng: 28.643164062500006 },
        { lat: 60.48295898437504, lng: 28.52226562500007 },
        { lat: 60.540136718750055, lng: 28.49160156250005 },
        { lat: 60.49160156250002, lng: 28.62246093750005 },
        { lat: 60.542871093749994, lng: 28.640332031250068 },
        { lat: 60.61098632812503, lng: 28.650585937500008 },
        { lat: 60.652539062499955, lng: 28.57783203125004 },
        { lat: 60.67729492187501, lng: 28.512792968750006 },
        { lat: 60.57099609375003, lng: 28.179296875 },
        { lat: 60.53613281250003, lng: 27.797656250000074 },
        { lat: 60.74584960937502, lng: 28.151953125000034 },
        { lat: 60.89692382812501, lng: 28.40742187500004 },
        { lat: 60.919628906250004, lng: 28.455078125000057 },
        { lat: 60.960205078125, lng: 28.568164062500017 },
        { lat: 61.00283203124999, lng: 28.662890625000045 },
        { lat: 61.05874023437502, lng: 28.739062500000014 },
        { lat: 61.16904296875, lng: 28.992968750000042 },
        { lat: 61.28779296874996, lng: 29.251660156250097 },
        { lat: 61.44423828125002, lng: 29.492382812500097 },
        { lat: 61.49345703125001, lng: 29.57939453125007 },
        { lat: 61.54609375, lng: 29.690136718750036 },
        { lat: 61.71157226562496, lng: 29.933203125 },
        { lat: 61.757373046875045, lng: 30.00996093750004 },
        { lat: 61.964843750000064, lng: 30.306445312500017 },
        { lat: 62.06821289062506, lng: 30.47968750000004 },
        { lat: 62.127587890624994, lng: 30.565625 },
        { lat: 62.32377929687499, lng: 30.935742187500093 },
        { lat: 62.48139648437503, lng: 31.18671875000004 },
        { lat: 62.567822265624955, lng: 31.28564453125003 },
        { lat: 62.691650390624964, lng: 31.382421875 },
        { lat: 62.77612304687503, lng: 31.437304687500014 },
        { lat: 62.885400390624994, lng: 31.533984375000017 },
        { lat: 62.921630859375036, lng: 31.53652343749999 },
        { lat: 62.95532226562503, lng: 31.509277343750025 },
        { lat: 63.007714843749966, lng: 31.437011718749968 },
        { lat: 63.06806640625001, lng: 31.336718750000074 },
        { lat: 63.141894531250045, lng: 31.247460937499994 },
        { lat: 63.208300781250074, lng: 31.180859375000093 },
        { lat: 63.300634765625034, lng: 30.974804687500036 },
        { lat: 63.41748046875006, lng: 30.65527343749997 },
        { lat: 63.50405273437502, lng: 30.41855468750006 },
        { lat: 63.689013671875045, lng: 30.05537109375004 },
        { lat: 63.73515625000002, lng: 29.991503906250074 },
        { lat: 63.747314453125, lng: 30.004101562500093 },
        { lat: 63.80332031250006, lng: 30.210253906250074 },
        { lat: 63.94750976562503, lng: 30.415332031250017 },
        { lat: 64.02060546875, lng: 30.50390625000003 },
        { lat: 64.077294921875, lng: 30.526074218750097 },
        { lat: 64.14111328125003, lng: 30.527929687500006 },
        { lat: 64.2, lng: 30.513769531250002 },
        { lat: 64.2365234375, lng: 30.487890625000063 },
        { lat: 64.28242187499995, lng: 30.390625 },
        { lat: 64.36611328125005, lng: 30.108105468750036 },
        { lat: 64.44335937499997, lng: 30.041894531250048 },
        { lat: 64.52426757812503, lng: 29.986621093750077 },
        { lat: 64.55771484375, lng: 29.98554687500004 },
        { lat: 64.64462890625002, lng: 30.12011718749997 },
        { lat: 64.6880859375, lng: 30.126171875000097 },
        { lat: 64.732568359375, lng: 30.110253906250048 },
        { lat: 64.76503906250005, lng: 30.072851562500063 },
        { lat: 64.80429687500006, lng: 29.783203125000025 },
        { lat: 64.84575195312505, lng: 29.70166015625003 },
        { lat: 64.911767578125, lng: 29.6375 },
        { lat: 64.968408203125, lng: 29.604199218750036 },
        { lat: 65.001953125, lng: 29.60087890625007 },
        { lat: 65.03950195312501, lng: 29.62246093750005 },
        { lat: 65.08032226562497, lng: 29.720019531250014 },
        { lat: 65.10791015625, lng: 29.81083984375007 },
        { lat: 65.14506835937502, lng: 29.826953125000017 },
        { lat: 65.18530273437504, lng: 29.826171874999968 },
        { lat: 65.204736328125, lng: 29.81054687499997 },
        { lat: 65.223876953125, lng: 29.629687500000017 },
        { lat: 65.234765625, lng: 29.61240234375001 },
        { lat: 65.248681640625, lng: 29.608007812500006 },
        { lat: 65.26533203125, lng: 29.617187500000025 },
        { lat: 65.33696289062505, lng: 29.714843750000025 },
        { lat: 65.47343750000003, lng: 29.72802734374997 },
        { lat: 65.56875, lng: 29.819433593750006 },
        { lat: 65.62456054687502, lng: 29.715917968750063 },
        { lat: 65.634375, lng: 29.723925781250014 },
        { lat: 65.66362304687505, lng: 29.882617187500017 },
        { lat: 65.67070312499999, lng: 30.029003906250097 },
        { lat: 65.68168945312502, lng: 30.0953125 },
        { lat: 65.72626953125004, lng: 30.102734375000093 },
        { lat: 65.78652343749995, lng: 30.0875 },
        { lat: 66.02294921875, lng: 29.936621093750002 },
        { lat: 66.091064453125, lng: 29.903417968750006 },
        { lat: 66.17705078125002, lng: 29.80351562500007 },
        { lat: 66.23486328125, lng: 29.72070312499997 },
        { lat: 66.27612304687504, lng: 29.67089843749997 },
        { lat: 66.35683593749997, lng: 29.59072265625005 },
        { lat: 66.43969726562497, lng: 29.544335937499998 },
        { lat: 66.53217773437497, lng: 29.464355468749968 },
        { lat: 66.61704101562506, lng: 29.371191406250002 },
        { lat: 66.69550781249994, lng: 29.29326171875002 },
        { lat: 66.84921875, lng: 29.093066406250017 },
        { lat: 66.89174804687497, lng: 29.066210937500042 },
        { lat: 66.93022460937499, lng: 29.06904296875001 },
        { lat: 66.97094726562503, lng: 29.08701171875003 },
        { lat: 67.09658203125005, lng: 29.243359375000093 },
        { lat: 67.201416015625, lng: 29.38769531249997 },
        { lat: 67.324365234375, lng: 29.57226562500003 },
        { lat: 67.426416015625, lng: 29.750585937500002 },
        { lat: 67.54746093749998, lng: 29.94121093750007 },
        { lat: 67.66826171874999, lng: 29.988085937500014 },
        { lat: 67.68857421875003, lng: 29.97919921875004 },
        { lat: 67.75400390625003, lng: 29.821582031250017 },
        { lat: 67.92910156250001, lng: 29.524218750000017 },
        { lat: 68.06186523437506, lng: 29.343847656250006 },
        { lat: 68.11796875000002, lng: 29.06298828125 },
        { lat: 68.189794921875, lng: 28.685156250000034 },
        { lat: 68.35136718750007, lng: 28.560156250000063 },
        { lat: 68.48837890625, lng: 28.470703125000053 },
        { lat: 68.53764648437499, lng: 28.479296875000014 },
        { lat: 68.77143554687501, lng: 28.752050781250002 },
        { lat: 68.81381835937503, lng: 28.777636718750042 },
        { lat: 68.84003906249995, lng: 28.77285156250005 },
        { lat: 68.85644531250001, lng: 28.744824218750036 },
        { lat: 68.86552734375002, lng: 28.70595703125002 },
        { lat: 68.87226562499994, lng: 28.453515625000023 },
        { lat: 68.90415039062506, lng: 28.414062500000057 },
        { lat: 68.92822265624999, lng: 28.566015625 },
        { lat: 68.96103515625, lng: 28.692187500000045 },
        { lat: 69.00966796874997, lng: 28.89892578124997 },
        { lat: 69.02197265625, lng: 28.96582031250003 },
        { lat: 69.049951171875, lng: 29.11855468750005 },
        { lat: 69.07153320312504, lng: 29.170898437500053 },
        { lat: 69.097021484375, lng: 29.20996093750003 },
        { lat: 69.27060546875, lng: 29.35302734375003 },
        { lat: 69.29814453125005, lng: 29.38828125 },
        { lat: 69.36044921875003, lng: 29.83271484375004 },
        { lat: 69.39248046874997, lng: 29.99404296874999 },
        { lat: 69.43286132812501, lng: 30.087304687500048 },
        { lat: 69.46425781250002, lng: 30.13183593749997 },
        { lat: 69.501611328125, lng: 30.163769531250093 },
        { lat: 69.54277343750005, lng: 30.18671875000004 },
        { lat: 69.58056640625003, lng: 30.196484375000093 },
        { lat: 69.62988281250003, lng: 30.159765625 },
        { lat: 69.63583984375, lng: 30.180175781249975 },
        { lat: 69.63378906250003, lng: 30.22753906250003 },
        { lat: 69.58471679687497, lng: 30.379687500000017 },
        { lat: 69.532568359375, lng: 30.615429687500093 },
        { lat: 69.52851562499998, lng: 30.788867187500074 },
        { lat: 69.53842773437503, lng: 30.86074218749999 },
        { lat: 69.56123046874998, lng: 30.896679687500097 },
        { lat: 69.605810546875, lng: 30.922460937500002 },
        { lat: 69.65175781250005, lng: 30.924121093750017 },
        { lat: 69.78344726562506, lng: 30.869726562500006 },
        { lat: 69.76923828124998, lng: 31.049511718750036 },
        { lat: 69.68959960937502, lng: 31.45273437500006 },
        { lat: 69.69692382812498, lng: 31.546972656250063 },
        { lat: 69.72099609375002, lng: 31.66621093750004 },
        { lat: 69.81577148437498, lng: 31.78857421874997 },
        { lat: 69.83198242187498, lng: 31.87939453125003 },
        { lat: 69.80991210937502, lng: 31.997949218749994 },
        { lat: 69.83530273437502, lng: 32.03056640625002 },
        { lat: 69.91391601562496, lng: 31.969335937500063 },
        { lat: 69.95366210937499, lng: 31.984570312500036 },
        { lat: 69.86870117187502, lng: 32.39160156250003 },
        { lat: 69.80649414062503, lng: 32.56542968749997 },
        { lat: 69.75185546875, lng: 32.94169921875002 },
        { lat: 69.72211914062498, lng: 33.00781249999997 },
        { lat: 69.67050781250003, lng: 33.01259765625005 },
        { lat: 69.62617187499998, lng: 32.99462890625003 },
        { lat: 69.60170898437497, lng: 32.915039062499964 },
        { lat: 69.605712890625, lng: 32.75429687499999 },
        { lat: 69.67402343749995, lng: 32.17675781250003 },
        { lat: 69.63256835937503, lng: 32.0915039062501 },
        { lat: 69.59663085937501, lng: 32.1613281250001 },
        { lat: 69.55424804687499, lng: 32.33056640625003 },
        { lat: 69.47910156250003, lng: 32.37773437500002 },
        { lat: 69.48945312500001, lng: 32.63681640625006 },
        { lat: 69.46083984374997, lng: 32.88378906250003 },
        { lat: 69.4701171875, lng: 32.99980468750002 },
        { lat: 69.44560546875005, lng: 33.02099609374997 },
        { lat: 69.38334960937497, lng: 32.94160156250004 },
        { lat: 69.367333984375, lng: 32.97890625000005 },
        { lat: 69.42773437499997, lng: 33.25585937499997 },
        { lat: 69.44428710937495, lng: 33.38486328125006 },
        { lat: 69.42817382812495, lng: 33.45429687500004 },
        { lat: 69.378173828125, lng: 33.46367187500002 },
        { lat: 69.31528320312498, lng: 33.41796875000003 },
        { lat: 69.267431640625, lng: 33.412988281249994 },
        { lat: 69.15185546874997, lng: 33.32773437500006 },
        { lat: 69.11684570312505, lng: 33.196386718750006 },
        { lat: 69.068701171875, lng: 33.14121093750006 },
        { lat: 69.09819335937507, lng: 33.333398437500044 },
        { lat: 69.13037109375006, lng: 33.43564453125 },
        { lat: 69.28916015624998, lng: 33.627050781250006 },
        { lat: 69.31025390625001, lng: 33.684375 },
        { lat: 69.31313476562497, lng: 34.229394531250044 },
        { lat: 69.30292968750004, lng: 34.35273437500004 },
        { lat: 69.22807617187505, lng: 34.8639648437501 },
        { lat: 69.22124023437497, lng: 35.00957031250002 },
        { lat: 69.230810546875, lng: 35.17587890625006 },
        { lat: 69.26557617187498, lng: 35.23320312500002 },
        { lat: 69.27543945312502, lng: 35.28984375000002 },
        { lat: 69.19174804687503, lng: 35.85791015625003 },
        { lat: 69.00346679687505, lng: 36.618261718750006 },
        { lat: 68.69213867187503, lng: 37.73056640625006 },
        { lat: 68.41513671875, lng: 38.35761718750009 },
        { lat: 68.35561523437504, lng: 38.43017578125002 },
        { lat: 68.321875, lng: 38.656835937500006 },
        { lat: 68.34472656250003, lng: 38.70556640624997 },
        { lat: 68.32490234375001, lng: 38.83154296874997 },
        { lat: 68.07172851562501, lng: 39.568945312500006 },
        { lat: 68.05859374999999, lng: 39.82333984375006 },
        { lat: 68.112158203125, lng: 39.78974609375004 },
        { lat: 68.16220703124998, lng: 39.7462890625001 },
        { lat: 68.15083007812497, lng: 39.80927734375003 },
        { lat: 68.11450195312503, lng: 39.89560546875006 },
        { lat: 68.015380859375, lng: 40.035742187500006 },
        { lat: 67.94189453125003, lng: 40.206640625 },
        { lat: 67.831884765625, lng: 40.38066406250001 },
        { lat: 67.78969726562502, lng: 40.52578125 },
        { lat: 67.77407226562505, lng: 40.65654296875001 },
        { lat: 67.74301757812503, lng: 40.76630859375004 },
        { lat: 67.71347656250003, lng: 40.96640625000006 },
        { lat: 67.44418945312498, lng: 41.06093750000005 },
        { lat: 67.38603515625005, lng: 41.13388671875 },
        { lat: 67.26694335937503, lng: 41.13388671875 },
        { lat: 67.21845703125001, lng: 41.26171875000003 },
        { lat: 67.20966796874998, lng: 41.358789062499994 },
        { lat: 67.12143554687503, lng: 41.35429687500002 },
        { lat: 66.91430664062503, lng: 41.2755859375001 },
        { lat: 66.82617187500003, lng: 41.18896484375002 },
        { lat: 66.44663085937498, lng: 40.52158203125006 },
        { lat: 66.29995117187502, lng: 40.10332031250002 },
        { lat: 66.13203125000001, lng: 39.28906250000003 },
        { lat: 66.06904296874994, lng: 38.65390625000006 },
        { lat: 66.064453125, lng: 38.39755859375006 },
        { lat: 66.09560546875005, lng: 37.900683593750074 },
        { lat: 66.12958984374995, lng: 37.628222656250074 },
        { lat: 66.22504882812495, lng: 37.294824218749994 },
        { lat: 66.27255859375003, lng: 36.98369140625002 },
        { lat: 66.29355468750006, lng: 36.76992187499999 },
        { lat: 66.30229492187505, lng: 36.37343750000005 },
        { lat: 66.39580078125002, lng: 35.51347656250002 },
        { lat: 66.42866210937495, lng: 35.3639648437501 },
        { lat: 66.61113281249997, lng: 34.82460937499999 },
        { lat: 66.55961914062499, lng: 34.610253906249994 },
        { lat: 66.55034179687505, lng: 34.48261718750004 },
        { lat: 66.61318359374997, lng: 34.39609375 },
        { lat: 66.62978515625, lng: 34.43085937500003 },
        { lat: 66.651220703125, lng: 34.4515625 },
        { lat: 66.70327148437502, lng: 34.14609375000006 },
        { lat: 66.70673828125004, lng: 33.893652343750055 },
        { lat: 66.75097656249997, lng: 33.75957031250002 },
        { lat: 66.78461914062498, lng: 33.59541015625004 },
        { lat: 66.76435546874995, lng: 33.52294921875003 },
        { lat: 66.76455078125, lng: 33.48203125 },
        { lat: 66.84394531250001, lng: 33.15019531250002 },
        { lat: 66.90830078125006, lng: 33.00195312500003 },
        { lat: 67.02153320312505, lng: 32.847558593749994 },
        { lat: 67.0611328125, lng: 32.88525390624997 },
        { lat: 67.08681640625002, lng: 32.93046875000001 },
        { lat: 67.152685546875, lng: 32.39990234375002 },
        { lat: 67.16142578125002, lng: 31.89531250000007 },
        { lat: 67.12983398437498, lng: 31.983007812500002 },
        { lat: 67.11323242187498, lng: 32.20156250000005 },
        { lat: 67.06787109374997, lng: 32.340625 },
        { lat: 67.00385742187498, lng: 32.50097656250003 },
        { lat: 66.91630859374999, lng: 32.46367187500002 },
        { lat: 66.82954101562501, lng: 32.68642578125005 },
        { lat: 66.74692382812503, lng: 32.85732421875005 },
        { lat: 66.72138671874998, lng: 32.86240234375 },
        { lat: 66.70410156250003, lng: 32.92871093750003 },
        { lat: 66.67993164062497, lng: 33.180566406249994 },
        { lat: 66.60385742187503, lng: 33.22441406250002 },
        { lat: 66.57387695312497, lng: 33.18291015625002 },
        { lat: 66.53164062499997, lng: 33.217382812500006 },
        { lat: 66.48427734375, lng: 33.40527343750003 },
        { lat: 66.47138671874994, lng: 33.517675781250006 },
        { lat: 66.44262695312506, lng: 33.65595703125004 },
        { lat: 66.38457031250002, lng: 33.59326171874997 },
        { lat: 66.346875, lng: 33.47695312499999 },
        { lat: 66.32954101562501, lng: 33.36054687500004 },
        { lat: 66.315625, lng: 33.41582031250002 },
        { lat: 66.32099609374995, lng: 33.566699218750074 },
        { lat: 66.225244140625, lng: 34.112695312499994 },
        { lat: 66.12841796874997, lng: 34.39980468750005 },
        { lat: 65.95185546874998, lng: 34.69179687500005 },
        { lat: 65.86455078125003, lng: 34.78632812500009 },
        { lat: 65.81635742187501, lng: 34.7931640625001 },
        { lat: 65.76826171874998, lng: 34.77695312500006 },
        { lat: 65.71630859375006, lng: 34.73476562499999 },
        { lat: 65.66406249999997, lng: 34.71552734375003 },
        { lat: 65.509912109375, lng: 34.61572265624997 },
        { lat: 65.456689453125, lng: 34.54414062500004 },
        { lat: 65.39575195312503, lng: 34.40644531250004 },
        { lat: 65.2779296875, lng: 34.535937500000074 },
        { lat: 65.168115234375, lng: 34.6710937500001 },
        { lat: 64.98598632812502, lng: 34.803515625000074 },
        { lat: 64.9126953125, lng: 34.82714843749997 },
        { lat: 64.80019531250002, lng: 34.832617187500006 },
        { lat: 64.75595703124998, lng: 34.95224609375006 },
        { lat: 64.738671875, lng: 34.90546875000003 },
        { lat: 64.70668945312497, lng: 34.858300781249994 },
        { lat: 64.56000976562501, lng: 34.86953125 },
        { lat: 64.44023437500005, lng: 35.03535156250004 },
        { lat: 64.36254882812503, lng: 35.284082031249994 },
        { lat: 64.34677734375, lng: 35.43203125 },
        { lat: 64.37832031250005, lng: 35.64707031250006 },
        { lat: 64.3353515625, lng: 35.802050781250074 },
        { lat: 64.18901367187502, lng: 36.14648437499997 },
        { lat: 64.034375, lng: 36.30195312500004 },
        { lat: 64.00283203125002, lng: 36.3649414062501 },
        { lat: 63.94506835937497, lng: 36.713769531249994 },
        { lat: 63.909521484375, lng: 36.975195312500006 },
        { lat: 63.81674804687503, lng: 37.37275390625004 },
        { lat: 63.81337890624997, lng: 37.44218750000002 },
        { lat: 63.893408203125, lng: 37.635351562500006 },
        { lat: 63.94912109374999, lng: 37.96796875000009 },
        { lat: 64.02583007812498, lng: 38.070800781249964 },
        { lat: 64.09101562499994, lng: 38.0622070312501 },
        { lat: 64.20703125000006, lng: 37.977148437500006 },
        { lat: 64.32011718749999, lng: 37.953710937500006 },
        { lat: 64.36630859375, lng: 37.843554687500074 },
        { lat: 64.39697265625003, lng: 37.740625 },
        { lat: 64.37358398437505, lng: 37.429589843749994 },
        { lat: 64.37792968750006, lng: 37.28955078124997 },
        { lat: 64.40849609375007, lng: 37.183691406250006 },
        { lat: 64.48916015624997, lng: 37.04042968750005 },
        { lat: 64.68525390624995, lng: 36.769335937500074 },
        { lat: 64.75053710937502, lng: 36.6242187500001 },
        { lat: 64.79096679687501, lng: 36.57871093750006 },
        { lat: 64.84736328125004, lng: 36.52822265625005 },
        { lat: 64.93862304687497, lng: 36.534570312499994 },
        { lat: 64.93544921875002, lng: 36.65292968750006 },
        { lat: 64.987158203125, lng: 36.785937500000074 },
        { lat: 65.17236328124997, lng: 36.88281249999997 },
        { lat: 65.19589843749998, lng: 37.050195312499994 },
        { lat: 65.19428710937501, lng: 37.14082031250004 },
        { lat: 65.10825195312498, lng: 37.528125 },
        { lat: 64.87875976562503, lng: 38.009375 },
        { lat: 64.85458984375, lng: 38.11572265624997 },
        { lat: 64.85122070312502, lng: 38.2282226562501 },
        { lat: 64.85708007812495, lng: 38.41210937499997 },
        { lat: 64.8271484375, lng: 38.441992187500006 },
        { lat: 64.79125976562497, lng: 38.540917968749994 },
        { lat: 64.78666992187502, lng: 38.613085937500074 },
        { lat: 64.71391601562502, lng: 39.05351562500002 },
        { lat: 64.57055664062503, lng: 39.56738281249997 },
        { lat: 64.57705078125002, lng: 39.7580078125001 },
        { lat: 64.65639648437502, lng: 39.83300781249997 },
        { lat: 64.69052734375006, lng: 39.84863281249997 },
        { lat: 64.77075195312497, lng: 40.05781250000004 },
        { lat: 64.78403320312499, lng: 40.2037109375 },
        { lat: 64.75488281250003, lng: 40.40781250000006 },
        { lat: 64.7787109375, lng: 40.44492187500006 },
        { lat: 64.89628906250003, lng: 40.37539062499999 },
        { lat: 64.99809570312502, lng: 40.28125 },
        { lat: 65.06328125000003, lng: 40.142675781250006 },
        { lat: 65.25478515625, lng: 39.89648437499997 },
        { lat: 65.34985351562499, lng: 39.7980468750001 },
        { lat: 65.44794921874998, lng: 39.74912109375006 },
        { lat: 65.53471679687499, lng: 39.781152343749994 },
        { lat: 65.59794921874999, lng: 39.81650390625 },
        { lat: 65.75170898437497, lng: 40.3278320312501 },
        { lat: 65.84379882812499, lng: 40.512792968750006 },
        { lat: 65.96342773437502, lng: 40.69160156250004 },
        { lat: 65.98789062500003, lng: 40.77441406250003 },
        { lat: 66.02109375000006, lng: 41.07607421875005 },
        { lat: 66.12343750000002, lng: 41.4757812500001 },
        { lat: 66.25932617187502, lng: 41.780859375 },
        { lat: 66.46591796875, lng: 42.08359375 },
        { lat: 66.51967773437502, lng: 42.21054687500006 },
        { lat: 66.51474609375, lng: 42.31367187500009 },
        { lat: 66.48242187499997, lng: 42.45078125000006 },
        { lat: 66.42250976562501, lng: 42.60214843750006 },
        { lat: 66.41132812499998, lng: 42.80654296875005 },
        { lat: 66.42094726562507, lng: 43.005957031250006 },
        { lat: 66.41552734375003, lng: 43.23320312500002 },
        { lat: 66.32128906250003, lng: 43.550878906250006 },
        { lat: 66.29121093750001, lng: 43.60332031250002 },
        { lat: 66.2509765625, lng: 43.653125 },
        { lat: 66.17338867187499, lng: 43.55039062500006 },
        { lat: 66.12338867187503, lng: 43.54189453125005 },
        { lat: 66.14672851562497, lng: 43.62392578125005 },
        { lat: 66.15839843749995, lng: 43.7370117187501 },
        { lat: 66.14238281249999, lng: 43.84375 },
        { lat: 66.09868164062505, lng: 43.944140625000074 },
        { lat: 66.04975585937504, lng: 44.01669921875 },
        { lat: 66.00859374999999, lng: 44.10439453125005 },
        { lat: 66.06455078125002, lng: 44.13242187500006 },
        { lat: 66.11274414062498, lng: 44.14531250000002 },
        { lat: 66.23505859375004, lng: 44.09716796874997 },
        { lat: 66.407080078125, lng: 44.22070312500003 },
        { lat: 66.481689453125, lng: 44.31640624999997 },
        { lat: 66.67177734375002, lng: 44.48867187499999 },
        { lat: 66.79462890624998, lng: 44.43710937500006 },
        { lat: 66.93774414062503, lng: 44.429296875000055 },
        { lat: 67.00419921875005, lng: 44.403906250000055 },
        { lat: 67.09965820312505, lng: 44.29179687500002 },
        { lat: 67.16733398437498, lng: 44.07441406250004 },
        { lat: 67.18862304687497, lng: 43.85537109375005 },
        { lat: 67.25449218749998, lng: 43.7824218750001 },
        { lat: 67.32958984375, lng: 43.79570312500002 },
        { lat: 67.43930664062506, lng: 43.85634765625005 },
        { lat: 67.67065429687503, lng: 44.036425781250074 },
        { lat: 67.99560546874997, lng: 44.22539062500002 },
        { lat: 68.07124023437501, lng: 44.231542968750006 },
        { lat: 68.11259765624999, lng: 44.21386718749997 },
        { lat: 68.15444335937498, lng: 44.22646484375005 },
        { lat: 68.25375976562498, lng: 44.20468750000006 },
        { lat: 68.32709960937501, lng: 44.1691406250001 },
        { lat: 68.60854492187497, lng: 43.4040039062501 },
        { lat: 68.63579101562502, lng: 43.35800781250006 },
        { lat: 68.67338867187502, lng: 43.33320312500004 },
        { lat: 68.68173828125002, lng: 43.41328125000004 },
        { lat: 68.67983398437502, lng: 43.471972656250074 },
        { lat: 68.54882812499997, lng: 44.04804687500004 },
        { lat: 68.54174804687503, lng: 44.17529296875003 },
        { lat: 68.57817382812499, lng: 45.078125 },
        { lat: 68.54653320312502, lng: 45.51943359375005 },
        { lat: 68.47968750000001, lng: 45.891992187499994 },
        { lat: 68.291357421875, lng: 46.15839843750009 },
        { lat: 68.11884765625004, lng: 46.42968750000003 },
        { lat: 67.970458984375, lng: 46.68359374999997 },
        { lat: 67.84882812500001, lng: 46.69042968750003 },
        { lat: 67.82368164062504, lng: 46.42890625000004 },
        { lat: 67.81816406250005, lng: 46.17421875 },
        { lat: 67.75756835937496, lng: 45.52871093750005 },
        { lat: 67.6888671875, lng: 45.374121093750006 },
        { lat: 67.47744140625002, lng: 44.93945312499997 },
        { lat: 67.41313476562505, lng: 44.90214843750002 },
        { lat: 67.35078124999995, lng: 44.93945312499997 },
        { lat: 67.28471679687502, lng: 45.13886718750004 },
        { lat: 67.18559570312507, lng: 45.56220703125004 },
        { lat: 66.98916015625002, lng: 45.752539062500006 },
        { lat: 66.891064453125, lng: 45.88535156250006 },
        { lat: 66.853125, lng: 45.98603515625004 },
        { lat: 66.843505859375, lng: 46.08398437500002 },
        { lat: 66.84282226562505, lng: 46.29775390625005 },
        { lat: 66.818994140625, lng: 46.44853515625002 },
        { lat: 66.80019531249997, lng: 46.49238281250009 },
        { lat: 66.818994140625, lng: 46.55234375000006 },
        { lat: 66.82553710937498, lng: 46.690820312499994 },
        { lat: 66.929833984375, lng: 47.49648437499999 },
        { lat: 66.97592773437498, lng: 47.65585937500006 },
        { lat: 67.04501953125003, lng: 47.70908203125006 },
        { lat: 67.27563476562503, lng: 47.76806640625003 },
        { lat: 67.355712890625, lng: 47.83925781250005 },
        { lat: 67.4546875, lng: 47.90820312499997 },
        { lat: 67.51533203125001, lng: 47.88261718750007 },
        { lat: 67.58417968749998, lng: 47.87470703125004 },
        { lat: 67.65039062499997, lng: 48.27871093750005 },
        { lat: 67.69526367187498, lng: 48.65380859374997 },
        { lat: 67.681494140625, lng: 48.83320312500004 },
        { lat: 67.73134765625005, lng: 48.87792968749997 },
        { lat: 67.827001953125, lng: 48.76269531249997 },
        { lat: 67.87421875000001, lng: 48.69570312499999 },
        { lat: 67.89594726562501, lng: 48.75429687500005 },
        { lat: 67.8697265625, lng: 48.840625 },
        { lat: 67.85380859375003, lng: 48.95390625000002 },
        { lat: 67.87041015625005, lng: 49.15527343750003 },
        { lat: 68.06513671875001, lng: 49.93125 },
        { lat: 68.17534179687499, lng: 50.233203125000074 },
        { lat: 68.21835937500006, lng: 50.41406250000003 },
        { lat: 68.31772460937503, lng: 50.6994140625001 },
        { lat: 68.34995117187503, lng: 50.83886718749997 },
        { lat: 68.36333007812502, lng: 51.078515625000044 },
        { lat: 68.40244140624998, lng: 51.33613281250004 },
        { lat: 68.47631835937503, lng: 51.61669921874997 },
        { lat: 68.53876953124995, lng: 51.9947265625 },
        { lat: 68.54130859375005, lng: 52.05566406249997 },
        { lat: 68.53203125000002, lng: 52.12880859375005 },
        { lat: 68.459375, lng: 52.28535156250004 },
        { lat: 68.418603515625, lng: 52.227441406249994 },
        { lat: 68.37426757812503, lng: 52.18349609374999 },
        { lat: 68.35092773437496, lng: 52.259179687500044 },
        { lat: 68.339697265625, lng: 52.32226562500003 },
        { lat: 68.35170898437505, lng: 52.3966796875001 },
        { lat: 68.38212890625, lng: 52.475 },
        { lat: 68.42675781249997, lng: 52.66972656250002 },
        { lat: 68.484033203125, lng: 52.72265624999997 },
        { lat: 68.50615234375007, lng: 52.64765625000004 },
        { lat: 68.59243164062497, lng: 52.550097656250074 },
        { lat: 68.61020507812503, lng: 52.43505859375003 },
        { lat: 68.60815429687497, lng: 52.34404296875002 },
        { lat: 68.731201171875, lng: 52.68359375000003 },
        { lat: 68.91254882812497, lng: 53.41289062500001 },
        { lat: 68.9958984375, lng: 53.80195312500004 },
        { lat: 69.00332031250002, lng: 54.185839843750074 },
        { lat: 68.992333984375, lng: 54.49121093750003 },
        { lat: 68.96474609374997, lng: 54.376269531250074 },
        { lat: 68.926611328125, lng: 53.87441406250005 },
        { lat: 68.90747070312503, lng: 53.79765625000007 },
        { lat: 68.88466796875, lng: 53.79824218749999 },
        { lat: 68.87124023437501, lng: 53.91953125 },
        { lat: 68.84428710937502, lng: 53.970605468749994 },
        { lat: 68.811865234375, lng: 53.92929687500006 },
        { lat: 68.80151367187501, lng: 53.891210937500006 },
        { lat: 68.70893554687497, lng: 53.83388671875005 },
        { lat: 68.63398437499998, lng: 53.75888671875006 },
        { lat: 68.53696289062503, lng: 53.9176757812501 },
        { lat: 68.43554687499997, lng: 53.9308593750001 },
        { lat: 68.38266601562503, lng: 53.82949218750005 },
        { lat: 68.4025390625, lng: 53.69003906250006 },
        { lat: 68.36708984374995, lng: 53.566699218750074 },
        { lat: 68.34321289062501, lng: 53.342578125000074 },
        { lat: 68.31166992187497, lng: 53.29335937499999 },
        { lat: 68.26748046875002, lng: 53.260546875000074 },
        { lat: 68.2568359375, lng: 53.403125 },
        { lat: 68.25966796875002, lng: 53.51513671874997 },
        { lat: 68.231201171875, lng: 53.91367187500006 },
        { lat: 68.22734375000002, lng: 53.967871093750006 },
        { lat: 68.259033203125, lng: 54.09921875 },
        { lat: 68.26630859374995, lng: 54.232910156249964 },
        { lat: 68.27509765624998, lng: 54.39394531250005 },
        { lat: 68.29414062499995, lng: 54.476171875 },
        { lat: 68.273046875, lng: 54.5612304687501 },
        { lat: 68.1841796875, lng: 54.71796875000004 },
        { lat: 68.20185546874998, lng: 54.86132812500003 },
        { lat: 68.37382812500002, lng: 54.9230468750001 },
        { lat: 68.48002929687499, lng: 55.15087890624997 },
        { lat: 68.56782226562501, lng: 55.418066406250006 },
        { lat: 68.57587890624998, lng: 55.67529296875003 },
        { lat: 68.63730468750006, lng: 55.92460937500002 },
        { lat: 68.64887695312501, lng: 56.04365234375004 },
        { lat: 68.62407226562502, lng: 56.275683593750074 },
        { lat: 68.61904296874997, lng: 56.62021484375006 },
        { lat: 68.56669921875005, lng: 56.909375 },
        { lat: 68.55400390625005, lng: 57.126855468749994 },
        { lat: 68.64150390625001, lng: 57.44433593750002 },
        { lat: 68.88974609375006, lng: 58.17304687500003 },
        { lat: 68.83393554687495, lng: 58.23701171875005 },
        { lat: 68.91621093750004, lng: 58.35390625000005 },
        { lat: 69.00380859375002, lng: 58.918945312499964 },
        { lat: 69.00605468750004, lng: 59.0573242187501 },
        { lat: 68.97255859374997, lng: 59.059863281250074 },
        { lat: 68.89628906250005, lng: 59.11015625000001 },
        { lat: 68.84960937500004, lng: 59.22041015625009 },
        { lat: 68.73837890625003, lng: 59.37050781250005 },
        { lat: 68.70844726562498, lng: 59.29833984374997 },
        { lat: 68.69130859375005, lng: 59.222558593749994 },
        { lat: 68.61630859375003, lng: 59.11230468750002 },
        { lat: 68.4443359375, lng: 59.099023437500044 },
        { lat: 68.40029296875, lng: 59.31074218750004 },
        { lat: 68.351123046875, lng: 59.60429687500008 },
        { lat: 68.35161132812502, lng: 59.725683593750006 },
        { lat: 68.38032226562501, lng: 59.82753906250006 },
        { lat: 68.39604492187502, lng: 59.858789062500044 },
        { lat: 68.42192382812505, lng: 59.897363281249994 },
        { lat: 68.471337890625, lng: 59.92285156250003 },
        { lat: 68.51049804687497, lng: 59.941406249999964 },
        { lat: 68.60493164062503, lng: 59.865136718749994 },
        { lat: 68.70634765624999, lng: 59.89599609374997 },
        { lat: 68.69951171875002, lng: 60.160253906250055 },
        { lat: 68.72895507812498, lng: 60.48916015624999 },
        { lat: 68.78701171875, lng: 60.637695312499964 },
        { lat: 68.89521484375001, lng: 60.81513671875009 },
        { lat: 68.986767578125, lng: 60.933593749999964 },
        { lat: 69.14550781250003, lng: 60.85859375000003 },
        { lat: 69.11025390625002, lng: 60.66455078124997 },
        { lat: 69.45703124999997, lng: 60.337304687499994 },
        { lat: 69.59091796875, lng: 60.17060546875004 },
        { lat: 69.65263671875005, lng: 60.276464843750006 },
        { lat: 69.69233398437495, lng: 60.55869140625006 },
        { lat: 69.821142578125, lng: 60.81298828125003 },
        { lat: 69.84711914062495, lng: 60.90908203125005 },
        { lat: 69.85146484374997, lng: 61.01591796875002 },
        { lat: 69.76303710937498, lng: 61.77050781250003 },
        { lat: 69.74311523437501, lng: 62.63125 },
        { lat: 69.67529296875001, lng: 63.36142578125006 },
        { lat: 69.53466796875, lng: 64.19042968750003 },
        { lat: 69.43564453124998, lng: 64.59218750000005 },
        { lat: 69.32539062499998, lng: 64.928515625 },
        { lat: 69.247802734375, lng: 64.89628906250002 },
        { lat: 69.26982421875005, lng: 65.03154296875002 },
        { lat: 69.20136718750004, lng: 65.32675781250006 },
        { lat: 69.17343750000003, lng: 65.5279296875 },
        { lat: 69.13232421875, lng: 65.73574218750005 },
        { lat: 69.077001953125, lng: 65.81269531250008 },
        { lat: 69.03632812499998, lng: 66.08476562500002 },
        { lat: 68.961328125, lng: 66.365625 },
        { lat: 68.94785156249998, lng: 66.41611328125 },
        { lat: 68.89199218749997, lng: 66.7564453125 },
        { lat: 68.87358398437505, lng: 67.00244140625001 },
        { lat: 68.75395507812502, lng: 67.14921875000007 },
        { lat: 68.57929687499995, lng: 67.63964843749997 },
        { lat: 68.513671875, lng: 67.73076171875007 },
        { lat: 68.40366210937506, lng: 68.15693359375004 },
        { lat: 68.31425781250005, lng: 68.37119140625006 },
        { lat: 68.34843749999999, lng: 68.50419921875007 },
        { lat: 68.56743164062502, lng: 68.82949218749998 },
        { lat: 68.81796875, lng: 69.02431640625 },
        { lat: 68.95063476562501, lng: 69.14052734375005 },
        { lat: 68.956201171875, lng: 68.92441406250006 },
        { lat: 68.9173828125, lng: 68.7628906250001 },
        { lat: 68.927392578125, lng: 68.6595703125 },
        { lat: 68.96708984374999, lng: 68.54277343750002 },
        { lat: 69.06757812499995, lng: 68.35507812500006 },
        { lat: 69.23623046875001, lng: 68.11738281250004 },
        { lat: 69.42080078124997, lng: 68.07304687500007 },
        { lat: 69.48002929687505, lng: 68.00585937499997 },
        { lat: 69.52998046875001, lng: 67.77431640625005 },
        { lat: 69.58442382812501, lng: 67.62412109375 },
        { lat: 69.69370117187498, lng: 67.06445312500001 },
        { lat: 69.65556640625002, lng: 66.9640625000001 },
        { lat: 69.5966796875, lng: 66.93417968750006 },
        { lat: 69.55380859374996, lng: 66.89667968750004 },
        { lat: 69.60917968749999, lng: 66.84023437499998 },
        { lat: 69.65922851562503, lng: 66.80400390625002 },
        { lat: 69.74013671875001, lng: 66.80292968750004 },
        { lat: 69.84218750000002, lng: 66.83222656250004 },
        { lat: 70.0142578125, lng: 66.92636718750006 },
        { lat: 70.00561523437499, lng: 67.0690429687501 },
        { lat: 70.03061523437503, lng: 67.14443359375 },
        { lat: 70.10805664062502, lng: 67.23925781250001 },
        { lat: 70.171630859375, lng: 67.19746093750004 },
        { lat: 70.21992187499998, lng: 67.14648437499997 },
        { lat: 70.29511718750001, lng: 67.1568359375 },
        { lat: 70.50009765625003, lng: 67.246875 },
        { lat: 70.73872070312498, lng: 67.28476562500006 },
        { lat: 70.79843749999998, lng: 67.21152343750006 },
        { lat: 70.83754882812502, lng: 67.143359375 },
        { lat: 70.79736328125003, lng: 66.82246093750004 },
        { lat: 70.81850585937497, lng: 66.70224609375006 },
        { lat: 70.86469726562498, lng: 66.67519531250005 },
        { lat: 70.90058593750001, lng: 66.66611328125006 },
        { lat: 70.96235351562498, lng: 66.75878906250003 },
        { lat: 71.06372070312503, lng: 66.8470703125 },
        { lat: 71.04169921874998, lng: 66.69257812500004 },
        { lat: 71.08139648437498, lng: 66.63964843749997 },
        { lat: 71.139892578125, lng: 66.76806640624997 },
        { lat: 71.28237304687497, lng: 66.91757812500006 },
        { lat: 71.34785156249998, lng: 67.27421875000007 },
        { lat: 71.41201171875, lng: 67.54179687500002 },
        { lat: 71.54838867187499, lng: 67.959375 },
        { lat: 71.6828125, lng: 68.2692382812501 },
        { lat: 71.85263671874998, lng: 68.4694335937501 },
        { lat: 72.01274414062499, lng: 68.60742187499996 },
        { lat: 72.39155273437497, lng: 68.82968750000006 },
        { lat: 72.66992187500003, lng: 69.03906249999997 },
        { lat: 72.95551757812495, lng: 69.39140625000007 },
        { lat: 72.98193359375, lng: 69.61181640625003 },
        { lat: 72.9775390625, lng: 69.69433593749997 },
        { lat: 72.95639648437503, lng: 69.70898437500003 },
        { lat: 72.93183593750001, lng: 69.6587890625 },
        { lat: 72.89755859375006, lng: 69.64511718750006 },
        { lat: 72.88496093749998, lng: 69.73828124999997 },
        { lat: 72.88256835937503, lng: 69.8875 },
        { lat: 72.90117187499999, lng: 70.17216796875007 },
        { lat: 72.890380859375, lng: 70.65537109374999 },
        { lat: 72.91367187500003, lng: 71.5001953125001 },
        { lat: 72.902099609375, lng: 71.61699218750006 },
        { lat: 72.819677734375, lng: 71.92958984375 },
        { lat: 72.82900390625002, lng: 72.1009765625 },
        { lat: 72.79033203125005, lng: 72.44638671875 },
        { lat: 72.74448242187503, lng: 72.63378906250003 },
        { lat: 72.69140624999997, lng: 72.812109375 },
        { lat: 72.48295898437505, lng: 72.78740234375002 },
        { lat: 72.3431640625, lng: 72.75292968750003 },
        { lat: 72.079443359375, lng: 72.62441406250005 },
        { lat: 72.01254882812506, lng: 72.57412109374998 },
        { lat: 71.82163085937506, lng: 72.375 },
        { lat: 71.69550781250004, lng: 72.27949218750004 },
        { lat: 71.60917968750002, lng: 72.12968750000007 },
        { lat: 71.54794921874998, lng: 71.91201171875005 },
        { lat: 71.511376953125, lng: 71.884375 },
        { lat: 71.457373046875, lng: 71.86728515625 },
        { lat: 71.30668945312503, lng: 72.07929687500004 },
        { lat: 71.15112304687497, lng: 72.58134765625007 },
        { lat: 70.96323242187498, lng: 72.70449218750005 },
        { lat: 70.82285156249998, lng: 72.73164062500004 },
        { lat: 70.45732421875002, lng: 72.7 },
        { lat: 70.40341796875005, lng: 72.65332031249997 },
        { lat: 70.34555664062498, lng: 72.5619140625 },
        { lat: 70.27495117187499, lng: 72.4694335937501 },
        { lat: 70.172509765625, lng: 72.52968750000005 },
        { lat: 69.793212890625, lng: 72.59941406250002 },
        { lat: 69.48403320312497, lng: 72.615625 },
        { lat: 69.37841796875006, lng: 72.55732421875004 },
        { lat: 69.15424804687504, lng: 72.52705078125004 },
        { lat: 69.08051757812501, lng: 72.52734374999997 },
        { lat: 68.96870117187498, lng: 72.5767578125 },
        { lat: 68.87485351562502, lng: 72.6783203125 },
        { lat: 68.81523437500007, lng: 72.81191406250004 },
        { lat: 68.706787109375, lng: 73.19072265625007 },
        { lat: 68.57451171875005, lng: 73.5480468750001 },
        { lat: 68.53261718750005, lng: 73.57343750000004 },
        { lat: 68.48188476562501, lng: 73.59169921875005 },
        { lat: 68.43076171874998, lng: 73.465234375 },
        { lat: 68.29448242187502, lng: 73.26640625000002 },
        { lat: 68.18134765624998, lng: 73.139453125 },
        { lat: 68.09091796875003, lng: 73.12939453124997 },
        { lat: 67.973046875, lng: 73.17304687500008 },
        { lat: 67.86503906250002, lng: 73.1521484375 },
        { lat: 67.76694335937499, lng: 73.06679687500005 },
        { lat: 67.69624023437501, lng: 72.94873046874997 },
        { lat: 67.58696289062502, lng: 72.59433593750006 },
        { lat: 67.00761718750005, lng: 71.84746093750002 },
        { lat: 66.93969726562497, lng: 71.6681640625001 },
        { lat: 66.96152343749998, lng: 71.36523437500003 },
        { lat: 66.87895507812502, lng: 71.44892578125004 },
        { lat: 66.76044921874995, lng: 71.551171875 },
        { lat: 66.68310546874999, lng: 71.53955078125003 },
        { lat: 66.68671875000004, lng: 71.3419921875001 },
        { lat: 66.60449218749997, lng: 71.065625 },
        { lat: 66.54814453125005, lng: 70.93945312499997 },
        { lat: 66.51943359374995, lng: 70.72490234375007 },
        { lat: 66.54868164062498, lng: 70.56142578125005 },
        { lat: 66.60249023437501, lng: 70.38281249999997 },
        { lat: 66.64760742187497, lng: 70.40888671875004 },
        { lat: 66.66826171875002, lng: 70.4425781250001 },
        { lat: 66.70087890624998, lng: 70.56796875000006 },
        { lat: 66.74531249999998, lng: 70.69072265625002 },
        { lat: 66.75419921875002, lng: 70.63076171875005 },
        { lat: 66.753759765625, lng: 70.57910156250003 },
        { lat: 66.69731445312507, lng: 70.44394531249999 },
        { lat: 66.68579101562503, lng: 70.2833984375001 },
        { lat: 66.75434570312495, lng: 70.09375 },
        { lat: 66.82998046875, lng: 69.9486328125 },
        { lat: 66.84545898437504, lng: 69.8771484375001 },
        { lat: 66.81459960937497, lng: 69.74042968750004 },
        { lat: 66.82861328125, lng: 69.21777343749997 },
        { lat: 66.81591796874997, lng: 69.07871093750006 },
        { lat: 66.78833007812503, lng: 69.01347656250002 },
        { lat: 66.766357421875, lng: 69.05117187500005 },
        { lat: 66.72358398437498, lng: 69.09111328125002 },
        { lat: 66.64072265624998, lng: 69.1439453125 },
        { lat: 66.57866210937505, lng: 69.19433593749997 },
        { lat: 66.51074218749997, lng: 69.41201171875 },
        { lat: 66.48457031249998, lng: 69.70097656250006 },
        { lat: 66.40141601562499, lng: 69.98242187499997 },
        { lat: 66.34238281250005, lng: 70.33945312500006 },
        { lat: 66.36665039062501, lng: 71.14550781250003 },
        { lat: 66.35942382812505, lng: 71.35800781250006 },
        { lat: 66.33374023437497, lng: 71.565625 },
        { lat: 66.24672851562502, lng: 71.91699218749997 },
        { lat: 66.25332031250002, lng: 72.06757812500004 },
        { lat: 66.33212890625, lng: 72.32158203125002 },
        { lat: 66.50654296875001, lng: 72.3839843750001 },
        { lat: 66.56079101562504, lng: 72.4173828125 },
        { lat: 66.80683593749998, lng: 73.34160156250007 },
        { lat: 66.86108398437503, lng: 73.51357421875 },
        { lat: 66.9953125, lng: 73.79208984375 },
        { lat: 67.0849609375, lng: 73.88330078125003 },
        { lat: 67.32768554687505, lng: 73.98623046875005 },
        { lat: 67.41411132812499, lng: 74.07451171875007 },
        { lat: 67.69462890625002, lng: 74.67607421875007 },
        { lat: 67.76635742187497, lng: 74.76953124999997 },
        { lat: 67.89750976562503, lng: 74.78730468750004 },
        { lat: 67.98593750000003, lng: 74.77822265625 },
        { lat: 68.07353515625005, lng: 74.74267578125003 },
        { lat: 68.21831054687505, lng: 74.63242187500006 },
        { lat: 68.303076171875, lng: 74.51123046874997 },
        { lat: 68.42060546874995, lng: 74.39140625000007 },
        { lat: 68.65888671875001, lng: 74.48095703125003 },
        { lat: 68.751220703125, lng: 74.57958984375003 },
        { lat: 68.86171875000002, lng: 75.12460937500006 },
        { lat: 68.90117187499999, lng: 75.5895507812501 },
        { lat: 68.975732421875, lng: 76.10751953125006 },
        { lat: 68.99150390624997, lng: 76.3160156250001 },
        { lat: 68.97827148437497, lng: 76.45917968750004 },
        { lat: 68.89760742187497, lng: 76.60576171875007 },
        { lat: 68.77690429687507, lng: 76.73505859375004 },
        { lat: 68.59619140625003, lng: 77.11171875000005 },
        { lat: 68.46958007812498, lng: 77.2384765625001 },
        { lat: 68.31557617187497, lng: 77.26103515625007 },
        { lat: 67.94101562500003, lng: 77.2484375 },
        { lat: 67.77851562499998, lng: 77.17441406250012 },
        { lat: 67.73564453125005, lng: 77.32509765624998 },
        { lat: 67.69868164062495, lng: 77.39560546875006 },
        { lat: 67.6439453125, lng: 77.57919921875006 },
        { lat: 67.58959960937503, lng: 77.67509765625007 },
        { lat: 67.57026367187501, lng: 77.77158203125006 },
        { lat: 67.55917968750006, lng: 77.98554687500004 },
        { lat: 67.57846679687498, lng: 78.5895507812501 },
        { lat: 67.58911132812503, lng: 78.92246093750006 },
        { lat: 67.61313476562503, lng: 78.88759765625 },
        { lat: 67.63120117187498, lng: 78.83906250000004 },
        { lat: 67.63911132812498, lng: 78.55908203125003 },
        { lat: 67.678369140625, lng: 78.16123046875005 },
        { lat: 67.75190429687498, lng: 77.58828125000004 },
        { lat: 67.90961914062495, lng: 77.52011718750012 },
        { lat: 68.00766601562503, lng: 77.5359375 },
        { lat: 68.19038085937495, lng: 77.66484375 },
        { lat: 68.22236328124998, lng: 77.75683593750003 },
        { lat: 68.234716796875, lng: 77.86826171875006 },
        { lat: 68.25947265624998, lng: 77.99511718749996 },
        { lat: 68.37705078125006, lng: 77.9586914062501 },
        { lat: 68.482275390625, lng: 77.90683593750012 },
        { lat: 68.63046874999998, lng: 77.7852539062501 },
        { lat: 68.90302734375001, lng: 77.65068359375007 },
        { lat: 68.90512695312498, lng: 77.46630859374997 },
        { lat: 68.95864257812497, lng: 77.32832031250004 },
        { lat: 69.11738281249998, lng: 76.64492187500005 },
        { lat: 69.23505859374998, lng: 76.00097656249997 },
        { lat: 69.251806640625, lng: 75.56113281250006 },
        { lat: 69.23862304687498, lng: 75.42001953125 },
        { lat: 69.11630859375003, lng: 75.05351562500002 },
        { lat: 69.09057617187503, lng: 74.81484375 },
        { lat: 69.144580078125, lng: 74.36259765625007 },
        { lat: 69.11464843750005, lng: 73.97744140625 },
        { lat: 69.143212890625, lng: 73.83603515625006 },
        { lat: 69.19824218750001, lng: 73.77568359375002 },
        { lat: 69.41796875000003, lng: 73.89091796875006 },
        { lat: 69.50390625000003, lng: 73.8327148437501 },
        { lat: 69.61708984375, lng: 73.66328125000004 },
        { lat: 69.70722656249998, lng: 73.56015625 },
        { lat: 69.80297851562503, lng: 73.578125 },
        { lat: 70.17568359375002, lng: 73.83017578125 },
        { lat: 70.27285156250001, lng: 73.93740234375005 },
        { lat: 70.445458984375, lng: 74.20673828125008 },
        { lat: 70.57871093749998, lng: 74.34335937500006 },
        { lat: 70.65361328125005, lng: 74.3109375 },
        { lat: 71.06870117187506, lng: 73.73154296875 },
        { lat: 71.21650390624995, lng: 73.57656250000004 },
        { lat: 71.26352539062503, lng: 73.50722656250005 },
        { lat: 71.31977539062495, lng: 73.36523437499997 },
        { lat: 71.38520507812495, lng: 73.15048828125 },
        { lat: 71.44492187500005, lng: 73.08623046875006 },
        { lat: 71.84506835937502, lng: 73.67177734375 },
        { lat: 71.91474609375001, lng: 73.93945312499997 },
        { lat: 71.95781249999999, lng: 74.31123046875004 },
        { lat: 71.99702148437498, lng: 74.48906250000007 },
        { lat: 72.07739257812503, lng: 74.80410156250004 },
        { lat: 72.14482421874999, lng: 74.99218749999997 },
        { lat: 72.19921874999997, lng: 75.05322265624997 },
        { lat: 72.26313476562504, lng: 75.08994140624999 },
        { lat: 72.42065429687497, lng: 75.09707031250005 },
        { lat: 72.54877929687495, lng: 75.0603515625 },
        { lat: 72.61943359375005, lng: 75.00800781250008 },
        { lat: 72.71010742187497, lng: 74.896875 },
        { lat: 72.811865234375, lng: 74.78681640625004 },
        { lat: 72.83842773437499, lng: 74.86494140625008 },
        { lat: 72.85380859375002, lng: 74.94218750000002 },
        { lat: 72.85273437499998, lng: 75.15244140625 },
        { lat: 72.796630859375, lng: 75.3693359375001 },
        { lat: 72.68500976562501, lng: 75.47490234375007 },
        { lat: 72.58105468750006, lng: 75.60351562499997 },
        { lat: 72.51215820312495, lng: 75.603125 },
        { lat: 72.45722656249995, lng: 75.59140625 },
        { lat: 72.38227539062494, lng: 75.64433593750007 },
        { lat: 72.35, lng: 75.6911132812501 },
        { lat: 72.29624023437503, lng: 75.74140625000004 },
        { lat: 72.25351562500003, lng: 75.69443359375006 },
        { lat: 72.23232421874997, lng: 75.64433593750007 },
        { lat: 72.17080078124997, lng: 75.55019531250005 },
        { lat: 71.98320312500002, lng: 75.39453124999997 },
        { lat: 71.95893554687495, lng: 75.273828125 },
        { lat: 71.81337890624997, lng: 75.2474609375 },
        { lat: 71.65463867187506, lng: 75.50322265625006 },
        { lat: 71.534375, lng: 75.46855468750002 },
        { lat: 71.49467773437507, lng: 75.41718750000004 },
        { lat: 71.43007812500004, lng: 75.28027343749997 },
        { lat: 71.378466796875, lng: 75.29804687500004 },
        { lat: 71.34174804687498, lng: 75.33203125000003 },
        { lat: 71.26591796874999, lng: 75.73359375000004 },
        { lat: 71.21855468750002, lng: 76.11044921875006 },
        { lat: 71.20205078125005, lng: 76.74199218750002 },
        { lat: 71.12788085937504, lng: 76.92900390625002 },
        { lat: 71.18105468750002, lng: 76.99521484375012 },
        { lat: 71.16791992187501, lng: 77.58964843750007 },
        { lat: 70.98632812499997, lng: 78.06826171875005 },
        { lat: 70.93041992187503, lng: 78.32060546875002 },
        { lat: 70.91181640624998, lng: 78.52578125 },
        { lat: 70.9337890625, lng: 78.94218750000002 },
        { lat: 70.95019531249997, lng: 79.01542968750002 },
        { lat: 71.00200195312505, lng: 79.08388671875 },
        { lat: 70.99716796875003, lng: 78.88867187500003 },
        { lat: 70.97353515625002, lng: 78.80351562500002 },
        { lat: 70.97597656249998, lng: 78.72392578125002 },
        { lat: 70.993896484375, lng: 78.58769531250007 },
        { lat: 71.02539062500003, lng: 78.4914062500001 },
        { lat: 71.08710937499998, lng: 78.38652343750002 },
        { lat: 71.26630859374998, lng: 78.21259765625004 },
        { lat: 71.32407226562503, lng: 77.90839843750008 },
        { lat: 71.30058593750005, lng: 77.70664062500006 },
        { lat: 71.31157226562507, lng: 77.48105468750006 },
        { lat: 71.409375, lng: 77.11367187499998 },
        { lat: 71.44658203125005, lng: 76.87119140625006 },
        { lat: 71.55249023437503, lng: 76.43339843750002 },
        { lat: 71.595458984375, lng: 76.31210937500012 },
        { lat: 71.68286132812503, lng: 76.21572265625 },
        { lat: 71.82900390624997, lng: 76.10361328125012 },
        { lat: 71.91040039062503, lng: 76.03242187500004 },
        { lat: 71.92661132812503, lng: 76.12402343749997 },
        { lat: 72.00600585937495, lng: 76.42167968750007 },
        { lat: 72.03300781250005, lng: 76.87138671875 },
        { lat: 72.00419921875005, lng: 77.06132812500007 },
        { lat: 71.84208984375005, lng: 77.55078124999997 },
        { lat: 71.83642578125006, lng: 77.77753906250004 },
        { lat: 71.90708007812506, lng: 78.18691406250005 },
        { lat: 71.95229492187502, lng: 78.23242187500003 },
        { lat: 72.04467773437503, lng: 78.1408203125001 },
        { lat: 72.092041015625, lng: 78.01640625000007 },
        { lat: 72.11430664062499, lng: 77.7806640625 },
        { lat: 72.07172851562504, lng: 77.49287109375004 },
        { lat: 72.107763671875, lng: 77.41083984375004 },
        { lat: 72.15654296874999, lng: 77.43974609375007 },
        { lat: 72.19213867187506, lng: 77.47158203125 },
        { lat: 72.20141601562497, lng: 77.62529296875002 },
        { lat: 72.22919921874995, lng: 77.73320312500007 },
        { lat: 72.32871093749998, lng: 77.9681640625 },
        { lat: 72.37744140625006, lng: 78.22539062500006 },
        { lat: 72.39497070312498, lng: 78.4826171875001 },
        { lat: 72.38076171875002, lng: 79.42207031250008 },
        { lat: 72.22304687500002, lng: 79.95390625000007 },
        { lat: 72.153125, lng: 80.4740234375 },
        { lat: 72.09829101562502, lng: 80.69921875000001 },
        { lat: 72.08916015625002, lng: 80.7625 },
        { lat: 72.05429687500002, lng: 80.81474609375 },
        { lat: 71.97021484375003, lng: 80.85605468750006 },
        { lat: 71.74614257812505, lng: 81.51123046874997 },
        { lat: 71.71596679687502, lng: 81.66162109374997 },
        { lat: 71.7068359375, lng: 82.07988281250002 },
        { lat: 71.75859375000002, lng: 82.547265625 },
        { lat: 71.76411132812498, lng: 82.75781250000003 },
        { lat: 71.74868164062502, lng: 82.98613281250007 },
        { lat: 71.72050781250006, lng: 83.10664062500004 },
        { lat: 71.66816406249995, lng: 83.23359375000004 },
        { lat: 71.60219726562502, lng: 83.16552734375003 },
        { lat: 71.56245117187501, lng: 83.1056640625001 },
        { lat: 71.45136718750004, lng: 82.97705078125003 },
        { lat: 71.41992187500003, lng: 82.91796874999996 },
        { lat: 71.29287109375, lng: 82.49316406250003 },
        { lat: 71.26000976562503, lng: 82.32285156250006 },
        { lat: 71.09345703125004, lng: 82.27695312500012 },
        { lat: 71.05620117187497, lng: 82.25429687499998 },
        { lat: 70.99770507812497, lng: 82.23916015625005 },
        { lat: 70.87944335937505, lng: 82.31601562500005 },
        { lat: 70.80737304687503, lng: 82.33593749999997 },
        { lat: 70.70673828125004, lng: 82.2707031250001 },
        { lat: 70.59814453125003, lng: 82.16318359375012 },
        { lat: 70.51147460937503, lng: 82.18242187500002 },
        { lat: 70.39570312499998, lng: 82.22119140625003 },
        { lat: 70.4302734375, lng: 82.23583984374996 },
        { lat: 70.48291015625, lng: 82.23144531249997 },
        { lat: 70.54360351562502, lng: 82.25839843750006 },
        { lat: 70.69008789062502, lng: 82.45166015624997 },
        { lat: 70.88994140625005, lng: 82.5924804687501 },
        { lat: 70.94208984375001, lng: 82.73779296875003 },
        { lat: 70.95483398437503, lng: 82.86914062499997 },
        { lat: 70.89541015625002, lng: 83.01015625 },
        { lat: 70.81523437500002, lng: 83.05107421875007 },
        { lat: 70.6947265625, lng: 83.05839843750007 },
        { lat: 70.58051757812497, lng: 83.03017578125 },
        { lat: 70.40742187499998, lng: 82.91982421875 },
        { lat: 70.28647460937503, lng: 82.74248046875002 },
        { lat: 70.21772460937498, lng: 82.6823242187501 },
        { lat: 70.15405273437497, lng: 82.7672851562501 },
        { lat: 70.10454101562502, lng: 82.85654296875006 },
        { lat: 70.08828124999997, lng: 82.9610351562501 },
        { lat: 70.09301757812497, lng: 83.08076171875008 },
        { lat: 70.10957031249995, lng: 83.1095703125001 },
        { lat: 70.15717773437498, lng: 83.13203125000004 },
        { lat: 70.22109375000002, lng: 83.09414062500005 },
        { lat: 70.276708984375, lng: 83.0738281250001 },
        { lat: 70.32133789062502, lng: 83.29345703124997 },
        { lat: 70.34526367187502, lng: 83.49707031249997 },
        { lat: 70.418359375, lng: 83.65986328125004 },
        { lat: 70.46640625, lng: 83.70048828125002 },
        { lat: 70.54648437499998, lng: 83.73593750000005 },
        { lat: 70.672216796875, lng: 83.65126953125004 },
        { lat: 70.76591796875002, lng: 83.57890625000007 },
        { lat: 70.98852539062496, lng: 83.33388671875005 },
        { lat: 71.10361328124998, lng: 83.15126953125005 },
        { lat: 71.27587890624997, lng: 83.266015625 },
        { lat: 71.46752929687503, lng: 83.45761718750012 },
        { lat: 71.51425781250006, lng: 83.53105468750007 },
        { lat: 71.54365234375001, lng: 83.55048828125004 },
        { lat: 71.59438476562502, lng: 83.57128906250003 },
        { lat: 71.64980468750005, lng: 83.55351562500002 },
        { lat: 71.68393554687498, lng: 83.534375 },
        { lat: 71.82753906250002, lng: 83.34042968750006 },
        { lat: 71.87470703125004, lng: 83.20029296875012 },
        { lat: 71.90283203125, lng: 82.7550781250001 },
        { lat: 71.92524414062504, lng: 82.64541015625005 },
        { lat: 72.07182617187505, lng: 82.31914062500002 },
        { lat: 72.105126953125, lng: 82.2806640625 },
        { lat: 72.21118164062503, lng: 82.20927734375 },
        { lat: 72.23754882812497, lng: 82.18359375000003 },
        { lat: 72.26542968750005, lng: 82.09365234374998 },
        { lat: 72.32661132812498, lng: 81.79287109375 },
        { lat: 72.35170898437505, lng: 81.58623046875007 },
        { lat: 72.35883789062498, lng: 81.28271484374997 },
        { lat: 72.38974609374998, lng: 81.09814453125001 },
        { lat: 72.48828124999997, lng: 80.82705078125005 },
        { lat: 72.51997070312495, lng: 80.79775390625005 },
        { lat: 72.64790039062498, lng: 80.71962890625 },
        { lat: 72.71201171875, lng: 80.65625 },
        { lat: 72.75917968750002, lng: 80.67539062500006 },
        { lat: 72.86079101562501, lng: 80.77373046875002 },
        { lat: 72.94916992187498, lng: 80.84160156250007 },
        { lat: 73.02524414062503, lng: 80.75742187500006 },
        { lat: 73.04916992187503, lng: 80.63867187500001 },
        { lat: 73.086083984375, lng: 80.50966796875005 },
        { lat: 73.15522460937495, lng: 80.45546875 },
        { lat: 73.23115234374998, lng: 80.4245117187501 },
        { lat: 73.2896484375, lng: 80.41894531250003 },
        { lat: 73.3568359375, lng: 80.39804687500012 },
        { lat: 73.41372070312504, lng: 80.45830078125007 },
        { lat: 73.47402343749998, lng: 80.59589843750004 },
        { lat: 73.51499023437498, lng: 80.56191406250005 },
        { lat: 73.56845703125003, lng: 80.5832031250001 },
        { lat: 73.64042968750005, lng: 81.46884765625006 },
        { lat: 73.65883789062497, lng: 81.81699218750012 },
        { lat: 73.66650390625003, lng: 83.54472656250002 },
        { lat: 73.68647460937501, lng: 83.66699218749996 },
        { lat: 73.72202148437498, lng: 84.4173828125 },
        { lat: 73.76284179687502, lng: 84.73789062500006 },
        { lat: 73.71953124999999, lng: 85.07744140625007 },
        { lat: 73.72153320312506, lng: 85.20058593750005 },
        { lat: 73.73461914062506, lng: 85.44833984375006 },
        { lat: 73.82158203125, lng: 85.61142578125006 },
        { lat: 73.85693359375, lng: 85.979296875 },
        { lat: 73.89428710937497, lng: 86.59140625000006 },
        { lat: 73.887109375, lng: 86.89296875 },
        { lat: 73.8607421875, lng: 86.961328125 },
        { lat: 73.82416992187501, lng: 87.02949218750004 },
        { lat: 73.71684570312499, lng: 86.69765625 },
        { lat: 73.61977539062502, lng: 86.36591796875004 },
        { lat: 73.57832031250001, lng: 86.094140625 },
        { lat: 73.49277343749998, lng: 85.82705078125005 },
        { lat: 73.45893554687501, lng: 85.80048828125003 },
        { lat: 73.438330078125, lng: 85.79257812500012 },
        { lat: 73.3716796875, lng: 85.8024414062501 },
        { lat: 73.32695312500005, lng: 85.81816406250007 },
        { lat: 73.272607421875, lng: 86.09814453125003 },
        { lat: 73.19575195312495, lng: 86.30791015625002 },
        { lat: 73.14047851562498, lng: 86.5143554687501 },
        { lat: 73.10678710937503, lng: 86.67705078125002 },
        { lat: 73.125830078125, lng: 86.7150390625001 },
        { lat: 73.30673828125, lng: 86.12167968750012 },
        { lat: 73.34707031249997, lng: 85.97080078125006 },
        { lat: 73.39042968750002, lng: 85.91005859375005 },
        { lat: 73.45649414062495, lng: 85.93896484374997 },
        { lat: 73.48583984375, lng: 85.99892578125005 },
        { lat: 73.51914062500003, lng: 86.09238281250005 },
        { lat: 73.53466796874999, lng: 86.15507812500006 },
        { lat: 73.56884765625003, lng: 86.37626953125002 },
        { lat: 73.6150390625, lng: 87.12011718750003 },
        { lat: 73.7046875, lng: 87.29443359375003 },
        { lat: 73.75590820312505, lng: 87.36953125000005 },
        { lat: 73.81074218750001, lng: 87.57119140625 },
        { lat: 73.83247070312501, lng: 87.50322265625002 },
        { lat: 73.846044921875, lng: 87.3375 },
        { lat: 73.878662109375, lng: 87.20966796875004 },
        { lat: 74.19531250000003, lng: 86.69707031250007 },
        { lat: 74.24375, lng: 86.57109375000007 },
        { lat: 74.27939453125, lng: 86.17783203125006 },
        { lat: 74.316015625, lng: 86.0013671875 },
        { lat: 74.42304687499998, lng: 86.18291015625007 },
        { lat: 74.45009765624997, lng: 86.39580078125007 },
        { lat: 74.44423828125002, lng: 86.5384765625 },
        { lat: 74.41425781249995, lng: 86.66474609375004 },
        { lat: 74.32534179687497, lng: 86.89794921874996 },
        { lat: 74.3638671875, lng: 87.22968750000004 },
        { lat: 74.403564453125, lng: 87.10615234375004 },
        { lat: 74.44970703124997, lng: 86.8942382812501 },
        { lat: 74.52246093749996, lng: 86.70009765624998 },
        { lat: 74.58549804687502, lng: 86.42568359375005 },
        { lat: 74.628564453125, lng: 86.11611328125005 },
        { lat: 74.6451171875, lng: 85.79101562499997 },
        { lat: 74.74023437500003, lng: 85.88076171875005 },
        { lat: 74.72822265624998, lng: 86.05888671875002 },
        { lat: 74.75742187500006, lng: 86.11953125 },
        { lat: 74.81621093750005, lng: 86.20126953125006 },
        { lat: 74.68242187500005, lng: 86.6514648437501 },
        { lat: 74.71787109374999, lng: 86.8628906250001 },
        { lat: 74.77885742187499, lng: 87.04179687500007 },
        { lat: 74.94091796875006, lng: 87.41933593750005 },
        { lat: 75.01323242187505, lng: 87.467578125 },
        { lat: 75.05253906250005, lng: 87.28740234375002 },
        { lat: 75.07226562499997, lng: 87.14072265625006 },
        { lat: 75.06811523437503, lng: 86.93906250000006 },
        { lat: 75.11279296874997, lng: 86.92167968750002 },
        { lat: 75.16982421874997, lng: 87.0059570312501 },
        { lat: 75.19174804687498, lng: 87.17080078125005 },
        { lat: 75.12958984375003, lng: 87.67138671874997 },
        { lat: 75.29047851562504, lng: 88.50371093750007 },
        { lat: 75.36918945312499, lng: 88.7331054687501 },
        { lat: 75.47011718750002, lng: 89.3102539062501 },
        { lat: 75.45825195312503, lng: 89.59511718750005 },
        { lat: 75.59106445312497, lng: 90.18496093750005 },
        { lat: 75.649560546875, lng: 91.00468750000006 },
        { lat: 75.64965820312503, lng: 91.47949218749997 },
        { lat: 75.72368164062499, lng: 91.8454101562501 },
        { lat: 75.74965820312497, lng: 92.40751953125002 },
        { lat: 75.7791015625, lng: 92.60253906249997 },
        { lat: 75.8541015625, lng: 93.54980468750003 },
        { lat: 75.91289062499997, lng: 94.07519531249997 },
        { lat: 75.95922851562503, lng: 94.15634765625006 },
        { lat: 75.92158203124998, lng: 93.68701171875003 },
        { lat: 75.95629882812506, lng: 93.57402343750002 },
        { lat: 75.93286132812497, lng: 93.47548828124998 },
        { lat: 75.90126953125002, lng: 93.40605468750007 },
        { lat: 75.95898437499997, lng: 93.178125 },
        { lat: 75.94462890624999, lng: 93.11630859375012 },
        { lat: 75.912841796875, lng: 93.06865234375006 },
        { lat: 75.90268554687505, lng: 92.98662109375007 },
        { lat: 75.90996093750002, lng: 92.89042968750002 },
        { lat: 75.97949218749997, lng: 92.8585937500001 },
        { lat: 76.07509765625, lng: 92.97158203125 },
        { lat: 76.02583007812501, lng: 93.10488281249998 },
        { lat: 76.09877929687502, lng: 93.25927734375003 },
        { lat: 76.100732421875, lng: 93.3595703125001 },
        { lat: 76.05415039062501, lng: 93.64843749999997 },
        { lat: 76.10131835937503, lng: 93.84287109375006 },
        { lat: 76.12358398437502, lng: 94.10234375000007 },
        { lat: 76.10278320312504, lng: 94.38828125000006 },
        { lat: 76.10795898437505, lng: 94.50673828125004 },
        { lat: 76.15175781249998, lng: 94.57558593750005 },
        { lat: 76.11352539062503, lng: 95.03847656249998 },
        { lat: 76.13959960937501, lng: 95.35927734375 },
        { lat: 76.13730468749998, lng: 95.57871093750012 },
        { lat: 76.11313476562503, lng: 95.91992187499996 },
        { lat: 76.08198242187497, lng: 96.07548828125006 },
        { lat: 76.00966796875, lng: 95.98603515625004 },
        { lat: 75.89218750000003, lng: 95.65332031250003 },
        { lat: 75.872314453125, lng: 95.7438476562501 },
        { lat: 75.926025390625, lng: 95.93476562500008 },
        { lat: 76.00556640624995, lng: 96.50859375 },
        { lat: 75.98989257812497, lng: 96.60058593750003 },
        { lat: 75.921630859375, lng: 96.53769531250005 },
        { lat: 75.89121093750003, lng: 96.49707031249996 },
        { lat: 75.93105468749995, lng: 96.87919921875 },
        { lat: 76.01870117187497, lng: 97.20546875000005 },
        { lat: 76.03339843749995, lng: 97.35068359375006 },
        { lat: 75.98022460937503, lng: 97.49921875000004 },
        { lat: 76.02905273437503, lng: 97.63769531250003 },
        { lat: 76.07802734375, lng: 97.66982421875 },
        { lat: 76.08867187500002, lng: 97.918359375 },
        { lat: 76.13369140625005, lng: 98.02001953125003 },
        { lat: 76.16640625000005, lng: 98.19462890625007 },
        { lat: 76.18056640625, lng: 98.34199218750004 },
        { lat: 76.24267578125003, lng: 98.66201171875005 },
        { lat: 76.22402343749997, lng: 98.7712890625 },
        { lat: 76.20756835937499, lng: 98.98466796875007 },
        { lat: 76.17763671875002, lng: 99.18730468750002 },
        { lat: 76.10932617187495, lng: 99.56269531250004 },
        { lat: 76.08232421875003, lng: 99.615625 },
        { lat: 76.07802734375, lng: 99.66318359375012 },
        { lat: 76.02875976562498, lng: 99.77041015624998 },
        { lat: 75.95634765625006, lng: 99.68925781250007 },
        { lat: 75.85205078125003, lng: 99.60234375000002 },
        { lat: 75.80317382812504, lng: 99.4421875 },
        { lat: 75.79858398437496, lng: 99.5407226562501 },
        { lat: 75.811279296875, lng: 99.609375 },
        { lat: 75.88066406250002, lng: 99.7375 },
        { lat: 75.93027343749998, lng: 99.85136718750007 },
        { lat: 76.13593749999995, lng: 99.8253906250001 },
        { lat: 76.24018554687498, lng: 99.61679687500006 },
        { lat: 76.27509765624998, lng: 99.46064453125003 },
        { lat: 76.38432617187505, lng: 99.09384765625012 },
        { lat: 76.43081054687498, lng: 98.96953125000002 },
        { lat: 76.48066406250004, lng: 98.80566406250003 },
        { lat: 76.50957031250005, lng: 98.86943359375002 },
        { lat: 76.47143554687503, lng: 99.57626953125005 },
        { lat: 76.48989257812505, lng: 99.93574218750004 },
        { lat: 76.479150390625, lng: 100.32236328125012 },
        { lat: 76.52519531250005, lng: 100.84375 },
        { lat: 76.47724609374995, lng: 101.06074218750004 },
        { lat: 76.47890625, lng: 101.31074218750008 },
        { lat: 76.43920898437503, lng: 101.59775390625006 },
        { lat: 76.48549804687505, lng: 101.6837890625001 },
        { lat: 76.53569335937505, lng: 101.21298828125006 },
        { lat: 76.53051757812497, lng: 101.00263671875004 },
        { lat: 76.55673828124998, lng: 100.92802734375002 },
        { lat: 76.61508789062498, lng: 101.00625 },
        { lat: 76.70400390624997, lng: 101.09931640625008 },
        { lat: 76.78134765625, lng: 101.008203125 },
        { lat: 76.82250976562503, lng: 100.92041015624997 },
        { lat: 76.90068359375007, lng: 100.90585937500012 },
        { lat: 76.99047851562497, lng: 100.98994140625004 },
        { lat: 77.028564453125, lng: 101.18574218750004 },
        { lat: 77.10156250000006, lng: 101.29287109375 },
        { lat: 77.198095703125, lng: 101.51767578125005 },
        { lat: 77.508544921875, lng: 102.61015625000007 },
        { lat: 77.62646484375006, lng: 103.13144531250012 },
        { lat: 77.64106445312501, lng: 103.33125 },
        { lat: 77.63193359375, lng: 103.56074218750008 },
        { lat: 77.73041992187501, lng: 104.01455078125 },
        { lat: 77.73046875, lng: 104.18486328125007 },
        { lat: 77.65209960937503, lng: 104.81425781250002 },
      ],
      [
        { lat: 78.13090820312505, lng: 107.69550781250003 },
        { lat: 78.08256835937507, lng: 107.60625 },
        { lat: 78.057763671875, lng: 107.48164062500004 },
        { lat: 78.09858398437494, lng: 107.34384765625006 },
        { lat: 78.09565429687498, lng: 107.00166015625004 },
        { lat: 78.13984375000001, lng: 106.41552734375003 },
        { lat: 78.16757812499998, lng: 106.58330078125 },
        { lat: 78.18940429687498, lng: 107.50830078124996 },
        { lat: 78.18554687499999, lng: 107.57324218749997 },
        { lat: 78.13090820312505, lng: 107.69550781250003 },
      ],
      [
        { lat: 78.20620117187502, lng: 106.27041015625005 },
        { lat: 78.1986328125, lng: 106.15107421875004 },
        { lat: 78.22011718750002, lng: 106.02363281250004 },
        { lat: 78.26464843750003, lng: 106.0583984375 },
        { lat: 78.27260742187497, lng: 106.35058593750003 },
        { lat: 78.34003906250003, lng: 106.45683593750002 },
        { lat: 78.33623046875005, lng: 106.6404296875 },
        { lat: 78.31665039062497, lng: 106.69121093750007 },
        { lat: 78.294189453125, lng: 106.71962890625 },
        { lat: 78.264990234375, lng: 106.71894531250004 },
        { lat: 78.264990234375, lng: 106.67910156249998 },
        { lat: 78.26166992187495, lng: 106.50468750000006 },
        { lat: 78.24501953125002, lng: 106.47246093750007 },
        { lat: 78.20620117187502, lng: 106.27041015625005 },
      ],
      [
        { lat: 79.25395507812505, lng: 102.88476562499997 },
        { lat: 79.17641601562497, lng: 102.7873046875001 },
        { lat: 79.10605468750002, lng: 102.7458007812501 },
        { lat: 78.87666015625001, lng: 102.44785156250012 },
        { lat: 78.83544921874997, lng: 102.4123046875001 },
        { lat: 78.87128906249998, lng: 102.58730468750004 },
        { lat: 78.94956054687502, lng: 102.7476562500001 },
        { lat: 79.01435546875001, lng: 102.84482421875006 },
        { lat: 79.05576171875, lng: 102.9503906250001 },
        { lat: 79.05649414062498, lng: 103.07568359374997 },
        { lat: 79.07128906249997, lng: 103.19912109375005 },
        { lat: 79.12612304687502, lng: 103.4333984375 },
        { lat: 79.15, lng: 103.67285156250003 },
        { lat: 79.14926757812503, lng: 103.80078124999997 },
        { lat: 79.12324218749998, lng: 103.92568359375 },
        { lat: 79.06254882812505, lng: 104.00400390625006 },
        { lat: 79.01318359375003, lng: 104.09111328125007 },
        { lat: 78.97709960937503, lng: 104.40419921875 },
        { lat: 78.96391601562502, lng: 104.44921875000003 },
        { lat: 78.92333984375003, lng: 104.47695312500005 },
        { lat: 78.880029296875, lng: 104.45205078125005 },
        { lat: 78.83515625000001, lng: 104.633203125 },
        { lat: 78.85488281250002, lng: 104.88105468750004 },
        { lat: 78.84331054687507, lng: 105.01464843750003 },
        { lat: 78.81884765625006, lng: 105.14599609375003 },
        { lat: 78.77993164062502, lng: 105.20458984374997 },
        { lat: 78.73300781249998, lng: 105.25605468750004 },
        { lat: 78.66616210937502, lng: 105.31015625000006 },
        { lat: 78.59394531249998, lng: 105.34267578125005 },
        { lat: 78.49990234375, lng: 105.31259765625012 },
        { lat: 78.35273437499995, lng: 104.83261718750006 },
        { lat: 78.33974609374997, lng: 104.74179687500012 },
        { lat: 78.34921875000002, lng: 104.51943359375 },
        { lat: 78.33505859374998, lng: 104.29746093750006 },
        { lat: 78.25825195312498, lng: 103.71933593750006 },
        { lat: 78.25585937500003, lng: 103.003125 },
        { lat: 78.18789062500002, lng: 102.79667968750006 },
        { lat: 78.18989257812498, lng: 102.734375 },
        { lat: 78.20170898437499, lng: 102.67314453125 },
        { lat: 78.22460937500004, lng: 102.61718749999996 },
        { lat: 78.20532226562503, lng: 102.18046875 },
        { lat: 78.1943359375, lng: 101.69238281249997 },
        { lat: 78.19194335937505, lng: 101.20410156249997 },
        { lat: 78.14296875000002, lng: 101.03994140625 },
        { lat: 78.04750976562501, lng: 100.54121093750008 },
        { lat: 77.975, lng: 100.08222656250004 },
        { lat: 77.95683593750002, lng: 99.84501953125002 },
        { lat: 77.97607421875003, lng: 99.50029296875002 },
        { lat: 78.00068359374998, lng: 99.39169921875012 },
        { lat: 78.03808593749996, lng: 99.28710937500003 },
        { lat: 78.08393554687497, lng: 99.4386718750001 },
        { lat: 78.178564453125, lng: 99.54560546875004 },
        { lat: 78.23349609374999, lng: 99.67792968750008 },
        { lat: 78.33891601562507, lng: 100.0189453125 },
        { lat: 78.38037109374997, lng: 100.05751953125004 },
        { lat: 78.47045898437503, lng: 100.12353515624997 },
        { lat: 78.50395507812502, lng: 100.16298828125005 },
        { lat: 78.53579101562502, lng: 100.2150390625001 },
        { lat: 78.57382812500006, lng: 100.25722656250005 },
        { lat: 78.63149414062498, lng: 100.26269531250003 },
        { lat: 78.67919921875003, lng: 100.28398437500002 },
        { lat: 78.753173828125, lng: 100.41640625 },
        { lat: 78.78779296875004, lng: 100.515625 },
        { lat: 78.79741210937503, lng: 100.61962890624997 },
        { lat: 78.78359374999995, lng: 100.87558593750006 },
        { lat: 78.7884765625, lng: 100.9557617187501 },
        { lat: 78.81245117187498, lng: 100.89794921875003 },
        { lat: 78.89775390625005, lng: 100.85625 },
        { lat: 78.92583007812499, lng: 100.86455078125006 },
        { lat: 78.98007812500003, lng: 100.90136718750003 },
        { lat: 79.00654296875, lng: 100.96542968750012 },
        { lat: 79.02329101562503, lng: 101.03085937500012 },
        { lat: 79.09624023437499, lng: 101.06816406250006 },
        { lat: 79.12324218749998, lng: 101.05224609375003 },
        { lat: 79.156884765625, lng: 101.148828125 },
        { lat: 79.204443359375, lng: 101.19609375 },
        { lat: 79.23261718749998, lng: 101.31044921875004 },
        { lat: 79.25444335937507, lng: 101.54306640625012 },
        { lat: 79.31264648437502, lng: 101.55527343750012 },
        { lat: 79.350439453125, lng: 101.590625 },
        { lat: 79.36137695312499, lng: 101.64335937500002 },
        { lat: 79.37197265625002, lng: 101.76132812500006 },
        { lat: 79.37021484375003, lng: 101.82421874999997 },
        { lat: 79.31162109374998, lng: 101.91210937499997 },
        { lat: 79.26367187499999, lng: 102.0052734375 },
        { lat: 79.252490234375, lng: 102.12851562500006 },
        { lat: 79.25605468749995, lng: 102.25126953125002 },
        { lat: 79.31259765625, lng: 102.17724609374997 },
        { lat: 79.37338867187506, lng: 102.18066406249997 },
        { lat: 79.41293945312503, lng: 102.22509765624997 },
        { lat: 79.43007812499997, lng: 102.28242187500008 },
        { lat: 79.43320312499998, lng: 102.40488281250005 },
        { lat: 79.39213867187503, lng: 102.78984375000007 },
        { lat: 79.33154296875006, lng: 103.04160156250012 },
        { lat: 79.29912109375002, lng: 103.09794921875007 },
        { lat: 79.28251953125002, lng: 103.0524414062501 },
        { lat: 79.27119140625001, lng: 102.93964843750003 },
        { lat: 79.25395507812505, lng: 102.88476562499997 },
      ],
      [
        { lat: 79.65107421874995, lng: 76.24892578125005 },
        { lat: 79.61523437500003, lng: 76.37255859374997 },
        { lat: 79.64316406250003, lng: 76.46738281250012 },
        { lat: 79.55683593750004, lng: 77.36015625000002 },
        { lat: 79.52441406249999, lng: 77.54931640625001 },
        { lat: 79.50190429687504, lng: 77.58896484375012 },
        { lat: 79.489501953125, lng: 76.81015625000006 },
        { lat: 79.49340820312499, lng: 76.64951171875012 },
        { lat: 79.54443359375, lng: 76.63652343750002 },
        { lat: 79.54545898437502, lng: 76.4576171875001 },
        { lat: 79.57875976562497, lng: 76.1537109375 },
        { lat: 79.62563476562502, lng: 76.07187500000012 },
        { lat: 79.64472656249998, lng: 76.05156250000007 },
        { lat: 79.66445312500002, lng: 76.14843749999997 },
        { lat: 79.65107421874995, lng: 76.24892578125005 },
      ],
      [
        { lat: 79.61420898437498, lng: 100.13593750000004 },
        { lat: 79.60161132812502, lng: 99.91542968750005 },
        { lat: 79.67143554687502, lng: 99.94228515624998 },
        { lat: 79.69033203124997, lng: 99.9557617187501 },
        { lat: 79.701025390625, lng: 100.06835937500003 },
        { lat: 79.68369140625003, lng: 100.14150390625 },
        { lat: 79.67026367187503, lng: 100.30029296875003 },
        { lat: 79.61420898437498, lng: 100.13593750000004 },
      ],
      [
        { lat: 79.685205078125, lng: 92.68349609375005 },
        { lat: 79.67548828124995, lng: 92.440625 },
        { lat: 79.68466796875006, lng: 92.1537109375 },
        { lat: 79.79057617187505, lng: 91.68359374999997 },
        { lat: 79.83549804687505, lng: 91.37626953125007 },
        { lat: 79.90493164062498, lng: 91.12607421875006 },
        { lat: 79.98149414062505, lng: 91.07031250000003 },
        { lat: 80.03071289062504, lng: 91.22929687500007 },
        { lat: 80.04921874999995, lng: 91.4259765625001 },
        { lat: 80.05229492187499, lng: 91.75195312499997 },
        { lat: 80.04545898437502, lng: 92.17343750000012 },
        { lat: 79.99653320312498, lng: 92.59277343750001 },
        { lat: 79.94111328124998, lng: 93.48154296875005 },
        { lat: 79.904541015625, lng: 93.803125 },
        { lat: 79.81674804687503, lng: 93.60351562499997 },
        { lat: 79.78388671875001, lng: 93.38203125000003 },
        { lat: 79.73759765624999, lng: 93.155078125 },
        { lat: 79.7044921875, lng: 92.92626953125003 },
        { lat: 79.685205078125, lng: 92.68349609375005 },
      ],
      [
        { lat: 79.94423828125, lng: 51.409277343750006 },
        { lat: 79.93193359375007, lng: 51.435156250000055 },
        { lat: 79.92050781250003, lng: 51.43125 },
        { lat: 79.93198242187498, lng: 51.076269531250006 },
        { lat: 79.92441406250003, lng: 50.45410156250003 },
        { lat: 79.98056640625003, lng: 50.09140625 },
        { lat: 80.03544921875002, lng: 50.47265624999997 },
        { lat: 80.04853515625001, lng: 50.67578124999997 },
        { lat: 80.09423828125, lng: 50.93632812500001 },
        { lat: 80.04863281250005, lng: 51.25439453124997 },
        { lat: 80.01035156250006, lng: 51.237890625 },
        { lat: 79.99125976562499, lng: 51.2427734375 },
        { lat: 79.97231445312502, lng: 51.32695312500002 },
        { lat: 79.94423828125, lng: 51.409277343750006 },
      ],
      [
        { lat: 79.95581054687506, lng: 59.688867187500044 },
        { lat: 79.92304687500004, lng: 59.3306640625 },
        { lat: 79.932958984375, lng: 59.20263671875002 },
        { lat: 79.94829101562502, lng: 59.169238281250074 },
        { lat: 79.96416015625005, lng: 59.100390625000074 },
        { lat: 79.98461914062506, lng: 58.91923828125001 },
        { lat: 80.04233398437499, lng: 58.946093750000074 },
        { lat: 80.05390624999995, lng: 59.001464843749964 },
        { lat: 80.11884765624994, lng: 59.544531250000055 },
        { lat: 80.08266601562505, lng: 59.801660156250044 },
        { lat: 79.99428710937497, lng: 59.911035156249994 },
        { lat: 79.95581054687506, lng: 59.688867187500044 },
      ],
      [
        { lat: 80.15825195312499, lng: 97.67451171875004 },
        { lat: 80.09501953124999, lng: 97.90361328125002 },
        { lat: 80.02285156250002, lng: 98.01777343750008 },
        { lat: 80.00375976562502, lng: 97.90673828125001 },
        { lat: 79.95629882812497, lng: 97.80791015625002 },
        { lat: 79.895849609375, lng: 97.75996093750004 },
        { lat: 79.85043945312498, lng: 97.62695312500001 },
        { lat: 79.77495117187505, lng: 97.59130859374997 },
        { lat: 79.76064453125, lng: 97.65166015625002 },
        { lat: 79.78139648437505, lng: 97.72451171875 },
        { lat: 79.85263671874996, lng: 97.87070312500006 },
        { lat: 79.90107421874998, lng: 98.06455078125012 },
        { lat: 79.87412109375, lng: 98.27324218750007 },
        { lat: 79.88432617187505, lng: 98.35312500000012 },
        { lat: 79.953125, lng: 98.49902343749996 },
        { lat: 80.00913085937498, lng: 98.471875 },
        { lat: 80.043603515625, lng: 98.53183593750006 },
        { lat: 80.05219726562495, lng: 98.596484375 },
        { lat: 80.04541015625, lng: 98.86591796875003 },
        { lat: 80.01635742187503, lng: 99.29492187500001 },
        { lat: 79.98637695312505, lng: 99.37070312500012 },
        { lat: 79.97016601562494, lng: 99.47304687499998 },
        { lat: 79.94130859375002, lng: 99.53613281249997 },
        { lat: 79.91992187500001, lng: 99.72656250000003 },
        { lat: 79.89819335937503, lng: 99.81835937499997 },
        { lat: 79.84897460937503, lng: 99.94658203125002 },
        { lat: 79.77709960937506, lng: 100.0612304687501 },
        { lat: 79.73833007812505, lng: 99.91582031250007 },
        { lat: 79.66894531250006, lng: 99.8392578125 },
        { lat: 79.653076171875, lng: 99.80546875000002 },
        { lat: 79.628271484375, lng: 99.78164062499998 },
        { lat: 79.56772460937503, lng: 99.77109375000006 },
        { lat: 79.51518554687497, lng: 99.74882812500002 },
        { lat: 79.49184570312502, lng: 99.72119140625003 },
        { lat: 79.4634765625, lng: 99.70625 },
        { lat: 79.38510742187502, lng: 99.72158203125 },
        { lat: 79.32333984374998, lng: 99.68066406250003 },
        { lat: 79.27656249999995, lng: 99.53730468750004 },
        { lat: 79.27475585937503, lng: 99.3877929687501 },
        { lat: 79.30629882812497, lng: 99.16708984375012 },
        { lat: 79.30537109374995, lng: 99.10439453125005 },
        { lat: 79.29301757812502, lng: 99.04179687500007 },
        { lat: 79.22719726562501, lng: 99.31738281249997 },
        { lat: 79.13017578125006, lng: 99.51728515625004 },
        { lat: 79.107666015625, lng: 99.75078125 },
        { lat: 79.095849609375, lng: 99.81464843750004 },
        { lat: 79.00639648437507, lng: 99.89960937500003 },
        { lat: 78.96142578124997, lng: 99.92929687500012 },
        { lat: 78.85273437500004, lng: 99.5408203125 },
        { lat: 78.834228515625, lng: 99.43955078125012 },
        { lat: 78.81826171875002, lng: 98.8195312500001 },
        { lat: 78.78779296875004, lng: 98.41113281250003 },
        { lat: 78.79501953125, lng: 98.28251953125002 },
        { lat: 78.82099609374995, lng: 98.05419921875003 },
        { lat: 78.81020507812497, lng: 97.90517578125005 },
        { lat: 78.82734375000001, lng: 97.68857421875006 },
        { lat: 78.82656250000002, lng: 97.55546875000002 },
        { lat: 78.86801757812503, lng: 97.24814453125006 },
        { lat: 78.93393554687506, lng: 96.93291015625002 },
        { lat: 78.96381835937501, lng: 96.87119140625006 },
        { lat: 78.98496093750005, lng: 96.80781250000004 },
        { lat: 79.00302734375, lng: 96.42998046875006 },
        { lat: 79.01586914062506, lng: 96.34736328125003 },
        { lat: 79.00141601562504, lng: 95.79648437500005 },
        { lat: 79.01201171875005, lng: 95.7028320312501 },
        { lat: 79.098095703125, lng: 95.53105468750007 },
        { lat: 79.09931640624998, lng: 95.4369140625 },
        { lat: 79.04960937499999, lng: 95.13320312500004 },
        { lat: 79.05268554687498, lng: 95.02041015625005 },
        { lat: 79.08662109374998, lng: 94.79101562499996 },
        { lat: 79.12749023437505, lng: 94.65234375000003 },
        { lat: 79.14086914062503, lng: 94.63164062500006 },
        { lat: 79.19238281250003, lng: 94.61972656250006 },
        { lat: 79.21860351562503, lng: 94.4821289062501 },
        { lat: 79.30751953125005, lng: 94.31376953125007 },
        { lat: 79.40234375, lng: 94.21875 },
        { lat: 79.45141601562504, lng: 93.75859375000002 },
        { lat: 79.46274414062503, lng: 93.47871093750004 },
        { lat: 79.45839843749997, lng: 93.27226562500007 },
        { lat: 79.49531250000001, lng: 93.07080078124997 },
        { lat: 79.63159179687497, lng: 93.40468750000004 },
        { lat: 79.70166015625006, lng: 93.84726562500005 },
        { lat: 79.75600585937502, lng: 94.03818359375006 },
        { lat: 79.82973632812502, lng: 94.25712890625007 },
        { lat: 79.94194335937506, lng: 94.34726562500006 },
        { lat: 80.01123046874997, lng: 94.71943359375004 },
        { lat: 80.03481445312497, lng: 94.81503906250006 },
        { lat: 80.08925781249997, lng: 94.94677734374996 },
        { lat: 80.096826171875, lng: 94.98730468749997 },
        { lat: 80.030517578125, lng: 95.28134765625012 },
        { lat: 80.04213867187505, lng: 95.3379882812501 },
        { lat: 80.07280273437499, lng: 95.39072265625012 },
        { lat: 80.10561523437502, lng: 95.49755859375003 },
        { lat: 80.11000976562502, lng: 95.85781250000005 },
        { lat: 80.096826171875, lng: 96.1625 },
        { lat: 80.11005859375004, lng: 96.27734374999997 },
        { lat: 80.10434570312499, lng: 96.41660156250012 },
        { lat: 80.15302734374998, lng: 97.1205078125 },
        { lat: 80.16826171874999, lng: 97.58681640625005 },
        { lat: 80.15825195312499, lng: 97.67451171875004 },
      ],
      [
        { lat: 80.07431640625003, lng: 50.05175781250003 },
        { lat: 80.0607421875, lng: 49.9708984375001 },
        { lat: 80.13613281250002, lng: 49.58828125 },
        { lat: 80.15893554687503, lng: 49.556054687500044 },
        { lat: 80.230224609375, lng: 49.883691406249994 },
        { lat: 80.21948242187503, lng: 50.25097656250003 },
        { lat: 80.18564453124998, lng: 50.30996093750005 },
        { lat: 80.17236328125003, lng: 50.319140625000074 },
        { lat: 80.10947265625, lng: 50.07226562500003 },
        { lat: 80.07431640625003, lng: 50.05175781250003 },
      ],
      [
        { lat: 80.273828125, lng: 55.47968750000004 },
        { lat: 80.226806640625, lng: 55.19511718750002 },
        { lat: 80.22836914062498, lng: 55.04843750000006 },
        { lat: 80.2564453125, lng: 54.9796875000001 },
        { lat: 80.295556640625, lng: 55.091601562500074 },
        { lat: 80.32539062500001, lng: 55.24003906250002 },
        { lat: 80.31767578125005, lng: 55.35322265625004 },
        { lat: 80.30224609375, lng: 55.43476562500003 },
        { lat: 80.273828125, lng: 55.47968750000004 },
      ],
      [
        { lat: 80.35092773437498, lng: 57.07871093750006 },
        { lat: 80.3169921875, lng: 57.12265625 },
        { lat: 80.19394531249998, lng: 57.118945312500074 },
        { lat: 80.13940429687496, lng: 57.072753906249964 },
        { lat: 80.09467773437501, lng: 57.080175781250006 },
        { lat: 80.07148437499998, lng: 56.986914062500006 },
        { lat: 80.07646484375002, lng: 56.20058593750005 },
        { lat: 80.08715820312497, lng: 55.811621093750006 },
        { lat: 80.104736328125, lng: 55.724023437499994 },
        { lat: 80.16328125000004, lng: 55.942285156249994 },
        { lat: 80.20390625000005, lng: 56.01220703125002 },
        { lat: 80.320068359375, lng: 55.98984375 },
        { lat: 80.34130859374997, lng: 56.02441406250003 },
        { lat: 80.33032226562506, lng: 56.65507812500007 },
        { lat: 80.36328125, lng: 56.70722656250004 },
        { lat: 80.36616210937498, lng: 56.94453125000003 },
        { lat: 80.35092773437498, lng: 57.07871093750006 },
      ],
      [
        { lat: 80.18520507812495, lng: 53.521386718749994 },
        { lat: 80.17324218750002, lng: 52.85634765625005 },
        { lat: 80.17885742187502, lng: 52.6359375000001 },
        { lat: 80.19116210937501, lng: 52.607031250000055 },
        { lat: 80.20185546874998, lng: 52.55048828125009 },
        { lat: 80.213232421875, lng: 52.34355468750001 },
        { lat: 80.26372070312507, lng: 52.21337890624997 },
        { lat: 80.27631835937498, lng: 52.2702148437501 },
        { lat: 80.29692382812499, lng: 52.57666015624997 },
        { lat: 80.31850585937505, lng: 52.680566406249994 },
        { lat: 80.34755859375, lng: 52.71601562500004 },
        { lat: 80.40239257812497, lng: 52.85390625 },
        { lat: 80.41264648437505, lng: 53.18564453125006 },
        { lat: 80.40239257812497, lng: 53.329199218750006 },
        { lat: 80.36630859375, lng: 53.34589843750004 },
        { lat: 80.32338867187497, lng: 53.48613281250002 },
        { lat: 80.26835937500005, lng: 53.85166015625006 },
        { lat: 80.22832031250005, lng: 53.777929687500006 },
        { lat: 80.22255859375002, lng: 53.65292968750006 },
        { lat: 80.18520507812495, lng: 53.521386718749994 },
      ],
      [
        { lat: 80.12324218749995, lng: 57.95625 },
        { lat: 80.10405273437505, lng: 57.80009765625001 },
        { lat: 80.13916015625, lng: 57.39228515625003 },
        { lat: 80.15810546875005, lng: 57.33232421875001 },
        { lat: 80.19389648437505, lng: 57.28144531250004 },
        { lat: 80.328271484375, lng: 57.21406250000009 },
        { lat: 80.36845703124999, lng: 57.211718750000074 },
        { lat: 80.39624023437497, lng: 57.18623046875009 },
        { lat: 80.44521484375, lng: 57.083398437499994 },
        { lat: 80.46831054687502, lng: 57.01113281250005 },
        { lat: 80.49394531249997, lng: 57.075 },
        { lat: 80.47539062500002, lng: 57.52197265625002 },
        { lat: 80.46474609375, lng: 58.480468749999964 },
        { lat: 80.41586914062498, lng: 58.971679687499964 },
        { lat: 80.38842773437497, lng: 59.11591796875003 },
        { lat: 80.34321289062501, lng: 59.255468750000055 },
        { lat: 80.31875, lng: 58.39794921874997 },
        { lat: 80.29780273437498, lng: 58.28388671875009 },
        { lat: 80.24814453124999, lng: 58.285742187500006 },
        { lat: 80.20180664062497, lng: 58.25546875000007 },
        { lat: 80.19653320312496, lng: 58.163183593750006 },
        { lat: 80.12324218749995, lng: 57.95625 },
      ],
      [
        { lat: 80.47280273437502, lng: 54.41533203125001 },
        { lat: 80.42133789062504, lng: 54.275878906249964 },
        { lat: 80.47622070312502, lng: 53.811914062499994 },
        { lat: 80.50385742187495, lng: 53.85 },
        { lat: 80.51542968750002, lng: 53.90019531250007 },
        { lat: 80.54248046875003, lng: 53.9015625000001 },
        { lat: 80.56303710937502, lng: 53.85888671874997 },
        { lat: 80.60527343750002, lng: 53.87724609375002 },
        { lat: 80.57436523437502, lng: 54.17675781250003 },
        { lat: 80.56176757812503, lng: 54.205371093750074 },
        { lat: 80.54013671874998, lng: 54.40712890625005 },
        { lat: 80.49868164062497, lng: 54.437304687500074 },
        { lat: 80.47280273437502, lng: 54.41533203125001 },
      ],
      [
        { lat: 80.853662109375, lng: 47.441992187500006 },
        { lat: 80.81269531250001, lng: 47.89951171875006 },
        { lat: 80.82348632812497, lng: 48.243261718750006 },
        { lat: 80.81899414062505, lng: 48.34521484374997 },
        { lat: 80.80600585937506, lng: 48.44570312500005 },
        { lat: 80.77905273437497, lng: 48.54736328124997 },
        { lat: 80.71777343750003, lng: 48.68652343749997 },
        { lat: 80.63325195312504, lng: 48.68359375000003 },
        { lat: 80.62929687500002, lng: 48.62548828124997 },
        { lat: 80.66816406249995, lng: 48.044335937499994 },
        { lat: 80.75625, lng: 47.77734375000002 },
        { lat: 80.76518554687499, lng: 47.7052734375001 },
        { lat: 80.74194335937496, lng: 47.60009765624997 },
        { lat: 80.68793945312498, lng: 47.51230468750006 },
        { lat: 80.67451171875, lng: 47.414160156250006 },
        { lat: 80.60620117187501, lng: 47.30390625000004 },
        { lat: 80.61494140625004, lng: 47.19824218750003 },
        { lat: 80.609033203125, lng: 47.14492187499999 },
        { lat: 80.562109375, lng: 47.011035156250074 },
        { lat: 80.56132812500005, lng: 46.677539062500074 },
        { lat: 80.540673828125, lng: 46.62392578124999 },
        { lat: 80.47553710937495, lng: 46.51367187499997 },
        { lat: 80.45678710937497, lng: 46.378125 },
        { lat: 80.44672851562495, lng: 46.141406250000074 },
        { lat: 80.48378906249997, lng: 46.059863281250074 },
        { lat: 80.54086914062503, lng: 46.0236328125001 },
        { lat: 80.56948242187502, lng: 45.96904296875007 },
        { lat: 80.53696289062503, lng: 45.64082031250003 },
        { lat: 80.56030273437499, lng: 45.38925781250006 },
        { lat: 80.59873046875, lng: 45.14921875000002 },
        { lat: 80.61127929687501, lng: 44.9049804687501 },
        { lat: 80.65224609375, lng: 45.12451171875003 },
        { lat: 80.73515625, lng: 46.327441406250074 },
        { lat: 80.755224609375, lng: 46.799121093750074 },
        { lat: 80.81440429687498, lng: 47.02060546875006 },
        { lat: 80.85292968750002, lng: 47.35234375000007 },
        { lat: 80.853662109375, lng: 47.441992187500006 },
      ],
      [
        { lat: 80.83476562500005, lng: 62.167773437500074 },
        { lat: 80.79438476562501, lng: 62.2277343750001 },
        { lat: 80.73022460937497, lng: 62.191796875000044 },
        { lat: 80.68369140625, lng: 62.11455078125002 },
        { lat: 80.616943359375, lng: 62.075781250000055 },
        { lat: 80.60102539062495, lng: 61.769140625 },
        { lat: 80.58632812499997, lng: 61.68125 },
        { lat: 80.53496093749999, lng: 61.59746093750002 },
        { lat: 80.50473632812506, lng: 61.28515625000003 },
        { lat: 80.41860351562498, lng: 61.051269531249964 },
        { lat: 80.43466796874996, lng: 60.722265625 },
        { lat: 80.49443359374999, lng: 60.278320312499964 },
        { lat: 80.44609375000002, lng: 59.90019531250001 },
        { lat: 80.43125, lng: 59.64980468749999 },
        { lat: 80.50502929687502, lng: 59.3463867187501 },
        { lat: 80.52153320312502, lng: 59.30439453125004 },
        { lat: 80.57265625000002, lng: 59.28818359375006 },
        { lat: 80.61777343749998, lng: 59.30625 },
        { lat: 80.71254882812502, lng: 59.38652343750002 },
        { lat: 80.76650390625, lng: 59.49511718750003 },
        { lat: 80.78359375000002, lng: 59.549414062500055 },
        { lat: 80.81650390624998, lng: 59.59228515625002 },
        { lat: 80.83637695312504, lng: 59.71582031250003 },
        { lat: 80.84858398437504, lng: 60.09453125000001 },
        { lat: 80.83774414062503, lng: 60.234960937500006 },
        { lat: 80.80146484375001, lng: 60.2780273437501 },
        { lat: 80.80424804687505, lng: 60.48154296875007 },
        { lat: 80.8265625, lng: 60.82021484375005 },
        { lat: 80.86264648437506, lng: 61.31318359375003 },
        { lat: 80.89291992187499, lng: 61.59746093750002 },
        { lat: 80.8859375, lng: 61.85058593750002 },
        { lat: 80.86660156249995, lng: 62.102929687499994 },
        { lat: 80.83476562500005, lng: 62.167773437500074 },
      ],
      [
        { lat: 80.92724609374996, lng: 50.278125 },
        { lat: 80.91088867187503, lng: 50.43144531250001 },
        { lat: 80.91416015624998, lng: 50.80107421875002 },
        { lat: 80.89042968750002, lng: 50.91767578125004 },
        { lat: 80.74467773437499, lng: 51.45478515625003 },
        { lat: 80.74077148437499, lng: 51.5910156250001 },
        { lat: 80.68764648437502, lng: 51.70361328125003 },
        { lat: 80.60395507812501, lng: 51.14619140625004 },
        { lat: 80.54047851562495, lng: 50.960839843750044 },
        { lat: 80.52734375000001, lng: 50.2796875 },
        { lat: 80.49765625000003, lng: 49.84599609375002 },
        { lat: 80.47207031249997, lng: 49.749804687500074 },
        { lat: 80.42534179687505, lng: 49.79414062500004 },
        { lat: 80.37656250000006, lng: 49.585937499999964 },
        { lat: 80.36918945312507, lng: 48.89609375000006 },
        { lat: 80.35371093750001, lng: 48.81103515625003 },
        { lat: 80.300048828125, lng: 48.67705078125002 },
        { lat: 80.29028320312497, lng: 48.68896484375003 },
        { lat: 80.27680664062498, lng: 48.92197265625 },
        { lat: 80.26567382812502, lng: 48.959570312500006 },
        { lat: 80.24238281249997, lng: 48.99082031250006 },
        { lat: 80.20742187499997, lng: 49.01074218749997 },
        { lat: 80.16259765624997, lng: 48.97753906250003 },
        { lat: 80.15532226562502, lng: 48.891894531250074 },
        { lat: 80.16113281250003, lng: 48.79736328125002 },
        { lat: 80.19536132812499, lng: 48.58173828125004 },
        { lat: 80.18330078125004, lng: 48.554589843749994 },
        { lat: 80.15825195312499, lng: 48.532617187499994 },
        { lat: 80.11010742187501, lng: 48.46679687499997 },
        { lat: 80.09580078125006, lng: 48.38623046875003 },
        { lat: 80.13276367187503, lng: 48.16718750000004 },
        { lat: 80.12231445312503, lng: 48.09589843750009 },
        { lat: 80.09946289062499, lng: 48.02578125 },
        { lat: 80.088623046875, lng: 47.93994140625003 },
        { lat: 80.08168945312502, lng: 47.73730468749997 },
        { lat: 80.11196289062497, lng: 47.632421875 },
        { lat: 80.1513671875, lng: 47.72314453125003 },
        { lat: 80.21254882812502, lng: 47.97753906249997 },
        { lat: 80.23925781249997, lng: 47.89296875000005 },
        { lat: 80.24531249999995, lng: 47.642382812500074 },
        { lat: 80.23012695312497, lng: 47.44433593749997 },
        { lat: 80.18852539062502, lng: 47.34306640625002 },
        { lat: 80.18022460937502, lng: 47.24863281250006 },
        { lat: 80.182763671875, lng: 46.991015625000074 },
        { lat: 80.23720703125, lng: 46.8458984375001 },
        { lat: 80.25766601562498, lng: 46.738183593749994 },
        { lat: 80.30034179687507, lng: 46.644433593749994 },
        { lat: 80.444775390625, lng: 47.40292968750006 },
        { lat: 80.50053710937499, lng: 47.65605468750001 },
        { lat: 80.52905273437503, lng: 47.89580078125002 },
        { lat: 80.54389648437495, lng: 48.20820312500004 },
        { lat: 80.56157226562497, lng: 48.30615234375003 },
        { lat: 80.56879882812495, lng: 48.40263671875007 },
        { lat: 80.55805664062497, lng: 48.464746093749994 },
        { lat: 80.50830078124997, lng: 48.625097656250006 },
        { lat: 80.515771484375, lng: 49.087792968749994 },
        { lat: 80.55864257812502, lng: 49.1852539062501 },
        { lat: 80.65600585937506, lng: 49.192675781250074 },
        { lat: 80.71210937500001, lng: 49.14746093750003 },
        { lat: 80.82138671875, lng: 49.24433593750004 },
        { lat: 80.86533203124998, lng: 49.50781249999997 },
        { lat: 80.92387695312499, lng: 50.124316406250074 },
        { lat: 80.92724609374996, lng: 50.278125 },
      ],
      [
        { lat: 80.84814453125003, lng: 80.02666015625007 },
        { lat: 80.81206054687503, lng: 79.09853515625005 },
        { lat: 80.83481445312498, lng: 79.00683593750003 },
        { lat: 80.84824218750003, lng: 78.97763671875012 },
        { lat: 80.92358398437503, lng: 79.10986328124996 },
        { lat: 80.96035156249995, lng: 79.21738281250012 },
        { lat: 80.975390625, lng: 79.80664062499997 },
        { lat: 80.94980468750003, lng: 80.27958984375007 },
        { lat: 80.92768554687498, lng: 80.4279296875001 },
        { lat: 80.88261718750005, lng: 80.37333984375007 },
        { lat: 80.86791992187497, lng: 80.34482421875012 },
        { lat: 80.84814453125003, lng: 80.02666015625007 },
      ],
      [
        { lat: 80.95034179687497, lng: 61.14082031250009 },
        { lat: 80.92968750000001, lng: 60.82675781250006 },
        { lat: 80.95551757812495, lng: 60.32109375000007 },
        { lat: 80.98461914062501, lng: 60.058203125000055 },
        { lat: 80.99916992187497, lng: 60.0783203125001 },
        { lat: 81.01665039062499, lng: 60.147558593750055 },
        { lat: 81.08769531250007, lng: 60.5866210937501 },
        { lat: 81.10395507812501, lng: 61.45742187499999 },
        { lat: 81.05029296875, lng: 61.56738281250002 },
        { lat: 81.01103515624999, lng: 61.471972656250074 },
        { lat: 80.95034179687497, lng: 61.14082031250009 },
      ],
      [
        { lat: 81.11596679687497, lng: 54.71894531250004 },
        { lat: 81.019873046875, lng: 55.47070312500003 },
        { lat: 81.02915039062503, lng: 56.17011718750003 },
        { lat: 80.99824218749995, lng: 56.47226562500006 },
        { lat: 80.91289062499999, lng: 56.90966796874997 },
        { lat: 80.81972656250001, lng: 57.567773437500044 },
        { lat: 80.79228515625002, lng: 57.69414062500002 },
        { lat: 80.75546874999998, lng: 57.58037109375001 },
        { lat: 80.66362304687502, lng: 56.81474609375001 },
        { lat: 80.63286132812505, lng: 56.315527343750006 },
        { lat: 80.62841796875003, lng: 55.883398437500055 },
        { lat: 80.63730468749998, lng: 55.7125 },
        { lat: 80.70332031250001, lng: 55.540625 },
        { lat: 80.75190429687495, lng: 55.11718750000003 },
        { lat: 80.738671875, lng: 54.66816406250004 },
        { lat: 80.765234375, lng: 54.62333984375002 },
        { lat: 80.78300781249999, lng: 54.53281250000006 },
        { lat: 80.786962890625, lng: 54.376074218750006 },
        { lat: 80.81362304687502, lng: 54.06660156250004 },
        { lat: 80.87197265625, lng: 54.04541015624997 },
        { lat: 80.90185546875006, lng: 54.24052734375001 },
        { lat: 80.90380859375, lng: 54.367285156250006 },
        { lat: 80.98652343749997, lng: 54.416796875000074 },
        { lat: 81.11318359375002, lng: 54.6339843750001 },
        { lat: 81.11596679687497, lng: 54.71894531250004 },
      ],
      [
        { lat: 81.04165039062501, lng: 58.622363281250024 },
        { lat: 80.990966796875, lng: 58.76152343750002 },
        { lat: 80.93359375000003, lng: 58.81533203124999 },
        { lat: 80.89765624999998, lng: 58.902539062500104 },
        { lat: 80.83168945312497, lng: 58.930566406249994 },
        { lat: 80.77939453125006, lng: 58.8599609375 },
        { lat: 80.76796875000002, lng: 58.64189453125002 },
        { lat: 80.76489257812503, lng: 58.28564453124997 },
        { lat: 80.79335937499995, lng: 57.93789062499999 },
        { lat: 80.88906250000002, lng: 57.74980468750007 },
        { lat: 80.91513671875, lng: 57.40517578125005 },
        { lat: 81.01708984374997, lng: 57.21093749999997 },
        { lat: 81.04677734375, lng: 57.41025390625001 },
        { lat: 81.03154296874999, lng: 57.65625 },
        { lat: 81.11845703125, lng: 58.04951171875004 },
        { lat: 81.11425781249997, lng: 58.10234375000001 },
        { lat: 81.09458007812506, lng: 58.18994140625002 },
        { lat: 81.06176757812503, lng: 58.50761718750001 },
        { lat: 81.04165039062501, lng: 58.622363281250024 },
      ],
      [
        { lat: 81.04741210937503, lng: 50.75371093750002 },
        { lat: 81.04125976562503, lng: 50.61601562500007 },
        { lat: 81.04555664062502, lng: 50.518164062500006 },
        { lat: 81.084375, lng: 50.41191406250002 },
        { lat: 81.10273437500001, lng: 50.37744140625003 },
        { lat: 81.12250976562495, lng: 50.368457031250074 },
        { lat: 81.126220703125, lng: 50.464941406250006 },
        { lat: 81.14423828124995, lng: 50.505957031250006 },
        { lat: 81.15820312500004, lng: 50.52158203125 },
        { lat: 81.16943359375003, lng: 50.59179687500002 },
        { lat: 81.170654296875, lng: 50.71591796875006 },
        { lat: 81.15087890624997, lng: 50.8786132812501 },
        { lat: 81.10815429687497, lng: 50.946191406249994 },
        { lat: 81.07182617187505, lng: 50.7887695312501 },
        { lat: 81.04741210937503, lng: 50.75371093750002 },
      ],
      [
        { lat: 80.70009765624997, lng: 63.37382812500002 },
        { lat: 80.697607421875, lng: 63.187597656250055 },
        { lat: 80.71284179687498, lng: 63.00214843750003 },
        { lat: 80.76269531250001, lng: 62.7604492187501 },
        { lat: 80.821875, lng: 62.52031250000002 },
        { lat: 80.85302734375004, lng: 62.59257812500001 },
        { lat: 80.893798828125, lng: 62.81933593750003 },
        { lat: 80.96679687500003, lng: 63.115820312500006 },
        { lat: 80.98090820312497, lng: 63.614746093749964 },
        { lat: 80.98115234375003, lng: 63.855957031249964 },
        { lat: 80.99833984374999, lng: 64.09570312499997 },
        { lat: 81.03574218750006, lng: 64.16591796875 },
        { lat: 81.10634765624997, lng: 64.21044921874997 },
        { lat: 81.14443359374998, lng: 64.25585937500003 },
        { lat: 81.17519531250005, lng: 64.31015625000006 },
        { lat: 81.198486328125, lng: 64.5753906250001 },
        { lat: 81.19726562499999, lng: 64.80205078125002 },
        { lat: 81.16948242187505, lng: 65.02773437500005 },
        { lat: 81.14404296875, lng: 65.17197265625006 },
        { lat: 81.09643554687497, lng: 65.30976562500004 },
        { lat: 81.05673828124998, lng: 65.38203125000004 },
        { lat: 81.00820312500005, lng: 65.3600585937501 },
        { lat: 80.96801757812503, lng: 65.37207031249997 },
        { lat: 80.93071289062507, lng: 65.43740234375005 },
        { lat: 80.81889648437502, lng: 64.99746093749998 },
        { lat: 80.75541992187505, lng: 64.54833984375003 },
        { lat: 80.70009765624997, lng: 63.37382812500002 },
      ],
      [
        { lat: 81.14121093750003, lng: 91.56718750000007 },
        { lat: 81.063818359375, lng: 91.2228515625001 },
        { lat: 81.113134765625, lng: 89.97578125000004 },
        { lat: 81.14873046875007, lng: 89.91943359375003 },
        { lat: 81.17070312500002, lng: 89.90117187500002 },
        { lat: 81.21372070312498, lng: 90.06992187500012 },
        { lat: 81.19912109375002, lng: 91.10898437500006 },
        { lat: 81.18393554687503, lng: 91.47783203125007 },
        { lat: 81.14121093750003, lng: 91.56718750000007 },
      ],
      [
        { lat: 81.0755859375, lng: 96.52656250000004 },
        { lat: 81.03007812500005, lng: 96.56308593750012 },
        { lat: 80.99418945312502, lng: 96.69326171875 },
        { lat: 80.957861328125, lng: 96.75498046875012 },
        { lat: 80.84184570312499, lng: 97.41367187500012 },
        { lat: 80.826708984375, lng: 97.70302734375 },
        { lat: 80.79829101562498, lng: 97.83183593750002 },
        { lat: 80.76328125000006, lng: 97.86992187500007 },
        { lat: 80.698095703125, lng: 97.85644531249997 },
        { lat: 80.69868164062495, lng: 97.74716796875012 },
        { lat: 80.678076171875, lng: 97.66542968750005 },
        { lat: 80.65244140625003, lng: 97.2213867187501 },
        { lat: 80.61406250000003, lng: 97.11308593750007 },
        { lat: 80.53554687500002, lng: 97.02539062499997 },
        { lat: 80.51987304687503, lng: 97.07255859375007 },
        { lat: 80.49658203125, lng: 97.11503906250002 },
        { lat: 80.36298828124995, lng: 97.25019531250004 },
        { lat: 80.34252929687506, lng: 97.28681640625004 },
        { lat: 80.32314453125, lng: 97.41699218749997 },
        { lat: 80.27275390625005, lng: 97.29843750000006 },
        { lat: 80.24101562500007, lng: 97.1751953125 },
        { lat: 80.17695312499998, lng: 95.85576171875007 },
        { lat: 80.15039062499997, lng: 94.961328125 },
        { lat: 80.12280273437506, lng: 94.66123046875005 },
        { lat: 80.12607421875, lng: 94.5650390625001 },
        { lat: 80.07602539062503, lng: 94.32841796875002 },
        { lat: 80.010107421875, lng: 93.87236328125 },
        { lat: 80.009619140625, lng: 93.6546875 },
        { lat: 80.10209960937502, lng: 93.00234375000004 },
        { lat: 80.179296875, lng: 92.2015625 },
        { lat: 80.22333984375001, lng: 92.0921875 },
        { lat: 80.24926757812497, lng: 91.89160156249997 },
        { lat: 80.26992187499998, lng: 91.6374023437501 },
        { lat: 80.35854492187502, lng: 91.52382812500005 },
        { lat: 80.41850585937499, lng: 91.68779296875002 },
        { lat: 80.47753906250003, lng: 91.89667968750004 },
        { lat: 80.49912109374998, lng: 92.24667968750012 },
        { lat: 80.53325195312499, lng: 92.5779296875 },
        { lat: 80.61855468749995, lng: 92.82675781250006 },
        { lat: 80.70297851562503, lng: 92.98105468750006 },
        { lat: 80.79125976562496, lng: 93.2625 },
        { lat: 80.76865234375, lng: 92.77294921874997 },
        { lat: 80.78085937499999, lng: 92.59257812500007 },
        { lat: 80.81000976562498, lng: 92.61015625000002 },
        { lat: 80.87216796875003, lng: 92.7103515625 },
        { lat: 80.89306640625001, lng: 92.76464843749997 },
        { lat: 80.92583007812505, lng: 92.93867187500004 },
        { lat: 80.98847656250001, lng: 93.06513671875004 },
        { lat: 81.03168945312504, lng: 93.35869140625 },
        { lat: 81.03920898437495, lng: 93.49736328125002 },
        { lat: 81.038134765625, lng: 93.63671874999996 },
        { lat: 81.05839843750005, lng: 93.8888671875001 },
        { lat: 81.08945312499998, lng: 94.14013671874997 },
        { lat: 81.10737304687498, lng: 94.37548828125003 },
        { lat: 81.11464843749995, lng: 94.61162109375 },
        { lat: 81.13940429687503, lng: 94.83789062499997 },
        { lat: 81.1880859375, lng: 95.06093750000005 },
        { lat: 81.27099609375003, lng: 95.1595703125 },
        { lat: 81.28046874999998, lng: 95.80068359375005 },
        { lat: 81.26059570312503, lng: 95.90195312500006 },
        { lat: 81.21142578125006, lng: 95.98398437500006 },
        { lat: 81.1927734375, lng: 96.07519531250003 },
        { lat: 81.18393554687503, lng: 96.18691406250005 },
        { lat: 81.09926757812502, lng: 96.47109375 },
        { lat: 81.0755859375, lng: 96.52656250000004 },
      ],
      [
        { lat: 81.30522460937507, lng: 59.31308593750006 },
        { lat: 81.29228515625002, lng: 59.09697265625007 },
        { lat: 81.31352539062507, lng: 58.71904296875001 },
        { lat: 81.337255859375, lng: 58.61015625000002 },
        { lat: 81.36035156250003, lng: 58.6344726562501 },
        { lat: 81.39184570312503, lng: 58.88056640625003 },
        { lat: 81.397705078125, lng: 59.075 },
        { lat: 81.36611328125002, lng: 59.280859375000055 },
        { lat: 81.325048828125, lng: 59.374609375000055 },
        { lat: 81.30522460937507, lng: 59.31308593750006 },
      ],
      [
        { lat: 81.54604492187502, lng: 57.81025390625003 },
        { lat: 81.50644531250003, lng: 57.86269531249999 },
        { lat: 81.48378906250002, lng: 58.01660156249997 },
        { lat: 81.46416015625002, lng: 58.43603515624998 },
        { lat: 81.41840820312504, lng: 58.56386718749999 },
        { lat: 81.38696289062503, lng: 58.371875 },
        { lat: 81.36806640625, lng: 57.858691406250074 },
        { lat: 81.30327148437502, lng: 57.91191406250007 },
        { lat: 81.25483398437501, lng: 58.0153320312501 },
        { lat: 81.19750976562497, lng: 57.912890625000074 },
        { lat: 81.16972656249997, lng: 57.76972656250004 },
        { lat: 81.13554687500003, lng: 57.45097656250002 },
        { lat: 81.178466796875, lng: 57.159472656250074 },
        { lat: 81.23793945312502, lng: 56.821875 },
        { lat: 81.19829101562503, lng: 56.66923828125001 },
        { lat: 81.17524414062495, lng: 56.5125 },
        { lat: 81.17861328125002, lng: 56.3639648437501 },
        { lat: 81.22397460937503, lng: 56.19199218750006 },
        { lat: 81.1884765625, lng: 55.716699218750044 },
        { lat: 81.22807617187507, lng: 55.57265624999999 },
        { lat: 81.31118164062502, lng: 55.46601562500004 },
        { lat: 81.32944335937503, lng: 55.7819335937501 },
        { lat: 81.30307617187498, lng: 56.1568359375 },
        { lat: 81.38701171875002, lng: 56.40468750000005 },
        { lat: 81.42338867187507, lng: 56.71875 },
        { lat: 81.51054687500007, lng: 56.97304687499999 },
        { lat: 81.5412109375, lng: 57.0915039062501 },
        { lat: 81.53525390625003, lng: 57.36503906250002 },
        { lat: 81.54287109375, lng: 57.456445312499994 },
        { lat: 81.56464843749998, lng: 57.71660156250007 },
        { lat: 81.54604492187502, lng: 57.81025390625003 },
      ],
      [
        { lat: 81.60932617187501, lng: 63.65097656250006 },
        { lat: 81.59658203125, lng: 63.5285156250001 },
        { lat: 81.60888671875003, lng: 62.88496093750004 },
        { lat: 81.63305664062497, lng: 62.57304687500002 },
        { lat: 81.64702148437507, lng: 62.53125 },
        { lat: 81.65913085937495, lng: 62.51523437500007 },
        { lat: 81.679345703125, lng: 62.10644531249997 },
        { lat: 81.70654296875003, lng: 62.28398437500001 },
        { lat: 81.71894531249998, lng: 62.79492187500002 },
        { lat: 81.68730468750002, lng: 63.7095703125 },
        { lat: 81.66416015625, lng: 63.767382812500074 },
        { lat: 81.64980468750001, lng: 63.782421875000104 },
        { lat: 81.60932617187501, lng: 63.65097656250006 },
      ],
      [
        { lat: 81.715185546875, lng: 58.29541015625003 },
        { lat: 81.69565429687502, lng: 57.96484375000003 },
        { lat: 81.71049804687502, lng: 57.92060546875005 },
        { lat: 81.72192382812504, lng: 57.90927734375006 },
        { lat: 81.74785156249999, lng: 57.945117187500074 },
        { lat: 81.797021484375, lng: 57.984960937500006 },
        { lat: 81.82797851562498, lng: 58.13457031250002 },
        { lat: 81.85419921874998, lng: 59.261816406250006 },
        { lat: 81.825439453125, lng: 59.40849609375002 },
        { lat: 81.78095703124998, lng: 59.356835937499994 },
        { lat: 81.75898437499995, lng: 59.35644531250003 },
        { lat: 81.715185546875, lng: 58.29541015625003 },
      ],
    ],
  },
  {
    code: "SI",
    coordinates: [
      [
        { lat: 46.49990234374999, lng: 16.516210937500006 },
        { lat: 46.5244140625, lng: 16.427636718750023 },
        { lat: 46.534619140625, lng: 16.321191406250023 },
        { lat: 46.52138671874999, lng: 16.301171875000023 },
        { lat: 46.50791015625, lng: 16.258398437500002 },
        { lat: 46.483837890625, lng: 16.236718750000023 },
        { lat: 46.389111328125, lng: 16.253320312500023 },
        { lat: 46.372851562499996, lng: 16.227441406250023 },
        { lat: 46.38222656249999, lng: 16.1064453125 },
        { lat: 46.37133789062499, lng: 16.066503906250006 },
        { lat: 46.30537109375, lng: 16.000683593750008 },
        { lat: 46.277636718749996, lng: 15.933300781250011 },
        { lat: 46.25786132812499, lng: 15.847558593750023 },
        { lat: 46.233984375, lng: 15.784277343750006 },
        { lat: 46.213232421875, lng: 15.704199218750004 },
        { lat: 46.200732421874996, lng: 15.635937500000011 },
        { lat: 46.17192382812499, lng: 15.608984375 },
        { lat: 46.139990234375, lng: 15.592578125000015 },
        { lat: 46.10922851562499, lng: 15.596875 },
        { lat: 46.048486328124994, lng: 15.666210937500011 },
        { lat: 45.983691406249996, lng: 15.675585937500017 },
        { lat: 45.90444335937499, lng: 15.668066406250004 },
        { lat: 45.862158203125, lng: 15.652148437500017 },
        { lat: 45.83403320312499, lng: 15.624804687500015 },
        { lat: 45.797607421875, lng: 15.4541015625 },
        { lat: 45.7326171875, lng: 15.277050781250011 },
        { lat: 45.71772460937499, lng: 15.27294921875 },
        { lat: 45.659912109375, lng: 15.353710937500011 },
        { lat: 45.64550781249999, lng: 15.356933593749998 },
        { lat: 45.612646484375, lng: 15.290136718750006 },
        { lat: 45.5796875, lng: 15.283593750000021 },
        { lat: 45.54155273437499, lng: 15.291210937500011 },
        { lat: 45.502294921875, lng: 15.326660156249998 },
        { lat: 45.467041015625, lng: 15.339453125 },
        { lat: 45.44140625, lng: 15.242089843750023 },
        { lat: 45.45078125, lng: 15.110449218750006 },
        { lat: 45.499902343749994, lng: 14.954589843749998 },
        { lat: 45.49267578125, lng: 14.9 },
        { lat: 45.467333984374996, lng: 14.847070312500021 },
        { lat: 45.47822265625, lng: 14.793066406250004 },
        { lat: 45.50849609375, lng: 14.733593750000011 },
        { lat: 45.571484375, lng: 14.649511718750006 },
        { lat: 45.610107421875, lng: 14.608593750000013 },
        { lat: 45.651269531249994, lng: 14.591796875 },
        { lat: 45.6572265625, lng: 14.56884765625 },
        { lat: 45.645263671875, lng: 14.533984375000015 },
        { lat: 45.59521484375, lng: 14.505175781250017 },
        { lat: 45.505761718749994, lng: 14.42734375 },
        { lat: 45.4814453125, lng: 14.369921875000015 },
        { lat: 45.48662109374999, lng: 14.283007812500017 },
        { lat: 45.48515625, lng: 14.161230468750004 },
        { lat: 45.477832031249996, lng: 14.085546875 },
        { lat: 45.509423828124994, lng: 13.992773437500006 },
        { lat: 45.503369140625, lng: 13.9703125 },
        { lat: 45.4826171875, lng: 13.970117187500023 },
        { lat: 45.4498046875, lng: 13.935644531250004 },
        { lat: 45.428369140624994, lng: 13.878710937500017 },
        { lat: 45.47675781249999, lng: 13.615234375 },
        { lat: 45.51689453124999, lng: 13.577929687500017 },
        { lat: 45.53593749999999, lng: 13.637304687500004 },
        { lat: 45.58759765625, lng: 13.719824218750006 },
        { lat: 45.581982421875, lng: 13.775976562500006 },
        { lat: 45.59287109375, lng: 13.8447265625 },
        { lat: 45.61484375, lng: 13.874707031250011 },
        { lat: 45.68041992187499, lng: 13.831152343750006 },
        { lat: 45.761279296874996, lng: 13.7216796875 },
        { lat: 45.7919921875, lng: 13.663476562500021 },
        { lat: 45.812353515625, lng: 13.583398437500023 },
        { lat: 45.834130859374994, lng: 13.569628906250017 },
        { lat: 45.961669921875, lng: 13.613964843750011 },
        { lat: 45.979785156249996, lng: 13.6005859375 },
        { lat: 45.973779296874994, lng: 13.509179687500023 },
        { lat: 45.987109375, lng: 13.487695312500023 },
        { lat: 46.009228515625, lng: 13.480273437500017 },
        { lat: 46.03955078125, lng: 13.486425781250004 },
        { lat: 46.08911132812499, lng: 13.548046875000011 },
        { lat: 46.133105468749996, lng: 13.616601562500023 },
        { lat: 46.157763671874996, lng: 13.63496093750001 },
        { lat: 46.177050781249996, lng: 13.632519531250011 },
        { lat: 46.19658203124999, lng: 13.544726562500017 },
        { lat: 46.216601562499996, lng: 13.491796875 },
        { lat: 46.223535156249994, lng: 13.449804687500006 },
        { lat: 46.212304687499994, lng: 13.420996093750006 },
        { lat: 46.224951171875, lng: 13.39960937500001 },
        { lat: 46.261621093749994, lng: 13.378222656250017 },
        { lat: 46.317529296874994, lng: 13.399511718750006 },
        { lat: 46.36918945312499, lng: 13.478515625 },
        { lat: 46.415087890624996, lng: 13.563281250000017 },
        { lat: 46.448535156249996, lng: 13.637109375000023 },
        { lat: 46.462890625, lng: 13.6796875 },
        { lat: 46.520263671875, lng: 13.7 },
        { lat: 46.514306640624994, lng: 13.743945312500017 },
        { lat: 46.51123046874999, lng: 13.831347656250015 },
        { lat: 46.498193359374994, lng: 13.928808593750006 },
        { lat: 46.482177734375, lng: 14.019628906250006 },
        { lat: 46.46191406249999, lng: 14.099511718750023 },
        { lat: 46.44072265624999, lng: 14.267285156250011 },
        { lat: 46.4279296875, lng: 14.419921875 },
        { lat: 46.41611328124999, lng: 14.465917968750004 },
        { lat: 46.417041015624996, lng: 14.503515625 },
        { lat: 46.399707031249996, lng: 14.5498046875 },
        { lat: 46.41293945312499, lng: 14.5771484375 },
        { lat: 46.436083984374996, lng: 14.596972656250017 },
        { lat: 46.463427734374996, lng: 14.68017578125 },
        { lat: 46.49912109375, lng: 14.756738281250023 },
        { lat: 46.544580078124994, lng: 14.810546875 },
        { lat: 46.58046875, lng: 14.840625 },
        { lat: 46.605908203125, lng: 14.893261718750011 },
        { lat: 46.613232421875, lng: 14.949414062500011 },
        { lat: 46.6259765625, lng: 15.000683593750011 },
        { lat: 46.64296874999999, lng: 15.216992187500011 },
        { lat: 46.62963867187499, lng: 15.439257812500019 },
        { lat: 46.65463867187499, lng: 15.545312500000023 },
        { lat: 46.6984375, lng: 15.632617187500017 },
        { lat: 46.710742187499996, lng: 15.76025390625 },
        { lat: 46.711279296875, lng: 15.766894531250017 },
        { lat: 46.677636718749994, lng: 15.957617187500006 },
        { lat: 46.69721679687499, lng: 15.972265625 },
        { lat: 46.705859375, lng: 15.98046875 },
        { lat: 46.8013671875, lng: 15.976855468750017 },
        { lat: 46.84482421875, lng: 16.037207031250006 },
        { lat: 46.86328125, lng: 16.093066406250017 },
        { lat: 46.857275390625, lng: 16.283593750000023 },
        { lat: 46.82797851562499, lng: 16.308496093750023 },
        { lat: 46.78251953124999, lng: 16.318457031250006 },
        { lat: 46.721630859375, lng: 16.33544921875 },
        { lat: 46.70478515625, lng: 16.3671875 },
        { lat: 46.680810546874994, lng: 16.384570312500017 },
        { lat: 46.638671875, lng: 16.38125 },
        { lat: 46.607226562499996, lng: 16.41845703125 },
        { lat: 46.5220703125, lng: 16.505664062500017 },
        { lat: 46.49990234374999, lng: 16.516210937500006 },
      ],
    ],
  },
  {
    code: "SE",
    coordinates: [
      [
        { lat: 56.29052734375, lng: 16.52851562500001 },
        { lat: 56.240185546874955, lng: 16.477148437500034 },
        { lat: 56.24375, lng: 16.431640625 },
        { lat: 56.31088867187498, lng: 16.401269531250023 },
        { lat: 56.483642578125, lng: 16.394140624999977 },
        { lat: 56.56899414062499, lng: 16.41230468750004 },
        { lat: 56.876855468749994, lng: 16.630371093750057 },
        { lat: 56.902001953124966, lng: 16.727734375 },
        { lat: 57.090673828125034, lng: 16.864648437499994 },
        { lat: 57.17460937499999, lng: 16.901562500000068 },
        { lat: 57.25019531250004, lng: 16.9609375 },
        { lat: 57.31777343750002, lng: 16.995996093750023 },
        { lat: 57.345068359375006, lng: 17.02539062499997 },
        { lat: 57.33227539062506, lng: 17.089257812500023 },
        { lat: 57.31982421875, lng: 17.11767578125003 },
        { lat: 57.28046874999998, lng: 17.050390625 },
        { lat: 57.22924804687503, lng: 17.058203125 },
        { lat: 57.20800781250006, lng: 17.053515625000014 },
        { lat: 56.985205078125034, lng: 16.883691406250076 },
        { lat: 56.840527343749955, lng: 16.83828125000005 },
        { lat: 56.80522460937495, lng: 16.77802734375004 },
        { lat: 56.29052734375, lng: 16.52851562500001 },
      ],
      [
        { lat: 57.8359375, lng: 19.076464843750045 },
        { lat: 57.812109375, lng: 18.99375 },
        { lat: 57.74160156250005, lng: 18.945117187500017 },
        { lat: 57.7296875, lng: 18.878125 },
        { lat: 57.70620117187502, lng: 18.813867187500023 },
        { lat: 57.483105468749955, lng: 18.790917968750048 },
        { lat: 57.39833984375003, lng: 18.907910156250068 },
        { lat: 57.38647460937499, lng: 18.84365234375005 },
        { lat: 57.36108398437497, lng: 18.784863281250036 },
        { lat: 57.32353515624995, lng: 18.74287109375001 },
        { lat: 57.24272460937502, lng: 18.699902343750068 },
        { lat: 57.19692382812502, lng: 18.53847656250005 },
        { lat: 57.16303710937504, lng: 18.477343750000017 },
        { lat: 57.08764648437503, lng: 18.38720703125003 },
        { lat: 56.97822265624995, lng: 18.34023437500005 },
        { lat: 56.93154296875002, lng: 18.248925781250023 },
        { lat: 56.920507812500006, lng: 18.146386718749994 },
        { lat: 57.010156249999966, lng: 18.20654296875 },
        { lat: 57.083203125, lng: 18.285351562500068 },
        { lat: 57.13330078125002, lng: 18.209570312500006 },
        { lat: 57.21171875000002, lng: 18.163964843750023 },
        { lat: 57.271875, lng: 18.105078125000034 },
        { lat: 57.33906250000001, lng: 18.151953124999977 },
        { lat: 57.44916992187498, lng: 18.12890625 },
        { lat: 57.55664062500003, lng: 18.136523437500045 },
        { lat: 57.61088867187495, lng: 18.204882812500017 },
        { lat: 57.655126953125006, lng: 18.283203125 },
        { lat: 57.75683593750003, lng: 18.40517578125005 },
        { lat: 57.83056640625005, lng: 18.537402343749985 },
        { lat: 57.863720703124955, lng: 18.721875 },
        { lat: 57.83315429687505, lng: 18.80517578125003 },
        { lat: 57.90019531250001, lng: 18.841113281250045 },
        { lat: 57.91547851562504, lng: 18.90058593750001 },
        { lat: 57.9, lng: 18.956445312500023 },
        { lat: 57.8359375, lng: 19.076464843750045 },
      ],
      [
        { lat: 57.922607421874964, lng: 19.15634765625006 },
        { lat: 57.860253906249966, lng: 19.13837890625004 },
        { lat: 57.86499023437506, lng: 19.086523437500034 },
        { lat: 57.91103515625002, lng: 19.039257812500008 },
        { lat: 57.981347656250016, lng: 19.13486328125003 },
        { lat: 57.977539062499964, lng: 19.28115234375008 },
        { lat: 57.96289062499999, lng: 19.331445312500023 },
        { lat: 57.922607421874964, lng: 19.15634765625006 },
      ],
      [
        { lat: 59.02910156250005, lng: 18.41621093750001 },
        { lat: 59.01958007812499, lng: 18.371875 },
        { lat: 59.022607421874966, lng: 18.349902343750074 },
        { lat: 59.06904296875001, lng: 18.377246093750045 },
        { lat: 59.08911132812502, lng: 18.397558593750006 },
        { lat: 59.10786132812504, lng: 18.464941406250063 },
        { lat: 59.10458984374998, lng: 18.485546875 },
        { lat: 59.02910156250005, lng: 18.41621093750001 },
      ],
      [
        { lat: 59.470361328124994, lng: 18.59541015625001 },
        { lat: 59.437255859375, lng: 18.57031250000003 },
        { lat: 59.47783203124998, lng: 18.545117187500068 },
        { lat: 59.485791015625004, lng: 18.555175781250057 },
        { lat: 59.525830078125004, lng: 18.572363281250002 },
        { lat: 59.547802734374955, lng: 18.620898437500045 },
        { lat: 59.53461914062501, lng: 18.69843750000004 },
        { lat: 59.52460937500001, lng: 18.69794921875001 },
        { lat: 59.4921875, lng: 18.623828125000017 },
        { lat: 59.470361328124994, lng: 18.59541015625001 },
      ],
      [
        { lat: 68.36733398437502, lng: 22.854101562500034 },
        { lat: 68.31645507812505, lng: 22.975390625000045 },
        { lat: 68.25756835937506, lng: 23.09785156250004 },
        { lat: 68.13662109375002, lng: 23.18251953125008 },
        { lat: 68.13032226562498, lng: 23.318554687500065 },
        { lat: 68.08867187500002, lng: 23.35546875000003 },
        { lat: 68.01733398437504, lng: 23.474218749999977 },
        { lat: 67.95439453125, lng: 23.63886718750004 },
        { lat: 67.93320312500003, lng: 23.632910156249977 },
        { lat: 67.87519531249995, lng: 23.50185546875002 },
        { lat: 67.79658203125001, lng: 23.487792968749996 },
        { lat: 67.69619140625, lng: 23.500195312500036 },
        { lat: 67.61430664062502, lng: 23.541308593750074 },
        { lat: 67.59038085937502, lng: 23.53701171875008 },
        { lat: 67.56215820312505, lng: 23.504492187500034 },
        { lat: 67.51787109374999, lng: 23.46542968750006 },
        { lat: 67.47919921875001, lng: 23.451464843750045 },
        { lat: 67.46025390625007, lng: 23.454882812500045 },
        { lat: 67.449951171875, lng: 23.468066406250074 },
        { lat: 67.449169921875, lng: 23.537109375 },
        { lat: 67.44003906250003, lng: 23.660839843749983 },
        { lat: 67.42290039062497, lng: 23.733593750000065 },
        { lat: 67.32861328124997, lng: 23.774902343750057 },
        { lat: 67.31049804687501, lng: 23.76093750000004 },
        { lat: 67.26782226562503, lng: 23.656640625000023 },
        { lat: 67.23393554687505, lng: 23.626074218750006 },
        { lat: 67.18413085937502, lng: 23.62304687500003 },
        { lat: 67.12939453124997, lng: 23.64150390625005 },
        { lat: 67.06811523437503, lng: 23.677343750000063 },
        { lat: 67.002587890625, lng: 23.758984375 },
        { lat: 66.93403320312498, lng: 23.86933593750001 },
        { lat: 66.87783203124997, lng: 23.941796875000023 },
        { lat: 66.838232421875, lng: 23.97607421875 },
        { lat: 66.81054687500003, lng: 23.988574218750042 },
        { lat: 66.77573242187505, lng: 23.93886718750005 },
        { lat: 66.70688476562506, lng: 23.894140625 },
        { lat: 66.62802734374996, lng: 23.885839843750006 },
        { lat: 66.57661132812497, lng: 23.865527343750045 },
        { lat: 66.50585937500004, lng: 23.768359375000042 },
        { lat: 66.48076171874997, lng: 23.70117187500003 },
        { lat: 66.44340820312502, lng: 23.68203125000005 },
        { lat: 66.38071289062503, lng: 23.673828125000053 },
        { lat: 66.304296875, lng: 23.693554687499983 },
        { lat: 66.25263671874998, lng: 23.70029296875003 },
        { lat: 66.21542968750003, lng: 23.720996093750074 },
        { lat: 66.19116210937497, lng: 23.75146484374997 },
        { lat: 66.14824218750002, lng: 23.907324218750034 },
        { lat: 66.06035156250005, lng: 23.994628906250053 },
        { lat: 65.98984375, lng: 24.04902343750004 },
        { lat: 65.80527343750006, lng: 24.15546875000004 },
        { lat: 65.78222656249997, lng: 23.89052734375008 },
        { lat: 65.828515625, lng: 23.69140625 },
        { lat: 65.80532226562497, lng: 23.592089843750017 },
        { lat: 65.80434570312505, lng: 23.41835937500005 },
        { lat: 65.78613281249997, lng: 23.221093750000023 },
        { lat: 65.74990234374995, lng: 23.154589843750074 },
        { lat: 65.73535156250003, lng: 23.102343750000074 },
        { lat: 65.78647460937503, lng: 22.919335937499994 },
        { lat: 65.870947265625, lng: 22.74658203124997 },
        { lat: 65.80654296875005, lng: 22.62031250000001 },
        { lat: 65.79433593750005, lng: 22.538574218750053 },
        { lat: 65.85263671875, lng: 22.465136718750017 },
        { lat: 65.86210937499997, lng: 22.400976562500006 },
        { lat: 65.84267578125002, lng: 22.366308593750063 },
        { lat: 65.79116210937502, lng: 22.3359375 },
        { lat: 65.75063476562502, lng: 22.28759765625 },
        { lat: 65.725, lng: 22.275 },
        { lat: 65.62153320312501, lng: 22.266601562499996 },
        { lat: 65.59755859375002, lng: 22.254003906250006 },
        { lat: 65.61093749999998, lng: 22.086230468750017 },
        { lat: 65.58378906250005, lng: 22.096289062500002 },
        { lat: 65.57011718750002, lng: 22.1328125 },
        { lat: 65.55288085937497, lng: 22.147558593750063 },
        { lat: 65.53022460937498, lng: 22.086718750000017 },
        { lat: 65.53237304687497, lng: 21.92011718750001 },
        { lat: 65.50834960937505, lng: 21.903125 },
        { lat: 65.47036132812502, lng: 21.95 },
        { lat: 65.437109375, lng: 21.91347656250008 },
        { lat: 65.42402343750001, lng: 21.87958984375001 },
        { lat: 65.40336914062507, lng: 21.680664062499996 },
        { lat: 65.40810546874995, lng: 21.565527343750063 },
        { lat: 65.386572265625, lng: 21.532617187500023 },
        { lat: 65.35859375000001, lng: 21.52343750000003 },
        { lat: 65.33115234375, lng: 21.545214843750017 },
        { lat: 65.31655273437495, lng: 21.595996093750045 },
        { lat: 65.29912109375005, lng: 21.61269531250008 },
        { lat: 65.261376953125, lng: 21.609179687500074 },
        { lat: 65.25454101562502, lng: 21.56689453125 },
        { lat: 65.32084960937505, lng: 21.446875 },
        { lat: 65.31743164062505, lng: 21.410351562500068 },
        { lat: 65.28295898437506, lng: 21.43779296875007 },
        { lat: 65.24536132812503, lng: 21.50634765625 },
        { lat: 65.20698242187501, lng: 21.545996093750006 },
        { lat: 65.16079101562502, lng: 21.580664062500034 },
        { lat: 65.12578124999999, lng: 21.57392578125001 },
        { lat: 65.01269531250006, lng: 21.424902343750002 },
        { lat: 64.94125976562498, lng: 21.29375 },
        { lat: 64.87690429687501, lng: 21.195898437500006 },
        { lat: 64.80869140625006, lng: 21.138183593750057 },
        { lat: 64.77431640625, lng: 21.20498046875008 },
        { lat: 64.72470703125, lng: 21.27929687500003 },
        { lat: 64.62934570312501, lng: 21.33154296875 },
        { lat: 64.54433593750002, lng: 21.39384765624999 },
        { lat: 64.46308593749998, lng: 21.519628906250034 },
        { lat: 64.41611328125, lng: 21.494335937500036 },
        { lat: 64.37958984375004, lng: 21.46503906250001 },
        { lat: 64.29916992187499, lng: 21.255761718750023 },
        { lat: 64.17797851562499, lng: 21.01845703125008 },
        { lat: 63.86782226562505, lng: 20.76269531250003 },
        { lat: 63.826269531250006, lng: 20.677636718750023 },
        { lat: 63.773730468750074, lng: 20.453710937500034 },
        { lat: 63.72290039062499, lng: 20.371386718750074 },
        { lat: 63.66245117187503, lng: 20.204687500000034 },
        { lat: 63.61054687500004, lng: 19.913671875000063 },
        { lat: 63.538183593750034, lng: 19.78164062500008 },
        { lat: 63.463330078124976, lng: 19.722070312500023 },
        { lat: 63.45800781250006, lng: 19.655761718750025 },
        { lat: 63.48725585937495, lng: 19.59003906250004 },
        { lat: 63.50903320312505, lng: 19.502343750000023 },
        { lat: 63.46020507812505, lng: 19.49091796875001 },
        { lat: 63.42436523437502, lng: 19.494628906250057 },
        { lat: 63.47749023437501, lng: 19.354296875000074 },
        { lat: 63.428759765625045, lng: 19.2880859375 },
        { lat: 63.34736328124998, lng: 19.236328125 },
        { lat: 63.23774414062501, lng: 19.034375 },
        { lat: 63.257470703125044, lng: 18.816699218750045 },
        { lat: 63.238134765625, lng: 18.792285156250042 },
        { lat: 63.22412109375, lng: 18.850195312500034 },
        { lat: 63.20659179687499, lng: 18.85898437500006 },
        { lat: 63.19726562500002, lng: 18.819433593749977 },
        { lat: 63.19824218749998, lng: 18.759570312500045 },
        { lat: 63.17656249999998, lng: 18.667187500000068 },
        { lat: 63.17827148437499, lng: 18.60644531250003 },
        { lat: 63.12641601562499, lng: 18.57763671875003 },
        { lat: 63.06352539062504, lng: 18.53066406250005 },
        { lat: 63.0375, lng: 18.407714843750057 },
        { lat: 63.03212890624996, lng: 18.34423828125 },
        { lat: 62.996386718750045, lng: 18.31289062500008 },
        { lat: 62.98886718750003, lng: 18.502050781249977 },
        { lat: 62.95859375, lng: 18.486914062500006 },
        { lat: 62.928320312500034, lng: 18.48261718750004 },
        { lat: 62.895849609375006, lng: 18.46308593750004 },
        { lat: 62.849072265624976, lng: 18.24804687500003 },
        { lat: 62.81220703125001, lng: 18.214941406250034 },
        { lat: 62.789355468750074, lng: 18.170019531250034 },
        { lat: 62.790673828124994, lng: 18.07441406250001 },
        { lat: 62.81196289062496, lng: 18.077929687500014 },
        { lat: 62.83603515624998, lng: 18.093554687500074 },
        { lat: 62.833886718749994, lng: 17.951074218749994 },
        { lat: 62.88676757812502, lng: 17.906640625000023 },
        { lat: 62.873193359374994, lng: 17.87958984375001 },
        { lat: 62.83051757812501, lng: 17.895605468749977 },
        { lat: 62.78613281250003, lng: 17.932910156250045 },
        { lat: 62.721044921875006, lng: 17.974414062500045 },
        { lat: 62.679882812499976, lng: 17.940722656250017 },
        { lat: 62.65947265624998, lng: 17.903027343750068 },
        { lat: 62.640625, lng: 17.930468750000074 },
        { lat: 62.626269531250074, lng: 18.006542968750036 },
        { lat: 62.60053710937498, lng: 18.037304687500068 },
        { lat: 62.578466796875, lng: 17.947070312500074 },
        { lat: 62.50273437500002, lng: 17.834472656250057 },
        { lat: 62.50087890624999, lng: 17.7177734375 },
        { lat: 62.45087890625004, lng: 17.646386718750023 },
        { lat: 62.45102539062498, lng: 17.570605468750045 },
        { lat: 62.48251953125, lng: 17.50898437500001 },
        { lat: 62.508398437500034, lng: 17.410253906250063 },
        { lat: 62.46279296874996, lng: 17.378417968750053 },
        { lat: 62.42651367187505, lng: 17.373339843750074 },
        { lat: 62.33471679687499, lng: 17.429003906250045 },
        { lat: 62.263671875, lng: 17.53525390625003 },
        { lat: 62.23300781250006, lng: 17.633691406249994 },
        { lat: 62.21230468750002, lng: 17.56289062500005 },
        { lat: 62.16630859375005, lng: 17.510156250000048 },
        { lat: 62.02265625, lng: 17.446582031250074 },
        { lat: 61.966113281250045, lng: 17.41201171875005 },
        { lat: 61.86630859375003, lng: 17.374511718750057 },
        { lat: 61.782080078125034, lng: 17.39824218749999 },
        { lat: 61.74067382812505, lng: 17.41728515625007 },
        { lat: 61.684472656250044, lng: 17.465429687500006 },
        { lat: 61.69169921874999, lng: 17.334570312500006 },
        { lat: 61.72456054687503, lng: 17.196386718750006 },
        { lat: 61.656347656250006, lng: 17.215625 },
        { lat: 61.57573242187498, lng: 17.13076171875005 },
        { lat: 61.50463867187499, lng: 17.146582031250063 },
        { lat: 61.45830078125004, lng: 17.16425781250004 },
        { lat: 61.381689453125006, lng: 17.137988281250017 },
        { lat: 61.35761718749998, lng: 17.177929687500068 },
        { lat: 61.31196289062501, lng: 17.199609375000023 },
        { lat: 61.278271484374976, lng: 17.163867187500045 },
        { lat: 61.24926757812503, lng: 17.179785156250006 },
        { lat: 61.146533203125045, lng: 17.18574218750004 },
        { lat: 60.98583984374999, lng: 17.212890625 },
        { lat: 60.95185546875001, lng: 17.20292968749999 },
        { lat: 60.81215820312497, lng: 17.278906250000034 },
        { lat: 60.76318359375003, lng: 17.261230468750057 },
        { lat: 60.70078125, lng: 17.25097656250003 },
        { lat: 60.640820312499955, lng: 17.35986328125 },
        { lat: 60.641796874999976, lng: 17.45703125 },
        { lat: 60.64272460937499, lng: 17.555468750000045 },
        { lat: 60.62768554687503, lng: 17.593066406250074 },
        { lat: 60.58525390625002, lng: 17.630761718750023 },
        { lat: 60.53515625000002, lng: 17.6611328125 },
        { lat: 60.53930664062497, lng: 17.7421875 },
        { lat: 60.58007812500002, lng: 17.871582031250057 },
        { lat: 60.589794921874955, lng: 17.955761718750068 },
        { lat: 60.511425781249976, lng: 18.011328125000034 },
        { lat: 60.40791015625004, lng: 18.1625 },
        { lat: 60.361523437499976, lng: 18.250488281249996 },
        { lat: 60.33710937499998, lng: 18.4 },
        { lat: 60.25356445312502, lng: 18.557519531250023 },
        { lat: 60.152880859375024, lng: 18.535449218750045 },
        { lat: 60.11923828125, lng: 18.601171875000034 },
        { lat: 60.0794921875, lng: 18.78701171875005 },
        { lat: 60.02587890625, lng: 18.85273437500001 },
        { lat: 59.98017578125001, lng: 18.884277343750057 },
        { lat: 59.942285156250016, lng: 18.933203124999977 },
        { lat: 59.82778320312496, lng: 18.99042968750001 },
        { lat: 59.757226562499994, lng: 18.970507812500045 },
        { lat: 59.73295898437501, lng: 18.895605468750063 },
        { lat: 59.65737304687496, lng: 18.71875 },
        { lat: 59.600927734375034, lng: 18.639941406250017 },
        { lat: 59.56577148437506, lng: 18.578125 },
        { lat: 59.49038085937496, lng: 18.402441406250034 },
        { lat: 59.47685546875007, lng: 18.338085937500065 },
        { lat: 59.437646484374966, lng: 18.276464843750034 },
        { lat: 59.420507812500034, lng: 18.216894531250063 },
        { lat: 59.43037109375001, lng: 18.163574218750057 },
        { lat: 59.359375, lng: 17.964257812500023 },
        { lat: 59.329052734374976, lng: 17.97978515625007 },
        { lat: 59.31621093750002, lng: 18.132617187500045 },
        { lat: 59.331445312500016, lng: 18.210546875000034 },
        { lat: 59.36713867187502, lng: 18.27050781249997 },
        { lat: 59.37534179687498, lng: 18.336035156250006 },
        { lat: 59.36860351562504, lng: 18.395800781250017 },
        { lat: 59.39672851562499, lng: 18.45917968750004 },
        { lat: 59.407958984374964, lng: 18.508886718750063 },
        { lat: 59.39448242187499, lng: 18.56025390625004 },
        { lat: 59.32705078124999, lng: 18.61757812500008 },
        { lat: 59.291943359374955, lng: 18.498632812500006 },
        { lat: 59.29033203124998, lng: 18.41425781250004 },
        { lat: 59.179736328125024, lng: 18.373046875 },
        { lat: 59.13222656250002, lng: 18.321972656250068 },
        { lat: 59.109375, lng: 18.285351562500068 },
        { lat: 59.06230468749999, lng: 18.09814453125003 },
        { lat: 59.00263671874998, lng: 17.974609375 },
        { lat: 58.95458984374997, lng: 17.829003906249994 },
        { lat: 58.96503906249998, lng: 17.765429687500017 },
        { lat: 58.916210937499976, lng: 17.66962890625004 },
        { lat: 58.85839843749999, lng: 17.45673828125001 },
        { lat: 58.78051757812502, lng: 17.34765625 },
        { lat: 58.71083984374997, lng: 17.102832031250042 },
        { lat: 58.65415039062506, lng: 16.978125 },
        { lat: 58.651171875000074, lng: 16.63935546875004 },
        { lat: 58.66362304687502, lng: 16.315820312500023 },
        { lat: 58.636669921874955, lng: 16.214257812500023 },
        { lat: 58.62832031250002, lng: 16.31806640625004 },
        { lat: 58.601855468750045, lng: 16.39082031250001 },
        { lat: 58.612890625, lng: 16.478027343750025 },
        { lat: 58.599658203125045, lng: 16.68300781250005 },
        { lat: 58.58525390625004, lng: 16.788476562500023 },
        { lat: 58.492578125, lng: 16.92382812499997 },
        { lat: 58.45961914062503, lng: 16.824316406250063 },
        { lat: 58.43432617187502, lng: 16.651953125 },
        { lat: 58.302880859374994, lng: 16.716601562500045 },
        { lat: 58.21425781249996, lng: 16.76992187500008 },
        { lat: 58.16079101562499, lng: 16.70009765625005 },
        { lat: 57.917529296874996, lng: 16.69492187500006 },
        { lat: 57.91289062500005, lng: 16.596972656250017 },
        { lat: 57.81225585937505, lng: 16.555371093750068 },
        { lat: 57.76093749999998, lng: 16.586230468750045 },
        { lat: 57.641748046875044, lng: 16.583789062500074 },
        { lat: 57.568310546875004, lng: 16.604199218750068 },
        { lat: 57.50068359374998, lng: 16.65224609375008 },
        { lat: 57.43017578124999, lng: 16.63085937499997 },
        { lat: 57.26513671875006, lng: 16.47597656250005 },
        { lat: 57.187695312499976, lng: 16.479492187500057 },
        { lat: 57.141699218750034, lng: 16.50732421875003 },
        { lat: 57.06816406249999, lng: 16.527929687500063 },
        { lat: 56.92680664062495, lng: 16.45751953125003 },
        { lat: 56.808691406250055, lng: 16.4078125 },
        { lat: 56.70927734374996, lng: 16.348730468750063 },
        { lat: 56.589990234374994, lng: 16.21650390625004 },
        { lat: 56.500830078125034, lng: 16.150683593750045 },
        { lat: 56.22260742187501, lng: 15.996679687500006 },
        { lat: 56.167382812499966, lng: 15.92031250000008 },
        { lat: 56.12495117187501, lng: 15.826660156250028 },
        { lat: 56.16420898437502, lng: 15.722265625000063 },
        { lat: 56.18559570312504, lng: 15.6265625 },
        { lat: 56.18300781250005, lng: 15.509667968749994 },
        { lat: 56.150830078124955, lng: 15.3265625 },
        { lat: 56.17221679687506, lng: 15.051171875000023 },
        { lat: 56.16191406250002, lng: 14.782031250000015 },
        { lat: 56.13413085937503, lng: 14.713964843750004 },
        { lat: 56.03315429687498, lng: 14.754785156250051 },
        { lat: 56.019921875000016, lng: 14.655566406249987 },
        { lat: 56.04863281250002, lng: 14.558593750000057 },
        { lat: 56.014355468749955, lng: 14.473242187500064 },
        { lat: 55.97675781250004, lng: 14.401953125000032 },
        { lat: 55.88754882812497, lng: 14.261914062500011 },
        { lat: 55.83261718749998, lng: 14.21503906250004 },
        { lat: 55.72915039062502, lng: 14.202929687500074 },
        { lat: 55.636376953124966, lng: 14.276464843750034 },
        { lat: 55.52773437500002, lng: 14.341699218749994 },
        { lat: 55.39663085937496, lng: 14.173730468750078 },
        { lat: 55.392187500000034, lng: 14.079980468750051 },
        { lat: 55.428564453125, lng: 13.806347656250011 },
        { lat: 55.34638671875004, lng: 13.321386718750063 },
        { lat: 55.41137695312506, lng: 12.88583984375006 },
        { lat: 55.48159179687505, lng: 12.940625 },
        { lat: 55.53320312499999, lng: 12.938769531250017 },
        { lat: 55.61259765625001, lng: 12.963378906250057 },
        { lat: 55.69379882812504, lng: 12.97802734375 },
        { lat: 55.74814453125, lng: 12.973925781250074 },
        { lat: 55.806054687499994, lng: 12.941992187500034 },
        { lat: 55.88183593750006, lng: 12.834570312500006 },
        { lat: 56.137597656250016, lng: 12.592578124999989 },
        { lat: 56.245556640624976, lng: 12.52099609374997 },
        { lat: 56.29052734375, lng: 12.471191406250055 },
        { lat: 56.29296874999997, lng: 12.507031250000068 },
        { lat: 56.235009765624966, lng: 12.706347656250074 },
        { lat: 56.242138671875004, lng: 12.752832031250051 },
        { lat: 56.26391601562499, lng: 12.80166015625005 },
        { lat: 56.346875, lng: 12.7421875 },
        { lat: 56.38442382812505, lng: 12.691113281250011 },
        { lat: 56.440576171875016, lng: 12.65644531250004 },
        { lat: 56.45576171875001, lng: 12.77314453125001 },
        { lat: 56.45239257812503, lng: 12.857421875000028 },
        { lat: 56.515576171875004, lng: 12.91953125 },
        { lat: 56.61772460937496, lng: 12.883691406250051 },
        { lat: 56.64916992187497, lng: 12.793164062500011 },
        { lat: 56.662841796875, lng: 12.717578125000072 },
        { lat: 56.82329101562502, lng: 12.572656250000023 },
        { lat: 56.90639648437496, lng: 12.421484375000034 },
        { lat: 57.22695312499999, lng: 12.15185546875 },
        { lat: 57.446972656249976, lng: 12.053222656249972 },
        { lat: 57.42607421874999, lng: 11.961523437500034 },
        { lat: 57.521923828124955, lng: 11.916992187500028 },
        { lat: 57.61269531249999, lng: 11.885058593750017 },
        { lat: 57.67944335937499, lng: 11.878710937500045 },
        { lat: 57.717675781249966, lng: 11.734960937500063 },
        { lat: 57.76445312499999, lng: 11.729101562500034 },
        { lat: 57.97319335937495, lng: 11.703222656250006 },
        { lat: 58.001220703125, lng: 11.549023437500038 },
        { lat: 58.11835937499995, lng: 11.449316406250063 },
        { lat: 58.339990234374994, lng: 11.43154296875008 },
        { lat: 58.38032226562495, lng: 11.32998046875008 },
        { lat: 58.369140625, lng: 11.24824218750004 },
        { lat: 58.424072265625, lng: 11.252050781250006 },
        { lat: 58.47563476562502, lng: 11.271582031250006 },
        { lat: 58.679931640624964, lng: 11.22382812500004 },
        { lat: 58.866406249999955, lng: 11.20791015625008 },
        { lat: 58.92270507812506, lng: 11.169140624999981 },
        { lat: 58.98862304687497, lng: 11.14716796875004 },
        { lat: 59.04555664062502, lng: 11.16689453125008 },
        { lat: 59.07827148437505, lng: 11.19580078125 },
        { lat: 59.086865234375004, lng: 11.295312500000023 },
        { lat: 59.03652343749996, lng: 11.388281250000063 },
        { lat: 58.90952148437503, lng: 11.470703125000057 },
        { lat: 58.893017578124955, lng: 11.543554687500063 },
        { lat: 58.926074218750024, lng: 11.64277343750004 },
        { lat: 59.01865234374998, lng: 11.712207031250045 },
        { lat: 59.15756835937503, lng: 11.75185546875005 },
        { lat: 59.28989257812498, lng: 11.798144531250072 },
        { lat: 59.431445312500045, lng: 11.743359375000011 },
        { lat: 59.55576171874998, lng: 11.684863281250074 },
        { lat: 59.59228515625002, lng: 11.680761718750032 },
        { lat: 59.697167968749994, lng: 11.834277343750044 },
        { lat: 59.78247070312497, lng: 11.88125 },
        { lat: 59.86367187499999, lng: 11.93212890625 },
        { lat: 59.89130859375004, lng: 11.98828125 },
        { lat: 59.897607421874994, lng: 12.071875 },
        { lat: 59.91289062499999, lng: 12.169238281250074 },
        { lat: 59.96723632812495, lng: 12.291992187500057 },
        { lat: 60.04003906250006, lng: 12.402050781249981 },
        { lat: 60.106787109375055, lng: 12.486132812500074 },
        { lat: 60.23886718750006, lng: 12.514648437500028 },
        { lat: 60.305224609375074, lng: 12.515820312499983 },
        { lat: 60.35449218749997, lng: 12.552832031250063 },
        { lat: 60.450732421875045, lng: 12.588671874999989 },
        { lat: 60.54565429687502, lng: 12.553808593750006 },
        { lat: 60.68964843749995, lng: 12.445312500000027 },
        { lat: 60.89213867187498, lng: 12.314648437500038 },
        { lat: 61.00268554687506, lng: 12.294140625000038 },
        { lat: 61.023193359374964, lng: 12.353710937500011 },
        { lat: 61.041503906249964, lng: 12.467578125000017 },
        { lat: 61.04682617187498, lng: 12.683007812500021 },
        { lat: 61.059863281250074, lng: 12.706054687500028 },
        { lat: 61.10825195312497, lng: 12.727832031250017 },
        { lat: 61.17397460937505, lng: 12.776367187500057 },
        { lat: 61.22182617187502, lng: 12.828222656250034 },
        { lat: 61.29028320312503, lng: 12.86367187500008 },
        { lat: 61.35229492187506, lng: 12.88076171875008 },
        { lat: 61.44570312499997, lng: 12.75751953125004 },
        { lat: 61.54130859375001, lng: 12.59609375 },
        { lat: 61.57299804687497, lng: 12.486816406250028 },
        { lat: 61.653466796875016, lng: 12.292089843750063 },
        { lat: 61.720751953125045, lng: 12.155371093750004 },
        { lat: 61.97685546875001, lng: 12.233691406250074 },
        { lat: 62.16743164062501, lng: 12.291992187500057 },
        { lat: 62.213769531250044, lng: 12.301367187500006 },
        { lat: 62.28559570312501, lng: 12.303515625000074 },
        { lat: 62.59189453124998, lng: 12.114550781250045 },
        { lat: 62.660009765625006, lng: 12.121875 },
        { lat: 62.72133789062496, lng: 12.13984375000004 },
        { lat: 62.82592773437497, lng: 12.11962890625 },
        { lat: 62.91948242187501, lng: 12.108593750000068 },
        { lat: 62.94785156250003, lng: 12.141015625000023 },
        { lat: 63.000634765625016, lng: 12.218164062500023 },
        { lat: 63.08251953125002, lng: 12.144628906250034 },
        { lat: 63.089160156250045, lng: 12.138671874999972 },
        { lat: 63.291699218750004, lng: 11.99990234375005 },
        { lat: 63.49223632812498, lng: 12.212109375000011 },
        { lat: 63.59594726562499, lng: 12.17519531250005 },
        { lat: 63.671191406250045, lng: 12.30195312500004 },
        { lat: 63.84355468749999, lng: 12.532714843750057 },
        { lat: 63.94047851562502, lng: 12.6625 },
        { lat: 63.95742187499999, lng: 12.690039062500032 },
        { lat: 64, lng: 12.792773437500017 },
        { lat: 64.05048828124995, lng: 12.987597656250017 },
        { lat: 64.07509765625, lng: 13.203515625000023 },
        { lat: 64.07480468750003, lng: 13.299609375000074 },
        { lat: 64.040625, lng: 13.670703125000074 },
        { lat: 64.01401367187498, lng: 13.960546875000063 },
        { lat: 64.04072265625001, lng: 14.002734375000044 },
        { lat: 64.09550781250007, lng: 14.063281250000045 },
        { lat: 64.17353515624998, lng: 14.141210937500006 },
        { lat: 64.26030273437507, lng: 14.148046874999977 },
        { lat: 64.38774414062502, lng: 14.119921875000017 },
        { lat: 64.46401367187498, lng: 14.077636718750028 },
        { lat: 64.51357421874997, lng: 13.873535156250028 },
        { lat: 64.58154296874997, lng: 13.650292968750023 },
        { lat: 64.79677734375001, lng: 13.92480468749997 },
        { lat: 64.946142578125, lng: 14.115136718750023 },
        { lat: 65.17084960937504, lng: 14.352441406250051 },
        { lat: 65.26435546874998, lng: 14.42626953125 },
        { lat: 65.30146484374998, lng: 14.479687500000038 },
        { lat: 65.64638671875002, lng: 14.549511718750068 },
        { lat: 65.74287109374995, lng: 14.595800781249977 },
        { lat: 65.79326171874999, lng: 14.634570312500074 },
        { lat: 65.84501953125007, lng: 14.635156250000023 },
        { lat: 65.932275390625, lng: 14.609960937500036 },
        { lat: 66.12934570312498, lng: 14.543261718750044 },
        { lat: 66.1537109375, lng: 14.91796875 },
        { lat: 66.16752929687503, lng: 15.0400390625 },
        { lat: 66.19106445312505, lng: 15.153320312500057 },
        { lat: 66.25205078125002, lng: 15.37490234375008 },
        { lat: 66.30595703124999, lng: 15.483789062500051 },
        { lat: 66.48984374999996, lng: 15.422949218750006 },
        { lat: 66.55209960937506, lng: 15.55703125000005 },
        { lat: 66.76884765625007, lng: 15.884179687500021 },
        { lat: 66.97641601562498, lng: 16.23769531250008 },
        { lat: 67.05498046875002, lng: 16.40351562500004 },
        { lat: 67.093359375, lng: 16.420703125000074 },
        { lat: 67.15507812500007, lng: 16.434277343749983 },
        { lat: 67.25200195312499, lng: 16.360644531249985 },
        { lat: 67.31206054687506, lng: 16.281542968750045 },
        { lat: 67.42583007812507, lng: 16.12744140625 },
        { lat: 67.50517578125006, lng: 16.193554687500068 },
        { lat: 67.52060546875, lng: 16.30712890625003 },
        { lat: 67.55175781250006, lng: 16.457128906250034 },
        { lat: 67.61958007812501, lng: 16.57412109375005 },
        { lat: 67.62832031250002, lng: 16.585546874999974 },
        { lat: 67.89501953125, lng: 16.783593750000023 },
        { lat: 68.03012695312498, lng: 17.170507812500063 },
        { lat: 68.10380859374999, lng: 17.324609375000023 },
        { lat: 68.04843749999998, lng: 17.564746093750074 },
        { lat: 67.96489257812502, lng: 17.916699218750008 },
        { lat: 68.08784179687501, lng: 18.073242187500025 },
        { lat: 68.133447265625, lng: 18.125 },
        { lat: 68.20063476562498, lng: 18.17666015625005 },
        { lat: 68.31684570312495, lng: 18.15595703125001 },
        { lat: 68.46777343749997, lng: 18.14707031250006 },
        { lat: 68.52841796874998, lng: 18.16259765625003 },
        { lat: 68.55541992187497, lng: 18.303027343750045 },
        { lat: 68.56240234374997, lng: 18.378613281250068 },
        { lat: 68.50004882812507, lng: 18.769824218750017 },
        { lat: 68.50112304687502, lng: 18.868261718749977 },
        { lat: 68.49272460937499, lng: 19.05263671875008 },
        { lat: 68.46533203125, lng: 19.25898437500001 },
        { lat: 68.39243164062498, lng: 19.691210937500045 },
        { lat: 68.36225585937497, lng: 19.87001953125005 },
        { lat: 68.35639648437501, lng: 19.969824218750063 },
        { lat: 68.39038085937503, lng: 20.055957031250014 },
        { lat: 68.4775390625, lng: 20.240039062500042 },
        { lat: 68.54204101562502, lng: 19.96884765625003 },
        { lat: 68.60732421875, lng: 20.147460937499996 },
        { lat: 68.67314453125007, lng: 20.240039062500042 },
        { lat: 68.75405273437502, lng: 20.31943359375003 },
        { lat: 68.84873046875002, lng: 20.348046875000023 },
        { lat: 68.89965820312503, lng: 20.33710937500001 },
        { lat: 68.934326171875, lng: 20.282324218750034 },
        { lat: 69.02089843750005, lng: 20.116699218750057 },
        { lat: 69.03330078124998, lng: 20.491992187500017 },
        { lat: 69.036865234375, lng: 20.622167968750006 },
        { lat: 68.97983398437502, lng: 20.895117187500006 },
        { lat: 68.96748046874998, lng: 20.907031250000014 },
        { lat: 68.93774414062497, lng: 20.908984375000074 },
        { lat: 68.90693359375001, lng: 20.91855468750006 },
        { lat: 68.82880859374998, lng: 21.183398437500017 },
        { lat: 68.787451171875, lng: 21.25976562500003 },
        { lat: 68.72460937499997, lng: 21.42236328125003 },
        { lat: 68.69067382812499, lng: 21.465429687500002 },
        { lat: 68.6509765625, lng: 21.616015625000045 },
        { lat: 68.60854492187497, lng: 21.724023437500023 },
        { lat: 68.57412109374997, lng: 21.850195312500063 },
        { lat: 68.52060546874998, lng: 21.99746093750005 },
        { lat: 68.477978515625, lng: 22.195117187500074 },
        { lat: 68.46406250000001, lng: 22.362109375000074 },
        { lat: 68.39101562499995, lng: 22.78242187500001 },
        { lat: 68.36733398437502, lng: 22.854101562500034 },
      ],
    ],
  },
  {
    code: "UA",
    coordinates: [
      [
        { lat: 46.20390624999998, lng: 32.01220703124997 },
        { lat: 46.1546875, lng: 32.15009765625004 },
        { lat: 46.167822265625006, lng: 32.009375 },
        { lat: 46.21406250000001, lng: 31.700195312500025 },
        { lat: 46.25776367187503, lng: 31.56386718750005 },
        { lat: 46.30659179687504, lng: 31.528710937499998 },
        { lat: 46.37314453125, lng: 31.50878906250003 },
        { lat: 46.303173828124955, lng: 31.58486328124999 },
        { lat: 46.27255859375003, lng: 31.63847656250007 },
        { lat: 46.20390624999998, lng: 32.01220703124997 },
      ],
      [
        { lat: 52.33378906250002, lng: 33.4518554687501 },
        { lat: 52.33261718750006, lng: 33.61337890625006 },
        { lat: 52.34477539062504, lng: 33.735253906249994 },
        { lat: 52.315625, lng: 33.81884765624997 },
        { lat: 52.25146484375003, lng: 33.92207031250003 },
        { lat: 52.15595703125004, lng: 34.01533203125004 },
        { lat: 51.979638671874994, lng: 34.113085937500074 },
        { lat: 51.78041992187499, lng: 34.397851562499994 },
        { lat: 51.74150390624996, lng: 34.40273437499999 },
        { lat: 51.71650390625004, lng: 34.37929687500005 },
        { lat: 51.69223632812506, lng: 34.239160156249994 },
        { lat: 51.67915039062498, lng: 34.12109375000002 },
        { lat: 51.64497070312501, lng: 34.11542968750004 },
        { lat: 51.607958984375045, lng: 34.14677734375002 },
        { lat: 51.553808593750006, lng: 34.20087890625004 },
        { lat: 51.48408203125001, lng: 34.20927734375002 },
        { lat: 51.419921875, lng: 34.20654296875003 },
        { lat: 51.36323242187501, lng: 34.229882812499994 },
        { lat: 51.340185546875006, lng: 34.275 },
        { lat: 51.311669921874966, lng: 34.280664062499994 },
        { lat: 51.27685546875, lng: 34.22841796875005 },
        { lat: 51.25537109375006, lng: 34.21386718750003 },
        { lat: 51.24379882812499, lng: 34.234179687500074 },
        { lat: 51.23706054687506, lng: 34.491015625000074 },
        { lat: 51.203125, lng: 34.616796875 },
        { lat: 51.17221679687498, lng: 34.71230468750005 },
        { lat: 51.16933593750002, lng: 34.76035156250006 },
        { lat: 51.18920898437499, lng: 34.86855468749999 },
        { lat: 51.20175781250006, lng: 34.99023437499997 },
        { lat: 51.203417968750045, lng: 35.0640625 },
        { lat: 51.18066406250003, lng: 35.092578125000074 },
        { lat: 51.12084960937499, lng: 35.11533203125006 },
        { lat: 51.06098632812498, lng: 35.158105468749994 },
        { lat: 51.043896484374955, lng: 35.19804687500002 },
        { lat: 51.04677734375002, lng: 35.26914062500006 },
        { lat: 51.043896484374955, lng: 35.31191406250005 },
        { lat: 51.02114257812502, lng: 35.33476562500002 },
        { lat: 50.98691406249998, lng: 35.30908203125003 },
        { lat: 50.949902343749976, lng: 35.31474609375001 },
        { lat: 50.90429687500003, lng: 35.34609375 },
        { lat: 50.79892578125006, lng: 35.38320312499999 },
        { lat: 50.76757812499997, lng: 35.41738281250005 },
        { lat: 50.72768554687502, lng: 35.4401367187501 },
        { lat: 50.682080078124955, lng: 35.4401367187501 },
        { lat: 50.64223632812502, lng: 35.41162109375003 },
        { lat: 50.610937500000034, lng: 35.39169921875006 },
        { lat: 50.539697265624994, lng: 35.41162109375003 },
        { lat: 50.459912109375004, lng: 35.48847656250004 },
        { lat: 50.43999023437502, lng: 35.54550781250006 },
        { lat: 50.36875, lng: 35.59111328125002 },
        { lat: 50.34599609374998, lng: 35.67373046875005 },
        { lat: 50.40576171874997, lng: 35.79619140625002 },
        { lat: 50.43710937499998, lng: 35.890234375 },
        { lat: 50.41967773437497, lng: 36.00781249999997 },
        { lat: 50.408544921875006, lng: 36.11640625000009 },
        { lat: 50.367822265624994, lng: 36.18945312499997 },
        { lat: 50.31176757812503, lng: 36.2433593750001 },
        { lat: 50.28046875000004, lng: 36.306054687499994 },
        { lat: 50.29682617187498, lng: 36.3688476562501 },
        { lat: 50.28046875000004, lng: 36.49980468750002 },
        { lat: 50.23486328124997, lng: 36.55966796875006 },
        { lat: 50.209228515625, lng: 36.61943359375007 },
        { lat: 50.246240234374994, lng: 36.696386718750006 },
        { lat: 50.291845703125034, lng: 36.75908203125002 },
        { lat: 50.33955078124998, lng: 36.98847656250003 },
        { lat: 50.35151367187504, lng: 37.13125 },
        { lat: 50.36088867187499, lng: 37.1710937500001 },
        { lat: 50.39497070312501, lng: 37.25488281250003 },
        { lat: 50.417626953124994, lng: 37.343164062499994 },
        { lat: 50.411474609375006, lng: 37.422851562499964 },
        { lat: 50.340722656249966, lng: 37.501367187499994 },
        { lat: 50.291845703125034, lng: 37.58232421875002 },
        { lat: 50.214941406250006, lng: 37.60507812500006 },
        { lat: 50.10908203125004, lng: 37.704199218750006 },
        { lat: 49.964208984375006, lng: 37.95029296875006 },
        { lat: 49.92001953125006, lng: 38.046875 },
        { lat: 49.927832031250055, lng: 38.1125 },
        { lat: 49.93940429687501, lng: 38.14677734375002 },
        { lat: 49.954541015624976, lng: 38.16269531250006 },
        { lat: 50.02539062500003, lng: 38.177539062500074 },
        { lat: 50.05146484375001, lng: 38.2086914062501 },
        { lat: 50.05234375, lng: 38.258593750000074 },
        { lat: 49.964062499999976, lng: 38.45117187500003 },
        { lat: 49.95458984375, lng: 38.55195312500004 },
        { lat: 49.95288085937499, lng: 38.64775390625002 },
        { lat: 49.88432617187499, lng: 38.77666015625002 },
        { lat: 49.82470703125, lng: 38.91835937499999 },
        { lat: 49.81840820312495, lng: 39.02773437499999 },
        { lat: 49.84174804687501, lng: 39.1149414062501 },
        { lat: 49.85595703124997, lng: 39.17480468750003 },
        { lat: 49.833203124999955, lng: 39.21181640624999 },
        { lat: 49.78193359374998, lng: 39.24599609375005 },
        { lat: 49.74204101562503, lng: 39.3029296875001 },
        { lat: 49.73066406250004, lng: 39.36845703125002 },
        { lat: 49.72802734375003, lng: 39.462792968749994 },
        { lat: 49.65068359374999, lng: 39.626562500000055 },
        { lat: 49.57202148437503, lng: 39.780566406250074 },
        { lat: 49.56767578125004, lng: 39.87685546875005 },
        { lat: 49.59077148437504, lng: 39.95849609374997 },
        { lat: 49.59672851562501, lng: 40.03066406250005 },
        { lat: 49.576855468749955, lng: 40.080664062500006 },
        { lat: 49.54267578125001, lng: 40.09492187500004 },
        { lat: 49.49707031250006, lng: 40.05781250000004 },
        { lat: 49.431542968750016, lng: 40.05781250000004 },
        { lat: 49.36884765625004, lng: 40.12617187500004 },
        { lat: 49.307226562500006, lng: 40.12832031250005 },
        { lat: 49.25156250000003, lng: 40.10878906250005 },
        { lat: 49.20029296874998, lng: 40.07001953125003 },
        { lat: 49.12983398437501, lng: 39.976367187500074 },
        { lat: 49.064062500000034, lng: 39.889746093750006 },
        { lat: 49.03657226562501, lng: 39.75947265625004 },
        { lat: 49.007910156250034, lng: 39.68652343749997 },
        { lat: 48.95957031250006, lng: 39.705664062500006 },
        { lat: 48.91445312500002, lng: 39.753320312499994 },
        { lat: 48.877978515625045, lng: 39.86376953124997 },
        { lat: 48.851416015625034, lng: 39.989160156249994 },
        { lat: 48.82207031250002, lng: 40.00361328125004 },
        { lat: 48.80737304687505, lng: 39.98447265625006 },
        { lat: 48.79375, lng: 39.90410156250002 },
        { lat: 48.807714843750034, lng: 39.792871093749994 },
        { lat: 48.782080078125034, lng: 39.75585937500003 },
        { lat: 48.739355468750034, lng: 39.70458984375002 },
        { lat: 48.662451171875006, lng: 39.67041015625002 },
        { lat: 48.59121093749996, lng: 39.64472656250009 },
        { lat: 48.571875, lng: 39.76542968750002 },
        { lat: 48.54277343749996, lng: 39.8356445312501 },
        { lat: 48.484228515625034, lng: 39.857519531250006 },
        { lat: 48.41909179687499, lng: 39.882617187500074 },
        { lat: 48.360449218750034, lng: 39.88984375000004 },
        { lat: 48.331933593749994, lng: 39.849902343750074 },
        { lat: 48.30278320312502, lng: 39.84746093750002 },
        { lat: 48.288427734375, lng: 39.866308593750006 },
        { lat: 48.28193359375001, lng: 39.91816406250003 },
        { lat: 48.26889648437503, lng: 39.95791015625005 },
        { lat: 48.23793945312502, lng: 39.96103515625006 },
        { lat: 48.168359374999966, lng: 39.88505859375002 },
        { lat: 48.03530273437505, lng: 39.81396484375003 },
        { lat: 47.964453125, lng: 39.77578125 },
        { lat: 47.88754882812506, lng: 39.778710937500044 },
        { lat: 47.844824218750055, lng: 39.7359375 },
        { lat: 47.84121093750002, lng: 39.658496093750074 },
        { lat: 47.83374023437502, lng: 39.39101562499999 },
        { lat: 47.83740234375005, lng: 39.158496093750074 },
        { lat: 47.848486328125006, lng: 39.0578125000001 },
        { lat: 47.85512695312502, lng: 38.90029296875005 },
        { lat: 47.83701171874998, lng: 38.82226562499997 },
        { lat: 47.71411132812497, lng: 38.71894531250004 },
        { lat: 47.66591796875002, lng: 38.640625 },
        { lat: 47.622412109375034, lng: 38.51093750000003 },
        { lat: 47.609960937500006, lng: 38.36884765625004 },
        { lat: 47.559179687500034, lng: 38.28740234375007 },
        { lat: 47.47954101562499, lng: 38.25878906250003 },
        { lat: 47.40893554687497, lng: 38.2565429687501 },
        { lat: 47.373681640624994, lng: 38.243261718750055 },
        { lat: 47.34277343749999, lng: 38.21240234374997 },
        { lat: 47.32080078124997, lng: 38.20136718750004 },
        { lat: 47.29653320312499, lng: 38.20800781249997 },
        { lat: 47.28769531249998, lng: 38.24101562500002 },
        { lat: 47.276660156250045, lng: 38.28076171874997 },
        { lat: 47.259033203125, lng: 38.28076171874997 },
        { lat: 47.23696289062502, lng: 38.26533203125009 },
        { lat: 47.21274414062498, lng: 38.22119140624997 },
        { lat: 47.17524414062498, lng: 38.20136718750004 },
        { lat: 47.13559570312498, lng: 38.205859375000074 },
        { lat: 47.091455078124966, lng: 38.21435546875003 },
        { lat: 47.08022460937499, lng: 38.17832031250006 },
        { lat: 47.095849609374966, lng: 37.82871093750006 },
        { lat: 47.07456054687498, lng: 37.54335937499999 },
        { lat: 46.916894531250016, lng: 37.33984375000003 },
        { lat: 46.917333984375006, lng: 37.21855468750002 },
        { lat: 46.87622070312499, lng: 37.0475585937501 },
        { lat: 46.82514648437498, lng: 36.93203125 },
        { lat: 46.71440429687499, lng: 36.794824218749994 },
        { lat: 46.764111328124976, lng: 36.68867187500004 },
        { lat: 46.76269531250006, lng: 36.55878906250004 },
        { lat: 46.73256835937502, lng: 36.43203125 },
        { lat: 46.658593749999966, lng: 36.2794921875001 },
        { lat: 46.64550781249997, lng: 36.19462890625002 },
        { lat: 46.66679687499996, lng: 36.02490234375003 },
        { lat: 46.62431640625002, lng: 35.82714843749997 },
        { lat: 46.38139648437499, lng: 35.40019531250002 },
        { lat: 46.20390624999998, lng: 35.256640625000074 },
        { lat: 46.169189453125, lng: 35.20439453125002 },
        { lat: 46.125878906249994, lng: 35.132324218749964 },
        { lat: 46.10400390625006, lng: 35.055273437500006 },
        { lat: 46.10600585937502, lng: 35.01455078125005 },
        { lat: 46.23217773437505, lng: 35.21777343749997 },
        { lat: 46.27949218750001, lng: 35.280175781249994 },
        { lat: 46.31440429687501, lng: 35.29091796875005 },
        { lat: 46.370703125000034, lng: 35.29199218749997 },
        { lat: 46.440625, lng: 35.230371093750044 },
        { lat: 46.267236328124994, lng: 35.0640625 },
        { lat: 46.24208984375002, lng: 34.96953125000002 },
        { lat: 46.189892578124955, lng: 34.84960937500003 },
        { lat: 46.07358398437498, lng: 34.84375 },
        { lat: 45.98735351562502, lng: 34.857324218749994 },
        { lat: 45.878808593749994, lng: 34.90664062499999 },
        { lat: 45.70097656250001, lng: 35.022851562500044 },
        { lat: 45.44692382812505, lng: 35.26015625 },
        { lat: 45.353613281250034, lng: 35.373925781249994 },
        { lat: 45.316308593749994, lng: 35.457519531249964 },
        { lat: 45.310888671875034, lng: 35.558007812499994 },
        { lat: 45.38935546875004, lng: 35.75097656249997 },
        { lat: 45.40161132812506, lng: 35.83349609375003 },
        { lat: 45.37167968749998, lng: 36.01289062500004 },
        { lat: 45.42412109375002, lng: 36.07714843749997 },
        { lat: 45.453076171874955, lng: 36.1705078125 },
        { lat: 45.45673828124998, lng: 36.29033203125007 },
        { lat: 45.433251953124994, lng: 36.42705078125007 },
        { lat: 45.3935546875, lng: 36.575 },
        { lat: 45.30375976562502, lng: 36.51425781250006 },
        { lat: 45.23232421875002, lng: 36.45078125 },
        { lat: 45.15327148437498, lng: 36.42841796875004 },
        { lat: 45.06538085937501, lng: 36.39335937500002 },
        { lat: 45.02597656249997, lng: 36.22988281250005 },
        { lat: 45.03081054687499, lng: 36.05478515625006 },
        { lat: 45.005322265624955, lng: 35.87011718750003 },
        { lat: 45.03959960937501, lng: 35.803613281250044 },
        { lat: 45.07084960937499, lng: 35.75947265625004 },
        { lat: 45.10200195312501, lng: 35.67753906250002 },
        { lat: 45.11933593750001, lng: 35.56953125000004 },
        { lat: 45.098486328125006, lng: 35.472558593749994 },
        { lat: 44.978417968749994, lng: 35.3578125 },
        { lat: 44.89633789062503, lng: 35.15478515625003 },
        { lat: 44.802636718749966, lng: 35.08769531250002 },
        { lat: 44.82358398437506, lng: 34.887792968750006 },
        { lat: 44.80712890625, lng: 34.716894531250006 },
        { lat: 44.72167968749999, lng: 34.46992187500004 },
        { lat: 44.53842773437506, lng: 34.28173828124997 },
        { lat: 44.423828124999964, lng: 34.0744140625001 },
        { lat: 44.387597656249966, lng: 33.909960937500074 },
        { lat: 44.39892578125005, lng: 33.75566406250002 },
        { lat: 44.433203125, lng: 33.655859375 },
        { lat: 44.553662109374955, lng: 33.45068359374997 },
        { lat: 44.59682617187505, lng: 33.46269531250002 },
        { lat: 44.618603515624955, lng: 33.491308593750055 },
        { lat: 44.680517578125034, lng: 33.530078125000074 },
        { lat: 44.90781249999998, lng: 33.612207031249994 },
        { lat: 44.98149414062499, lng: 33.60117187500006 },
        { lat: 45.09765625000003, lng: 33.55517578125003 },
        { lat: 45.187841796875006, lng: 33.392480468749994 },
        { lat: 45.170751953125006, lng: 33.261523437500074 },
        { lat: 45.19477539062501, lng: 33.18691406250005 },
        { lat: 45.34814453124999, lng: 32.9186523437501 },
        { lat: 45.35898437499998, lng: 32.77265625000004 },
        { lat: 45.32807617187498, lng: 32.61132812500002 },
        { lat: 45.35039062499999, lng: 32.55185546875006 },
        { lat: 45.40380859375005, lng: 32.5080078125001 },
        { lat: 45.59301757812505, lng: 32.828027343749994 },
        { lat: 45.74921874999998, lng: 33.1422851562501 },
        { lat: 45.76523437500006, lng: 33.28007812500002 },
        { lat: 45.83793945312502, lng: 33.466210937499994 },
        { lat: 45.94707031249996, lng: 33.664843750000074 },
        { lat: 46.03286132812505, lng: 33.63671875000003 },
        { lat: 46.09624023437499, lng: 33.59414062500005 },
        { lat: 46.078857421875, lng: 33.498828125000074 },
        { lat: 46.05761718750003, lng: 33.42988281250004 },
        { lat: 46.12568359375004, lng: 33.26347656250002 },
        { lat: 46.17573242187501, lng: 33.20224609375006 },
        { lat: 46.123779296875, lng: 32.94179687499999 },
        { lat: 46.131494140624966, lng: 32.796875 },
        { lat: 46.08369140625001, lng: 32.47675781250004 },
        { lat: 46.13037109374999, lng: 32.329882812500074 },
        { lat: 46.26098632812497, lng: 32.035742187500006 },
        { lat: 46.287255859374994, lng: 31.925195312500048 },
        { lat: 46.28168945312501, lng: 31.8312500000001 },
        { lat: 46.32465820312498, lng: 31.77998046875004 },
        { lat: 46.34614257812501, lng: 31.842871093750063 },
        { lat: 46.34868164062499, lng: 31.915917968749998 },
        { lat: 46.364404296874994, lng: 31.99169921874997 },
        { lat: 46.38715820312501, lng: 32.013085937499994 },
        { lat: 46.42998046875002, lng: 32.00849609375004 },
        { lat: 46.46245117187499, lng: 31.855761718750017 },
        { lat: 46.47177734375, lng: 31.713671875000017 },
        { lat: 46.51025390625003, lng: 31.62363281250006 },
        { lat: 46.554296875000034, lng: 31.554882812500097 },
        { lat: 46.55498046875002, lng: 31.71601562500004 },
        { lat: 46.521679687499976, lng: 31.87792968749997 },
        { lat: 46.509375, lng: 32.13144531250006 },
        { lat: 46.474951171875034, lng: 32.36132812499997 },
        { lat: 46.51777343749998, lng: 32.418945312499964 },
        { lat: 46.59199218749998, lng: 32.55253906250002 },
        { lat: 46.615625, lng: 32.578027343749994 },
        { lat: 46.564843749999966, lng: 32.354101562500006 },
        { lat: 46.59721679687499, lng: 32.127246093750074 },
        { lat: 46.64248046874996, lng: 32.04433593750005 },
        { lat: 46.70878906249999, lng: 31.974316406250093 },
        { lat: 46.784375, lng: 31.94492187500006 },
        { lat: 46.85483398437498, lng: 31.96406250000004 },
        { lat: 46.981982421875045, lng: 31.939550781250006 },
        { lat: 47.095117187499994, lng: 31.864746093749968 },
        { lat: 47.15722656250002, lng: 31.83818359375007 },
        { lat: 47.21284179687501, lng: 31.759179687500048 },
        { lat: 47.087011718750034, lng: 31.836914062499968 },
        { lat: 47.00327148437503, lng: 31.865917968750036 },
        { lat: 46.92612304687503, lng: 31.912695312500063 },
        { lat: 46.72163085937504, lng: 31.901660156250014 },
        { lat: 46.649755859375034, lng: 31.872851562500014 },
        { lat: 46.63164062499998, lng: 31.779589843750017 },
        { lat: 46.64243164062506, lng: 31.657031250000017 },
        { lat: 46.664746093749976, lng: 31.532128906249994 },
        { lat: 46.777294921875004, lng: 31.56337890625005 },
        { lat: 46.73837890624997, lng: 31.496875 },
        { lat: 46.62880859375002, lng: 31.402929687500063 },
        { lat: 46.6125, lng: 31.32031249999997 },
        { lat: 46.62446289062504, lng: 31.136816406250006 },
        { lat: 46.55200195312503, lng: 30.79628906249999 },
        { lat: 46.47304687500002, lng: 30.772851562499994 },
        { lat: 46.3662109375, lng: 30.72167968749997 },
        { lat: 46.304003906250045, lng: 30.672265625000048 },
        { lat: 46.266503906250016, lng: 30.65673828124997 },
        { lat: 46.105371093749966, lng: 30.511523437500074 },
        { lat: 46.09013671874998, lng: 30.49296875000002 },
        { lat: 45.866748046875045, lng: 30.219042968750074 },
        { lat: 45.84995117187498, lng: 30.184179687500006 },
        { lat: 45.79794921875006, lng: 30.006640625000074 },
        { lat: 45.75239257812501, lng: 29.901660156250074 },
        { lat: 45.73208007812505, lng: 29.82119140625005 },
        { lat: 45.75468750000004, lng: 29.68505859375003 },
        { lat: 45.722460937500045, lng: 29.628417968750025 },
        { lat: 45.68251953124999, lng: 29.601660156250063 },
        { lat: 45.6, lng: 29.60117187500006 },
        { lat: 45.54067382812505, lng: 29.6703125 },
        { lat: 45.34331054687499, lng: 29.72695312499999 },
        { lat: 45.25991210937505, lng: 29.70585937500007 },
        { lat: 45.31391601562504, lng: 29.651953125 },
        { lat: 45.37080078124998, lng: 29.567675781250074 },
        { lat: 45.41967773437499, lng: 29.40371093750005 },
        { lat: 45.402929687500034, lng: 29.22353515625005 },
        { lat: 45.32055664062506, lng: 29.027441406250063 },
        { lat: 45.28994140625002, lng: 28.894335937500017 },
        { lat: 45.31108398437498, lng: 28.82431640625006 },
        { lat: 45.30986328125001, lng: 28.78173828125 },
        { lat: 45.28623046874998, lng: 28.766601562500025 },
        { lat: 45.266894531250045, lng: 28.769824218750074 },
        { lat: 45.25190429687501, lng: 28.791406250000023 },
        { lat: 45.240966796875, lng: 28.78828125000001 },
        { lat: 45.23413085937503, lng: 28.7607421875 },
        { lat: 45.292187499999955, lng: 28.451269531250006 },
        { lat: 45.347119140624955, lng: 28.317675781250045 },
        { lat: 45.45043945312506, lng: 28.2125 },
        { lat: 45.48388671875003, lng: 28.264843750000036 },
        { lat: 45.49858398437499, lng: 28.310351562500074 },
        { lat: 45.50717773437506, lng: 28.47138671875001 },
        { lat: 45.517724609374994, lng: 28.499023437500057 },
        { lat: 45.541552734375045, lng: 28.501757812500074 },
        { lat: 45.57241210937502, lng: 28.513769531250034 },
        { lat: 45.61782226562505, lng: 28.50947265625004 },
        { lat: 45.66577148437502, lng: 28.49160156250005 },
        { lat: 45.735791015625004, lng: 28.562304687500074 },
        { lat: 45.79384765625002, lng: 28.667578125 },
        { lat: 45.852001953124955, lng: 28.729296875000074 },
        { lat: 45.937158203124994, lng: 28.738769531250025 },
        { lat: 45.97866210937502, lng: 28.849511718750055 },
        { lat: 46.049951171874966, lng: 28.947753906249968 },
        { lat: 46.12763671874998, lng: 28.971875 },
        { lat: 46.17646484374998, lng: 29.00625 },
        { lat: 46.28842773437506, lng: 28.94375 },
        { lat: 46.362255859375004, lng: 28.930566406250023 },
        { lat: 46.42412109374998, lng: 28.92744140625001 },
        { lat: 46.45849609374997, lng: 28.958398437500023 },
        { lat: 46.49702148437501, lng: 29.049902343750006 },
        { lat: 46.52690429687496, lng: 29.146289062500017 },
        { lat: 46.52397460937499, lng: 29.186230468750068 },
        { lat: 46.504980468750034, lng: 29.20078125 },
        { lat: 46.37934570312501, lng: 29.204589843749968 },
        { lat: 46.37695312499997, lng: 29.223828125000097 },
        { lat: 46.39262695312495, lng: 29.25458984375004 },
        { lat: 46.46660156250001, lng: 29.304882812500097 },
        { lat: 46.445068359375, lng: 29.339550781250043 },
        { lat: 46.43691406250002, lng: 29.392871093750074 },
        { lat: 46.455957031249994, lng: 29.43281250000004 },
        { lat: 46.45375976562499, lng: 29.458789062500017 },
        { lat: 46.434667968750006, lng: 29.49101562500007 },
        { lat: 46.407763671875045, lng: 29.55507812499999 },
        { lat: 46.39882812499999, lng: 29.614941406250097 },
        { lat: 46.416748046875, lng: 29.66455078124997 },
        { lat: 46.44873046875003, lng: 29.706835937500017 },
        { lat: 46.43779296875002, lng: 29.75195312499997 },
        { lat: 46.35053710937501, lng: 29.83789062499997 },
        { lat: 46.360205078125034, lng: 29.878027343750063 },
        { lat: 46.37783203124996, lng: 30.07568359375003 },
        { lat: 46.40156250000001, lng: 30.107519531250002 },
        { lat: 46.42309570312505, lng: 30.131054687500097 },
        { lat: 46.53886718750002, lng: 29.92431640624997 },
        { lat: 46.625, lng: 29.934765625000097 },
        { lat: 46.72377929687502, lng: 29.942480468750063 },
        { lat: 46.782421874999976, lng: 29.918066406250063 },
        { lat: 46.828906250000045, lng: 29.877832031249994 },
        { lat: 46.882910156250034, lng: 29.719726562499968 },
        { lat: 46.93881835937503, lng: 29.597753906250063 },
        { lat: 46.96401367187502, lng: 29.57197265625004 },
        { lat: 46.99672851562502, lng: 29.568652343750017 },
        { lat: 47.047509765624994, lng: 29.56347656250003 },
        { lat: 47.09111328124998, lng: 29.515039062499994 },
        { lat: 47.12802734375003, lng: 29.51093750000004 },
        { lat: 47.18554687500003, lng: 29.541796875000017 },
        { lat: 47.246826171875, lng: 29.54931640624997 },
        { lat: 47.27099609375003, lng: 29.539160156250002 },
        { lat: 47.29072265624998, lng: 29.51064453124999 },
        { lat: 47.292626953124994, lng: 29.455664062500002 },
        { lat: 47.32802734375002, lng: 29.383398437500002 },
        { lat: 47.37573242187497, lng: 29.333789062500014 },
        { lat: 47.44448242187502, lng: 29.20058593749999 },
        { lat: 47.455664062500006, lng: 29.159765625 },
        { lat: 47.48969726562501, lng: 29.134863281250006 },
        { lat: 47.53037109375003, lng: 29.122949218750048 },
        { lat: 47.58085937500002, lng: 29.150878906250053 },
        { lat: 47.65859375000005, lng: 29.18603515625003 },
        { lat: 47.73154296874998, lng: 29.210742187500017 },
        { lat: 47.775, lng: 29.211132812500097 },
        { lat: 47.88242187499997, lng: 29.19482421875006 },
        { lat: 47.96455078125001, lng: 29.125390625000023 },
        { lat: 47.975439453125034, lng: 29.09296874999998 },
        { lat: 47.95234375, lng: 29.036914062500017 },
        { lat: 47.933007812499994, lng: 28.97333984375004 },
        { lat: 47.951123046874955, lng: 28.923144531250042 },
        { lat: 47.99565429687496, lng: 28.865820312499977 },
        { lat: 48.119580078124976, lng: 28.77382812500008 },
        { lat: 48.14438476562498, lng: 28.601660156250002 },
        { lat: 48.15029296875002, lng: 28.530468750000068 },
        { lat: 48.09052734375001, lng: 28.46308593750001 },
        { lat: 48.10869140624998, lng: 28.441992187500063 },
        { lat: 48.146875, lng: 28.42304687500001 },
        { lat: 48.16210937500002, lng: 28.3875 },
        { lat: 48.144433593749994, lng: 28.34052734375001 },
        { lat: 48.16142578124999, lng: 28.326953125000074 },
        { lat: 48.21303710937502, lng: 28.34716796875003 },
        { lat: 48.23857421874999, lng: 28.29101562500003 },
        { lat: 48.237988281249955, lng: 28.158789062500002 },
        { lat: 48.25703125000001, lng: 28.088476562499977 },
        { lat: 48.29580078124999, lng: 28.080078125000057 },
        { lat: 48.32128906250006, lng: 28.038476562500023 },
        { lat: 48.33354492187496, lng: 27.963378906249996 },
        { lat: 48.36523437500003, lng: 27.890625 },
        { lat: 48.41625976562503, lng: 27.82001953125001 },
        { lat: 48.44951171874996, lng: 27.714453125 },
        { lat: 48.46489257812498, lng: 27.57373046875 },
        { lat: 48.470410156249955, lng: 27.562207031250068 },
        { lat: 48.47773437500004, lng: 27.54921875000008 },
        { lat: 48.44306640624998, lng: 27.45839843750005 },
        { lat: 48.415625, lng: 27.40380859375003 },
        { lat: 48.432714843750006, lng: 27.336914062499996 },
        { lat: 48.37143554687506, lng: 27.22851562500003 },
        { lat: 48.36826171875003, lng: 27.008496093750068 },
        { lat: 48.371923828125055, lng: 26.90058593750001 },
        { lat: 48.38715820312495, lng: 26.847070312500023 },
        { lat: 48.294140625, lng: 26.640429687500042 },
        { lat: 48.259863281250055, lng: 26.618945312500014 },
        { lat: 48.248486328124955, lng: 26.57246093750004 },
        { lat: 48.22998046875, lng: 26.4423828125 },
        { lat: 48.203759765624994, lng: 26.305664062500057 },
        { lat: 48.11323242187504, lng: 26.276953125000063 },
        { lat: 48.06435546875002, lng: 26.236230468750023 },
        { lat: 47.992529296875034, lng: 26.162695312500063 },
        { lat: 47.96757812500002, lng: 25.90869140625 },
        { lat: 47.93247070312506, lng: 25.689257812500045 },
        { lat: 47.910791015624994, lng: 25.46425781250005 },
        { lat: 47.82309570312498, lng: 25.169628906250068 },
        { lat: 47.745703125000034, lng: 25.073828125 },
        { lat: 47.72412109374997, lng: 24.97910156250006 },
        { lat: 47.71777343750002, lng: 24.89335937499999 },
        { lat: 47.760839843750006, lng: 24.83789062499997 },
        { lat: 47.87651367187502, lng: 24.650976562500006 },
        { lat: 47.93105468750005, lng: 24.57890625000007 },
        { lat: 47.947119140625034, lng: 24.48408203125001 },
        { lat: 47.938037109375045, lng: 24.380957031250063 },
        { lat: 47.91118164062499, lng: 24.28193359375004 },
        { lat: 47.90605468750002, lng: 24.177734375000057 },
        { lat: 47.944775390624976, lng: 24.059765624999983 },
        { lat: 47.941015625000034, lng: 24.047363281250057 },
        { lat: 47.93579101562503, lng: 24.001855468750023 },
        { lat: 47.98261718749998, lng: 23.70898437500003 },
        { lat: 47.99038085937505, lng: 23.68203125000005 },
        { lat: 47.992333984374994, lng: 23.669042968750063 },
        { lat: 47.995849609375, lng: 23.628710937500017 },
        { lat: 47.98999023437505, lng: 23.40820312500003 },
        { lat: 48.084521484375045, lng: 23.20263671875 },
        { lat: 48.08740234375, lng: 23.139453124999985 },
        { lat: 48.04912109375002, lng: 23.09082031250003 },
        { lat: 48.006542968749955, lng: 23.05478515625006 },
        { lat: 47.964257812499966, lng: 22.912890625000014 },
        { lat: 47.94726562500006, lng: 22.87666015625001 },
        { lat: 47.960302734375034, lng: 22.856054687500006 },
        { lat: 47.9970703125, lng: 22.846484374999985 },
        { lat: 48.02954101562503, lng: 22.857226562500045 },
        { lat: 48.060302734375, lng: 22.836230468750042 },
        { lat: 48.09521484375, lng: 22.782226562500053 },
        { lat: 48.109619140625, lng: 22.769140625000063 },
        { lat: 48.10703125, lng: 22.70156250000005 },
        { lat: 48.10361328125003, lng: 22.68310546875003 },
        { lat: 48.104394531249994, lng: 22.67636718750006 },
        { lat: 48.134033203125, lng: 22.58242187500002 },
        { lat: 48.20537109374995, lng: 22.52011718750003 },
        { lat: 48.243310546874966, lng: 22.423828125000057 },
        { lat: 48.25605468749998, lng: 22.350195312500063 },
        { lat: 48.28662109375, lng: 22.31669921875007 },
        { lat: 48.327294921875016, lng: 22.29511718750001 },
        { lat: 48.35800781249998, lng: 22.272167968750068 },
        { lat: 48.36088867187504, lng: 22.269433593750023 },
        { lat: 48.407373046874994, lng: 22.253710937500017 },
        { lat: 48.41215820312499, lng: 22.23115234375004 },
        { lat: 48.41342773437498, lng: 22.22714843750003 },
        { lat: 48.40532226562502, lng: 22.131835937500057 },
        { lat: 48.568505859374966, lng: 22.142871093750017 },
        { lat: 48.68583984374999, lng: 22.295214843750042 },
        { lat: 48.745068359374955, lng: 22.332617187500034 },
        { lat: 48.87348632812501, lng: 22.389453125000045 },
        { lat: 48.93354492187498, lng: 22.432031250000023 },
        { lat: 48.983251953125, lng: 22.48320312500007 },
        { lat: 49.03139648437502, lng: 22.52412109375004 },
        { lat: 49.07270507812501, lng: 22.538671875 },
        { lat: 49.07719726562504, lng: 22.57998046875005 },
        { lat: 49.03994140624999, lng: 22.701269531249977 },
        { lat: 49.020751953125, lng: 22.809765625000065 },
        { lat: 49.038916015625055, lng: 22.83974609375005 },
        { lat: 49.06274414062503, lng: 22.852050781250057 },
        { lat: 49.08125, lng: 22.847070312500023 },
        { lat: 49.13623046874997, lng: 22.760156250000076 },
        { lat: 49.17119140624999, lng: 22.705664062500006 },
        { lat: 49.19272460937503, lng: 22.70234375000004 },
        { lat: 49.240966796875, lng: 22.721972656250045 },
        { lat: 49.29516601562503, lng: 22.73242187500003 },
        { lat: 49.35380859374998, lng: 22.719921875000065 },
        { lat: 49.48369140624999, lng: 22.660644531250057 },
        { lat: 49.53901367187498, lng: 22.649414062499996 },
        { lat: 49.60620117187497, lng: 22.706152343750006 },
        { lat: 49.766259765624994, lng: 22.890722656250034 },
        { lat: 49.82636718749998, lng: 22.952246093750063 },
        { lat: 49.899072265624966, lng: 23.036328125000036 },
        { lat: 50.072851562500006, lng: 23.264453125000074 },
        { lat: 50.173925781250006, lng: 23.408593750000023 },
        { lat: 50.229833984375034, lng: 23.506152343750017 },
        { lat: 50.32705078125002, lng: 23.64902343750006 },
        { lat: 50.377343749999966, lng: 23.711718750000045 },
        { lat: 50.410058593749966, lng: 23.97265625 },
        { lat: 50.45703125000003, lng: 24.004980468750034 },
        { lat: 50.50844726562502, lng: 24.05263671875005 },
        { lat: 50.53046874999998, lng: 24.089941406250006 },
        { lat: 50.617041015625034, lng: 24.0947265625 },
        { lat: 50.722802734374994, lng: 24.046289062499994 },
        { lat: 50.760156249999966, lng: 24.007324218750057 },
        { lat: 50.78559570312501, lng: 23.978417968750023 },
        { lat: 50.809375, lng: 23.9970703125 },
        { lat: 50.81616210937503, lng: 24.025976562500034 },
        { lat: 50.819531249999976, lng: 24.061621093750002 },
        { lat: 50.84497070312503, lng: 24.105761718750045 },
        { lat: 50.87275390625001, lng: 24.095800781250063 },
        { lat: 50.94042968750003, lng: 23.985742187500023 },
        { lat: 50.99252929687498, lng: 23.938085937499977 },
        { lat: 51.12622070312503, lng: 23.863476562500068 },
        { lat: 51.26513671875, lng: 23.712207031250074 },
        { lat: 51.31005859374999, lng: 23.66445312500002 },
        { lat: 51.35249023437504, lng: 23.65761718750005 },
        { lat: 51.394921874999966, lng: 23.6796875 },
        { lat: 51.44897460937497, lng: 23.65888671875004 },
        { lat: 51.51791992187498, lng: 23.605273437500045 },
        { lat: 51.525390625, lng: 23.613769531249996 },
        { lat: 51.61049804687502, lng: 23.60859375000001 },
        { lat: 51.62885742187504, lng: 23.64667968750004 },
        { lat: 51.64130859374998, lng: 23.706835937500045 },
        { lat: 51.63710937500002, lng: 23.79169921875001 },
        { lat: 51.62397460937501, lng: 23.864257812500053 },
        { lat: 51.58505859374998, lng: 23.951171875 },
        { lat: 51.59130859375003, lng: 23.978320312500017 },
        { lat: 51.664648437500034, lng: 24.12685546875008 },
        { lat: 51.77470703124998, lng: 24.280078125000017 },
        { lat: 51.83842773437499, lng: 24.323730468750025 },
        { lat: 51.86752929687498, lng: 24.361914062500006 },
        { lat: 51.88305664062503, lng: 24.495214843750063 },
        { lat: 51.889501953125006, lng: 24.611328125 },
        { lat: 51.888281250000034, lng: 24.685156250000034 },
        { lat: 51.89912109375001, lng: 24.86640625 },
        { lat: 51.91113281249997, lng: 24.973828125000036 },
        { lat: 51.930517578125034, lng: 25.066699218750045 },
        { lat: 51.937744140624964, lng: 25.267187500000034 },
        { lat: 51.92475585937501, lng: 25.580273437500068 },
        { lat: 51.92382812499999, lng: 25.785742187500006 },
        { lat: 51.91352539062501, lng: 25.925292968749996 },
        { lat: 51.85502929687502, lng: 26.26708984375 },
        { lat: 51.844433593749976, lng: 26.394335937500074 },
        { lat: 51.813427734374976, lng: 26.453417968750045 },
        { lat: 51.80190429687502, lng: 26.566894531250057 },
        { lat: 51.77070312499998, lng: 26.77343750000003 },
        { lat: 51.754003906250034, lng: 26.952832031249983 },
        { lat: 51.760839843750006, lng: 27.074121093750023 },
        { lat: 51.75205078124998, lng: 27.141992187500076 },
        { lat: 51.61357421875002, lng: 27.270117187500063 },
        { lat: 51.59741210937502, lng: 27.29628906250008 },
        { lat: 51.594140624999966, lng: 27.347656250000053 },
        { lat: 51.60610351562502, lng: 27.452343750000065 },
        { lat: 51.60161132812499, lng: 27.601367187500045 },
        { lat: 51.572412109374994, lng: 27.689746093750017 },
        { lat: 51.48994140624998, lng: 27.67675781250003 },
        { lat: 51.47797851562501, lng: 27.7 },
        { lat: 51.482568359374966, lng: 27.741308593750034 },
        { lat: 51.52915039062506, lng: 27.788867187500042 },
        { lat: 51.577441406250045, lng: 27.82880859375001 },
        { lat: 51.59238281250006, lng: 27.858593750000036 },
        { lat: 51.559765624999976, lng: 28.010742187500053 },
        { lat: 51.565039062500006, lng: 28.08027343750001 },
        { lat: 51.601660156250006, lng: 28.14443359375002 },
        { lat: 51.607861328125004, lng: 28.18378906250004 },
        { lat: 51.581835937500045, lng: 28.29160156250006 },
        { lat: 51.563623046874966, lng: 28.424609375000074 },
        { lat: 51.56245117187501, lng: 28.532031250000017 },
        { lat: 51.54262695312505, lng: 28.59902343750008 },
        { lat: 51.45654296875, lng: 28.647753906250074 },
        { lat: 51.43886718750005, lng: 28.690234375000017 },
        { lat: 51.43339843749999, lng: 28.73125 },
        { lat: 51.510351562500034, lng: 28.793261718750045 },
        { lat: 51.540185546874994, lng: 28.849511718750055 },
        { lat: 51.56215820312502, lng: 28.927539062500045 },
        { lat: 51.57177734375003, lng: 28.977734375000036 },
        { lat: 51.59892578124996, lng: 29.013085937500048 },
        { lat: 51.625439453124955, lng: 29.060742187500008 },
        { lat: 51.627539062500034, lng: 29.102050781250057 },
        { lat: 51.61728515624998, lng: 29.13564453125008 },
        { lat: 51.58061523437496, lng: 29.17421875000002 },
        { lat: 51.49702148437498, lng: 29.23046875000003 },
        { lat: 51.413037109375004, lng: 29.29882812500003 },
        { lat: 51.38256835937503, lng: 29.346484375000014 },
        { lat: 51.408349609375044, lng: 29.469628906249998 },
        { lat: 51.43457031249997, lng: 29.553125 },
        { lat: 51.439550781250006, lng: 29.70605468750003 },
        { lat: 51.45800781250003, lng: 29.908789062500002 },
        { lat: 51.482031250000034, lng: 30.063769531250074 },
        { lat: 51.477880859375006, lng: 30.160742187500002 },
        { lat: 51.45122070312499, lng: 30.219531250000017 },
        { lat: 51.399609374999955, lng: 30.30898437499999 },
        { lat: 51.32553710937506, lng: 30.333398437499994 },
        { lat: 51.274316406249994, lng: 30.449511718750017 },
        { lat: 51.265039062499994, lng: 30.544531250000063 },
        { lat: 51.318359375, lng: 30.576953125000074 },
        { lat: 51.35541992187501, lng: 30.63251953125004 },
        { lat: 51.406347656250006, lng: 30.61171875000005 },
        { lat: 51.47124023437499, lng: 30.602343750000017 },
        { lat: 51.531494140625, lng: 30.560742187500043 },
        { lat: 51.59633789062496, lng: 30.533007812500017 },
        { lat: 51.68896484375002, lng: 30.583886718749994 },
        { lat: 51.77006835937502, lng: 30.639453125000017 },
        { lat: 51.81411132812502, lng: 30.667285156250017 },
        { lat: 51.89516601562502, lng: 30.755273437499994 },
        { lat: 51.95307617187501, lng: 30.84570312500003 },
        { lat: 52.04619140624995, lng: 30.980664062500097 },
        { lat: 52.07695312500002, lng: 31.079296875000097 },
        { lat: 52.06293945312501, lng: 31.16845703124997 },
        { lat: 52.050244140624976, lng: 31.217968750000093 },
        { lat: 52.10537109375002, lng: 31.34599609375007 },
        { lat: 52.108105468749955, lng: 31.573730468750025 },
        { lat: 52.10107421875003, lng: 31.763378906250093 },
        { lat: 52.09941406249995, lng: 31.782421875000097 },
        { lat: 52.070898437500034, lng: 31.87558593750006 },
        { lat: 52.04663085937506, lng: 31.973828125000097 },
        { lat: 52.04501953124998, lng: 32.041601562500006 },
        { lat: 52.05058593749996, lng: 32.12226562500004 },
        { lat: 52.08295898437498, lng: 32.21679687500003 },
        { lat: 52.114013671875, lng: 32.28281250000006 },
        { lat: 52.272119140624994, lng: 32.36298828125003 },
        { lat: 52.29482421874999, lng: 32.39130859375004 },
        { lat: 52.307226562500034, lng: 32.435449218749994 },
        { lat: 52.30854492187504, lng: 32.507910156250006 },
        { lat: 52.27910156249999, lng: 32.64541015625005 },
        { lat: 52.252636718750004, lng: 32.806445312500074 },
        { lat: 52.25634765625006, lng: 32.899707031250074 },
        { lat: 52.340429687500034, lng: 33.14843750000003 },
        { lat: 52.35356445312496, lng: 33.28710937500002 },
        { lat: 52.33378906250002, lng: 33.4518554687501 },
      ],
    ],
  },
  {
    code: "VA",
    coordinates: [
      [
        { lat: 41.89838867187499, lng: 12.439160156250011 },
        { lat: 41.89755859375, lng: 12.430566406250021 },
        { lat: 41.900732421875, lng: 12.427539062500015 },
        { lat: 41.90546875, lng: 12.430566406250021 },
        { lat: 41.906201171875, lng: 12.438378906250023 },
        { lat: 41.89838867187499, lng: 12.439160156250011 },
      ],
    ],
  },
  {
    code: "MA",
    coordinates: [
      [
        { lat: 35.206396484375006, lng: -4.628320312499966 },
        { lat: 35.161474609375006, lng: -4.329980468749937 },
        { lat: 35.243408203125, lng: -3.982421875 },
        { lat: 35.244921875000045, lng: -3.787988281250023 },
        { lat: 35.27998046874998, lng: -3.693261718749994 },
        { lat: 35.228320312500045, lng: -3.590625 },
        { lat: 35.21181640625005, lng: -3.394726562499926 },
        { lat: 35.239111328125006, lng: -3.206005859374926 },
        { lat: 35.317236328125034, lng: -3.063085937499949 },
        { lat: 35.40727539062499, lng: -2.972216796874989 },
        { lat: 35.36308593749996, lng: -2.957958984374926 },
        { lat: 35.315136718749955, lng: -2.953613281249943 },
        { lat: 35.28710937500003, lng: -2.925976562499983 },
        { lat: 35.17265624999999, lng: -2.869531249999937 },
        { lat: 35.127832031249994, lng: -2.839941406249949 },
        { lat: 35.135205078124976, lng: -2.731396484374955 },
        { lat: 35.11269531250002, lng: -2.636816406249977 },
        { lat: 35.12348632812498, lng: -2.423730468749994 },
        { lat: 35.104199218749976, lng: -2.219628906249965 },
        { lat: 35.02978515625, lng: -2.190771484374948 },
        { lat: 34.970849609374994, lng: -2.131787109374926 },
        { lat: 34.835546875000034, lng: -1.920898437499943 },
        { lat: 34.751904296874955, lng: -1.795605468749926 },
        { lat: 34.72319335937499, lng: -1.792187499999926 },
        { lat: 34.654638671875034, lng: -1.832421874999966 },
        { lat: 34.607324218749994, lng: -1.849658203125017 },
        { lat: 34.55708007812498, lng: -1.816601562499926 },
        { lat: 34.49609375, lng: -1.739453124999926 },
        { lat: 34.46704101562503, lng: -1.733300781250023 },
        { lat: 34.43325195312496, lng: -1.751855468749966 },
        { lat: 34.36791992187499, lng: -1.791796874999932 },
        { lat: 34.17607421874999, lng: -1.706933593749966 },
        { lat: 33.99028320312496, lng: -1.692675781249989 },
        { lat: 33.85820312499995, lng: -1.714697265624949 },
        { lat: 33.781835937500034, lng: -1.714111328125 },
        { lat: 33.716845703125045, lng: -1.702978515624977 },
        { lat: 33.566748046875006, lng: -1.63125 },
        { lat: 33.31865234375002, lng: -1.67919921875 },
        { lat: 33.18334960937497, lng: -1.625097656250005 },
        { lat: 33.073583984375006, lng: -1.550732421874954 },
        { lat: 32.877636718749955, lng: -1.510009765625 },
        { lat: 32.784814453124966, lng: -1.45 },
        { lat: 32.70336914062497, lng: -1.352148437499977 },
        { lat: 32.67568359375002, lng: -1.29638671875 },
        { lat: 32.608496093750006, lng: -1.188232421875 },
        { lat: 32.55229492187502, lng: -1.111035156249983 },
        { lat: 32.46831054687496, lng: -1.065527343749949 },
        { lat: 32.399169921875, lng: -1.16259765625 },
        { lat: 32.33759765624998, lng: -1.240332031249949 },
        { lat: 32.27114257812502, lng: -1.262109374999937 },
        { lat: 32.16455078125, lng: -1.225927734374949 },
        { lat: 32.10722656250004, lng: -1.225927734374949 },
        { lat: 32.089013671874966, lng: -1.275341796874983 },
        { lat: 32.094873046874994, lng: -1.477050781249943 },
        { lat: 32.09956054687498, lng: -1.63515625 },
        { lat: 32.10478515624998, lng: -1.81699218749992 },
        { lat: 32.11503906250002, lng: -2.072802734374989 },
        { lat: 32.12133789062497, lng: -2.23125 },
        { lat: 32.12998046875006, lng: -2.448388671874937 },
        { lat: 32.12568359374998, lng: -2.523242187500017 },
        { lat: 32.09575195312502, lng: -2.722607421874955 },
        { lat: 32.074707031249964, lng: -2.863427734374937 },
        { lat: 32.06884765625003, lng: -2.88720703125 },
        { lat: 32.04252929687499, lng: -2.930859374999926 },
        { lat: 31.963964843749977, lng: -2.961132812499955 },
        { lat: 31.874218749999983, lng: -2.988232421874983 },
        { lat: 31.834277343750017, lng: -3.01738281249996 },
        { lat: 31.70454101562498, lng: -3.439794921874949 },
        { lat: 31.686767578125, lng: -3.604589843749948 },
        { lat: 31.70009765625005, lng: -3.700244140624989 },
        { lat: 31.689550781250034, lng: -3.768164062499977 },
        { lat: 31.661914062499985, lng: -3.82675781249992 },
        { lat: 31.619873046875057, lng: -3.846679687499971 },
        { lat: 31.56640625, lng: -3.849560546874955 },
        { lat: 31.512353515624994, lng: -3.837109374999983 },
        { lat: 31.43710937500003, lng: -3.79643554687496 },
        { lat: 31.361816406250053, lng: -3.789160156249977 },
        { lat: 31.308837890625, lng: -3.815136718749954 },
        { lat: 31.25546875000006, lng: -3.821386718749978 },
        { lat: 31.19780273437505, lng: -3.833398437499938 },
        { lat: 31.166601562499977, lng: -3.811816406249988 },
        { lat: 31.161816406249983, lng: -3.77099609375 },
        { lat: 31.13540039062502, lng: -3.730175781249955 },
        { lat: 31.111376953125014, lng: -3.672509765624937 },
        { lat: 31.065771484375034, lng: -3.62451171875 },
        { lat: 31.00092773437498, lng: -3.626904296874954 },
        { lat: 30.964013671875023, lng: -3.666796874999932 },
        { lat: 30.94448242187502, lng: -3.702001953124977 },
        { lat: 30.927246093749968, lng: -3.860058593749954 },
        { lat: 30.913525390625036, lng: -3.985351562499972 },
        { lat: 30.8095703125, lng: -4.148779296874977 },
        { lat: 30.698876953124994, lng: -4.322851562500006 },
        { lat: 30.62553710937499, lng: -4.52915039062492 },
        { lat: 30.604785156250014, lng: -4.619628906249972 },
        { lat: 30.55239257812499, lng: -4.778515624999926 },
        { lat: 30.465380859375042, lng: -4.968261718749943 },
        { lat: 30.326416015625057, lng: -5.061914062499937 },
        { lat: 30.166162109374994, lng: -5.180126953124955 },
        { lat: 30.058642578125045, lng: -5.293652343749983 },
        { lat: 29.956933593750023, lng: -5.448779296874959 },
        { lat: 29.91796874999997, lng: -5.593310546875017 },
        { lat: 29.86904296875005, lng: -5.775 },
        { lat: 29.83125, lng: -6.00429687499999 },
        { lat: 29.81894531250006, lng: -6.166503906249999 },
        { lat: 29.810693359374966, lng: -6.214794921874955 },
        { lat: 29.80830078125001, lng: -6.357617187499925 },
        { lat: 29.816113281250008, lng: -6.427636718749994 },
        { lat: 29.82036132812499, lng: -6.479736328124943 },
        { lat: 29.809130859375014, lng: -6.500878906249994 },
        { lat: 29.783789062500006, lng: -6.507910156250005 },
        { lat: 29.72602539062495, lng: -6.510693359374954 },
        { lat: 29.65986328124998, lng: -6.520556640624989 },
        { lat: 29.60385742187503, lng: -6.565673828124943 },
        { lat: 29.578955078125002, lng: -6.59775390624992 },
        { lat: 29.568798828124983, lng: -6.635351562499949 },
        { lat: 29.583837890625034, lng: -6.755126953124999 },
        { lat: 29.601611328125014, lng: -6.855566406249949 },
        { lat: 29.625195312500008, lng: -7.094921874999955 },
        { lat: 29.61958007812504, lng: -7.142431640624949 },
        { lat: 29.61264648437503, lng: -7.160205078124932 },
        { lat: 29.574902343749983, lng: -7.234912109374959 },
        { lat: 29.49472656250001, lng: -7.349755859374994 },
        { lat: 29.425, lng: -7.427685546874982 },
        { lat: 29.39223632812499, lng: -7.485742187499994 },
        { lat: 29.37519531249998, lng: -7.624609374999948 },
        { lat: 29.34951171874999, lng: -7.685156249999949 },
        { lat: 29.17475585937501, lng: -7.943847656249972 },
        { lat: 29.132421874999974, lng: -7.998925781249994 },
        { lat: 28.980517578125045, lng: -8.265185546874989 },
        { lat: 28.93017578125, lng: -8.340478515624937 },
        { lat: 28.880175781250017, lng: -8.399316406249937 },
        { lat: 28.76787109374996, lng: -8.558349609375028 },
        { lat: 28.71860351562506, lng: -8.659912109375 },
        { lat: 28.689404296874983, lng: -8.678417968749955 },
        { lat: 28.620751953125023, lng: -8.683349609375 },
        { lat: 28.46923828124997, lng: -8.683349609375 },
        { lat: 28.323681640624983, lng: -8.683349609375 },
        { lat: 28.11201171875004, lng: -8.683349609375 },
        { lat: 27.900390625, lng: -8.683349609375 },
        { lat: 27.65644531250004, lng: -8.683349609375 },
        { lat: 27.65644531250004, lng: -8.817822265624953 },
        { lat: 27.65590820312502, lng: -8.817773437499937 },
        { lat: 27.61386718750006, lng: -8.813916015624955 },
        { lat: 27.530859375000034, lng: -8.784570312499994 },
        { lat: 27.460546875, lng: -8.774365234374983 },
        { lat: 27.416552734375017, lng: -8.788964843750023 },
        { lat: 27.360937500000034, lng: -8.802685546874955 },
        { lat: 27.30820312500006, lng: -8.796826171874926 },
        { lat: 27.250585937500034, lng: -8.774365234374983 },
        { lat: 27.191015624999977, lng: -8.753857421874955 },
        { lat: 27.150976562500006, lng: -8.753857421874955 },
        { lat: 27.120703125000034, lng: -8.794873046874983 },
        { lat: 27.104101562500034, lng: -8.889062499999964 },
        { lat: 27.090429687500006, lng: -9.001904296874955 },
        { lat: 27.090429687500006, lng: -9.084423828124983 },
        { lat: 27.100195312500034, lng: -9.208447265624955 },
        { lat: 27.098242187500002, lng: -9.285595703124926 },
        { lat: 27.098242187500002, lng: -9.352978515624983 },
        { lat: 27.088476562500063, lng: -9.413037109374955 },
        { lat: 27.050390625, lng: -9.4873046875 },
        { lat: 26.990820312500063, lng: -9.569824218749941 },
        { lat: 26.910742187499977, lng: -9.673339843749972 },
        { lat: 26.86093750000006, lng: -9.7353515625 },
        { lat: 26.850195312500002, lng: -9.817871093750028 },
        { lat: 26.850195312500002, lng: -9.900341796874955 },
        { lat: 26.890234374999977, lng: -9.980908203124924 },
        { lat: 26.910742187499977, lng: -10.03271484375 },
        { lat: 26.908789062500034, lng: -10.066845703124926 },
        { lat: 26.880468750000034, lng: -10.123046875000027 },
        { lat: 26.86093750000006, lng: -10.189453124999972 },
        { lat: 26.86093750000006, lng: -10.251464843749972 },
        { lat: 26.900976562500034, lng: -10.354931640624926 },
        { lat: 26.960546875, lng: -10.478955078124955 },
        { lat: 26.990820312500063, lng: -10.551269531249943 },
        { lat: 27.000585937500006, lng: -10.654248046874983 },
        { lat: 27.020117187499977, lng: -10.757763671874926 },
        { lat: 27.010351562500034, lng: -10.830078125 },
        { lat: 27.010351562500034, lng: -10.922802734374983 },
        { lat: 26.970312500000034, lng: -11.046826171874926 },
        { lat: 26.941015625000034, lng: -11.150341796874955 },
        { lat: 26.910742187499977, lng: -11.263623046874955 },
        { lat: 26.883398437500006, lng: -11.392578125000028 },
        { lat: 26.793554687500006, lng: -11.361279296874955 },
        { lat: 26.744726562500006, lng: -11.316845703124955 },
        { lat: 26.684179687500006, lng: -11.316845703124955 },
        { lat: 26.633398437499977, lng: -11.337890624999972 },
        { lat: 26.583593750000034, lng: -11.39990234375 },
        { lat: 26.520117187499977, lng: -11.470703124999943 },
        { lat: 26.470312500000063, lng: -11.511669921874955 },
        { lat: 26.400976562500063, lng: -11.553173828124955 },
        { lat: 26.360937499999977, lng: -11.583984374999943 },
        { lat: 26.295507812500063, lng: -11.637207031249943 },
        { lat: 26.213476562500034, lng: -11.684521484374981 },
        { lat: 26.162695312500006, lng: -11.699218749999972 },
        { lat: 26.10410156250006, lng: -11.718212890624926 },
        { lat: 26.086523437500034, lng: -11.754882812499943 },
        { lat: 26.070898437500034, lng: -11.880859375000027 },
        { lat: 26.05039062500003, lng: -11.960888671874983 },
        { lat: 26.030859375000063, lng: -12.03076171875 },
        { lat: 25.99633789062503, lng: -12.056787109374966 },
        { lat: 25.990820312499977, lng: -12.060986328124955 },
        { lat: 25.920507812500034, lng: -12.081054687499943 },
        { lat: 25.87070312500003, lng: -12.081054687499943 },
        { lat: 25.830664062500034, lng: -12.101025390624926 },
        { lat: 25.731054687500006, lng: -12.130859374999972 },
        { lat: 25.64023437500006, lng: -12.170849609374953 },
        { lat: 25.520117187500002, lng: -12.201123046874983 },
        { lat: 25.420507812500063, lng: -12.230957031249943 },
        { lat: 25.260302734375017, lng: -12.270947265625011 },
        { lat: 25.110937500000063, lng: -12.310986328124981 },
        { lat: 24.9703125, lng: -12.360839843750027 },
        { lat: 24.88046875, lng: -12.40087890625 },
        { lat: 24.830664062500063, lng: -12.431152343749941 },
        { lat: 24.770117187499977, lng: -12.500976562499972 },
        { lat: 24.731054687500002, lng: -12.561035156249943 },
        { lat: 24.680273437499977, lng: -12.630810546874955 },
        { lat: 24.63046875000003, lng: -12.710937500000028 },
        { lat: 24.570898437499977, lng: -12.820751953124924 },
        { lat: 24.520117187500034, lng: -12.911132812499941 },
        { lat: 24.497265624999983, lng: -12.947851562499977 },
        { lat: 24.4703125, lng: -12.99116210937501 },
        { lat: 24.400976562500006, lng: -13.061035156249943 },
        { lat: 24.300390625000034, lng: -13.12109375 },
        { lat: 24.22031250000006, lng: -13.1611328125 },
        { lat: 24.090429687499977, lng: -13.23095703125 },
        { lat: 24.020117187500034, lng: -13.280761718749943 },
        { lat: 23.981054687499977, lng: -13.310986328124955 },
        { lat: 23.941015625, lng: -13.391113281249941 },
        { lat: 23.910742187500063, lng: -13.480957031249941 },
        { lat: 23.870703124999977, lng: -13.5810546875 },
        { lat: 23.830664062500002, lng: -13.661083984374955 },
        { lat: 23.790625, lng: -13.770947265624955 },
        { lat: 23.750585937500034, lng: -13.840771484374983 },
        { lat: 23.691015625000063, lng: -13.891113281250028 },
        { lat: 23.620703125000034, lng: -13.93110351562501 },
        { lat: 23.520117187500063, lng: -13.980908203124924 },
        { lat: 23.410742187499977, lng: -14.020996093750028 },
        { lat: 23.340429687500034, lng: -14.040966796875011 },
        { lat: 23.100195312500034, lng: -14.10107421875 },
        { lat: 22.960546875, lng: -14.121093749999972 },
        { lat: 22.870703125, lng: -14.141064453124955 },
        { lat: 22.760351562499977, lng: -14.170898437499998 },
        { lat: 22.590429687500002, lng: -14.190869140624981 },
        { lat: 22.450781249999977, lng: -14.190869140624981 },
        { lat: 22.370703125, lng: -14.2109375 },
        { lat: 22.310156250000034, lng: -14.221191406249943 },
        { lat: 22.240820312500006, lng: -14.270996093749972 },
        { lat: 22.191015625, lng: -14.311035156249943 },
        { lat: 22.120703125000063, lng: -14.380810546874955 },
        { lat: 22.080664062499977, lng: -14.440917968749943 },
        { lat: 22.040625, lng: -14.460888671874924 },
        { lat: 21.99086914062499, lng: -14.520996093749998 },
        { lat: 21.910742187500006, lng: -14.581005859374981 },
        { lat: 21.860937499999974, lng: -14.630859375 },
        { lat: 21.820898437500006, lng: -14.62109375 },
        { lat: 21.750585937499977, lng: -14.610791015625011 },
        { lat: 21.680273437500034, lng: -14.641113281249972 },
        { lat: 21.600195312499974, lng: -14.670849609374981 },
        { lat: 21.500585937500034, lng: -14.750976562499972 },
        { lat: 21.45078125, lng: -14.840820312499972 },
        { lat: 21.441015625000063, lng: -14.971142578124955 },
        { lat: 21.441015625000063, lng: -15.15087890625 },
        { lat: 21.45078125, lng: -15.290966796874924 },
        { lat: 21.45078125, lng: -15.4609375 },
        { lat: 21.470312499999977, lng: -15.610791015624983 },
        { lat: 21.490820312499977, lng: -15.750927734374924 },
        { lat: 21.500585937500034, lng: -15.920849609375011 },
        { lat: 21.500585937500034, lng: -16.04101562499997 },
        { lat: 21.481054687500034, lng: -16.190869140624955 },
        { lat: 21.481054687500034, lng: -16.581005859374926 },
        { lat: 21.470312499999977, lng: -16.73095703125003 },
        { lat: 21.430273437500006, lng: -16.951123046874926 },
        { lat: 21.420751953125006, lng: -17.002978515625017 },
        { lat: 21.420703125000017, lng: -17.003076171874937 },
        { lat: 21.9, lng: -16.930859374999983 },
        { lat: 22.159716796875017, lng: -16.793261718750017 },
        { lat: 22.27436523437501, lng: -16.683984374999937 },
        { lat: 22.33349609374997, lng: -16.514404296874943 },
        { lat: 22.594531250000042, lng: -16.35874023437495 },
        { lat: 22.834814453125063, lng: -16.30429687499995 },
        { lat: 22.945361328125017, lng: -16.201855468749955 },
        { lat: 23.031933593749983, lng: -16.16972656249999 },
        { lat: 23.097900390625, lng: -16.21025390624999 },
        { lat: 23.227539062500057, lng: -16.113671874999937 },
        { lat: 23.425488281249955, lng: -15.996728515624993 },
        { lat: 23.552636718750023, lng: -15.942626953125 },
        { lat: 23.74951171874997, lng: -15.805957031249958 },
        { lat: 23.79287109375002, lng: -15.789257812499926 },
        { lat: 23.842236328124955, lng: -15.801660156249966 },
        { lat: 23.800341796875045, lng: -15.855175781249955 },
        { lat: 23.727587890625045, lng: -15.912548828124983 },
        { lat: 23.670312500000023, lng: -15.980712890624943 },
        { lat: 23.740820312499974, lng: -15.952832031249953 },
        { lat: 23.844433593749955, lng: -15.899316406249964 },
        { lat: 23.952929687500045, lng: -15.777783203124983 },
        { lat: 24.07275390625003, lng: -15.586328124999966 },
        { lat: 24.478808593750045, lng: -15.188623046874937 },
        { lat: 24.54882812500003, lng: -15.038867187499987 },
        { lat: 24.719775390625017, lng: -14.90429687500003 },
        { lat: 24.871582031250053, lng: -14.856054687499977 },
        { lat: 25.220117187499994, lng: -14.842919921874966 },
        { lat: 25.404150390625006, lng: -14.794921874999943 },
        { lat: 25.547705078125034, lng: -14.70703125 },
        { lat: 25.80854492187498, lng: -14.602294921874972 },
        { lat: 25.92524414062504, lng: -14.522753906250017 },
        { lat: 26.163037109374983, lng: -14.470556640624949 },
        { lat: 26.25371093749999, lng: -14.41386718749993 },
        { lat: 26.296728515625034, lng: -14.312451171874983 },
        { lat: 26.415429687499966, lng: -14.168359375000023 },
        { lat: 26.48876953125, lng: -13.952099609374924 },
        { lat: 26.642919921875063, lng: -13.695898437499949 },
        { lat: 26.735107421875, lng: -13.57578125 },
        { lat: 26.872656250000034, lng: -13.495751953124937 },
        { lat: 27.14663085937499, lng: -13.409814453124937 },
        { lat: 27.43461914062496, lng: -13.256152343749987 },
        { lat: 27.65185546874997, lng: -13.177392578125023 },
        { lat: 27.655712890624983, lng: -13.175976562499981 },
        { lat: 27.769824218750045, lng: -13.040722656249983 },
        { lat: 27.914160156250034, lng: -12.948925781249926 },
        { lat: 27.978417968749994, lng: -12.793652343749983 },
        { lat: 28.009423828124994, lng: -12.468896484374993 },
        { lat: 28.12929687499999, lng: -11.986083984374972 },
        { lat: 28.31010742187496, lng: -11.552685546874955 },
        { lat: 28.38203124999998, lng: -11.430175781249943 },
        { lat: 28.52607421875001, lng: -11.299072265624972 },
        { lat: 28.713769531249962, lng: -11.080957031249937 },
        { lat: 28.93920898437497, lng: -10.673828124999972 },
        { lat: 29.064941406249996, lng: -10.486474609374994 },
        { lat: 29.380371093750057, lng: -10.200585937499994 },
        { lat: 29.641406250000045, lng: -10.010498046875 },
        { lat: 29.80922851562502, lng: -9.852636718750006 },
        { lat: 29.958203125, lng: -9.74345703124996 },
        { lat: 30.10927734375005, lng: -9.667089843749949 },
        { lat: 30.352636718749974, lng: -9.623828124999932 },
        { lat: 30.447558593750045, lng: -9.652929687499977 },
        { lat: 30.603125, lng: -9.773144531249955 },
        { lat: 30.644580078125045, lng: -9.85390625 },
        { lat: 30.717919921874962, lng: -9.875488281249943 },
        { lat: 30.84726562500003, lng: -9.832421874999966 },
        { lat: 31.069628906250042, lng: -9.833349609374977 },
        { lat: 31.424609374999957, lng: -9.80869140624992 },
        { lat: 31.710986328125045, lng: -9.674951171874937 },
        { lat: 32.086376953124955, lng: -9.347460937499932 },
        { lat: 32.240576171875034, lng: -9.286572265624955 },
        { lat: 32.48583984374997, lng: -9.249121093749977 },
        { lat: 32.57246093749995, lng: -9.245849609375 },
        { lat: 32.92045898437499, lng: -8.83623046874996 },
        { lat: 33.187158203125044, lng: -8.59628906249992 },
        { lat: 33.25244140625003, lng: -8.512841796874993 },
        { lat: 33.37436523437498, lng: -8.301171874999937 },
        { lat: 33.64028320312499, lng: -7.562353515624977 },
        { lat: 33.83032226562497, lng: -7.144677734374966 },
        { lat: 33.96904296874999, lng: -6.900976562499949 },
        { lat: 34.13291015624998, lng: -6.755761718749966 },
        { lat: 34.77607421875001, lng: -6.353125 },
        { lat: 35.68115234375, lng: -5.95756835937496 },
        { lat: 35.78579101562502, lng: -5.924804687499943 },
        { lat: 35.81596679687502, lng: -5.747949218749994 },
        { lat: 35.82890624999999, lng: -5.622851562499989 },
        { lat: 35.86201171874998, lng: -5.522265624999932 },
        { lat: 35.929882812499955, lng: -5.397363281249966 },
        { lat: 35.90273437500002, lng: -5.277832031249943 },
        { lat: 35.856542968750034, lng: -5.337646484374972 },
        { lat: 35.74521484375, lng: -5.337646484374972 },
        { lat: 35.61474609374997, lng: -5.252685546874971 },
        { lat: 35.46777343749997, lng: -5.105371093749994 },
        { lat: 35.28129882812499, lng: -4.837207031249989 },
        { lat: 35.206396484375006, lng: -4.628320312499966 },
      ],
    ],
  },
  {
    code: "EH",
    coordinates: [
      [
        { lat: 27.2859375, lng: -8.683349609375 },
        { lat: 27.119287109374994, lng: -8.68310546875 },
        { lat: 26.921337890624994, lng: -8.682861328125 },
        { lat: 26.723144531249996, lng: -8.682617187499998 },
        { lat: 26.497705078124994, lng: -8.682324218749983 },
        { lat: 26.273193359375, lng: -8.68212890625 },
        { lat: 26.10947265625, lng: -8.68212890625 },
        { lat: 25.995507812499994, lng: -8.682226562499977 },
        { lat: 25.995507812499994, lng: -8.885644531249994 },
        { lat: 25.995507812499994, lng: -9.071923828124994 },
        { lat: 25.995507812499994, lng: -9.25820312499999 },
        { lat: 25.995507812499994, lng: -9.444531249999981 },
        { lat: 25.995507812499994, lng: -9.630859375 },
        { lat: 25.99545898437499, lng: -9.817187499999989 },
        { lat: 25.99545898437499, lng: -10.003515624999977 },
        { lat: 25.99545898437499, lng: -10.189794921874977 },
        { lat: 25.99545898437499, lng: -10.376123046874994 },
        { lat: 25.99545898437499, lng: -10.562451171874983 },
        { lat: 25.99545898437499, lng: -10.748779296875 },
        { lat: 25.99545898437499, lng: -10.935107421874989 },
        { lat: 25.99545898437499, lng: -11.121386718749989 },
        { lat: 25.99541015625, lng: -11.307714843749977 },
        { lat: 25.99541015625, lng: -11.494042968749994 },
        { lat: 25.99541015625, lng: -11.680371093749983 },
        { lat: 25.99541015625, lng: -11.866650390624983 },
        { lat: 25.99541015625, lng: -12.016308593749983 },
        { lat: 25.87631835937499, lng: -12.016308593749983 },
        { lat: 25.740136718749994, lng: -12.016308593749983 },
        { lat: 25.60400390625, lng: -12.016308593749983 },
        { lat: 25.46787109374999, lng: -12.016308593749983 },
        { lat: 25.331689453124994, lng: -12.016308593749983 },
        { lat: 25.195556640625, lng: -12.016308593749983 },
        { lat: 25.059375, lng: -12.016308593749983 },
        { lat: 24.923242187499994, lng: -12.016308593749983 },
        { lat: 24.787109375, lng: -12.016308593749983 },
        { lat: 24.65097656249999, lng: -12.016308593749983 },
        { lat: 24.514794921874994, lng: -12.016308593749983 },
        { lat: 24.378662109375, lng: -12.016308593749983 },
        { lat: 24.242480468750003, lng: -12.016308593749983 },
        { lat: 24.106347656249994, lng: -12.016308593749983 },
        { lat: 23.97021484375, lng: -12.016308593749983 },
        { lat: 23.834033203125003, lng: -12.016308593749983 },
        { lat: 23.697900390624994, lng: -12.016308593749983 },
        { lat: 23.576464843750003, lng: -12.016308593749983 },
        { lat: 23.467578125, lng: -12.0234375 },
        { lat: 23.43544921874999, lng: -12.083349609374977 },
        { lat: 23.377490234375003, lng: -12.226171874999977 },
        { lat: 23.318017578124994, lng: -12.372900390624977 },
        { lat: 23.290820312500003, lng: -12.559375 },
        { lat: 23.27133789062499, lng: -12.620410156249989 },
        { lat: 23.19272460937499, lng: -12.739599609374977 },
        { lat: 23.089550781249997, lng: -12.89599609375 },
        { lat: 23.000244140625, lng: -13.031494140625 },
        { lat: 22.88408203125, lng: -13.120898437499989 },
        { lat: 22.820507812499997, lng: -13.153271484374983 },
        { lat: 22.753222656250003, lng: -13.16650390625 },
        { lat: 22.68930664062499, lng: -13.155957031249983 },
        { lat: 22.560742187499997, lng: -13.107324218749993 },
        { lat: 22.495996093749994, lng: -13.094335937499977 },
        { lat: 22.383251953124997, lng: -13.086767578124977 },
        { lat: 22.260449218749997, lng: -13.078466796874977 },
        { lat: 22.128173828125, lng: -13.069580078124998 },
        { lat: 21.995751953124994, lng: -13.060644531249977 },
        { lat: 21.854785156250003, lng: -13.051220703124983 },
        { lat: 21.713818359374997, lng: -13.041748046875 },
        { lat: 21.572070312500003, lng: -13.032226562499998 },
        { lat: 21.466796875, lng: -13.025097656249983 },
        { lat: 21.333935546874994, lng: -13.016210937499977 },
        { lat: 21.333789062500003, lng: -13.167431640624981 },
        { lat: 21.333544921875003, lng: -13.396728515625 },
        { lat: 21.333251953124996, lng: -13.626025390624987 },
        { lat: 21.332958984374997, lng: -13.855371093749994 },
        { lat: 21.332714843749994, lng: -14.084667968749983 },
        { lat: 21.33242187499999, lng: -14.31396484375 },
        { lat: 21.33212890624999, lng: -14.543261718749989 },
        { lat: 21.33188476562499, lng: -14.772607421874994 },
        { lat: 21.331591796875003, lng: -15.001904296874983 },
        { lat: 21.331298828125, lng: -15.231201171875 },
        { lat: 21.3310546875, lng: -15.460546874999975 },
        { lat: 21.330761718749997, lng: -15.689794921874977 },
        { lat: 21.33046875, lng: -15.919140624999981 },
        { lat: 21.33022460937499, lng: -16.1484375 },
        { lat: 21.32993164062499, lng: -16.377734374999985 },
        { lat: 21.329638671875003, lng: -16.607031249999977 },
        { lat: 21.32939453125, lng: -16.83632812499999 },
        { lat: 21.329248046874994, lng: -16.964550781249983 },
        { lat: 21.14243164062499, lng: -17.00590820312499 },
        { lat: 21.008007812499997, lng: -17.042382812499994 },
        { lat: 20.89882812499999, lng: -17.06396484375 },
        { lat: 20.806152343749996, lng: -17.048046874999983 },
        { lat: 20.856884765624994, lng: -17.098779296874994 },
        { lat: 21.37709960937499, lng: -17.009619140624977 },
        { lat: 21.420703125, lng: -17.003076171874994 },
        { lat: 21.420751953124988, lng: -17.00297851562499 },
        { lat: 21.430273437499988, lng: -16.951123046874983 },
        { lat: 21.4703125, lng: -16.73095703125 },
        { lat: 21.48105468749999, lng: -16.58100585937498 },
        { lat: 21.48105468749999, lng: -16.190869140624983 },
        { lat: 21.50058593749999, lng: -16.041015625 },
        { lat: 21.50058593749999, lng: -15.920849609374983 },
        { lat: 21.49082031249999, lng: -15.750927734374981 },
        { lat: 21.4703125, lng: -15.610791015624983 },
        { lat: 21.45078125, lng: -15.4609375 },
        { lat: 21.45078125, lng: -15.290966796874981 },
        { lat: 21.441015624999988, lng: -15.15087890625 },
        { lat: 21.441015624999988, lng: -14.971142578124983 },
        { lat: 21.45078125, lng: -14.8408203125 },
        { lat: 21.50058593749999, lng: -14.7509765625 },
        { lat: 21.60019531249999, lng: -14.670849609374981 },
        { lat: 21.680273437499988, lng: -14.641113281250002 },
        { lat: 21.75058593749999, lng: -14.610791015624983 },
        { lat: 21.82089843749999, lng: -14.62109375 },
        { lat: 21.8609375, lng: -14.630859375 },
        { lat: 21.91074218749999, lng: -14.581005859374981 },
        { lat: 21.99086914062499, lng: -14.520996093749998 },
        { lat: 22.040625, lng: -14.460888671874983 },
        { lat: 22.08066406249999, lng: -14.44091796875 },
        { lat: 22.12070312499999, lng: -14.380810546874985 },
        { lat: 22.19101562499999, lng: -14.311035156249998 },
        { lat: 22.240820312499988, lng: -14.27099609375 },
        { lat: 22.31015625, lng: -14.221191406249998 },
        { lat: 22.37070312499999, lng: -14.2109375 },
        { lat: 22.45078125, lng: -14.190869140624981 },
        { lat: 22.59042968749999, lng: -14.190869140624981 },
        { lat: 22.760351562499988, lng: -14.170898437499998 },
        { lat: 22.87070312499999, lng: -14.141064453124983 },
        { lat: 22.96054687499999, lng: -14.12109375 },
        { lat: 23.100195312499988, lng: -14.10107421875 },
        { lat: 23.34042968749999, lng: -14.040966796874981 },
        { lat: 23.41074218749999, lng: -14.02099609375 },
        { lat: 23.52011718749999, lng: -13.980908203124983 },
        { lat: 23.62070312499999, lng: -13.931103515624983 },
        { lat: 23.69101562499999, lng: -13.89111328125 },
        { lat: 23.750585937499988, lng: -13.840771484374983 },
        { lat: 23.790625, lng: -13.770947265624983 },
        { lat: 23.83066406249999, lng: -13.661083984374983 },
        { lat: 23.87070312499999, lng: -13.5810546875 },
        { lat: 23.910742187499988, lng: -13.48095703125 },
        { lat: 23.94101562499999, lng: -13.39111328125 },
        { lat: 23.98105468749999, lng: -13.310986328124983 },
        { lat: 24.02011718749999, lng: -13.28076171875 },
        { lat: 24.090429687499988, lng: -13.23095703125 },
        { lat: 24.2203125, lng: -13.1611328125 },
        { lat: 24.30039062499999, lng: -13.12109375 },
        { lat: 24.40097656249999, lng: -13.061035156249998 },
        { lat: 24.4703125, lng: -12.991162109374981 },
        { lat: 24.497265625, lng: -12.947851562499977 },
        { lat: 24.520117187499988, lng: -12.9111328125 },
        { lat: 24.57089843749999, lng: -12.820751953124983 },
        { lat: 24.63046875, lng: -12.7109375 },
        { lat: 24.68027343749999, lng: -12.630810546874981 },
        { lat: 24.73105468749999, lng: -12.56103515625 },
        { lat: 24.77011718749999, lng: -12.5009765625 },
        { lat: 24.83066406249999, lng: -12.43115234375 },
        { lat: 24.88046875, lng: -12.40087890625 },
        { lat: 24.9703125, lng: -12.360839843749998 },
        { lat: 25.1109375, lng: -12.310986328124981 },
        { lat: 25.260302734375003, lng: -12.270947265624983 },
        { lat: 25.420507812499988, lng: -12.23095703125 },
        { lat: 25.52011718749999, lng: -12.201123046874983 },
        { lat: 25.64023437499999, lng: -12.170849609374983 },
        { lat: 25.73105468749999, lng: -12.130859375 },
        { lat: 25.83066406249999, lng: -12.101025390624983 },
        { lat: 25.87070312499999, lng: -12.0810546875 },
        { lat: 25.92050781249999, lng: -12.0810546875 },
        { lat: 25.99082031249999, lng: -12.060986328124983 },
        { lat: 25.996337890625, lng: -12.056787109374994 },
        { lat: 26.030859375, lng: -12.03076171875 },
        { lat: 26.050390625, lng: -11.960888671874983 },
        { lat: 26.0708984375, lng: -11.880859375 },
        { lat: 26.0865234375, lng: -11.7548828125 },
        { lat: 26.1041015625, lng: -11.718212890624983 },
        { lat: 26.1626953125, lng: -11.69921875 },
        { lat: 26.213476562499995, lng: -11.684521484374981 },
        { lat: 26.2955078125, lng: -11.63720703125 },
        { lat: 26.3609375, lng: -11.583984375 },
        { lat: 26.4009765625, lng: -11.553173828124983 },
        { lat: 26.4703125, lng: -11.511669921874983 },
        { lat: 26.5201171875, lng: -11.470703125 },
        { lat: 26.58359375, lng: -11.39990234375 },
        { lat: 26.6333984375, lng: -11.337890625 },
        { lat: 26.6841796875, lng: -11.316845703124983 },
        { lat: 26.7447265625, lng: -11.316845703124983 },
        { lat: 26.7935546875, lng: -11.361279296874983 },
        { lat: 26.8833984375, lng: -11.392578125 },
        { lat: 26.910742187499995, lng: -11.263623046874983 },
        { lat: 26.941015625, lng: -11.150341796874983 },
        { lat: 26.9703125, lng: -11.046826171874983 },
        { lat: 27.0103515625, lng: -10.922802734374983 },
        { lat: 27.0103515625, lng: -10.830078125 },
        { lat: 27.0201171875, lng: -10.757763671874983 },
        { lat: 27.0005859375, lng: -10.654248046874983 },
        { lat: 26.9908203125, lng: -10.55126953125 },
        { lat: 26.960546875, lng: -10.478955078124983 },
        { lat: 26.9009765625, lng: -10.354931640624983 },
        { lat: 26.8609375, lng: -10.25146484375 },
        { lat: 26.8609375, lng: -10.189453125 },
        { lat: 26.88046875, lng: -10.123046875 },
        { lat: 26.9087890625, lng: -10.066845703124981 },
        { lat: 26.910742187499995, lng: -10.03271484375 },
        { lat: 26.890234375, lng: -9.980908203124983 },
        { lat: 26.8501953125, lng: -9.900341796874983 },
        { lat: 26.8501953125, lng: -9.81787109375 },
        { lat: 26.8609375, lng: -9.7353515625 },
        { lat: 26.910742187499995, lng: -9.67333984375 },
        { lat: 26.9908203125, lng: -9.56982421875 },
        { lat: 27.050390625, lng: -9.4873046875 },
        { lat: 27.0884765625, lng: -9.413037109374983 },
        { lat: 27.0982421875, lng: -9.352978515624983 },
        { lat: 27.0982421875, lng: -9.285595703124983 },
        { lat: 27.1001953125, lng: -9.208447265624983 },
        { lat: 27.0904296875, lng: -9.084423828124983 },
        { lat: 27.0904296875, lng: -9.001904296874983 },
        { lat: 27.1041015625, lng: -8.8890625 },
        { lat: 27.120703125, lng: -8.794873046874983 },
        { lat: 27.1509765625, lng: -8.753857421874983 },
        { lat: 27.191015625, lng: -8.753857421874983 },
        { lat: 27.250585937499995, lng: -8.774365234374983 },
        { lat: 27.308203125, lng: -8.796826171874983 },
        { lat: 27.3609375, lng: -8.802685546874983 },
        { lat: 27.416552734374996, lng: -8.788964843749994 },
        { lat: 27.460546875, lng: -8.774365234374983 },
        { lat: 27.530859375, lng: -8.784570312499994 },
        { lat: 27.613867187499995, lng: -8.813916015624983 },
        { lat: 27.655908203124994, lng: -8.817773437499994 },
        { lat: 27.656445312499997, lng: -8.817822265624983 },
        { lat: 27.656445312499997, lng: -8.683349609375 },
        { lat: 27.490234375, lng: -8.683349609375 },
        { lat: 27.2859375, lng: -8.683349609375 },
      ],
    ],
  },
  {
    code: "TN",
    coordinates: [
      [
        { lat: 33.72207031250005, lng: 10.957617187500063 },
        { lat: 33.717431640624994, lng: 10.93134765625004 },
        { lat: 33.69018554687502, lng: 10.883007812500066 },
        { lat: 33.68715820312502, lng: 10.857421875 },
        { lat: 33.71767578125002, lng: 10.784765625000032 },
        { lat: 33.71748046874998, lng: 10.757031250000068 },
        { lat: 33.738916015624994, lng: 10.72207031250005 },
        { lat: 33.855615234374966, lng: 10.733886718750057 },
        { lat: 33.88867187500006, lng: 10.74521484375006 },
        { lat: 33.89311523437499, lng: 10.921972656250006 },
        { lat: 33.82333984374998, lng: 11.017871093749989 },
        { lat: 33.80502929687498, lng: 11.03359375 },
        { lat: 33.785058593749994, lng: 11.037597656250028 },
        { lat: 33.745947265625006, lng: 10.993066406249994 },
        { lat: 33.72207031250005, lng: 10.957617187500063 },
      ],
      [
        { lat: 34.753808593749994, lng: 11.278027343750068 },
        { lat: 34.68168945312496, lng: 11.123632812500063 },
        { lat: 34.74458007812498, lng: 11.153027343750011 },
        { lat: 34.82031250000006, lng: 11.254882812500057 },
        { lat: 34.80219726562501, lng: 11.281054687500045 },
        { lat: 34.753808593749994, lng: 11.278027343750068 },
      ],
      [
        { lat: 37.21142578125002, lng: 9.783984375000074 },
        { lat: 37.13535156250006, lng: 9.830273437499983 },
        { lat: 37.181640625, lng: 9.896386718750051 },
        { lat: 37.21284179687504, lng: 9.879394531250055 },
        { lat: 37.25415039062503, lng: 9.875585937499975 },
        { lat: 37.257763671874955, lng: 9.988085937500074 },
        { lat: 37.25126953124996, lng: 10.087402343750057 },
        { lat: 37.205859375000045, lng: 10.196386718750063 },
        { lat: 37.03388671874998, lng: 10.188769531250017 },
        { lat: 36.86538085937505, lng: 10.334082031250034 },
        { lat: 36.781494140625, lng: 10.293261718750074 },
        { lat: 36.73183593750002, lng: 10.412304687499983 },
        { lat: 36.79135742187506, lng: 10.518164062500063 },
        { lat: 36.87944335937496, lng: 10.571289062500057 },
        { lat: 36.930273437500034, lng: 10.766210937500063 },
        { lat: 37.05927734375001, lng: 10.951367187500038 },
        { lat: 37.07250976562506, lng: 11.053906250000068 },
        { lat: 36.96669921874999, lng: 11.07705078125005 },
        { lat: 36.874072265625045, lng: 11.126660156250038 },
        { lat: 36.84145507812505, lng: 11.056542968750051 },
        { lat: 36.74301757812498, lng: 10.967187500000051 },
        { lat: 36.493115234374955, lng: 10.798144531249989 },
        { lat: 36.419628906250004, lng: 10.642382812500074 },
        { lat: 36.323339843750006, lng: 10.525683593749989 },
        { lat: 36.2548828125, lng: 10.48798828125004 },
        { lat: 36.175146484375006, lng: 10.476562500000028 },
        { lat: 36.03242187499998, lng: 10.505761718750023 },
        { lat: 35.88725585937499, lng: 10.590820312500028 },
        { lat: 35.799511718749955, lng: 10.688964843750057 },
        { lat: 35.77207031250006, lng: 10.783691406249972 },
        { lat: 35.63383789062496, lng: 11.00429687500008 },
        { lat: 35.551611328125006, lng: 11.00068359375004 },
        { lat: 35.45385742187497, lng: 11.031542968750017 },
        { lat: 35.33510742187502, lng: 11.043261718750017 },
        { lat: 35.24028320312499, lng: 11.120117187500057 },
        { lat: 35.03364257812498, lng: 10.955859375000074 },
        { lat: 34.88432617187504, lng: 10.8662109375 },
        { lat: 34.67846679687502, lng: 10.69091796875 },
        { lat: 34.544726562500045, lng: 10.534863281250011 },
        { lat: 34.34604492187506, lng: 10.200390625000068 },
        { lat: 34.28007812500004, lng: 10.118359375000068 },
        { lat: 34.21162109375004, lng: 10.06484375000008 },
        { lat: 34.14033203124998, lng: 10.0400390625 },
        { lat: 34.056298828124994, lng: 10.049023437500066 },
        { lat: 33.850048828125004, lng: 10.158984375000072 },
        { lat: 33.72827148437497, lng: 10.305273437500034 },
        { lat: 33.6625, lng: 10.454296875000011 },
        { lat: 33.68901367187496, lng: 10.713183593750017 },
        { lat: 33.60966796874996, lng: 10.704296875000068 },
        { lat: 33.514404296875, lng: 10.722753906250006 },
        { lat: 33.518896484375034, lng: 10.828125 },
        { lat: 33.53369140625003, lng: 10.8984375 },
        { lat: 33.62631835937498, lng: 10.958007812500057 },
        { lat: 33.56289062500002, lng: 11.084570312500006 },
        { lat: 33.369238281250006, lng: 11.150292968750051 },
        { lat: 33.30883789062506, lng: 11.257421875000034 },
        { lat: 33.28632812499998, lng: 11.269921875000023 },
        { lat: 33.271582031250006, lng: 11.23212890625004 },
        { lat: 33.24921874999998, lng: 11.20263671874997 },
        { lat: 33.23359375000001, lng: 11.234277343750023 },
        { lat: 33.20947265624997, lng: 11.33808593750004 },
        { lat: 33.22490234375002, lng: 11.400585937500066 },
        { lat: 33.181933593750045, lng: 11.50458984375004 },
        { lat: 33.15556640624999, lng: 11.502441406250028 },
        { lat: 32.96572265625005, lng: 11.467187500000051 },
        { lat: 32.897363281249966, lng: 11.459179687500011 },
        { lat: 32.78168945312504, lng: 11.453906250000017 },
        { lat: 32.64257812500003, lng: 11.453906250000017 },
        { lat: 32.52495117187495, lng: 11.533789062500034 },
        { lat: 32.47333984375001, lng: 11.535937500000017 },
        { lat: 32.41367187500003, lng: 11.504980468750034 },
        { lat: 32.34521484375003, lng: 11.358007812500006 },
        { lat: 32.25673828125002, lng: 11.168261718750072 },
        { lat: 32.17270507812506, lng: 11.005175781250074 },
        { lat: 32.080664062500034, lng: 10.826367187500066 },
        { lat: 32.02119140625001, lng: 10.771582031250006 },
        { lat: 31.97539062499999, lng: 10.68300781250008 },
        { lat: 31.929541015624977, lng: 10.60888671875 },
        { lat: 31.88574218750003, lng: 10.595507812500017 },
        { lat: 31.802539062500042, lng: 10.543652343750011 },
        { lat: 31.736035156249983, lng: 10.47578125000004 },
        { lat: 31.704833984375025, lng: 10.306054687500021 },
        { lat: 31.684960937499994, lng: 10.274609375000011 },
        { lat: 31.585107421874966, lng: 10.195996093750068 },
        { lat: 31.54580078124997, lng: 10.159863281249981 },
        { lat: 31.46376953125005, lng: 10.114941406250068 },
        { lat: 31.250976562500025, lng: 10.172656250000017 },
        { lat: 31.03212890625002, lng: 10.24335937500004 },
        { lat: 30.940820312499994, lng: 10.257031250000068 },
        { lat: 30.86494140624998, lng: 10.25605468750004 },
        { lat: 30.78320312500003, lng: 10.216406250000063 },
        { lat: 30.66596679687495, lng: 10.125976562500028 },
        { lat: 30.580078125000025, lng: 10.05976562500004 },
        { lat: 30.425341796874964, lng: 9.932519531250051 },
        { lat: 30.387304687500034, lng: 9.895019531250028 },
        { lat: 30.342236328124983, lng: 9.807421875000045 },
        { lat: 30.282324218750034, lng: 9.637988281250074 },
        { lat: 30.22939453124999, lng: 9.51875 },
        { lat: 30.465380859375042, lng: 9.4580078125 },
        { lat: 30.666796875000045, lng: 9.406054687500074 },
        { lat: 30.832910156250023, lng: 9.363281250000057 },
        { lat: 31.12534179687501, lng: 9.287890625000074 },
        { lat: 31.373681640624998, lng: 9.224023437500021 },
        { lat: 31.621337890625, lng: 9.160253906250006 },
        { lat: 31.846142578124955, lng: 9.102343750000015 },
        { lat: 32.072363281250034, lng: 9.044042968750032 },
        { lat: 32.10537109375002, lng: 9.018945312500078 },
        { lat: 32.21210937499998, lng: 8.844042968750074 },
        { lat: 32.31044921875005, lng: 8.682910156250017 },
        { lat: 32.42231445312501, lng: 8.515136718750028 },
        { lat: 32.54360351562502, lng: 8.333398437500051 },
        { lat: 32.69628906250006, lng: 8.304199218750028 },
        { lat: 32.92670898437501, lng: 8.210937500000057 },
        { lat: 33.055322265624994, lng: 8.1125 },
        { lat: 33.089062499999955, lng: 8.075585937499994 },
        { lat: 33.172119140625, lng: 7.877246093750017 },
        { lat: 33.23310546874998, lng: 7.762695312500028 },
        { lat: 33.26850585937501, lng: 7.73134765625005 },
        { lat: 33.36230468750003, lng: 7.709179687500068 },
        { lat: 33.54863281249996, lng: 7.627539062500034 },
        { lat: 33.717919921874994, lng: 7.534375 },
        { lat: 33.83247070312498, lng: 7.500195312500011 },
        { lat: 33.976513671875004, lng: 7.495605468750057 },
        { lat: 34.080517578124955, lng: 7.513867187500067 },
        { lat: 34.125, lng: 7.554492187500074 },
        { lat: 34.25449218750006, lng: 7.74853515625 },
        { lat: 34.410302734374994, lng: 7.838281250000079 },
        { lat: 34.46870117187501, lng: 7.949414062500068 },
        { lat: 34.51269531249999, lng: 8.04560546875004 },
        { lat: 34.56391601562504, lng: 8.12343750000008 },
        { lat: 34.646289062500045, lng: 8.19277343750008 },
        { lat: 34.73408203124998, lng: 8.24560546875 },
        { lat: 34.82895507812503, lng: 8.254687500000072 },
        { lat: 34.97949218749997, lng: 8.276855468750057 },
        { lat: 35.084619140624994, lng: 8.312109375000063 },
        { lat: 35.20385742187503, lng: 8.394238281250011 },
        { lat: 35.29960937499999, lng: 8.35986328125 },
        { lat: 35.403125, lng: 8.316406250000028 },
        { lat: 35.58222656250001, lng: 8.329003906250021 },
        { lat: 35.654931640624994, lng: 8.318066406250011 },
        { lat: 35.71928710937496, lng: 8.282910156250068 },
        { lat: 35.80180664062499, lng: 8.247070312500028 },
        { lat: 35.870556640624955, lng: 8.245703125000034 },
        { lat: 36.05097656250004, lng: 8.280273437500057 },
        { lat: 36.188769531250045, lng: 8.306738281250034 },
        { lat: 36.367968750000045, lng: 8.348730468750063 },
        { lat: 36.418164062499955, lng: 8.33398437499997 },
        { lat: 36.45561523437495, lng: 8.302734375 },
        { lat: 36.4951171875, lng: 8.208789062500045 },
        { lat: 36.518945312499994, lng: 8.207617187500006 },
        { lat: 36.545263671875006, lng: 8.230761718749987 },
        { lat: 36.63251953125004, lng: 8.369628906250055 },
        { lat: 36.76074218750003, lng: 8.444238281250051 },
        { lat: 36.7875, lng: 8.506738281249994 },
        { lat: 36.83393554687504, lng: 8.601269531250066 },
        { lat: 36.88388671874998, lng: 8.597656250000057 },
        { lat: 36.937207031250004, lng: 8.576562500000023 },
        { lat: 36.99760742187499, lng: 8.823535156250072 },
        { lat: 37.15585937499998, lng: 9.058886718750045 },
        { lat: 37.19462890624996, lng: 9.141992187500023 },
        { lat: 37.34038085937499, lng: 9.687988281250055 },
        { lat: 37.330273437499976, lng: 9.758886718750006 },
        { lat: 37.30898437499999, lng: 9.838476562500063 },
        { lat: 37.25463867187503, lng: 9.815527343750006 },
        { lat: 37.21142578125002, lng: 9.783984375000074 },
      ],
    ],
  },
  {
    code: "IL",
    coordinates: [
      [
        { lat: 32.734912109374996, lng: 35.78730468750001 },
        { lat: 32.72890625, lng: 35.734472656250006 },
        { lat: 32.682080078125, lng: 35.61123046875002 },
        { lat: 32.668017578124996, lng: 35.59453125000002 },
        { lat: 32.640869140625, lng: 35.572851562500006 },
        { lat: 32.619873046875, lng: 35.56904296875001 },
        { lat: 32.39550781249999, lng: 35.551464843750004 },
        { lat: 32.401660156249996, lng: 35.484375 },
        { lat: 32.450634765625, lng: 35.40263671875002 },
        { lat: 32.493017578125, lng: 35.38671875 },
        { lat: 32.507470703124994, lng: 35.36210937500002 },
        { lat: 32.512939453125, lng: 35.303808593750006 },
        { lat: 32.534423828125, lng: 35.19326171875002 },
        { lat: 32.46044921875, lng: 35.065039062500006 },
        { lat: 32.338183593749996, lng: 35.01054687500002 },
        { lat: 32.281054687499996, lng: 34.99951171875 },
        { lat: 32.1609375, lng: 34.95595703125002 },
        { lat: 32.087109375, lng: 34.97138671875001 },
        { lat: 31.991601562499994, lng: 34.97880859375002 },
        { lat: 31.91328125, lng: 34.98974609375 },
        { lat: 31.86640625, lng: 34.97832031250002 },
        { lat: 31.841259765624994, lng: 34.95380859375001 },
        { lat: 31.823339843749995, lng: 34.96113281250001 },
        { lat: 31.81679687499999, lng: 34.983007812500006 },
        { lat: 31.837939453124996, lng: 35.05322265625 },
        { lat: 31.816748046875, lng: 35.12714843750001 },
        { lat: 31.776318359374997, lng: 35.19804687500002 },
        { lat: 31.75, lng: 35.203710937500006 },
        { lat: 31.73447265625, lng: 35.153417968750006 },
        { lat: 31.67324218749999, lng: 35.03466796875 },
        { lat: 31.602294921875, lng: 34.95097656250002 },
        { lat: 31.536572265624994, lng: 34.92919921875 },
        { lat: 31.396875, lng: 34.87275390625001 },
        { lat: 31.368164062499996, lng: 34.88046875 },
        { lat: 31.351318359375, lng: 34.9078125 },
        { lat: 31.3662109375, lng: 35.101171875 },
        { lat: 31.422802734374994, lng: 35.27666015625002 },
        { lat: 31.48291015625, lng: 35.40869140624999 },
        { lat: 31.479296875, lng: 35.45058593750002 },
        { lat: 31.325390625, lng: 35.4228515625 },
        { lat: 31.324853515624994, lng: 35.42353515625001 },
        { lat: 31.230517578124996, lng: 35.40068359375002 },
        { lat: 31.214453125, lng: 35.40966796875 },
        { lat: 31.132421875, lng: 35.43925781250002 },
        { lat: 30.982275390624995, lng: 35.38300781250001 },
        { lat: 30.860205078125, lng: 35.32011718750002 },
        { lat: 30.802246093749996, lng: 35.2978515625 },
        { lat: 30.673486328124994, lng: 35.23662109375002 },
        { lat: 30.523925781249996, lng: 35.17402343750001 },
        { lat: 30.4208984375, lng: 35.140625 },
        { lat: 30.384326171875, lng: 35.14814453125001 },
        { lat: 30.1953125, lng: 35.13261718750002 },
        { lat: 30.141699218749995, lng: 35.1416015625 },
        { lat: 29.977880859375, lng: 35.06816406250002 },
        { lat: 29.896923828124997, lng: 35.05341796875001 },
        { lat: 29.787060546874997, lng: 35.02392578125 },
        { lat: 29.555029296874995, lng: 34.97343750000002 },
        { lat: 29.47734375, lng: 34.904296875 },
        { lat: 29.563916015624997, lng: 34.86982421875001 },
        { lat: 29.812109375, lng: 34.79111328125 },
        { lat: 29.98203125, lng: 34.73505859375001 },
        { lat: 30.191455078124996, lng: 34.65859375000002 },
        { lat: 30.446044921874996, lng: 34.52968750000002 },
        { lat: 30.507373046874992, lng: 34.51777343750001 },
        { lat: 30.5962890625, lng: 34.48994140625001 },
        { lat: 30.827832031249997, lng: 34.400976562500006 },
        { lat: 30.99501953124999, lng: 34.32851562500002 },
        { lat: 31.208300781249996, lng: 34.24531250000001 },
        { lat: 31.292919921874997, lng: 34.34833984375001 },
        { lat: 31.362744140624997, lng: 34.350195312500006 },
        { lat: 31.525634765624996, lng: 34.52558593750001 },
        { lat: 31.541650390624994, lng: 34.52412109375001 },
        { lat: 31.58486328124999, lng: 34.47734375000002 },
        { lat: 31.592285156249996, lng: 34.483984375 },
        { lat: 31.895703125, lng: 34.67841796875001 },
        { lat: 32.196337890624996, lng: 34.803808593750006 },
        { lat: 32.6140625, lng: 34.921875 },
        { lat: 32.826611328125, lng: 35.005859375 },
        { lat: 32.9671875, lng: 35.07705078125002 },
        { lat: 33.08369140625, lng: 35.10859375 },
        { lat: 33.0919921875, lng: 35.22333984375001 },
        { lat: 33.079541015625, lng: 35.30888671875002 },
        { lat: 33.07568359375, lng: 35.411230468750006 },
        { lat: 33.119482421875, lng: 35.4931640625 },
        { lat: 33.25048828125, lng: 35.53251953125002 },
        { lat: 33.271484375, lng: 35.579296875 },
        { lat: 33.240625, lng: 35.60292968750002 },
        { lat: 33.275048828124994, lng: 35.62724609375001 },
        { lat: 33.3326171875, lng: 35.734472656250006 },
        { lat: 33.369775390624994, lng: 35.7875 },
        { lat: 33.415673828124994, lng: 35.84072265625002 },
        { lat: 33.43173828124999, lng: 35.869140625 },
        { lat: 33.370458984375, lng: 35.8515625 },
        { lat: 33.330517578125, lng: 35.83710937500001 },
        { lat: 33.278222656249994, lng: 35.837011718750006 },
        { lat: 33.24956054687499, lng: 35.858789062500016 },
        { lat: 33.19248046874999, lng: 35.88847656250002 },
        { lat: 33.135693359375, lng: 35.90664062500002 },
        { lat: 33.08857421875, lng: 35.86806640625002 },
        { lat: 33.039355468749996, lng: 35.87177734375001 },
        { lat: 32.998095703124996, lng: 35.88203125000001 },
        { lat: 32.94960937499999, lng: 35.91347656250002 },
        { lat: 32.86235351562499, lng: 35.85683593750002 },
        { lat: 32.78232421875, lng: 35.80146484375001 },
        { lat: 32.734912109374996, lng: 35.78730468750001 },
      ],
    ],
  },
  {
    code: "IR",
    coordinates: [
      [
        { lat: 26.92114257812497, lng: 56.18798828125002 },
        { lat: 26.80117187500005, lng: 56.0949218750001 },
        { lat: 26.70112304687501, lng: 55.95429687500004 },
        { lat: 26.732275390625034, lng: 55.894140625 },
        { lat: 26.730810546875006, lng: 55.847656249999964 },
        { lat: 26.692480468750034, lng: 55.74726562500003 },
        { lat: 26.68583984374999, lng: 55.674609375000074 },
        { lat: 26.617529296875034, lng: 55.54316406250004 },
        { lat: 26.58310546875003, lng: 55.42373046875005 },
        { lat: 26.585742187500045, lng: 55.340429687500006 },
        { lat: 26.592626953125002, lng: 55.31152343749997 },
        { lat: 26.639208984375014, lng: 55.29501953125 },
        { lat: 26.657568359375006, lng: 55.29648437500006 },
        { lat: 26.64794921875, lng: 55.34697265625002 },
        { lat: 26.710009765625042, lng: 55.53173828125003 },
        { lat: 26.81196289062504, lng: 55.76259765625005 },
        { lat: 26.857177734375, lng: 55.784570312499994 },
        { lat: 26.930957031250014, lng: 55.747460937499994 },
        { lat: 26.94765625000005, lng: 55.75761718750002 },
        { lat: 26.909814453124966, lng: 55.907128906249994 },
        { lat: 26.98334960937504, lng: 56.074121093749994 },
        { lat: 27.003271484375002, lng: 56.21396484375 },
        { lat: 26.952099609374983, lng: 56.279394531250006 },
        { lat: 26.92114257812497, lng: 56.18798828125002 },
      ],
      [
        { lat: 39.42353515625001, lng: 45.00019531250004 },
        { lat: 39.362890625, lng: 45.071679687499994 },
        { lat: 39.311572265625045, lng: 45.11308593750002 },
        { lat: 39.25429687499999, lng: 45.14121093750006 },
        { lat: 39.215625, lng: 45.190625 },
        { lat: 39.194677734375034, lng: 45.255957031250006 },
        { lat: 39.13916015625, lng: 45.33554687500006 },
        { lat: 39.09589843749998, lng: 45.38925781250006 },
        { lat: 39.00625, lng: 45.4796875000001 },
        { lat: 38.97280273437502, lng: 45.575 },
        { lat: 38.907910156249955, lng: 45.921875 },
        { lat: 38.877783203125034, lng: 46.1144531250001 },
        { lat: 38.86904296875002, lng: 46.1701171875001 },
        { lat: 38.912646484375045, lng: 46.31777343750005 },
        { lat: 38.90668945312498, lng: 46.490625 },
        { lat: 38.904394531250034, lng: 46.554785156250006 },
        { lat: 39.08740234375003, lng: 46.78320312500003 },
        { lat: 39.14843750000003, lng: 46.85253906250003 },
        { lat: 39.18017578125, lng: 46.98886718750006 },
        { lat: 39.25288085937498, lng: 47.06542968750003 },
        { lat: 39.340966796874994, lng: 47.188378906250044 },
        { lat: 39.42387695312498, lng: 47.33847656250006 },
        { lat: 39.49833984374999, lng: 47.47617187500006 },
        { lat: 39.54335937499999, lng: 47.581835937500074 },
        { lat: 39.64858398437505, lng: 47.772851562499994 },
        { lat: 39.68505859374999, lng: 47.8922851562501 },
        { lat: 39.683935546875034, lng: 47.995898437500074 },
        { lat: 39.56054687500006, lng: 48.15107421875004 },
        { lat: 39.448339843750006, lng: 48.28173828125003 },
        { lat: 39.399072265625016, lng: 48.322167968749994 },
        { lat: 39.35498046875, lng: 48.257226562499994 },
        { lat: 39.312353515625006, lng: 48.13603515625002 },
        { lat: 39.28110351562503, lng: 48.112890625 },
        { lat: 39.241113281249994, lng: 48.10439453125005 },
        { lat: 39.20283203125001, lng: 48.10917968750007 },
        { lat: 39.17163085937503, lng: 48.125488281249964 },
        { lat: 39.09912109375, lng: 48.2741210937501 },
        { lat: 39.05927734374998, lng: 48.29101562499997 },
        { lat: 39.01884765624999, lng: 48.292089843750006 },
        { lat: 38.99360351562501, lng: 48.2750976562501 },
        { lat: 38.978955078124955, lng: 48.24199218750001 },
        { lat: 38.958642578124994, lng: 48.138574218749994 },
        { lat: 38.93500976562498, lng: 48.05009765625002 },
        { lat: 38.911816406249955, lng: 48.01933593750001 },
        { lat: 38.88427734375003, lng: 47.99267578125003 },
        { lat: 38.85375976562503, lng: 47.99648437499999 },
        { lat: 38.81904296874998, lng: 48.02324218750002 },
        { lat: 38.72412109375, lng: 48.20468750000006 },
        { lat: 38.689208984375, lng: 48.22519531250006 },
        { lat: 38.64228515625001, lng: 48.261328125000055 },
        { lat: 38.61347656250001, lng: 48.305566406249994 },
        { lat: 38.605615234375016, lng: 48.38125 },
        { lat: 38.58623046874995, lng: 48.41738281250005 },
        { lat: 38.41108398437498, lng: 48.59267578125005 },
        { lat: 38.39873046874996, lng: 48.63554687500007 },
        { lat: 38.437255859375, lng: 48.84033203124997 },
        { lat: 38.43549804687498, lng: 48.86875 },
        { lat: 38.39252929687503, lng: 48.870703125 },
        { lat: 38.143652343750034, lng: 48.90136718749997 },
        { lat: 38.015136718749964, lng: 48.92509765625002 },
        { lat: 37.89013671875, lng: 48.95996093750003 },
        { lat: 37.77607421875004, lng: 49.0153320312501 },
        { lat: 37.667578125000034, lng: 49.08095703125005 },
        { lat: 37.60058593749997, lng: 49.171191406250074 },
        { lat: 37.51997070312498, lng: 49.372460937499994 },
        { lat: 37.496679687500034, lng: 49.47011718749999 },
        { lat: 37.480517578125045, lng: 49.726953125000044 },
        { lat: 37.44487304687496, lng: 49.98066406250004 },
        { lat: 37.40712890624999, lng: 50.13046875 },
        { lat: 37.380517578124994, lng: 50.17626953124997 },
        { lat: 37.33959960937503, lng: 50.21406250000004 },
        { lat: 37.14916992187503, lng: 50.33789062499997 },
        { lat: 37.01367187500006, lng: 50.53320312499997 },
        { lat: 36.810205078124994, lng: 50.9274414062501 },
        { lat: 36.742578124999966, lng: 51.11855468750005 },
        { lat: 36.614501953125, lng: 51.76201171875002 },
        { lat: 36.62172851562505, lng: 52.19013671875004 },
        { lat: 36.86875, lng: 53.37412109375 },
        { lat: 36.93032226562502, lng: 53.76767578125006 },
        { lat: 36.93032226562502, lng: 53.91542968750005 },
        { lat: 36.88120117187498, lng: 53.827441406250074 },
        { lat: 36.853125, lng: 53.67949218750002 },
        { lat: 36.81845703124998, lng: 53.76875 },
        { lat: 36.812695312499955, lng: 53.90625 },
        { lat: 36.818310546874955, lng: 53.970117187499994 },
        { lat: 36.849658203125045, lng: 54.016210937500006 },
        { lat: 36.90131835937498, lng: 54.02382812500005 },
        { lat: 36.95249023437503, lng: 54.0171875 },
        { lat: 37.181738281250006, lng: 53.95195312500002 },
        { lat: 37.34355468750002, lng: 53.91416015625006 },
        { lat: 37.33247070312498, lng: 54.1916015625001 },
        { lat: 37.353613281250034, lng: 54.29980468750002 },
        { lat: 37.407568359375, lng: 54.4586914062501 },
        { lat: 37.44023437499998, lng: 54.578906250000074 },
        { lat: 37.44472656250002, lng: 54.63964843749997 },
        { lat: 37.47016601562498, lng: 54.69941406250009 },
        { lat: 37.501904296874955, lng: 54.745214843750006 },
        { lat: 37.72265624999997, lng: 54.84863281250003 },
        { lat: 37.77792968750006, lng: 54.90009765625004 },
        { lat: 37.90249023437502, lng: 55.075585937499994 },
        { lat: 37.98134765625002, lng: 55.224707031250006 },
        { lat: 38.051123046875034, lng: 55.38085937500003 },
        { lat: 38.099755859374994, lng: 55.57841796875001 },
        { lat: 38.094628906249994, lng: 55.84130859375002 },
        { lat: 38.077539062499994, lng: 56.050292968749964 },
        { lat: 38.07836914062497, lng: 56.171191406250074 },
        { lat: 38.07338867187502, lng: 56.22880859375001 },
        { lat: 38.080419921875034, lng: 56.2720703125 },
        { lat: 38.094824218750034, lng: 56.296972656250006 },
        { lat: 38.19111328125004, lng: 56.324121093750044 },
        { lat: 38.222509765625034, lng: 56.36689453125004 },
        { lat: 38.249414062499994, lng: 56.440625 },
        { lat: 38.249609375000034, lng: 56.54404296875 },
        { lat: 38.25664062499996, lng: 56.66992187499997 },
        { lat: 38.25004882812496, lng: 56.7746093750001 },
        { lat: 38.213037109374966, lng: 56.90664062499999 },
        { lat: 38.20996093750006, lng: 57.079003906249994 },
        { lat: 38.216406250000034, lng: 57.1935546875001 },
        { lat: 38.179589843749994, lng: 57.26015625000005 },
        { lat: 38.13037109375, lng: 57.308105468749964 },
        { lat: 38.08930664062498, lng: 57.33144531249999 },
        { lat: 38.032910156249955, lng: 57.33671875000002 },
        { lat: 37.98994140624998, lng: 57.33574218750001 },
        { lat: 37.97333984374998, lng: 57.35371093750004 },
        { lat: 37.947705078125004, lng: 57.42382812500002 },
        { lat: 37.928466796875, lng: 57.52099609374997 },
        { lat: 37.90527343749997, lng: 57.71054687500006 },
        { lat: 37.86083984374997, lng: 57.88818359375002 },
        { lat: 37.830468750000016, lng: 57.98056640625 },
        { lat: 37.783056640625034, lng: 58.108789062499994 },
        { lat: 37.665820312500045, lng: 58.26162109374999 },
        { lat: 37.64721679687497, lng: 58.31816406250001 },
        { lat: 37.63535156250006, lng: 58.38671874999998 },
        { lat: 37.63852539062497, lng: 58.4357421875001 },
        { lat: 37.68818359374998, lng: 58.55048828125004 },
        { lat: 37.65156249999998, lng: 58.65019531250002 },
        { lat: 37.65625, lng: 58.70078125 },
        { lat: 37.683496093749994, lng: 58.81542968750003 },
        { lat: 37.64965820312503, lng: 58.93720703125004 },
        { lat: 37.52075195312497, lng: 59.240820312500006 },
        { lat: 37.52373046874996, lng: 59.27412109375004 },
        { lat: 37.51064453125005, lng: 59.30175781249997 },
        { lat: 37.48115234374998, lng: 59.32695312500002 },
        { lat: 37.44472656250002, lng: 59.344726562500036 },
        { lat: 37.333740234374964, lng: 59.3673828125001 },
        { lat: 37.25283203125002, lng: 59.454980468749994 },
        { lat: 37.178906249999955, lng: 59.56220703125009 },
        { lat: 37.13847656249999, lng: 59.68720703125004 },
        { lat: 37.04160156250006, lng: 59.94863281250005 },
        { lat: 36.96289062499999, lng: 60.06279296875001 },
        { lat: 36.829443359375006, lng: 60.1783203125 },
        { lat: 36.65356445312506, lng: 60.32070312499999 },
        { lat: 36.63764648437501, lng: 60.34130859375002 },
        { lat: 36.64296875000002, lng: 60.707910156249994 },
        { lat: 36.64257812500003, lng: 61.11962890625003 },
        { lat: 36.572265625, lng: 61.16992187499997 },
        { lat: 36.432714843750006, lng: 61.160351562500104 },
        { lat: 36.289697265624994, lng: 61.17509765625007 },
        { lat: 36.190527343750034, lng: 61.21201171875 },
        { lat: 36.099121093749964, lng: 61.21240234375003 },
        { lat: 36.05283203125006, lng: 61.18261718749997 },
        { lat: 35.99990234375002, lng: 61.159472656250074 },
        { lat: 35.976757812500004, lng: 61.15292968750006 },
        { lat: 35.943701171875034, lng: 61.20585937500001 },
        { lat: 35.86762695312498, lng: 61.25214843750004 },
        { lat: 35.761816406250006, lng: 61.25869140625005 },
        { lat: 35.70556640625, lng: 61.23554687500003 },
        { lat: 35.659277343750006, lng: 61.2388671875 },
        { lat: 35.61958007812498, lng: 61.26201171875002 },
        { lat: 35.55341796875001, lng: 61.28183593750006 },
        { lat: 35.513769531250006, lng: 61.2785156250001 },
        { lat: 35.47407226562501, lng: 61.245507812499994 },
        { lat: 35.42446289062502, lng: 61.22568359375007 },
        { lat: 35.36162109375002, lng: 61.199218749999964 },
        { lat: 35.31201171875003, lng: 61.18925781250002 },
        { lat: 35.28886718750002, lng: 61.13964843750002 },
        { lat: 35.272314453125034, lng: 61.1 },
        { lat: 35.20947265625003, lng: 61.10664062500003 },
        { lat: 35.15654296874999, lng: 61.12646484375003 },
        { lat: 35.09375, lng: 61.1496093750001 },
        { lat: 35.05073242187501, lng: 61.12314453125006 },
        { lat: 35.00112304687502, lng: 61.10664062500003 },
        { lat: 34.921728515625006, lng: 61.070214843749994 },
        { lat: 34.85561523437505, lng: 61.080078124999964 },
        { lat: 34.799365234375045, lng: 61.040429687499994 },
        { lat: 34.74975585937497, lng: 60.9908203125 },
        { lat: 34.71005859375006, lng: 60.95781250000001 },
        { lat: 34.65385742187499, lng: 60.951171874999964 },
        { lat: 34.633984375, lng: 60.91474609375004 },
        { lat: 34.58769531249998, lng: 60.8453125 },
        { lat: 34.55463867187501, lng: 60.802343750000055 },
        { lat: 34.544726562500045, lng: 60.73945312500003 },
        { lat: 34.518261718749976, lng: 60.726269531250104 },
        { lat: 34.491796875, lng: 60.73613281250007 },
        { lat: 34.475244140624994, lng: 60.76259765625005 },
        { lat: 34.41801757812499, lng: 60.80390625000009 },
        { lat: 34.31943359375006, lng: 60.88945312500001 },
        { lat: 34.30717773437496, lng: 60.64267578125 },
        { lat: 34.219628906249966, lng: 60.57021484374999 },
        { lat: 34.09477539062502, lng: 60.485742187500044 },
        { lat: 33.841992187499955, lng: 60.52705078125009 },
        { lat: 33.7119140625, lng: 60.4859375 },
        { lat: 33.63891601562497, lng: 60.51083984375 },
        { lat: 33.58833007812498, lng: 60.57382812500006 },
        { lat: 33.56040039062506, lng: 60.654589843750074 },
        { lat: 33.55869140625006, lng: 60.80644531250002 },
        { lat: 33.53896484375005, lng: 60.90693359375004 },
        { lat: 33.505224609375006, lng: 60.91699218749997 },
        { lat: 33.45625, lng: 60.859277343749994 },
        { lat: 33.36381835937496, lng: 60.76689453125001 },
        { lat: 33.32353515625002, lng: 60.718066406250024 },
        { lat: 33.13784179687502, lng: 60.56054687499997 },
        { lat: 33.05878906250001, lng: 60.561914062499994 },
        { lat: 32.99487304687503, lng: 60.57656249999999 },
        { lat: 32.794384765624955, lng: 60.644531249999964 },
        { lat: 32.6, lng: 60.71044921874997 },
        { lat: 32.24941406250005, lng: 60.82929687500004 },
        { lat: 32.16796874999997, lng: 60.82724609375006 },
        { lat: 31.987109374999985, lng: 60.78994140624999 },
        { lat: 31.87719726562497, lng: 60.7875 },
        { lat: 31.73447265625003, lng: 60.804296875 },
        { lat: 31.660595703124983, lng: 60.791601562500006 },
        { lat: 31.49516601562505, lng: 60.82070312499999 },
        { lat: 31.483251953125006, lng: 60.8541015625 },
        { lat: 31.451123046875036, lng: 61.110742187499994 },
        { lat: 31.42163085937497, lng: 61.34648437500007 },
        { lat: 31.382421874999974, lng: 61.66015625000003 },
        { lat: 31.28530273437499, lng: 61.755078125000104 },
        { lat: 31.07255859375002, lng: 61.81425781250007 },
        { lat: 30.913281249999983, lng: 61.81083984375007 },
        { lat: 30.831933593750026, lng: 61.784179687499964 },
        { lat: 30.59936523437497, lng: 61.55947265625005 },
        { lat: 30.363720703125008, lng: 61.331640625000055 },
        { lat: 30.128417968750025, lng: 61.10410156250006 },
        { lat: 29.884375, lng: 60.868164062499964 },
        { lat: 29.858691406249985, lng: 60.84335937500006 },
        { lat: 29.663427734374974, lng: 61.03417968750003 },
        { lat: 29.542724609374996, lng: 61.152148437500024 },
        { lat: 29.37260742187499, lng: 61.31835937500003 },
        { lat: 29.331787109375025, lng: 61.33945312500006 },
        { lat: 29.26499023437501, lng: 61.33789062500003 },
        { lat: 29.006054687500015, lng: 61.50859375000007 },
        { lat: 28.87089843749999, lng: 61.56875 },
        { lat: 28.791601562500006, lng: 61.62304687500002 },
        { lat: 28.66767578124998, lng: 61.75800781250004 },
        { lat: 28.546533203124994, lng: 61.88984375000009 },
        { lat: 28.49101562499996, lng: 62.03300781250001 },
        { lat: 28.478808593749957, lng: 62.13056640625003 },
        { lat: 28.414746093749983, lng: 62.35302734374997 },
        { lat: 28.363867187500006, lng: 62.43388671875002 },
        { lat: 28.235156249999985, lng: 62.56455078125007 },
        { lat: 28.252783203125006, lng: 62.71757812500007 },
        { lat: 28.252880859375036, lng: 62.749414062499994 },
        { lat: 28.243554687499994, lng: 62.75800781250004 },
        { lat: 28.20205078124999, lng: 62.7625 },
        { lat: 28.002050781250006, lng: 62.739746093749964 },
        { lat: 27.800537109375, lng: 62.782324218750006 },
        { lat: 27.497021484374983, lng: 62.81201171875003 },
        { lat: 27.44453125000001, lng: 62.800878906250055 },
        { lat: 27.35673828124999, lng: 62.764257812500055 },
        { lat: 27.300195312500023, lng: 62.7625 },
        { lat: 27.265625, lng: 62.75273437500001 },
        { lat: 27.250195312499955, lng: 62.762988281250074 },
        { lat: 27.229443359374983, lng: 62.81162109375006 },
        { lat: 27.218408203124966, lng: 62.91542968750006 },
        { lat: 27.25249023437499, lng: 63.166796875000024 },
        { lat: 27.243945312500017, lng: 63.19609375000002 },
        { lat: 27.207910156250048, lng: 63.25625 },
        { lat: 27.151464843750002, lng: 63.30156250000001 },
        { lat: 27.124560546875014, lng: 63.30517578124997 },
        { lat: 27.07768554687499, lng: 63.24208984374999 },
        { lat: 26.998144531250034, lng: 63.23144531250003 },
        { lat: 26.87924804687506, lng: 63.25039062499999 },
        { lat: 26.86474609375003, lng: 63.24160156250005 },
        { lat: 26.83759765625001, lng: 63.186132812500055 },
        { lat: 26.66557617187496, lng: 63.168066406250006 },
        { lat: 26.649755859375034, lng: 63.15781250000006 },
        { lat: 26.63232421875003, lng: 63.09296875000003 },
        { lat: 26.643896484374977, lng: 62.78662109375002 },
        { lat: 26.63916015625, lng: 62.751562500000055 },
        { lat: 26.59365234375005, lng: 62.63642578125003 },
        { lat: 26.56103515624997, lng: 62.43925781250002 },
        { lat: 26.54262695312505, lng: 62.38505859375002 },
        { lat: 26.490869140624994, lng: 62.31230468750001 },
        { lat: 26.42749023437503, lng: 62.25966796875005 },
        { lat: 26.369238281249977, lng: 62.249609375 },
        { lat: 26.357031249999977, lng: 62.23935546875006 },
        { lat: 26.368994140625034, lng: 62.125976562499964 },
        { lat: 26.31826171874999, lng: 62.0890625000001 },
        { lat: 26.242431640625, lng: 61.8698242187501 },
        { lat: 26.225927734375006, lng: 61.842382812500006 },
        { lat: 26.165283203125, lng: 61.809960937499994 },
        { lat: 25.99584960937503, lng: 61.78076171874997 },
        { lat: 25.84335937500006, lng: 61.75439453125003 },
        { lat: 25.821093750000045, lng: 61.73769531249999 },
        { lat: 25.76899414062501, lng: 61.66865234375004 },
        { lat: 25.751269531250017, lng: 61.6618164062501 },
        { lat: 25.692382812500025, lng: 61.671386718749964 },
        { lat: 25.584619140624994, lng: 61.64013671875003 },
        { lat: 25.286132812500025, lng: 61.61542968750003 },
        { lat: 25.20234375, lng: 61.58789062499997 },
        { lat: 25.19550781249995, lng: 61.533105468749994 },
        { lat: 25.15366210937506, lng: 61.49033203125006 },
        { lat: 25.102099609375017, lng: 61.41220703125006 },
        { lat: 25.14199218749999, lng: 61.24296875000002 },
        { lat: 25.183886718749985, lng: 61.1085937500001 },
        { lat: 25.28222656250003, lng: 60.66386718750001 },
        { lat: 25.329833984374968, lng: 60.61513671874999 },
        { lat: 25.413525390624955, lng: 60.5875 },
        { lat: 25.437060546875045, lng: 60.51054687500002 },
        { lat: 25.31157226562507, lng: 60.40019531250002 },
        { lat: 25.384130859375002, lng: 60.024707031250074 },
        { lat: 25.36181640625, lng: 59.8970703125 },
        { lat: 25.400878906250057, lng: 59.81835937499997 },
        { lat: 25.40327148437501, lng: 59.61601562500001 },
        { lat: 25.481494140625045, lng: 59.45605468749997 },
        { lat: 25.42773437500003, lng: 59.22724609375003 },
        { lat: 25.417285156250017, lng: 59.0460937500001 },
        { lat: 25.55458984375002, lng: 58.79785156249997 },
        { lat: 25.592431640624994, lng: 58.530859375 },
        { lat: 25.580859375000045, lng: 58.31425781250007 },
        { lat: 25.591601562500017, lng: 58.20292968750002 },
        { lat: 25.640820312500008, lng: 58.022363281249994 },
        { lat: 25.691650390625053, lng: 57.93662109375001 },
        { lat: 25.65302734375001, lng: 57.7960937500001 },
        { lat: 25.724902343749985, lng: 57.73251953125 },
        { lat: 25.791552734375074, lng: 57.334570312500006 },
        { lat: 25.918847656249966, lng: 57.26093750000003 },
        { lat: 26.037207031250006, lng: 57.205566406249964 },
        { lat: 26.15883789062502, lng: 57.20136718750009 },
        { lat: 26.371435546874977, lng: 57.10429687500002 },
        { lat: 26.68007812499999, lng: 57.0719726562501 },
        { lat: 26.80068359375005, lng: 57.03603515625005 },
        { lat: 26.905468749999983, lng: 56.98222656250002 },
        { lat: 26.99458007812501, lng: 56.910449218750074 },
        { lat: 27.089990234374994, lng: 56.81289062499999 },
        { lat: 27.127685546875057, lng: 56.728125 },
        { lat: 27.20024414062499, lng: 56.3561523437501 },
        { lat: 27.190625, lng: 56.284375 },
        { lat: 27.14311523437499, lng: 56.11806640624999 },
        { lat: 27.037597656249996, lng: 55.9411132812501 },
        { lat: 26.977539062499996, lng: 55.650292968749994 },
        { lat: 26.93212890625, lng: 55.59160156250002 },
        { lat: 26.82993164062503, lng: 55.518554687499964 },
        { lat: 26.770556640625017, lng: 55.4240234375001 },
        { lat: 26.7859375, lng: 55.29414062500009 },
        { lat: 26.72539062499999, lng: 55.15458984375002 },
        { lat: 26.55668945312499, lng: 54.89580078125002 },
        { lat: 26.50507812500004, lng: 54.75927734375002 },
        { lat: 26.508935546875023, lng: 54.64492187499999 },
        { lat: 26.589160156250017, lng: 54.522070312500006 },
        { lat: 26.696630859374977, lng: 54.24707031250003 },
        { lat: 26.73237304687498, lng: 54.06933593749997 },
        { lat: 26.707714843750008, lng: 53.822558593750074 },
        { lat: 26.725585937500025, lng: 53.70576171875004 },
        { lat: 26.851757812499955, lng: 53.50712890625002 },
        { lat: 26.94326171875005, lng: 53.45498046875005 },
        { lat: 27.004492187500006, lng: 53.34169921875005 },
        { lat: 27.141943359375002, lng: 52.98251953125006 },
        { lat: 27.323388671875023, lng: 52.69160156250004 },
        { lat: 27.391992187499966, lng: 52.638183593749964 },
        { lat: 27.49335937500001, lng: 52.60263671875006 },
        { lat: 27.61650390624999, lng: 52.475878906250074 },
        { lat: 27.717285156249996, lng: 52.19189453125003 },
        { lat: 27.824414062499955, lng: 52.030761718749964 },
        { lat: 27.848242187500034, lng: 51.84199218750003 },
        { lat: 27.84497070312497, lng: 51.666308593750074 },
        { lat: 27.864208984374983, lng: 51.58906250000004 },
        { lat: 27.910009765625006, lng: 51.51855468749997 },
        { lat: 28.13134765624997, lng: 51.27890625 },
        { lat: 28.21884765625003, lng: 51.27607421875004 },
        { lat: 28.435156250000034, lng: 51.128417968749964 },
        { lat: 28.51210937499999, lng: 51.09384765625006 },
        { lat: 28.72612304687499, lng: 51.06201171874997 },
        { lat: 28.782080078125034, lng: 51.0211914062501 },
        { lat: 28.870166015625014, lng: 50.86699218750002 },
        { lat: 28.92783203125006, lng: 50.8429687500001 },
        { lat: 29.004394531250032, lng: 50.87578125000002 },
        { lat: 29.06269531249998, lng: 50.87578125000002 },
        { lat: 29.117431640625053, lng: 50.795507812500006 },
        { lat: 29.146582031250034, lng: 50.67519531250005 },
        { lat: 29.21220703124999, lng: 50.64609375000006 },
        { lat: 29.339843749999975, lng: 50.667968749999964 },
        { lat: 29.420068359374966, lng: 50.64960937500004 },
        { lat: 29.547998046875023, lng: 50.54355468750006 },
        { lat: 29.679052734374977, lng: 50.3869140625001 },
        { lat: 29.872900390625034, lng: 50.23017578125004 },
        { lat: 29.92124023437503, lng: 50.16894531250003 },
        { lat: 30.048095703125025, lng: 50.12890625000003 },
        { lat: 30.198535156250014, lng: 50.071582031250074 },
        { lat: 30.209375, lng: 49.9831054687501 },
        { lat: 30.028955078125026, lng: 49.55488281250004 },
        { lat: 30.13046875, lng: 49.42998046875002 },
        { lat: 30.30693359374999, lng: 49.05429687500006 },
        { lat: 30.333447265624983, lng: 49.028125 },
        { lat: 30.37392578124997, lng: 49.00195312500003 },
        { lat: 30.397265625000014, lng: 49.04902343750003 },
        { lat: 30.40678710937499, lng: 49.096191406249964 },
        { lat: 30.37539062499999, lng: 49.190332031250044 },
        { lat: 30.4125, lng: 49.2472656250001 },
        { lat: 30.47231445312502, lng: 49.224511718749994 },
        { lat: 30.509423828125023, lng: 49.130371093749964 },
        { lat: 30.50654296874998, lng: 49.00195312500003 },
        { lat: 30.450488281250017, lng: 49.03710937499997 },
        { lat: 30.397265625000014, lng: 48.91679687500002 },
        { lat: 30.32763671875003, lng: 48.891210937500006 },
        { lat: 30.24145507812497, lng: 48.90869140625002 },
        { lat: 30.12089843750002, lng: 48.91914062500004 },
        { lat: 30.06240234374999, lng: 48.87011718749997 },
        { lat: 30.03549804687503, lng: 48.83242187500005 },
        { lat: 30.0283203125, lng: 48.670898437499964 },
        { lat: 29.975048828124983, lng: 48.59550781250002 },
        { lat: 29.96235351562495, lng: 48.54648437500006 },
        { lat: 30.003808593749966, lng: 48.478515624999964 },
        { lat: 30.03759765625, lng: 48.43457031249997 },
        { lat: 30.10961914062503, lng: 48.39863281250004 },
        { lat: 30.159863281249955, lng: 48.387597656249994 },
        { lat: 30.188330078124974, lng: 48.401367187499964 },
        { lat: 30.230175781249983, lng: 48.382617187500074 },
        { lat: 30.285449218749964, lng: 48.33105468749997 },
        { lat: 30.31582031250002, lng: 48.27890625 },
        { lat: 30.321337890624985, lng: 48.226171875 },
        { lat: 30.355029296875017, lng: 48.18242187500007 },
        { lat: 30.416845703125002, lng: 48.14755859375006 },
        { lat: 30.457666015624966, lng: 48.06611328125004 },
        { lat: 30.465625, lng: 48.01494140625002 },
        { lat: 30.656445312499958, lng: 48.01347656250002 },
        { lat: 30.823632812500023, lng: 48.012011718750074 },
        { lat: 30.989794921875014, lng: 48.01064453125005 },
        { lat: 30.996435546875034, lng: 47.836328125000044 },
        { lat: 31.00239257812501, lng: 47.679492187500074 },
        { lat: 31.141503906250023, lng: 47.679492187500074 },
        { lat: 31.400585937499958, lng: 47.679492187500074 },
        { lat: 31.601367187500017, lng: 47.75390624999997 },
        { lat: 31.794433593749996, lng: 47.82998046874999 },
        { lat: 31.936425781249966, lng: 47.71455078125004 },
        { lat: 32.087988281250034, lng: 47.5915039062501 },
        { lat: 32.15083007812504, lng: 47.51191406250004 },
        { lat: 32.34008789062506, lng: 47.41816406250004 },
        { lat: 32.42373046875002, lng: 47.3712890625001 },
        { lat: 32.45551757812501, lng: 47.3297851562501 },
        { lat: 32.474023437499966, lng: 47.28515625000002 },
        { lat: 32.46660156249996, lng: 47.121386718750074 },
        { lat: 32.56840820312502, lng: 46.96855468750002 },
        { lat: 32.68798828125006, lng: 46.789062499999964 },
        { lat: 32.83393554687501, lng: 46.569921875 },
        { lat: 32.92924804687498, lng: 46.37705078125006 },
        { lat: 32.95024414062502, lng: 46.29824218750005 },
        { lat: 32.957666015624994, lng: 46.11279296875003 },
        { lat: 32.97587890624999, lng: 46.09306640625002 },
        { lat: 33.028222656249994, lng: 46.08046875 },
        { lat: 33.08652343750006, lng: 46.0807617187501 },
        { lat: 33.174414062500034, lng: 46.14111328125002 },
        { lat: 33.229638671874994, lng: 46.145898437499994 },
        { lat: 33.41572265624998, lng: 46.01992187500005 },
        { lat: 33.47011718750005, lng: 45.981054687500006 },
        { lat: 33.49199218749996, lng: 45.8732421875001 },
        { lat: 33.54565429687497, lng: 45.8947265625001 },
        { lat: 33.58154296875, lng: 45.8947265625001 },
        { lat: 33.60976562499999, lng: 45.87939453124997 },
        { lat: 33.62333984374998, lng: 45.85449218749997 },
        { lat: 33.62480468750002, lng: 45.822851562500006 },
        { lat: 33.60283203124999, lng: 45.73828125000003 },
        { lat: 33.68666992187502, lng: 45.673730468749994 },
        { lat: 33.92548828125001, lng: 45.473242187500006 },
        { lat: 33.95449218750005, lng: 45.408984375000074 },
        { lat: 33.970849609374994, lng: 45.39707031250006 },
        { lat: 34.044042968750006, lng: 45.44609375000002 },
        { lat: 34.152539062499976, lng: 45.52861328125002 },
        { lat: 34.21552734375004, lng: 45.542773437500074 },
        { lat: 34.28466796875, lng: 45.52685546875003 },
        { lat: 34.41513671875, lng: 45.43759765625006 },
        { lat: 34.470361328124994, lng: 45.459375 },
        { lat: 34.533886718749955, lng: 45.49775390625003 },
        { lat: 34.58159179687499, lng: 45.50078125000002 },
        { lat: 34.57451171874999, lng: 45.56083984375002 },
        { lat: 34.573828125, lng: 45.6375 },
        { lat: 34.61269531250002, lng: 45.661523437499994 },
        { lat: 34.74877929687503, lng: 45.660058593749994 },
        { lat: 34.798437500000034, lng: 45.678125 },
        { lat: 35.02851562500001, lng: 45.92089843750002 },
        { lat: 35.08017578125006, lng: 46.04179687500002 },
        { lat: 35.12763671874995, lng: 46.13378906249997 },
        { lat: 35.19672851562498, lng: 46.15468750000005 },
        { lat: 35.232275390625034, lng: 46.13574218749997 },
        { lat: 35.28427734374998, lng: 46.11777343750006 },
        { lat: 35.32167968750005, lng: 46.11210937500007 },
        { lat: 35.4248046875, lng: 46.010644531249994 },
        { lat: 35.47680664062503, lng: 45.97539062500002 },
        { lat: 35.524169921875, lng: 45.97109375000005 },
        { lat: 35.608105468749955, lng: 45.99501953124999 },
        { lat: 35.67314453124999, lng: 46.03740234375002 },
        { lat: 35.71137695312504, lng: 46.180957031250074 },
        { lat: 35.74414062500006, lng: 46.2625 },
        { lat: 35.77324218750002, lng: 46.27343749999997 },
        { lat: 35.820556640625, lng: 46.16748046874997 },
        { lat: 35.83540039062498, lng: 45.94140625000003 },
        { lat: 35.82182617187499, lng: 45.77636718749997 },
        { lat: 35.83666992187497, lng: 45.72343750000002 },
        { lat: 35.92836914062502, lng: 45.64501953125002 },
        { lat: 35.97719726562502, lng: 45.561621093750006 },
        { lat: 36.008544921875, lng: 45.48378906250005 },
        { lat: 36.00278320312498, lng: 45.40771484375003 },
        { lat: 36.015332031249955, lng: 45.36162109375001 },
        { lat: 36.05463867187498, lng: 45.350878906250074 },
        { lat: 36.35595703125, lng: 45.241113281249994 },
        { lat: 36.397167968749955, lng: 45.20654296874997 },
        { lat: 36.407373046874994, lng: 45.155273437499964 },
        { lat: 36.409277343750034, lng: 45.11240234375006 },
        { lat: 36.43002929687498, lng: 45.08378906250002 },
        { lat: 36.47163085937501, lng: 45.053125 },
        { lat: 36.52607421875001, lng: 45.03105468750002 },
        { lat: 36.59755859375002, lng: 45.029394531250006 },
        { lat: 36.65888671874998, lng: 45.033984375000074 },
        { lat: 36.698388671875016, lng: 45.0192382812501 },
        { lat: 36.73769531250005, lng: 44.98144531250003 },
        { lat: 36.76591796875002, lng: 44.92783203125 },
        { lat: 36.79931640625, lng: 44.88085937499997 },
        { lat: 37.063867187499966, lng: 44.79843750000006 },
        { lat: 37.135009765625, lng: 44.765429687500074 },
        { lat: 37.142431640625006, lng: 44.76513671875003 },
        { lat: 37.15634765624998, lng: 44.76669921875006 },
        { lat: 37.21708984375002, lng: 44.75830078125003 },
        { lat: 37.26977539062499, lng: 44.79677734375005 },
        { lat: 37.29038085937503, lng: 44.79414062500003 },
        { lat: 37.35712890625004, lng: 44.71513671875001 },
        { lat: 37.42373046875002, lng: 44.60410156250006 },
        { lat: 37.435400390625, lng: 44.574023437500074 },
        { lat: 37.50639648437499, lng: 44.573144531249994 },
        { lat: 37.560205078125016, lng: 44.57714843749997 },
        { lat: 37.60864257812503, lng: 44.56718750000002 },
        { lat: 37.63632812499998, lng: 44.54609375000003 },
        { lat: 37.65815429687498, lng: 44.5453125 },
        { lat: 37.71035156249996, lng: 44.58994140625 },
        { lat: 37.74462890625003, lng: 44.56123046875004 },
        { lat: 37.82924804687502, lng: 44.39775390625002 },
        { lat: 37.87177734374998, lng: 44.33623046875002 },
        { lat: 37.88017578125002, lng: 44.22294921875002 },
        { lat: 37.908056640625006, lng: 44.21132812499999 },
        { lat: 37.96718749999996, lng: 44.22890625 },
        { lat: 38.038818359375, lng: 44.26796875 },
        { lat: 38.109277343749966, lng: 44.329394531250074 },
        { lat: 38.146484375, lng: 44.34892578125002 },
        { lat: 38.209716796875, lng: 44.37275390625009 },
        { lat: 38.25458984374998, lng: 44.38085937499997 },
        { lat: 38.317773437499994, lng: 44.44960937500005 },
        { lat: 38.33422851562506, lng: 44.44990234375009 },
        { lat: 38.356787109375034, lng: 44.43085937500004 },
        { lat: 38.36958007812498, lng: 44.37578125000001 },
        { lat: 38.374707031249955, lng: 44.31962890625002 },
        { lat: 38.38627929687499, lng: 44.2985351562501 },
        { lat: 38.420117187499955, lng: 44.29082031250002 },
        { lat: 38.557812499999955, lng: 44.29785156250003 },
        { lat: 38.64067382812496, lng: 44.28017578124999 },
        { lat: 38.70063476562501, lng: 44.25703125000004 },
        { lat: 38.83603515625006, lng: 44.27167968750004 },
        { lat: 38.86323242187501, lng: 44.23242187500003 },
        { lat: 38.934375, lng: 44.170800781249994 },
        { lat: 38.994384765625, lng: 44.14453124999997 },
        { lat: 39.01674804687502, lng: 44.158789062500006 },
        { lat: 39.05625, lng: 44.171875 },
        { lat: 39.10805664062496, lng: 44.180566406249994 },
        { lat: 39.14482421874998, lng: 44.17802734375002 },
        { lat: 39.18061523437501, lng: 44.12128906250004 },
        { lat: 39.218310546875045, lng: 44.07910156249997 },
        { lat: 39.25996093750001, lng: 44.07431640625006 },
        { lat: 39.31083984374999, lng: 44.05751953124999 },
        { lat: 39.35102539062498, lng: 44.03378906250006 },
        { lat: 39.37744140625005, lng: 44.02324218750002 },
        { lat: 39.39296875000002, lng: 44.04394531249997 },
        { lat: 39.40522460937501, lng: 44.12402343749997 },
        { lat: 39.39677734374998, lng: 44.24042968750004 },
        { lat: 39.39604492187502, lng: 44.33544921874997 },
        { lat: 39.422119140625, lng: 44.3893554687501 },
        { lat: 39.666748046875, lng: 44.455957031249994 },
        { lat: 39.73125, lng: 44.51669921875 },
        { lat: 39.76855468750006, lng: 44.58710937500004 },
        { lat: 39.681738281250034, lng: 44.725 },
        { lat: 39.65107421875001, lng: 44.782128906249994 },
        { lat: 39.65043945312496, lng: 44.81718750000002 },
        { lat: 39.62910156249998, lng: 44.838183593750074 },
        { lat: 39.42353515625001, lng: 45.00019531250004 },
      ],
    ],
  },
  {
    code: "AZ",
    coordinates: [
      [
        { lat: 39.58266601562502, lng: 45.15283203125003 },
        { lat: 39.57060546874996, lng: 45.17255859375003 },
        { lat: 39.59545898437506, lng: 45.252539062500006 },
        { lat: 39.56557617187499, lng: 45.2882812500001 },
        { lat: 39.529882812500006, lng: 45.34990234375002 },
        { lat: 39.494482421875006, lng: 45.456835937500074 },
        { lat: 39.5498046875, lng: 45.610742187499994 },
        { lat: 39.56406250000006, lng: 45.687402343750044 },
        { lat: 39.56293945312501, lng: 45.75048828125003 },
        { lat: 39.54560546875001, lng: 45.78447265625001 },
        { lat: 39.488134765625034, lng: 45.79648437500006 },
        { lat: 39.41723632812497, lng: 45.784179687499964 },
        { lat: 39.37846679687499, lng: 45.76630859375004 },
        { lat: 39.350195312500006, lng: 45.798632812500074 },
        { lat: 39.28193359375004, lng: 45.925 },
        { lat: 39.24389648437503, lng: 45.977441406249994 },
        { lat: 39.178125, lng: 45.9518554687501 },
        { lat: 39.01752929687498, lng: 46.04589843749997 },
        { lat: 38.95488281250002, lng: 46.07744140625002 },
        { lat: 38.877783203125034, lng: 46.1144531250001 },
        { lat: 38.907910156249955, lng: 45.921875 },
        { lat: 38.97280273437502, lng: 45.575 },
        { lat: 39.00625, lng: 45.4796875000001 },
        { lat: 39.09589843749998, lng: 45.38925781250006 },
        { lat: 39.13916015625, lng: 45.33554687500006 },
        { lat: 39.194677734375034, lng: 45.255957031250006 },
        { lat: 39.215625, lng: 45.190625 },
        { lat: 39.25429687499999, lng: 45.14121093750006 },
        { lat: 39.311572265625045, lng: 45.11308593750002 },
        { lat: 39.362890625, lng: 45.071679687499994 },
        { lat: 39.42353515625001, lng: 45.00019531250004 },
        { lat: 39.62910156249998, lng: 44.838183593750074 },
        { lat: 39.65043945312496, lng: 44.81718750000002 },
        { lat: 39.684667968750006, lng: 44.7833984375001 },
        { lat: 39.70351562500005, lng: 44.76826171875004 },
        { lat: 39.71914062500002, lng: 44.86718750000003 },
        { lat: 39.76513671874997, lng: 45.03164062500005 },
        { lat: 39.742822265624966, lng: 45.07646484375002 },
        { lat: 39.69633789062499, lng: 45.12460937500006 },
        { lat: 39.65659179687498, lng: 45.14863281250003 },
        { lat: 39.58266601562502, lng: 45.15283203125003 },
      ],
      [
        { lat: 41.02724609374996, lng: 45.0236328125001 },
        { lat: 41.015820312499955, lng: 45.00205078125006 },
        { lat: 41.02724609374996, lng: 44.969042968750074 },
        { lat: 41.052636718749994, lng: 44.95888671875005 },
        { lat: 41.079248046874994, lng: 44.96142578125003 },
        { lat: 41.085595703124966, lng: 44.9943359375001 },
        { lat: 41.077978515625006, lng: 45.02109375 },
        { lat: 41.05385742187499, lng: 45.02871093750005 },
        { lat: 41.02724609374996, lng: 45.0236328125001 },
      ],
      [
        { lat: 41.812304687500045, lng: 46.552148437499994 },
        { lat: 41.800097656250045, lng: 46.571289062499964 },
        { lat: 41.80693359375001, lng: 46.616015625000074 },
        { lat: 41.83134765625002, lng: 46.690332031249994 },
        { lat: 41.812597656250006, lng: 46.74931640625002 },
        { lat: 41.74340820312503, lng: 46.82558593750005 },
        { lat: 41.67041015625, lng: 46.93085937500004 },
        { lat: 41.62138671874996, lng: 46.98779296875003 },
        { lat: 41.5875, lng: 47.01015625000005 },
        { lat: 41.55468750000006, lng: 47.06396484375003 },
        { lat: 41.51606445312501, lng: 47.14257812500003 },
        { lat: 41.45561523437501, lng: 47.2052734375001 },
        { lat: 41.315087890624994, lng: 47.26113281250005 },
        { lat: 41.28242187500001, lng: 47.31767578125002 },
        { lat: 41.22905273437496, lng: 47.52060546875006 },
        { lat: 41.21811523437506, lng: 47.59179687499997 },
        { lat: 41.19926757812502, lng: 47.79101562499997 },
        { lat: 41.212744140625034, lng: 47.86113281250007 },
        { lat: 41.33398437500003, lng: 47.96367187500007 },
        { lat: 41.45869140625004, lng: 48.05605468750005 },
        { lat: 41.48476562500002, lng: 48.14228515625004 },
        { lat: 41.545019531250034, lng: 48.29814453125002 },
        { lat: 41.60190429687498, lng: 48.39140625000007 },
        { lat: 41.66333007812497, lng: 48.43066406249997 },
        { lat: 41.77934570312499, lng: 48.51865234375006 },
        { lat: 41.84448242187503, lng: 48.572851562500006 },
        { lat: 41.78662109375006, lng: 48.66464843750006 },
        { lat: 41.62958984375004, lng: 48.8239257812501 },
        { lat: 41.37397460937501, lng: 49.050878906250055 },
        { lat: 41.30170898437504, lng: 49.10664062500004 },
        { lat: 41.21777343749997, lng: 49.14326171875004 },
        { lat: 41.116113281249966, lng: 49.17470703125005 },
        { lat: 41.02622070312503, lng: 49.22646484375005 },
        { lat: 40.79985351562502, lng: 49.45673828125004 },
        { lat: 40.71630859375005, lng: 49.55615234374997 },
        { lat: 40.60810546875004, lng: 49.71835937500006 },
        { lat: 40.583984375, lng: 49.775976562500055 },
        { lat: 40.577197265625045, lng: 49.85175781250004 },
        { lat: 40.57680664062505, lng: 49.990625 },
        { lat: 40.534521484375055, lng: 50.11914062499997 },
        { lat: 40.50478515625002, lng: 50.182519531250044 },
        { lat: 40.46176757812506, lng: 50.24804687499997 },
        { lat: 40.412207031250006, lng: 50.30683593750003 },
        { lat: 40.27949218749995, lng: 50.3659179687501 },
        { lat: 40.3232421875, lng: 50.1431640625 },
        { lat: 40.31640625000003, lng: 49.91884765625005 },
        { lat: 40.28789062499999, lng: 49.79199218749997 },
        { lat: 40.24902343749997, lng: 49.66904296875006 },
        { lat: 40.19414062499999, lng: 49.55117187499999 },
        { lat: 40.08725585937506, lng: 49.477343750000074 },
        { lat: 39.83984375, lng: 49.415136718750006 },
        { lat: 39.60834960937501, lng: 49.3244140625001 },
        { lat: 39.50122070312503, lng: 49.327539062499994 },
        { lat: 39.398388671874955, lng: 49.36738281250004 },
        { lat: 39.349560546874955, lng: 49.36279296875003 },
        { lat: 39.32890625000001, lng: 49.32119140625005 },
        { lat: 39.28515624999997, lng: 49.269335937500074 },
        { lat: 39.07265625000002, lng: 49.199804687500006 },
        { lat: 39.03027343750003, lng: 49.16533203125002 },
        { lat: 39.00390624999997, lng: 49.12099609375005 },
        { lat: 39.02905273437503, lng: 49.10869140625002 },
        { lat: 39.084716796875, lng: 49.11132812500003 },
        { lat: 39.13398437500001, lng: 49.013476562500074 },
        { lat: 39.07875976562502, lng: 48.96171875000002 },
        { lat: 38.961767578125006, lng: 48.92617187500005 },
        { lat: 38.83881835937501, lng: 48.85449218750003 },
        { lat: 38.81533203125002, lng: 48.850878906250074 },
        { lat: 38.43549804687498, lng: 48.86875 },
        { lat: 38.437255859375, lng: 48.84033203124997 },
        { lat: 38.39873046874996, lng: 48.63554687500007 },
        { lat: 38.41108398437498, lng: 48.59267578125005 },
        { lat: 38.58623046874995, lng: 48.41738281250005 },
        { lat: 38.605615234375016, lng: 48.38125 },
        { lat: 38.61347656250001, lng: 48.305566406249994 },
        { lat: 38.64228515625001, lng: 48.261328125000055 },
        { lat: 38.689208984375, lng: 48.22519531250006 },
        { lat: 38.72412109375, lng: 48.20468750000006 },
        { lat: 38.81904296874998, lng: 48.02324218750002 },
        { lat: 38.85375976562503, lng: 47.99648437499999 },
        { lat: 38.88427734375003, lng: 47.99267578125003 },
        { lat: 38.911816406249955, lng: 48.01933593750001 },
        { lat: 38.93500976562498, lng: 48.05009765625002 },
        { lat: 38.958642578124994, lng: 48.138574218749994 },
        { lat: 38.978955078124955, lng: 48.24199218750001 },
        { lat: 38.99360351562501, lng: 48.2750976562501 },
        { lat: 39.01884765624999, lng: 48.292089843750006 },
        { lat: 39.05927734374998, lng: 48.29101562499997 },
        { lat: 39.09912109375, lng: 48.2741210937501 },
        { lat: 39.17163085937503, lng: 48.125488281249964 },
        { lat: 39.20283203125001, lng: 48.10917968750007 },
        { lat: 39.241113281249994, lng: 48.10439453125005 },
        { lat: 39.28110351562503, lng: 48.112890625 },
        { lat: 39.312353515625006, lng: 48.13603515625002 },
        { lat: 39.35498046875, lng: 48.257226562499994 },
        { lat: 39.399072265625016, lng: 48.322167968749994 },
        { lat: 39.448339843750006, lng: 48.28173828125003 },
        { lat: 39.56054687500006, lng: 48.15107421875004 },
        { lat: 39.683935546875034, lng: 47.995898437500074 },
        { lat: 39.68505859374999, lng: 47.8922851562501 },
        { lat: 39.64858398437505, lng: 47.772851562499994 },
        { lat: 39.54335937499999, lng: 47.581835937500074 },
        { lat: 39.49833984374999, lng: 47.47617187500006 },
        { lat: 39.42387695312498, lng: 47.33847656250006 },
        { lat: 39.340966796874994, lng: 47.188378906250044 },
        { lat: 39.25288085937498, lng: 47.06542968750003 },
        { lat: 39.18017578125, lng: 46.98886718750006 },
        { lat: 39.14843750000003, lng: 46.85253906250003 },
        { lat: 39.08740234375003, lng: 46.78320312500003 },
        { lat: 38.904394531250034, lng: 46.554785156250006 },
        { lat: 38.90668945312498, lng: 46.490625 },
        { lat: 38.997460937499994, lng: 46.48671875 },
        { lat: 39.069433593750006, lng: 46.48984375 },
        { lat: 39.11088867187502, lng: 46.47539062500001 },
        { lat: 39.16767578125003, lng: 46.40146484375006 },
        { lat: 39.1921875, lng: 46.400292968749994 },
        { lat: 39.207373046875034, lng: 46.42031250000005 },
        { lat: 39.19819335937504, lng: 46.477148437500006 },
        { lat: 39.20141601562497, lng: 46.55 },
        { lat: 39.22368164062499, lng: 46.584765625000074 },
        { lat: 39.298535156249955, lng: 46.506640625000074 },
        { lat: 39.34853515625002, lng: 46.43730468750007 },
        { lat: 39.382275390624955, lng: 46.37841796874997 },
        { lat: 39.402490234374994, lng: 46.36523437500003 },
        { lat: 39.41679687499999, lng: 46.365136718749994 },
        { lat: 39.43388671874999, lng: 46.3776367187501 },
        { lat: 39.47509765625006, lng: 46.478125 },
        { lat: 39.512841796874994, lng: 46.48808593750001 },
        { lat: 39.55517578125002, lng: 46.481445312499964 },
        { lat: 39.617431640625, lng: 46.32167968750005 },
        { lat: 39.59448242187503, lng: 46.202050781249994 },
        { lat: 39.66445312499999, lng: 46.09482421875 },
        { lat: 39.71855468749999, lng: 46.025878906249964 },
        { lat: 39.77656250000001, lng: 45.939941406249964 },
        { lat: 39.80834960937499, lng: 45.863183593749994 },
        { lat: 39.881103515624964, lng: 45.7896484375 },
        { lat: 39.956201171874994, lng: 45.6618164062501 },
        { lat: 39.9775390625, lng: 45.57978515625004 },
        { lat: 39.98901367187503, lng: 45.58095703125005 },
        { lat: 40.00283203124999, lng: 45.595996093750074 },
        { lat: 40.01420898437501, lng: 45.63017578125002 },
        { lat: 40.011279296875045, lng: 45.8581054687501 },
        { lat: 40.024853515624955, lng: 45.8859375000001 },
        { lat: 40.05708007812504, lng: 45.90009765625004 },
        { lat: 40.104687499999955, lng: 45.93125 },
        { lat: 40.17480468750003, lng: 45.96757812500002 },
        { lat: 40.23378906249996, lng: 45.96464843750002 },
        { lat: 40.32910156250003, lng: 45.73574218750005 },
        { lat: 40.416845703125055, lng: 45.5695312500001 },
        { lat: 40.532373046874966, lng: 45.45439453125002 },
        { lat: 40.63808593750002, lng: 45.37617187500004 },
        { lat: 40.67358398437506, lng: 45.37890624999997 },
        { lat: 40.707128906250034, lng: 45.40136718749997 },
        { lat: 40.80449218749999, lng: 45.57939453125007 },
        { lat: 40.829736328124966, lng: 45.59140625 },
        { lat: 40.846923828125, lng: 45.5875 },
        { lat: 40.89672851562503, lng: 45.52402343750006 },
        { lat: 40.947998046875, lng: 45.444238281249994 },
        { lat: 40.98569335937503, lng: 45.41914062500004 },
        { lat: 41.00488281250003, lng: 45.36894531250002 },
        { lat: 41.00625, lng: 45.27343750000003 },
        { lat: 41.06933593750003, lng: 45.106054687500006 },
        { lat: 41.075585937499966, lng: 45.07050781250004 },
        { lat: 41.08813476562503, lng: 45.06259765625006 },
        { lat: 41.10083007812506, lng: 45.07070312499999 },
        { lat: 41.12636718750002, lng: 45.19023437500002 },
        { lat: 41.14741210937504, lng: 45.18857421875 },
        { lat: 41.175146484375006, lng: 45.15234375000003 },
        { lat: 41.195458984374966, lng: 45.08476562500002 },
        { lat: 41.24570312499998, lng: 45.02294921874997 },
        { lat: 41.29096679687498, lng: 45.001367187499994 },
        { lat: 41.423193359375006, lng: 45.2171875 },
        { lat: 41.449560546875034, lng: 45.28095703125004 },
        { lat: 41.42529296874997, lng: 45.42226562500005 },
        { lat: 41.33764648437497, lng: 45.715625 },
        { lat: 41.28901367187501, lng: 45.69570312500005 },
        { lat: 41.26162109375002, lng: 45.72548828124999 },
        { lat: 41.22441406249999, lng: 45.79277343750002 },
        { lat: 41.186718749999955, lng: 45.92197265625006 },
        { lat: 41.16728515624999, lng: 46.03125 },
        { lat: 41.183837890625, lng: 46.086523437500006 },
        { lat: 41.197851562500006, lng: 46.17070312500002 },
        { lat: 41.15444335937505, lng: 46.2799804687501 },
        { lat: 41.09931640625001, lng: 46.380761718749994 },
        { lat: 41.077050781249994, lng: 46.43095703125002 },
        { lat: 41.070214843750016, lng: 46.457910156249994 },
        { lat: 41.08857421875004, lng: 46.534375 },
        { lat: 41.15966796875006, lng: 46.626367187500044 },
        { lat: 41.24550781250002, lng: 46.66240234375002 },
        { lat: 41.286816406250004, lng: 46.67255859375004 },
        { lat: 41.34375, lng: 46.61894531250002 },
        { lat: 41.40556640624996, lng: 46.50878906249997 },
        { lat: 41.459863281249994, lng: 46.38496093750003 },
        { lat: 41.507714843749994, lng: 46.30546875000002 },
        { lat: 41.602148437500034, lng: 46.254687500000074 },
        { lat: 41.61259765625004, lng: 46.20351562500005 },
        { lat: 41.62485351562503, lng: 46.19052734375006 },
        { lat: 41.657080078125034, lng: 46.18212890625003 },
        { lat: 41.70214843749997, lng: 46.18427734375004 },
        { lat: 41.736865234375045, lng: 46.20185546875004 },
        { lat: 41.75175781249996, lng: 46.251855468750044 },
        { lat: 41.75708007812497, lng: 46.302539062500074 },
        { lat: 41.790185546874966, lng: 46.348242187500006 },
        { lat: 41.855078125000055, lng: 46.40546875000004 },
        { lat: 41.890966796875006, lng: 46.42988281250004 },
        { lat: 41.87041015624999, lng: 46.5376953125 },
        { lat: 41.812304687500045, lng: 46.552148437499994 },
      ],
      [
        { lat: 40.60698242187499, lng: 45.47880859375002 },
        { lat: 40.59956054687498, lng: 45.51435546875003 },
        { lat: 40.61606445312506, lng: 45.55234375000006 },
        { lat: 40.64916992187506, lng: 45.562304687500074 },
        { lat: 40.664013671874955, lng: 45.53417968750003 },
        { lat: 40.664843750000045, lng: 45.504492187500006 },
        { lat: 40.648339843749966, lng: 45.47880859375002 },
        { lat: 40.60698242187499, lng: 45.47880859375002 },
      ],
    ],
  },
  {
    code: "TR",
    coordinates: [
      [
        { lat: 40.136328125, lng: 25.970019531250045 },
        { lat: 40.10546875000003, lng: 25.740234375000057 },
        { lat: 40.13588867187502, lng: 25.668945312499996 },
        { lat: 40.19628906249997, lng: 25.74091796875001 },
        { lat: 40.23369140624996, lng: 25.874804687500014 },
        { lat: 40.23798828125004, lng: 25.91835937500002 },
        { lat: 40.177832031250034, lng: 25.977050781250053 },
        { lat: 40.136328125, lng: 25.970019531250045 },
      ],
      [
        { lat: 41.95698242187504, lng: 35.114062500000074 },
        { lat: 41.89111328125003, lng: 35.12207031250002 },
        { lat: 41.79438476562503, lng: 35.2091796875001 },
        { lat: 41.72851562500003, lng: 35.297753906249994 },
        { lat: 41.63403320312506, lng: 35.558007812499994 },
        { lat: 41.713720703125034, lng: 35.919824218749994 },
        { lat: 41.704833984375, lng: 35.978125 },
        { lat: 41.68256835937498, lng: 36.05175781249997 },
        { lat: 41.4265625, lng: 36.17919921875003 },
        { lat: 41.336132812500004, lng: 36.27841796875006 },
        { lat: 41.27460937500001, lng: 36.40537109375006 },
        { lat: 41.2625, lng: 36.509667968749994 },
        { lat: 41.32666015625006, lng: 36.58710937500004 },
        { lat: 41.3525390625, lng: 36.647070312500006 },
        { lat: 41.36347656250001, lng: 36.77773437499999 },
        { lat: 41.275390625, lng: 36.99199218750002 },
        { lat: 41.18442382812503, lng: 37.066210937500074 },
        { lat: 41.114111328125006, lng: 37.43095703125002 },
        { lat: 41.07890625000002, lng: 37.765625 },
        { lat: 41.001904296874955, lng: 37.910058593749994 },
        { lat: 40.92451171875001, lng: 38.38105468750004 },
        { lat: 40.93652343749997, lng: 38.55693359375001 },
        { lat: 41.01767578124998, lng: 38.8521484375 },
        { lat: 41.10644531250003, lng: 39.426367187500006 },
        { lat: 40.982519531250006, lng: 39.80791015625002 },
        { lat: 40.96645507812502, lng: 39.91113281250003 },
        { lat: 40.97714843749998, lng: 40.00019531250004 },
        { lat: 40.94301757812505, lng: 40.12841796874997 },
        { lat: 40.96132812500005, lng: 40.26523437500006 },
        { lat: 41.10742187499997, lng: 40.6875 },
        { lat: 41.19023437499996, lng: 40.8195312500001 },
        { lat: 41.211621093749976, lng: 40.95947265624997 },
        { lat: 41.26118164062504, lng: 41.08359375000006 },
        { lat: 41.42363281249999, lng: 41.41435546875002 },
        { lat: 41.51748046875002, lng: 41.510058593750074 },
        { lat: 41.497314453125, lng: 41.57656250000005 },
        { lat: 41.471582031249994, lng: 41.70175781250006 },
        { lat: 41.44052734374998, lng: 41.77939453125006 },
        { lat: 41.432373046875, lng: 41.823535156250074 },
        { lat: 41.49565429687502, lng: 41.92578125000003 },
        { lat: 41.494091796874955, lng: 42.077734375 },
        { lat: 41.486718749999966, lng: 42.21113281250009 },
        { lat: 41.475, lng: 42.27998046875004 },
        { lat: 41.454003906249966, lng: 42.364355468750006 },
        { lat: 41.43984375000002, lng: 42.46640625 },
        { lat: 41.470068359375034, lng: 42.50791015625006 },
        { lat: 41.55927734375001, lng: 42.56738281249997 },
        { lat: 41.57070312500002, lng: 42.5904296875 },
        { lat: 41.57880859374998, lng: 42.60683593750005 },
        { lat: 41.58574218749999, lng: 42.682421875000074 },
        { lat: 41.57890625000002, lng: 42.75410156250003 },
        { lat: 41.56372070312503, lng: 42.787890625000074 },
        { lat: 41.49238281249998, lng: 42.82167968750005 },
        { lat: 41.46684570312502, lng: 42.90673828125003 },
        { lat: 41.35283203124996, lng: 43.05712890625003 },
        { lat: 41.30712890624997, lng: 43.149023437500006 },
        { lat: 41.28793945312498, lng: 43.171289062499994 },
        { lat: 41.264843749999976, lng: 43.14101562499999 },
        { lat: 41.23642578125006, lng: 43.15283203124997 },
        { lat: 41.19916992187501, lng: 43.20546875000005 },
        { lat: 41.185205078124994, lng: 43.27929687499997 },
        { lat: 41.19013671875004, lng: 43.35898437500006 },
        { lat: 41.17656250000001, lng: 43.40234375000002 },
        { lat: 41.155517578125, lng: 43.43339843750002 },
        { lat: 41.12597656250003, lng: 43.44160156250004 },
        { lat: 41.107128906250004, lng: 43.43945312500003 },
        { lat: 41.06469726562497, lng: 43.45527343750003 },
        { lat: 41.00483398437504, lng: 43.51748046875005 },
        { lat: 40.96821289062504, lng: 43.591699218750044 },
        { lat: 40.929003906250045, lng: 43.63164062500002 },
        { lat: 40.79414062500001, lng: 43.6964843750001 },
        { lat: 40.71953124999999, lng: 43.722656249999964 },
        { lat: 40.64775390625002, lng: 43.71289062499997 },
        { lat: 40.574072265625034, lng: 43.667871093749994 },
        { lat: 40.48237304687498, lng: 43.56933593750003 },
        { lat: 40.444042968750004, lng: 43.59375 },
        { lat: 40.39331054687497, lng: 43.615820312500006 },
        { lat: 40.35659179687505, lng: 43.60839843749997 },
        { lat: 40.239306640625045, lng: 43.678125 },
        { lat: 40.16650390625002, lng: 43.70986328125005 },
        { lat: 40.14965820312497, lng: 43.68330078125004 },
        { lat: 40.12636718750002, lng: 43.66621093750004 },
        { lat: 40.07026367187498, lng: 43.79169921875004 },
        { lat: 40.023144531249955, lng: 43.9419921875 },
        { lat: 40.01411132812498, lng: 44.00537109375003 },
        { lat: 40.035742187500034, lng: 44.17802734375002 },
        { lat: 40.040380859375006, lng: 44.28925781250003 },
        { lat: 39.995751953124966, lng: 44.39960937500004 },
        { lat: 39.887597656249966, lng: 44.56044921875005 },
        { lat: 39.74648437499999, lng: 44.733789062499994 },
        { lat: 39.70351562500005, lng: 44.76826171875004 },
        { lat: 39.684667968750006, lng: 44.7833984375001 },
        { lat: 39.65043945312496, lng: 44.81718750000002 },
        { lat: 39.65107421875001, lng: 44.782128906249994 },
        { lat: 39.681738281250034, lng: 44.725 },
        { lat: 39.76855468750006, lng: 44.58710937500004 },
        { lat: 39.73125, lng: 44.51669921875 },
        { lat: 39.666748046875, lng: 44.455957031249994 },
        { lat: 39.422119140625, lng: 44.3893554687501 },
        { lat: 39.39604492187502, lng: 44.33544921874997 },
        { lat: 39.39677734374998, lng: 44.24042968750004 },
        { lat: 39.40522460937501, lng: 44.12402343749997 },
        { lat: 39.39296875000002, lng: 44.04394531249997 },
        { lat: 39.37744140625005, lng: 44.02324218750002 },
        { lat: 39.35102539062498, lng: 44.03378906250006 },
        { lat: 39.31083984374999, lng: 44.05751953124999 },
        { lat: 39.25996093750001, lng: 44.07431640625006 },
        { lat: 39.218310546875045, lng: 44.07910156249997 },
        { lat: 39.18061523437501, lng: 44.12128906250004 },
        { lat: 39.14482421874998, lng: 44.17802734375002 },
        { lat: 39.10805664062496, lng: 44.180566406249994 },
        { lat: 39.05625, lng: 44.171875 },
        { lat: 39.01674804687502, lng: 44.158789062500006 },
        { lat: 38.994384765625, lng: 44.14453124999997 },
        { lat: 38.934375, lng: 44.170800781249994 },
        { lat: 38.86323242187501, lng: 44.23242187500003 },
        { lat: 38.83603515625006, lng: 44.27167968750004 },
        { lat: 38.70063476562501, lng: 44.25703125000004 },
        { lat: 38.64067382812496, lng: 44.28017578124999 },
        { lat: 38.557812499999955, lng: 44.29785156250003 },
        { lat: 38.420117187499955, lng: 44.29082031250002 },
        { lat: 38.38627929687499, lng: 44.2985351562501 },
        { lat: 38.374707031249955, lng: 44.31962890625002 },
        { lat: 38.36958007812498, lng: 44.37578125000001 },
        { lat: 38.356787109375034, lng: 44.43085937500004 },
        { lat: 38.33422851562506, lng: 44.44990234375009 },
        { lat: 38.317773437499994, lng: 44.44960937500005 },
        { lat: 38.25458984374998, lng: 44.38085937499997 },
        { lat: 38.209716796875, lng: 44.37275390625009 },
        { lat: 38.146484375, lng: 44.34892578125002 },
        { lat: 38.109277343749966, lng: 44.329394531250074 },
        { lat: 38.038818359375, lng: 44.26796875 },
        { lat: 37.96718749999996, lng: 44.22890625 },
        { lat: 37.908056640625006, lng: 44.21132812499999 },
        { lat: 37.88017578125002, lng: 44.22294921875002 },
        { lat: 37.87177734374998, lng: 44.33623046875002 },
        { lat: 37.82924804687502, lng: 44.39775390625002 },
        { lat: 37.74462890625003, lng: 44.56123046875004 },
        { lat: 37.71035156249996, lng: 44.58994140625 },
        { lat: 37.65815429687498, lng: 44.5453125 },
        { lat: 37.63632812499998, lng: 44.54609375000003 },
        { lat: 37.60864257812503, lng: 44.56718750000002 },
        { lat: 37.560205078125016, lng: 44.57714843749997 },
        { lat: 37.50639648437499, lng: 44.573144531249994 },
        { lat: 37.435400390625, lng: 44.574023437500074 },
        { lat: 37.42373046875002, lng: 44.60410156250006 },
        { lat: 37.35712890625004, lng: 44.71513671875001 },
        { lat: 37.29038085937503, lng: 44.79414062500003 },
        { lat: 37.26977539062499, lng: 44.79677734375005 },
        { lat: 37.21708984375002, lng: 44.75830078125003 },
        { lat: 37.15634765624998, lng: 44.76669921875006 },
        { lat: 37.142431640625006, lng: 44.76513671875003 },
        { lat: 37.16528320312502, lng: 44.73095703124997 },
        { lat: 37.17358398437503, lng: 44.66933593750005 },
        { lat: 37.17602539062499, lng: 44.605957031249964 },
        { lat: 37.15825195312502, lng: 44.566015625 },
        { lat: 37.11054687499998, lng: 44.495996093749994 },
        { lat: 37.058496093750016, lng: 44.401953125 },
        { lat: 37.0107421875, lng: 44.325585937499994 },
        { lat: 36.97802734374997, lng: 44.28183593750006 },
        { lat: 36.983300781249994, lng: 44.245703125000055 },
        { lat: 37.01186523437505, lng: 44.2174804687501 },
        { lat: 37.05180664062502, lng: 44.20166015624997 },
        { lat: 37.20263671875, lng: 44.208398437499994 },
        { lat: 37.24985351562503, lng: 44.19179687499999 },
        { lat: 37.28295898437502, lng: 44.15625 },
        { lat: 37.30185546875006, lng: 44.11445312500004 },
        { lat: 37.31245117187498, lng: 44.06464843750004 },
        { lat: 37.313525390625045, lng: 44.01318359375003 },
        { lat: 37.269287109375, lng: 43.94003906250006 },
        { lat: 37.223535156249994, lng: 43.83642578124997 },
        { lat: 37.227246093749955, lng: 43.67578125000002 },
        { lat: 37.23583984375003, lng: 43.56796875 },
        { lat: 37.244531250000016, lng: 43.51582031250004 },
        { lat: 37.31464843749998, lng: 43.30673828125 },
        { lat: 37.316503906250006, lng: 43.263085937499994 },
        { lat: 37.34487304687502, lng: 43.18515625 },
        { lat: 37.36738281249998, lng: 43.09248046875004 },
        { lat: 37.32475585937502, lng: 42.936621093750006 },
        { lat: 37.33491210937504, lng: 42.86914062500003 },
        { lat: 37.371875, lng: 42.77460937500004 },
        { lat: 37.36191406250003, lng: 42.74111328125005 },
        { lat: 37.249267578125, lng: 42.6354492187501 },
        { lat: 37.128710937500045, lng: 42.45585937500002 },
        { lat: 37.10859375000004, lng: 42.358984375 },
        { lat: 37.22958984374998, lng: 42.31289062499999 },
        { lat: 37.27656249999995, lng: 42.268554687499964 },
        { lat: 37.28222656250006, lng: 42.24755859375003 },
        { lat: 37.29726562499999, lng: 42.20273437500006 },
        { lat: 37.28862304687502, lng: 42.16787109375005 },
        { lat: 37.2060546875, lng: 42.05986328125007 },
        { lat: 37.156396484374994, lng: 41.88681640625 },
        { lat: 37.12612304687505, lng: 41.74355468750005 },
        { lat: 37.08916015624999, lng: 41.51552734375005 },
        { lat: 37.07080078125006, lng: 41.33955078125004 },
        { lat: 37.06933593750003, lng: 41.26464843749997 },
        { lat: 37.085888671875004, lng: 41.1021484375 },
        { lat: 37.10917968749996, lng: 40.95888671875005 },
        { lat: 37.10815429687503, lng: 40.815625 },
        { lat: 37.09770507812502, lng: 40.70566406250006 },
        { lat: 37.00888671875006, lng: 40.4503906250001 },
        { lat: 36.82607421875002, lng: 40.016406250000074 },
        { lat: 36.73862304687506, lng: 39.68652343749997 },
        { lat: 36.702246093750034, lng: 39.50146484374997 },
        { lat: 36.681591796874976, lng: 39.35664062500004 },
        { lat: 36.68056640625005, lng: 39.10839843749997 },
        { lat: 36.69467773437498, lng: 38.90644531250004 },
        { lat: 36.69311523437503, lng: 38.76660156249997 },
        { lat: 36.71508789062497, lng: 38.68886718750005 },
        { lat: 36.789111328125045, lng: 38.57802734375005 },
        { lat: 36.86225585937501, lng: 38.44375 },
        { lat: 36.879248046875034, lng: 38.38398437500004 },
        { lat: 36.89335937499996, lng: 38.30585937500009 },
        { lat: 36.90156250000004, lng: 38.19169921875002 },
        { lat: 36.79462890625001, lng: 37.90664062500005 },
        { lat: 36.765576171874955, lng: 37.81796875 },
        { lat: 36.74370117187502, lng: 37.7203125 },
        { lat: 36.678320312500034, lng: 37.52353515625006 },
        { lat: 36.64331054687499, lng: 37.436328125000074 },
        { lat: 36.64658203125006, lng: 37.327050781249994 },
        { lat: 36.655908203124994, lng: 37.18740234375005 },
        { lat: 36.652636718750045, lng: 37.066210937500074 },
        { lat: 36.70239257812506, lng: 36.98535156250003 },
        { lat: 36.758398437500006, lng: 36.94179687499999 },
        { lat: 36.79267578124998, lng: 36.77656250000004 },
        { lat: 36.80253906250002, lng: 36.65859375000005 },
        { lat: 36.777685546875034, lng: 36.62841796875003 },
        { lat: 36.70136718750001, lng: 36.596875 },
        { lat: 36.50634765625, lng: 36.546679687500074 },
        { lat: 36.45742187499996, lng: 36.5375 },
        { lat: 36.263525390625, lng: 36.64140625000002 },
        { lat: 36.233984375, lng: 36.63671874999997 },
        { lat: 36.22392578125002, lng: 36.562402343749994 },
        { lat: 36.220703124999964, lng: 36.47705078125003 },
        { lat: 36.203466796875006, lng: 36.42148437500006 },
        { lat: 36.171240234375034, lng: 36.37539062499999 },
        { lat: 36.003515625000034, lng: 36.347558593749994 },
        { lat: 35.97270507812499, lng: 36.248828125000074 },
        { lat: 35.93754882812502, lng: 36.20195312500002 },
        { lat: 35.83388671875005, lng: 36.15361328125002 },
        { lat: 35.831445312499994, lng: 36.12734375 },
        { lat: 35.91005859375002, lng: 35.96757812500007 },
        { lat: 35.91655273437502, lng: 35.89267578125006 },
        { lat: 35.998144531250006, lng: 35.95693359374999 },
        { lat: 36.15908203125002, lng: 35.88710937499999 },
        { lat: 36.30986328125002, lng: 35.81093750000005 },
        { lat: 36.406347656250034, lng: 35.88281250000003 },
        { lat: 36.52270507812503, lng: 36.03173828124997 },
        { lat: 36.65898437499999, lng: 36.18847656250003 },
        { lat: 36.743066406249994, lng: 36.18818359375004 },
        { lat: 36.807226562500006, lng: 36.18007812499999 },
        { lat: 36.85161132812499, lng: 36.13515625 },
        { lat: 36.91059570312501, lng: 36.04892578125 },
        { lat: 36.84760742187498, lng: 35.90458984375002 },
        { lat: 36.77807617187502, lng: 35.801562500000074 },
        { lat: 36.76396484374999, lng: 35.73427734375005 },
        { lat: 36.72431640624998, lng: 35.66113281249997 },
        { lat: 36.65278320312498, lng: 35.625585937500006 },
        { lat: 36.59702148437497, lng: 35.53740234375007 },
        { lat: 36.57519531249997, lng: 35.393164062500006 },
        { lat: 36.634863281250055, lng: 35.17617187500005 },
        { lat: 36.725683593750006, lng: 34.943164062500074 },
        { lat: 36.799267578124976, lng: 34.81123046875004 },
        { lat: 36.81679687499999, lng: 34.70361328125003 },
        { lat: 36.78447265624999, lng: 34.601367187500074 },
        { lat: 36.60419921875004, lng: 34.29960937500007 },
        { lat: 36.34077148437501, lng: 34.02343750000003 },
        { lat: 36.29521484374996, lng: 33.95488281250002 },
        { lat: 36.18198242187498, lng: 33.694726562499994 },
        { lat: 36.14399414062498, lng: 33.522753906250074 },
        { lat: 36.15283203124999, lng: 33.44179687499999 },
        { lat: 36.10297851562498, lng: 33.099511718749994 },
        { lat: 36.095703125, lng: 32.92949218750002 },
        { lat: 36.03588867187497, lng: 32.794824218749994 },
        { lat: 36.10073242187505, lng: 32.533789062500006 },
        { lat: 36.18364257812495, lng: 32.37773437500002 },
        { lat: 36.26787109374999, lng: 32.283789062500006 },
        { lat: 36.449121093749966, lng: 32.13056640625004 },
        { lat: 36.53530273437502, lng: 32.02197265625003 },
        { lat: 36.61279296875, lng: 31.77792968750006 },
        { lat: 36.80107421874998, lng: 31.352539062499968 },
        { lat: 36.82172851562504, lng: 31.240625 },
        { lat: 36.84868164062502, lng: 30.950292968750002 },
        { lat: 36.865673828125004, lng: 30.64404296874997 },
        { lat: 36.79716796874999, lng: 30.58203124999997 },
        { lat: 36.525830078124955, lng: 30.55849609375005 },
        { lat: 36.45112304687501, lng: 30.506054687500097 },
        { lat: 36.310400390625034, lng: 30.483593750000043 },
        { lat: 36.269873046875034, lng: 30.44609375000007 },
        { lat: 36.24326171875003, lng: 30.38730468750006 },
        { lat: 36.287695312500034, lng: 30.295410156250025 },
        { lat: 36.30732421875004, lng: 30.23164062500004 },
        { lat: 36.249365234375034, lng: 30.08320312500004 },
        { lat: 36.168066406250006, lng: 29.789257812500097 },
        { lat: 36.15668945312498, lng: 29.6890625 },
        { lat: 36.25883789062502, lng: 29.348339843750043 },
        { lat: 36.32446289062497, lng: 29.223632812499968 },
        { lat: 36.39721679687506, lng: 29.143261718750008 },
        { lat: 36.520117187500034, lng: 29.116113281250076 },
        { lat: 36.59008789062499, lng: 29.065527343750006 },
        { lat: 36.63813476562501, lng: 29.05810546875 },
        { lat: 36.693457031250006, lng: 29.038281250000043 },
        { lat: 36.71533203125002, lng: 28.96962890625008 },
        { lat: 36.67358398437505, lng: 28.895898437500076 },
        { lat: 36.67529296875003, lng: 28.816894531250053 },
        { lat: 36.70087890625001, lng: 28.717675781249994 },
        { lat: 36.803808593750006, lng: 28.48359375000001 },
        { lat: 36.811962890624976, lng: 28.303710937500053 },
        { lat: 36.68632812499999, lng: 28.195605468750045 },
        { lat: 36.64638671875002, lng: 28.111523437500068 },
        { lat: 36.63447265624998, lng: 28.01943359375005 },
        { lat: 36.67021484374999, lng: 28.01416015625003 },
        { lat: 36.75146484374999, lng: 28.083984375000057 },
        { lat: 36.73647460937496, lng: 27.803808593749974 },
        { lat: 36.67460937499998, lng: 27.655859375000034 },
        { lat: 36.684228515624994, lng: 27.54042968750008 },
        { lat: 36.712158203125, lng: 27.453906250000017 },
        { lat: 36.74633789062502, lng: 27.466894531250006 },
        { lat: 36.75888671875, lng: 27.55468750000003 },
        { lat: 36.78666992187499, lng: 27.63085937500003 },
        { lat: 36.80927734374998, lng: 27.93447265625005 },
        { lat: 36.83198242187498, lng: 28.00537109375003 },
        { lat: 36.920263671875034, lng: 28.08300781250003 },
        { lat: 36.99638671874999, lng: 28.224414062500045 },
        { lat: 37.029052734375, lng: 28.242382812500068 },
        { lat: 37.02949218749998, lng: 28.133691406250048 },
        { lat: 37.007421875000034, lng: 27.668359375000023 },
        { lat: 37.01958007812502, lng: 27.348925781250045 },
        { lat: 36.98188476562498, lng: 27.311035156250057 },
        { lat: 36.97656250000003, lng: 27.262988281250045 },
        { lat: 37.07915039062499, lng: 27.249707031249983 },
        { lat: 37.126855468750016, lng: 27.30019531250005 },
        { lat: 37.122412109375006, lng: 27.368164062500057 },
        { lat: 37.16386718750002, lng: 27.535058593750048 },
        { lat: 37.24912109375006, lng: 27.520117187500006 },
        { lat: 37.30673828124998, lng: 27.400585937500008 },
        { lat: 37.34072265624996, lng: 27.376269531250017 },
        { lat: 37.34868164062499, lng: 27.28955078125003 },
        { lat: 37.38916015625, lng: 27.219238281249996 },
        { lat: 37.49140625000004, lng: 27.203906250000074 },
        { lat: 37.60361328124998, lng: 27.147949218750057 },
        { lat: 37.65791015625003, lng: 27.06796875 },
        { lat: 37.687695312499955, lng: 27.077832031250065 },
        { lat: 37.725439453125006, lng: 27.22441406250007 },
        { lat: 37.88232421875, lng: 27.254785156250048 },
        { lat: 37.978662109374994, lng: 27.232421875000025 },
        { lat: 37.98686523437499, lng: 27.15869140625 },
        { lat: 38.06289062500002, lng: 26.94384765625003 },
        { lat: 38.054785156250055, lng: 26.878613281250068 },
        { lat: 38.13833007812502, lng: 26.807421875000045 },
        { lat: 38.198339843750006, lng: 26.68281250000004 },
        { lat: 38.176367187500034, lng: 26.62109375 },
        { lat: 38.149267578125034, lng: 26.582421875000023 },
        { lat: 38.16225585937502, lng: 26.524707031250074 },
        { lat: 38.21435546874997, lng: 26.427929687499983 },
        { lat: 38.24248046875002, lng: 26.33291015625008 },
        { lat: 38.27719726562498, lng: 26.290722656250008 },
        { lat: 38.37006835937498, lng: 26.34365234375005 },
        { lat: 38.36787109374998, lng: 26.41640625000005 },
        { lat: 38.440625, lng: 26.4296875 },
        { lat: 38.561914062499994, lng: 26.37226562500001 },
        { lat: 38.624169921874966, lng: 26.37783203124999 },
        { lat: 38.64121093749998, lng: 26.44130859375005 },
        { lat: 38.62949218749998, lng: 26.513574218750023 },
        { lat: 38.557031249999966, lng: 26.586523437500063 },
        { lat: 38.48691406249998, lng: 26.61035156250003 },
        { lat: 38.41860351562502, lng: 26.595019531250017 },
        { lat: 38.35244140625002, lng: 26.64130859375004 },
        { lat: 38.33574218750002, lng: 26.67421875000008 },
        { lat: 38.40537109374998, lng: 26.69638671875006 },
        { lat: 38.41860351562502, lng: 26.727343750000074 },
        { lat: 38.38818359375003, lng: 26.769921875000023 },
        { lat: 38.37294921875005, lng: 26.861425781250034 },
        { lat: 38.415722656249955, lng: 27.09863281250003 },
        { lat: 38.45195312499995, lng: 27.144238281250008 },
        { lat: 38.447851562500034, lng: 26.97041015625001 },
        { lat: 38.48173828124998, lng: 26.906835937500034 },
        { lat: 38.55756835937498, lng: 26.83779296874999 },
        { lat: 38.62641601562498, lng: 26.795312500000048 },
        { lat: 38.66020507812501, lng: 26.787695312500006 },
        { lat: 38.709619140624966, lng: 26.763671875 },
        { lat: 38.73608398437503, lng: 26.790136718750063 },
        { lat: 38.77578125000005, lng: 26.909179687499968 },
        { lat: 38.88686523437502, lng: 27.013671875000057 },
        { lat: 38.919042968750006, lng: 26.97011718750005 },
        { lat: 38.934228515624994, lng: 26.920312500000023 },
        { lat: 38.92294921875, lng: 26.86621093750003 },
        { lat: 38.96098632812502, lng: 26.814941406250057 },
        { lat: 39.01391601562497, lng: 26.808300781250036 },
        { lat: 39.05673828124998, lng: 26.84931640625004 },
        { lat: 39.115625, lng: 26.853613281250034 },
        { lat: 39.26064453124996, lng: 26.719335937500034 },
        { lat: 39.292236328125, lng: 26.68183593750004 },
        { lat: 39.33964843749999, lng: 26.710742187500042 },
        { lat: 39.41904296875, lng: 26.813281250000074 },
        { lat: 39.51733398437503, lng: 26.910937500000074 },
        { lat: 39.549658203125034, lng: 26.89921874999999 },
        { lat: 39.56289062499999, lng: 26.82705078125005 },
        { lat: 39.52070312500001, lng: 26.484082031250068 },
        { lat: 39.48408203125001, lng: 26.35078125 },
        { lat: 39.46738281249998, lng: 26.113085937500074 },
        { lat: 39.52080078125002, lng: 26.095996093750045 },
        { lat: 39.56894531249998, lng: 26.101367187500074 },
        { lat: 39.65664062499999, lng: 26.154687500000023 },
        { lat: 39.87285156249999, lng: 26.14980468750008 },
        { lat: 39.99008789062498, lng: 26.18134765625004 },
        { lat: 40.025, lng: 26.313378906250023 },
        { lat: 40.197265625, lng: 26.475390625000074 },
        { lat: 40.40024414062506, lng: 26.738085937500045 },
        { lat: 40.39633789062506, lng: 27.01210937500008 },
        { lat: 40.45234375000001, lng: 27.12167968750003 },
        { lat: 40.45561523437496, lng: 27.28457031250008 },
        { lat: 40.414892578125006, lng: 27.314160156250068 },
        { lat: 40.37592773437498, lng: 27.332617187500006 },
        { lat: 40.319921875000034, lng: 27.4755859375 },
        { lat: 40.32880859374998, lng: 27.728027343749996 },
        { lat: 40.35087890625002, lng: 27.789355468750074 },
        { lat: 40.381738281250016, lng: 27.84853515625005 },
        { lat: 40.48149414062499, lng: 27.731835937500076 },
        { lat: 40.509619140625034, lng: 27.769140625000034 },
        { lat: 40.512939453125, lng: 27.87490234375008 },
        { lat: 40.48945312500001, lng: 27.989550781250074 },
        { lat: 40.46660156249999, lng: 27.99482421875001 },
        { lat: 40.435302734375, lng: 27.96435546875 },
        { lat: 40.38041992187502, lng: 27.928906250000065 },
        { lat: 40.369873046875, lng: 27.96259765625001 },
        { lat: 40.40302734374998, lng: 28.2890625 },
        { lat: 40.37646484375, lng: 28.63027343750005 },
        { lat: 40.390869140625, lng: 28.738867187500063 },
        { lat: 40.389746093750034, lng: 29.007128906249985 },
        { lat: 40.424169921875034, lng: 29.055175781250025 },
        { lat: 40.46738281250006, lng: 28.97402343749999 },
        { lat: 40.482421875, lng: 28.894628906250006 },
        { lat: 40.50346679687502, lng: 28.84121093750005 },
        { lat: 40.53403320312503, lng: 28.787890625000017 },
        { lat: 40.63056640624998, lng: 28.958007812500025 },
        { lat: 40.64912109375004, lng: 29.054101562500076 },
        { lat: 40.70839843750002, lng: 29.507617187500017 },
        { lat: 40.73808593750004, lng: 29.844921875000036 },
        { lat: 40.760107421875006, lng: 29.84921875000006 },
        { lat: 40.760156250000016, lng: 29.800585937500017 },
        { lat: 40.80927734374998, lng: 29.36474609375003 },
        { lat: 40.847314453124994, lng: 29.25976562499997 },
        { lat: 40.93784179687506, lng: 29.113867187499977 },
        { lat: 40.963427734375045, lng: 29.082226562500008 },
        { lat: 41.00756835937506, lng: 29.045507812500002 },
        { lat: 41.101660156250034, lng: 29.06738281250003 },
        { lat: 41.17724609374997, lng: 29.094335937500006 },
        { lat: 41.221044921875034, lng: 29.14814453125004 },
        { lat: 41.227734374999955, lng: 29.322265624999968 },
        { lat: 41.150830078125004, lng: 29.919335937500048 },
        { lat: 41.196923828124994, lng: 30.34492187500004 },
        { lat: 41.08486328124999, lng: 30.81005859374997 },
        { lat: 41.10761718750001, lng: 31.254882812499968 },
        { lat: 41.15791015624995, lng: 31.34667968750003 },
        { lat: 41.32001953125004, lng: 31.45800781249997 },
        { lat: 41.58920898437498, lng: 32.08642578125003 },
        { lat: 41.72958984374998, lng: 32.30644531250007 },
        { lat: 41.806396484375, lng: 32.54218750000004 },
        { lat: 41.891748046874966, lng: 32.94667968750005 },
        { lat: 42.004589843749955, lng: 33.284765625 },
        { lat: 42.01757812500003, lng: 33.38134765625003 },
        { lat: 41.96367187499996, lng: 34.19296875 },
        { lat: 41.95683593749998, lng: 34.75048828124997 },
        { lat: 42.06328125000002, lng: 35.006445312500006 },
        { lat: 42.02753906250001, lng: 35.15488281250006 },
        { lat: 41.989501953125, lng: 35.14101562500005 },
        { lat: 41.95698242187504, lng: 35.114062500000074 },
      ],
      [
        { lat: 42.02504882812505, lng: 27.362890625000034 },
        { lat: 41.946875, lng: 27.47480468750001 },
        { lat: 41.92080078125002, lng: 27.53486328125001 },
        { lat: 41.93291015625002, lng: 27.579882812500017 },
        { lat: 41.96132812500002, lng: 27.661132812500057 },
        { lat: 41.96152343749998, lng: 27.738867187500006 },
        { lat: 41.95654296875003, lng: 27.80166015625008 },
        { lat: 41.981298828125006, lng: 27.831933593750023 },
        { lat: 41.98662109375001, lng: 27.879199218750074 },
        { lat: 41.96904296874999, lng: 28.014453125000017 },
        { lat: 41.854882812500016, lng: 27.98730468749997 },
        { lat: 41.729150390624966, lng: 28.05029296875003 },
        { lat: 41.55449218750002, lng: 28.19785156250006 },
        { lat: 41.46635742187499, lng: 28.34638671875004 },
        { lat: 41.248388671875, lng: 28.94677734375006 },
        { lat: 41.22973632812503, lng: 29.057226562500002 },
        { lat: 41.140478515625034, lng: 29.032128906250023 },
        { lat: 41.06113281250003, lng: 28.99599609375005 },
        { lat: 41.00820312499999, lng: 28.95625 },
        { lat: 40.97416992187498, lng: 28.78037109374998 },
        { lat: 41.07148437500001, lng: 28.294921875000025 },
        { lat: 41.08071289062502, lng: 28.172167968750074 },
        { lat: 41.06132812499999, lng: 28.085546875 },
        { lat: 40.99057617187506, lng: 27.925195312500023 },
        { lat: 41.01328124999998, lng: 27.747363281250045 },
        { lat: 40.97314453124997, lng: 27.49941406250005 },
        { lat: 40.839941406250006, lng: 27.43017578125 },
        { lat: 40.687353515625006, lng: 27.258007812499983 },
        { lat: 40.56401367187502, lng: 26.974609375 },
        { lat: 40.498046875, lng: 26.772070312500034 },
        { lat: 40.26147460937503, lng: 26.467968750000068 },
        { lat: 40.123388671875034, lng: 26.329980468750023 },
        { lat: 40.096582031249994, lng: 26.271777343750074 },
        { lat: 40.07539062500004, lng: 26.202734375000034 },
        { lat: 40.141699218750034, lng: 26.22597656250005 },
        { lat: 40.20239257812497, lng: 26.260156250000023 },
        { lat: 40.24814453125006, lng: 26.252343750000023 },
        { lat: 40.31469726562503, lng: 26.25380859375005 },
        { lat: 40.39023437500006, lng: 26.355273437500017 },
        { lat: 40.44501953125001, lng: 26.447460937500068 },
        { lat: 40.54423828124999, lng: 26.720312500000063 },
        { lat: 40.626611328124994, lng: 26.792089843750034 },
        { lat: 40.62465820312502, lng: 26.578125 },
        { lat: 40.60634765625002, lng: 26.360937500000034 },
        { lat: 40.61806640625002, lng: 26.224218750000063 },
        { lat: 40.61132812499997, lng: 26.10546875000003 },
        { lat: 40.68339843750002, lng: 26.06777343750008 },
        { lat: 40.726757812499955, lng: 26.03896484375008 },
        { lat: 40.74028320312496, lng: 26.069726562500023 },
        { lat: 40.749658203124994, lng: 26.109179687500074 },
        { lat: 40.826513671875034, lng: 26.178906250000068 },
        { lat: 40.88320312500002, lng: 26.241210937500057 },
        { lat: 40.95449218749999, lng: 26.331054687500057 },
        { lat: 40.99707031250006, lng: 26.354101562500063 },
        { lat: 41.03676757812496, lng: 26.354101562500063 },
        { lat: 41.06430664062497, lng: 26.33261718750003 },
        { lat: 41.09702148437498, lng: 26.32841796875007 },
        { lat: 41.143261718749976, lng: 26.325683593750025 },
        { lat: 41.23876953125, lng: 26.330664062499977 },
        { lat: 41.343115234375034, lng: 26.536425781250074 },
        { lat: 41.354150390624966, lng: 26.60234374999999 },
        { lat: 41.401757812499994, lng: 26.62490234375008 },
        { lat: 41.51215820312501, lng: 26.60976562499999 },
        { lat: 41.60126953125003, lng: 26.581347656250074 },
        { lat: 41.60722656250002, lng: 26.54453125000003 },
        { lat: 41.63325195312498, lng: 26.49501953125008 },
        { lat: 41.66337890624999, lng: 26.4625 },
        { lat: 41.696337890625045, lng: 26.41054687499999 },
        { lat: 41.716552734375, lng: 26.320898437500034 },
        { lat: 41.744677734375045, lng: 26.31796875000006 },
        { lat: 41.77280273437498, lng: 26.327246093750006 },
        { lat: 41.80156249999999, lng: 26.3603515625 },
        { lat: 41.82636718749998, lng: 26.51142578125004 },
        { lat: 41.84667968750003, lng: 26.52929687500003 },
        { lat: 41.896728515625, lng: 26.549707031250023 },
        { lat: 41.947949218749955, lng: 26.5796875 },
        { lat: 41.964892578125045, lng: 26.61533203125006 },
        { lat: 41.96333007812498, lng: 26.67919921875003 },
        { lat: 41.97514648437498, lng: 26.800390625000034 },
        { lat: 41.99184570312502, lng: 26.884863281250006 },
        { lat: 42.02685546875006, lng: 26.96875 },
        { lat: 42.05864257812496, lng: 27.01171875 },
        { lat: 42.07709960937498, lng: 27.193359375000057 },
        { lat: 42.09326171874999, lng: 27.24433593750004 },
        { lat: 42.079541015624955, lng: 27.294921875000057 },
        { lat: 42.02504882812505, lng: 27.362890625000034 },
      ],
    ],
  },
  {
    code: "CY",
    coordinates: [
      [
        { lat: 35.065234375, lng: 34.004492187500006 },
        { lat: 35.056787109374994, lng: 33.96572265625002 },
        { lat: 35.08544921875, lng: 33.9033203125 },
        { lat: 35.093603515625, lng: 33.86640625000001 },
        { lat: 35.0671875, lng: 33.83203125 },
        { lat: 35.048193359375, lng: 33.79228515625001 },
        { lat: 35.03974609375, lng: 33.756933593750006 },
        { lat: 35.0373046875, lng: 33.72578125000001 },
        { lat: 35.017871093749996, lng: 33.675390625 },
        { lat: 35.022753906249996, lng: 33.61445312500001 },
        { lat: 35.038671875, lng: 33.52568359375002 },
        { lat: 35.00034179687499, lng: 33.47578125000001 },
        { lat: 35.004931640624996, lng: 33.4638671875 },
        { lat: 35.101416015625, lng: 33.45595703125002 },
        { lat: 35.14091796874999, lng: 33.42421875000002 },
        { lat: 35.1626953125, lng: 33.3837890625 },
        { lat: 35.153613281249996, lng: 33.32558593750002 },
        { lat: 35.15693359375, lng: 33.24833984375002 },
        { lat: 35.173144531249996, lng: 33.191015625 },
        { lat: 35.14619140624999, lng: 33.07753906250002 },
        { lat: 35.11640625, lng: 32.9859375 },
        { lat: 35.087841796875, lng: 32.91953125 },
        { lat: 35.089404296874996, lng: 32.86943359375002 },
        { lat: 35.115771484374996, lng: 32.78408203125002 },
        { lat: 35.145361328125, lng: 32.72021484375 },
        { lat: 35.171044921874994, lng: 32.71269531250002 },
        { lat: 35.15957031249999, lng: 32.77236328125002 },
        { lat: 35.180566406249994, lng: 32.8798828125 },
        { lat: 35.278076171875, lng: 32.926367187500006 },
        { lat: 35.390429687499996, lng: 32.94160156250001 },
        { lat: 35.358203125, lng: 33.12343750000002 },
        { lat: 35.34150390625, lng: 33.30781250000001 },
        { lat: 35.335888671875, lng: 33.45878906250002 },
        { lat: 35.354150390624994, lng: 33.607617187500004 },
        { lat: 35.473974609375, lng: 34.06347656249999 },
        { lat: 35.545703125, lng: 34.19248046875 },
        { lat: 35.569970703124994, lng: 34.27236328125002 },
        { lat: 35.62929687499999, lng: 34.4111328125 },
        { lat: 35.662060546875, lng: 34.55605468750002 },
        { lat: 35.593505859375, lng: 34.46318359375002 },
        { lat: 35.292041015624996, lng: 33.941992187500006 },
        { lat: 35.202392578125, lng: 33.90791015625001 },
        { lat: 35.140380859375, lng: 33.93125 },
        { lat: 35.065234375, lng: 34.004492187500006 },
      ],
    ],
  },
  {
    code: "CY",
    coordinates: [
      [
        { lat: 35.171044921874994, lng: 32.71269531250002 },
        { lat: 35.145361328125, lng: 32.72021484375 },
        { lat: 35.115771484374996, lng: 32.78408203125002 },
        { lat: 35.089404296874996, lng: 32.86943359375002 },
        { lat: 35.087841796875, lng: 32.91953125 },
        { lat: 35.11640625, lng: 32.9859375 },
        { lat: 35.14619140624999, lng: 33.07753906250002 },
        { lat: 35.173144531249996, lng: 33.191015625 },
        { lat: 35.15693359375, lng: 33.24833984375002 },
        { lat: 35.153613281249996, lng: 33.32558593750002 },
        { lat: 35.1626953125, lng: 33.3837890625 },
        { lat: 35.14091796874999, lng: 33.42421875000002 },
        { lat: 35.101416015625, lng: 33.45595703125002 },
        { lat: 35.004931640624996, lng: 33.4638671875 },
        { lat: 35.00034179687499, lng: 33.47578125000001 },
        { lat: 35.038671875, lng: 33.52568359375002 },
        { lat: 35.022753906249996, lng: 33.61445312500001 },
        { lat: 35.017871093749996, lng: 33.675390625 },
        { lat: 35.0373046875, lng: 33.72578125000001 },
        { lat: 35.03974609375, lng: 33.756933593750006 },
        { lat: 35.048193359375, lng: 33.79228515625001 },
        { lat: 35.0671875, lng: 33.83203125 },
        { lat: 35.093603515625, lng: 33.86640625000001 },
        { lat: 35.08544921875, lng: 33.9033203125 },
        { lat: 35.056787109374994, lng: 33.96572265625002 },
        { lat: 35.065234375, lng: 34.004492187500006 },
        { lat: 35.045556640624994, lng: 34.02363281250001 },
        { lat: 34.98837890624999, lng: 34.05019531250002 },
        { lat: 34.971484375, lng: 33.9365234375 },
        { lat: 34.96591796875, lng: 33.82246093750001 },
        { lat: 34.9732421875, lng: 33.75898437500001 },
        { lat: 34.969873046874994, lng: 33.69941406250001 },
        { lat: 34.806445312499996, lng: 33.51445312500002 },
        { lat: 34.75087890624999, lng: 33.41494140625002 },
        { lat: 34.717724609375, lng: 33.29658203125001 },
        { lat: 34.698046875, lng: 33.17607421875002 },
        { lat: 34.695556640625, lng: 33.11552734375002 },
        { lat: 34.67480468749999, lng: 33.06230468750002 },
        { lat: 34.6369140625, lng: 33.02490234375 },
        { lat: 34.6, lng: 33.02392578125 },
        { lat: 34.569580078125, lng: 33.00791015625 },
        { lat: 34.57587890625, lng: 32.94179687500002 },
        { lat: 34.635498046875, lng: 32.91425781250001 },
        { lat: 34.6611328125, lng: 32.8671875 },
        { lat: 34.647802734375, lng: 32.750097656250006 },
        { lat: 34.649365234375, lng: 32.69296875 },
        { lat: 34.70625, lng: 32.50556640625001 },
        { lat: 34.729443359375, lng: 32.44902343750002 },
        { lat: 34.77802734374999, lng: 32.41376953125001 },
        { lat: 34.9533203125, lng: 32.31718750000002 },
        { lat: 35.082958984375, lng: 32.30097656250001 },
        { lat: 35.0498046875, lng: 32.39091796875002 },
        { lat: 35.089990234374994, lng: 32.475 },
        { lat: 35.15576171875, lng: 32.55595703125002 },
        { lat: 35.182666015624996, lng: 32.65234375 },
        { lat: 35.171044921874994, lng: 32.71269531250002 },
      ],
    ],
  },
];

export default countries;
